
function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global = globalThis;
    var parcelRequire = $parcel$global["parcelRequire49d7"];
var parcelRegister = parcelRequire.register;
parcelRegister("j6nm6", function(module, exports) {

$parcel$export(module.exports, "TopNav3Sync", () => $3b17498f5b84ae22$export$b499cb5a112c6fff);
/* TopNav3Sync.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $eCCin = parcelRequire("eCCin");

var $4R6GH = parcelRequire("4R6GH");

var $koVbs = parcelRequire("koVbs");

var $6cNb0 = parcelRequire("6cNb0");

var $bBulW = parcelRequire("bBulW");

var $6jY6G = parcelRequire("6jY6G");

var $cZpsT = parcelRequire("cZpsT");

var $dWQF5 = parcelRequire("dWQF5");

var $jyW1v = parcelRequire("jyW1v");

var $6RKvu = parcelRequire("6RKvu");

var $96WTB = parcelRequire("96WTB");

var $crC7i = parcelRequire("crC7i");

var $klog1 = parcelRequire("klog1");

var $7bwNu = parcelRequire("7bwNu");

var $ag3PC = parcelRequire("ag3PC");

var $2YzXO = parcelRequire("2YzXO");

var $1mNGt = parcelRequire("1mNGt");

var $lbp13 = parcelRequire("lbp13");

var $a5zoF = parcelRequire("a5zoF");

var $jSplz = parcelRequire("jSplz");

var $3bzLW = parcelRequire("3bzLW");

var $cvQRb = parcelRequire("cvQRb");

var $9i62K = parcelRequire("9i62K");

var $el0Fl = parcelRequire("el0Fl");

var $6U0zt = parcelRequire("6U0zt");

var $fwJYI = parcelRequire("fwJYI");

var $eoNiZ = parcelRequire("eoNiZ");

var $jUhOq = parcelRequire("jUhOq");

var $inFGE = parcelRequire("inFGE");
/*
    The DiscoverMore component is from experiment TBLZ-197, so rather than updating the Atlassian Navigation
    package we are extending the renderNotifications prop for now.
    If this experiment is productionised, we will move the code into the appropriate location.
*/ const $3b17498f5b84ae22$var$RenderNotificationsWithConversationAssistant = ()=>{
    const isAnonymous = (0, $cZpsT.useIsAnonymous)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, !isAnonymous && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $jUhOq.ConversationAssistant), null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $inFGE.Notifications), null));
};
const $3b17498f5b84ae22$var$SearchWithoutProps = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $fwJYI.Search), null);
const $3b17498f5b84ae22$var$EditionAwarenessAndSearch = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($3b17498f5b84ae22$var$EditionAwarenessWrapper, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $bBulW.EditionAwareness), null)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($3b17498f5b84ae22$var$SearchWithoutProps, null));
const $3b17498f5b84ae22$export$b499cb5a112c6fff = ()=>{
    const theme = (0, $eoNiZ.useTheme)();
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const isAnonymous = (0, $cZpsT.useIsAnonymous)();
    const showAssets = (0, $9i62K.useShowAssets)();
    const showRoadmaps = (0, $dWQF5.useIsCrossProjectViewsEnabled)();
    const route = (0, $6jY6G.useCurrentRoute)();
    const PrimaryMenuItemsNav3 = (0, $5uXOq.useMemo)(()=>[
            /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $1mNGt.OpenOverflowMenuForPlansSpotlightObserver), {
                key: "arj-open-overflow-menu-for-plans-spotlight-observer"
            }),
            !isAnonymous && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $lbp13.YourWorkDropdown), {
                key: "yourWorkDropdown"
            }),
            /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $a5zoF.Projects), {
                key: "projects"
            }),
            /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $jSplz.Filters), {
                key: "filters"
            }),
            /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $3bzLW.Dashboards), {
                key: "dashboards"
            }),
            /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $cvQRb.People), {
                key: "people"
            }),
            /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $1mNGt.Plans), {
                key: "plans"
            }),
            showRoadmaps && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $el0Fl.Roadmaps), {
                key: "roadmaps"
            }),
            showAssets && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $9i62K.Insight), {
                key: "insight"
            }),
            /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $6U0zt.Addons), {
                key: "addons"
            })
        ].filter(Boolean), [
        isAnonymous,
        showAssets,
        showRoadmaps
    ]);
    const extraSsrPlaceholderEnabledRoutes = [
        'servicedesk-queues-custom-view',
        'servicedesk-practice-custom-and-issue'
    ];
    const ssrPlaceholderEnabledRoutes = [
        'global-issue-navigator',
        'software-issue-navigator',
        'issue-navigator-classic',
        'servicedesk-issues',
        'issue-navigator-core',
        'issue',
        'rapidboard-board',
        'rapidboard-backlog',
        ...(0, $4R6GH.fg)('add_ssr_placeholder_replacements_to_queues_nav') ? extraSsrPlaceholderEnabledRoutes : []
    ];
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $eCCin.AtlassianNavigation), {
        primaryItems: PrimaryMenuItemsNav3,
        label: formatMessage((0, $jyW1v.default).topNav),
        moreLabel: formatMessage((0, $jyW1v.default).more),
        renderAppSwitcher: (0, $6RKvu.AppSwitcher),
        renderCreate: (0, $96WTB.Create),
        renderHelp: (0, $crC7i.Help),
        renderNotifications: $3b17498f5b84ae22$var$RenderNotificationsWithConversationAssistant,
        renderProductHome: (0, $klog1.ProductHome),
        renderProfile: (0, $7bwNu.Profile),
        renderSearch: $3b17498f5b84ae22$var$EditionAwarenessAndSearch,
        renderSettings: (0, $ag3PC.Settings),
        renderSignIn: (0, $2YzXO.SignIn),
        theme: theme,
        testId: (0, $6cNb0.testIdGenerate)(null),
        isServer: false,
        isSSRPlaceholderEnabled: ssrPlaceholderEnabledRoutes.includes(route.name)
    });
};
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $3b17498f5b84ae22$var$EditionAwarenessWrapper = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_2hwxpxbi _j2s1glyw",
            __cmplp.className
        ])
    });
});

});
parcelRegister("eCCin", function(module, exports) {

$parcel$export(module.exports, "AtlassianNavigation", () => $58c8bcec2d2f91c7$export$f66ccb39f60980e5);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ // eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766

var $f8Sb3 = parcelRequire("f8Sb3");

var $1PVpv = parcelRequire("1PVpv");



var $k2eCO = parcelRequire("k2eCO");
var $hBZh1 = parcelRequire("hBZh1");

var $fSH9K = parcelRequire("fSH9K");
function $58c8bcec2d2f91c7$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $58c8bcec2d2f91c7$var$containerStyles = /*#__PURE__*/ (0, $f8Sb3.css)({
    display: 'flex',
    boxSizing: 'border-box',
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    height: (0, $8acc83d90e579622$export$30fa7cc5f2690a43),
    position: 'relative',
    alignItems: 'center',
    justifyContent: 'space-between',
    flexShrink: 0,
    borderBlockEnd: `1px solid ${`var(--ds-border, ${(0, $829f609a65d26a98$export$3e51e8f1440314ba)})`}`,
    paddingInlineEnd: "var(--ds-space-150, 12px)",
    paddingInlineStart: "var(--ds-space-150, 12px)"
});
const $58c8bcec2d2f91c7$var$leftStyles = {
    name: "vtikxo",
    styles: "display:flex;min-width:0;height:inherit;align-items:center;flex-grow:1;& > *{flex-shrink:0;}"
};
const $58c8bcec2d2f91c7$var$rightStyles = {
    name: "1mwlrd6",
    styles: "display:flex;align-items:center;flex-shrink:0;& > *{flex-shrink:0;margin-inline-end:var(--ds-space-050, 4px);}"
};
const $58c8bcec2d2f91c7$var$noRightMarginStyles = {
    name: "1oo7nc3",
    styles: "margin-inline-end:0"
};
const $58c8bcec2d2f91c7$var$analyticsData = {
    attributes: {
        navigationLayer: 'global'
    },
    componentName: 'atlassianNavigation'
};
const $58c8bcec2d2f91c7$export$f66ccb39f60980e5 = (props)=>{
    const { label: label, primaryItems: primaryItems = [], renderAppSwitcher: AppSwitcher, renderCreate: create, renderHelp: Help, renderNotifications: Notifications, renderProductHome: ProductHome, renderProfile: Profile, renderSearch: Search, renderSignIn: SignIn, renderSettings: Settings, moreLabel: moreLabel = "\u2026", theme: theme = (0, $k2eCO.defaultTheme), testId: testId, isServer: isServer = false, isSSRPlaceholderEnabled: isSSRPlaceholderEnabled = false } = props;
    return /*#__PURE__*/ (0, $f8Sb3.jsx)((0, $hBZh1.ThemeProvider), {
        value: theme
    }, /*#__PURE__*/ (0, $f8Sb3.jsx)((0, $1PVpv.NavigationAnalyticsContext), {
        data: $58c8bcec2d2f91c7$var$analyticsData
    }, /*#__PURE__*/ (0, $f8Sb3.jsx)("header", {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
        style: theme.mode.navigation,
        css: $58c8bcec2d2f91c7$var$containerStyles,
        "data-testid": testId && `${testId}-header`,
        role: "banner",
        "data-vc": `atlassian-navigation${isServer ? '-ssr' : ''}`,
        ...isServer && isSSRPlaceholderEnabled && {
            'data-ssr-placeholder': 'atlassian-navigation-placeholder'
        },
        ...!isServer && isSSRPlaceholderEnabled && {
            'data-ssr-placeholder-replace': 'atlassian-navigation-placeholder'
        }
    }, /*#__PURE__*/ (0, $f8Sb3.jsx)("nav", {
        css: $58c8bcec2d2f91c7$var$leftStyles,
        "aria-label": label
    }, AppSwitcher && /*#__PURE__*/ (0, $f8Sb3.jsx)(AppSwitcher, null), ProductHome && /*#__PURE__*/ (0, $f8Sb3.jsx)(ProductHome, null), /*#__PURE__*/ (0, $f8Sb3.jsx)((0, $fSH9K.PrimaryItemsContainer), {
        testId: testId,
        moreLabel: moreLabel,
        items: primaryItems,
        create: create,
        // eslint-disable-next-line @repo/internal/react/no-unsafe-overrides
        theme: theme
    })), /*#__PURE__*/ (0, $f8Sb3.jsx)("div", {
        css: $58c8bcec2d2f91c7$var$rightStyles,
        "data-testid": testId && `${testId}-secondary-actions`
    }, Search && /*#__PURE__*/ (0, $f8Sb3.jsx)(Search, null), /*#__PURE__*/ (0, $f8Sb3.jsx)("div", {
        role: "list",
        css: [
            $58c8bcec2d2f91c7$var$rightStyles,
            $58c8bcec2d2f91c7$var$noRightMarginStyles
        ],
        "data-vc": "atlassian-navigation-secondary-actions"
    }, Notifications && /*#__PURE__*/ (0, $f8Sb3.jsx)(Notifications, null), Help && /*#__PURE__*/ (0, $f8Sb3.jsx)(Help, null), Settings && /*#__PURE__*/ (0, $f8Sb3.jsx)(Settings, null), SignIn && /*#__PURE__*/ (0, $f8Sb3.jsx)(SignIn, null), Profile && /*#__PURE__*/ (0, $f8Sb3.jsx)(Profile, null))))));
};

});
var $829f609a65d26a98$exports = {};

$parcel$export($829f609a65d26a98$exports, "R50", () => $829f609a65d26a98$export$4b84fd0e2c617bd);
$parcel$export($829f609a65d26a98$exports, "R75", () => $829f609a65d26a98$export$b34b069eff244586);
$parcel$export($829f609a65d26a98$exports, "R100", () => $829f609a65d26a98$export$be802dd0d8b57f35);
$parcel$export($829f609a65d26a98$exports, "R200", () => $829f609a65d26a98$export$60847d42f9da92a6);
$parcel$export($829f609a65d26a98$exports, "R300", () => $829f609a65d26a98$export$4a7404f376229999);
$parcel$export($829f609a65d26a98$exports, "R400", () => $829f609a65d26a98$export$2010d0fb4295b346);
$parcel$export($829f609a65d26a98$exports, "R500", () => $829f609a65d26a98$export$2837b5a1a71d5c02);
$parcel$export($829f609a65d26a98$exports, "Y50", () => $829f609a65d26a98$export$8d9596b529bbb9cf);
$parcel$export($829f609a65d26a98$exports, "Y75", () => $829f609a65d26a98$export$41060a744ab0b7ae);
$parcel$export($829f609a65d26a98$exports, "Y100", () => $829f609a65d26a98$export$1cc05bbbf340e559);
$parcel$export($829f609a65d26a98$exports, "Y200", () => $829f609a65d26a98$export$5aae31392d72caaa);
$parcel$export($829f609a65d26a98$exports, "Y300", () => $829f609a65d26a98$export$c6930421db9fa514);
$parcel$export($829f609a65d26a98$exports, "Y400", () => $829f609a65d26a98$export$59619663aa6500fb);
$parcel$export($829f609a65d26a98$exports, "Y500", () => $829f609a65d26a98$export$874739ea9e379ab6);
$parcel$export($829f609a65d26a98$exports, "G50", () => $829f609a65d26a98$export$8a6341c32b6a3ee6);
$parcel$export($829f609a65d26a98$exports, "G75", () => $829f609a65d26a98$export$69a3bf21b9686c2b);
$parcel$export($829f609a65d26a98$exports, "G100", () => $829f609a65d26a98$export$afbce1382ec95f73);
$parcel$export($829f609a65d26a98$exports, "G200", () => $829f609a65d26a98$export$747d86715d4175de);
$parcel$export($829f609a65d26a98$exports, "G300", () => $829f609a65d26a98$export$940e1f69e873f202);
$parcel$export($829f609a65d26a98$exports, "G400", () => $829f609a65d26a98$export$a49394138f7b8e85);
$parcel$export($829f609a65d26a98$exports, "G500", () => $829f609a65d26a98$export$6fa04827ac68a4fb);
$parcel$export($829f609a65d26a98$exports, "B50", () => $829f609a65d26a98$export$226de0355ed012f8);
$parcel$export($829f609a65d26a98$exports, "B75", () => $829f609a65d26a98$export$8c13c2ee36917869);
$parcel$export($829f609a65d26a98$exports, "B100", () => $829f609a65d26a98$export$ecfc1dff386a3e7a);
$parcel$export($829f609a65d26a98$exports, "B200", () => $829f609a65d26a98$export$215b7063051591f1);
$parcel$export($829f609a65d26a98$exports, "B300", () => $829f609a65d26a98$export$e62e8919cca44969);
$parcel$export($829f609a65d26a98$exports, "B400", () => $829f609a65d26a98$export$b3de0ae08da2ce64);
$parcel$export($829f609a65d26a98$exports, "B500", () => $829f609a65d26a98$export$a6ee3d71bc067634);
$parcel$export($829f609a65d26a98$exports, "B600", () => $829f609a65d26a98$export$67f15409e87642a1);
$parcel$export($829f609a65d26a98$exports, "B700", () => $829f609a65d26a98$export$f0539dbc42dbb067);
$parcel$export($829f609a65d26a98$exports, "P50", () => $829f609a65d26a98$export$363e4475840015bb);
$parcel$export($829f609a65d26a98$exports, "P75", () => $829f609a65d26a98$export$4b0a4417ed59760f);
$parcel$export($829f609a65d26a98$exports, "P100", () => $829f609a65d26a98$export$6011520a64d9a187);
$parcel$export($829f609a65d26a98$exports, "P200", () => $829f609a65d26a98$export$a7175d4e9206bc80);
$parcel$export($829f609a65d26a98$exports, "P300", () => $829f609a65d26a98$export$b48405b95304b5a1);
$parcel$export($829f609a65d26a98$exports, "P400", () => $829f609a65d26a98$export$c71e4279dd54a18d);
$parcel$export($829f609a65d26a98$exports, "P500", () => $829f609a65d26a98$export$147899de772240ec);
$parcel$export($829f609a65d26a98$exports, "T50", () => $829f609a65d26a98$export$2cf711fe14c66f06);
$parcel$export($829f609a65d26a98$exports, "T75", () => $829f609a65d26a98$export$7a8f4d33f6f9772c);
$parcel$export($829f609a65d26a98$exports, "T100", () => $829f609a65d26a98$export$776c9c497ef08533);
$parcel$export($829f609a65d26a98$exports, "T200", () => $829f609a65d26a98$export$69cb3ca10c1e330e);
$parcel$export($829f609a65d26a98$exports, "T300", () => $829f609a65d26a98$export$9dc1ef0f3f48059b);
$parcel$export($829f609a65d26a98$exports, "T400", () => $829f609a65d26a98$export$7c835c78b6fcdef8);
$parcel$export($829f609a65d26a98$exports, "T500", () => $829f609a65d26a98$export$6036577f95c3877e);
$parcel$export($829f609a65d26a98$exports, "N0", () => $829f609a65d26a98$export$29a4f05edc054374);
$parcel$export($829f609a65d26a98$exports, "N10", () => $829f609a65d26a98$export$e655ef011c4aa1a2);
$parcel$export($829f609a65d26a98$exports, "N20", () => $829f609a65d26a98$export$9fdfb749e33cdf97);
$parcel$export($829f609a65d26a98$exports, "N30", () => $829f609a65d26a98$export$3e51e8f1440314ba);
$parcel$export($829f609a65d26a98$exports, "N40", () => $829f609a65d26a98$export$1ce2d1575d444ceb);
$parcel$export($829f609a65d26a98$exports, "N50", () => $829f609a65d26a98$export$8754fc7e6d8b3000);
$parcel$export($829f609a65d26a98$exports, "N60", () => $829f609a65d26a98$export$c2e91cbeada39b8b);
$parcel$export($829f609a65d26a98$exports, "N70", () => $829f609a65d26a98$export$5f71e19f3a7ad9de);
$parcel$export($829f609a65d26a98$exports, "N80", () => $829f609a65d26a98$export$eaa8c8a70ac22806);
$parcel$export($829f609a65d26a98$exports, "N90", () => $829f609a65d26a98$export$7c87d337fb91a97d);
$parcel$export($829f609a65d26a98$exports, "N100", () => $829f609a65d26a98$export$d6447c357493214f);
$parcel$export($829f609a65d26a98$exports, "N200", () => $829f609a65d26a98$export$f563ee71e9ee74cd);
$parcel$export($829f609a65d26a98$exports, "N300", () => $829f609a65d26a98$export$e2ef2124cf4024b1);
$parcel$export($829f609a65d26a98$exports, "N400", () => $829f609a65d26a98$export$eece5f492e429f08);
$parcel$export($829f609a65d26a98$exports, "N500", () => $829f609a65d26a98$export$c39c0fe0f26207ae);
$parcel$export($829f609a65d26a98$exports, "N600", () => $829f609a65d26a98$export$7090862dc3038a9f);
$parcel$export($829f609a65d26a98$exports, "N700", () => $829f609a65d26a98$export$ad0bacf983b7ddaa);
$parcel$export($829f609a65d26a98$exports, "N800", () => $829f609a65d26a98$export$7d61b15e0da132af);
$parcel$export($829f609a65d26a98$exports, "N900", () => $829f609a65d26a98$export$fbda843f0a27fe96);
$parcel$export($829f609a65d26a98$exports, "N10A", () => $829f609a65d26a98$export$791e57b27ca738ef);
$parcel$export($829f609a65d26a98$exports, "N20A", () => $829f609a65d26a98$export$8d43898f60b96a82);
$parcel$export($829f609a65d26a98$exports, "N30A", () => $829f609a65d26a98$export$920c0d5c49070351);
$parcel$export($829f609a65d26a98$exports, "N40A", () => $829f609a65d26a98$export$46987b49aab6d1a8);
$parcel$export($829f609a65d26a98$exports, "N50A", () => $829f609a65d26a98$export$7d3359664e8bb0e5);
$parcel$export($829f609a65d26a98$exports, "N60A", () => $829f609a65d26a98$export$d2d3bedfb276cac0);
$parcel$export($829f609a65d26a98$exports, "N70A", () => $829f609a65d26a98$export$6e5e7499ff054f6d);
$parcel$export($829f609a65d26a98$exports, "N80A", () => $829f609a65d26a98$export$59264b346c877fa7);
$parcel$export($829f609a65d26a98$exports, "N90A", () => $829f609a65d26a98$export$d092757d7c64925c);
$parcel$export($829f609a65d26a98$exports, "N100A", () => $829f609a65d26a98$export$486ab785e4bac3c6);
$parcel$export($829f609a65d26a98$exports, "N200A", () => $829f609a65d26a98$export$fba592bbc6419fea);
$parcel$export($829f609a65d26a98$exports, "N300A", () => $829f609a65d26a98$export$13609db0e6812ab8);
$parcel$export($829f609a65d26a98$exports, "N400A", () => $829f609a65d26a98$export$fbae4efaa892d883);
$parcel$export($829f609a65d26a98$exports, "N500A", () => $829f609a65d26a98$export$f13946d26f440ce6);
$parcel$export($829f609a65d26a98$exports, "N600A", () => $829f609a65d26a98$export$19f58225ac52a306);
$parcel$export($829f609a65d26a98$exports, "N700A", () => $829f609a65d26a98$export$6384f09da70e7b62);
$parcel$export($829f609a65d26a98$exports, "N800A", () => $829f609a65d26a98$export$d0dccc730683edc2);
$parcel$export($829f609a65d26a98$exports, "DN900", () => $829f609a65d26a98$export$2f6319cf7d736c2a);
$parcel$export($829f609a65d26a98$exports, "DN800", () => $829f609a65d26a98$export$95126bc8884d6634);
$parcel$export($829f609a65d26a98$exports, "DN700", () => $829f609a65d26a98$export$8338d8c35d44ff1);
$parcel$export($829f609a65d26a98$exports, "DN600", () => $829f609a65d26a98$export$5368d76ae4fbbda7);
$parcel$export($829f609a65d26a98$exports, "DN500", () => $829f609a65d26a98$export$9f0a771d16ec8d36);
$parcel$export($829f609a65d26a98$exports, "DN400", () => $829f609a65d26a98$export$abcf8c38338b4aa5);
$parcel$export($829f609a65d26a98$exports, "DN300", () => $829f609a65d26a98$export$97e81faa16a182c7);
$parcel$export($829f609a65d26a98$exports, "DN200", () => $829f609a65d26a98$export$bfe21c59123ecf33);
$parcel$export($829f609a65d26a98$exports, "DN100", () => $829f609a65d26a98$export$ee82aa2ea6a1558);
$parcel$export($829f609a65d26a98$exports, "DN90", () => $829f609a65d26a98$export$682927c6ed76be02);
$parcel$export($829f609a65d26a98$exports, "DN80", () => $829f609a65d26a98$export$91fd9994c5be9757);
$parcel$export($829f609a65d26a98$exports, "DN70", () => $829f609a65d26a98$export$d281fbfe3cff2df6);
$parcel$export($829f609a65d26a98$exports, "DN60", () => $829f609a65d26a98$export$3902c91d8b98a753);
$parcel$export($829f609a65d26a98$exports, "DN50", () => $829f609a65d26a98$export$8e8133c1ba5845b5);
$parcel$export($829f609a65d26a98$exports, "DN40", () => $829f609a65d26a98$export$33ff357f6620b39);
$parcel$export($829f609a65d26a98$exports, "DN30", () => $829f609a65d26a98$export$633847cf062b69e0);
$parcel$export($829f609a65d26a98$exports, "DN20", () => $829f609a65d26a98$export$9776a6e503bdbf76);
$parcel$export($829f609a65d26a98$exports, "DN10", () => $829f609a65d26a98$export$6c813d5160dff5db);
$parcel$export($829f609a65d26a98$exports, "DN0", () => $829f609a65d26a98$export$3d4f271a500072a);
$parcel$export($829f609a65d26a98$exports, "DN800A", () => $829f609a65d26a98$export$fe151285c22759ec);
$parcel$export($829f609a65d26a98$exports, "DN700A", () => $829f609a65d26a98$export$a101c6190d0da34);
$parcel$export($829f609a65d26a98$exports, "DN600A", () => $829f609a65d26a98$export$4b16f52932fda51);
$parcel$export($829f609a65d26a98$exports, "DN500A", () => $829f609a65d26a98$export$a74bcd7b9845b0d8);
$parcel$export($829f609a65d26a98$exports, "DN400A", () => $829f609a65d26a98$export$9209c179316d1751);
$parcel$export($829f609a65d26a98$exports, "DN300A", () => $829f609a65d26a98$export$88f55133f636c8dd);
$parcel$export($829f609a65d26a98$exports, "DN200A", () => $829f609a65d26a98$export$51126f85d1009512);
$parcel$export($829f609a65d26a98$exports, "DN100A", () => $829f609a65d26a98$export$a069b547bd23af78);
$parcel$export($829f609a65d26a98$exports, "DN90A", () => $829f609a65d26a98$export$40cce05af3b2600a);
$parcel$export($829f609a65d26a98$exports, "DN80A", () => $829f609a65d26a98$export$b78942185925a0d);
$parcel$export($829f609a65d26a98$exports, "DN70A", () => $829f609a65d26a98$export$e058fb44b8eaafca);
$parcel$export($829f609a65d26a98$exports, "DN60A", () => $829f609a65d26a98$export$92b0b8de26920c18);
$parcel$export($829f609a65d26a98$exports, "DN50A", () => $829f609a65d26a98$export$67564f7459d3fc9e);
$parcel$export($829f609a65d26a98$exports, "DN40A", () => $829f609a65d26a98$export$77868e1ca884ffa3);
$parcel$export($829f609a65d26a98$exports, "DN30A", () => $829f609a65d26a98$export$2afd71d7d3ea2cd5);
$parcel$export($829f609a65d26a98$exports, "DN20A", () => $829f609a65d26a98$export$f2a0acaab9972c70);
$parcel$export($829f609a65d26a98$exports, "DN10A", () => $829f609a65d26a98$export$9ab70e67d6475361);
$parcel$export($829f609a65d26a98$exports, "T30", () => $829f609a65d26a98$export$d2adc5dedf09fced);
$parcel$export($829f609a65d26a98$exports, "L50", () => $829f609a65d26a98$export$f51762073d2bb381);
$parcel$export($829f609a65d26a98$exports, "L75", () => $829f609a65d26a98$export$95e26d54def96891);
// Reds
const $829f609a65d26a98$export$4b84fd0e2c617bd = '#FFEBE6';
const $829f609a65d26a98$export$b34b069eff244586 = '#FFBDAD';
const $829f609a65d26a98$export$be802dd0d8b57f35 = '#FF8F73';
const $829f609a65d26a98$export$60847d42f9da92a6 = '#FF7452';
const $829f609a65d26a98$export$4a7404f376229999 = '#FF5630';
const $829f609a65d26a98$export$2010d0fb4295b346 = '#DE350B';
const $829f609a65d26a98$export$2837b5a1a71d5c02 = '#BF2600';
const $829f609a65d26a98$export$8d9596b529bbb9cf = '#FFFAE6';
const $829f609a65d26a98$export$41060a744ab0b7ae = '#FFF0B3';
const $829f609a65d26a98$export$1cc05bbbf340e559 = '#FFE380';
const $829f609a65d26a98$export$5aae31392d72caaa = '#FFC400';
const $829f609a65d26a98$export$c6930421db9fa514 = '#FFAB00';
const $829f609a65d26a98$export$59619663aa6500fb = '#FF991F';
const $829f609a65d26a98$export$874739ea9e379ab6 = '#FF8B00';
const $829f609a65d26a98$export$8a6341c32b6a3ee6 = '#E3FCEF';
const $829f609a65d26a98$export$69a3bf21b9686c2b = '#ABF5D1';
const $829f609a65d26a98$export$afbce1382ec95f73 = '#79F2C0';
const $829f609a65d26a98$export$747d86715d4175de = '#57D9A3';
const $829f609a65d26a98$export$940e1f69e873f202 = '#36B37E';
const $829f609a65d26a98$export$a49394138f7b8e85 = '#00875A';
const $829f609a65d26a98$export$6fa04827ac68a4fb = '#006644';
const $829f609a65d26a98$export$226de0355ed012f8 = '#DEEBFF';
const $829f609a65d26a98$export$8c13c2ee36917869 = '#B3D4FF';
const $829f609a65d26a98$export$ecfc1dff386a3e7a = '#4C9AFF';
const $829f609a65d26a98$export$215b7063051591f1 = '#2684FF';
const $829f609a65d26a98$export$e62e8919cca44969 = '#0065FF';
const $829f609a65d26a98$export$b3de0ae08da2ce64 = '#0052CC';
const $829f609a65d26a98$export$a6ee3d71bc067634 = '#0747A6';
const $829f609a65d26a98$export$67f15409e87642a1 = '#669DF1';
const $829f609a65d26a98$export$f0539dbc42dbb067 = '#8FB8F6';
const $829f609a65d26a98$export$363e4475840015bb = '#EAE6FF';
const $829f609a65d26a98$export$4b0a4417ed59760f = '#C0B6F2';
const $829f609a65d26a98$export$6011520a64d9a187 = '#998DD9';
const $829f609a65d26a98$export$a7175d4e9206bc80 = '#8777D9';
const $829f609a65d26a98$export$b48405b95304b5a1 = '#6554C0';
const $829f609a65d26a98$export$c71e4279dd54a18d = '#5243AA';
const $829f609a65d26a98$export$147899de772240ec = '#403294';
const $829f609a65d26a98$export$2cf711fe14c66f06 = '#E6FCFF';
const $829f609a65d26a98$export$7a8f4d33f6f9772c = '#B3F5FF';
const $829f609a65d26a98$export$776c9c497ef08533 = '#79E2F2';
const $829f609a65d26a98$export$69cb3ca10c1e330e = '#00C7E6';
const $829f609a65d26a98$export$9dc1ef0f3f48059b = '#00B8D9';
const $829f609a65d26a98$export$7c835c78b6fcdef8 = '#00A3BF';
const $829f609a65d26a98$export$6036577f95c3877e = '#008DA6';
const $829f609a65d26a98$export$29a4f05edc054374 = '#FFFFFF';
const $829f609a65d26a98$export$e655ef011c4aa1a2 = '#FAFBFC';
const $829f609a65d26a98$export$9fdfb749e33cdf97 = '#F4F5F7';
const $829f609a65d26a98$export$3e51e8f1440314ba = '#EBECF0';
const $829f609a65d26a98$export$1ce2d1575d444ceb = '#DFE1E6';
const $829f609a65d26a98$export$8754fc7e6d8b3000 = '#C1C7D0';
const $829f609a65d26a98$export$c2e91cbeada39b8b = '#B3BAC5';
const $829f609a65d26a98$export$5f71e19f3a7ad9de = '#A5ADBA';
const $829f609a65d26a98$export$eaa8c8a70ac22806 = '#97A0AF';
const $829f609a65d26a98$export$7c87d337fb91a97d = '#8993A4';
const $829f609a65d26a98$export$d6447c357493214f = '#7A869A';
const $829f609a65d26a98$export$f563ee71e9ee74cd = '#6B778C';
const $829f609a65d26a98$export$e2ef2124cf4024b1 = '#5E6C84';
const $829f609a65d26a98$export$eece5f492e429f08 = '#505F79';
const $829f609a65d26a98$export$c39c0fe0f26207ae = '#42526E';
const $829f609a65d26a98$export$7090862dc3038a9f = '#344563';
const $829f609a65d26a98$export$ad0bacf983b7ddaa = '#253858';
const $829f609a65d26a98$export$7d61b15e0da132af = '#172B4D';
const $829f609a65d26a98$export$fbda843f0a27fe96 = '#091E42';
const $829f609a65d26a98$export$791e57b27ca738ef = 'rgba(9, 30, 66, 0.02)';
const $829f609a65d26a98$export$8d43898f60b96a82 = 'rgba(9, 30, 66, 0.04)';
const $829f609a65d26a98$export$920c0d5c49070351 = 'rgba(9, 30, 66, 0.08)';
const $829f609a65d26a98$export$46987b49aab6d1a8 = 'rgba(9, 30, 66, 0.13)';
const $829f609a65d26a98$export$7d3359664e8bb0e5 = 'rgba(9, 30, 66, 0.25)';
const $829f609a65d26a98$export$d2d3bedfb276cac0 = 'rgba(9, 30, 66, 0.31)';
const $829f609a65d26a98$export$6e5e7499ff054f6d = 'rgba(9, 30, 66, 0.36)';
const $829f609a65d26a98$export$59264b346c877fa7 = 'rgba(9, 30, 66, 0.42)';
const $829f609a65d26a98$export$d092757d7c64925c = 'rgba(9, 30, 66, 0.48)';
const $829f609a65d26a98$export$486ab785e4bac3c6 = 'rgba(9, 30, 66, 0.54)';
const $829f609a65d26a98$export$fba592bbc6419fea = 'rgba(9, 30, 66, 0.60)';
const $829f609a65d26a98$export$13609db0e6812ab8 = 'rgba(9, 30, 66, 0.66)';
const $829f609a65d26a98$export$fbae4efaa892d883 = 'rgba(9, 30, 66, 0.71)';
const $829f609a65d26a98$export$f13946d26f440ce6 = 'rgba(9, 30, 66, 0.77)';
const $829f609a65d26a98$export$19f58225ac52a306 = 'rgba(9, 30, 66, 0.82)';
const $829f609a65d26a98$export$6384f09da70e7b62 = 'rgba(9, 30, 66, 0.89)';
const $829f609a65d26a98$export$d0dccc730683edc2 = 'rgba(9, 30, 66, 0.95)';
const $829f609a65d26a98$export$2f6319cf7d736c2a = '#E6EDFA';
const $829f609a65d26a98$export$95126bc8884d6634 = '#DCE5F5';
const $829f609a65d26a98$export$8338d8c35d44ff1 = '#CED9EB';
const $829f609a65d26a98$export$5368d76ae4fbbda7 = '#B8C7E0';
const $829f609a65d26a98$export$9f0a771d16ec8d36 = '#ABBBD6';
const $829f609a65d26a98$export$abcf8c38338b4aa5 = '#9FB0CC';
const $829f609a65d26a98$export$97e81faa16a182c7 = '#8C9CB8';
const $829f609a65d26a98$export$bfe21c59123ecf33 = '#7988A3';
const $829f609a65d26a98$export$ee82aa2ea6a1558 = '#67758F';
const $829f609a65d26a98$export$682927c6ed76be02 = '#56637A';
const $829f609a65d26a98$export$91fd9994c5be9757 = '#455166';
const $829f609a65d26a98$export$d281fbfe3cff2df6 = '#3B475C';
const $829f609a65d26a98$export$3902c91d8b98a753 = '#313D52';
const $829f609a65d26a98$export$8e8133c1ba5845b5 = '#283447';
const $829f609a65d26a98$export$33ff357f6620b39 = '#202B3D';
const $829f609a65d26a98$export$633847cf062b69e0 = '#1B2638';
const $829f609a65d26a98$export$9776a6e503bdbf76 = '#121A29';
const $829f609a65d26a98$export$6c813d5160dff5db = '#0E1624';
const $829f609a65d26a98$export$3d4f271a500072a = '#0D1424';
const $829f609a65d26a98$export$fe151285c22759ec = 'rgba(13, 20, 36, 0.06)';
const $829f609a65d26a98$export$a101c6190d0da34 = 'rgba(13, 20, 36, 0.14)';
const $829f609a65d26a98$export$4b16f52932fda51 = 'rgba(13, 20, 36, 0.18)';
const $829f609a65d26a98$export$a74bcd7b9845b0d8 = 'rgba(13, 20, 36, 0.29)';
const $829f609a65d26a98$export$9209c179316d1751 = 'rgba(13, 20, 36, 0.36)';
const $829f609a65d26a98$export$88f55133f636c8dd = 'rgba(13, 20, 36, 0.40)';
const $829f609a65d26a98$export$51126f85d1009512 = 'rgba(13, 20, 36, 0.47)';
const $829f609a65d26a98$export$a069b547bd23af78 = 'rgba(13, 20, 36, 0.53)';
const $829f609a65d26a98$export$40cce05af3b2600a = 'rgba(13, 20, 36, 0.63)';
const $829f609a65d26a98$export$b78942185925a0d = 'rgba(13, 20, 36, 0.73)';
const $829f609a65d26a98$export$e058fb44b8eaafca = 'rgba(13, 20, 36, 0.78)';
const $829f609a65d26a98$export$92b0b8de26920c18 = 'rgba(13, 20, 36, 0.81)';
const $829f609a65d26a98$export$67564f7459d3fc9e = 'rgba(13, 20, 36, 0.85)';
const $829f609a65d26a98$export$77868e1ca884ffa3 = 'rgba(13, 20, 36, 0.89)';
const $829f609a65d26a98$export$2afd71d7d3ea2cd5 = 'rgba(13, 20, 36, 0.92)';
const $829f609a65d26a98$export$f2a0acaab9972c70 = 'rgba(13, 20, 36, 0.95)';
const $829f609a65d26a98$export$9ab70e67d6475361 = 'rgba(13, 20, 36, 0.97)';
const $829f609a65d26a98$export$d2adc5dedf09fced = '#292A2E';
const $829f609a65d26a98$export$f51762073d2bb381 = '#94C748';
const $829f609a65d26a98$export$95e26d54def96891 = '#B3DF72';

const $8acc83d90e579622$export$30fa7cc5f2690a43 = 56;
const $8acc83d90e579622$export$4033a111ca79977d = 1280;
const $8acc83d90e579622$export$24ec62cee78b7042 = 1130;
const $8acc83d90e579622$export$d8bde68ac946124f = '--ds--ans--fbc';
const $8acc83d90e579622$export$73e44f54603a0964 = '--ds--ans--hbgc';
const $8acc83d90e579622$export$13f8aa8f663f4c99 = '--ds--ans--bgc';
const $8acc83d90e579622$export$d81606c1fc5119bc = '--ds--ans--c';
const $8acc83d90e579622$export$65f656ad520ea71 = '--ds--ans--bc';

parcelRegister("fSH9K", function(module, exports) {

$parcel$export(module.exports, "PrimaryItemsContainer", () => $6fdfdcc72d14d5cb$export$43e704064d596a9e);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $5uXOq = parcelRequire("5uXOq");

var $f8Sb3 = parcelRequire("f8Sb3");

var $1I7E8 = parcelRequire("1I7E8");


var $gJlZe = parcelRequire("gJlZe");

var $2bzBV = parcelRequire("2bzBV");

var $7ownK = parcelRequire("7ownK");
function $6fdfdcc72d14d5cb$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $6fdfdcc72d14d5cb$var$containerStyles = /*#__PURE__*/ (0, $f8Sb3.css)({
    display: 'flex',
    height: '100%',
    position: 'relative',
    alignItems: 'stretch',
    flexBasis: 0,
    flexGrow: 1,
    flexShrink: 0,
    // eslint-disable-next-line @atlaskit/design-system/no-nested-styles, @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
    '& > *': {
        margin: `0 ${"var(--ds-space-050, 4px)"}`,
        flexShrink: 0
    }
});
const $6fdfdcc72d14d5cb$var$widthObserverContainerStyles = {
    name: "o1tvrz",
    styles: "width:100%;min-width:1px;margin:0px;position:relative;flex-shrink:1"
};
const $6fdfdcc72d14d5cb$var$overflowItemsStyles = /*#__PURE__*/ (0, $f8Sb3.css)({
    color: `var(--ds-text, ${(0, $829f609a65d26a98$export$ad0bacf983b7ddaa)})`
});
const $6fdfdcc72d14d5cb$export$43e704064d596a9e = ({ moreLabel: moreLabel, items: items, create: Create, theme: theme, testId: testId })=>{
    const [isMoreOpen, setIsMoreOpen] = (0, $5uXOq.useState)(false);
    const { updateWidth: updateWidth, visibleItems: visibleItems, overflowItems: overflowItems } = (0, $2bzBV.useOverflowController)(items);
    const onMoreClick = (0, $5uXOq.useCallback)(()=>{
        setIsMoreOpen(!isMoreOpen);
    }, [
        isMoreOpen,
        setIsMoreOpen
    ]);
    const onMoreClose = (0, $5uXOq.useCallback)(()=>{
        setIsMoreOpen(false);
    }, []);
    const openOverflowMenu = (0, $5uXOq.useCallback)(()=>{
        setIsMoreOpen(true);
    }, []);
    const trigger = (0, $5uXOq.useCallback)((triggerProps)=>/*#__PURE__*/ (0, $f8Sb3.jsx)((0, $7ownK.PrimaryDropdownButton), {
            onClick: onMoreClick,
            isSelected: isMoreOpen,
            testId: testId ? `${testId}-overflow-menu-trigger` : 'overflow-menu-trigger',
            ...triggerProps
        }, moreLabel), [
        moreLabel,
        onMoreClick,
        isMoreOpen,
        testId
    ]);
    const content = (0, $5uXOq.useCallback)(()=>/*#__PURE__*/ (0, $f8Sb3.jsx)((0, $2bzBV.OverflowProvider), {
            isVisible: false,
            openOverflowMenu: openOverflowMenu,
            closeOverflowMenu: onMoreClose
        }, /*#__PURE__*/ (0, $f8Sb3.jsx)("div", {
            css: $6fdfdcc72d14d5cb$var$overflowItemsStyles
        }, overflowItems)), // Overflow items has an unstable reference - so we will only recalculate
    // content if `overflowItems` length changes.
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [
        overflowItems.length,
        openOverflowMenu,
        onMoreClose
    ]);
    return /*#__PURE__*/ (0, $f8Sb3.jsx)("div", {
        css: $6fdfdcc72d14d5cb$var$containerStyles,
        "data-testid": testId && `${testId}-primary-actions`,
        role: "list"
    }, /*#__PURE__*/ (0, $f8Sb3.jsx)((0, $2bzBV.OverflowProvider), {
        isVisible: true,
        openOverflowMenu: openOverflowMenu,
        closeOverflowMenu: onMoreClose
    }, visibleItems), overflowItems.length > 0 && /*#__PURE__*/ (0, $f8Sb3.jsx)((0, $1I7E8.default), {
        shouldRenderToParent: true,
        placement: "bottom-start",
        content: content,
        isOpen: isMoreOpen,
        onClose: onMoreClose,
        trigger: trigger,
        testId: testId ? `${testId}-overflow-menu-popup` : 'overflow-menu-popup'
    }), Create && /*#__PURE__*/ (0, $f8Sb3.jsx)(Create, null), /*#__PURE__*/ (0, $f8Sb3.jsx)("div", {
        css: $6fdfdcc72d14d5cb$var$widthObserverContainerStyles
    }, /*#__PURE__*/ (0, $f8Sb3.jsx)((0, $gJlZe.WidthObserver), {
        offscreen: true,
        setWidth: updateWidth
    })));
};

});
parcelRegister("gJlZe", function(module, exports) {

$parcel$export(module.exports, "WidthObserver", () => $f3c667de71b5760d$export$b2ad68b9bc407b80);

var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $jWz2c = parcelRequire("jWz2c");
const $f3c667de71b5760d$export$b2ad68b9bc407b80 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).memo((props)=>{
    return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $jWz2c.WidthDetectorObserver), {
        setWidth: props.setWidth,
        offscreen: props.offscreen
    });
});
var $f3c667de71b5760d$export$2e2bcd8739ae039 = $f3c667de71b5760d$export$b2ad68b9bc407b80;

});
parcelRegister("jWz2c", function(module, exports) {

$parcel$export(module.exports, "WidthDetectorObserver", () => $76470ef26276f9f4$export$ff983d2a2b6112ea);

var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $1LwQL = parcelRequire("1LwQL");
const $76470ef26276f9f4$export$ff983d2a2b6112ea = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).memo(({ setWidth: setWidth, offscreen: offscreen })=>{
    const [inViewRef, inView, target] = (0, $1LwQL.useInView)({
        /* Optional options */ threshold: 0
    });
    const observer = (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).useRef(()=>{
        if (typeof window === 'undefined') return null;
        // https://github.com/DefinitelyTyped/DefinitelyTyped/pull/40909
        // @ts-ignore
        return new ResizeObserver((entries)=>{
            if (!Array.isArray(entries) || !entries.length) return;
            const { width: width } = entries[0].contentRect;
            setWidth(Math.round(width));
        });
    });
    (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).useEffect(()=>{
        const { current: currentObserver } = observer;
        const resizeObserver = currentObserver();
        if (resizeObserver === null) return;
        if (target) {
            if (inView || offscreen) resizeObserver.observe(target);
            else resizeObserver.unobserve(target);
        }
        return ()=>{
            resizeObserver.disconnect();
        };
    }, [
        target,
        inView,
        offscreen
    ]);
    return /*#__PURE__*/ (0, $2OMIu.jsx)("div", {
        style: {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
            display: 'block',
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
            width: '100%',
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
            position: 'absolute'
        },
        ref: inViewRef
    });
});

});
parcelRegister("1LwQL", function(module, exports) {

$parcel$export(module.exports, "useInView", () => $1dfb7d23cdbb03d0$export$2f62ee6831462844);

var $5uXOq = parcelRequire("5uXOq");
function $1dfb7d23cdbb03d0$export$2f62ee6831462844(options = {}) {
    const ref = (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).useRef();
    const observerInstance = (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).useRef();
    const [state, setState] = (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).useState({
        inView: false,
        entry: undefined,
        target: undefined
    });
    const { threshold: threshold, root: root, rootMargin: rootMargin } = options;
    const setRef = (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).useCallback((node)=>{
        observerInstance.current = new IntersectionObserver((entries)=>{
            if (entries && entries.length) {
                const intersection = entries[0];
                const { isIntersecting: isIntersecting, intersectionRatio: intersectionRatio } = intersection;
                if (intersectionRatio >= 0) {
                    // Note: `0` will be used here when an array of numbers is passed as the threshold, which doesn't feel right
                    const numericThreshold = typeof threshold === 'number' ? threshold : 0;
                    let inView = intersectionRatio >= numericThreshold;
                    if (isIntersecting !== undefined) inView = inView && isIntersecting;
                    setState({
                        inView: inView,
                        entry: intersection,
                        target: node
                    });
                }
            }
        }, {
            threshold: threshold,
            root: root,
            rootMargin: rootMargin
        });
        if (ref.current) observerInstance.current.unobserve(ref.current);
        if (node) observerInstance.current.observe(node);
        // Store a reference to the node
        ref.current = node;
    }, [
        threshold,
        root,
        rootMargin
    ]);
    /**
	 * Unsubscribe IntersectionObserver before unmounting a component.
	 */ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).useEffect(()=>{
        return ()=>{
            if (observerInstance.current && ref.current) observerInstance.current.unobserve(ref.current);
        };
    }, []);
    return [
        setRef,
        state.inView,
        state.target,
        state.entry
    ];
}

});



parcelRegister("7ownK", function(module, exports) {

$parcel$export(module.exports, "PrimaryDropdownButton", () => $07ec44e10e1bbcf4$export$bb3af89fb196520d);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $5uXOq = parcelRequire("5uXOq");

var $f8Sb3 = parcelRequire("f8Sb3");

var $kEVMo = parcelRequire("kEVMo");

var $711X2 = parcelRequire("711X2");
const $07ec44e10e1bbcf4$export$bb3af89fb196520d = /*#__PURE__*/ (0, $5uXOq.forwardRef)((props, ref)=>{
    const { component: component, isHighlighted: isHighlighted, isLoading: isLoading, onClick: onClick, testId: testId, theme: theme, tooltip: tooltip, ...rest } = props;
    return /*#__PURE__*/ (0, $f8Sb3.jsx)((0, $711X2.PrimaryButton), {
        component: component,
        iconAfter: /*#__PURE__*/ (0, $f8Sb3.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($kEVMo))), {
            LEGACY_margin: `0 ${"var(--ds-space-negative-050, -4px)"} 0 ${"var(--ds-space-negative-100, -8px)"}`,
            color: "currentColor",
            label: "",
            size: "small"
        }),
        isHighlighted: isHighlighted,
        isLoading: isLoading,
        onClick: onClick,
        ref: ref,
        testId: testId,
        // eslint-disable-next-line @repo/internal/react/no-unsafe-overrides
        theme: theme,
        tooltip: tooltip,
        ...rest
    });
});

});



parcelRegister("dWQF5", function(module, exports) {

$parcel$export(module.exports, "useIsPremiumEdition", () => $901349e77566565e$export$8aa8a7878fd61770);
$parcel$export(module.exports, "useIsViewPermissionsEnabled", () => $901349e77566565e$export$a94405ffcb20c356);
$parcel$export(module.exports, "useIsCrossProjectViewsEnabled", () => $901349e77566565e$export$34d097b1cd6f89c1);
$parcel$export(module.exports, "useIsConnectionsEnabled", () => $901349e77566565e$export$304793dd2c5f4db0);

var $4R6GH = parcelRequire("4R6GH");

var $efvDm = parcelRequire("efvDm");

var $ldyPw = parcelRequire("ldyPw");

var $k9JTq = parcelRequire("k9JTq");
const $901349e77566565e$export$8aa8a7878fd61770 = ()=>{
    const appEditions = (0, $k9JTq.useAppEditions)();
    if ((0, $4R6GH.fg)('polaris_force-premium')) return true;
    const jpdEdition = (0, $ldyPw.getEdition)((0, $efvDm.JIRA_PRODUCT_DISCOVERY), appEditions);
    // TODO: POL-10089 use entitlements instead of the edition when it will be available
    return jpdEdition === (0, $ldyPw.toEdition)((0, $ldyPw.PREMIUM_EDITION));
};
const $901349e77566565e$export$642bac71144485ad = ()=>{
    const appEditions = (0, $k9JTq.useAppEditions)();
    const jpdEdition = (0, $ldyPw.getEdition)((0, $efvDm.JIRA_PRODUCT_DISCOVERY), appEditions);
    return jpdEdition === (0, $ldyPw.toEdition)((0, $ldyPw.STANDARD_EDITION));
};
const $901349e77566565e$export$a94405ffcb20c356 = ()=>{
    const isPremium = $901349e77566565e$export$8aa8a7878fd61770();
    return isPremium;
};
const $901349e77566565e$export$34d097b1cd6f89c1 = ()=>{
    const isPremium = $901349e77566565e$export$8aa8a7878fd61770();
    return isPremium;
};
const $901349e77566565e$export$304793dd2c5f4db0 = ()=>{
    const isPremium = $901349e77566565e$export$8aa8a7878fd61770();
    const isStandard = $901349e77566565e$export$642bac71144485ad();
    if (!(0, $4R6GH.fg)('jpd_issues_relationships')) return false;
    if (isStandard && (0, $4R6GH.fg)('jpd_issues_relationships_eap_lighthouse_customer')) return true;
    return isPremium;
};

});

parcelRegister("1mNGt", function(module, exports) {

$parcel$export(module.exports, "Plans", () => $73b77f33bee79d45$export$fa027c23da0a12ea);
$parcel$export(module.exports, "OpenOverflowMenuForPlansSpotlightObserver", () => $73b77f33bee79d45$export$c741bc6980da6a32);

var $5uXOq = parcelRequire("5uXOq");

var $2bzBV = parcelRequire("2bzBV");

var $bcn6L = parcelRequire("bcn6L");

var $koVbs = parcelRequire("koVbs");

var $lmyls = parcelRequire("lmyls");

var $8Bc5A = parcelRequire("8Bc5A");

var $cE2Qr = parcelRequire("cE2Qr");

var $88fdg = parcelRequire("88fdg");

var $h9iZl = parcelRequire("h9iZl");

var $Mp6qH = parcelRequire("Mp6qH");

var $4uXxK = parcelRequire("4uXxK");

var $4XiFK = parcelRequire("4XiFK");

var $ebYJ0 = parcelRequire("ebYJ0");

var $7Fvqy = parcelRequire("7Fvqy");

var $edhzr = parcelRequire("edhzr");

var $2eMU9 = parcelRequire("2eMU9");

var $2FrC0 = parcelRequire("2FrC0");
const $73b77f33bee79d45$var$PlansDropdown = ()=>{
    const [isPlansVisible] = (0, $h9iZl.useNavigationPlansVisibility)();
    const [{ hasFetchedOnce: hasFetchedOncePlans }, { loadFavoritePlans: loadFavorite }] = (0, $bcn6L.useFavoritePlans)();
    const [{ hasSuccessOnce: hasSuccessOnce }, { load: load }] = (0, $88fdg.usePlansItems)();
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const isStandardOrFree = (0, $7Fvqy.useIsStandardOrFreeJSW)();
    // Initialise items data
    (0, $5uXOq.useEffect)(()=>{
        !hasSuccessOnce && !isStandardOrFree && isPlansVisible && load();
    }, [
        hasSuccessOnce,
        load,
        isPlansVisible,
        isStandardOrFree
    ]);
    // Keep items data fresh
    const onBeforeMenuOpen = (0, $5uXOq.useCallback)(()=>{
        if (!isStandardOrFree) {
            load();
            if (!hasFetchedOncePlans) loadFavorite((0, $Mp6qH.DEFAULT_LOAD_COUNT_FAV));
        }
    }, // We dont care about hasFetchedOncePlans, it will generate a new call back which then closes the popup
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [
        load,
        loadFavorite
    ]);
    if (!isPlansVisible) return null;
    /**
   * Cannot do <Popup ... MenuTrigger={MenuTrigger} /> because
   * Popup passes exact common MenuTrigger props which doesn't have DI components
   * that makes Flow complains about props passing to customized MenuTrigger
   * */ // @ts-expect-error - TS2322 - Type '((instance: unknown) => void) | MutableRefObject<unknown> | null' is not assignable to type 'Ref<MenuTriggerProps> | undefined'.
    // FIXME: Navigation should fix that by extracting the forwarded component
    // eslint-disable-next-line react/no-unstable-nested-components
    const FinalMenuTrigger = /*#__PURE__*/ (0, $5uXOq.forwardRef)((props, ref)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $edhzr.MenuTrigger), {
            ...props,
            ref: ref
        }));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $4XiFK.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $ebYJ0.Popup), {
        menuId: (0, $lmyls.MENU_ID).PLANS,
        navigationItemId: (0, $Mp6qH.NAVIGATION_ITEM_ID).PLANS,
        Menu: (0, $2eMU9.default),
        // @ts-expect-error - TS2322 - Type 'ForwardRefExoticComponent<RefAttributes<unknown>>' is not assignable to type 'ComponentType<MenuTriggerProps> | undefined'.
        MenuTrigger: FinalMenuTrigger,
        onBeforeMenuOpen: onBeforeMenuOpen,
        label: formatMessage((0, $2FrC0.default).plans)
    }, formatMessage((0, $2FrC0.default).plans)));
};
const $73b77f33bee79d45$export$fa027c23da0a12ea = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $4uXxK.TopLevelErrorBoundary), {
        id: (0, $lmyls.MENU_ID).PLANS
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($73b77f33bee79d45$var$PlansDropdown, null));
const $73b77f33bee79d45$export$c741bc6980da6a32 = ()=>{
    const [isPlansVisible] = (0, $h9iZl.useNavigationPlansVisibility)();
    const [shouldShow] = (0, $cE2Qr.useShouldShowNudge)({
        itemNames: [
            (0, $8Bc5A.ADVANCED_ROADMAPS_TASK)
        ]
    });
    const WRAPPER_UID = 'plans-spotlight-target-wrapper';
    const spotlightVisible = // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
    !false && document.querySelector(`[data-uid="${WRAPPER_UID}"]`) != null;
    const { openOverflowMenu: openOverflowMenu } = (0, $2bzBV.useOverflowStatus)();
    (0, $5uXOq.useEffect)(()=>{
        isPlansVisible && shouldShow && !spotlightVisible && openOverflowMenu();
    }, [
        isPlansVisible,
        openOverflowMenu,
        shouldShow,
        spotlightVisible
    ]);
    return null;
};

});
parcelRegister("88fdg", function(module, exports) {

$parcel$export(module.exports, "usePlansItems", () => $fbc1adaeeb4c0d23$export$9386de9ff002702a);

var $jjts0 = parcelRequire("jjts0");

var $g5X3G = parcelRequire("g5X3G");

var $3sQ5x = parcelRequire("3sQ5x");
var $iXqE5 = parcelRequire("iXqE5");
const $fbc1adaeeb4c0d23$var$handleFetch = ()=>async ({ setState: setState, getState: getState })=>{
        const { fetchPlansItems: fetchPlansItems, baseUrl: baseUrl, isFetching: isFetching } = getState();
        if (!isFetching) try {
            const promise = fetchPlansItems(baseUrl);
            setState({
                isFetching: true,
                fetchError: null,
                promise: promise
            });
            const items = await promise;
            setState({
                items: items,
                hasFetchedOnce: true,
                hasSuccessOnce: true,
                isFetching: false,
                fetchError: null,
                promise: null
            });
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        } catch (fetchError) {
            setState({
                ...getState(),
                fetchError: fetchError,
                hasFetchedOnce: true,
                isFetching: false,
                promise: null
            });
        }
    };
const $fbc1adaeeb4c0d23$var$actions = {
    load: ()=>async ({ dispatch: dispatch })=>{
            const promise = dispatch($fbc1adaeeb4c0d23$var$handleFetch());
            await promise;
        }
};
const $fbc1adaeeb4c0d23$export$b0dd7d935d0978a4 = ({ storeName: storeName = 'plans-item-store', fetchPlansItems: fetchPlansItems })=>{
    const initialState = {
        baseUrl: (0, $g5X3G.toBaseUrl)(''),
        fetchPlansItems: fetchPlansItems,
        hasFetchedOnce: false,
        hasSuccessOnce: false,
        items: null,
        fetchError: null,
        promise: null,
        isFetching: false
    };
    const Store = (0, $iXqE5.createStore)({
        name: storeName,
        actions: $fbc1adaeeb4c0d23$var$actions,
        initialState: initialState
    });
    const selector = ({ items: items, hasFetchedOnce: hasFetchedOnce, fetchError: fetchError, promise: promise, hasSuccessOnce: hasSuccessOnce, isFetching: isFetching })=>({
            items: items,
            hasFetchedOnce: hasFetchedOnce,
            hasSuccessOnce: hasSuccessOnce,
            fetchError: fetchError,
            promise: promise,
            isFetching: isFetching
        });
    const usePlansItems = (0, $3sQ5x.createHook)(Store, {
        selector: selector
    });
    return {
        usePlansItems: usePlansItems
    };
};
const { usePlansItems: $fbc1adaeeb4c0d23$export$9386de9ff002702a } = $fbc1adaeeb4c0d23$export$b0dd7d935d0978a4({
    fetchPlansItems: (0, $jjts0.fetchPlansItems)
});

});
parcelRegister("jjts0", function(module, exports) {

$parcel$export(module.exports, "fetchPlansItems", () => $9279033d6121eb6e$export$ae5884604a8ac77b);

var $5HnTq = parcelRequire("5HnTq");

var $g5X3G = parcelRequire("g5X3G");

const $9279033d6121eb6e$var$handleError = (error)=>{
    throw error;
};
const $9279033d6121eb6e$var$transformResult = ({ isVisible: isVisible, staticLinks: staticLinks, recentPlans: recentPlans = [] })=>{
    const recentItems = recentPlans.map(({ planId: planId, scenarioId: scenarioId, title: title, url: url })=>({
            id: `${planId}|${scenarioId}`,
            title: title || '',
            url: url,
            type: (0, $49a076eb01652100$export$eebccb886b064713)
        }));
    return {
        isVisible: isVisible,
        recent: recentItems,
        links: staticLinks
    };
};
const $9279033d6121eb6e$export$ae5884604a8ac77b = async (baseUrl = (0, $g5X3G.toBaseUrl)(''))=>{
    const url = `${baseUrl}/rest/jpo/1.0/navigation`;
    try {
        const response = await fetch(url, (0, $5HnTq.getDefaultOptions)(url));
        if (response.ok) {
            const result = await response.json();
            return $9279033d6121eb6e$var$transformResult(result);
        }
        return $9279033d6121eb6e$var$handleError(new Error(response.statusText));
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    } catch (error) {
        return $9279033d6121eb6e$var$handleError(error);
    }
};

});
const $49a076eb01652100$export$91a9dba2d38d9a6f = 'projects';
const $49a076eb01652100$export$ebb48b08205007c5 = 'issues';
const $49a076eb01652100$export$6737b9227f60f39d = 'filters';
const $49a076eb01652100$export$6e58b6b0aa48a271 = 'dashboards';
const $49a076eb01652100$export$20f1031cc9fdf29e = 'queues';
const $49a076eb01652100$export$f95f1a684a17f189 = 'boards';
const $49a076eb01652100$export$3c11110d46d67e8c = 'jwmBoards';
const $49a076eb01652100$export$5e2cc09b58170ca2 = 'addons';
const $49a076eb01652100$export$eebccb886b064713 = 'plans';
const $49a076eb01652100$export$1c2ea36059c73937 = 'alerts';



parcelRegister("4XiFK", function(module, exports) {

$parcel$export(module.exports, "default", () => $f53eb447f22f4276$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $dC5iT = parcelRequire("dC5iT");
var $8CUq3 = parcelRequire("8CUq3");
const $f53eb447f22f4276$var$PopupBoxWrapper = ({ children: children })=>{
    if (!false) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dC5iT.default), {
        xcss: $f53eb447f22f4276$var$popupBoxWrapperStyles
    }, children);
    // Wraped children in <></> to avoid returning undefined
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, children);
};
const $f53eb447f22f4276$var$popupBoxWrapperStyles = (0, $8CUq3.xcss)({
    color: 'color.text',
    height: '100%'
});
var $f53eb447f22f4276$export$2e2bcd8739ae039 = $f53eb447f22f4276$var$PopupBoxWrapper;

});

parcelRegister("ebYJ0", function(module, exports) {

$parcel$export(module.exports, "Popup", () => $85fdbd4ad4faa6ef$export$129a32eedafa97c5);

var $5uXOq = parcelRequire("5uXOq");

var $8Rkzz = parcelRequire("8Rkzz");

var $2bzBV = parcelRequire("2bzBV");

var $1I7E8 = parcelRequire("1I7E8");

var $2Ui4E = parcelRequire("2Ui4E");

var $6cNb0 = parcelRequire("6cNb0");

var $gAtvZ = parcelRequire("gAtvZ");

var $fVbkk = parcelRequire("fVbkk");

var $8JFi2 = parcelRequire("8JFi2");
const $85fdbd4ad4faa6ef$var$OFFSET = [
    12,
    -11
];
const $85fdbd4ad4faa6ef$export$129a32eedafa97c5 = ({ Menu: Menu, MenuTrigger: MenuTrigger = (0, $fVbkk.MenuTrigger), children: children, menuId: menuId, navigationItemId: navigationItemId, onBeforeMenuOpen: onBeforeMenuOpen = ()=>undefined, label: label })=>{
    const [isMenuOpen, { off: closeMenu }] = (0, $2Ui4E.useTopMenus)(menuId);
    const [isEventFromSpotlightTour] = (0, $gAtvZ.useFromSpotlightTour)('spotlight');
    const { isVisible: isVisible } = (0, $2bzBV.useOverflowStatus)();
    const Trigger = (0, $5uXOq.useCallback)((props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(MenuTrigger, {
            ...props,
            onBeforeMenuOpen: onBeforeMenuOpen,
            menuId: menuId,
            navigationItemId: navigationItemId,
            "aria-haspopup": false
        }, children), // eslint-disable-next-line react-hooks/exhaustive-deps
    [
        children,
        menuId,
        navigationItemId,
        onBeforeMenuOpen
    ]);
    const testId = (0, $6cNb0.testIdGenerate)('primary-actions', menuId, 'menu-popup');
    const Content = (0, $5uXOq.useCallback)((props)=>// eslint-disable-next-line @atlassian/a11y/interactive-element-not-keyboard-focusable
        /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("span", {
            onClick: (0, $8JFi2.stopPropagation),
            "data-testid": testId,
            role: "presentation"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(Menu, {
            ...props,
            testIdPrefix: testId
        }, children)), // eslint-disable-next-line react-hooks/exhaustive-deps
    [
        children,
        testId
    ]);
    if (false) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(Trigger, {
        "aria-expanded": false,
        "aria-haspopup": false
    });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $1I7E8.default), {
        shouldRenderToParent: true,
        isOpen: isMenuOpen,
        onClose: isEventFromSpotlightTour ? (0, (/*@__PURE__*/$parcel$interopDefault($8Rkzz))) : closeMenu,
        content: Content,
        offset: isVisible ? undefined : $85fdbd4ad4faa6ef$var$OFFSET,
        placement: isVisible ? 'bottom-start' : 'right-start',
        trigger: Trigger,
        label: label
    });
};

});
parcelRegister("gAtvZ", function(module, exports) {

$parcel$export(module.exports, "useFromSpotlightTour", () => $27f5c6431be57d88$export$dc0191efbad6291c);

var $2qauD = parcelRequire("2qauD");
const { useSwitch: $27f5c6431be57d88$var$useSwitch } = (0, $2qauD.createSwitchController)('spotlight');
const $27f5c6431be57d88$export$dc0191efbad6291c = $27f5c6431be57d88$var$useSwitch;

});

parcelRegister("fVbkk", function(module, exports) {

$parcel$export(module.exports, "MenuTrigger", () => $bb37eb68c16a7749$export$27d2ad3c5815583e);
$parcel$export(module.exports, "ChevronRightIcon", () => $bb37eb68c16a7749$export$b837bd7eac09a33e);
/* main.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $bwpsq = parcelRequire("bwpsq");

var $5uXOq = parcelRequire("5uXOq");

var $3uzfU = parcelRequire("3uzfU");

var $2bzBV = parcelRequire("2bzBV");

var $kJpBP = parcelRequire("kJpBP");

var $2Ui4E = parcelRequire("2Ui4E");

var $6cNb0 = parcelRequire("6cNb0");

var $hjSul = parcelRequire("hjSul");

var $kAJ4Y = parcelRequire("kAJ4Y");

var $iPj86 = parcelRequire("iPj86");

var $jmHsa = parcelRequire("jmHsa");

var $5MZG9 = parcelRequire("5MZG9");

var $jngLf = parcelRequire("jngLf");

var $9YfZr = parcelRequire("9YfZr");
const $bb37eb68c16a7749$export$27d2ad3c5815583e = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ href: href, menuId: menuId, navigationItemId: navigationItemId, onBeforeMenuOpen: onBeforeMenuOpen = ()=>undefined, params: params, query: query, replace: replace, to: to, type: type, analyticsAttributes: analyticsAttributes, ...rest }, ref)=>{
    const [isMenuOpen, { off: closeMenu, toggle: toggleMenu }] = (0, $2Ui4E.useTopMenus)(menuId);
    const { isVisible: isVisible } = (0, $2bzBV.useOverflowStatus)();
    const isHighlighted = (0, $kAJ4Y.useMenuHighlighted)(menuId);
    const triggerAnalytics = (0, $iPj86.useNavigationItemAnalytics)({
        navigationItemId: navigationItemId
    });
    const onClick = (0, $5uXOq.useCallback)(()=>{
        if (!isMenuOpen) onBeforeMenuOpen();
        toggleMenu();
        triggerAnalytics(analyticsAttributes);
    }, [
        analyticsAttributes,
        isMenuOpen,
        onBeforeMenuOpen,
        toggleMenu,
        triggerAnalytics
    ]);
    // close menu on unmount
    (0, $5uXOq.useEffect)(()=>closeMenu, [
        closeMenu
    ]);
    const testId = (0, $6cNb0.testIdGenerate)('primary-actions', menuId, 'menu-trigger');
    if (isVisible) return href != null ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $jmHsa.PrimaryButton), {
        ...rest,
        component: (0, $hjSul.Link),
        href: href,
        isHighlighted: isHighlighted,
        onClick: onClick,
        ref: ref,
        testId: testId,
        // @ts-expect-error - Type '"a"' is not assignable to type '"submit" | "reset" | "button" | undefined'
        type: "a"
    }) : // @ts-expect-error - iconBefore types mismatch ReactNode vs ReactChild
    /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5MZG9.PrimaryDropdownButton), {
        ...rest,
        isHighlighted: isHighlighted,
        isSelected: isMenuOpen,
        onClick: onClick,
        ref: ref,
        testId: testId
    });
    if (to != null && __SPA__) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $9YfZr.RouteLinkItem), {
        ...rest,
        onClick: onClick,
        params: params,
        query: query,
        replace: replace,
        testId: testId,
        to: to,
        type: type
    });
    return href != null ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $jngLf.LinkItem), {
        ...rest,
        href: href,
        onClick: onClick,
        testId: testId
    }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("span", {
        ref: ref
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $kJpBP.default), {
        ...rest,
        iconAfter: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($bb37eb68c16a7749$export$b837bd7eac09a33e, null),
        isSelected: isMenuOpen,
        onClick: onClick,
        testId: testId
    }));
});
// re-render regression detection
// @ts-expect-error - TS2339 - Property 'whyDidYouRender' does not exist on type 'ForwardRefExoticComponent<Pick<any, string | number | symbol> & RefAttributes<MenuTriggerProps>>'.
$bb37eb68c16a7749$export$27d2ad3c5815583e.whyDidYouRender = {
    customName: 'MenuTrigger'
};
const $bb37eb68c16a7749$export$b837bd7eac09a33e = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($bb37eb68c16a7749$var$ChevronWrapper, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($3uzfU))), {
        spacing: "spacious",
        label: "",
        size: "small"
    }));
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $bb37eb68c16a7749$var$ChevronWrapper = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "span", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_tzy4105o _2hwxmgjw",
            __cmplp.className
        ])
    });
});

});
parcelRegister("kAJ4Y", function(module, exports) {

$parcel$export(module.exports, "useMenuHighlighted", () => $afe91b4b16cc8923$export$d47286bd4be0870d);


var $2Ioew = parcelRequire("2Ioew");

var $6jY6G = parcelRequire("6jY6G");
const $afe91b4b16cc8923$export$d47286bd4be0870d = (menuId)=>{
    const route = (0, $6jY6G.useCurrentRoute)();
    const topNavEntryPointReference = (0, $2Ioew.usePageLayoutEntryPoint)((0, $6d6ccf8a2b2c5b3c$export$bec6dca2e63de4ae));
    if (route.navigation) return route.navigation.menuId === menuId;
    if (topNavEntryPointReference) return topNavEntryPointReference.extraProps.menuId === menuId;
    return false;
};

});
const $6d6ccf8a2b2c5b3c$export$948d4d345566aed3 = '__pageLayoutHorizontalNavigation';
const $6d6ccf8a2b2c5b3c$export$50ea883ba6f28ff5 = '__pageLayoutLeftSidebar';
const $6d6ccf8a2b2c5b3c$export$900ddb492c628f48 = '__pageLayoutMainContent';
const $6d6ccf8a2b2c5b3c$export$bec6dca2e63de4ae = '__pageLayoutTopNavigation';
const $6d6ccf8a2b2c5b3c$export$7bf43119a6b49ddb = '__pageLayoutRightSidebar';

parcelRegister("2Ioew", function(module, exports) {

$parcel$export(module.exports, "usePageLayoutEntryPoint", () => $dcf886ac39f7cfda$export$fe1c839e8baf4110);

var $h22md = parcelRequire("h22md");

var $6jY6G = parcelRequire("6jY6G");
const $dcf886ac39f7cfda$export$fe1c839e8baf4110 = (layoutField)=>{
    const route = (0, $6jY6G.useCurrentRoute)();
    const entryPointReference = (0, $h22md.useRouteEntryPoint)({
        route: route
    });
    // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    return entryPointReference?.entryPoints[layoutField];
};

});
parcelRegister("h22md", function(module, exports) {

$parcel$export(module.exports, "useRouteEntryPoint", () => $4e1bc9edc261b42d$export$c96377f800cdddb4);

var $3I4nj = parcelRequire("3I4nj");
const $4e1bc9edc261b42d$export$c96377f800cdddb4 = ({ route: route })=>{
    const [lastLoadedRoute] = (0, $3I4nj.useLastLoadedRoute)();
    // route.entryPoint is already loaded
    if (lastLoadedRoute && lastLoadedRoute.entryPointReference && lastLoadedRoute.route === route) return lastLoadedRoute.entryPointReference;
    return null;
};

});



parcelRegister("jmHsa", function(module, exports) {

$parcel$export(module.exports, "PrimaryButton", () => $d112cde340963e02$export$ac16a6a04d9b7c84);

var $5uXOq = parcelRequire("5uXOq");

var $711X2 = parcelRequire("711X2");

var $6R0Et = parcelRequire("6R0Et");
const $d112cde340963e02$export$ac16a6a04d9b7c84 = /*#__PURE__*/ (0, $5uXOq.forwardRef)((props, ref)=>{
    if (false) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $6R0Et.SkeletonPrimaryButton), {
        text: props.children === undefined ? '' : props.children,
        isHighlighted: props.isHighlighted
    });
    const buttonProps = {
        ...props,
        ref: ref
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $711X2.PrimaryButton), buttonProps);
});

});
parcelRegister("6R0Et", function(module, exports) {

$parcel$export(module.exports, "SkeletonPrimaryButton", () => $9c211af0799e6e88$export$4a3049f952d3f130);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ // eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766

var $f8Sb3 = parcelRequire("f8Sb3");

var $gKAEK = parcelRequire("gKAEK");

var $3mMDm = parcelRequire("3mMDm");
function $9c211af0799e6e88$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $9c211af0799e6e88$var$VAR_PRIMARY_BUTTON_BEFORE_HIGHLIGHTED_BACKGROUND_COLOR = '--primary-button-before-highlighted-background-color';
const $9c211af0799e6e88$var$VAR_PRIMARY_BUTTON_AFTER_DROPDOWN_BORDER_COLOR = '--primary-button-after-dropdown-border-color';
const $9c211af0799e6e88$var$primaryButtonSkeletonStyles = /*#__PURE__*/ (0, $f8Sb3.css)({
    margin: `0 ${"var(--ds-space-075, 6px)"}`,
    padding: `0 ${"var(--ds-space-050, 4px)"}`,
    position: 'relative',
    appearance: 'none',
    border: 0,
    font: "var(--ds-font-body, normal 400 14px/20px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif)",
    fontWeight: "var(--ds-font-weight-medium, 500)",
    pointerEvents: 'none',
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-selectors -- Ignored via go/DSP-18766
    ':focus, :active, :hover': {
        appearance: 'none',
        border: 0,
        outline: 0
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-selectors -- Ignored via go/DSP-18766
    '::-moz-focus-inner': {
        border: 0
    }
});
const $9c211af0799e6e88$var$isHighlightedStyles = /*#__PURE__*/ (0, $f8Sb3.css)({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-selectors -- Ignored via go/DSP-18766
    '&:before': {
        height: 3,
        position: 'absolute',
        backgroundColor: `var(${$9c211af0799e6e88$var$VAR_PRIMARY_BUTTON_BEFORE_HIGHLIGHTED_BACKGROUND_COLOR})`,
        borderStartEndRadius: "var(--ds-border-radius-050, 1px)",
        borderStartStartRadius: "var(--ds-border-radius-050, 1px)",
        content: '""',
        insetBlockEnd: 0,
        insetInlineStart: "var(--ds-space-025, 2px)"
    }
});
const $9c211af0799e6e88$var$isHighlightedAndDropdownButtonStyles = /*#__PURE__*/ (0, $f8Sb3.css)({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-selectors -- Ignored via go/DSP-18766
    '&:before': {
        insetInlineEnd: -10
    }
});
const $9c211af0799e6e88$var$isHighlightedNotDropdownButtonStyles = {
    name: "1sue5tp",
    styles: "&:before{inset-inline-end:var(--ds-space-025, 2px);}"
};
const $9c211af0799e6e88$var$isDropdownButtonStyles = /*#__PURE__*/ (0, $f8Sb3.css)({
    // eslint-disable-next-line @atlaskit/design-system/use-tokens-space
    marginInlineEnd: 18,
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-selectors -- Ignored via go/DSP-18766
    '&:after': {
        display: 'inline-block',
        width: 4,
        height: 4,
        position: 'absolute',
        borderBlockEnd: '2px solid',
        borderColor: `var(${$9c211af0799e6e88$var$VAR_PRIMARY_BUTTON_AFTER_DROPDOWN_BORDER_COLOR})`,
        borderInlineEnd: '2px solid',
        borderRadius: "var(--ds-border-radius-050, 1px)",
        content: '""',
        insetBlockStart: 'calc(50% - 4px)',
        insetInlineStart: 'calc(100% - 3px)',
        marginInlineStart: "var(--ds-space-050, 4px)",
        transform: 'rotate(45deg) scale(1.05)',
        verticalAlign: 'middle'
    }
});
const $9c211af0799e6e88$var$buttonWrapperStyles = {
    name: "rfxc55",
    styles: "display:flex;margin:0"
};
const $9c211af0799e6e88$export$4a3049f952d3f130 = ({ isDropdownButton: isDropdownButton = false, isHighlighted: isHighlighted = false, text: text, children: children, testId: testId })=>{
    const theme = (0, $gKAEK.useTheme)();
    const primaryButton = theme.mode.primaryButton;
    const dynamicStyles = (0, $3mMDm.stripEmptyProperties)({
        ...primaryButton.default,
        ...isHighlighted && {
            color: primaryButton.selected.color
        },
        [$9c211af0799e6e88$var$VAR_PRIMARY_BUTTON_BEFORE_HIGHLIGHTED_BACKGROUND_COLOR]: primaryButton.selected.borderColor,
        [$9c211af0799e6e88$var$VAR_PRIMARY_BUTTON_AFTER_DROPDOWN_BORDER_COLOR]: isHighlighted ? primaryButton.default.borderColor : primaryButton.default.color
    });
    return /*#__PURE__*/ (0, $f8Sb3.jsx)("div", {
        role: "listitem",
        css: $9c211af0799e6e88$var$buttonWrapperStyles
    }, /*#__PURE__*/ (0, $f8Sb3.jsx)("button", {
        type: "button",
        // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
        style: dynamicStyles,
        css: [
            $9c211af0799e6e88$var$primaryButtonSkeletonStyles,
            isHighlighted && $9c211af0799e6e88$var$isHighlightedStyles,
            isDropdownButton && $9c211af0799e6e88$var$isDropdownButtonStyles,
            isHighlighted && (isDropdownButton ? $9c211af0799e6e88$var$isHighlightedAndDropdownButtonStyles : $9c211af0799e6e88$var$isHighlightedNotDropdownButtonStyles)
        ],
        "data-testid": testId
    }, text || children));
};

});


parcelRegister("5MZG9", function(module, exports) {

$parcel$export(module.exports, "PrimaryDropdownButton", () => $e5d31dff0e605df2$export$bb3af89fb196520d);

var $5uXOq = parcelRequire("5uXOq");

var $7ownK = parcelRequire("7ownK");

var $6R0Et = parcelRequire("6R0Et");
const $e5d31dff0e605df2$export$bb3af89fb196520d = /*#__PURE__*/ (0, $5uXOq.forwardRef)((props, ref)=>{
    if (false) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $6R0Et.SkeletonPrimaryButton), {
        isDropdownButton: true,
        isHighlighted: props.isHighlighted,
        text: props.children === undefined ? '' : props.children
    });
    const buttonProps = {
        ...props,
        ref: ref
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7ownK.PrimaryDropdownButton), buttonProps);
});

});


parcelRegister("8JFi2", function(module, exports) {

$parcel$export(module.exports, "stopPropagation", () => $df06b43d1eb10455$export$51134cce184326b9);
const $df06b43d1eb10455$export$51134cce184326b9 = (e)=>e.stopPropagation();

});


parcelRegister("7Fvqy", function(module, exports) {

$parcel$export(module.exports, "useIsStandardOrFreeJSW", () => $ac0a44b8f9a76c7a$export$5edaea31b41b30b);
$parcel$export(module.exports, "useIsPremiumJSW", () => $ac0a44b8f9a76c7a$export$d245a3118a8b4004);
$parcel$export(module.exports, "useIsUnlicensedJSW", () => $ac0a44b8f9a76c7a$export$47ec61465121ff53);

var $efvDm = parcelRequire("efvDm");

var $ldyPw = parcelRequire("ldyPw");

var $k9JTq = parcelRequire("k9JTq");
const $ac0a44b8f9a76c7a$export$a2bbf41e67157372 = ()=>{
    const appEditions = (0, $k9JTq.useAppEditions)();
    const jswEdition = appEditions ? (0, $ldyPw.getEdition)((0, $efvDm.JIRA_SOFTWARE), appEditions) : undefined;
    return jswEdition === (0, $ldyPw.STANDARD_EDITION);
};
const $ac0a44b8f9a76c7a$export$a55cc88b2381611c = ()=>{
    const appEditions = (0, $k9JTq.useAppEditions)();
    const jswEdition = appEditions ? (0, $ldyPw.getEdition)((0, $efvDm.JIRA_SOFTWARE), appEditions) : undefined;
    return jswEdition === (0, $ldyPw.FREE_EDITION);
};
const $ac0a44b8f9a76c7a$export$5edaea31b41b30b = ()=>{
    const appEditions = (0, $k9JTq.useAppEditions)();
    const jswEdition = appEditions ? (0, $ldyPw.getEdition)((0, $efvDm.JIRA_SOFTWARE), appEditions) : undefined;
    return jswEdition === (0, $ldyPw.STANDARD_EDITION) || jswEdition === (0, $ldyPw.FREE_EDITION);
};
const $ac0a44b8f9a76c7a$export$d245a3118a8b4004 = ()=>{
    const appEditions = (0, $k9JTq.useAppEditions)();
    const jswEdition = appEditions ? (0, $ldyPw.getEdition)((0, $efvDm.JIRA_SOFTWARE), appEditions) : undefined;
    return jswEdition === (0, $ldyPw.PREMIUM_EDITION);
};
const $ac0a44b8f9a76c7a$export$47ec61465121ff53 = ()=>{
    const appEditions = (0, $k9JTq.useAppEditions)();
    const jswEdition = appEditions ? (0, $ldyPw.getEdition)((0, $efvDm.JIRA_SOFTWARE), appEditions) : undefined;
    return !jswEdition || jswEdition === (0, $ldyPw.UNLICENSED);
};

});

parcelRegister("edhzr", function(module, exports) {

$parcel$export(module.exports, "MenuTrigger", () => $4c1d4dc7eac32f82$export$27d2ad3c5815583e);

var $5uXOq = parcelRequire("5uXOq");

var $fVbkk = parcelRequire("fVbkk");

var $fcc8T = parcelRequire("fcc8T");
const $4c1d4dc7eac32f82$export$27d2ad3c5815583e = /*#__PURE__*/ (0, $5uXOq.forwardRef)((props, ref)=>{
    if (!false) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $fcc8T.MenuTrigger), {
        ...props,
        ref: ref
    });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $fVbkk.MenuTrigger), {
        ...props,
        ref: ref
    });
});

});
parcelRegister("fcc8T", function(module, exports) {

$parcel$export(module.exports, "MenuTrigger", () => $4bbcc669498d0877$export$27d2ad3c5815583e);

var $5uXOq = parcelRequire("5uXOq");

var $jZ4fr = parcelRequire("jZ4fr");

var $2bzBV = parcelRequire("2bzBV");

var $imZsD = parcelRequire("imZsD");
var $5Fk4Z = parcelRequire("5Fk4Z");

var $dC5iT = parcelRequire("dC5iT");
var $8CUq3 = parcelRequire("8CUq3");

var $lmyls = parcelRequire("lmyls");

var $2Ui4E = parcelRequire("2Ui4E");

var $8Bc5A = parcelRequire("8Bc5A");

var $cE2Qr = parcelRequire("cE2Qr");

var $88fdg = parcelRequire("88fdg");

var $efvDm = parcelRequire("efvDm");

var $ldyPw = parcelRequire("ldyPw");

var $dsvCp = parcelRequire("dsvCp");

var $8QMHF = parcelRequire("8QMHF");

var $k9JTq = parcelRequire("k9JTq");

var $fVbkk = parcelRequire("fVbkk");

var $j94qH = parcelRequire("j94qH");
const $4bbcc669498d0877$var$WRAPPER_UID = 'plans-spotlight-target-wrapper';
const $4bbcc669498d0877$var$useDelayedSpotlight = ()=>{
    const [ready, setSpotlightReady] = (0, $5uXOq.useState)(false);
    (0, $5uXOq.useLayoutEffect)(()=>{
        const timeoutId = setTimeout(()=>setSpotlightReady(true), 100);
        return ()=>clearTimeout(timeoutId);
    }, []);
    return ready;
};
const $4bbcc669498d0877$var$useWrapper = ()=>{
    const ref = (0, $5uXOq.useRef)(null);
    return {
        ref: ref
    };
};
const $4bbcc669498d0877$var$state = {
    hasSpotlightShown: false,
    hasSpotlightDone: false
};
/**
 * The spotlight is forced closed on any click (outside of the menu), which is unexpected behavior
 * This hook will try to re-open the "More" dropdown when the "Plans" is unmounted until the user
 * clicks "Done" on the spotlight
 */ const $4bbcc669498d0877$var$useSpotlightForceOpen = ()=>{
    const { isVisible: isVisible, openOverflowMenu: openOverflowMenu } = (0, $2bzBV.useOverflowStatus)();
    const isDropdownItem = !isVisible;
    (0, $5uXOq.useLayoutEffect)(()=>()=>{
            const updateState = ()=>{
                /**
				 * The actual wrapper is supposed to be unmounted, so, if there is
				 * another wrapper element, it must be the cloned one on the spotlight
				 */ // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
                const spotlightVisible = document.querySelector(`[data-uid="${$4bbcc669498d0877$var$WRAPPER_UID}"]`) != null;
                /**
				 * The dropdown menu is required to remaining openned after clicking Done on the
				 * spotlight. So openOverflowMenu() will be called until state.hasSpotlightDone is true.
				 */ $4bbcc669498d0877$var$state.hasSpotlightShown = $4bbcc669498d0877$var$state.hasSpotlightShown || spotlightVisible;
                if (isDropdownItem && spotlightVisible && $4bbcc669498d0877$var$state.hasSpotlightShown && !$4bbcc669498d0877$var$state.hasSpotlightDone) openOverflowMenu();
                if ($4bbcc669498d0877$var$state.hasSpotlightShown && !spotlightVisible) $4bbcc669498d0877$var$state.hasSpotlightDone = true;
            };
            queueMicrotask(updateState);
        }, [
        isDropdownItem,
        openOverflowMenu
    ]);
};
const $4bbcc669498d0877$export$56d544c4f479b7fb = ({ children: children, isVisible: isVisible })=>{
    const shouldShowNudge = (0, $dsvCp.useCanShowQuickstartNudge)();
    return shouldShowNudge && !false ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $8QMHF.NavigationPlansNavItemWrapperNudgeAsync), {
        isInsideMenu: !isVisible
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $j94qH.FullHeightTextColorWrapper), null, children)) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, children);
};
const $4bbcc669498d0877$export$27d2ad3c5815583e = /*#__PURE__*/ (0, $5uXOq.forwardRef)((props, triggerRef)=>{
    const wrapper = $4bbcc669498d0877$var$useWrapper();
    const ready = $4bbcc669498d0877$var$useDelayedSpotlight();
    const appEditions = (0, $k9JTq.useAppEditions)();
    const jswEdition = appEditions ? (0, $ldyPw.getEdition)((0, $efvDm.JIRA_SOFTWARE), appEditions) : undefined;
    const [shouldShow] = (0, $cE2Qr.useShouldShowNudge)({
        itemNames: [
            (0, $8Bc5A.ADVANCED_ROADMAPS_TASK)
        ]
    });
    $4bbcc669498d0877$var$useSpotlightForceOpen();
    const { isVisible: isVisible } = (0, $2bzBV.useOverflowStatus)();
    const [{ items: items }] = (0, $88fdg.usePlansItems)();
    const analyticsAttributes = {
        isAbleToCreateSamplePlan: !!items?.links?.createSamplePlan?.isVisible,
        ...jswEdition ? {
            jswEdition: jswEdition
        } : {}
    };
    const [isMenuOpen, { toggle: toggleMenu }] = (0, $2Ui4E.useTopMenus)((0, $lmyls.MENU_ID).PLANS);
    (0, $5uXOq.useEffect)(()=>{
        if (shouldShow && !isMenuOpen) toggleMenu();
    }, [
        isMenuOpen,
        shouldShow,
        toggleMenu
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dC5iT.default), {
        backgroundColor: "color.background.neutral.subtle",
        xcss: $4bbcc669498d0877$var$triggerWrapperStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $imZsD.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5Fk4Z.default), {
        name: "nav-advanced-roadmaps-plans-spotlight"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dC5iT.default), {
        "data-uid": $4bbcc669498d0877$var$WRAPPER_UID,
        ref: wrapper.ref,
        backgroundColor: "color.background.neutral.subtle",
        xcss: $4bbcc669498d0877$var$triggerWrapperStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($4bbcc669498d0877$export$56d544c4f479b7fb, {
        isVisible: isVisible
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $fVbkk.MenuTrigger), {
        ref: triggerRef,
        analyticsAttributes: analyticsAttributes,
        ...props
    })))), ready && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $jZ4fr.EngagementSpotlight), {
        engagementId: "nav-advanced-roadmaps-plans-spotlight"
    })));
});
const $4bbcc669498d0877$var$triggerWrapperStyles = (0, $8CUq3.xcss)({
    height: '100%',
    display: 'flex',
    flexGrow: 1
});

});
parcelRegister("8QMHF", function(module, exports) {

$parcel$export(module.exports, "NavigationPlansNavItemWrapperNudgeAsync", () => $721bcfa7775fc750$export$e2e248a8ac2b2891);

var $5uXOq = parcelRequire("5uXOq");


var $bBbEG = parcelRequire("bBbEG");

var $lfTZh = parcelRequire("lfTZh");

var $kxZPA = parcelRequire("kxZPA");

// eslint-disable-next-line jira/deprecations/no-rll-client-async-experiences
const $721bcfa7775fc750$var$NavigationPlansNavItemLazy = (0, $kxZPA.lazyAfterPaint)(()=>(parcelRequire("hFzjx")).then((exportedModule)=>exportedModule.NavigationPlansNavItemWrapperNudge), {
    ssr: false,
    moduleId: "./src/packages/software/onboarding-nudges/src/ui/navigation-plans/index.tsx"
});
const $721bcfa7775fc750$export$e2e248a8ac2b2891 = ({ children: children, isInsideMenu: isInsideMenu })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $bBbEG.OnboardingNudgeErrorBoundary), {
        id: (0, $6784cbc7d62e5d7c$export$46d9a3d441dfd22b),
        fallback: children,
        attributes: {
            nudgeId: (0, $6784cbc7d62e5d7c$export$46d9a3d441dfd22b)
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $lfTZh.default), {
        name: "software-onboarding-navigation-plans-nudge",
        fallback: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, children)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($721bcfa7775fc750$var$NavigationPlansNavItemLazy, {
        nudgeId: (0, $6784cbc7d62e5d7c$export$46d9a3d441dfd22b),
        isInsideMenu: isInsideMenu
    }, children)));

});
// Session storage constants used between going through initial onboarding screens
// and landing in JIRA
// Note this key used to be 'should-show-scrum-modal' but was changed to prevent a bug where experienced users
// Could see the modal if they were previously enrolled into ISO
const $6784cbc7d62e5d7c$export$67abe0a3b8dfe03f = 'should-show-scrum-modal-v2';
const $6784cbc7d62e5d7c$export$4e1360a3e7785935 = 'should-show-kanban-modal';
const $6784cbc7d62e5d7c$export$e3884212029f7bef = 'should-show-welcome-modal';
const $6784cbc7d62e5d7c$export$c45d2ea50af63a85 = 'showed-welcome-modal-during-signup';
const $6784cbc7d62e5d7c$export$c9dc4cb209930823 = 'can-enroll-in-config-wizard-view';
const $6784cbc7d62e5d7c$export$891ca65264b256bb = 'should-show-personlized-sample-data-for-kanban';
const $6784cbc7d62e5d7c$export$f47dca9dda77d157 = 'should-hide-quickstart-for-personalized-sample-data';
const $6784cbc7d62e5d7c$export$16588d2012f3f89b = 'should-show-business-sample-data-nudge';
const $6784cbc7d62e5d7c$export$928ffae10e4c0006 = 'template-key-to-show-onboarding-modal';
const $6784cbc7d62e5d7c$export$6e69f8dc03075ef8 = 'team-type';
const $6784cbc7d62e5d7c$export$c06666264cd35603 = 'team-type-shorthand';
const $6784cbc7d62e5d7c$export$8a00ecf6498ee2fe = 'onboarding-selected-project-template-type';
const $6784cbc7d62e5d7c$export$6973064a898f5989 = 'should-show-list-view-type-cell-spotlight';
const $6784cbc7d62e5d7c$export$115fac1f1144bda1 = 'should-show-list-view-fields-dropdown-spotlight';
const $6784cbc7d62e5d7c$export$69fe8832c4f79a32 = 'onboarding_started_timestamp';
const $6784cbc7d62e5d7c$export$a8d62e500b59f31e = 'boardCreateColumnButtonNudge';
const $6784cbc7d62e5d7c$export$92c7f0eacc8d8d98 = 'assigneeFilterAddPeopleButtonNudge';
const $6784cbc7d62e5d7c$export$dd63d0099d95ba4f = 'navigationAppsNavItemNudge';
const $6784cbc7d62e5d7c$export$aba87e019f5ccb8d = 'navigationCreateIssueButtonNudge';
const $6784cbc7d62e5d7c$export$46d9a3d441dfd22b = 'navigationPlansNavItemNudge';
const $6784cbc7d62e5d7c$export$e20072f7d0c5357f = 'roadmapCreateEpicButtonNudge';
const $6784cbc7d62e5d7c$export$1e39959907a7f359 = 'roadmapCreateEpicChildIssueButtonNudge';
const $6784cbc7d62e5d7c$export$b74a8fdb2c75b869 = 'navigationPeopleNavItemNudge';
const $6784cbc7d62e5d7c$export$b1a6ab17737f33e = 'backlogAccordionNudge';
const $6784cbc7d62e5d7c$export$eb64d5f1a091478b = 'backlogCreateSprintIssueNudge';
const $6784cbc7d62e5d7c$export$64d75060ee6ba425 = 'backlogCreateIssueNudge';
const $6784cbc7d62e5d7c$export$3366ddefe77d5112 = 'boardCreateColumnNudge';
const $6784cbc7d62e5d7c$export$9d9e95a66a2c6abe = 'addItemsCalendarNudge';
const $6784cbc7d62e5d7c$export$69aca8ebee0d34c8 = 'trelloCrossflowAddItemsCalendarNudge';
const $6784cbc7d62e5d7c$export$7aa8bceae32c7862 = 'navigationAppsProfileItemNudge';
const $6784cbc7d62e5d7c$export$c6df9a2c7447e12d = 'getStartedListNudge';
const $6784cbc7d62e5d7c$export$468488291ccd988 = 'timelineAddItemNudge';
const $6784cbc7d62e5d7c$export$7a33548109ac931d = 'createFormNudge';
const $6784cbc7d62e5d7c$export$b65ba9ea0c0ced43 = 'jsw-onboarding-checklist.open';
const $6784cbc7d62e5d7c$export$3b5d230b66f60471 = 'jsw-onboarding-checklist.visibility';
const $6784cbc7d62e5d7c$export$594d3436316492be = 'summaryViewNudge';
const $6784cbc7d62e5d7c$export$f93b83d735f01fa3 = 'pagesCreatePageNudge';
const $6784cbc7d62e5d7c$export$77bc79debbf5c069 = 'inviteTeamNudge';
const $6784cbc7d62e5d7c$export$6ffa29e74c0304c4 = 'tailorBoardColumnsNudge';
const $6784cbc7d62e5d7c$export$699265ec8ad9a740 = 'Software Development';
const $6784cbc7d62e5d7c$export$e07d1fa2da8ed874 = 'Customer Service';
const $6784cbc7d62e5d7c$export$76dcec3f438d9e56 = 'IT Support';
const $6784cbc7d62e5d7c$export$9a574c301f67ba30 = 'Human Resources';
const $6784cbc7d62e5d7c$export$363ec144a94029c8 = 'Finance';
const $6784cbc7d62e5d7c$export$df0fb32d68ae1e78 = 'Legal';
const $6784cbc7d62e5d7c$export$d9c0e3e59442fb4 = 'Marketing';
const $6784cbc7d62e5d7c$export$27dbc7d7ce66e6e3 = 'Operations';
const $6784cbc7d62e5d7c$export$a5dce388adf922bd = 'Sales';
const $6784cbc7d62e5d7c$export$e1473b31a257caff = 'Data Science';
const $6784cbc7d62e5d7c$export$85657457db93c2c2 = 'Product Management';
const $6784cbc7d62e5d7c$export$c0c2d1dfaeba89dd = 'Project Management';
const $6784cbc7d62e5d7c$export$2e6a7ad3ab9c82a3 = 'Design';
const $6784cbc7d62e5d7c$export$7b60378c3b4372e9 = 'Other or Personal';
const $6784cbc7d62e5d7c$export$572242e58bd07594 = 'CS';
const $6784cbc7d62e5d7c$export$d7de553940261eba = 'ITS';
const $6784cbc7d62e5d7c$export$4c29d0d04c15e55d = 'HR';
const $6784cbc7d62e5d7c$export$3950f7f841bf94b6 = 'FNC';
const $6784cbc7d62e5d7c$export$881249b988b6030f = 'LGL';
const $6784cbc7d62e5d7c$export$e4824f74b9879164 = 'MKT';
const $6784cbc7d62e5d7c$export$4f3cb0844009af52 = 'OPS';
const $6784cbc7d62e5d7c$export$1a65d50c4a641bb4 = 'SAL';
const $6784cbc7d62e5d7c$export$9ee64e8fbd8b03a2 = 'DS';
const $6784cbc7d62e5d7c$export$b8b1ac856ba1434b = 'DEV';
const $6784cbc7d62e5d7c$export$4f54a09a24fd1d74 = 'PDM';
const $6784cbc7d62e5d7c$export$79685802e8ff1098 = 'PJM';
const $6784cbc7d62e5d7c$export$e5c438b7501b5a24 = 'DES';
const $6784cbc7d62e5d7c$export$cbc0e551d91a692d = 'OTR';

parcelRegister("hFzjx", function(module, exports) {

let $cdd1a8a662bf5e90$var$load = (parcelRequire("28QjX"))(4);
module.exports = $cdd1a8a662bf5e90$var$load("56cs9").then(()=>parcelRequire('gf2wp'));

});


parcelRegister("j94qH", function(module, exports) {

$parcel$export(module.exports, "FullHeightTextColorWrapper", () => $1e4986b0c19053de$export$19a17a164d8e4de3);
/* styled.tsx generated by @compiled/babel-plugin v0.36.1 */ // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766

var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");
const $1e4986b0c19053de$export$7ac7d6a768c2e9b2 = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $5uXOq.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_4t3i1osq _1e0c1txw _4cvr1h6o _16jlkb7n _19pnkb7n _13aikb7n _1gqrf1ug",
            __cmplp.className
        ])
    });
});
const $1e4986b0c19053de$export$19a17a164d8e4de3 = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $5uXOq.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_4t3i1osq _1e0c1txw _4cvr1h6o _syaz1fxt _16jlkb7n _19pnkb7n _13aikb7n _1gqrf1ug",
            __cmplp.className
        ])
    });
});

});



parcelRegister("2eMU9", function(module, exports) {

$parcel$export(module.exports, "default", () => $c5668dcd9601b742$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $9UCCQ = parcelRequire("9UCCQ");

var $MHKc7 = parcelRequire("MHKc7");

var $g0Gtc = parcelRequire("g0Gtc");

var $7CMCs = parcelRequire("7CMCs");

var $bcn6L = parcelRequire("bcn6L");

var $lmyls = parcelRequire("lmyls");

var $6cNb0 = parcelRequire("6cNb0");

var $lfTZh = parcelRequire("lfTZh");

var $cmvab = parcelRequire("cmvab");

var $9JG4b = parcelRequire("9JG4b");

var $Mp6qH = parcelRequire("Mp6qH");

var $8vzcp = parcelRequire("8vzcp");

var $ag3sS = parcelRequire("ag3sS");

var $9TMfX = parcelRequire("9TMfX");

var $6WLja = parcelRequire("6WLja");

var $7Fvqy = parcelRequire("7Fvqy");

var $hZbyv = parcelRequire("hZbyv");

var $42REw = parcelRequire("42REw");

var $53HSR = parcelRequire("53HSR");

var $6MUS3 = parcelRequire("6MUS3");

var $5n6PC = parcelRequire("5n6PC");

var $aProA = parcelRequire("aProA");
const $c5668dcd9601b742$var$EVENT_DATA = {
    id: (0, $lmyls.MENU_ID).PLANS
};
const $c5668dcd9601b742$var$Menu = ({ ActionFooter: ActionFooter = (0, $hZbyv.ActionFooter), AdminFooter: AdminFooter = (0, $42REw.AdminFooter), Content: Content = (0, $53HSR.default), FavoriteContent: // @ts-expect-error - TS2339 - Property 'FavoriteContent' does not exist on type 'MenuProps'.
FavoriteContent = (0, $6MUS3.FavoriteContent), Error: Error = (0, $8vzcp.MenuError), JSErrorBoundary: JSErrorBoundary = (0, $7CMCs.JSErrorBoundary), Layout: Layout = (0, $ag3sS.MenuLayout), LoadStatus: LoadStatus = (0, $5n6PC.LoadStatus), Section: Section = (0, $9UCCQ.default), SkeletonContent: SkeletonContent = (0, $9TMfX.MenuSkeletonContent), SkeletonFooter: SkeletonFooter = (0, $6WLja.MenuSkeletonFooter), ViewExperienceSuccessTracker: ViewExperienceSuccessTracker = (0, $g0Gtc.ExperienceSuccessTracker), testIdPrefix: testIdPrefix, useFavorite: // @ts-expect-error - TS2339 - Property 'useFavorite' does not exist on type 'MenuProps'.
useFavorite = (0, $bcn6L.useFavoritePlans) })=>{
    const [, { loadFavoritePlans: loadFavorite }] = useFavorite();
    const contentTestId = (0, $6cNb0.testIdConcat)(testIdPrefix, 'content');
    const actionFooterTestId = (0, $6cNb0.testIdConcat)(testIdPrefix, 'action-footer');
    const adminFooterTestId = (0, $6cNb0.testIdConcat)(testIdPrefix, 'admin-footer');
    const isStandardOrFree = (0, $7Fvqy.useIsStandardOrFreeJSW)();
    const errorFallback = (0, $5uXOq.useCallback)(()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(Error, {
            testIdPrefix: contentTestId
        }), // eslint-disable-next-line react-hooks/exhaustive-deps
    [
        contentTestId
    ]);
    (0, $5uXOq.useEffect)(()=>()=>{
            // Refresh favourites on close to update if user has toggled any item
            !isStandardOrFree && loadFavorite((0, $Mp6qH.DEFAULT_LOAD_COUNT_FAV));
        }, [
        loadFavorite,
        isStandardOrFree
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(Layout, {
        isWide: true
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(JSErrorBoundary, {
        id: (0, $lmyls.MENU_ID).PLANS,
        packageName: (0, $Mp6qH.PACKAGE_NAME),
        fallback: errorFallback,
        withExperienceTracker: true,
        extraEventData: $c5668dcd9601b742$var$EVENT_DATA
    }, isStandardOrFree ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $aProA.default), null) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(Section, {
        isScrollable: true
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $lfTZh.default), {
        name: "plans-menu-content",
        fallback: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(SkeletonContent, {
            testIdPrefix: contentTestId
        })
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $cmvab.PaidFeatureAwarenessRenderer), {
        component: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $MHKc7.default), {
            paddingInline: "space.200",
            paddingBlockStart: "space.200",
            paddingBlockEnd: "space.075"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $9JG4b.PaidFeatureAwarenessPremiumLozenge), null)),
        placement: "navigation.v3.plans"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(ViewExperienceSuccessTracker, {
        location: "atlassian-navigation--primary-actions--plans--menu-popup--content",
        failureEventAttributes: null,
        parentProviders: null
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(LoadStatus, {
        shouldThrowError: true
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(FavoriteContent, {
        testIdPrefix: contentTestId
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(Content, {
        testIdPrefix: contentTestId
    })))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(Section, {
        hasSeparator: true
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $lfTZh.default), {
        name: "plans-menu-footer",
        fallback: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(SkeletonFooter, {
            testIdPrefix: contentTestId
        })
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(LoadStatus, null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(ActionFooter, {
        testIdPrefix: actionFooterTestId
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(AdminFooter, {
        testIdPrefix: adminFooterTestId
    }))))));
};
var $c5668dcd9601b742$export$2e2bcd8739ae039 = $c5668dcd9601b742$var$Menu;

});
parcelRegister("cmvab", function(module, exports) {

$parcel$export(module.exports, "PaidFeatureAwarenessRenderer", () => $3d319632a25c0850$export$64aa988820df8e0f);

var $b6HdT = parcelRequire("b6HdT");

var $5uXOq = parcelRequire("5uXOq");

var $8Uumt = parcelRequire("8Uumt");

var $hYRTO = parcelRequire("hYRTO");

var $cLXfT = parcelRequire("cLXfT");

var $k9JTq = parcelRequire("k9JTq");

var $5oBMG = parcelRequire("5oBMG");

var $ldyPw = parcelRequire("ldyPw");


var $4R6GH = parcelRequire("4R6GH");

var $6s1PB = parcelRequire("6s1PB");

var $koeKL = parcelRequire("koeKL");

var $7CMCs = parcelRequire("7CMCs");

var $iXVV6 = parcelRequire("iXVV6");
var $5oFIy = parcelRequire("5oFIy");
const $3d319632a25c0850$export$dc50189dfb775e17 = (props)=>{
    const { component: component } = props;
    const cloudId = (0, $koeKL.useCloudId)();
    const hamsProductKey = (0, $cLXfT.getHamsProductKey)((0, $c06e1abca7c13910$export$1346c9aa3cbb477d));
    const data = (0, $8Uumt.useLazyLoadQuery)((0, $b6HdT.default), {
        cloudId: cloudId,
        hamsProductKey: hamsProductKey
    });
    const entitlement = data?.tenantContexts?.[0]?.entitlementInfo?.entitlement;
    const hasPaymentDetails = entitlement?.transactionAccount?.isBillToPresent === true;
    if (hasPaymentDetails !== false) return props.fallback;
    return (0, $6s1PB.expValEquals)('persistent_paid_feature_awareness_ab', 'cohort', 'variation', 'not-enrolled') ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $iXVV6.ContextualAnalyticsData), {
        sourceType: (0, $4d5e0871c06cee03$export$f636b5b56f1d624a),
        sourceName: "paidFeatureAwareness",
        attributes: {
            placement: props.placement
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5oFIy.FireScreenAnalytics), null), component) : props.fallback;
};
const $3d319632a25c0850$export$43f5a9f3669b7084 = (props)=>{
    const appEditions = (0, $k9JTq.useAppEditions)();
    const jswEdition = appEditions.software;
    const productEntitlementDetails = (0, $5oBMG.useProductEntitlementDetails)();
    const jswEntitlementDetails = productEntitlementDetails?.[0, $c06e1abca7c13910$export$1346c9aa3cbb477d];
    const trialEndTime = jswEntitlementDetails?.trialEndTime;
    const currentDate = (0, $5uXOq.useMemo)(()=>Date.now(), []);
    const isOnJSWTrial = Boolean(trialEndTime && currentDate < trialEndTime);
    /** Eligibility criteria (in order of evaluation)
   * - FG must be on
   * - Must be on JSW Premium Trial
   * - Must not have payment details entered (obtained via query)
   * - Must be in variation for experiment (fire exposure at this point)
   */ const isOnJswPremiumTrial = jswEdition === (0, $ldyPw.PREMIUM_EDITION) && isOnJSWTrial;
    return isOnJswPremiumTrial ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($3d319632a25c0850$export$dc50189dfb775e17, props) : props.fallback;
};
const $3d319632a25c0850$export$64aa988820df8e0f = (props)=>{
    const { fallback: fallback = null, ...rest } = props;
    return (0, $4R6GH.fg)('persistent_paid_feature_awareness') ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7CMCs.JSErrorBoundary), {
        id: "paidFeatureAwarenessBoundary",
        packageName: "@atlassian/jira-paid-feature-awareness-renderer",
        fallback: fallback ? ()=>fallback : 'unmount',
        teamName: "growth-tako",
        sendToPrivacyUnsafeSplunk: true,
        attributes: {
            placement: props.placement
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $hYRTO.default), {
        name: "paid-feature-awareness-renderer-placeholder",
        fallback: null
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($3d319632a25c0850$export$43f5a9f3669b7084, {
        fallback: fallback,
        ...rest
    }))) : fallback;
};

});
parcelRegister("b6HdT", function(module, exports) {

$parcel$export(module.exports, "default", () => $96fb09f2fb680d6a$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<c65e158836bb825b8b10729b53579e23>>
 * @relayHash dd332bbc60ac1be709db56083c130987
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 41d0bebb795cea640c8555aa4316be536054f8f7c4f0550009867fc14f76adf5
const $96fb09f2fb680d6a$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "cloudId"
        },
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "hamsProductKey"
        }
    ], v1 = [
        {
            "items": [
                {
                    "kind": "Variable",
                    "name": "cloudIds.0",
                    "variableName": "cloudId"
                }
            ],
            "kind": "ListValue",
            "name": "cloudIds"
        }
    ], v2 = [
        {
            "kind": "Variable",
            "name": "hamsProductKey",
            "variableName": "hamsProductKey"
        }
    ], v3 = {
        "kind": "ScalarField",
        "name": "isBillToPresent"
    }, v4 = {
        "kind": "ScalarField",
        "name": "__typename"
    }, v5 = {
        "kind": "ScalarField",
        "name": "id"
    };
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "uiGetPaymentDetailsEnteredQuery",
            "selections": [
                {
                    "args": v1 /*: any*/ ,
                    "concreteType": "TenantContext",
                    "kind": "LinkedField",
                    "name": "tenantContexts",
                    "plural": true,
                    "selections": [
                        {
                            "args": v2 /*: any*/ ,
                            "kind": "LinkedField",
                            "name": "entitlementInfo",
                            "plural": false,
                            "selections": [
                                {
                                    "kind": "LinkedField",
                                    "name": "entitlement",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "kind": "LinkedField",
                                            "name": "transactionAccount",
                                            "plural": false,
                                            "selections": [
                                                v3 /*: any*/ 
                                            ]
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ],
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "uiGetPaymentDetailsEnteredQuery",
            "selections": [
                {
                    "args": v1 /*: any*/ ,
                    "concreteType": "TenantContext",
                    "kind": "LinkedField",
                    "name": "tenantContexts",
                    "plural": true,
                    "selections": [
                        {
                            "args": v2 /*: any*/ ,
                            "kind": "LinkedField",
                            "name": "entitlementInfo",
                            "plural": false,
                            "selections": [
                                v4 /*: any*/ ,
                                {
                                    "kind": "LinkedField",
                                    "name": "entitlement",
                                    "plural": false,
                                    "selections": [
                                        v4 /*: any*/ ,
                                        {
                                            "kind": "LinkedField",
                                            "name": "transactionAccount",
                                            "plural": false,
                                            "selections": [
                                                v4 /*: any*/ ,
                                                v3 /*: any*/ ,
                                                {
                                                    "kind": "InlineFragment",
                                                    "selections": [
                                                        v5 /*: any*/ 
                                                    ],
                                                    "type": "Node",
                                                    "abstractKey": "__isNode"
                                                }
                                            ]
                                        },
                                        v5 /*: any*/ 
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ]
        },
        "params": {
            "id": "41d0bebb795cea640c8555aa4316be536054f8f7c4f0550009867fc14f76adf5",
            "metadata": {},
            "name": "uiGetPaymentDetailsEnteredQuery",
            "operationKind": "query",
            "text": null
        }
    };
}();
$96fb09f2fb680d6a$var$node.hash = "cd9ff36ba318610ca3a732f7742e9802";
var $96fb09f2fb680d6a$export$2e2bcd8739ae039 = $96fb09f2fb680d6a$var$node;

});

parcelRegister("cLXfT", function(module, exports) {

$parcel$export(module.exports, "getHamsProductKey", () => $be23717f2b4b385d$export$413aba2429285627);
$parcel$export(module.exports, "getHamsProductKeyForProject", () => $be23717f2b4b385d$export$74f585c1245fa1a4);


var $1laI5 = parcelRequire("1laI5");
const $be23717f2b4b385d$export$413aba2429285627 = (applicationKey)=>{
    // JPD key does not have '.ondemand'
    if (applicationKey === (0, $c06e1abca7c13910$export$202f50ee62667e32)) return applicationKey;
    return `${applicationKey}.ondemand`;
};
const $be23717f2b4b385d$export$74f585c1245fa1a4 = (project)=>{
    const application = (0, $1laI5.projectToApplicationKey)(project);
    return $be23717f2b4b385d$export$413aba2429285627(application);
};

});
const $c06e1abca7c13910$export$c8c1c8c3f8ddba61 = 'jira-servicedesk';
const $c06e1abca7c13910$export$e9c56aa3b027d98f = 'jira-customer-service';
const $c06e1abca7c13910$export$1346c9aa3cbb477d = 'jira-software';
const $c06e1abca7c13910$export$202f50ee62667e32 = 'jira-product-discovery';
const $c06e1abca7c13910$export$db515c8cec1e6f79 = 'jira-core';
const $c06e1abca7c13910$export$c811f21c9ad05dc2 = 'confluence';
const $c06e1abca7c13910$export$961148c98d198270 = 'opsgenie';


// SCREENS
const $4d5e0871c06cee03$export$f636b5b56f1d624a = 'Screen';
const $4d5e0871c06cee03$export$9d2de6eebf7462b5 = 'Drawer';
const $4d5e0871c06cee03$export$1171103ea9083ffa = 'Modal';
const $4d5e0871c06cee03$export$cae2783c9279926 = 'InlineDialog';
const $4d5e0871c06cee03$export$d1123261ca8831d2 = 'Dropdown';
const $4d5e0871c06cee03$export$238d30785c4bca84 = 'Banner';
const $4d5e0871c06cee03$export$a1562d08625f5d7e = 'UI';
const $4d5e0871c06cee03$export$947dac6c72b26f81 = 'TRACK';
const $4d5e0871c06cee03$export$f1d537d508d2945a = 'SCREEN';
const $4d5e0871c06cee03$export$12346a674644c156 = 'OPERATIONAL';


parcelRegister("9JG4b", function(module, exports) {

$parcel$export(module.exports, "PaidFeatureAwarenessStandardLozenge", () => $2cc69a400fe5eaed$export$7ffe6b10a925635e);
$parcel$export(module.exports, "PaidFeatureAwarenessPremiumLozenge", () => $2cc69a400fe5eaed$export$c759caf4220d9852);

var $5uXOq = parcelRequire("5uXOq");

var $aYAc3 = parcelRequire("aYAc3");

var $3bDjY = parcelRequire("3bDjY");

var $koVbs = parcelRequire("koVbs");

var $6J1YC = parcelRequire("6J1YC");
const $2cc69a400fe5eaed$export$7ffe6b10a925635e = ()=>{
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $3bDjY.default), {
        content: formatMessage((0, $6J1YC.default).standardTooltip)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $aYAc3.default), {
        appearance: "new"
    }, formatMessage((0, $6J1YC.default).standardLozenge)));
};
const $2cc69a400fe5eaed$export$c759caf4220d9852 = ()=>{
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $3bDjY.default), {
        content: formatMessage((0, $6J1YC.default).premiumTooltip)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $aYAc3.default), {
        appearance: "new"
    }, formatMessage((0, $6J1YC.default).premiumLozenge)));
};

});
parcelRegister("6J1YC", function(module, exports) {

$parcel$export(module.exports, "default", () => $93f00b26671642aa$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $93f00b26671642aa$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    standardLozenge: {
        "id": "paid-feature-awareness.standard-lozenge",
        "defaultMessage": "Standard"
    },
    premiumLozenge: {
        "id": "paid-feature-awareness.premium-lozenge",
        "defaultMessage": "Premium"
    },
    standardGemTooltip: {
        "id": "paid-feature-awareness.standard-gem-tooltip",
        "defaultMessage": "This is a Standard and Premium plan feature"
    },
    standardTooltip: {
        "id": "paid-feature-awareness.standard-lozenge-tooltip",
        "defaultMessage": "This is a Standard plan feature"
    },
    premiumTooltip: {
        "id": "paid-feature-awareness.premium-tooltip",
        "defaultMessage": "This is a Premium plan feature"
    },
    automationTooltip: {
        "id": "paid-feature-awareness.automation-tooltip",
        "defaultMessage": "Automations varies by plan. Free: 100 rule runs/mo; Standard: 1,700 rule runs/mo; Premium: 1000 rule runs per user/mo"
    }
});

});


parcelRegister("8vzcp", function(module, exports) {

$parcel$export(module.exports, "MenuError", () => $51a1ea955baf80ff$export$b4cb8426191db8b3);
/* main.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $koVbs = parcelRequire("koVbs");

var $6cNb0 = parcelRequire("6cNb0");

var $jyltl = parcelRequire("jyltl");

var $56G71 = parcelRequire("56G71");

var $itL3d = parcelRequire("itL3d");
const $51a1ea955baf80ff$export$b4cb8426191db8b3 = ({ testIdPrefix: testIdPrefix })=>{
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const errorText = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($51a1ea955baf80ff$var$TextWrapper, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($51a1ea955baf80ff$var$Heading, null, formatMessage((0, $itL3d.default).errorHeading)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("div", null, formatMessage((0, $itL3d.default).errorBody)));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $jyltl.MenuInfo), {
        imgAltText: formatMessage((0, $itL3d.default).errorImg),
        imgSrc: (0, (/*@__PURE__*/$parcel$interopDefault($56G71))),
        testId: (0, $6cNb0.testIdConcat)(testIdPrefix, 'error'),
        text: errorText,
        useSmallImage: true
    });
};
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $51a1ea955baf80ff$var$TextWrapper = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_ca0qidpf _u5f31ejb _n3tdidpf _19bv1ejb",
            __cmplp.className
        ])
    });
});
const $51a1ea955baf80ff$var$Heading = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "strong", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_1e0c1ule _otyru2gc",
            __cmplp.className
        ])
    });
});

});
parcelRegister("jyltl", function(module, exports) {

$parcel$export(module.exports, "MenuInfo", () => $c2ec3089b9809088$export$14caacd677140cdb);
/* main.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");
var $lD23V = parcelRequire("lD23V");
const $c2ec3089b9809088$export$14caacd677140cdb = ({ imgAltText: imgAltText, imgHeight: imgHeight, imgSrc: imgSrc, text: text, useSmallImage: useSmallImage = false, testId: testId })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($c2ec3089b9809088$export$895814aa5a1cf38c, {
        "data-testid": testId
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($c2ec3089b9809088$export$e54065c861f556f9, {
        alt: imgAltText || '',
        imgHeight: imgHeight,
        src: imgSrc,
        useSmallImage: useSmallImage
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($c2ec3089b9809088$export$7c3018f441722857, null, text));
const $c2ec3089b9809088$export$895814aa5a1cf38c = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_19pkidpf _2hwx1wug _otyridpf _18u01wug _1bsbnklw _1e0c1txw _y3gn1h6o _2lx21bp4",
            __cmplp.className
        ])
    });
});
const $c2ec3089b9809088$export$e54065c861f556f9 = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "img", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { useSmallImage: useSmallImage, imgHeight: imgHeight, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmpldp,
        style: {
            ...__cmpls,
            "--_ve50id": (0, $lD23V.default)(__cmplp.imgHeight, "px")
        },
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_19pkidpf _2hwx1wug _otyridpf _18u01wug _1e0c1ule _ca0qv47k _u5f3idpf _n3tdpxbi _19bvidpf _p12f1osq",
            __cmplp.useSmallImage ? "_1bsb16xz" : "_1bsb1lit",
            __cmplp.imgHeight != null ? "_4t3i1m1g" : "_4t3i1wug",
            __cmplp.className
        ])
    });
});
const $c2ec3089b9809088$export$7c3018f441722857 = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_1e0c1ule _ca0qidpf _u5f3v47k _n3tdv47k _19bvv47k",
            __cmplp.className
        ])
    });
});

});

parcelRegister("56G71", function(module, exports) {
module.exports = new URL("generic-error.bc45c66a.svg", import.meta.url).toString();

});

parcelRegister("itL3d", function(module, exports) {

$parcel$export(module.exports, "default", () => $9730b8dbc9b9bc1a$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $9730b8dbc9b9bc1a$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    errorHeading: {
        "id": "atlassian-navigation.common.menu.error.error-heading",
        "defaultMessage": "Something went wrong"
    },
    errorBody: {
        "id": "atlassian-navigation.common.menu.error.error-body",
        "defaultMessage": "Try refreshing or navigating to another page."
    },
    errorImg: {
        "id": "atlassian-navigation.common.menu.error.error-img",
        "defaultMessage": "An image showing that an error has occurred"
    }
});

});


parcelRegister("hZbyv", function(module, exports) {

$parcel$export(module.exports, "ActionFooter", () => $adef3029a926b6d1$export$2d2b754ac238f9aa);

var $5uXOq = parcelRequire("5uXOq");

var $koVbs = parcelRequire("koVbs");

var $6cNb0 = parcelRequire("6cNb0");

var $88fdg = parcelRequire("88fdg");

var $gD5Z0 = parcelRequire("gD5Z0");

var $4LAva = parcelRequire("4LAva");

var $L0P37 = parcelRequire("L0P37");

var $9EGDV = parcelRequire("9EGDV");

var $eemc9 = parcelRequire("eemc9");
const $adef3029a926b6d1$export$2d2b754ac238f9aa = ({ testIdPrefix: testIdPrefix })=>{
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const [{ items: items }] = (0, $88fdg.usePlansItems)();
    const isPlanListEmpty = (0, $eemc9.useIsPlanListEmpty)();
    const testId = (0, $6cNb0.testIdConcat)(testIdPrefix, 'action-footer');
    const [, { openDrawer: openCreateNewPlanWizardDrawer }] = (0, $gD5Z0.useCreateNewPlanWizardDrawer)();
    const [, { open: openCreateSamplePlanModal }] = (0, $4LAva.useCreateSamplePlan)();
    const onClick = (0, $5uXOq.useCallback)(()=>{
        openCreateNewPlanWizardDrawer();
    }, [
        openCreateNewPlanWizardDrawer
    ]);
    if (!items || !items.links) return null;
    const { links: links } = items;
    const { managePlans: managePlans, createPlan: createPlan, createSamplePlan: createSamplePlan } = links;
    const isAnyItemVisible = managePlans.isVisible || createPlan.isVisible;
    if (!isAnyItemVisible) return null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("span", {
        "data-testId": testId
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $L0P37.MenuItem), {
        ...links.managePlans,
        title: formatMessage((0, $9EGDV.default).managePlans),
        testIdPrefix: testIdPrefix
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $L0P37.MenuItem), {
        id: links.createPlan.id,
        isVisible: links.createPlan.isVisible && !isPlanListEmpty,
        title: formatMessage((0, $9EGDV.default).createPlan),
        testIdPrefix: testIdPrefix,
        onClick: onClick
    }), createSamplePlan && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $L0P37.MenuItem), {
        id: createSamplePlan.id,
        isVisible: createSamplePlan.isVisible && !isPlanListEmpty,
        title: formatMessage((0, $9EGDV.default).createDemoPlan),
        testIdPrefix: testIdPrefix,
        onClick: openCreateSamplePlanModal
    }));
};

});
parcelRegister("gD5Z0", function(module, exports) {

$parcel$export(module.exports, "useCreateNewPlanWizardDrawer", () => $13f82bb8cfc1f7f2$export$f3e7d3fc94eda89a);
$parcel$export(module.exports, "useImportedMessagesForLocale", () => $13f82bb8cfc1f7f2$export$52303468eeac3ad0);

var $5uXOq = parcelRequire("5uXOq");

var $eTXmK = parcelRequire("eTXmK");

var $koVbs = parcelRequire("koVbs");

var $gg7kZ = parcelRequire("gg7kZ");
var $3sQ5x = parcelRequire("3sQ5x");
var $iXqE5 = parcelRequire("iXqE5");

var $4R6GH = parcelRequire("4R6GH");
const $13f82bb8cfc1f7f2$var$CONTROLLER_NAME = 'create-new-plan-wizard-drawer';
const $13f82bb8cfc1f7f2$var$initialState = {
    isOpen: false,
    plan: undefined,
    isPlanCreationComplete: false
};
const $13f82bb8cfc1f7f2$var$Store = (0, $iXqE5.createStore)({
    name: $13f82bb8cfc1f7f2$var$CONTROLLER_NAME,
    initialState: $13f82bb8cfc1f7f2$var$initialState,
    actions: {
        openDrawer: (plan)=>{
            (0, $eTXmK.default)('arj-create-plan-wizard-drawer');
            return (0, $4R6GH.fg)('ensure_plan_create_ufo_event_fires_successfully') ? ({ setState: setState })=>setState({
                    isOpen: true,
                    plan: plan,
                    isPlanCreationComplete: false
                }) : ({ setState: setState })=>setState({
                    isOpen: true,
                    plan: plan
                });
        },
        closeDrawer: ()=>({ setState: setState })=>setState({
                    isOpen: false,
                    plan: undefined
                }),
        setIsPlanCreationComplete: (isPlanCreationComplete = true)=>({ setState: setState })=>(0, $4R6GH.fg)('ensure_plan_create_ufo_event_fires_successfully') ? setState({
                    isPlanCreationComplete: isPlanCreationComplete
                }) : undefined
    }
});
const $13f82bb8cfc1f7f2$export$f3e7d3fc94eda89a = (0, $3sQ5x.createHook)($13f82bb8cfc1f7f2$var$Store);
const $13f82bb8cfc1f7f2$export$9ec7b5762fb72de2 = (0, $gg7kZ.createContainer)($13f82bb8cfc1f7f2$var$Store, {
    onInit: ()=>({ setState: setState }, { isOpen: isOpen, plan: plan })=>{
            setState({
                isOpen: isOpen,
                plan: plan
            });
        }
});
const $13f82bb8cfc1f7f2$var$EXCLUDED_I18N_FILES = [
    'index',
    'languages',
    'en'
];
const $13f82bb8cfc1f7f2$var$FALLBACK_INTL_MESSAGES = Object.freeze({});
const $13f82bb8cfc1f7f2$export$19442c17ab279a67 = async (rawlocale = 'en')=>{
    // Filter out country code as the AFE i18n does not use them e.g en => en-US
    const locale = rawlocale.split('-')[0];
    if (!locale || $13f82bb8cfc1f7f2$var$EXCLUDED_I18N_FILES.includes(locale)) return {
        default: $13f82bb8cfc1f7f2$var$FALLBACK_INTL_MESSAGES
    };
    const packageName = (0, $4R6GH.fg)('finish_jira-portfolio-3-plan-wizard_migration') ? 'jira-portfolio-3-plan-wizard' : 'jira-portfolio-plan-wizard';
    try {
        {
            // eslint-disable-next-line jira/import/webpack-magic-comment-entries
            const i18nModule = await import(`@atlassian/${packageName}/dist/esm/i18n/*.js`);
            const result = i18nModule[locale]();
            return result;
        }
        // eslint-disable-next-line jira/import/webpack-magic-comment-entries
        const result = await import(`@atlassian/${packageName}/dist/cjs/i18n/${locale}`);
        return result;
    } catch  {
        return {
            default: $13f82bb8cfc1f7f2$var$FALLBACK_INTL_MESSAGES
        };
    }
};
const $13f82bb8cfc1f7f2$export$52303468eeac3ad0 = ()=>{
    const { locale: locale } = (0, $koVbs.default)();
    const [state, setState] = (0, $5uXOq.useState)({
        locale: locale,
        loading: true,
        intlMessages: undefined
    });
    (0, $5uXOq.useEffect)(()=>{
        let mounted = true;
        const load = async ()=>{
            // eslint-disable-next-line @typescript-eslint/no-shadow
            setState((state)=>({
                    ...state,
                    loading: true
                }));
            const { default: intlMessages } = await $13f82bb8cfc1f7f2$export$19442c17ab279a67(locale);
            if (!mounted) return;
            // eslint-disable-next-line @typescript-eslint/no-shadow
            setState((state)=>({
                    ...state,
                    loading: false,
                    intlMessages: intlMessages
                }));
        };
        load();
        return ()=>{
            mounted = false;
        };
    }, [
        locale
    ]);
    return state;
};

});

parcelRegister("4LAva", function(module, exports) {

$parcel$export(module.exports, "useCreateSamplePlan", () => $8f6b3552bc4c872c$export$53d6fde96f096b86);
$parcel$export(module.exports, "CreateSamplePlanProvider", () => $8f6b3552bc4c872c$export$88b99aa46c223622);

var $5uXOq = parcelRequire("5uXOq");

var $jcw0u = parcelRequire("jcw0u");

var $gg7kZ = parcelRequire("gg7kZ");
var $3sQ5x = parcelRequire("3sQ5x");
var $iXqE5 = parcelRequire("iXqE5");

var $e0K2C = parcelRequire("e0K2C");

var $hK1fQ = parcelRequire("hK1fQ");
const $8f6b3552bc4c872c$var$CONTROLLER_NAME = 'create-sample-plan';
const $8f6b3552bc4c872c$var$initialState = {
    /**
	 * This field controls modal dismissible status
	 */ isOpen: false,
    /**
	 * This field is only used to redirect the user to plan page if the modal is not closed.
	 */ planId: null,
    /**
	 * This field is used to detect the correct redirection creation session,
	 * without this field, we don't know which creation session needs to be redirected
	 * e.g. the user started multiple sample creation and stays on the last one - in this case,
	 * only the last creation needs to be redirected.
	 */ taskId: null,
    /**
	 * Progress of the ongoing task
	 */ progressPercentage: null,
    /**
	 * Once this field has been set to `true`, we'll know we can call the actions returned
	 * by our useCreateSamplePlan hook.
	 */ hasBeenInitialised: false
};
const $8f6b3552bc4c872c$var$actions = {
    open: ()=>({ setState: setState })=>{
            setState({
                isOpen: true
            });
        },
    close: ()=>({ setState: setState })=>{
            const nextState = (({ hasBeenInitialised: hasBeenInitialised, ...rest })=>rest)($8f6b3552bc4c872c$var$initialState);
            setState(nextState);
        },
    setPlanId: (planId)=>({ setState: setState })=>{
            setState({
                planId: planId
            });
        },
    setTaskId: (taskId)=>({ setState: setState })=>{
            setState({
                taskId: taskId
            });
        },
    setProgressPercentage: (progressPercentage)=>({ setState: setState })=>{
            setState({
                progressPercentage: progressPercentage
            });
        },
    submitSamplePlan: ({ planName: planName, flags: { success: SuccessFlag, error: ErrorFlag } })=>async ({ setState: setState, getState: getState, dispatch: dispatch }, { showFlag: showFlag, redirectToPlan: redirectToPlan, leadAccountId: leadAccountId })=>{
            try {
                const taskId = await (0, $hK1fQ.createSamplePlanAsync)({
                    body: JSON.stringify({
                        title: planName,
                        leadAccountId: leadAccountId
                    })
                });
                setState({
                    taskId: taskId
                });
                const response = await (0, $hK1fQ.pollCreateSamplePlan)(taskId, (progressPercentage)=>{
                    const { taskId: latestTaskId } = getState();
                    // progressPercentage should reflect the progress of the most recent taskId
                    // If they don't match, skip updating
                    if (taskId !== latestTaskId) return;
                    setState({
                        progressPercentage: progressPercentage
                    });
                });
                const { plan: plan } = response.samplePlan;
                const currentState = getState();
                // We only want to redirect them if the taskId for the current modal is the same as the one for this request
                // Else it might belong to a previous modal
                if (currentState.isOpen && taskId === currentState.taskId) {
                    redirectToPlan(plan.id);
                    dispatch($8f6b3552bc4c872c$var$actions.close());
                } else {
                    const flagId = (0, $e0K2C.CREATE_SUCCESS_FLAG_ID) + plan.id;
                    showFlag({
                        id: flagId,
                        render: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(SuccessFlag, {
                                id: flagId,
                                planName: plan.name,
                                planId: plan.id
                            })
                    });
                }
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            } catch (err) {
                // we only want to track errors unrelated to user settings
                if (!(0, $e0K2C.USER_SETTINGS_ERRORS).includes(err.message)) (0, $jcw0u.default)({
                    error: err,
                    meta: {
                        id: `${(0, $e0K2C.ERROR_REPORTING_PACKAGE)}SubmitFailed`,
                        packageName: (0, $e0K2C.ERROR_REPORTING_PACKAGE),
                        teamName: (0, $e0K2C.ERROR_REPORTING_TEAM)
                    },
                    sendToPrivacyUnsafeSplunk: true
                });
                const props = {
                    id: (0, $e0K2C.CREATE_ERROR_FLAG_ID),
                    errorCode: err.message
                };
                showFlag({
                    id: (0, $e0K2C.CREATE_ERROR_FLAG_ID),
                    render: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(ErrorFlag, props)
                });
                dispatch($8f6b3552bc4c872c$var$actions.close());
            }
        }
};
const $8f6b3552bc4c872c$var$Store = (0, $iXqE5.createStore)({
    name: $8f6b3552bc4c872c$var$CONTROLLER_NAME,
    initialState: $8f6b3552bc4c872c$var$initialState,
    actions: $8f6b3552bc4c872c$var$actions
});
const $8f6b3552bc4c872c$export$53d6fde96f096b86 = (0, $3sQ5x.createHook)($8f6b3552bc4c872c$var$Store);
const $8f6b3552bc4c872c$export$88b99aa46c223622 = (0, $gg7kZ.createContainer)($8f6b3552bc4c872c$var$Store, {
    onInit: ()=>({ setState: setState }, { isOpen: isOpen = false })=>{
            setState({
                isOpen: isOpen,
                hasBeenInitialised: true
            });
        }
});

});
parcelRegister("e0K2C", function(module, exports) {

$parcel$export(module.exports, "ERROR_REPORTING_PACKAGE", () => $3613c4dc2e67ca96$export$f27a837467ec20e5);
$parcel$export(module.exports, "ERROR_REPORTING_TEAM", () => $3613c4dc2e67ca96$export$cfeee2ee86ead336);
$parcel$export(module.exports, "MAX_PLAN_NAME_LENGTH", () => $3613c4dc2e67ca96$export$62da4a2465b3b309);
$parcel$export(module.exports, "CREATE_SUCCESS_FLAG_ID", () => $3613c4dc2e67ca96$export$d526356745046017);
$parcel$export(module.exports, "CREATE_ERROR_FLAG_ID", () => $3613c4dc2e67ca96$export$abd17266df221a92);
$parcel$export(module.exports, "UNKNOWN_EXCEPTION", () => $3613c4dc2e67ca96$export$cfba07bc71f884c1);
$parcel$export(module.exports, "USER_SETTINGS_ERRORS", () => $3613c4dc2e67ca96$export$4a3e779cd3c10125);
$parcel$export(module.exports, "ERROR_CODE_TITLE_MAPPING", () => $3613c4dc2e67ca96$export$91ec80863c2c2030);
$parcel$export(module.exports, "ERROR_CODE_DESCRIPTION_MAPPING", () => $3613c4dc2e67ca96$export$c43e20911e13ca0);
$parcel$export(module.exports, "ERROR_CODE_DESCRIPTION_MAPPING_ISSUE_TERM_REFRESH", () => $3613c4dc2e67ca96$export$525cba92c9b435f4);
$parcel$export(module.exports, "ERROR_LINK_MAPPING", () => $3613c4dc2e67ca96$export$2c5a783ab3215ce1);

var $2L5wO = parcelRequire("2L5wO");
const $3613c4dc2e67ca96$export$f27a837467ec20e5 = 'jiraPortfolio3CreateSamplePlan';
const $3613c4dc2e67ca96$export$cfeee2ee86ead336 = 'advanced-roadmaps';
const $3613c4dc2e67ca96$var$CONTACT_SUPPORT_URL = 'https://support.atlassian.com/contact';
const $3613c4dc2e67ca96$var$LEARN_MORE_URL = 'https://support.atlassian.com/jira-software-cloud/docs/view-a-sample-advanced-roadmaps-plan/';
const $3613c4dc2e67ca96$export$62da4a2465b3b309 = 255;
const $3613c4dc2e67ca96$export$d526356745046017 = 'samplePlanCreatedSuccessfully';
const $3613c4dc2e67ca96$export$abd17266df221a92 = 'samplePlanError';
const $3613c4dc2e67ca96$export$e6515d2009b1dba7 = 'REQUIRED_FIELDS_CONFIGURED_ON_ISSUE';
const $3613c4dc2e67ca96$var$EMPTY_ISSUE_LINKS = 'EMPTY_ISSUE_LINKS';
const $3613c4dc2e67ca96$var$NO_BROWSE_PROJECTS_PERMISSION = 'NO_BROWSE_PROJECTS_PERMISSION';
const $3613c4dc2e67ca96$var$NO_CREATE_ISSUES_PERMISSION = 'NO_CREATE_ISSUES_PERMISSION';
const $3613c4dc2e67ca96$var$NO_TRANSITION_ISSUES_PERMISSION = 'NO_TRANSITION_ISSUES_PERMISSION';
const $3613c4dc2e67ca96$var$NO_EDIT_ISSUES_PERMISSION = 'NO_EDIT_ISSUES_PERMISSION';
const $3613c4dc2e67ca96$var$WATCHING_DISABLED = 'WATCHING_DISABLED';
const $3613c4dc2e67ca96$export$cfba07bc71f884c1 = 'UNKNOWN_EXCEPTION';
const $3613c4dc2e67ca96$export$4a3e779cd3c10125 = [
    $3613c4dc2e67ca96$export$e6515d2009b1dba7,
    $3613c4dc2e67ca96$var$EMPTY_ISSUE_LINKS,
    $3613c4dc2e67ca96$var$NO_BROWSE_PROJECTS_PERMISSION,
    $3613c4dc2e67ca96$var$NO_CREATE_ISSUES_PERMISSION,
    $3613c4dc2e67ca96$var$NO_TRANSITION_ISSUES_PERMISSION,
    $3613c4dc2e67ca96$var$NO_EDIT_ISSUES_PERMISSION,
    $3613c4dc2e67ca96$var$WATCHING_DISABLED
];
const $3613c4dc2e67ca96$export$91ec80863c2c2030 = {
    [$3613c4dc2e67ca96$export$e6515d2009b1dba7]: (0, $2L5wO.default).configurationErrorTitle,
    [$3613c4dc2e67ca96$var$EMPTY_ISSUE_LINKS]: (0, $2L5wO.default).configurationErrorTitle,
    [$3613c4dc2e67ca96$var$NO_BROWSE_PROJECTS_PERMISSION]: (0, $2L5wO.default).permissionErrorTitle,
    [$3613c4dc2e67ca96$var$NO_CREATE_ISSUES_PERMISSION]: (0, $2L5wO.default).permissionErrorTitle,
    [$3613c4dc2e67ca96$var$NO_TRANSITION_ISSUES_PERMISSION]: (0, $2L5wO.default).permissionErrorTitle,
    [$3613c4dc2e67ca96$var$NO_EDIT_ISSUES_PERMISSION]: (0, $2L5wO.default).permissionErrorTitle,
    [$3613c4dc2e67ca96$var$WATCHING_DISABLED]: (0, $2L5wO.default).configurationErrorTitle,
    [$3613c4dc2e67ca96$export$cfba07bc71f884c1]: (0, $2L5wO.default).tryAgainErrorTitle
};
const $3613c4dc2e67ca96$export$c43e20911e13ca0 = {
    [$3613c4dc2e67ca96$export$e6515d2009b1dba7]: (0, $2L5wO.default).requiredFieldsConfiguredOnIssueError,
    [$3613c4dc2e67ca96$var$EMPTY_ISSUE_LINKS]: (0, $2L5wO.default).emptyIssueLinksError,
    [$3613c4dc2e67ca96$var$NO_BROWSE_PROJECTS_PERMISSION]: (0, $2L5wO.default).noBrowseProjectsPermissionError,
    [$3613c4dc2e67ca96$var$NO_CREATE_ISSUES_PERMISSION]: (0, $2L5wO.default).noCreateIssuesPermissionError,
    [$3613c4dc2e67ca96$var$NO_TRANSITION_ISSUES_PERMISSION]: (0, $2L5wO.default).noTransitionIssuesPermissionError,
    [$3613c4dc2e67ca96$var$NO_EDIT_ISSUES_PERMISSION]: (0, $2L5wO.default).noEditIssuesPermissionError,
    [$3613c4dc2e67ca96$var$WATCHING_DISABLED]: (0, $2L5wO.default).watchingDisabledError,
    [$3613c4dc2e67ca96$export$cfba07bc71f884c1]: (0, $2L5wO.default).unknownExceptionError
};
const $3613c4dc2e67ca96$export$525cba92c9b435f4 = {
    [$3613c4dc2e67ca96$export$e6515d2009b1dba7]: (0, $2L5wO.default).requiredFieldsConfiguredOnIssueErrorIssueTermRefresh,
    [$3613c4dc2e67ca96$var$EMPTY_ISSUE_LINKS]: (0, $2L5wO.default).emptyIssueLinksErrorIssueTermRefresh,
    [$3613c4dc2e67ca96$var$NO_BROWSE_PROJECTS_PERMISSION]: (0, $2L5wO.default).noBrowseProjectsPermissionError,
    [$3613c4dc2e67ca96$var$NO_CREATE_ISSUES_PERMISSION]: (0, $2L5wO.default).noCreateIssuesPermissionErrorIssueTermRefresh,
    [$3613c4dc2e67ca96$var$NO_TRANSITION_ISSUES_PERMISSION]: (0, $2L5wO.default).noTransitionIssuesPermissionErrorIssueTermRefresh,
    [$3613c4dc2e67ca96$var$NO_EDIT_ISSUES_PERMISSION]: (0, $2L5wO.default).noEditIssuesPermissionErrorIssueTermRefresh,
    [$3613c4dc2e67ca96$var$WATCHING_DISABLED]: (0, $2L5wO.default).watchingDisabledErrorIssueTermRefresh,
    [$3613c4dc2e67ca96$export$cfba07bc71f884c1]: (0, $2L5wO.default).unknownExceptionError
};
const $3613c4dc2e67ca96$export$2c5a783ab3215ce1 = {
    [$3613c4dc2e67ca96$export$e6515d2009b1dba7]: {
        text: (0, $2L5wO.default).learnMore,
        href: $3613c4dc2e67ca96$var$LEARN_MORE_URL
    },
    [$3613c4dc2e67ca96$var$EMPTY_ISSUE_LINKS]: {
        text: (0, $2L5wO.default).learnMore,
        href: $3613c4dc2e67ca96$var$LEARN_MORE_URL
    },
    [$3613c4dc2e67ca96$var$NO_BROWSE_PROJECTS_PERMISSION]: {
        text: (0, $2L5wO.default).learnMore,
        href: $3613c4dc2e67ca96$var$LEARN_MORE_URL
    },
    [$3613c4dc2e67ca96$var$NO_CREATE_ISSUES_PERMISSION]: {
        text: (0, $2L5wO.default).learnMore,
        href: $3613c4dc2e67ca96$var$LEARN_MORE_URL
    },
    [$3613c4dc2e67ca96$var$NO_TRANSITION_ISSUES_PERMISSION]: {
        text: (0, $2L5wO.default).learnMore,
        href: $3613c4dc2e67ca96$var$LEARN_MORE_URL
    },
    [$3613c4dc2e67ca96$var$NO_EDIT_ISSUES_PERMISSION]: {
        text: (0, $2L5wO.default).learnMore,
        href: $3613c4dc2e67ca96$var$LEARN_MORE_URL
    },
    [$3613c4dc2e67ca96$var$WATCHING_DISABLED]: {
        text: (0, $2L5wO.default).learnMore,
        href: $3613c4dc2e67ca96$var$LEARN_MORE_URL
    },
    [$3613c4dc2e67ca96$export$cfba07bc71f884c1]: {
        text: (0, $2L5wO.default).contactSupport,
        href: $3613c4dc2e67ca96$var$CONTACT_SUPPORT_URL
    }
};

});
parcelRegister("2L5wO", function(module, exports) {

$parcel$export(module.exports, "default", () => $e4969e0d482b1a0a$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $e4969e0d482b1a0a$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    configurationErrorTitle: {
        "id": "portfolio-3-create-sample-plan.common.configuration-error-title",
        "defaultMessage": "Your demo plan couldn't be created because of a configuration error"
    },
    permissionErrorTitle: {
        "id": "portfolio-3-create-sample-plan.common.permission-error-title",
        "defaultMessage": "Your demo plan couldn't be created because you\u2019re missing a required permission"
    },
    tryAgainErrorTitle: {
        "id": "portfolio-3-create-sample-plan.common.try-again-error-title",
        "defaultMessage": "Try to create your demo plan again"
    },
    requiredFieldsConfiguredOnIssueError: {
        "id": "portfolio-3-create-sample-plan.common.required-fields-configured-on-issue-error",
        "defaultMessage": "Your issues have required fields which blocked your demo plan from being created. {readMoreLink}"
    },
    emptyIssueLinksError: {
        "id": "portfolio-3-create-sample-plan.common.empty-issue-links-error",
        "defaultMessage": "Your site doesn't have issue links configured, which are required to create a demo plan. {readMoreLink}"
    },
    noBrowseProjectsPermissionError: {
        "id": "portfolio-3-create-sample-plan.common.no-browse-projects-permission-error",
        "defaultMessage": "Your demo plan couldn't be created because you don\u2019t have the <permission-type>Browse Projects</permission-type> permission. {readMoreLink}"
    },
    noCreateIssuesPermissionError: {
        "id": "portfolio-3-create-sample-plan.common.no-create-issues-permission-error",
        "defaultMessage": "Your demo plan couldn't be created because you don\u2019t have the <permission-type>Create Issues</permission-type> permission. {readMoreLink}"
    },
    noTransitionIssuesPermissionError: {
        "id": "portfolio-3-create-sample-plan.common.no-transition-issues-permission-error",
        "defaultMessage": "Your demo plan couldn't be created because you don\u2019t have the <permission-type>Transition Issues</permission-type> permission. {readMoreLink}"
    },
    noEditIssuesPermissionError: {
        "id": "portfolio-3-create-sample-plan.common.no-edit-issues-permission-error",
        "defaultMessage": "Your demo plan couldn't be created because you don\u2019t have the <permission-type>Edit Issues</permission-type> permission. {readMoreLink}"
    },
    watchingDisabledError: {
        "id": "portfolio-3-create-sample-plan.common.watching-disabled-error",
        "defaultMessage": "Your demo plan couldn't be created because you have issue watching disabled. {readMoreLink}"
    },
    unknownExceptionError: {
        "id": "portfolio-3-create-sample-plan.common.unknown-exception-error",
        "defaultMessage": "Your demo plan couldn't be created, but we\u2019re not sure why. If the problem persists, contact Atlassian support. {readMoreLink}"
    },
    learnMore: {
        "id": "portfolio-3-create-sample-plan.common.learn-more",
        "defaultMessage": "Learn more"
    },
    contactSupport: {
        "id": "portfolio-3-create-sample-plan.common.contact-support",
        "defaultMessage": "Contact Atlassian support"
    },
    requiredFieldsConfiguredOnIssueErrorIssueTermRefresh: {
        "id": "portfolio-3-create-sample-plan.common.required-fields-configured-on-issue-error-issue-term-refresh",
        "defaultMessage": "Your work items have required fields which blocked your demo plan from being created. {readMoreLink}"
    },
    emptyIssueLinksErrorIssueTermRefresh: {
        "id": "portfolio-3-create-sample-plan.common.empty-issue-links-error-issue-term-refresh",
        "defaultMessage": "Your site doesn't have work item links configured, which are required to create a demo plan. {readMoreLink}"
    },
    noCreateIssuesPermissionErrorIssueTermRefresh: {
        "id": "portfolio-3-create-sample-plan.common.no-create-issues-permission-error-issue-term-refresh",
        "defaultMessage": "Your demo plan couldn't be created because you don\u2019t have the <permission-type>Create work items</permission-type> permission. {readMoreLink}"
    },
    noTransitionIssuesPermissionErrorIssueTermRefresh: {
        "id": "portfolio-3-create-sample-plan.common.no-transition-issues-permission-error-issue-term-refresh",
        "defaultMessage": "Your demo plan couldn't be created because you don\u2019t have the <permission-type>Transition work items</permission-type> permission. {readMoreLink}"
    },
    noEditIssuesPermissionErrorIssueTermRefresh: {
        "id": "portfolio-3-create-sample-plan.common.no-edit-issues-permission-error-issue-term-refresh",
        "defaultMessage": "Your demo plan couldn't be created because you don\u2019t have the <permission-type>Edit work items</permission-type> permission. {readMoreLink}"
    },
    watchingDisabledErrorIssueTermRefresh: {
        "id": "portfolio-3-create-sample-plan.common.watching-disabled-error-issue-term-refresh",
        "defaultMessage": "Your demo plan couldn't be created because you have work item watching disabled. {readMoreLink}"
    }
});

});


parcelRegister("hK1fQ", function(module, exports) {

$parcel$export(module.exports, "createSamplePlanAsync", () => $4a753946a320d2b7$export$fed9130b90cf6213);
$parcel$export(module.exports, "pollCreateSamplePlan", () => $4a753946a320d2b7$export$5d240a69af545c0d);
/**
 * Consider moving into service
 */ 
var $jcw0u = parcelRequire("jcw0u");

var $fnyT4 = parcelRequire("fnyT4");

var $jJZqs = parcelRequire("jJZqs");

var $eusud = parcelRequire("eusud");

var $e0K2C = parcelRequire("e0K2C");
const $4a753946a320d2b7$var$throwIfNotOk = async (response)=>{
    if (response.ok) return response;
    if (response.status === 500) throw new (0, $jJZqs.default)(response.status, (0, $e0K2C.UNKNOWN_EXCEPTION), response.headers.get((0, $fnyT4.TRACE_ID_HEADER)) ?? undefined, response);
};
const $4a753946a320d2b7$var$throwIfFailed = (result)=>{
    if (result.samplePlan && !result.samplePlan.success) throw new Error(result.samplePlan.error);
};
const $4a753946a320d2b7$var$delay = (ms = 3000)=>new Promise((res)=>setTimeout(res, ms));
const $4a753946a320d2b7$export$fed9130b90cf6213 = async (data)=>{
    const response = await (0, $eusud.performPostRequest)('/rest/jpo/1.0/plans/sampleplan/async', data);
    const { taskId: taskId } = response;
    if (!taskId) throw new Error('Invalid response from createSamplePlan');
    return taskId;
};
const $4a753946a320d2b7$export$5d240a69af545c0d = async (taskId, onUpdate)=>{
    const url = `/rest/jpo/1.0/plans/sampleplan/async/${taskId}`;
    try {
        const response = await fetch(url);
        await $4a753946a320d2b7$var$throwIfNotOk(response);
        // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
        const raw = await response.json();
        $4a753946a320d2b7$var$throwIfFailed(raw);
        onUpdate(raw.progressPercent);
        if (raw.done) return raw;
        await $4a753946a320d2b7$var$delay();
        return $4a753946a320d2b7$export$5d240a69af545c0d(taskId, onUpdate);
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    } catch (error) {
        // we only want to track errors unrelated to user settings
        if (!(0, $e0K2C.USER_SETTINGS_ERRORS).includes(error.message)) (0, $jcw0u.default)({
            meta: {
                id: `${(0, $e0K2C.ERROR_REPORTING_PACKAGE)}PollingFailed`,
                packageName: (0, $e0K2C.ERROR_REPORTING_PACKAGE),
                teamName: (0, $e0K2C.ERROR_REPORTING_TEAM)
            },
            attributes: {
                message: 'Polling create sample plan failed'
            },
            error: error,
            sendToPrivacyUnsafeSplunk: true
        });
        throw error;
    }
};

});


parcelRegister("L0P37", function(module, exports) {

$parcel$export(module.exports, "MenuItem", () => $3555250889c231c3$export$2ce376c2cc3355c8);

var $5uXOq = parcelRequire("5uXOq");

var $6cNb0 = parcelRequire("6cNb0");

var $d4B4Y = parcelRequire("d4B4Y");
const $3555250889c231c3$export$2ce376c2cc3355c8 = ({ id: id, url: url, title: title, isVisible: isVisible, onClick: onClick, testIdPrefix: testIdPrefix })=>isVisible ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $d4B4Y.MenuItem), {
        analytics: {
            actionSubjectId: 'plansNavigationMenuItem',
            menuItemId: id,
            menuItemType: 'action'
        },
        href: url,
        key: id,
        onClick: onClick,
        testId: (0, $6cNb0.testIdConcat)(testIdPrefix, `item-${id}`)
    }, title) : null;

});

parcelRegister("9EGDV", function(module, exports) {

$parcel$export(module.exports, "default", () => $1b84dd9eb74c4947$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $1b84dd9eb74c4947$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    managePlans: {
        "id": "atlassian-navigation.plans.menu.action-footer.manage-plans",
        "defaultMessage": "View all plans"
    },
    createPlan: {
        "id": "atlassian-navigation.plans.menu.action-footer.create-plan",
        "defaultMessage": "Create plan"
    },
    createDemoPlan: {
        "id": "atlassian-navigation.plans.menu.action-footer.create-demo-plan",
        "defaultMessage": "Create demo plan"
    }
});

});

parcelRegister("eemc9", function(module, exports) {

$parcel$export(module.exports, "useIsPlanListEmpty", () => $6d7bc7f34f360a53$export$5b132e35e5bd9b74);

var $dMJS0 = parcelRequire("dMJS0");
const $6d7bc7f34f360a53$export$5b132e35e5bd9b74 = ()=>{
    const { recentItems: recentItems, favoriteItems: favoriteItems } = (0, $dMJS0.usePlanNavItems)();
    const hasRecentItems = recentItems && recentItems.length > 0;
    const hasFavoriteItems = favoriteItems && favoriteItems.length > 0;
    return !(hasRecentItems || hasFavoriteItems);
};

});
parcelRegister("dMJS0", function(module, exports) {

$parcel$export(module.exports, "useBoardNavItems", () => $104764fbcbb91fe4$export$cad67ea3bdbadd5e);
$parcel$export(module.exports, "useDashboardNavItems", () => $104764fbcbb91fe4$export$eb662c364f65f2a5);
$parcel$export(module.exports, "useFilterNavItems", () => $104764fbcbb91fe4$export$b00ea32725560f5d);
$parcel$export(module.exports, "usePlanNavItems", () => $104764fbcbb91fe4$export$8448c28cc43804d4);
$parcel$export(module.exports, "useProjectNavItems", () => $104764fbcbb91fe4$export$4a9469e6b2e4297c);
$parcel$export(module.exports, "useRecentNavItems", () => $104764fbcbb91fe4$export$5cfe5f7fc9ab5417);
$parcel$export(module.exports, "useQueueNavItems", () => $104764fbcbb91fe4$export$7723949d2540d672);

var $5uXOq = parcelRequire("5uXOq");

var $9XE6b = parcelRequire("9XE6b");

var $bcn6L = parcelRequire("bcn6L");

var $4041n = parcelRequire("4041n");

var $88fdg = parcelRequire("88fdg");

var $apeap = parcelRequire("apeap");
const $104764fbcbb91fe4$var$getFavouriteAndRecentItems = (recentItems, favoriteItems, changedItems)=>{
    const mapChangedItems = (item)=>{
        const changedItem = (0, (/*@__PURE__*/$parcel$interopDefault($9XE6b)))(changedItems, item.id);
        return changedItem ? {
            ...item,
            favourite: changedItem.value
        } : item;
    };
    const updatedFavorites = favoriteItems ? favoriteItems.map(mapChangedItems) : [];
    const updatedRecents = recentItems ? recentItems.map(mapChangedItems) : [];
    // this logic relies on the fact that we defer update favorites store on dropdown close
    // so we can assume that favorites list always affects recent list
    const favoritesIds = updatedFavorites.map((item)=>item.id);
    const filteredRecents = updatedRecents.filter((item)=>!favoritesIds.includes(Number(item.id)));
    return {
        favoriteItems: updatedFavorites,
        recentItems: filteredRecents
    };
};
const $104764fbcbb91fe4$var$getFilteredViewedItems = (viewedItems, // @ts-expect-error - TS2304 - Cannot find name 'IssueItem'.
workedOnItems)=>viewedItems?.filter((viewedItem)=>!workedOnItems?.some(// @ts-expect-error - TS2304 - Cannot find name 'IssueItem'.
        (workedOnItem)=>parseInt(workedOnItem.localResourceId, 10) === viewedItem.id && workedOnItem.type === viewedItem.type)) || [];
const $104764fbcbb91fe4$export$cad67ea3bdbadd5e = ()=>{
    const { changeFavorite: changeFavorite, items: { boards: changedItems } } = (0, $5uXOq.useContext)((0, $4041n.FavoriteChangeContext));
    const [recentData] = (0, $apeap.useRecentBoards)();
    const [favoriteData] = (0, $bcn6L.useFavoriteBoards)();
    const { favoriteItems: favoriteItems, recentItems: recentItems } = (0, $5uXOq.useMemo)(()=>$104764fbcbb91fe4$var$getFavouriteAndRecentItems(recentData.items, favoriteData.items, changedItems), [
        recentData.items,
        favoriteData.items,
        changedItems
    ]);
    return {
        changeFavorite: changeFavorite,
        changedItems: // @ts-expect-error - TS2322 - Type 'ItemMap | undefined' is not assignable to type 'ItemMap'.
        changedItems,
        favoriteItems: favoriteItems,
        recentItems: recentItems
    };
};
const $104764fbcbb91fe4$export$eb662c364f65f2a5 = ()=>{
    const { changeFavorite: changeFavorite, items: { dashboards: changedItems } } = (0, $5uXOq.useContext)((0, $4041n.FavoriteChangeContext));
    const [recentData] = (0, $apeap.useRecentDashboards)();
    const [favoriteData] = (0, $bcn6L.useFavoriteDashboards)();
    const { favoriteItems: favoriteItems, recentItems: recentItems } = (0, $5uXOq.useMemo)(()=>$104764fbcbb91fe4$var$getFavouriteAndRecentItems(recentData.items, favoriteData.items, changedItems), [
        recentData.items,
        favoriteData.items,
        changedItems
    ]);
    return {
        changeFavorite: changeFavorite,
        changedItems: // @ts-expect-error - TS2322 - Type 'ItemMap | undefined' is not assignable to type 'ItemMap'.
        changedItems,
        favoriteItems: favoriteItems,
        recentItems: recentItems
    };
};
const $104764fbcbb91fe4$export$b00ea32725560f5d = ()=>{
    const { changeFavorite: changeFavorite, items: { filters: changedItems } } = (0, $5uXOq.useContext)((0, $4041n.FavoriteChangeContext));
    const [recentData] = (0, $apeap.useRecentFilters)();
    const [favoriteData] = (0, $bcn6L.useFavoriteFilters)();
    const { favoriteItems: favoriteItems, recentItems: recentItems } = (0, $5uXOq.useMemo)(()=>$104764fbcbb91fe4$var$getFavouriteAndRecentItems(recentData.items, favoriteData.items, changedItems), [
        recentData.items,
        favoriteData.items,
        changedItems
    ]);
    return {
        changeFavorite: changeFavorite,
        changedItems: // @ts-expect-error - TS2322 - Type 'ItemMap | undefined' is not assignable to type 'ItemMap'.
        changedItems,
        favoriteItems: favoriteItems,
        recentItems: recentItems
    };
};
const $104764fbcbb91fe4$export$8448c28cc43804d4 = ()=>{
    const { changeFavorite: changeFavorite, items: { plans: changedItems } } = (0, $5uXOq.useContext)((0, $4041n.FavoriteChangeContext));
    const [{ items: items }] = (0, $88fdg.usePlansItems)();
    const [favoriteData] = (0, $bcn6L.useFavoritePlans)();
    const { favoriteItems: favoriteItems, recentItems: recentItems } = (0, $5uXOq.useMemo)(()=>{
        const recentPlans = items?.recent ? items.recent.map(// the id is a concatenation of planId and scenarioId...
        // we need to strip the scenario so we just have the plan id
        (plan)=>({
                ...plan,
                id: plan.id.toString().split('|')[0]
            })) : [];
        return $104764fbcbb91fe4$var$getFavouriteAndRecentItems(recentPlans, favoriteData.items, changedItems);
    }, [
        items,
        favoriteData.items,
        changedItems
    ]);
    return {
        changeFavorite: changeFavorite,
        changedItems: // @ts-expect-error - TS2322 - Type 'ItemMap | undefined' is not assignable to type 'ItemMap'.
        changedItems,
        favoriteItems: favoriteItems,
        recentItems: recentItems
    };
};
const $104764fbcbb91fe4$export$4a9469e6b2e4297c = ()=>{
    const { changeFavorite: changeFavorite, items: { projects: changedItems } } = (0, $5uXOq.useContext)((0, $4041n.FavoriteChangeContext));
    const [recentData] = (0, $apeap.useRecentProjects)();
    const [favoriteData] = (0, $bcn6L.useFavoriteProjects)();
    const { favoriteItems: favoriteItems, recentItems: recentItems } = (0, $5uXOq.useMemo)(()=>$104764fbcbb91fe4$var$getFavouriteAndRecentItems(recentData.items, favoriteData.items, changedItems), [
        recentData.items,
        favoriteData.items,
        changedItems
    ]);
    return {
        changeFavorite: changeFavorite,
        changedItems: // @ts-expect-error - TS2322 - Type 'ItemMap | undefined' is not assignable to type 'ItemMap'.
        changedItems,
        favoriteItems: favoriteItems,
        recentItems: recentItems
    };
};
const $104764fbcbb91fe4$export$5cfe5f7fc9ab5417 = ()=>{
    const [viewedData] = (0, $apeap.useRecentAllSingleList)();
    const [workedOnData] = (0, $apeap.useWorkedOnAllSingleList)();
    const viewedItems = (0, $5uXOq.useMemo)(()=>$104764fbcbb91fe4$var$getFilteredViewedItems(viewedData.items, workedOnData.items), [
        viewedData.items,
        workedOnData.items
    ]);
    return {
        workedOnItems: workedOnData.items || [],
        viewedItems: viewedItems
    };
};
const $104764fbcbb91fe4$export$7723949d2540d672 = ()=>{
    const { changeFavorite: changeFavorite, items: { queues: changedItems } } = (0, $5uXOq.useContext)((0, $4041n.FavoriteChangeContext));
    const [recentData] = (0, $apeap.useRecentQueues)();
    const [favoriteData] = (0, $bcn6L.useFavoriteQueues)();
    const { favoriteItems: favoriteItems, recentItems: recentItems } = (0, $5uXOq.useMemo)(()=>$104764fbcbb91fe4$var$getFavouriteAndRecentItems(recentData.items, favoriteData.items, changedItems), [
        recentData.items,
        favoriteData.items,
        changedItems
    ]);
    return {
        changeFavorite: changeFavorite,
        changedItems: // @ts-expect-error - TS2322 - Type 'ItemMap | undefined' is not assignable to type 'ItemMap'.
        changedItems,
        favoriteItems: favoriteItems,
        recentItems: recentItems
    };
};

});
parcelRegister("4041n", function(module, exports) {

$parcel$export(module.exports, "FavoriteChangeContext", () => $e574e5c3227b76f4$export$a5d258b9665ce94b);
$parcel$export(module.exports, "FavoriteChangeProvider", () => $e574e5c3227b76f4$export$b06b5ce59fd5e408);
$parcel$export(module.exports, "FavoriteChangeConsumer", () => $e574e5c3227b76f4$export$f227cdfbb355444a);
$parcel$export(module.exports, "useChangeFavorite", () => $e574e5c3227b76f4$export$cfa169f3278459e8);

var $kZupY = parcelRequire("kZupY");

var $5uXOq = parcelRequire("5uXOq");

var $8Rkzz = parcelRequire("8Rkzz");

var $8Uumt = parcelRequire("8Uumt");

var $eiowN = parcelRequire("eiowN");

var $jcw0u = parcelRequire("jcw0u");

var $dXq4S = parcelRequire("dXq4S");

var $8zOmE = parcelRequire("8zOmE");

var $koeKL = parcelRequire("koeKL");

var $iJZ8l = parcelRequire("iJZ8l");

var $j6ttF = parcelRequire("j6ttF");

var $7lK06 = parcelRequire("7lK06");

var $eXQym = parcelRequire("eXQym");

var $5c9oS = parcelRequire("5c9oS");

var $7SIuT = parcelRequire("7SIuT");
const $e574e5c3227b76f4$export$4fe337ef5f0ceb74 = (item)=>(state)=>({
            ...state,
            // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
            [item.type]: {
                ...state[item.type],
                [item.id]: item
            }
        });
const $e574e5c3227b76f4$export$72b8c6d38aa6195b = (item)=>(state)=>({
            ...state,
            items: {
                ...state.items,
                // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
                [item.type]: {
                    ...state.items[item.type],
                    [item.id]: item
                }
            }
        });
const $e574e5c3227b76f4$export$b212ddc707077772 = {
    items: {
        boards: {},
        filters: {},
        issues: {},
        dashboards: {},
        projects: {},
        queues: {},
        plans: {}
    },
    changeFavorite: ()=>new Promise((0, (/*@__PURE__*/$parcel$interopDefault($8Rkzz)))),
    changeFavoriteMutation: (0, (/*@__PURE__*/$parcel$interopDefault($8Rkzz))),
    emitChangedFavorite: (0, (/*@__PURE__*/$parcel$interopDefault($8Rkzz))),
    emitChangedFavoriteMutation: (0, (/*@__PURE__*/$parcel$interopDefault($8Rkzz))),
    updateFavoriteState: (0, (/*@__PURE__*/$parcel$interopDefault($8Rkzz)))
};
const $e574e5c3227b76f4$export$a5d258b9665ce94b = /*#__PURE__*/ (0, $5uXOq.createContext)($e574e5c3227b76f4$export$b212ddc707077772);
// supports project types only for now
const $e574e5c3227b76f4$var$useRelayFavoriteUpdate = ()=>{
    const environment = (0, $8Uumt.useRelayEnvironment)();
    const cloudId = (0, $koeKL.useCloudId)();
    const commitUpdate = (0, $5uXOq.useCallback)(({ id: id, type: type, value: value })=>{
        if (type === (0, $eXQym.PROJECTS_ITEM_TYPE)) (0, $eiowN.commitLocalUpdate)(environment, (store)=>{
            const ari = (0, $dXq4S.createAri)({
                resourceOwner: 'jira',
                resourceType: 'project',
                resourceId: id,
                cloudId: cloudId
            });
            const projectRecordId = (0, $iJZ8l.default)({
                id: ari
            }, 'JiraProject');
            if (projectRecordId) {
                const projectRecord = store.get(projectRecordId);
                const favoriteRecord = projectRecord?.getLinkedRecord('favouriteValue');
                favoriteRecord?.setValue(value, 'isFavourite');
            }
        });
    }, [
        cloudId,
        environment
    ]);
    return {
        commitUpdate: commitUpdate
    };
};
const $e574e5c3227b76f4$export$b06b5ce59fd5e408 = ({ onShowFlag: onShowFlag, children: children })=>{
    const { commitUpdate: commitUpdate } = $e574e5c3227b76f4$var$useRelayFavoriteUpdate();
    const [items, setItems] = (0, $5uXOq.useState)({
        boards: {},
        filters: {},
        dashboards: {},
        issues: {},
        projects: {},
        queues: {},
        plans: {}
    });
    const onChangeStart = (0, $5uXOq.useCallback)((item)=>{
        setItems($e574e5c3227b76f4$export$4fe337ef5f0ceb74({
            ...item,
            pending: true
        }));
    }, []);
    const onChangeSuccess = (0, $5uXOq.useCallback)((item, analyticsEvent)=>{
        setItems($e574e5c3227b76f4$export$4fe337ef5f0ceb74({
            ...item,
            pending: false
        }));
        if (analyticsEvent) (0, $8zOmE.fireTrackAnalytics)(analyticsEvent, // removing last letter to make item.type singular tense (i.e. boards => board)
        `${item.type.slice(0, item.type.length - 1)} ${item.value ? 'starred' : 'unstarred'}`, `${item.id}`);
    }, []);
    const onChangeFail = (0, $5uXOq.useCallback)((item, analyticsId, error)=>{
        setItems($e574e5c3227b76f4$export$4fe337ef5f0ceb74({
            ...item,
            value: !item.value,
            pending: false
        }));
        if (onShowFlag) onShowFlag((0, $7SIuT.errorFlag)());
        (0, $jcw0u.default)({
            meta: {
                id: analyticsId,
                packageName: 'jiraFavouriteChangeProvider',
                teamName: 'empanada'
            },
            error: error,
            sendToPrivacyUnsafeSplunk: true
        });
    }, [
        onShowFlag
    ]);
    const changeFavorite = (0, $5uXOq.useCallback)(async (item, analyticsEvent)=>{
        const performChange = async ()=>{
            onChangeStart(item);
            try {
                commitUpdate({
                    type: item.type,
                    id: item.id,
                    value: item.value
                });
                await (0, $5c9oS.default)(item);
                const typename = (0, $j6ttF.favoriteTypeToTypename)(item.type, item.id);
                if (typename) (0, $7lK06.publishFavorite)(typename, {
                    type: 'REST',
                    entityId: item.id,
                    isFavourite: item.value
                });
                onChangeSuccess(item, analyticsEvent);
            } catch (error) {
                commitUpdate({
                    type: item.type,
                    id: item.id,
                    value: !item.value
                });
                onChangeFail(item, 'changeFavourite', error instanceof Error ? error : undefined);
            }
        };
        return performChange();
    }, [
        commitUpdate,
        onChangeStart,
        onChangeSuccess,
        onChangeFail
    ]);
    const [commitMutation] = (0, $8Uumt.useMutation)((0, $kZupY.default));
    const changeFavoriteMutation = (0, $5uXOq.useCallback)((payload, analyticsEvent)=>{
        const dataId = (0, $iJZ8l.default)({
            id: payload.id
        }, payload.typename);
        const restItem = (0, $j6ttF.favoriteMutationToRestPayload)(payload);
        const onUpdate = (store, isOptimistic)=>{
            if (!dataId) return;
            (0, $7lK06.publishFavorite)(payload.typename, {
                type: 'MUTATION',
                store: store,
                dataId: dataId,
                entityId: payload.id,
                isFavourite: payload.value,
                isOptimistic: isOptimistic
            });
            const record = store.get(dataId);
            if (record) {
                // Some favoritable entities provide an `isFavourite` field, e.g. `JiraFilter`, `JiraProject`.
                if (typeof record.getValue('isFavourite') === 'boolean') record.setValue(payload.value, 'isFavourite');
                // Optimistically update the `favouriteValue` node associated with the updated entity (if present).
                // We only need to do this during optimistic update as the node will be returned in a successful
                // mutation response.
                if (isOptimistic) {
                    const favoriteRecord = record.getLinkedRecord('favouriteValue');
                    favoriteRecord?.setValue(payload.value, 'isFavourite');
                }
            }
        };
        onChangeStart(restItem);
        commitMutation({
            variables: {
                input: {
                    entityId: payload.id,
                    isFavourite: payload.value,
                    beforeEntityId: payload.beforeEntity?.id ?? null
                }
            },
            optimisticUpdater: (store)=>{
                onUpdate(store, true);
            },
            updater: (store, response)=>{
                if (response?.jira?.setEntityIsFavourite?.success) onUpdate(store, false);
            },
            onCompleted: (response)=>{
                if (response?.jira?.setEntityIsFavourite?.success) onChangeSuccess(restItem, analyticsEvent);
                else onChangeFail(restItem, 'changeFavoriteMutation');
            },
            onError: (error)=>onChangeFail(restItem, 'changeFavouriteMutation', error)
        });
    }, [
        commitMutation,
        onChangeStart,
        onChangeSuccess,
        onChangeFail
    ]);
    const updateFavoriteState = (0, $5uXOq.useCallback)((item)=>{
        setItems($e574e5c3227b76f4$export$4fe337ef5f0ceb74({
            ...item,
            pending: false
        }));
    }, []);
    const emitChangedFavorite = (0, $5uXOq.useCallback)((payload, analyticsEvent)=>{
        onChangeSuccess(payload, analyticsEvent);
        const typeName = (0, $j6ttF.favoriteTypeToTypename)(payload.type, payload.id);
        if (typeName) (0, $7lK06.publishFavorite)(typeName, {
            type: 'REST',
            entityId: payload.id,
            isFavourite: payload.value
        });
    }, [
        onChangeSuccess
    ]);
    const emitChangedFavoriteMutation = (0, $5uXOq.useCallback)(// eslint-disable-next-line @typescript-eslint/no-explicit-any
    (payload, store, analyticsEvent)=>{
        const dataId = (0, $iJZ8l.default)({
            id: payload.id
        }, payload.typename) ?? '';
        const restItem = (0, $j6ttF.favoriteMutationToRestPayload)(payload);
        onChangeSuccess(restItem, analyticsEvent);
        (0, $7lK06.publishFavorite)(payload.typename, {
            type: 'MUTATION',
            store: store,
            dataId: dataId,
            entityId: payload.id,
            isFavourite: payload.value,
            isOptimistic: false
        });
    }, [
        onChangeSuccess
    ]);
    const providerValue = (0, $5uXOq.useMemo)(()=>({
            items: items,
            changeFavorite: changeFavorite,
            changeFavoriteMutation: changeFavoriteMutation,
            emitChangedFavorite: emitChangedFavorite,
            emitChangedFavoriteMutation: emitChangedFavoriteMutation,
            updateFavoriteState: updateFavoriteState
        }), [
        items,
        changeFavorite,
        changeFavoriteMutation,
        emitChangedFavorite,
        emitChangedFavoriteMutation,
        updateFavoriteState
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($e574e5c3227b76f4$export$a5d258b9665ce94b.Provider, {
        value: providerValue
    }, children);
};
const $e574e5c3227b76f4$export$f227cdfbb355444a = $e574e5c3227b76f4$export$a5d258b9665ce94b.Consumer;
const $e574e5c3227b76f4$export$61944ffe37754ff2 = (WrappedComponent)=>{
    const WithFavoriteChangeConsumer = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($e574e5c3227b76f4$export$f227cdfbb355444a, null, (favoriteChangeContext)=>// @ts-expect-error - TS2322 - Type 'P & { favoriteChangeContext: FavoriteChangeContextType; }' is not assignable to type 'IntrinsicAttributes & W & { children?: ReactNode; }'.
            /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(WrappedComponent, {
                ...props,
                favoriteChangeContext: favoriteChangeContext
            }));
    const wrappedDisplayName = WrappedComponent.displayName || WrappedComponent.name || 'Component';
    WithFavoriteChangeConsumer.displayName = `WithFavoriteChangeConsumer(${wrappedDisplayName})`;
    return WithFavoriteChangeConsumer;
};
const $e574e5c3227b76f4$export$cfa169f3278459e8 = ()=>(0, $5uXOq.useContext)($e574e5c3227b76f4$export$a5d258b9665ce94b);

});
parcelRegister("kZupY", function(module, exports) {

$parcel$export(module.exports, "default", () => $d64781493fbfe6b0$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<581ee8573bf9ee1f32ccc64539d4c7bc>>
 * @relayHash 6de546c6546651e6c4572b78dca9bcd9
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 55cc4316f34f570b5daad61eb737e9475face6fd2ceb7b85de1040658ff30d9f
const $d64781493fbfe6b0$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "input"
        }
    ], v1 = [
        {
            "concreteType": "JiraMutation",
            "kind": "LinkedField",
            "name": "jira",
            "plural": false,
            "selections": [
                {
                    "args": [
                        {
                            "kind": "Variable",
                            "name": "input",
                            "variableName": "input"
                        }
                    ],
                    "concreteType": "JiraSetIsFavouritePayload",
                    "kind": "LinkedField",
                    "name": "setEntityIsFavourite",
                    "plural": false,
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "name": "success"
                        },
                        {
                            "concreteType": "JiraFavouriteValue",
                            "kind": "LinkedField",
                            "name": "favouriteValue",
                            "plural": false,
                            "selections": [
                                {
                                    "kind": "ScalarField",
                                    "name": "id"
                                },
                                {
                                    "kind": "ScalarField",
                                    "name": "isFavourite"
                                }
                            ]
                        }
                    ]
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "viewSetFavouriteMutation",
            "selections": v1 /*: any*/ ,
            "type": "Mutation"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "viewSetFavouriteMutation",
            "selections": v1 /*: any*/ 
        },
        "params": {
            "id": "55cc4316f34f570b5daad61eb737e9475face6fd2ceb7b85de1040658ff30d9f",
            "metadata": {},
            "name": "viewSetFavouriteMutation",
            "operationKind": "mutation",
            "text": null
        }
    };
}();
$d64781493fbfe6b0$var$node.hash = "af74e48c451986374e11a5b801d5009f";
var $d64781493fbfe6b0$export$2e2bcd8739ae039 = $d64781493fbfe6b0$var$node;

});

parcelRegister("dXq4S", function(module, exports) {

$parcel$export(module.exports, "isAri", () => $5c4418bd595ae8cf$export$8e68286aef4c3a8b);
$parcel$export(module.exports, "createAri", () => $5c4418bd595ae8cf$export$594d18a0ad2e0e57);
$parcel$export(module.exports, "toAri", () => $5c4418bd595ae8cf$export$24b47820a324e614);
$parcel$export(module.exports, "toAriOrDefault", () => $5c4418bd595ae8cf$export$e2789192113e8b07);
$parcel$export(module.exports, "parseAri", () => $5c4418bd595ae8cf$export$f8e7d14b19dc8ba5);
$parcel$export(module.exports, "getAriConfig", () => $5c4418bd595ae8cf$export$3d8d7031a11613fd);
/**
 * Module to work with Atlassian Resource Identifier (ARI)
 * More info in go/aris
 */ const $5c4418bd595ae8cf$var$ARI_REG_EXP = /^ari:cloud:(?<resourceOwner>[a-z.-]+):(?<cloudId>[\w-]*):(?<resourceType>[a-z.-]+)\/(?<resourceId>[\w.~_-]+)$/;
const $5c4418bd595ae8cf$var$ARI_REG_EXP_ACTIVATION = /^ari:cloud:(?<resourceOwner>[a-z.-]+):(?<cloudId>[\w-]*):(?<resourceType>[a-z.-]+)\/activation\/(?<activationId>[\w-]*)\/(?<resourceId>[\w.~_-]+)$/;
const $5c4418bd595ae8cf$var$ARI_REG_EXP_WORKSPACE = /^ari:cloud:(?<resourceOwner>[a-z.-]+):(?<cloudId>.{0}):(?<resourceType>[a-z.-]+)(\/(?<workspaceId>[\w.~_-]+)?)\/(?<resourceId>[\w.~_-]+)$/;
const $5c4418bd595ae8cf$var$ARI_REG_EXP_PROVIDER_CONTAINER = /^ari:cloud:(?<resourceOwner>[a-z.-]+):(?<cloudId>[\w-]*):(?<resourceType>[a-z.-]+)\/activation\/(?<activationId>[\w-]*)\/(?<providerAppId>[\w.~_-]+)\/(?<resourceId>[\w.~_/-]+)$/;
const $5c4418bd595ae8cf$export$8e68286aef4c3a8b = (ari)=>$5c4418bd595ae8cf$var$ARI_REG_EXP.test(ari) || $5c4418bd595ae8cf$var$ARI_REG_EXP_WORKSPACE.test(ari) || $5c4418bd595ae8cf$var$ARI_REG_EXP_ACTIVATION.test(ari) || $5c4418bd595ae8cf$var$ARI_REG_EXP_PROVIDER_CONTAINER.test(ari);
const $5c4418bd595ae8cf$export$594d18a0ad2e0e57 = ({ resourceOwner: resourceOwner, cloudId: cloudId, resourceType: resourceType, workspaceId: workspaceId, resourceId: resourceId, activationId: activationId })=>{
    if (workspaceId != null) return `ari:cloud:${resourceOwner}::${resourceType}/${workspaceId}/${resourceId}`;
    if (activationId != null) return `ari:cloud:${resourceOwner}:${cloudId || ''}:${resourceType}/activation/${activationId}/${resourceId}`;
    return `ari:cloud:${resourceOwner}:${cloudId || ''}:${resourceType}/${resourceId}`;
};
const $5c4418bd595ae8cf$export$24b47820a324e614 = (ari)=>{
    if ($5c4418bd595ae8cf$export$8e68286aef4c3a8b(ari)) return ari;
    return undefined;
};
const $5c4418bd595ae8cf$export$e2789192113e8b07 = (ari, defaultValue = '')=>$5c4418bd595ae8cf$export$24b47820a324e614(ari) ?? defaultValue;
const $5c4418bd595ae8cf$export$f8e7d14b19dc8ba5 = (ari)=>{
    if ($5c4418bd595ae8cf$export$8e68286aef4c3a8b(ari)) {
        const parts = $5c4418bd595ae8cf$var$ARI_REG_EXP.exec(ari) || $5c4418bd595ae8cf$var$ARI_REG_EXP_WORKSPACE.exec(ari) || $5c4418bd595ae8cf$var$ARI_REG_EXP_ACTIVATION.exec(ari) || $5c4418bd595ae8cf$var$ARI_REG_EXP_PROVIDER_CONTAINER.exec(ari);
        if (parts?.groups) {
            // reconstructing an object just to avoid flow error (otherwise says inexact object type of parts.groups is incompatible with exact AriConfig type)
            const { resourceOwner: resourceOwner, cloudId: cloudId, resourceType: resourceType, workspaceId: workspaceId, resourceId: resourceId, activationId: activationId } = parts.groups;
            return {
                resourceOwner: resourceOwner,
                cloudId: cloudId,
                resourceType: resourceType,
                workspaceId: workspaceId,
                resourceId: resourceId,
                activationId: activationId
            };
        }
    }
    return undefined;
};
const $5c4418bd595ae8cf$export$3d8d7031a11613fd = (ari)=>{
    const config = $5c4418bd595ae8cf$export$f8e7d14b19dc8ba5(ari);
    if (config === undefined) throw Error('Invalid ARI - this should only be possible if there is a bug in `toAri`');
    return config;
};

});

parcelRegister("j6ttF", function(module, exports) {

$parcel$export(module.exports, "favoriteTypeToTypename", () => $b9c3378eb0d73712$export$b98f76d96728a853);
$parcel$export(module.exports, "favoriteMutationToRestPayload", () => $b9c3378eb0d73712$export$717886a1047f1287);

var $9AmTW = parcelRequire("9AmTW");

var $6BtlL = parcelRequire("6BtlL");

var $kwbhb = parcelRequire("kwbhb");

var $6oLWS = parcelRequire("6oLWS");

var $aSWXp = parcelRequire("aSWXp");

var $kV9ss = parcelRequire("kV9ss");
function $b9c3378eb0d73712$var$assertUnreachable(_) {
    throw new Error('Unexpected entity type');
}
const $b9c3378eb0d73712$var$isSystemFilter = (filterId)=>/^-\d+$/.test(filterId);
const $b9c3378eb0d73712$export$b98f76d96728a853 = (type, resourceId)=>{
    switch(type){
        case 'projects':
            return 'JiraProject';
        case 'filters':
            return $b9c3378eb0d73712$var$isSystemFilter(resourceId) ? 'JiraSystemFilter' : 'JiraCustomFilter';
        case 'dashboards':
            return 'JiraDashboard';
        case 'plans':
            return 'JiraPlan';
        case 'boards':
            return 'JiraBoard';
        case 'queues':
            return 'JiraServiceManagementQueue';
        default:
            return undefined;
    }
};
const $b9c3378eb0d73712$var$favoriteAriToId = (typename, ari)=>{
    switch(typename){
        case 'JiraProject':
            return (0, $kV9ss.JiraProjectAri).parse(ari).projectId;
        case 'JiraCustomFilter':
        case 'JiraSystemFilter':
            return (0, $6oLWS.JiraFilterAri).parse(ari).filterId;
        case 'JiraDashboard':
            return (0, $kwbhb.JiraDashboardAri).parse(ari).dashboardId;
        case 'JiraPlan':
            return (0, $aSWXp.JiraPlanAri).parse(ari).planId;
        case 'JiraBoard':
            return (0, $6BtlL.JiraSoftwareBoardAri).parse(ari).boardId;
        case 'JiraServiceManagementQueue':
            return (0, $9AmTW.JiraServicedeskQueueAri).parse(ari).queueId;
        default:
            $b9c3378eb0d73712$var$assertUnreachable(typename);
    }
};
const $b9c3378eb0d73712$var$favoriteTypenameToType = (typename)=>{
    switch(typename){
        case 'JiraProject':
            return 'projects';
        case 'JiraCustomFilter':
        case 'JiraSystemFilter':
            return 'filters';
        case 'JiraDashboard':
            return 'dashboards';
        case 'JiraPlan':
            return 'plans';
        case 'JiraBoard':
            return 'boards';
        case 'JiraServiceManagementQueue':
            return 'queues';
        default:
            $b9c3378eb0d73712$var$assertUnreachable(typename);
    }
};
const $b9c3378eb0d73712$export$717886a1047f1287 = ({ id: id, typename: typename, value: value, beforeEntity: beforeEntity })=>({
        id: $b9c3378eb0d73712$var$favoriteAriToId(typename, id),
        type: $b9c3378eb0d73712$var$favoriteTypenameToType(typename),
        value: value,
        beforeEntity: beforeEntity ? {
            id: $b9c3378eb0d73712$var$favoriteAriToId(beforeEntity.typename, beforeEntity.id),
            type: $b9c3378eb0d73712$var$favoriteTypenameToType(beforeEntity.typename)
        } : undefined
    });

});
parcelRegister("9AmTW", function(module, exports) {

$parcel$export(module.exports, "JiraServicedeskQueueAri", () => $6fa93d978dc51edc$export$555c8ae00f64ebff);

var $IfwMb = parcelRequire("IfwMb");

var $3NoER = parcelRequire("3NoER");

var $gYPG7 = parcelRequire("gYPG7");
// src/jira-servicedesk/queue/manifest.ts
var $6fa93d978dc51edc$var$jiraServicedeskQueueAriStaticOpts = {
    qualifier: "ari",
    platformQualifier: "cloud",
    cloudId: new RegExp("^[a-zA-Z0-9_\\-.]{1,255}$"),
    // eslint-disable-line no-useless-escape
    resourceOwner: (0, $IfwMb.JiraServicedeskQueueAriResourceOwner),
    resourceType: (0, $IfwMb.JiraServicedeskQueueAriResourceType),
    resourceIdSlug: "activation/{activationId}/{queueId}",
    resourceIdSegmentFormats: {
        activationId: /[a-zA-Z0-9\-]+/,
        // eslint-disable-line no-useless-escape
        queueId: /[0-9]+/
    }
};
// src/jira-servicedesk/queue/index.ts
var $6fa93d978dc51edc$export$555c8ae00f64ebff = class _JiraServicedeskQueueAri extends (0, $3NoER.RegisteredAri) {
    constructor(opts){
        super(opts);
        this._siteId = opts.cloudId || "", this._activationId = opts.resourceIdSegmentValues.activationId, this._queueId = opts.resourceIdSegmentValues.queueId;
    }
    get siteId() {
        return this._siteId;
    }
    get activationId() {
        return this._activationId;
    }
    get queueId() {
        return this._queueId;
    }
    static create(opts) {
        let derivedOpts = {
            qualifier: $6fa93d978dc51edc$var$jiraServicedeskQueueAriStaticOpts.qualifier,
            platformQualifier: $6fa93d978dc51edc$var$jiraServicedeskQueueAriStaticOpts.platformQualifier,
            cloudId: opts.siteId,
            resourceOwner: $6fa93d978dc51edc$var$jiraServicedeskQueueAriStaticOpts.resourceOwner,
            resourceType: $6fa93d978dc51edc$var$jiraServicedeskQueueAriStaticOpts.resourceType,
            resourceId: `activation/${opts.activationId}/${opts.queueId}`,
            resourceIdSegmentValues: {
                activationId: opts.activationId,
                queueId: opts.queueId
            }
        }, ariOpts = (0, $gYPG7.AriParser).fromOpts(derivedOpts, $6fa93d978dc51edc$var$jiraServicedeskQueueAriStaticOpts);
        return new _JiraServicedeskQueueAri(ariOpts);
    }
    static parse(maybeAri) {
        let opts = (0, $gYPG7.AriParser).fromString(maybeAri, $6fa93d978dc51edc$var$jiraServicedeskQueueAriStaticOpts);
        return new _JiraServicedeskQueueAri(opts);
    }
    getVariables() {
        return {
            siteId: this.siteId,
            activationId: this.activationId,
            queueId: this.queueId
        };
    }
};

});
parcelRegister("IfwMb", function(module, exports) {

$parcel$export(module.exports, "JiraServicedeskQueueAriResourceOwner", () => $085027a493012871$export$704112eeb385ceab);
$parcel$export(module.exports, "JiraServicedeskQueueAriResourceType", () => $085027a493012871$export$6adb8c07b8bc2c5a);
// src/jira-servicedesk/queue/types.ts
var $085027a493012871$export$704112eeb385ceab = "jira-servicedesk", $085027a493012871$export$6adb8c07b8bc2c5a = "queue";

});


parcelRegister("6BtlL", function(module, exports) {

$parcel$export(module.exports, "JiraSoftwareBoardAri", () => $4cecf7137216f798$export$fcd404066e55a7a8);

var $8ANGM = parcelRequire("8ANGM");

var $3NoER = parcelRequire("3NoER");

var $gYPG7 = parcelRequire("gYPG7");
// src/jira-software/board/manifest.ts
var $4cecf7137216f798$var$jiraSoftwareBoardAriStaticOpts = {
    qualifier: "ari",
    platformQualifier: "cloud",
    cloudId: new RegExp("^[a-zA-Z0-9_\\-.]{1,255}$"),
    // eslint-disable-line no-useless-escape
    resourceOwner: (0, $8ANGM.JiraSoftwareBoardAriResourceOwner),
    resourceType: (0, $8ANGM.JiraSoftwareBoardAriResourceType),
    resourceIdSlug: "{boardId}",
    resourceIdSegmentFormats: {
        boardId: /[!a-zA-Z0-9\-_.~@:;{}=]+(\/[!a-zA-Z0-9\-_.~@:;{}=]+)*/
    }
};
// src/jira-software/board/index.ts
var $4cecf7137216f798$export$fcd404066e55a7a8 = class _JiraSoftwareBoardAri extends (0, $3NoER.RegisteredAri) {
    constructor(opts){
        super(opts);
        this._siteId = opts.cloudId || "", this._boardId = opts.resourceIdSegmentValues.boardId;
    }
    get siteId() {
        return this._siteId;
    }
    get boardId() {
        return this._boardId;
    }
    static create(opts) {
        let derivedOpts = {
            qualifier: $4cecf7137216f798$var$jiraSoftwareBoardAriStaticOpts.qualifier,
            platformQualifier: $4cecf7137216f798$var$jiraSoftwareBoardAriStaticOpts.platformQualifier,
            cloudId: opts.siteId,
            resourceOwner: $4cecf7137216f798$var$jiraSoftwareBoardAriStaticOpts.resourceOwner,
            resourceType: $4cecf7137216f798$var$jiraSoftwareBoardAriStaticOpts.resourceType,
            resourceId: `${opts.boardId}`,
            resourceIdSegmentValues: {
                boardId: opts.boardId
            }
        }, ariOpts = (0, $gYPG7.AriParser).fromOpts(derivedOpts, $4cecf7137216f798$var$jiraSoftwareBoardAriStaticOpts);
        return new _JiraSoftwareBoardAri(ariOpts);
    }
    static parse(maybeAri) {
        let opts = (0, $gYPG7.AriParser).fromString(maybeAri, $4cecf7137216f798$var$jiraSoftwareBoardAriStaticOpts);
        return new _JiraSoftwareBoardAri(opts);
    }
    getVariables() {
        return {
            siteId: this.siteId,
            boardId: this.boardId
        };
    }
};

});
parcelRegister("8ANGM", function(module, exports) {

$parcel$export(module.exports, "JiraSoftwareBoardAriResourceOwner", () => $64183abbeecc9672$export$d716ba4f5572ec86);
$parcel$export(module.exports, "JiraSoftwareBoardAriResourceType", () => $64183abbeecc9672$export$d4b70c04cf2221a5);
// src/jira-software/board/types.ts
var $64183abbeecc9672$export$d716ba4f5572ec86 = "jira-software", $64183abbeecc9672$export$d4b70c04cf2221a5 = "board";

});


parcelRegister("kwbhb", function(module, exports) {

$parcel$export(module.exports, "JiraDashboardAri", () => $eeff8afd95fca51f$export$b7d4016f0f5da5b8);

var $6H9w3 = parcelRequire("6H9w3");

var $3NoER = parcelRequire("3NoER");

var $gYPG7 = parcelRequire("gYPG7");
// src/jira/dashboard/manifest.ts
var $eeff8afd95fca51f$var$jiraDashboardAriStaticOpts = {
    qualifier: "ari",
    platformQualifier: "cloud",
    cloudId: new RegExp("^[a-zA-Z0-9_\\-.]{1,255}$"),
    // eslint-disable-line no-useless-escape
    resourceOwner: (0, $6H9w3.JiraDashboardAriResourceOwner),
    resourceType: (0, $6H9w3.JiraDashboardAriResourceType),
    resourceIdSlug: "activation/{activationId}/{dashboardId}",
    resourceIdSegmentFormats: {
        activationId: /[a-zA-Z0-9\-]+/,
        // eslint-disable-line no-useless-escape
        dashboardId: /[!a-zA-Z0-9\-_.~@:;{}=]+(\/[!a-zA-Z0-9\-_.~@:;{}=]+)*/
    }
};
// src/jira/dashboard/index.ts
var $eeff8afd95fca51f$export$b7d4016f0f5da5b8 = class _JiraDashboardAri extends (0, $3NoER.RegisteredAri) {
    constructor(opts){
        super(opts);
        this._siteId = opts.cloudId || "", this._activationId = opts.resourceIdSegmentValues.activationId, this._dashboardId = opts.resourceIdSegmentValues.dashboardId;
    }
    get siteId() {
        return this._siteId;
    }
    get activationId() {
        return this._activationId;
    }
    get dashboardId() {
        return this._dashboardId;
    }
    static create(opts) {
        let derivedOpts = {
            qualifier: $eeff8afd95fca51f$var$jiraDashboardAriStaticOpts.qualifier,
            platformQualifier: $eeff8afd95fca51f$var$jiraDashboardAriStaticOpts.platformQualifier,
            cloudId: opts.siteId,
            resourceOwner: $eeff8afd95fca51f$var$jiraDashboardAriStaticOpts.resourceOwner,
            resourceType: $eeff8afd95fca51f$var$jiraDashboardAriStaticOpts.resourceType,
            resourceId: `activation/${opts.activationId}/${opts.dashboardId}`,
            resourceIdSegmentValues: {
                activationId: opts.activationId,
                dashboardId: opts.dashboardId
            }
        }, ariOpts = (0, $gYPG7.AriParser).fromOpts(derivedOpts, $eeff8afd95fca51f$var$jiraDashboardAriStaticOpts);
        return new _JiraDashboardAri(ariOpts);
    }
    static parse(maybeAri) {
        let opts = (0, $gYPG7.AriParser).fromString(maybeAri, $eeff8afd95fca51f$var$jiraDashboardAriStaticOpts);
        return new _JiraDashboardAri(opts);
    }
    getVariables() {
        return {
            siteId: this.siteId,
            activationId: this.activationId,
            dashboardId: this.dashboardId
        };
    }
};

});
parcelRegister("6H9w3", function(module, exports) {

$parcel$export(module.exports, "JiraDashboardAriResourceOwner", () => $014208d660d71eea$export$62c1deae25c41d24);
$parcel$export(module.exports, "JiraDashboardAriResourceType", () => $014208d660d71eea$export$e4e3a57a5e435aff);
// src/jira/dashboard/types.ts
var $014208d660d71eea$export$62c1deae25c41d24 = "jira", $014208d660d71eea$export$e4e3a57a5e435aff = "dashboard";

});


parcelRegister("aSWXp", function(module, exports) {

$parcel$export(module.exports, "JiraPlanAri", () => $7eccae3426beb5b5$export$6d2eb3641569f26);

var $fi2nK = parcelRequire("fi2nK");

var $3NoER = parcelRequire("3NoER");

var $gYPG7 = parcelRequire("gYPG7");
// src/jira/plan/manifest.ts
var $7eccae3426beb5b5$var$jiraPlanAriStaticOpts = {
    qualifier: "ari",
    platformQualifier: "cloud",
    cloudId: new RegExp("^[a-zA-Z0-9_\\-.]{1,255}$"),
    // eslint-disable-line no-useless-escape
    resourceOwner: (0, $fi2nK.JiraPlanAriResourceOwner),
    resourceType: (0, $fi2nK.JiraPlanAriResourceType),
    resourceIdSlug: "activation/{activationId}/{planId}",
    resourceIdSegmentFormats: {
        activationId: /[a-zA-Z0-9\-]+/,
        // eslint-disable-line no-useless-escape
        planId: /[0-9]+/
    }
};
// src/jira/plan/index.ts
var $7eccae3426beb5b5$export$6d2eb3641569f26 = class _JiraPlanAri extends (0, $3NoER.RegisteredAri) {
    constructor(opts){
        super(opts);
        this._siteId = opts.cloudId || "", this._activationId = opts.resourceIdSegmentValues.activationId, this._planId = opts.resourceIdSegmentValues.planId;
    }
    get siteId() {
        return this._siteId;
    }
    get activationId() {
        return this._activationId;
    }
    get planId() {
        return this._planId;
    }
    static create(opts) {
        let derivedOpts = {
            qualifier: $7eccae3426beb5b5$var$jiraPlanAriStaticOpts.qualifier,
            platformQualifier: $7eccae3426beb5b5$var$jiraPlanAriStaticOpts.platformQualifier,
            cloudId: opts.siteId,
            resourceOwner: $7eccae3426beb5b5$var$jiraPlanAriStaticOpts.resourceOwner,
            resourceType: $7eccae3426beb5b5$var$jiraPlanAriStaticOpts.resourceType,
            resourceId: `activation/${opts.activationId}/${opts.planId}`,
            resourceIdSegmentValues: {
                activationId: opts.activationId,
                planId: opts.planId
            }
        }, ariOpts = (0, $gYPG7.AriParser).fromOpts(derivedOpts, $7eccae3426beb5b5$var$jiraPlanAriStaticOpts);
        return new _JiraPlanAri(ariOpts);
    }
    static parse(maybeAri) {
        let opts = (0, $gYPG7.AriParser).fromString(maybeAri, $7eccae3426beb5b5$var$jiraPlanAriStaticOpts);
        return new _JiraPlanAri(opts);
    }
    getVariables() {
        return {
            siteId: this.siteId,
            activationId: this.activationId,
            planId: this.planId
        };
    }
};

});
parcelRegister("fi2nK", function(module, exports) {

$parcel$export(module.exports, "JiraPlanAriResourceOwner", () => $b21a627cc548ba69$export$bfd26af3c5e1b90d);
$parcel$export(module.exports, "JiraPlanAriResourceType", () => $b21a627cc548ba69$export$d6abe08eb30f433d);
// src/jira/plan/types.ts
var $b21a627cc548ba69$export$bfd26af3c5e1b90d = "jira", $b21a627cc548ba69$export$d6abe08eb30f433d = "plan";

});



parcelRegister("7lK06", function(module, exports) {

$parcel$export(module.exports, "publishFavorite", () => $703ce7b9c2eadfdd$export$229a24253fb568e1);
$parcel$export(module.exports, "useSubscribeToFavorite", () => $703ce7b9c2eadfdd$export$eb04bf805f6b8fb2);

var $5uXOq = parcelRequire("5uXOq");
/**
 * Simple pub-sub implementation to emit and listen to change events for the favorite state of an entity.
 */ class $703ce7b9c2eadfdd$var$FavoritePubSub {
    constructor(){
        this.subscribers = {};
        this.subscribe = (typename, subscriber)=>{
            this.subscribers[typename] = [
                ...this.subscribers[typename] ?? [],
                subscriber
            ];
            return ()=>{
                this.subscribers[typename] = this.subscribers[typename]?.filter((sub)=>sub !== subscriber) ?? [];
            };
        };
        this.publish = (typename, payload)=>{
            this.subscribers[typename]?.forEach((subscriber)=>subscriber(payload));
        };
    }
}
// Singleton to emit and listen to events
const $703ce7b9c2eadfdd$var$favoritePubSub = new $703ce7b9c2eadfdd$var$FavoritePubSub();
const $703ce7b9c2eadfdd$export$229a24253fb568e1 = $703ce7b9c2eadfdd$var$favoritePubSub.publish;
const $703ce7b9c2eadfdd$export$eb04bf805f6b8fb2 = (typename, subscriber)=>{
    (0, $5uXOq.useEffect)(()=>{
        const typenames = Array.isArray(typename) ? typename : [
            typename
        ];
        const unsubscribes = typenames.map((val)=>$703ce7b9c2eadfdd$var$favoritePubSub.subscribe(val, subscriber));
        return ()=>unsubscribes.forEach((unsubscribe)=>unsubscribe());
    }, [
        typename,
        subscriber
    ]);
};

});

parcelRegister("eXQym", function(module, exports) {

$parcel$export(module.exports, "BOARDS_ITEM_TYPE", () => $6c76a5a290814989$export$aade82542e73ffc8);
$parcel$export(module.exports, "FILTERS_ITEM_TYPE", () => $6c76a5a290814989$export$a448ebfa10cebc74);
$parcel$export(module.exports, "DASHBOARDS_ITEM_TYPE", () => $6c76a5a290814989$export$f8099f229527572c);
$parcel$export(module.exports, "ISSUES_ITEM_TYPE", () => $6c76a5a290814989$export$8e58083dcbb878d);
$parcel$export(module.exports, "PLANS_ITEM_TYPE", () => $6c76a5a290814989$export$2fd44a6cb58b66cb);
$parcel$export(module.exports, "PROJECTS_ITEM_TYPE", () => $6c76a5a290814989$export$8e2cd98172988d7e);
$parcel$export(module.exports, "QUEUES_ITEM_TYPE", () => $6c76a5a290814989$export$6b0c8e47d2c7f1d9);
$parcel$export(module.exports, "VALID_ITEM_TYPES", () => $6c76a5a290814989$export$9c8cfad65800ddfb);
$parcel$export(module.exports, "VALID_ITEM_TYPENAMES", () => $6c76a5a290814989$export$2d63a9c2e78633c8);
const $6c76a5a290814989$export$aade82542e73ffc8 = 'boards';
const $6c76a5a290814989$export$a448ebfa10cebc74 = 'filters';
const $6c76a5a290814989$export$f8099f229527572c = 'dashboards';
const $6c76a5a290814989$export$8e58083dcbb878d = 'issues';
const $6c76a5a290814989$export$2fd44a6cb58b66cb = 'plans';
const $6c76a5a290814989$export$8e2cd98172988d7e = 'projects';
const $6c76a5a290814989$export$6b0c8e47d2c7f1d9 = 'queues';
const $6c76a5a290814989$export$9c8cfad65800ddfb = [
    $6c76a5a290814989$export$aade82542e73ffc8,
    $6c76a5a290814989$export$f8099f229527572c,
    $6c76a5a290814989$export$a448ebfa10cebc74,
    $6c76a5a290814989$export$8e58083dcbb878d,
    $6c76a5a290814989$export$2fd44a6cb58b66cb,
    $6c76a5a290814989$export$8e2cd98172988d7e,
    $6c76a5a290814989$export$6b0c8e47d2c7f1d9
];
const $6c76a5a290814989$export$2d63a9c2e78633c8 = [
    'JiraProject',
    'JiraCustomFilter',
    'JiraSystemFilter',
    'JiraDashboard',
    'JiraPlan',
    'JiraBoard',
    'JiraServiceManagementQueue'
];

});

parcelRegister("5c9oS", function(module, exports) {

$parcel$export(module.exports, "default", () => $f9559749111f2eca$export$2e2bcd8739ae039);

var $7eYK2 = parcelRequire("7eYK2");
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$f9559749111f2eca$export$2e2bcd8739ae039 = async (request)=>(0, $7eYK2.updateFavorite)(request);

});
parcelRegister("7eYK2", function(module, exports) {

$parcel$export(module.exports, "updateFavorite", () => $16085bb5bdb7219b$export$8c2f00130cc945dc);

var $eusud = parcelRequire("eusud");
const $16085bb5bdb7219b$export$8c2f00130cc945dc = async (request)=>{
    if (request.value) return (0, $eusud.performPostRequest)('/rest/internal/2/favourites', {
        body: JSON.stringify({
            entity: {
                id: request.id,
                type: request.type
            },
            beforeEntityPosition: request.beforeEntity || null
        })
    });
    return (0, $eusud.performDeleteRequest)(`/rest/internal/2/favourites/${request.type}/${request.id}`);
};

});


parcelRegister("7SIuT", function(module, exports) {

$parcel$export(module.exports, "errorFlag", () => $7252fdcfc0e15292$export$b9a7f1ebeaa76953);

var $0YlRJ = parcelRequire("0YlRJ");
const $7252fdcfc0e15292$export$b9a7f1ebeaa76953 = ()=>({
        type: 'error',
        ...(0, $0YlRJ.default)
    });

});
parcelRegister("0YlRJ", function(module, exports) {

$parcel$export(module.exports, "default", () => $87ad72b3da53041c$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $87ad72b3da53041c$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    title: {
        "id": "platform.ui.favouriting.favourite-change-provider.flags.failure.title",
        "defaultMessage": "Something\u2019s gone wrong"
    },
    description: {
        "id": "platform.ui.favouriting.favourite-change-provider.flags.failure.description",
        "defaultMessage": "You cannot star items right now due to an error."
    }
});

});






parcelRegister("42REw", function(module, exports) {

$parcel$export(module.exports, "AdminFooter", () => $7b2abd444f379ab5$export$d7aa9aad32d41ef6);

var $5uXOq = parcelRequire("5uXOq");

var $9UCCQ = parcelRequire("9UCCQ");

var $koVbs = parcelRequire("koVbs");

var $6cNb0 = parcelRequire("6cNb0");

var $88fdg = parcelRequire("88fdg");

var $d4B4Y = parcelRequire("d4B4Y");

var $7Josu = parcelRequire("7Josu");
const $7b2abd444f379ab5$export$d7aa9aad32d41ef6 = ({ testIdPrefix: testIdPrefix })=>{
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const [{ items: items }] = (0, $88fdg.usePlansItems)();
    const testId = (0, $6cNb0.testIdConcat)(testIdPrefix, 'admin-footer');
    if (!items || !items.links) return null;
    const { links: { settings: { id: id, isVisible: isVisible } } } = items;
    if (!isVisible) return null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $9UCCQ.default), {
        hasSeparator: true,
        testId: testId
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $d4B4Y.MenuItem), {
        analytics: {
            actionSubjectId: 'planSettingsNavigationMenuItem',
            menuItemId: id,
            menuItemType: 'action'
        },
        href: "/jira/plans/settings/permissions",
        key: id,
        testId: (0, $6cNb0.testIdConcat)(testId, `item-${id}`)
    }, formatMessage((0, $7Josu.default).settings)));
};

});
parcelRegister("7Josu", function(module, exports) {

$parcel$export(module.exports, "default", () => $f7ecad56cc035bca$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $f7ecad56cc035bca$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    settings: {
        "id": "atlassian-navigation.plans.menu.admin-footer.settings",
        "defaultMessage": "Settings"
    }
});

});


parcelRegister("53HSR", function(module, exports) {

$parcel$export(module.exports, "default", () => $c5a598b0994a63b7$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $4mNf3 = parcelRequire("4mNf3");

var $eXQym = parcelRequire("eXQym");

var $koVbs = parcelRequire("koVbs");

var $2EqxS = parcelRequire("2EqxS");

var $6cNb0 = parcelRequire("6cNb0");

var $fhtpB = parcelRequire("fhtpB");

var $d4B4Y = parcelRequire("d4B4Y");

var $dMJS0 = parcelRequire("dMJS0");

var $9ZBW7 = parcelRequire("9ZBW7");

var $gJFyv = parcelRequire("gJFyv");
// request to include icon in atlaskit
// https://ecosystem.atlassian.net/jira/servicedesk/projects/DS/queues/issue/DS-7743
// https://jdog.jira-dev.com/browse/JPO-18296
const $c5a598b0994a63b7$var$IconPlans = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("svg", {
        height: 24,
        width: 24,
        fill: "none",
        viewBox: "0 0 24 24"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("path", {
        fill: "var(--ds-icon, #44546F)",
        d: "M10 8a1 1 0 000 2h4a1 1 0 100-2h-4zM10 12a1 1 0 011-1h4a1 1 0 110 2h-4a1 1 0 01-1-1zM10 14a1 1 0 100 2h2a1 1 0 100-2h-2z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("path", {
        fill: "var(--ds-icon, #44546F)",
        fillRule: "evenodd",
        d: "M8 4a2 2 0 012-2h4a2 2 0 012 2h1a2 2 0 012 2v12a2 2 0 01-2 2H7a2 2 0 01-2-2V6a2 2 0 012-2h1zm6 3a2 2 0 001.732-1H17v12H7V6h1.268A2 2 0 0010 7h4zm0-3h-4v1h4V4z",
        clipRule: "evenodd"
    }));
const $c5a598b0994a63b7$var$Content = ({ testIdPrefix: testIdPrefix })=>{
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const { recentItems: recentItems, favoriteItems: favoriteItems, changeFavorite: onChangeFavorite, changedItems: changedItems } = (0, $dMJS0.usePlanNavItems)();
    const testId = (0, $6cNb0.testIdConcat)(testIdPrefix, 'items');
    const hasRecentItems = recentItems && recentItems.length > 0;
    const hasFavoriteItems = favoriteItems && favoriteItems.length > 0;
    if (!hasRecentItems && !hasFavoriteItems) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $9ZBW7.default), {
        testIdPrefix: (0, $6cNb0.testIdConcat)(testIdPrefix, 'empty')
    });
    return hasRecentItems ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("span", {
        "data-testId": testId
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $4mNf3.default), {
        testId: (0, $6cNb0.testIdConcat)(testIdPrefix, 'heading')
    }, formatMessage((0, $gJFyv.default).recent)), recentItems.map((item, index)=>{
        const { id: id, favourite: isFavourite, title: title } = item;
        const contextItem = changedItems[id.toString()];
        const isPending = contextItem && contextItem.pending === true ? contextItem.pending : false;
        const { id: beforeEntityId, type: beforeEntityType } = (0, $2EqxS.getBeforeEntity)(favoriteItems);
        const itemTitle = title || formatMessage((0, $gJFyv.default).untitledPlan);
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $d4B4Y.MenuItem), {
            analytics: {
                actionSubjectId: 'plansNavigationMenuItem',
                menuItemId: id,
                menuItemType: 'recent',
                position: index
            },
            href: item.url,
            key: item.id,
            testId: (0, $6cNb0.testIdConcat)(testIdPrefix, `item-${index}`),
            iconBefore: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($c5a598b0994a63b7$var$IconPlans, null),
            iconAfter: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $fhtpB.FavoriteButton), {
                beforeEntityId: beforeEntityId,
                beforeEntityType: beforeEntityType,
                id: String(id),
                isFavorite: Boolean(isFavourite),
                favoriteItemName: itemTitle,
                isPending: isPending,
                menuItemType: "recent",
                onChangeFavorite: onChangeFavorite,
                type: (0, $eXQym.PLANS_ITEM_TYPE)
            }),
            "aria-label": itemTitle
        }, itemTitle);
    })) : null;
};
var $c5a598b0994a63b7$export$2e2bcd8739ae039 = $c5a598b0994a63b7$var$Content;

});
parcelRegister("fhtpB", function(module, exports) {

$parcel$export(module.exports, "FavoriteButton", () => $fd1b3cb9e133f54f$export$8d5dab2ad1e19ea0);

var $5uXOq = parcelRequire("5uXOq");

var $2bzBV = parcelRequire("2bzBV");

var $hcObS = parcelRequire("hcObS");

var $iXVV6 = parcelRequire("iXVV6");
var $8zOmE = parcelRequire("8zOmE");
var $2NMNM = parcelRequire("2NMNM");
const $fd1b3cb9e133f54f$export$8d5dab2ad1e19ea0 = ({ beforeEntityId: // @ts-expect-error - TS2339 - Property 'beforeEntityId' does not exist on type 'FavoriteButtonProps'.
beforeEntityId, beforeEntityType: // @ts-expect-error - TS2339 - Property 'beforeEntityType' does not exist on type 'FavoriteButtonProps'.
beforeEntityType, id: id, isFavorite: isFavorite, favoriteItemName: favoriteItemName, isPending: isPending, menuItemType: menuItemType, onChangeFavorite: onChangeFavorite, type: type })=>{
    const { isVisible: isVisible } = (0, $2bzBV.useOverflowStatus)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $2NMNM.useAnalyticsEvents)();
    const contextualAnalyticsDataAttributes = (0, $5uXOq.useMemo)(()=>({
            isInMore: !isVisible,
            menuType: type,
            menuItemType: menuItemType
        }), [
        isVisible,
        menuItemType,
        type
    ]);
    const onClick = (0, $5uXOq.useCallback)(()=>{
        const beforeEntity = beforeEntityId != null && beforeEntityType != null ? {
            beforeEntity: {
                id: beforeEntityId,
                type: beforeEntityType
            }
        } : undefined;
        onChangeFavorite({
            id: id,
            value: !isFavorite,
            type: type,
            ...beforeEntity
        });
        const actionSubject = type.slice(0, type.length - 1); // remove "s" from type ("projects" -> "project", etc)
        const action = isFavorite ? 'unstarred' : 'starred';
        const analyticsEvent = createAnalyticsEvent({});
        (0, $8zOmE.fireTrackAnalytics)(analyticsEvent, `${actionSubject} ${action}`, id);
    }, [
        beforeEntityId,
        beforeEntityType,
        createAnalyticsEvent,
        id,
        isFavorite,
        onChangeFavorite,
        type
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $iXVV6.ContextualAnalyticsData), {
        attributes: contextualAnalyticsDataAttributes
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $hcObS.default), {
        isSmall: true,
        isShownInList: true,
        isFavorite: isFavorite,
        favoriteItemName: favoriteItemName,
        pending: isPending,
        onClick: onClick
    }));
};

});
parcelRegister("hcObS", function(module, exports) {

$parcel$export(module.exports, "FavoriteButtonWrapper", () => $0a68425ce3fc2fa8$export$bb1478fee6cd5f0c);
$parcel$export(module.exports, "default", () => $0a68425ce3fc2fa8$export$2e2bcd8739ae039);
/* view.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $basmW = parcelRequire("basmW");

var $8Rkzz = parcelRequire("8Rkzz");

var $fVnbM = parcelRequire("fVnbM");

var $dm1qi = parcelRequire("dm1qi");

var $dAf5R = parcelRequire("dAf5R");

var $5oTeF = parcelRequire("5oTeF");

var $bH1hf = parcelRequire("bH1hf");

var $7FtaJ = parcelRequire("7FtaJ");

var $1Cvrw = parcelRequire("1Cvrw");

var $fNobW = parcelRequire("fNobW");

var $3bDjY = parcelRequire("3bDjY");

var $iQv12 = parcelRequire("iQv12");

var $7XYc4 = parcelRequire("7XYc4");

var $az4zD = parcelRequire("az4zD");

var $dCm1o = parcelRequire("dCm1o");

var $6fQ6A = parcelRequire("6fQ6A");
const $0a68425ce3fc2fa8$var$SKELETON_TEST_ID = 'favouriting.favorite-button-stateless.skeleton';
const $0a68425ce3fc2fa8$var$ICON_WRAPPER_TEST_ID_PREFIX = 'favouriting.favorite-button-stateless.icon-wrapper';
class $0a68425ce3fc2fa8$export$f8ad2acf0ec4860f extends (0, $5uXOq.Component) {
    static{
        this.defaultProps = {
            isFavorite: undefined,
            favoriteItemName: undefined,
            isShownInList: false,
            isSmall: false,
            hideTooltip: false,
            onClick: (0, (/*@__PURE__*/$parcel$interopDefault($8Rkzz))),
            tooltipPosition: 'bottom',
            skipAnimation: false
        };
    }
    componentDidUpdate(prevProps) {
        if (!this.props.skipAnimation && (!prevProps.pending && this.props.pending || !prevProps.isFavorite && this.props.isFavorite)) {
            this.onAnimationStart();
            this.onSettingAnimationEnd();
        }
    }
    onAnimationStart() {
        this.setState({
            isAnimating: !this.state.isAnimating
        });
    }
    onSettingAnimationEnd() {
        setTimeout(()=>{
            this.setState({
                isAnimating: false
            });
        }, $0a68425ce3fc2fa8$var$animationTime * 2);
    }
    render() {
        const { isFavorite: isFavorite, favoriteItemName: favoriteItemName, isShownInList: isShownInList, isSmall: isSmall, hideTooltip: hideTooltip, tooltipPosition: tooltipPosition, pending: pending, intl: { formatMessage: formatMessage } } = this.props;
        const { isAnimating: isAnimating } = this.state;
        if (isFavorite === undefined) // show skeleton as a space placeholder (to avoid layout recalculations in browser and visible "jump" when we got data)
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $fNobW.default), {
            name: "favourite-button"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($0a68425ce3fc2fa8$export$db65185b5889c83, {
            "data-testid": $0a68425ce3fc2fa8$var$SKELETON_TEST_ID,
            isSmall: isSmall
        }));
        const iconWrapperTestId = isShownInList ? `${$0a68425ce3fc2fa8$var$ICON_WRAPPER_TEST_ID_PREFIX}-list` : $0a68425ce3fc2fa8$var$ICON_WRAPPER_TEST_ID_PREFIX;
        const buttonContentOld = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($0a68425ce3fc2fa8$var$FavIconWrapper, {
            isFavorite: isFavorite,
            isAnimating: isAnimating,
            "data-testid": iconWrapperTestId,
            isSmall: isSmall
        }, isFavorite ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($dm1qi))), {
            LEGACY_fallbackIcon: (0, (/*@__PURE__*/$parcel$interopDefault($bH1hf))),
            LEGACY_size: isSmall ? 'small' : undefined,
            color: "currentColor",
            label: formatMessage((0, $6fQ6A.default).removeFromStarred)
        }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($dAf5R))), {
            LEGACY_fallbackIcon: (0, (/*@__PURE__*/$parcel$interopDefault($5oTeF))),
            LEGACY_size: isSmall ? 'small' : undefined,
            color: "currentColor",
            label: formatMessage((0, $6fQ6A.default).addToStarred)
        }));
        const renderIcon = ()=>{
            const label = isFavorite ? formatMessage((0, $6fQ6A.default).removeFromStarred) : formatMessage((0, $6fQ6A.default).addToStarred);
            let StarIconComponent;
            if (isSmall) StarIconComponent = isFavorite ? (0, (/*@__PURE__*/$parcel$interopDefault($7FtaJ))) : (0, (/*@__PURE__*/$parcel$interopDefault($1Cvrw)));
            else StarIconComponent = isFavorite ? (0, (/*@__PURE__*/$parcel$interopDefault($dm1qi))) : (0, (/*@__PURE__*/$parcel$interopDefault($dAf5R)));
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(StarIconComponent, {
                color: "currentColor",
                label: label
            });
        };
        const buttonContent = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($0a68425ce3fc2fa8$var$FavIconWrapper, {
            isFavorite: isFavorite,
            isAnimating: isAnimating,
            "data-testid": iconWrapperTestId,
            isSmall: isSmall
        }, renderIcon());
        const tooltipContent = isFavorite ? formatMessage((0, $6fQ6A.default).removeFromStarred) : formatMessage((0, $6fQ6A.default).addToStarred);
        const ariaLabel = favoriteItemName ? formatMessage((0, $6fQ6A.default).toggleStarredWithItemName, {
            itemName: favoriteItemName
        }) : formatMessage((0, $6fQ6A.default).toggleStarred);
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($0a68425ce3fc2fa8$export$bb1478fee6cd5f0c, {
            role: "presentation",
            onClick: this.onBtnClickWrapper,
            onKeyPress: this.onBtnClickWrapper,
            "data-is-favorite": isFavorite
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $3bDjY.default), {
            content: !hideTooltip && tooltipContent,
            hideTooltipOnClick: true,
            position: tooltipPosition
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $fVnbM.default), {
            appearance: isShownInList ? 'subtle-link' : 'subtle',
            spacing: "none",
            "aria-label": ariaLabel,
            "aria-pressed": isFavorite,
            onClick: !pending ? this.onClick : (0, (/*@__PURE__*/$parcel$interopDefault($8Rkzz)))
        }, (0, $dCm1o.isVisualRefreshEnabled)() ? buttonContent : buttonContentOld)));
    }
    constructor(...args){
        super(...args), this.state = {
            isAnimating: false
        }, this.onBtnClickWrapper = (e)=>{
            e.stopPropagation(); // should not let this event get outside of the component, to prevent issue when, for example, star button is clicked in an item or row, which goes somewhere else on onClick handler. Cannot put it in onBtnClick, otherwise hideTooltipOnClick in <Tooltip> will not work
            e.preventDefault(); // same for cases when btn is inside a link - not to go to that link (e.g. in Star Drawer)
        }, this.onClick = (_, analyticsEvent)=>{
            this.props.onClick(analyticsEvent);
        };
    }
}
var $0a68425ce3fc2fa8$export$2e2bcd8739ae039 = (0, (/*@__PURE__*/$parcel$interopDefault($basmW)))((0, $iQv12.default)({
    onClick: ()=>({
            name: 'star'
        })
}), (0, $az4zD.injectIntlV2))($0a68425ce3fc2fa8$export$f8ad2acf0ec4860f);
const $0a68425ce3fc2fa8$var$animationTime = 500; // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
const $0a68425ce3fc2fa8$export$bb1478fee6cd5f0c = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_1e0c1o8l",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $0a68425ce3fc2fa8$var$FavoriteIconWrapperBaseOld = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "span", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { isSmall: isSmall, isAnimating: isAnimating, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmpldp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_1e0c1txw _4cvr1h6o _1bah1h6o",
            __cmplp.isSmall ? "_1bsb1tcg" : "_1bsbzwfg",
            __cmplp.isSmall ? "_4t3i1tcg" : "_4t3izwfg",
            __cmplp.isAnimating && "_11vn1ssb _1px1fmmq _48hmq7pw _1uvf1e03",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $0a68425ce3fc2fa8$var$FavoriteIconWrapperBaseNew = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "span", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { isSmall: isSmall, isAnimating: isAnimating, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmpldp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_1e0c1txw _4cvr1h6o _1bah1h6o",
            __cmplp.isSmall ? "_1bsb1tcg" : "_1bsbzwfg",
            __cmplp.isSmall ? "_4t3i1tcg" : "_4t3izwfg",
            __cmplp.isAnimating && "_1px1fmmq _48hmq7pw _1uvf1e03",
            __cmplp.className
        ])
    });
});
const $0a68425ce3fc2fa8$var$FavoriteIconWrapperBase = (0, $7XYc4.componentWithCondition)((0, $dCm1o.isVisualRefreshEnabled), $0a68425ce3fc2fa8$var$FavoriteIconWrapperBaseNew, $0a68425ce3fc2fa8$var$FavoriteIconWrapperBaseOld); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $0a68425ce3fc2fa8$var$FavIconWrapper = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = $0a68425ce3fc2fa8$var$FavoriteIconWrapperBase, style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "",
            __cmplp.isFavorite ? "_syaz1oqg" : "_syaz1oju",
            __cmplp.isFavorite ? "_30l31vop" : "_30l3wdcn",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
const $0a68425ce3fc2fa8$export$db65185b5889c83 = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { isSmall: isSmall, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmpldp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_1e0c1txw",
            __cmplp.isSmall ? "_1bsb1tcg" : "_1bsbzwfg",
            __cmplp.isSmall ? "_4t3i1tcg" : "_4t3izwfg",
            __cmplp.className
        ])
    });
});

});
parcelRegister("dm1qi", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::84298877a5ffec5302189e1356603055>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $9b8e6f0febff8b04$var$_react = $9b8e6f0febff8b04$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $9b8e6f0febff8b04$var$_baseNew = $9b8e6f0febff8b04$var$_interopRequireDefault((parcelRequire("fEaCe")));
function $9b8e6f0febff8b04$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "StarStarred".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for starred or favourited objects.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $9b8e6f0febff8b04$var$StarStarredIcon = (props)=>/*#__PURE__*/ $9b8e6f0febff8b04$var$_react.default.createElement($9b8e6f0febff8b04$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M8 0a.75.75 0 0 1 .7.48l1.705 4.434 4.403.338a.75.75 0 0 1 .422 1.324l-3.38 2.818 1.25 4.662a.75.75 0 0 1-1.148.813L8 12.159l-3.95 2.71a.75.75 0 0 1-1.15-.813l1.251-4.662L.77 6.576a.75.75 0 0 1 .422-1.324l4.403-.338L7.3.48A.75.75 0 0 1 8 0m0 2.84L6.655 6.335l-3.506.27 2.7 2.25-.973 3.627L8 10.341l3.124 2.142-.973-3.627 2.7-2.25-3.506-.27z" clip-rule="evenodd"/><path fill="currentcolor" d="M6.655 6.336 8 2.84l1.345 3.497 3.506.27-2.7 2.25.973 3.627L8 10.341l-3.124 2.142.973-3.627-2.7-2.25z"/>`
    }, props));
$9b8e6f0febff8b04$var$StarStarredIcon.displayName = 'StarStarredIcon';
var $9b8e6f0febff8b04$var$_default = module.exports.default = $9b8e6f0febff8b04$var$StarStarredIcon;

});

parcelRegister("5oTeF", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $3eea0a48351333dc$var$_react = $3eea0a48351333dc$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $c7fbr = parcelRequire("c7fbr");

var $3eea0a48351333dc$var$_starUnstarred = $3eea0a48351333dc$var$_interopRequireDefault((parcelRequire("dAf5R")));
function $3eea0a48351333dc$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $3eea0a48351333dc$var$StarIcon = (props)=>/*#__PURE__*/ $3eea0a48351333dc$var$_react.default.createElement($c7fbr.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="currentcolor" d="m12 16.373 3.98 2.193-.76-4.655 3.276-3.347-4.524-.69L12 5.687l-1.972 4.189-4.524.689L8.78 13.91l-.762 4.655zm0 2.283-3.016 1.662a2 2 0 0 1-2.939-2.075l.599-3.656-2.57-2.624a2 2 0 0 1 1.129-3.377l3.47-.528 1.518-3.224a2 2 0 0 1 3.618 0l1.519 3.224 3.47.528a2 2 0 0 1 1.127 3.377l-2.569 2.624.599 3.656a2 2 0 0 1-2.94 2.075z"/></svg>`
    }, props, {
        newIcon: $3eea0a48351333dc$var$_starUnstarred.default
    }));
$3eea0a48351333dc$var$StarIcon.displayName = 'StarIcon';
var $3eea0a48351333dc$var$_default = module.exports.default = $3eea0a48351333dc$var$StarIcon;

});

parcelRegister("bH1hf", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $8834b3797a7b4177$var$_react = $8834b3797a7b4177$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $c7fbr = parcelRequire("c7fbr");

var $8834b3797a7b4177$var$_starStarred = $8834b3797a7b4177$var$_interopRequireDefault((parcelRequire("dm1qi")));
function $8834b3797a7b4177$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $8834b3797a7b4177$var$StarFilledIcon = (props)=>/*#__PURE__*/ $8834b3797a7b4177$var$_react.default.createElement($c7fbr.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="currentcolor" fill-rule="evenodd" d="m12.072 17.284-3.905 2.053a1 1 0 0 1-1.451-1.054l.745-4.349-3.159-3.08a1 1 0 0 1 .554-1.705l4.366-.635 1.953-3.956a1 1 0 0 1 1.794 0l1.952 3.956 4.366.635a1 1 0 0 1 .555 1.705l-3.16 3.08.746 4.349a1 1 0 0 1-1.45 1.054z"/></svg>`
    }, props, {
        newIcon: $8834b3797a7b4177$var$_starStarred.default
    }));
$8834b3797a7b4177$var$StarFilledIcon.displayName = 'StarFilledIcon';
var $8834b3797a7b4177$var$_default = module.exports.default = $8834b3797a7b4177$var$StarFilledIcon;

});

parcelRegister("7FtaJ", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::14f14ae2593cbb89c3cab1b7918f4611>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $5952fdbb28afd899$var$_react = $5952fdbb28afd899$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $5952fdbb28afd899$var$_baseNew = $5952fdbb28afd899$var$_interopRequireDefault((parcelRequire("fEaCe")));
function $5952fdbb28afd899$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "StarStarred".
 * Category: utility
 * Location: @atlaskit/icon
 * Usage guidance: Reserved for starred or favourited objects as a secondary/tertiary action.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $5952fdbb28afd899$var$StarStarredIcon = (props)=>/*#__PURE__*/ $5952fdbb28afd899$var$_react.default.createElement($5952fdbb28afd899$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M6 0a.75.75 0 0 1 .7.48l1.288 3.35 3.32.256a.75.75 0 0 1 .422 1.324L9.182 7.533l.945 3.523a.75.75 0 0 1-1.148.813L6 9.825l-2.979 2.042a.75.75 0 0 1-1.148-.812l.945-3.523L.27 5.41a.75.75 0 0 1 .422-1.324l3.32-.256L5.3.48A.75.75 0 0 1 6 0m0 2.84-.928 2.413-2.423.186 1.866 1.556-.667 2.488L6 8.007l2.152 1.476-.667-2.488L9.35 5.439l-2.423-.186z" clip-rule="evenodd"/><path fill="currentcolor" d="M5.072 5.253 6 2.84l.928 2.414 2.423.186-1.866 1.556.667 2.488L6 8.007 3.848 9.483l.667-2.488L2.65 5.439z"/>`,
        type: 'utility'
    }, props));
$5952fdbb28afd899$var$StarStarredIcon.displayName = 'StarStarredIcon';
var $5952fdbb28afd899$var$_default = module.exports.default = $5952fdbb28afd899$var$StarStarredIcon;

});

parcelRegister("1Cvrw", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::52af1617dddfd09530e8f62747e987f3>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $12e1baef6b49aa95$var$_react = $12e1baef6b49aa95$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $12e1baef6b49aa95$var$_baseNew = $12e1baef6b49aa95$var$_interopRequireDefault((parcelRequire("fEaCe")));
function $12e1baef6b49aa95$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "StarUnstarred".
 * Category: utility
 * Location: @atlaskit/icon
 * Usage guidance: Reserved for starring or favoriting objects as a secondary/tertiary action.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $12e1baef6b49aa95$var$StarUnstarredIcon = (props)=>/*#__PURE__*/ $12e1baef6b49aa95$var$_react.default.createElement($12e1baef6b49aa95$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M6 0a.75.75 0 0 1 .7.48l1.288 3.35 3.32.256a.75.75 0 0 1 .422 1.324L9.182 7.533l.945 3.523a.75.75 0 0 1-1.148.813L6 9.825l-2.979 2.042a.75.75 0 0 1-1.148-.812l.945-3.523L.27 5.41a.75.75 0 0 1 .422-1.324l3.32-.256L5.3.48A.75.75 0 0 1 6 0m0 2.84-.928 2.413-2.423.186 1.866 1.556-.667 2.488L6 8.007l2.152 1.476-.667-2.488L9.35 5.439l-2.423-.186z" clip-rule="evenodd"/>`,
        type: 'utility'
    }, props));
$12e1baef6b49aa95$var$StarUnstarredIcon.displayName = 'StarUnstarredIcon';
var $12e1baef6b49aa95$var$_default = module.exports.default = $12e1baef6b49aa95$var$StarUnstarredIcon;

});

parcelRegister("iQv12", function(module, exports) {

$parcel$export(module.exports, "default", () => $945500a9598c3ac2$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $gvRPW = parcelRequire("gvRPW");
/**
 * Adds analytics events to the given callbacks without altering the original behavior
 * Callback is expected to have analyticsEvent as a last argument
 * @example
 * ```tsx
 *  // will fire "select" event when onSelect is called
 *  fileWithUIAnalytics({ onSelect: 'select' })
 *
 *  // will fire "select" event with extra attributes
 *  fileWithUIAnalytics({ onSelect: (value) => ({ name: 'select', value: value}) }
 *  ```
 */ const $945500a9598c3ac2$var$fireWithUIAnalytics = (ConnectedProps)=>{
    // sort the keys so we can set the deps of useMemo
    const providedKeys = Object.keys(ConnectedProps).sort();
    /**
	 * We implement a custom caching mechanism rather than memoizeOne. We got
	 * more ops/sec this way and we only need to bust the changing props cache
	 * instead of destroying all references on a single prop change.
	 */ // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const cachedMappedProps = {}; /*    the actual prop value */ 
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const cachedConnectedProps = {}; /* the connected prop value (the callback) */ 
    const getStateFromMappedProps = (mapped)=>{
        providedKeys.forEach((key, index)=>{
            // firstly check the cache if the prop has changed before creating
            // any new connected props
            const prop = mapped[index];
            if (key in cachedMappedProps && cachedMappedProps[key] === prop) return;
            cachedMappedProps[key] = prop;
            // @ts-expect-error - TS7019 - Rest parameter 'attrs' implicitly has an 'any[]' type.
            cachedConnectedProps[key] = (...attrs)=>{
                // assume that analytics event is always the last one (it should be by convention)
                const analyticsEvent = attrs[attrs.length - 1].clone();
                const connectedProp = ConnectedProps[key];
                // example: { onSelect: 'select' }
                if (typeof ConnectedProps[key] === 'string') analyticsEvent.update({
                    name: connectedProp,
                    analyticsType: (0, $gvRPW.UI_EVENT_TYPE)
                }).fire();
                else if (typeof connectedProp === 'function') {
                    const update = connectedProp(...attrs);
                    analyticsEvent.update({
                        ...update,
                        analyticsType: (0, $gvRPW.UI_EVENT_TYPE)
                    }).fire();
                }
                if (typeof prop === 'function') prop(...attrs);
            };
        });
        return cachedConnectedProps;
    };
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    return (WrappedComponent)=>// eslint-disable-next-line jira/react/no-class-components, @typescript-eslint/no-explicit-any,@typescript-eslint/consistent-type-assertions
        class WithAnalytics extends (0, $5uXOq.Component) {
            static{
                // Note: This seems to render weirdly in the chrome debugger. May need to change the string formatting to work around it
                this.displayName = `WithAnalytics(${WrappedComponent.displayName || WrappedComponent.name || 'UnnamedComponent'}`;
            }
            render() {
                const newMappedProps = getStateFromMappedProps(providedKeys.map((key)=>this.props[key]));
                // @ts-expect-error TS2322: Type {} is not assignable to type
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(WrappedComponent, {
                    ...this.props,
                    ...newMappedProps
                });
            }
        }; // eslint-disable-line @typescript-eslint/no-explicit-any
};
var $945500a9598c3ac2$export$2e2bcd8739ae039 = $945500a9598c3ac2$var$fireWithUIAnalytics;

});

parcelRegister("az4zD", function(module, exports) {

$parcel$export(module.exports, "injectIntlV2", () => $90dc1bd887533804$export$440265f0ca78e98e);
/* eslint-disable @typescript-eslint/consistent-type-assertions */ /* eslint-disable @typescript-eslint/no-explicit-any */ 
var $5uXOq = parcelRequire("5uXOq");

var $dY8Js = parcelRequire("dY8Js");

var $koVbs = parcelRequire("koVbs");
const $90dc1bd887533804$var$isDisplayableString = (mayBeString)=>typeof mayBeString === 'string' && mayBeString !== '';
function $90dc1bd887533804$var$getDisplayName(Component) {
    if ($90dc1bd887533804$var$isDisplayableString(Component.displayName)) // @ts-expect-error - TS2322 - Type 'string | undefined' is not assignable to type 'string'.
    return Component.displayName;
    if ($90dc1bd887533804$var$isDisplayableString(Component.name)) return Component.name;
    return 'Component';
}
const $90dc1bd887533804$export$440265f0ca78e98e = (WrappedComponent, options)=>{
    const { withRef: withRef = false } = options || {};
    const WithIntl = (props)=>{
        const intl = (0, $koVbs.default)();
        const intlRef = (0, $5uXOq.useRef)(null);
        if (!intl) throw new Error('REACT_INTL_FACADE: React Intl Could not find required `intl` object');
        if (!intlRef.current) intlRef.current = {
            // @ts-expect-error We force v5 messages type on v2 type
            messages: intl.messages,
            locale: intl.locale,
            formats: intl.formats,
            formatDate: intl.formatDate,
            formatMessage: intl.formatMessage,
            formatNumber: intl.formatNumber,
            formatPlural: intl.formatPlural,
            formatTime: intl.formatTime
        };
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(WrappedComponent, {
            ...props,
            intl: intlRef.current,
            ref: withRef ? props.forwardedRef : null
        });
    };
    // Changed this display name to be capital letter to prevent snapshots from failing, here is the original: https://github.com/formatjs/formatjs/blob/main/packages/react-intl/src/components/injectIntl.tsx#L98
    WithIntl.displayName = `InjectIntl(${$90dc1bd887533804$var$getDisplayName(WrappedComponent)})`;
    WithIntl.WrappedComponent = WrappedComponent;
    if (withRef) return (0, (/*@__PURE__*/$parcel$interopDefault($dY8Js)))(/*#__PURE__*/ (0, $5uXOq.forwardRef)((props, ref)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(WithIntl, {
            ...props,
            forwardedRef: ref
        })), WrappedComponent);
    return (0, (/*@__PURE__*/$parcel$interopDefault($dY8Js)))(WithIntl, WrappedComponent);
};

});

parcelRegister("6fQ6A", function(module, exports) {

$parcel$export(module.exports, "default", () => $10bc2ec5d9a72db1$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $10bc2ec5d9a72db1$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    addToStarred: {
        "id": "platform.ui.favouriting.favourite-button-stateless.add-to-starred",
        "defaultMessage": "Add to Starred"
    },
    removeFromStarred: {
        "id": "platform.ui.favouriting.favourite-button-stateless.remove-from-starred",
        "defaultMessage": "Remove from Starred"
    },
    toggleStarred: {
        "id": "platform.ui.favouriting.favourite-button-stateless.toggle-starred",
        "defaultMessage": "Star"
    },
    toggleStarredWithItemName: {
        "id": "platform.ui.favouriting.favourite-button-stateless.toggle-starred-with-item-name",
        "defaultMessage": "Star {itemName}"
    }
});

});



parcelRegister("9ZBW7", function(module, exports) {

$parcel$export(module.exports, "default", () => $72e027cbf3ff743a$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $fVnbM = parcelRequire("fVnbM");

var $dC5iT = parcelRequire("dC5iT");
var $8CUq3 = parcelRequire("8CUq3");

var $ousew = parcelRequire("ousew");

var $6cNb0 = parcelRequire("6cNb0");

var $88fdg = parcelRequire("88fdg");

var $gD5Z0 = parcelRequire("gD5Z0");

var $4LAva = parcelRequire("4LAva");

var $8zOmE = parcelRequire("8zOmE");

var $jyltl = parcelRequire("jyltl");

var $fXuwM = parcelRequire("fXuwM");

var $iy6PK = parcelRequire("iy6PK");
const $72e027cbf3ff743a$var$EmptyWithCTAs = ({ testIdPrefix: testIdPrefix })=>{
    const [{ items: items }] = (0, $88fdg.usePlansItems)();
    const [, { openDrawer: openCreateNewPlanWizardDrawer }] = (0, $gD5Z0.useCreateNewPlanWizardDrawer)();
    const [, { open: openCreateSamplePlanModal }] = (0, $4LAva.useCreateSamplePlan)();
    const handleRequestCreateSamplePlan = (0, $5uXOq.useCallback)(// eslint-disable-next-line @typescript-eslint/no-explicit-any
    (e, analyticsEvent)=>{
        (0, $8zOmE.fireUIAnalytics)(analyticsEvent, 'navigationCreateSamplePlan');
        openCreateSamplePlanModal();
    }, [
        openCreateSamplePlanModal
    ]);
    const handleRequestCreatePlan = (0, $5uXOq.useCallback)(// eslint-disable-next-line @typescript-eslint/no-explicit-any
    (e, analyticsEvent)=>{
        (0, $8zOmE.fireUIAnalytics)(analyticsEvent, 'navigationCreatePlan');
        openCreateNewPlanWizardDrawer();
    }, [
        openCreateNewPlanWizardDrawer
    ]);
    const createPlan = items?.links?.createPlan;
    const createSamplePlan = items?.links?.createSamplePlan;
    const hasButtons = Boolean(createPlan?.isVisible || createSamplePlan?.isVisible);
    const text = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("p", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $ousew.default), (0, $iy6PK.default).plansText)), hasButtons && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dC5iT.default), {
        xcss: $72e027cbf3ff743a$var$buttonGroupStyles
    }, createSamplePlan?.isVisible && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $fVnbM.default), {
        onClick: handleRequestCreateSamplePlan
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $ousew.default), (0, $iy6PK.default).createDemoPlan)), createPlan?.isVisible && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $fVnbM.default), {
        appearance: "primary",
        onClick: handleRequestCreatePlan
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $ousew.default), (0, $iy6PK.default).createPlan))));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $jyltl.MenuInfo), {
        imgAltText: "",
        imgSrc: (0, (/*@__PURE__*/$parcel$interopDefault($fXuwM))),
        testId: (0, $6cNb0.testIdConcat)(testIdPrefix, 'empty'),
        text: text
    });
};
var $72e027cbf3ff743a$export$2e2bcd8739ae039 = $72e027cbf3ff743a$var$EmptyWithCTAs;
const $72e027cbf3ff743a$var$buttonGroupStyles = (0, $8CUq3.xcss)({
    marginTop: 'space.200',
    display: 'flex',
    gap: 'space.100',
    justifyContent: 'center'
});

});
parcelRegister("fXuwM", function(module, exports) {
module.exports = new URL("plans-empty.7a647633.svg", import.meta.url).toString();

});

parcelRegister("iy6PK", function(module, exports) {

$parcel$export(module.exports, "default", () => $20432d5456b05a6a$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $20432d5456b05a6a$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    plansText: {
        "id": "atlassian-navigation.plans.menu.content.empty.plans-text",
        "defaultMessage": "Create up-to-date plans from multiple teams and projects."
    },
    createPlan: {
        "id": "atlassian-navigation.plans.menu.content.empty.create-plan",
        "defaultMessage": "Create plan"
    },
    createDemoPlan: {
        "id": "atlassian-navigation.plans.menu.content.empty.create-demo-plan",
        "defaultMessage": "Create demo plan"
    },
    learnMore: {
        "id": "atlassian-navigation.plans.menu.content.empty.learn-more",
        "defaultMessage": "Learn more"
    }
});

});


parcelRegister("gJFyv", function(module, exports) {

$parcel$export(module.exports, "default", () => $9f1da9814d244cf8$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $9f1da9814d244cf8$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    recent: {
        "id": "atlassian-navigation.plans.menu.content.recent",
        "defaultMessage": "Recent"
    },
    untitledPlan: {
        "id": "atlassian-navigation.plans.menu.content.untitled-plan",
        "defaultMessage": "Untitled plan"
    }
});

});


parcelRegister("6MUS3", function(module, exports) {

$parcel$export(module.exports, "FavoriteContent", () => $4f470a059723f912$export$297af018011b145a);

var $5uXOq = parcelRequire("5uXOq");

var $4mNf3 = parcelRequire("4mNf3");

var $eXQym = parcelRequire("eXQym");

var $koVbs = parcelRequire("koVbs");

var $6cNb0 = parcelRequire("6cNb0");

var $8jQu6 = parcelRequire("8jQu6");

var $Mp6qH = parcelRequire("Mp6qH");

var $fhtpB = parcelRequire("fhtpB");

var $d4B4Y = parcelRequire("d4B4Y");

var $56fXm = parcelRequire("56fXm");

var $dMJS0 = parcelRequire("dMJS0");

var $fbx6q = parcelRequire("fbx6q");
// request to include icon in atlaskit
// https://ecosystem.atlassian.net/jira/servicedesk/projects/DS/queues/issue/DS-7743
// https://jdog.jira-dev.com/browse/JPO-18296
const $4f470a059723f912$var$IconPlans = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("svg", {
        height: 24,
        width: 24,
        fill: "none",
        viewBox: "0 0 24 24"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("path", {
        fill: "var(--ds-icon, #44546F)",
        d: "M10 8a1 1 0 000 2h4a1 1 0 100-2h-4zM10 12a1 1 0 011-1h4a1 1 0 110 2h-4a1 1 0 01-1-1zM10 14a1 1 0 100 2h2a1 1 0 100-2h-2z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("path", {
        fill: "var(--ds-icon, #44546F)",
        fillRule: "evenodd",
        d: "M8 4a2 2 0 012-2h4a2 2 0 012 2h1a2 2 0 012 2v12a2 2 0 01-2 2H7a2 2 0 01-2-2V6a2 2 0 012-2h1zm6 3a2 2 0 001.732-1H17v12H7V6h1.268A2 2 0 0010 7h4zm0-3h-4v1h4V4z",
        clipRule: "evenodd"
    }));
const $4f470a059723f912$export$297af018011b145a = ({ testIdPrefix: testIdPrefix })=>{
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const { favoriteItems: favoriteItems, changeFavorite: onChangeFavorite, changedItems: changedItems } = (0, $dMJS0.usePlanNavItems)();
    const itemsToShow = (0, $5uXOq.useMemo)(()=>favoriteItems.slice(0, (0, $Mp6qH.DEFAULT_LOAD_COUNT_FAV)), [
        favoriteItems
    ]);
    const testId = (0, $6cNb0.testIdConcat)(testIdPrefix, 'items-starred');
    return favoriteItems.length > 0 ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("span", {
        "data-testId": testId
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $4mNf3.default), {
        testId: (0, $6cNb0.testIdConcat)(testId, 'heading')
    }, formatMessage((0, $fbx6q.default).starred)), itemsToShow.map((item, idx)=>{
        const { url: url, id: id, favourite: isFavourite, title: title } = item;
        const contextItem = changedItems[item.id.toString()];
        const isPending = contextItem && contextItem.pending === true ? contextItem.pending : false;
        const itemTitle = title || formatMessage((0, $fbx6q.default).untitledPlan);
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $d4B4Y.MenuItem), {
            analytics: {
                actionSubjectId: 'plansNavigationMenuItem',
                menuItemId: id,
                menuItemType: 'starred',
                position: idx,
                starred: Boolean(isFavourite)
            },
            href: url,
            iconBefore: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($4f470a059723f912$var$IconPlans, null),
            iconAfter: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $fhtpB.FavoriteButton), {
                id: String(id),
                isFavorite: Boolean(isFavourite),
                favoriteItemName: itemTitle,
                isPending: isPending,
                menuItemType: "starred",
                onChangeFavorite: onChangeFavorite,
                type: (0, $eXQym.PLANS_ITEM_TYPE)
            }),
            key: id,
            testId: (0, $6cNb0.testIdConcat)(testId, `item-${idx}`),
            "aria-label": itemTitle
        }, itemTitle);
    }), favoriteItems.length >= (0, $Mp6qH.DEFAULT_LOAD_COUNT_FAV) && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $56fXm.MenuItemViewAll), {
        analytics: {
            actionSubjectId: 'plansNavigationMenuItem',
            menuItemId: 'viewAll',
            // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
            position: (0, $Mp6qH.DEFAULT_LOAD_COUNT_FAV)
        },
        href: "/jira/plans",
        testId: (0, $6cNb0.testIdConcat)(testId, 'item-view-all'),
        to: (0, $8jQu6.plansDirectoryRoute)
    })) : null;
};

});
parcelRegister("8jQu6", function(module, exports) {

$parcel$export(module.exports, "plansDirectoryRoute", () => $f8b07af15c3bb184$export$143b4a1ef2ffc051);
const $f8b07af15c3bb184$export$143b4a1ef2ffc051 = {
    name: 'plans-directory',
    path: '/jira/plans'
};

});

parcelRegister("56fXm", function(module, exports) {

$parcel$export(module.exports, "MenuItemViewAll", () => $fec3d6e24cccbb91$export$2d5ce40137c4f96d);
/* main.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $9Xmvg = parcelRequire("9Xmvg");

var $koVbs = parcelRequire("koVbs");

var $d4B4Y = parcelRequire("d4B4Y");

var $awxdD = parcelRequire("awxdD");
const $fec3d6e24cccbb91$var$styles = {
    viewAll: "_4bfu18uv _1hmsglyw _ajmmnqa1 _syaz14q2 _ufb318uv _xrk1glyw _wgbdnqa1 _1tjq14q2 _1a3b18uv _9oik18uv _4fprglyw _1bnxglyw _5goinqa1 _jf4cnqa1 _f8pj14q2 _30l314q2 _1nrm18uv _c2waglyw _1iohnqa1 _9h8h16c2"
};
const $fec3d6e24cccbb91$export$2d5ce40137c4f96d = (props)=>{
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    return /*#__PURE__*/ $5uXOq.createElement((0, $d4B4Y.MenuItem), {
        ...props,
        target: "_blank",
        iconAfter: /*#__PURE__*/ $5uXOq.createElement((0, (/*@__PURE__*/$parcel$interopDefault($9Xmvg))), {
            spacing: "spacious",
            label: formatMessage((0, $awxdD.default).viewAllStarred)
        }),
        className: (0, $bwpsq.default)([
            $fec3d6e24cccbb91$var$styles.viewAll
        ])
    }, formatMessage((0, $awxdD.default).viewAllStarred));
};

});
parcelRegister("9Xmvg", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::2acc08ab6395d499b2798249d78c49fd>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $73fb14674561f421$var$_react = $73fb14674561f421$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $73fb14674561f421$var$_arrowUpRight = $73fb14674561f421$var$_interopRequireDefault((parcelRequire("3sGLB")));

var $73fb14674561f421$var$_open = $73fb14674561f421$var$_interopRequireDefault((parcelRequire("1FouZ")));
function $73fb14674561f421$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Migration Icon component for ArrowUpRightIcon.
 * This component is ArrowUpRightIcon, with `UNSAFE_fallbackIcon` set to "OpenIcon".
 *
 * Category: multi-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Multi purpose
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $73fb14674561f421$var$ArrowUpRightIcon = (props)=>/*#__PURE__*/ $73fb14674561f421$var$_react.default.createElement($73fb14674561f421$var$_arrowUpRight.default, Object.assign({
        LEGACY_fallbackIcon: $73fb14674561f421$var$_open.default
    }, props));
$73fb14674561f421$var$ArrowUpRightIcon.Name = 'ArrowUpRightIconMigration';
var $73fb14674561f421$var$_default = module.exports.default = $73fb14674561f421$var$ArrowUpRightIcon;

});
parcelRegister("3sGLB", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::aa37e7fb05387379200e2a91e20ea76e>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $2855293259c2814d$var$_react = $2855293259c2814d$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $2855293259c2814d$var$_baseNew = $2855293259c2814d$var$_interopRequireDefault((parcelRequire("fEaCe")));
function $2855293259c2814d$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "ArrowUpRight".
 * Category: multi-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Multi purpose
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $2855293259c2814d$var$ArrowUpRightIcon = (props)=>/*#__PURE__*/ $2855293259c2814d$var$_react.default.createElement($2855293259c2814d$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="m2.47 12.47 9.75-9.75 1.06 1.06-9.75 9.75z" clip-rule="evenodd"/><path fill="currentcolor" fill-rule="evenodd" d="M12 4H5.75V2.5h7a.75.75 0 0 1 .75.75v7H12z" clip-rule="evenodd"/>`
    }, props));
$2855293259c2814d$var$ArrowUpRightIcon.displayName = 'ArrowUpRightIcon';
var $2855293259c2814d$var$_default = module.exports.default = $2855293259c2814d$var$ArrowUpRightIcon;

});

parcelRegister("1FouZ", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $136c9fbd1122fba5$var$_react = $136c9fbd1122fba5$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $c7fbr = parcelRequire("c7fbr");

var $136c9fbd1122fba5$var$_arrowUpRight = $136c9fbd1122fba5$var$_interopRequireDefault((parcelRequire("3sGLB")));
function $136c9fbd1122fba5$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $136c9fbd1122fba5$var$OpenIcon = (props)=>/*#__PURE__*/ $136c9fbd1122fba5$var$_react.default.createElement($c7fbr.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><g fill="currentcolor" fill-rule="evenodd"><path d="M11.031 7A1.03 1.03 0 0 0 10 8.036a1.05 1.05 0 0 0 1.044 1.045l3.121.014.014 3.121a1.05 1.05 0 0 0 1.045 1.044 1.03 1.03 0 0 0 1.036-1.035l-.019-4.161a1.053 1.053 0 0 0-1.045-1.045L11.035 7z"/><path d="m13.364 8.292-7.071 7.071a1 1 0 0 0 0 1.415 1 1 0 0 0 1.414 0l7.071-7.071A1.002 1.002 0 0 0 14.071 8a1 1 0 0 0-.707.292"/></g></svg>`
    }, props, {
        newIcon: $136c9fbd1122fba5$var$_arrowUpRight.default
    }));
$136c9fbd1122fba5$var$OpenIcon.displayName = 'OpenIcon';
var $136c9fbd1122fba5$var$_default = module.exports.default = $136c9fbd1122fba5$var$OpenIcon;

});


parcelRegister("awxdD", function(module, exports) {

$parcel$export(module.exports, "default", () => $f6318f13bf447304$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $f6318f13bf447304$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    viewAllStarred: {
        "id": "atlassian-navigation.common.menu.view-all.view-all-starred",
        "defaultMessage": "View all starred"
    }
});

});


parcelRegister("fbx6q", function(module, exports) {

$parcel$export(module.exports, "default", () => $2c5162b46fd824b0$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $2c5162b46fd824b0$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    starred: {
        "id": "atlassian-navigation.plans.menu.favorite-content.starred",
        "defaultMessage": "Starred"
    },
    untitledPlan: {
        "id": "atlassian-navigation.plans.menu.favorite-content.untitled-plan",
        "defaultMessage": "Untitled plan"
    }
});

});


parcelRegister("5n6PC", function(module, exports) {

$parcel$export(module.exports, "LoadStatus", () => $28d55793d37ab45d$export$c7df4a3f1b89de01);

var $5uXOq = parcelRequire("5uXOq");

var $88fdg = parcelRequire("88fdg");

var $dHtVS = parcelRequire("dHtVS");
const $28d55793d37ab45d$export$c7df4a3f1b89de01 = ({ LoadStatusCommon: LoadStatusCommon = (0, $dHtVS.LoadStatus), usePlansItems: usePlansItems = (0, $88fdg.usePlansItems), shouldThrowError: shouldThrowError = false })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(LoadStatusCommon, {
        shouldThrowError: shouldThrowError,
        useProvider: usePlansItems
    });

});
parcelRegister("dHtVS", function(module, exports) {

$parcel$export(module.exports, "LoadStatus", () => $97c251fd319eb785$export$c7df4a3f1b89de01);
const $97c251fd319eb785$export$c7df4a3f1b89de01 = ({ useProvider: useProvider, shouldThrowError: shouldThrowError = false })=>{
    // @ts-expect-error - TS2525 - Initializer provides no value for this binding element and the binding element has no default value. | TS2525 - Initializer provides no value for this binding element and the binding element has no default value.
    const [{ fetchError: fetchError, isFetching: isFetching = false, promise: promise, hasSuccessOnce: hasSuccessOnce = false } = {}] = useProvider();
    if (fetchError != null && shouldThrowError && !hasSuccessOnce) throw fetchError;
    if (isFetching && !hasSuccessOnce) throw promise;
    return null;
};

});


parcelRegister("aProA", function(module, exports) {

$parcel$export(module.exports, "default", () => $59ef1621dccedbfe$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $9yOBd = parcelRequire("9yOBd");

var $l1N8i = parcelRequire("l1N8i");

var $3ZC89 = parcelRequire("3ZC89");

var $dC5iT = parcelRequire("dC5iT");
var $8CUq3 = parcelRequire("8CUq3");

var $hxoiH = parcelRequire("hxoiH");

var $iwnVa = parcelRequire("iwnVa");

var $6s1PB = parcelRequire("6s1PB");

var $koVbs = parcelRequire("koVbs");

var $liGrj = parcelRequire("liGrj");

var $iXVV6 = parcelRequire("iXVV6");
var $5oFIy = parcelRequire("5oFIy");
var $8zOmE = parcelRequire("8zOmE");

var $dCm1o = parcelRequire("dCm1o");

var $Mp6qH = parcelRequire("Mp6qH");

var $iIz7a = parcelRequire("iIz7a");

var $gblI8 = parcelRequire("gblI8");
const $59ef1621dccedbfe$var$LEARN_MORE_LINK = 'https://www.atlassian.com/software/jira/guides/advanced-roadmaps/overview#what-are-advanced-roadmaps'; // Statsig experiment `plans_menu_try_it_free_one_stop_shop_modal`
// the control cohort will be shown the modal, whereas the test cohort will be redirected to the billing page instead.
// if the check errors for whatever reason, we still want to show the modal, hence why it defaults to true
const $59ef1621dccedbfe$var$PremiumFeatureGate = ()=>{
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const { colorMode: colorMode } = (0, $hxoiH.default)();
    const { data: { premiumTrialUpgradeLink: premiumTrialUpgradeLink } } = (0, $6s1PB.expVal)('plans_menu_try_it_free_one_stop_shop_modal', 'isOneStopShopModalEnabled', true) ? {
        data: {
            premiumTrialUpgradeLink: undefined
        }
    } : // eslint-disable-next-line react-hooks/rules-of-hooks
    (0, $iwnVa.useJswPremiumTrialUpgradeLink)({
        caller: (0, $Mp6qH.PACKAGE_NAME)
    });
    const onStartTrialClick = (_, analyticsEvent)=>{
        if ((0, $dCm1o.isVisualRefreshEnabled)()) (0, $8zOmE.fireUIAnalytics)(analyticsEvent, 'plansNavigationMenuItem', {
            level: 2,
            componentType: 'fixedItemAction',
            parentItemId: 'plans',
            itemId: 'tryItFree'
        });
        else (0, $8zOmE.fireUIAnalytics)(analyticsEvent, 'navigationUpgradeToPremiumFromPlansMenu');
    };
    const onLearnMoreClick = (_, analyticsEvent)=>{
        if ((0, $dCm1o.isVisualRefreshEnabled)()) (0, $8zOmE.fireUIAnalytics)(analyticsEvent, 'plansNavigationMenuItem', {
            level: 2,
            componentType: 'fixedItemAction',
            parentItemId: 'plans',
            itemId: 'readTheGuide'
        });
        else (0, $8zOmE.fireUIAnalytics)(analyticsEvent, 'navigationLearnMoreAboutPremiumFromPlansMenu');
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $iXVV6.ContextualAnalyticsData), {
        sourceName: "plansPremiumFeatureGate",
        sourceType: "Modal"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($59ef1621dccedbfe$var$MenuContainer, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($59ef1621dccedbfe$var$MenuHeaderContainer, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $iIz7a.FeatureGateLogo), {
        alt: "",
        colorMode: colorMode
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($59ef1621dccedbfe$var$ContentContainer, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $l1N8i.default), {
        size: "small",
        as: "h2"
    }, formatMessage((0, $gblI8.default).title)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dC5iT.default), {
        xcss: $59ef1621dccedbfe$var$contentDescriptionStyles
    }, formatMessage((0, $gblI8.default).description))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($59ef1621dccedbfe$var$FooterContainer, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($59ef1621dccedbfe$var$LearnMoreButton, {
        appearance: "link",
        href: $59ef1621dccedbfe$var$LEARN_MORE_LINK,
        target: "_blank",
        onClick: onLearnMoreClick
    }, formatMessage((0, $gblI8.default).learnMoreLink)), (0, $6s1PB.expVal)('plans_menu_try_it_free_one_stop_shop_modal', 'isOneStopShopModalEnabled', true) ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($59ef1621dccedbfe$var$TryPremiumButton, {
        onClick: onStartTrialClick,
        iconBefore: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($3ZC89))), {
            LEGACY_size: "small",
            label: formatMessage((0, $gblI8.default).imageAlt),
            color: "var(--ds-text-inverse, #FFFFFF)"
        })
    }, formatMessage((0, $gblI8.default).startTrialButton)) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($59ef1621dccedbfe$var$TryPremiumButtonDirectLink, {
        href: premiumTrialUpgradeLink,
        iconBefore: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($3ZC89))), {
            LEGACY_size: "small",
            label: formatMessage((0, $gblI8.default).imageAlt),
            color: "var(--ds-text-inverse, #FFFFFF)"
        })
    }, formatMessage((0, $gblI8.default).startTrialButton)))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5oFIy.FireScreenAnalytics), null));
};
var $59ef1621dccedbfe$export$2e2bcd8739ae039 = $59ef1621dccedbfe$var$PremiumFeatureGate;
const $59ef1621dccedbfe$var$TryPremiumButton = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $liGrj.PremiumUpgradeModalEntryPointButton), {
        ...props,
        theme: (current, themeProps)=>({
                buttonStyles: {
                    ...current(themeProps).buttonStyles,
                    display: 'flex',
                    alignItems: 'center',
                    background: `linear-gradient(135deg, ${"var(--ds-background-discovery-bold, #6E5DC6)"}, ${"var(--ds-background-brand-bold, #0C66E4)"})`,
                    color: "var(--ds-text-inverse, #FFFFFF)",
                    outline: 'none',
                    boxSizing: 'border-box',
                    padding: `${"var(--ds-space-050, 4px)"} ${"var(--ds-space-150, 12px)"}`,
                    borderRadius: "var(--ds-space-050, 4px)",
                    height: "var(--ds-space-400, 32px)",
                    border: 'none',
                    font: "var(--ds-font-heading-xsmall, normal 600 14px/16px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif)",
                    gap: "var(--ds-space-025, 2px)"
                },
                spinnerStyles: current(themeProps).spinnerStyles
            })
    });
const $59ef1621dccedbfe$var$TryPremiumButtonDirectLink = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $9yOBd.default), {
        ...props,
        theme: (current, themeProps)=>({
                buttonStyles: {
                    ...current(themeProps).buttonStyles,
                    display: 'flex',
                    alignItems: 'center',
                    background: `linear-gradient(135deg, ${"var(--ds-background-discovery-bold, #6E5DC6)"}, ${"var(--ds-background-brand-bold, #0C66E4)"})`,
                    color: "var(--ds-text-inverse, #FFFFFF)",
                    outline: 'none',
                    boxSizing: 'border-box',
                    padding: `${"var(--ds-space-050, 4px)"} ${"var(--ds-space-150, 12px)"}`,
                    borderRadius: "var(--ds-space-050, 4px)",
                    height: "var(--ds-space-400, 32px)",
                    border: 'none',
                    font: "var(--ds-font-heading-xsmall, normal 600 14px/16px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif)",
                    gap: "var(--ds-space-025, 2px)"
                },
                spinnerStyles: current(themeProps).spinnerStyles
            })
    });
const $59ef1621dccedbfe$var$LearnMoreButton = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $9yOBd.default), {
        ...props,
        theme: (current, themeProps)=>({
                buttonStyles: {
                    ...current(themeProps).buttonStyles,
                    maxWidth: '250px',
                    marginRight: "var(--ds-space-200, 16px)"
                },
                spinnerStyles: current(themeProps).spinnerStyles
            })
    }); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $59ef1621dccedbfe$var$MenuContainer = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_2rko1b66 _11q717kt _189et94y _1dqonqa1 _1h6d3acm _vchhusvi _qjkjusvi _1y1m18uv _p12f4lgm",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $59ef1621dccedbfe$var$MenuHeaderContainer = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_11q7gup1 _2rko1xsr _ca0qidpf _u5f3idpf _n3tdidpf _19bvidpf _4t3il1r9 _kqswh2mm",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $59ef1621dccedbfe$var$ContentContainer = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_11q7vuon _ca0q1ejb _u5f31ejb _n3td1ejb _19bv1ejb",
            __cmplp.className
        ])
    });
});
const $59ef1621dccedbfe$var$contentDescriptionStyles = (0, $8CUq3.xcss)({
    marginTop: 'space.100'
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $59ef1621dccedbfe$var$FooterContainer = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_11q7vuon _2rko4dok _ca0qidpf _u5f31ejb _n3td1ejb _19bv1ejb _1e0c1txw _4cvr1h6o _1bahesu3",
            __cmplp.className
        ])
    });
});

});
parcelRegister("3ZC89", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::0b007f69ad81895a86b02f3ac63c0846>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $2e84a5872037db9e$var$_react = $2e84a5872037db9e$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $2e84a5872037db9e$var$_premium = $2e84a5872037db9e$var$_interopRequireDefault((parcelRequire("41hx5")));

var $2e84a5872037db9e$var$_premium2 = $2e84a5872037db9e$var$_interopRequireDefault((parcelRequire("8EYBJ")));
function $2e84a5872037db9e$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Migration Icon component for PremiumIcon.
 * This component is PremiumIcon, with `UNSAFE_fallbackIcon` set to "PremiumIcon".
 *
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for premium features.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $2e84a5872037db9e$var$PremiumIcon = (props)=>/*#__PURE__*/ $2e84a5872037db9e$var$_react.default.createElement($2e84a5872037db9e$var$_premium.default, Object.assign({
        LEGACY_fallbackIcon: $2e84a5872037db9e$var$_premium2.default
    }, props));
$2e84a5872037db9e$var$PremiumIcon.Name = 'PremiumIconMigration';
var $2e84a5872037db9e$var$_default = module.exports.default = $2e84a5872037db9e$var$PremiumIcon;

});
parcelRegister("41hx5", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::821d8a868bec01d1b9c95a45239911fb>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $2ed4db10c38a4841$var$_react = $2ed4db10c38a4841$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $2ed4db10c38a4841$var$_baseNew = $2ed4db10c38a4841$var$_interopRequireDefault((parcelRequire("fEaCe")));
function $2ed4db10c38a4841$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "Premium".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for premium features.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $2ed4db10c38a4841$var$PremiumIcon = (props)=>/*#__PURE__*/ $2ed4db10c38a4841$var$_react.default.createElement($2ed4db10c38a4841$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M1.5 3v1.5H3V3h1.5V1.5H3V0H1.5v1.5H0V3zM8 1c.31 0 .587.19.699.478l1.63 4.193 4.193 1.63a.75.75 0 0 1 0 1.398l-4.193 1.63-1.63 4.193a.75.75 0 0 1-1.398 0l-1.63-4.193L1.478 8.7a.75.75 0 0 1 0-1.398l4.193-1.63L7.3 1.478A.75.75 0 0 1 8 1m0 2.82L6.949 6.521a.75.75 0 0 1-.427.427L3.819 8l2.703 1.051a.75.75 0 0 1 .427.427L8 12.181l1.051-2.703a.75.75 0 0 1 .427-.427L12.181 8 9.478 6.949a.75.75 0 0 1-.427-.427zm5 10.68V16h1.5v-1.5H16V13h-1.5v-1.5H13V13h-1.5v1.5z" clip-rule="evenodd"/>`
    }, props));
$2ed4db10c38a4841$var$PremiumIcon.displayName = 'PremiumIcon';
var $2ed4db10c38a4841$var$_default = module.exports.default = $2ed4db10c38a4841$var$PremiumIcon;

});

parcelRegister("8EYBJ", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $64e11291068cd489$var$_react = $64e11291068cd489$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $c7fbr = parcelRequire("c7fbr");

var $64e11291068cd489$var$_premium = $64e11291068cd489$var$_interopRequireDefault((parcelRequire("41hx5")));
function $64e11291068cd489$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $64e11291068cd489$var$PremiumIcon = (props)=>/*#__PURE__*/ $64e11291068cd489$var$_react.default.createElement($c7fbr.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="currentcolor" fill-rule="evenodd" d="M9.276 4.382 7.357 9.247l-4.863 1.917a.78.78 0 0 0 0 1.45l4.863 1.918 1.919 4.863a.78.78 0 0 0 1.45 0h-.001l1.918-4.863 4.864-1.919a.781.781 0 0 0 0-1.45l-4.864-1.916-1.918-4.865a.78.78 0 0 0-.44-.438.78.78 0 0 0-1.01.438m8.297-2.03-.743 1.886-1.884.743a.56.56 0 0 0 0 1.038l1.884.743.743 1.886a.558.558 0 0 0 1.038 0l.745-1.886 1.883-.743a.557.557 0 0 0 0-1.038l-1.883-.743-.745-1.885a.55.55 0 0 0-.314-.314.56.56 0 0 0-.724.314m-.704 13.003-.744 1.883-1.883.744a.55.55 0 0 0-.316.314.56.56 0 0 0 .316.724l1.883.743.744 1.884c.057.144.17.258.314.315a.56.56 0 0 0 .724-.315l.744-1.884 1.883-.743a.557.557 0 0 0 0-1.038l-1.883-.744-.744-1.883a.55.55 0 0 0-.315-.316.56.56 0 0 0-.723.316"/></svg>`
    }, props, {
        newIcon: $64e11291068cd489$var$_premium.default
    }));
$64e11291068cd489$var$PremiumIcon.displayName = 'PremiumIcon';
var $64e11291068cd489$var$_default = module.exports.default = $64e11291068cd489$var$PremiumIcon;

});


parcelRegister("iwnVa", function(module, exports) {

$parcel$export(module.exports, "useJswPremiumTrialUpgradeLink", () => $fc84e0a2b7204935$export$645eda3f5f2163ec);

var $2vSU6 = parcelRequire("2vSU6");


var $ldyPw = parcelRequire("ldyPw");

var $9OXo1 = parcelRequire("9OXo1");

var $7qMMP = parcelRequire("7qMMP");
const $fc84e0a2b7204935$export$645eda3f5f2163ec = ({ deepLink: deepLink = true, skip: skip = false, caller: caller })=>{
    const { productEntitlementDetails: productEntitlementDetails } = (0, $9OXo1.useTenantContext)();
    const jswEntitlement = productEntitlementDetails?.[0, $c06e1abca7c13910$export$1346c9aa3cbb477d];
    const isJswUsingCcp = jswEntitlement?.billingSourceSystem === 'CCP';
    const { data: data, ...rest } = (0, $7qMMP.useGetBillingPageUrl)({
        isUsingCcp: isJswUsingCcp,
        editionToUpgradeTo: deepLink ? (0, $ldyPw.PREMIUM_EDITION) : undefined,
        caller: caller,
        skip: skip,
        subProduct: (0, $2vSU6.SOFTWARE_PROJECT)
    });
    return {
        data: {
            premiumTrialUpgradeLink: data.billingPageUrl
        },
        ...rest
    };
};

});
parcelRegister("7qMMP", function(module, exports) {

$parcel$export(module.exports, "useGetBillingPageUrl", () => $8899a5adc0f59798$export$7b1495b7581dcd01);

var $5uXOq = parcelRequire("5uXOq");

var $cVzoY = parcelRequire("cVzoY");

var $8zOmE = parcelRequire("8zOmE");
var $2NMNM = parcelRequire("2NMNM");

var $14XJw = parcelRequire("14XJw");


var $ldyPw = parcelRequire("ldyPw");

var $16v4H = parcelRequire("16v4H");

var $9OXo1 = parcelRequire("9OXo1");

var $7j7Ij = parcelRequire("7j7Ij");

var $5aye8 = parcelRequire("5aye8");

var $5Q4f1 = parcelRequire("5Q4f1");

var $iHAwr = parcelRequire("iHAwr");
const $8899a5adc0f59798$export$7b1495b7581dcd01 = ({ isUsingCcp: isUsingCcp, editionToUpgradeTo: editionToUpgradeTo, caller: caller, skip: skip = false, subProduct: subProduct, onError: onError })=>{
    const [billingPageUrl, setBillingPageUrl] = (0, $5uXOq.useState)();
    const [loading, setLoading] = (0, $5uXOq.useState)(true);
    const [error, setError] = (0, $5uXOq.useState)(null);
    const tenantContext = (0, $9OXo1.useTenantContext)();
    const contextSubProduct = (0, $16v4H.useSubProduct)();
    const { data: orgId } = (0, $14XJw.useOrgId)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $2NMNM.useAnalyticsEvents)();
    const subProductToUse = subProduct || contextSubProduct;
    (0, $5uXOq.useEffect)(()=>{
        if (skip) return;
        const loadBillingInfo = async ()=>{
            try {
                const explicitlyLicensedProducts = (0, $cVzoY.default)(tenantContext);
                const productKey = (0, $iHAwr.getProductKey)(subProductToUse, explicitlyLicensedProducts);
                const referrerKey = (0, $5aye8.getProductReferrerKey)(productKey);
                // The product key as used by Commerce.
                // JPD product key as used by Commerce does not include .ondemand
                const commerceProductKey = productKey === (0, $c06e1abca7c13910$export$202f50ee62667e32) ? productKey : `${productKey}.ondemand`;
                const entitlementId = productKey ? tenantContext.productEntitlementDetails?.[productKey]?.entitlementId : null;
                if (isUsingCcp) {
                    if (!entitlementId) {
                        (0, $8zOmE.fireOperationalAnalytics)(createAnalyticsEvent({}), 'RetrieveEntitlementId failed', {
                            caller: caller,
                            productKey: productKey,
                            productEntitlementDetails: JSON.stringify(tenantContext.productEntitlementDetails),
                            subProduct: subProductToUse
                        });
                        throw new Error('Empty entitlement ID');
                    }
                    const ccpTransactionAccountId = await (0, $5aye8.getCcpTransactionAccountId)(entitlementId);
                    // List of valid referrer values
                    // https://hello.atlassian.net/wiki/spaces/BILLIONS/pages/2652063891/How+to+Deeplink+to+BAC+s+change+plan#How-to-use-this-deeplink%3F
                    const ccpBaseUrl = `${(0, $5Q4f1.getAdminBaseUrl)()}/billing/o/${orgId}/${ccpTransactionAccountId}/entitlement/${entitlementId}/change-plan?referrer=${referrerKey}&enableMpucup=true`;
                    switch(editionToUpgradeTo){
                        case 0, $ldyPw.STANDARD_EDITION:
                        case 0, $ldyPw.PREMIUM_EDITION:
                            setBillingPageUrl(`${ccpBaseUrl}&offeringName=${(0, $7j7Ij.EDITION_KEY)[editionToUpgradeTo]}`);
                            break;
                        default:
                            setBillingPageUrl(ccpBaseUrl);
                    }
                } else // HAMS Billing System
                switch(editionToUpgradeTo){
                    case 0, $ldyPw.STANDARD_EDITION:
                    case 0, $ldyPw.PREMIUM_EDITION:
                        setBillingPageUrl(`${(0, $5Q4f1.getAdminBaseUrl)()}/s/${tenantContext.cloudId}/billing/applications/change-edition/${commerceProductKey}/${(0, $7j7Ij.EDITION_KEY)[editionToUpgradeTo]}`);
                        break;
                    default:
                        setBillingPageUrl(`${(0, $5Q4f1.getAdminBaseUrl)()}/s/${tenantContext.cloudId}/billing/applications/change-edition/${commerceProductKey}`);
                }
            } catch (e) {
                setError(e);
                if (onError && e instanceof Error) onError(e);
            } finally{
                setLoading(false);
            }
        };
        loadBillingInfo();
    }, [
        caller,
        createAnalyticsEvent,
        editionToUpgradeTo,
        isUsingCcp,
        onError,
        orgId,
        skip,
        subProduct,
        subProductToUse,
        tenantContext,
        tenantContext.cloudId
    ]);
    return {
        data: {
            billingPageUrl: billingPageUrl
        },
        loading: loading,
        error: error
    };
};

});
parcelRegister("7j7Ij", function(module, exports) {

$parcel$export(module.exports, "EDITION_KEY", () => $2797dd9db1687273$export$d73720c31c622c1f);

var $ldyPw = parcelRequire("ldyPw");
const $2797dd9db1687273$export$d73720c31c622c1f = {
    STANDARD_EDITION: (0, $ldyPw.STANDARD_EDITION_KEY),
    PREMIUM_EDITION: (0, $ldyPw.PREMIUM_EDITION_KEY)
};

});

parcelRegister("5aye8", function(module, exports) {

$parcel$export(module.exports, "getProductReferrerKey", () => $c065e9df012feb0c$export$b4fb3304d5d8fc5f);
$parcel$export(module.exports, "getCcpTransactionAccountId", () => $c065e9df012feb0c$export$5186b9d213f626fd);

var $7f4tk = parcelRequire("7f4tk");

const $c065e9df012feb0c$export$b4fb3304d5d8fc5f = (productKey)=>{
    if (productKey === (0, $c06e1abca7c13910$export$1346c9aa3cbb477d)) return 'jsw';
    if (productKey === (0, $c06e1abca7c13910$export$c8c1c8c3f8ddba61)) return 'jsm';
    if (productKey === (0, $c06e1abca7c13910$export$202f50ee62667e32)) return 'jpd';
    if (productKey === (0, $c06e1abca7c13910$export$db515c8cec1e6f79)) return 'jwm';
    return null;
};
const $c065e9df012feb0c$export$5186b9d213f626fd = async (entitlementId)=>{
    const entitlementDetails = await (0, $7f4tk.default)(`/gateway/api/ccp/api/v1/entitlements/${entitlementId}/details`);
    if (!entitlementDetails?.transactionAccountId) // TODO: Handle errors properly
    throw Error('Could not get transactionAccountId');
    return (entitlementDetails ?? {}).transactionAccountId;
};

});

parcelRegister("5Q4f1", function(module, exports) {

$parcel$export(module.exports, "getAdminBaseUrl", () => $2c9346932f4dad13$export$76bb37a926058cca);

var $5euJh = parcelRequire("5euJh");
const $2c9346932f4dad13$export$76bb37a926058cca = ()=>`https://${(0, $5euJh.getATLContextDomain)('admin')}`;

});

parcelRegister("iHAwr", function(module, exports) {

$parcel$export(module.exports, "getProductKey", () => $a2785a755bdb8c08$export$d0b7f02493f85477);

const $a2785a755bdb8c08$export$d0b7f02493f85477 = (subProduct, explicitlyLicensedProducts)=>{
    if (subProduct === 'software') return 0, $c06e1abca7c13910$export$1346c9aa3cbb477d;
    if (subProduct === 'serviceDesk') return 0, $c06e1abca7c13910$export$c8c1c8c3f8ddba61;
    // useSubProduct currently doesn't support polaris
    // JPD's subproduct currently falls under to 'software'
    // https://hello.atlassian.net/wiki/spaces/STAR/pages/2940457206/Detach+from+JSW+analytics+subproduct
    if (subProduct === 'polaris') return 0, $c06e1abca7c13910$export$202f50ee62667e32;
    if (subProduct === 'core') return 0, $c06e1abca7c13910$export$db515c8cec1e6f79;
    // If subProduct is null, we may be on a product-agnostic page e.g. "Your Work".
    // If there is only one licensed product, we can infer what the user is using.
    if (explicitlyLicensedProducts.length === 1) return explicitlyLicensedProducts[0];
    return null;
};

});



parcelRegister("liGrj", function(module, exports) {

$parcel$export(module.exports, "PremiumUpgradeModalEntryPointButton", () => $c0d01fc7cb7615a5$export$9901be7804227da7);

var $5uXOq = parcelRequire("5uXOq");

var $9yOBd = parcelRequire("9yOBd");

var $47gW9 = parcelRequire("47gW9");

var $ivDCs = parcelRequire("ivDCs");

var $4mO32 = parcelRequire("4mO32");

var $b3Gth = parcelRequire("b3Gth");
const $c0d01fc7cb7615a5$var$entryPointParams = {};
const $c0d01fc7cb7615a5$export$9901be7804227da7 = (buttonProps)=>{
    const { entryPointActions: entryPointActions, entryPointReferenceSubject: entryPointReferenceSubject } = (0, $4mO32.useEntryPoint)((0, $b3Gth.entryPointPremiumUpgradeModal), $c0d01fc7cb7615a5$var$entryPointParams);
    const buttonTrigger = (0, $47gW9.useEntryPointButtonTrigger)(entryPointActions);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $9yOBd.default), {
        ...buttonProps,
        ref: buttonTrigger
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $ivDCs.ModalEntryPointContainer), {
        entryPointReferenceSubject: entryPointReferenceSubject,
        id: "jira-premium-upgrade-modal",
        packageName: "jiraPremiumUpgradeModal",
        errorFallback: "flag",
        runtimeProps: {
            onClose: entryPointActions.unload
        },
        entryPointActions: entryPointActions
    }));
};

});
parcelRegister("ivDCs", function(module, exports) {

$parcel$export(module.exports, "ModalEntryPointContainer", () => $832a9e21b9f9d7ff$export$4d67c6ee49f3d14d);

var $5uXOq = parcelRequire("5uXOq");

var $i8Qvm = parcelRequire("i8Qvm");

var $8Bm0k = parcelRequire("8Bm0k");

var $c5vfY = parcelRequire("c5vfY");
const $832a9e21b9f9d7ff$export$4d67c6ee49f3d14d = ({ entryPointActions: { unload: unload }, entryPointReferenceSubject: entryPointReferenceSubject, errorFallback: errorFallback, runtimeProps: runtimeProps, ...containerProps })=>{
    const entryPointReference = (0, $8Bm0k.useEntryPointSubscription)(entryPointReferenceSubject);
    const props = (0, $5uXOq.useMemo)(()=>// eslint-disable-next-line @typescript-eslint/consistent-type-assertions
        ({
            ...runtimeProps,
            onClose () {
                runtimeProps.onClose?.();
                unload();
            }
        }), [
        runtimeProps,
        unload
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $i8Qvm.default), null, entryPointReference && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $c5vfY.InternalEntryPointContainer), {
        ...containerProps,
        entryPointReference: entryPointReference,
        errorFallback: errorFallback || 'flag',
        placeholderName: "modal-entry-point-container",
        runtimeProps: props
    }));
};

});

parcelRegister("b3Gth", function(module, exports) {

$parcel$export(module.exports, "entryPointPremiumUpgradeModal", () => $a50fd4829307668f$export$7116d5b1a93db8d6);

var $eufEc = parcelRequire("eufEc");

var $fEDBv = parcelRequire("fEDBv");

const $a50fd4829307668f$export$7116d5b1a93db8d6 = (0, $fEDBv.createEntryPoint)({
    root: (0, $eufEc.JSResourceForInteraction)(()=>(parcelRequire("3lj1i")).then((module)=>module.PremiumUpgradeModalEntryPoint), {
        moduleId: "1102b440"
    }),
    getPreloadProps: ()=>({})
});

});
parcelRegister("3lj1i", function(module, exports) {

let $26f2163bd2555fbe$var$load = (parcelRequire("28QjX"))(4);
module.exports = Promise.all([
    $26f2163bd2555fbe$var$load("ffQaD"),
    $26f2163bd2555fbe$var$load("kvRbA"),
    $26f2163bd2555fbe$var$load("kNFvF"),
    $26f2163bd2555fbe$var$load("jU6DJ")
]).then(()=>parcelRequire('5s8iH'));

});



parcelRegister("iIz7a", function(module, exports) {

$parcel$export(module.exports, "FeatureGateLogo", () => $bde809f68e5981c8$export$83d4ce06fb8c3c0);

var $5uXOq = parcelRequire("5uXOq");

var $5qRwM = parcelRequire("5qRwM");

var $6DbpV = parcelRequire("6DbpV");

var $j1jFP = parcelRequire("j1jFP");
const $bde809f68e5981c8$export$83d4ce06fb8c3c0 = ({ colorMode: colorMode, alt: alt })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5qRwM.default), {
        src: colorMode === 'dark' ? (0, (/*@__PURE__*/$parcel$interopDefault($6DbpV))) : (0, (/*@__PURE__*/$parcel$interopDefault($j1jFP))),
        alt: alt
    });

});
parcelRegister("5qRwM", function(module, exports) {

$parcel$export(module.exports, "default", () => $b3e92bcc4cb7160f$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $4NS88 = parcelRequire("4NS88");

var $hxoiH = parcelRequire("hxoiH");
const $b3e92bcc4cb7160f$var$baseImageStyles = null; /**
                               * __Image__
                               *
                               * This component can be used interchangeably with the native `img` element. It includes additional functionality, such as theme support.
                               *
                               * - [Examples](https://atlassian.design/components/image/examples)
                               * - [Code](https://atlassian.design/components/image/code)
                               * - [Usage](https://atlassian.design/components/image/usage)
                               */ 
function $b3e92bcc4cb7160f$export$2e2bcd8739ae039({ src: src, srcDark: srcDark, alt: alt, testId: testId, className: className, ...props }) {
    const imgRef = (0, $5uXOq.useRef)(null);
    const providedColorMode = (0, $4NS88.UNSAFE_useColorModeForMigration)();
    const { colorMode: observedColorMode } = (0, $hxoiH.default)();
    const colorMode = providedColorMode || observedColorMode;
    (0, $5uXOq.useEffect)(()=>{
        if (imgRef === null || imgRef.current === null) return;
        if (srcDark && colorMode === 'dark') imgRef.current.src = srcDark;
        else if (src) imgRef.current.src = src;
    }, [
        src,
        srcDark,
        colorMode
    ]);
    return /*#__PURE__*/ (0, $2OMIu.jsx)("img", {
        alt: alt,
        "data-testid": testId,
        src: src,
        className: (0, $bwpsq.default)([
            "_p12f1osq _4t3i1wug",
            className
        ]),
        ref: imgRef,
        ...props
    });
}

});
parcelRegister("4NS88", function(module, exports) {

$parcel$export(module.exports, "UNSAFE_useColorModeForMigration", () => $c865b9b4a27ce99e$export$ce91654eb9fea460);
$parcel$export(module.exports, "default", () => $c865b9b4a27ce99e$export$2e2bcd8739ae039);

var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $cBeZP = parcelRequire("cBeZP");

var $VSDnB = parcelRequire("VSDnB");

var $cSyk1 = parcelRequire("cSyk1");
var $9NXG8 = parcelRequire("9NXG8");
var $8Zdb4 = parcelRequire("8Zdb4");
const $c865b9b4a27ce99e$var$defaultThemeSettings = ()=>({
        dark: 'dark',
        light: 'light',
        spacing: 'spacing',
        typography: (0, $VSDnB.fg)('platform-default-typography-modernized') ? 'typography-modernized' : undefined
    });
const $c865b9b4a27ce99e$var$ColorModeContext = /*#__PURE__*/ (0, $5uXOq.createContext)(undefined);
const $c865b9b4a27ce99e$var$SetColorModeContext = /*#__PURE__*/ (0, $5uXOq.createContext)(undefined);
const $c865b9b4a27ce99e$var$ThemeContext = /*#__PURE__*/ (0, $5uXOq.createContext)(undefined);
const $c865b9b4a27ce99e$var$SetThemeContext = /*#__PURE__*/ (0, $5uXOq.createContext)(undefined);
function $c865b9b4a27ce99e$export$ce91654eb9fea460() {
    const value = (0, $5uXOq.useContext)($c865b9b4a27ce99e$var$ColorModeContext);
    return value;
}
function $c865b9b4a27ce99e$export$20f3076712c8dfa() {
    const value = (0, $5uXOq.useContext)($c865b9b4a27ce99e$var$ColorModeContext);
    if (!value) throw new Error('useColorMode must be used within AppProvider.');
    return value;
}
function $c865b9b4a27ce99e$export$e2afe7397c3d11c7() {
    const value = (0, $5uXOq.useContext)($c865b9b4a27ce99e$var$SetColorModeContext);
    if (!value) throw new Error('useSetColorMode must be used within AppProvider.');
    return value;
}
function $c865b9b4a27ce99e$export$93d4e7f90805808f() {
    const theme = (0, $5uXOq.useContext)($c865b9b4a27ce99e$var$ThemeContext);
    const [resolvedTheme, setResolvedTheme] = (0, $5uXOq.useState)(theme || (0, $cSyk1.default)());
    (0, $5uXOq.useEffect)(()=>{
        // We are using theme from context so no need to reference the DOM
        if (theme) return;
        const observer = new (0, $8Zdb4.default)(setResolvedTheme);
        observer.observe();
        return ()=>observer.disconnect();
    }, [
        theme
    ]);
    return resolvedTheme;
}
function $c865b9b4a27ce99e$export$501aa0dcd5527a48() {
    const value = (0, $5uXOq.useContext)($c865b9b4a27ce99e$var$SetThemeContext);
    if (!value) throw new Error('useSetTheme must be used within AppProvider.');
    return value;
}
const $c865b9b4a27ce99e$var$isMatchMediaAvailable = typeof window !== 'undefined' && 'matchMedia' in window;
const $c865b9b4a27ce99e$var$prefersDarkModeMql = $c865b9b4a27ce99e$var$isMatchMediaAvailable ? window.matchMedia('(prefers-color-scheme: dark)') : undefined;
// TODO: currently 'auto' color mode will always return 'light' in SSR.
// Additional work required: https://product-fabric.atlassian.net/browse/DSP-9781
function $c865b9b4a27ce99e$var$getReconciledColorMode(colorMode) {
    if (colorMode === 'auto') return $c865b9b4a27ce99e$var$prefersDarkModeMql?.matches ? 'dark' : 'light';
    return colorMode;
}
/**
 * __Theme provider__
 *
 * Provides global theming configuration.
 *
 * @internal
 */ function $c865b9b4a27ce99e$var$ThemeProvider({ children: children, defaultColorMode: defaultColorMode, defaultTheme: defaultTheme }) {
    const [chosenColorMode, setChosenColorMode] = (0, $5uXOq.useState)(defaultColorMode);
    const [reconciledColorMode, setReconciledColorMode] = (0, $5uXOq.useState)($c865b9b4a27ce99e$var$getReconciledColorMode(defaultColorMode));
    const [theme, setTheme] = (0, $5uXOq.useState)(()=>({
            ...$c865b9b4a27ce99e$var$defaultThemeSettings(),
            ...defaultTheme
        }));
    const setColorMode = (0, $5uXOq.useCallback)((colorMode)=>{
        setChosenColorMode(colorMode);
        setReconciledColorMode($c865b9b4a27ce99e$var$getReconciledColorMode(colorMode));
    }, []);
    const setPartialTheme = (0, $5uXOq.useCallback)((nextTheme)=>{
        setTheme((theme)=>({
                ...theme,
                ...nextTheme
            }));
    }, []);
    const lastSetGlobalThemePromiseRef = (0, $5uXOq.useRef)(null);
    (0, $5uXOq.useEffect)(()=>{
        /**
     * We need to wait for any previous `setGlobalTheme` calls to finish before calling it again.
     * This is to prevent race conditions as `setGlobalTheme` is async and mutates the DOM (e.g. sets the
     * `data-color-mode` attribute on the root element).
     *
     * Since we can't safely abort the `setGlobalTheme` execution, we need to wait for it to properly finish before
     * applying the new theme.
     *
     * Without this, we can end up in the following scenario:
     * 1. app loads with the default 'light' theme, kicking off `setGlobalTheme`
     * 2. app switches to 'dark' theme after retrieving value persisted in local storage, calling `setGlobalTheme` again
     * 3. `setGlobalTheme` function execution for `dark` finishes before the initial `light` execution
     * 4. `setGlobalTheme` function execution for `light` then finishes, resulting in the 'light' theme being applied.
     */ const cleanupLastFnCall = async ()=>{
            if (lastSetGlobalThemePromiseRef.current) {
                const unbindFn = await lastSetGlobalThemePromiseRef.current;
                unbindFn();
                lastSetGlobalThemePromiseRef.current = null;
            }
        };
        const safelySetGlobalTheme = async ()=>{
            await cleanupLastFnCall();
            const promise = (0, $9NXG8.default)({
                ...theme,
                colorMode: reconciledColorMode
            });
            lastSetGlobalThemePromiseRef.current = promise;
        };
        safelySetGlobalTheme();
        return function cleanup() {
            cleanupLastFnCall();
        };
    }, [
        theme,
        reconciledColorMode
    ]);
    (0, $5uXOq.useEffect)(()=>{
        if (!$c865b9b4a27ce99e$var$prefersDarkModeMql) return;
        const unbindListener = (0, $cBeZP.bind)($c865b9b4a27ce99e$var$prefersDarkModeMql, {
            type: 'change',
            listener: (event)=>{
                if (chosenColorMode === 'auto') setReconciledColorMode(event.matches ? 'dark' : 'light');
            }
        });
        return unbindListener;
    }, [
        chosenColorMode
    ]);
    return /*#__PURE__*/ (0, $2OMIu.jsx)($c865b9b4a27ce99e$var$ColorModeContext.Provider, {
        value: reconciledColorMode,
        children: /*#__PURE__*/ (0, $2OMIu.jsx)($c865b9b4a27ce99e$var$SetColorModeContext.Provider, {
            value: setColorMode,
            children: /*#__PURE__*/ (0, $2OMIu.jsx)($c865b9b4a27ce99e$var$ThemeContext.Provider, {
                value: theme,
                children: /*#__PURE__*/ (0, $2OMIu.jsx)($c865b9b4a27ce99e$var$SetThemeContext.Provider, {
                    value: setPartialTheme,
                    children: children
                })
            })
        })
    });
}
var $c865b9b4a27ce99e$export$2e2bcd8739ae039 = $c865b9b4a27ce99e$var$ThemeProvider;

});


parcelRegister("6DbpV", function(module, exports) {
module.exports = new URL("plans-standard-dark.fce82c99.svg", import.meta.url).toString();

});

parcelRegister("j1jFP", function(module, exports) {
module.exports = new URL("plans-standard-light.fde35b0d.svg", import.meta.url).toString();

});


parcelRegister("gblI8", function(module, exports) {

$parcel$export(module.exports, "default", () => $9ba9ec5dc8deac7d$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $9ba9ec5dc8deac7d$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    title: {
        "id": "atlassian-navigation.plans.menu.premium-feature-gate.title",
        "defaultMessage": "Unlock advanced planning tools"
    },
    imageAlt: {
        "id": "atlassian-navigation.plans.menu.premium-feature-gate.image-alt",
        "defaultMessage": "Upgrade to Jira Premium"
    },
    description: {
        "id": "atlassian-navigation.plans.menu.premium-feature-gate.description",
        "defaultMessage": "Boost agility with capacity planning, dependency mapping, and more. Try Jira Premium's high-level cross-team planning tools."
    },
    learnMoreLink: {
        "id": "atlassian-navigation.plans.menu.premium-feature-gate.learn-more-link",
        "defaultMessage": "Read the guide"
    },
    startTrialButton: {
        "id": "atlassian-navigation.plans.menu.premium-feature-gate.start-trial-button",
        "defaultMessage": "Try it free"
    }
});

});



parcelRegister("2FrC0", function(module, exports) {

$parcel$export(module.exports, "default", () => $10a254be368ab7ac$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $10a254be368ab7ac$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    plans: {
        "id": "atlassian-navigation.plans.plans",
        "defaultMessage": "Plans"
    }
});

});


parcelRegister("lbp13", function(module, exports) {

$parcel$export(module.exports, "YourWorkDropdown", () => $4aa4f1efd8bce12b$export$3f0b217fc9bdcb2b);

var $5uXOq = parcelRequire("5uXOq");

var $3zm3p = parcelRequire("3zm3p");

var $koVbs = parcelRequire("koVbs");

var $lmyls = parcelRequire("lmyls");

var $koeKL = parcelRequire("koeKL");

var $jFpmD = parcelRequire("jFpmD");

var $Mp6qH = parcelRequire("Mp6qH");

var $4uXxK = parcelRequire("4uXxK");

var $4XiFK = parcelRequire("4XiFK");

var $ebYJ0 = parcelRequire("ebYJ0");

var $e8iSm = parcelRequire("e8iSm");

var $bJsBT = parcelRequire("bJsBT");

var $fFuPf = parcelRequire("fFuPf");
const $4aa4f1efd8bce12b$var$YourWorkDropdown = ()=>{
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const activityClient = (0, $jFpmD.useActivityClient)('v3', 'jira');
    const cloudId = (0, $koeKL.useCloudId)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $3zm3p.AlertsStoreContainer), {
        cloudId: cloudId
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $e8iSm.RecentActivityContainer), {
        activityClient: activityClient,
        cloudId: cloudId
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $4XiFK.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $ebYJ0.Popup), {
        menuId: (0, $lmyls.MENU_ID).HOME,
        navigationItemId: (0, $Mp6qH.NAVIGATION_ITEM_ID).HOME,
        Menu: (0, $bJsBT.AsyncMenu),
        label: formatMessage((0, $fFuPf.default).title)
    }, formatMessage((0, $fFuPf.default).title)))));
};
const $4aa4f1efd8bce12b$export$3f0b217fc9bdcb2b = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $4uXxK.TopLevelErrorBoundary), {
        id: (0, $lmyls.MENU_ID).HOME
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($4aa4f1efd8bce12b$var$YourWorkDropdown, null));

});
parcelRegister("3zm3p", function(module, exports) {

$parcel$export(module.exports, "useAlertsStore", () => $d7740626dfebecb7$export$52a528b1f45cfa42);
$parcel$export(module.exports, "AlertsStoreContainer", () => $d7740626dfebecb7$export$dac8df4ae2328540);

var $gg7kZ = parcelRequire("gg7kZ");
var $3sQ5x = parcelRequire("3sQ5x");
var $iXqE5 = parcelRequire("iXqE5");

var $DWjzc = parcelRequire("DWjzc");

var $aT1mD = parcelRequire("aT1mD");
const $d7740626dfebecb7$export$a2290b0841306a43 = {
    items: null,
    isFetching: false,
    fetchError: null,
    promise: null,
    hasFetchedOnce: false,
    hasSuccessOnce: false,
    totalCount: 0
};
const $d7740626dfebecb7$export$d4c72bab9d6cc13a = {};
const $d7740626dfebecb7$var$loadAlerts = ({ searchParams: searchParams, key: key, shouldOverwrite: shouldOverwrite = true })=>async ({ setState: setState, getState: getState }, { cloudId: cloudId })=>{
        if (!cloudId) throw new Error('`cloudId` is required please wrap your component with `AlertsStoreContainer`, and provide the prop.');
        if (!key) throw new Error('`key` is required please provie a unique key for each query.');
        try {
            const promise = (0, $aT1mD.fetchAlerts)({
                cloudId: cloudId,
                searchParams: searchParams
            });
            setState({
                ...getState(),
                [key]: {
                    ...$d7740626dfebecb7$export$a2290b0841306a43,
                    ...getState()[key],
                    isFetching: true,
                    fetchError: null,
                    promise: promise
                }
            });
            const response = await promise;
            // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
            const alerts = response?.values ?? null;
            const newItems = shouldOverwrite ? alerts : [
                ...getState()[key]?.items ?? [],
                ...alerts
            ];
            setState({
                ...getState(),
                [key]: {
                    ...getState()[key],
                    items: newItems,
                    totalCount: newItems.length,
                    hasSuccessOnce: true,
                    hasFetchedOnce: true,
                    isFetching: false
                }
            });
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        } catch (error) {
            setState({
                ...getState(),
                [key]: {
                    ...$d7740626dfebecb7$export$a2290b0841306a43,
                    ...getState()[key],
                    fetchError: error,
                    hasFetchedOnce: true,
                    isFetching: false
                }
            });
            throw error;
        }
    };
const $d7740626dfebecb7$var$removeAlert = ({ alertId: alertId, key: key })=>async ({ setState: setState, getState: getState })=>{
        setState({
            ...getState(),
            [key]: {
                ...$d7740626dfebecb7$export$a2290b0841306a43,
                ...getState()[key],
                items: getState()[key]?.items?.filter((alert)=>alert.id !== alertId) ?? []
            }
        });
    };
const $d7740626dfebecb7$export$e324594224ef24da = {
    loadAlerts: $d7740626dfebecb7$var$loadAlerts,
    removeAlert: $d7740626dfebecb7$var$removeAlert
};
const $d7740626dfebecb7$var$alertsStore = (0, $iXqE5.createStore)({
    name: (0, $DWjzc.ALERTS_STORE_NAME),
    actions: $d7740626dfebecb7$export$e324594224ef24da,
    initialState: $d7740626dfebecb7$export$d4c72bab9d6cc13a
});
const $d7740626dfebecb7$export$52a528b1f45cfa42 = (0, $3sQ5x.createHook)($d7740626dfebecb7$var$alertsStore, {
    selector: (state)=>state
});
const $d7740626dfebecb7$export$dac8df4ae2328540 = (0, $gg7kZ.createContainer)($d7740626dfebecb7$var$alertsStore);

});
parcelRegister("DWjzc", function(module, exports) {

$parcel$export(module.exports, "ALERTS_STORE_NAME", () => $44a8ac0f9ca87731$export$6793992c0b67d9c9);
$parcel$export(module.exports, "PredefinedQueries", () => $44a8ac0f9ca87731$export$ed6721f2880ce367);
const $44a8ac0f9ca87731$export$6793992c0b67d9c9 = 'navigation-alerts-store';
const $44a8ac0f9ca87731$var$ONLY_MY_SELECTOR_QUERY = '(acknowledgedBy: me OR owner: me OR responders: me)';
const $44a8ac0f9ca87731$export$ed6721f2880ce367 = {
    MY_OPEN_ALERTS: `status: open AND acknowledged: false AND snoozed: false AND ${$44a8ac0f9ca87731$var$ONLY_MY_SELECTOR_QUERY}`,
    MY_ACKED_ALERTS: `status: open AND acknowledged: true AND ${$44a8ac0f9ca87731$var$ONLY_MY_SELECTOR_QUERY}`,
    MY_SNOOZED_ALERTS: `status: open AND acknowledged: false AND snoozed: true AND ${$44a8ac0f9ca87731$var$ONLY_MY_SELECTOR_QUERY}`
};

});

parcelRegister("aT1mD", function(module, exports) {

$parcel$export(module.exports, "fetchAlerts", () => $523404c6486132da$export$f7b1e2075b3da718);

var $jcw0u = parcelRequire("jcw0u");

var $7f4tk = parcelRequire("7f4tk");

var $g9E9n = parcelRequire("g9E9n");
const $523404c6486132da$export$f7b1e2075b3da718 = async ({ cloudId: cloudId, searchParams: searchParams })=>{
    try {
        const params = new URLSearchParams(searchParams ?? {});
        const result = await (0, $7f4tk.default)(`/gateway/api/jsm/ops/web/${cloudId}/v1/alerts/?${params.toString()}`);
        if (!result) throw Error('Could not retrieve alerts');
        // https://data-portal.internal.atlassian.com/analytics/registry/50237
        (0, $g9E9n.getAnalyticsWebClient)().getInstance().sendOperationalEvent({
            action: 'succeeded',
            actionSubject: 'jiraPlatformServicesAlertsStore.fetchAlerts',
            source: 'alertsStore'
        });
        return result;
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    } catch (error) {
        // https://data-portal.internal.atlassian.com/analytics/registry/50236
        (0, $jcw0u.default)({
            meta: {
                id: 'fetchAlerts',
                packageName: 'jiraAlertsStore',
                teamName: 'alexstrasza'
            },
            attributes: {
                error: error,
                searchParams: searchParams
            },
            error: error
        });
        throw error;
    }
};

});


parcelRegister("jFpmD", function(module, exports) {

$parcel$export(module.exports, "useActivityClient", () => $7287efdb57b3bb52$export$6620595b7f837f8f);

var $5uXOq = parcelRequire("5uXOq");

var $btDaU = parcelRequire("btDaU");

var $3LJ9C = parcelRequire("3LJ9C");

var $hoYXe = parcelRequire("hoYXe");
const $7287efdb57b3bb52$export$6620595b7f837f8f = (version, product, logger, baseUrl)=>{
    const { getArtifact: getArtifact } = (0, $btDaU.useFlightDeckContext)();
    return (0, $5uXOq.useMemo)(()=>(0, $hoYXe.createActivityClient)(version, product, logger, baseUrl, // If the rw-client is wrapped in a FD provider, use the provided fetch function
        getArtifact ? ()=>getArtifact((0, $3LJ9C.FD_CLIENT_FETCH_PROPS).name, (0, $3LJ9C.FD_CLIENT_FETCH_PROPS).dimensions) : undefined), [
        version,
        product,
        logger,
        baseUrl,
        getArtifact
    ]);
};

});
parcelRegister("btDaU", function(module, exports) {

$parcel$export(module.exports, "FlightDeckProvider", () => $85b0ca77dee62619$export$56da85ac9d40dbcd);
$parcel$export(module.exports, "useFlightDeckContext", () => $85b0ca77dee62619$export$73c96350a5e69ec);
$parcel$export(module.exports, "useFlightDeckArtifact", () => $85b0ca77dee62619$export$3b241cde208d2c5e);

var $5uXOq = parcelRequire("5uXOq");

var $6HV40 = parcelRequire("6HV40");
const $85b0ca77dee62619$export$ca1b33377afa620 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createContext({
    getArtifact: null
});
function $85b0ca77dee62619$export$56da85ac9d40dbcd({ children: children, product: product, config: config, fallbackArtifacts: fallbackArtifacts }) {
    const flightDeckClient = (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).useMemo(()=>{
        return new (0, $6HV40.default)(product, {
            handlers: {
                captureException: config === null || config === void 0 ? void 0 : config.captureException
            }
        }, fallbackArtifacts);
    }, [
        product,
        config === null || config === void 0 ? void 0 : config.captureException,
        fallbackArtifacts
    ]);
    const getArtifact = (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).useCallback(async (name, dimensions)=>{
        return flightDeckClient.fetchConfigFromFlightDeck({
            name: name,
            dimensions: dimensions
        });
    }, [
        flightDeckClient
    ]);
    const providerValue = (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).useMemo(()=>({
            getArtifact: getArtifact
        }), [
        getArtifact
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($85b0ca77dee62619$export$ca1b33377afa620.Provider, {
        value: providerValue
    }, children);
}
const $85b0ca77dee62619$export$73c96350a5e69ec = ()=>(0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).useContext($85b0ca77dee62619$export$ca1b33377afa620);
function $85b0ca77dee62619$export$3b241cde208d2c5e(key, dimensions) {
    const [artifact, setArtifact] = (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).useState();
    const { getArtifact: getArtifact } = $85b0ca77dee62619$export$73c96350a5e69ec();
    (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).useEffect(()=>{
        if (!getArtifact) throw new Error("Flight Deck Context not provided");
        getArtifact(key, dimensions).then((resp)=>setArtifact(resp))// we don't need to do anything with the error as it is already instrumented in the flightDeckClient
        .catch();
    }, [
        dimensions,
        key,
        getArtifact,
        setArtifact
    ]);
    return artifact;
}

});
parcelRegister("6HV40", function(module, exports) {

$parcel$export(module.exports, "default", () => $4e2305dbe349082f$export$2e2bcd8739ae039);

var $eHiP8 = parcelRequire("eHiP8");

var $6fYNv = parcelRequire("6fYNv");

var $jtD64 = parcelRequire("jtD64");

var $fynqv = parcelRequire("fynqv");

var $lKWnb = parcelRequire("lKWnb");

var $4r7nA = parcelRequire("4r7nA");

var $814TT = parcelRequire("814TT");
function $4e2305dbe349082f$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $4e2305dbe349082f$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $4e2305dbe349082f$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, $eHiP8.default)(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $4e2305dbe349082f$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
const $4e2305dbe349082f$var$STORAGE_KEY_BASE = "@atlassiansox/flight-deck-frontend-client";
const $4e2305dbe349082f$var$RETRIABLE_FD_ERROR_MESSAGES = [
    "Failed to fetch",
    "NetworkError when attempting to fetch resource.",
    "Load failed"
];
class $4e2305dbe349082f$export$2e2bcd8739ae039 {
    constructor(product, options = {
        handlers: {}
    }, fallbackArtifacts = []){
        (0, $eHiP8.default)(this, "fallbackArtifactMap", new Map());
        (0, $eHiP8.default)(this, "fetchFromFlightDeckPromises", new Map());
        this.expiryMS = options.expiryMS;
        this.handlers = options.handlers;
        this.product = product;
        this.storageClient = new (0, $jtD64.default)($4e2305dbe349082f$var$STORAGE_KEY_BASE, options);
        fallbackArtifacts.forEach((artifact)=>this.fallbackArtifactMap.set((0, $4r7nA.artifactKey)(artifact.name, artifact.dimensions), artifact.value));
        this.captureException = this.captureException.bind(this);
    }
    captureException(e, tags) {
        if (this.handlers.captureException) this.handlers.captureException(e, tags);
    }
    async fetchAndCacheArtifact(artifact, retryConfig) {
        const response = await (0, $6fYNv.retryOnException)(async ()=>{
            try {
                // await the result here so that we capture any errors
                const result = await (0, $fynqv.fetchFlightDeckConfiguration)(artifact.name, artifact.dimensions);
                return result;
            } catch (error) {
                throw new (0, $lKWnb.default)({
                    artifact: artifact.key,
                    dimensions: artifact.dimensions,
                    error: error
                });
            }
        }, {
            captureException: this.captureException,
            retryOn: (err)=>$4e2305dbe349082f$var$RETRIABLE_FD_ERROR_MESSAGES.includes(err.message),
            intervalsMS: retryConfig === null || retryConfig === void 0 ? void 0 : retryConfig.intervalsMS,
            onRetry: retryConfig === null || retryConfig === void 0 ? void 0 : retryConfig.onRetry
        });
        if (!response) {
            const missingArtifactError = new Error(`Missing artifact: ${artifact.key}`);
            this.captureException(missingArtifactError);
            throw missingArtifactError;
        }
        this.storageClient.setItemWithExpiry(artifact.key, response, this.expiryMS);
        // Clear the in-flight check
        this.fetchFromFlightDeckPromises.delete(artifact.key);
        return response;
    }
    async fetchArtifactPromise(artifact, retryConfig) {
        // Check for in-flight requests for this artifact
        if (this.fetchFromFlightDeckPromises.has(artifact.key)) return this.fetchFromFlightDeckPromises.get(artifact.key);
        const fetchPromise = this.fetchAndCacheArtifact(artifact, retryConfig);
        this.fetchFromFlightDeckPromises.set(artifact.key, fetchPromise);
        return fetchPromise;
    }
    async fetchConfigFromFlightDeck(artifact, retryConfig) {
        const experience = (0, $814TT.flightDeckClientExperience)();
        experience.start();
        try {
            const artifactWithKey = $4e2305dbe349082f$var$_objectSpread($4e2305dbe349082f$var$_objectSpread({}, artifact), {}, {
                key: (0, $4r7nA.artifactKey)(artifact.name, artifact.dimensions)
            });
            experience.addMetadata({
                key: artifactWithKey.key,
                product: this.product
            });
            // Create the promise to fetch the config, we only need to await this if we don't have local config
            const artifactPromise = this.fetchArtifactPromise(artifactWithKey, retryConfig);
            // Check local storage for the artifact
            const localConfig = this.storageClient.getItem(artifactWithKey.key);
            if (localConfig) {
                experience.addMetadata({
                    configSource: "localStorage"
                });
                return localConfig;
            }
            // Was a fallback config provided?
            if (this.fallbackArtifactMap.has(artifactWithKey.key)) {
                experience.addMetadata({
                    configSource: "fallback"
                });
                return this.fallbackArtifactMap.get(artifactWithKey.key);
            }
            experience.addMetadata({
                configSource: "fetch"
            });
            // No local copies of config, await FD fetch promise here so that we can capture any errors & fail the experience
            const result = await artifactPromise;
            return result;
        } catch (e) {
            experience.failure({
                metadata: {
                    error: (0, $814TT.exceptionToMetadata)(e)
                }
            });
            throw e;
        } finally{
            // if the experience has been failed in the "catch" block, calling "success" will have no effect
            experience.success();
        }
    }
}

});
parcelRegister("6fYNv", function(module, exports) {

$parcel$export(module.exports, "retryOnException", () => $0dab620feb4778b8$export$1d94629c94e7a17f);
$parcel$export(module.exports, "FailedFetchError", () => (parcelRequire("6sAya")).default);

var $lLItl = parcelRequire("lLItl");

var $daTxP = parcelRequire("daTxP");

var $6sAya = parcelRequire("6sAya");
const $0dab620feb4778b8$export$5c069c93d2b7493f = (ms)=>new Promise((resolve)=>{
        setTimeout(resolve, ms);
    });
const $0dab620feb4778b8$var$NO_CALLS_ERROR = 'No calls made';
const $0dab620feb4778b8$export$1d94629c94e7a17f = async (invokeOperation, { intervalsMS: intervalsMS = (0, $daTxP.NO_RETRIES), retryOn: retryOn = [
    (0, $6sAya.default)
], captureException: captureException, onRetry: onRetry })=>{
    const intervals = [
        ...intervalsMS
    ];
    let nextMSInterval = 0;
    let error = new Error($0dab620feb4778b8$var$NO_CALLS_ERROR);
    while(nextMSInterval !== undefined)try {
        if (nextMSInterval > 0) await $0dab620feb4778b8$export$5c069c93d2b7493f(nextMSInterval);
        if (onRetry && error.message !== $0dab620feb4778b8$var$NO_CALLS_ERROR) onRetry(error);
        return await invokeOperation();
    } catch (e) {
        error = (0, $lLItl.default)(e);
        if (captureException) captureException(error);
        // Retry ONLY when the error is an instance of one of the provided `retryOn` errors, or passes the `retryOn` test.
        // You need to ensure you are throwing one of the `retryOn` errors if that is the method you are using.
        if (typeof retryOn === 'function' ? retryOn(error) : retryOn.some((err)=>error instanceof err)) nextMSInterval = intervals.shift();
        else nextMSInterval = undefined;
    }
    throw error;
};

});
parcelRegister("lLItl", function(module, exports) {

$parcel$export(module.exports, "default", () => $b7435f92b90f1f57$export$2e2bcd8739ae039);
const $b7435f92b90f1f57$var$convertToError = (e)=>{
    let error;
    if (e instanceof Error) error = e;
    else if (typeof e === 'string') error = new Error(e);
    else if (typeof e === 'object') try {
        error = new Error('Object error instance thrown for operation: ' + JSON.stringify(e));
    } catch (jsonError) {
        error = new Error('Object serialisation error thrown during operation: ' + String(e));
    }
    else error = new Error('No error instance thrown for operation: ' + String(e));
    return error;
};
var $b7435f92b90f1f57$export$2e2bcd8739ae039 = $b7435f92b90f1f57$var$convertToError;

});

parcelRegister("daTxP", function(module, exports) {

$parcel$export(module.exports, "NO_RETRIES", () => $6d1feaff7ce645cb$export$a0a1c8f90becc136);
const $6d1feaff7ce645cb$export$a0a1c8f90becc136 = [];
const $6d1feaff7ce645cb$export$972171517b12aa4 = [
    0,
    0
];
const $6d1feaff7ce645cb$export$746d2203ed8cdc40 = [
    0,
    50,
    100
];
const $6d1feaff7ce645cb$export$f6858378b665f957 = [
    100,
    500,
    1000
];

});

parcelRegister("6sAya", function(module, exports) {

$parcel$export(module.exports, "default", () => $b434fbcc8a3be4d5$export$2e2bcd8739ae039);
class $b434fbcc8a3be4d5$export$2e2bcd8739ae039 extends Error {
    constructor({ error: error, path: path, method: method }){
        super();
        this.name = 'FailedFetchError';
        this.message = error.message || 'Unknown fetch error';
        this.stack = error.stack;
        this.originalName = error.name;
        this.method = method;
        const p = path.split('?')[0];
        this.path = /^[/-a-z]+$/i.test(p) ? p : '';
    }
}

});


parcelRegister("jtD64", function(module, exports) {

$parcel$export(module.exports, "default", () => $7fec5df08c1bfd78$export$2e2bcd8739ae039);

var $fvm5n = parcelRequire("fvm5n");
const $7fec5df08c1bfd78$var$DEFAULT_STORAGE_ENGINE = 'localStorage';
class $7fec5df08c1bfd78$export$2e2bcd8739ae039 {
    constructor(clientKey, options){
        this.getItem = (key, { useExpiredItem: useExpiredItem } = {
            useExpiredItem: false
        })=>{
            const item = this.client.getItem(this.itemKey(key));
            if (item) try {
                const parsedItem = JSON.parse(item);
                // item is expired
                if (parsedItem.expires && new Date(parsedItem.expires) < new Date()) {
                    /**
					 * Commented out removing this item, as it is a slightly different state
					 * to the item not existing that we may want to preserve.
					 *  this.client.removeItem(this.itemKey(key));
					 */ if (!useExpiredItem) return undefined;
                }
                return parsedItem.value;
            } catch (e) {
                this.captureException(e);
            }
            return undefined;
        };
        this.removeItem = (key)=>{
            try {
                this.client.removeItem(this.itemKey(key));
            } catch (e) {
                this.captureException(e);
            }
        };
        this.setItemWithExpiry = (key, value, expireInMS)=>{
            const itemWithExpiry = {
                value: value,
                expires: typeof expireInMS === 'number' ? Date.now() + expireInMS : undefined
            };
            try {
                this.client.setItem(this.itemKey(key), JSON.stringify(itemWithExpiry));
            } catch (e) {
                this.captureException(e);
            }
        };
        this.clientKey = clientKey;
        this.handlers = options?.handlers;
        const storageEngine = options?.storageEngine || $7fec5df08c1bfd78$var$DEFAULT_STORAGE_ENGINE;
        if (!Object.prototype.hasOwnProperty.call(window, storageEngine)) (0, $fvm5n.mockWindowStorage)([
            storageEngine
        ]);
        this.client = window[storageEngine];
    }
    captureException(e, tags) {
        if (this.handlers?.captureException) this.handlers?.captureException(e, tags);
    }
    itemKey(key) {
        return `${this.clientKey}_${key}`;
    }
}

});
parcelRegister("fvm5n", function(module, exports) {

$parcel$export(module.exports, "mockWindowStorage", () => $e2c0533271428186$export$efebfe7859cae3c7);
/**
 * This can be used to mock local storage for Edge and other browsers that have disabled local storage setting
 */ const $e2c0533271428186$export$c65e688d8b365035 = {
    _data: {},
    length: 0,
    setItem: function(id, val) {
        return this._data[id] = String(val);
    },
    getItem: function(id) {
        return this._data.hasOwnProperty(id) ? this._data[id] : undefined;
    },
    removeItem: function(id) {
        return delete this._data[id];
    },
    clear: function() {
        return this._data = {};
    },
    key: function(index) {
        return Object.keys(this._data)[index];
    }
};
const $e2c0533271428186$export$efebfe7859cae3c7 = (storageToMock = [
    'localStorage',
    'sessionStorage'
])=>{
    for (const storageToMockElement of storageToMock)Object.defineProperty(window, storageToMockElement, {
        value: {
            ...$e2c0533271428186$export$c65e688d8b365035
        },
        configurable: true
    });
};

});


parcelRegister("fynqv", function(module, exports) {

$parcel$export(module.exports, "fetchFlightDeckConfiguration", () => $b52c33ff29e619cd$export$6026918e023c9101);

var $euiLX = parcelRequire("euiLX");

var $6l8hg = parcelRequire("6l8hg");

var $3TdLx = parcelRequire("3TdLx");

var $3Oidj = parcelRequire("3Oidj");

var $d5LIN = parcelRequire("d5LIN");

var $95uqQ = parcelRequire("95uqQ");

var $kJG1r = parcelRequire("kJG1r");
/**
 * Arguments for passing in dimensions that the artifact might vary on.
 * For more details see: https://developer.atlassian.com/platform/flight-deck/getting-your-capability-onto-flight-deck/dimensions/
 */ /**
 * default to using prod instance since artifacts that don't depend on environment should be using the prod instance.
 */ const $b52c33ff29e619cd$var$defaultEnvType = "prod";
/**
 * default to using commercial instance.
 */ const $b52c33ff29e619cd$var$defaultPerimeter = "commercial";
async function $b52c33ff29e619cd$export$6026918e023c9101(artifactName, dim = {}) {
    var _dim$environmentType, _dim$perimeter;
    const environmentType = (_dim$environmentType = dim.environmentType) !== null && _dim$environmentType !== void 0 ? _dim$environmentType : $b52c33ff29e619cd$var$defaultEnvType;
    const perimeter = (_dim$perimeter = dim.perimeter) !== null && _dim$perimeter !== void 0 ? _dim$perimeter : $b52c33ff29e619cd$var$defaultPerimeter;
    const environment = $b52c33ff29e619cd$var$getEnvFromEnvType(environmentType);
    const locale = dim.locale && (0, $euiLX.default)(dim.locale);
    const artifactDimensions = {
        perimeter: perimeter,
        environment: environment,
        locale: locale
    };
    const client = await $b52c33ff29e619cd$var$getConfigClient(environmentType, perimeter);
    return client.getArtifact(artifactName, artifactDimensions);
}
async function $b52c33ff29e619cd$export$4abbe3ae0811355(dim = {}) {
    var _dim$environmentType2, _dim$perimeter2;
    const client = await $b52c33ff29e619cd$var$getConfigClient((_dim$environmentType2 = dim.environmentType) !== null && _dim$environmentType2 !== void 0 ? _dim$environmentType2 : $b52c33ff29e619cd$var$defaultEnvType, (_dim$perimeter2 = dim.perimeter) !== null && _dim$perimeter2 !== void 0 ? _dim$perimeter2 : $b52c33ff29e619cd$var$defaultPerimeter);
    return client.getLatestVersionMetadata();
}
async function $b52c33ff29e619cd$var$getConfigClient(env, perimeter) {
    const fetchArtifactExperience = await (0, $95uqQ.getFlightDeckFetchExperience)();
    const fetchVersionMetadataExperience = await (0, $95uqQ.getVersionMetadataFetchExperience)();
    return new (0, $d5LIN.ConfigClient)(new (0, $3TdLx.BifrostDataSource)(new (0, $3Oidj.BifrostHttpClientImpl)(env, perimeter), (0, $6l8hg.Versions).ManifestVersion), "Bifrost", fetchArtifactExperience, fetchVersionMetadataExperience);
}
/**
 *
 * This function is necessary since all artifacts are tagged using an environment,
 * so to get an artifact we need to specify an environment. However, users only
 * specify an environmentType since that's all that matters to them. Flight Deck
 * ensures that frontend artifacts don't vary based on region so this is safe to do.
 *
 * @param environmentDependentDimensions
 * @returns a specific environment that has that envtype
 */ function $b52c33ff29e619cd$var$getEnvFromEnvType(environment) {
    if (environment === undefined || environment === "prod") return "prod-west";
    switch(environment){
        case "stg":
            return "stg-west";
        case "adev":
            return "adev";
        case "ddev":
            return "ddev";
        case "pdev":
            return "pdev-apse2";
        case "fedex":
            return "stg-apse";
    }
}

});
parcelRegister("euiLX", function(module, exports) {

$parcel$export(module.exports, "default", () => $838bf5d423642311$export$2e2bcd8739ae039);
/**
 * This function is being used to address locale discrepancies in Atlassian products:
 * see: https://hello.atlassian.net/wiki/spaces/i18n/pages/528623554/Locale+Discrepancies+Across+Atlassian+Products+and+Platform+Areas
 */ const $838bf5d423642311$export$852ff24d0930c62f = (locale)=>{
    const standardizedLocale = locale.replace('_', '-');
    switch(standardizedLocale){
        case 'en-GB':
        case 'en-US':
        case 'en-XA':
        case 'en-XB':
        case 'en-ZZ':
        case 'pt-BR':
        case 'zh-CN':
        case 'zh-TW':
            return standardizedLocale;
        case 'en-UK':
            return 'en-GB';
        case 'en':
            return 'en-US';
        default:
            return standardizedLocale.split('-')[0];
    }
};
var $838bf5d423642311$export$2e2bcd8739ae039 = $838bf5d423642311$export$852ff24d0930c62f;

});

parcelRegister("6l8hg", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.Versions = module.exports.BaseUrls = module.exports.ConfigRegistryDataSource = module.exports.checkManifest = module.exports.parseVersionMetadata = module.exports.parseArtifactManifest = module.exports.tryGetArtifactData = module.exports.getArtifactFromSource = module.exports.Either = void 0;

var $auuB0 = parcelRequire("auuB0");
Object.defineProperty(module.exports, "Either", {
    enumerable: true,
    get: function() {
        return $auuB0.Either;
    }
});

var $2v7c1 = parcelRequire("2v7c1");
Object.defineProperty(module.exports, "getArtifactFromSource", {
    enumerable: true,
    get: function() {
        return $2v7c1.getArtifactFromSource;
    }
});
Object.defineProperty(module.exports, "tryGetArtifactData", {
    enumerable: true,
    get: function() {
        return $2v7c1.tryGetArtifactData;
    }
});

var $8Xjp5 = parcelRequire("8Xjp5");
Object.defineProperty(module.exports, "parseArtifactManifest", {
    enumerable: true,
    get: function() {
        return $8Xjp5.parseArtifactManifest;
    }
});

var $1NPzc = parcelRequire("1NPzc");
Object.defineProperty(module.exports, "parseVersionMetadata", {
    enumerable: true,
    get: function() {
        return $1NPzc.parseVersionMetadata;
    }
});

var $5LTws = parcelRequire("5LTws");
Object.defineProperty(module.exports, "checkManifest", {
    enumerable: true,
    get: function() {
        return $5LTws.checkManifest;
    }
});

var $6FHvZ = parcelRequire("6FHvZ");
Object.defineProperty(module.exports, "ConfigRegistryDataSource", {
    enumerable: true,
    get: function() {
        return $6FHvZ.ConfigRegistryDataSource;
    }
});

var $3ijEk = parcelRequire("3ijEk");
Object.defineProperty(module.exports, "BaseUrls", {
    enumerable: true,
    get: function() {
        return $3ijEk.BaseUrls;
    }
});
Object.defineProperty(module.exports, "Versions", {
    enumerable: true,
    get: function() {
        return $3ijEk.Versions;
    }
});

});
parcelRegister("auuB0", function(module, exports) {
"use strict";
var $7a34706d0f0f02a3$var$__extends = module.exports && module.exports.__extends || function() {
    var extendStatics = function(d, b) {
        extendStatics = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(d, b) {
            d.__proto__ = b;
        } || function(d, b) {
            for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
        };
        return extendStatics(d, b);
    };
    return function(d, b) {
        if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
}();
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.Either = void 0;
var $7a34706d0f0f02a3$var$Either = /** @class */ function() {
    function Either() {}
    Either.prototype.map = function(f) {
        return this.flatMap(function(a) {
            return Either.right(f(a));
        });
    };
    Either.right = function(value) {
        return new $7a34706d0f0f02a3$var$Right(value);
    };
    Either.left = function(error) {
        return new $7a34706d0f0f02a3$var$Left(error);
    };
    return Either;
}();
module.exports.Either = $7a34706d0f0f02a3$var$Either;
var $7a34706d0f0f02a3$var$Right = /** @class */ function(_super) {
    $7a34706d0f0f02a3$var$__extends(Right, _super);
    function Right(r) {
        var _this = _super.call(this) || this;
        _this.right = r;
        return _this;
    }
    Right.prototype.bimap = function(_f, g) {
        return $7a34706d0f0f02a3$var$Either.right(g(this.right));
    };
    Right.prototype.flatMap = function(f) {
        return f(this.right);
    };
    Right.prototype.fold = function(_onLeft, onRight) {
        return onRight(this.right);
    };
    Right.prototype.leftMap = function(_f) {
        return $7a34706d0f0f02a3$var$Either.right(this.right);
    };
    return Right;
}($7a34706d0f0f02a3$var$Either);
var $7a34706d0f0f02a3$var$Left = /** @class */ function(_super) {
    $7a34706d0f0f02a3$var$__extends(Left, _super);
    function Left(e) {
        var _this = _super.call(this) || this;
        _this.left = e;
        return _this;
    }
    Left.prototype.bimap = function(f, _g) {
        return $7a34706d0f0f02a3$var$Either.left(f(this.left));
    };
    Left.prototype.flatMap = function(_f) {
        return $7a34706d0f0f02a3$var$Either.left(this.left);
    };
    Left.prototype.fold = function(onLeft, _onRight) {
        return onLeft(this.left);
    };
    Left.prototype.leftMap = function(f) {
        return $7a34706d0f0f02a3$var$Either.left(f(this.left));
    };
    return Left;
}($7a34706d0f0f02a3$var$Either);

});

parcelRegister("2v7c1", function(module, exports) {
"use strict";
var $1d240e683f64836f$var$__assign = module.exports && module.exports.__assign || function() {
    $1d240e683f64836f$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $1d240e683f64836f$var$__assign.apply(this, arguments);
};
var $1d240e683f64836f$var$__awaiter = module.exports && module.exports.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var $1d240e683f64836f$var$__generator = module.exports && module.exports.__generator || function(thisArg, body) {
    var _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    }, f, y, t, g;
    return g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(g && (g = 0, op[0] && (_ = 0)), _)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.tryGetArtifactData = module.exports.getArtifactFromSource = void 0;

var $hdDPm = parcelRequire("hdDPm");

var $6l8hg = parcelRequire("6l8hg");

var $9te7V = parcelRequire("9te7V");

var $9P145 = parcelRequire("9P145");

var $3evgk = parcelRequire("3evgk");
function $1d240e683f64836f$var$getArtifactFromSource(dataSource, specifiedDimensions, deniedArtifactType) {
    return $1d240e683f64836f$var$__awaiter(this, void 0, void 0, function() {
        var manifestResult;
        var _this = this;
        return $1d240e683f64836f$var$__generator(this, function(_a) {
            switch(_a.label){
                case 0:
                    return [
                        4 /*yield*/ ,
                        dataSource.getManifest(specifiedDimensions.name, specifiedDimensions.version)
                    ];
                case 1:
                    manifestResult = _a.sent();
                    return [
                        2 /*return*/ ,
                        manifestResult.fold(function(error) {
                            return Promise.resolve({
                                type: "manifest-fetch-error",
                                error: error
                            });
                        }, function(manifest) {
                            return $1d240e683f64836f$var$__awaiter(_this, void 0, void 0, function() {
                                var manifestCheckResult, publishMetadata, dimensionContextResult;
                                return $1d240e683f64836f$var$__generator(this, function(_a) {
                                    manifestCheckResult = (0, $6l8hg.checkManifest)(manifest, {
                                        name: specifiedDimensions.name,
                                        version: specifiedDimensions.version
                                    });
                                    if (manifestCheckResult.key !== "success") return [
                                        2 /*return*/ ,
                                        {
                                            type: manifestCheckResult.key
                                        }
                                    ];
                                    publishMetadata = manifest.publishMetadata;
                                    if (manifest.frontend && deniedArtifactType === "frontend") return [
                                        2 /*return*/ ,
                                        {
                                            type: "denied-artifact-type",
                                            deniedType: "frontend",
                                            publishMetadata: publishMetadata
                                        }
                                    ];
                                    else if (!manifest.frontend && deniedArtifactType === "backend") return [
                                        2 /*return*/ ,
                                        {
                                            type: "denied-artifact-type",
                                            deniedType: "backend",
                                            publishMetadata: publishMetadata
                                        }
                                    ];
                                    dimensionContextResult = (0, $9te7V.getDimensionContext)(specifiedDimensions, manifest);
                                    switch(dimensionContextResult.type){
                                        case "missing-dimension-specification":
                                            return [
                                                2 /*return*/ ,
                                                {
                                                    type: "missing-dimension-specification",
                                                    publishMetadata: publishMetadata
                                                }
                                            ];
                                        case "unsupported-value-specified-for-supported-dimension":
                                            return [
                                                2 /*return*/ ,
                                                {
                                                    type: "unsupported-value-specified-for-supported-dimension",
                                                    publishMetadata: publishMetadata
                                                }
                                            ];
                                        case "success":
                                            return [
                                                2 /*return*/ ,
                                                $1d240e683f64836f$var$getArtifact(dataSource, manifest, dimensionContextResult.dimensionContext)
                                            ];
                                        default:
                                            (0, $9P145.assertUnreachable)(dimensionContextResult);
                                    }
                                    return [
                                        2 /*return*/ 
                                    ];
                                });
                            });
                        })
                    ];
            }
        });
    });
}
module.exports.getArtifactFromSource = $1d240e683f64836f$var$getArtifactFromSource;
function $1d240e683f64836f$var$getArtifact(dataSource, manifest, dimensionContext) {
    return $1d240e683f64836f$var$__awaiter(this, void 0, void 0, function() {
        var publishMetadata, tag, artifactResult;
        var _this = this;
        return $1d240e683f64836f$var$__generator(this, function(_a) {
            switch(_a.label){
                case 0:
                    publishMetadata = manifest.publishMetadata;
                    try {
                        tag = (0, $hdDPm.interpolateTagScheme)(manifest.tagScheme, $1d240e683f64836f$var$__assign($1d240e683f64836f$var$__assign({}, dimensionContext), {
                            name: manifest.name
                        }));
                    } catch (e) {
                        return [
                            2 /*return*/ ,
                            {
                                type: "tag-scheme-interpolation-error",
                                publishMetadata: publishMetadata
                            }
                        ];
                    }
                    return [
                        4 /*yield*/ ,
                        dataSource.getArtifact(manifest.name, tag)
                    ];
                case 1:
                    artifactResult = _a.sent();
                    return [
                        2 /*return*/ ,
                        artifactResult.fold(function(error) {
                            return Promise.resolve({
                                type: "artifact-fetch-error",
                                error: error,
                                publishMetadata: publishMetadata
                            });
                        }, function(data) {
                            return $1d240e683f64836f$var$__awaiter(_this, void 0, void 0, function() {
                                return $1d240e683f64836f$var$__generator(this, function(_a) {
                                    return [
                                        2 /*return*/ ,
                                        {
                                            type: "success",
                                            data: data,
                                            publishMetadata: publishMetadata,
                                            artifactVersion: dimensionContext["version"]
                                        }
                                    ];
                                });
                            });
                        })
                    ];
            }
        });
    });
}
function $1d240e683f64836f$var$tryGetArtifactData(artifact, dataSourceName) {
    switch(artifact.type){
        case "manifest-fetch-error":
            throw new Error("Unable to fetch manifest due to ".concat(dataSourceName, " response error: ").concat((0, $3evgk.toPrettyJson)(artifact.error)));
        case "artifact-fetch-error":
            throw new Error("Unable to fetch artifact due to ".concat(dataSourceName, " response error: ").concat((0, $3evgk.toPrettyJson)(artifact.error)));
        case "denied-artifact-type":
            throw new Error("No artifacts should be denied, but type ".concat(artifact.deniedType, " was denied."));
        case "unsupported-value-specified-for-supported-dimension":
            throw new Error("An unsupported value was specified for a supported dimension");
        case "missing-dimension-specification":
            throw new Error("A required dimension specification was missing");
        case "tag-scheme-interpolation-error":
            throw new Error("Ran into failure when trying to interpolate tag scheme");
        case "mismatched-manifest-name":
            throw new Error("Manifest has been corrupted. Manifest name is mismatched.");
        case "mismatched-manifest-version":
            throw new Error("Manifest has been corrupted. Manifest version is mismatched.");
        case "success":
            return artifact.data;
        default:
            (0, $9P145.assertUnreachable)(artifact);
    }
}
module.exports.tryGetArtifactData = $1d240e683f64836f$var$tryGetArtifactData;

});
parcelRegister("hdDPm", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.getVersionMetadataTag = module.exports.getDataTagForManifest = module.exports.getDimensionsFromTagScheme = module.exports.generateTagScheme = module.exports.interpolateTagScheme = void 0;
const $c8928b7419a5cc69$var$TAG_SCHEME_VERSION = 2;
function $c8928b7419a5cc69$var$interpolateTagScheme(tagSchema, context) {
    const dimensions = Array.from($c8928b7419a5cc69$var$getDimensionsFromTagScheme(tagSchema));
    return dimensions.reduce((interpolatedTagScheme, dimension)=>{
        if (context.hasOwnProperty(dimension)) return interpolatedTagScheme.replace(new RegExp(`\\$${dimension}\\$`, "g"), context[dimension]);
        else {
            const contextAsJson = $c8928b7419a5cc69$var$toPrettyJson(context);
            throw new Error(`Bad variable "${dimension}" found enclosed in '$', so cannot infer
                     filename for artifact from tag schema: was expecting that
                     '${dimension}' would be a known dimension passed in context. This
                     is most likely a bug in Flight Deck. To help you debug, the Context
                     received was:\n"${contextAsJson}"\nOne of the keys in that object should
                     have been '${contextAsJson}'.`);
        }
    }, tagSchema);
}
module.exports.interpolateTagScheme = $c8928b7419a5cc69$var$interpolateTagScheme;
/**
 *
 * @param dimensions - the dimensions that this tag scheme needs to use
 *
 * @param supportedDimensionPrefixes - a map of those dimensions to
 * shortened versions (ie name to n)
 *
 *  @param effectiveContextDimension - maps dimensions down into dimensions supported
 *  by original context. NOTE:
 *
 *  There is only 1 correct implementation of this function, but
 *  it is not defined in this module because the most typesafe
 *  (least error prone) definition of this function requires referencing
 *  the specific dimension types (specific available dimensions), and
 *  we are intentionally keeping this module unaware of the specific
 *  dimensions to enable adding/changing dimensions easily in consumers
 *  which use this tags library. So therefore we define effectiveContextDimension
 *  outside of this package, but accept it as an argument. Note that in this
 *  package we redefine the meaning of common Flight Deck types (e.g.
 *  Dimension == string, rather than the specific subset of supported
 *  dimension strings), so when generateTagScheme is called then effectiveContextDimension
 *  needs to be cast (using `as`) in order to have the types
 *
 * @returns a generated schema
 */ function $c8928b7419a5cc69$var$generateTagScheme(dimensions, supportedDimensionPrefixes, effectiveContextDimension = (d)=>d) {
    const effectiveDimensions = new Set([
        ...dimensions
    ].map(effectiveContextDimension));
    for (const dimensionToInclude of effectiveDimensions){
        if (!supportedDimensionPrefixes.has(effectiveContextDimension(dimensionToInclude))) throw new Error([
            `Building a tag scheme failed! The dimension '${dimensionToInclude}' is not `,
            `recognized as a dimension (known dimensions are ${[
                ...supportedDimensionPrefixes.keys()
            ].join(", ")}!`
        ].join(" "));
    }
    // pad the version number to 3 digits (e.g. 001, 002, 003, etc) so that artifacts will sort by
    // version when sorted lexicographically (helpful for debugging)
    const padded_version = $c8928b7419a5cc69$var$TAG_SCHEME_VERSION.toString().padStart(3, "0");
    // IMPORTANT! Update {@link TAG_SCHEME_VERSION} if you change the tagging scheme logic!
    let tagScheme = `v${padded_version}`;
    for (const entry of supportedDimensionPrefixes.entries()){
        const [dimension, prefix] = entry;
        if (effectiveDimensions.has(dimension)) // We avoid using `:` or `/` or `\` as separator characters because these characters have
        // meaning on certain filesystems that make them painful to work with; we also don't use
        // ` ` or similar because whitespace characters are the default values used by shells
        // to word-split, which makes scripting harder (see https://bash.cyberciti.biz/guide/$IFS ).
        tagScheme += `-${prefix}_$${dimension}$`;
    }
    return tagScheme;
}
module.exports.generateTagScheme = $c8928b7419a5cc69$var$generateTagScheme;
// Important! Context: Front end client will be using old version of tags.When we make changes to this function
// we need to be extra cautious that it will be compatible with older versions
// Step -1
// we have test in frontend package :integration-test/frontend/frontend-fetch.spec.ts to test oldest front end client
// make sure we add sample artifact to the test which will test newest functionality against oldest client
// Step-2
// Update manifest version across flight-deck
// step-3
// update manifest version in poop-deck repo
// step-4
// communicate with external customers and #flight-deck channel announcements
// step-5
// Update oldest supported version in integration-test/frontend/frontend-fetch.spec.ts and the test will be passed
function $c8928b7419a5cc69$var$getDimensionsFromTagScheme(tagSchema) {
    // regex to get all dimensions
    // for a dimension:
    // \$ means the expression starts with a `$` sign
    // [A-Za-z]+ means dollar sign is followed by one or more alphabetical chars
    // \$ means the dimension ends with a `$` sign
    const dimensionsFormat = /\$([A-Za-z]+)\$/g;
    // regex to ensure that we have the right format
    // for the dimension format:
    // ^v means it must start with a v
    // \d{3} means it is followed by three digits
    // ?: tries to match the expression without capturing the group
    // -[a-z]_ means expression starts with `-<single lowercase a-z char>_`
    // (\$[A-Za-z]+\$) defines that a dimension is in the format `<one or more alphabetical chars>` and this group is captured.
    // + means we could have one or more dimensions.
    // $ means we must end at the end of a dimension.
    const tagSchemeFormat = /^v\d{3}(?:-[a-z]_(\$[A-Za-z]+\$))+$/;
    const isValidTag = tagSchemeFormat.test(tagSchema);
    if (!isValidTag) throw new Error(`The provided tag scheme: "${tagSchema}" is invalid.
                Tag schemes must have the following format:
                v<3 digit number>-<letter>$<dimension_name>$
                where -<letter>$<dimension_name>$ can be repeated
                and all characters of <letter> and <dimension_name>
                must be alphabetical characters
                e.g "v001-n_$name$-d_$dimension$" is a valid tag scheme`);
    const allDim = Array.from(tagSchema.matchAll(dimensionsFormat));
    try {
        // Grab the second element of each element in matches
        const captures = allDim.map(([_, capture])=>capture);
        const dimensions = new Set(captures);
        return dimensions;
    } catch (e) {
        throw new Error(`Could not capture dimensions. Expected dimension format to look like 
             ${dimensionsFormat}`);
    }
}
module.exports.getDimensionsFromTagScheme = $c8928b7419a5cc69$var$getDimensionsFromTagScheme;
function $c8928b7419a5cc69$var$getDataTagForManifest(artifactName, manifestVersion, artifactVersion) {
    return artifactVersion === undefined ? `${artifactName}_manifest_${manifestVersion}` : `${artifactName}_${artifactVersion}_manifest_${manifestVersion}`;
}
module.exports.getDataTagForManifest = $c8928b7419a5cc69$var$getDataTagForManifest;
function $c8928b7419a5cc69$var$getVersionMetadataTag(version) {
    return version ? `version_metadata_${version}` : "version_metadata";
}
module.exports.getVersionMetadataTag = $c8928b7419a5cc69$var$getVersionMetadataTag;
function $c8928b7419a5cc69$var$toPrettyJson(obj) {
    return JSON.stringify(obj, null, 2);
}

});

parcelRegister("9te7V", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.getDimensionContext = void 0;
/**
 * Resolves a record of Dimensions and their values based on the manifest
 * and the user specified dimensions values.
 *
 * If a dimension is not specified by the user, then the fallback value
 * will be used as the value for that dimension. If the fallback value
 * does not exist in this case, then a "missing-dimension-specification"
 * result will be reported.
 *
 * If a dimension value specified by the user is not part of the list
 * of supported values, then the dimension value will be the fallback
 * value defined. If a fallback value does not exist for that dimension,
 * then an "unsupported-value-specified-for-supported-dimension" result
 * will be reported.
 *
 * Otherwise, a "success" result will be reported on a valid context
 * resolution.
 *
 * @param specifiedDimensions the dimensions the user specified
 * @param manifest the manifest to validate and fallback user specifications
 * @returns a record of Dimensions and their valid values, or an error type
 *      if a record of valid values could not be derived from the user input
 */ function $6e51c7c28a67d567$var$getDimensionContext(specifiedDimensions, manifest) {
    var dimensionToValues = {};
    for(var dimension in manifest.dimensions){
        var manifestDimensionSpecs = manifest.dimensions[dimension];
        var dimensionValue = specifiedDimensions[dimension];
        var fallback = manifestDimensionSpecs.fallback;
        if (dimensionValue === undefined) {
            if (fallback === undefined) return {
                type: "missing-dimension-specification"
            };
            else dimensionValue = fallback;
        }
        if (!manifestDimensionSpecs.supported.includes(dimensionValue)) {
            if (fallback === undefined) return {
                type: "unsupported-value-specified-for-supported-dimension"
            };
            else dimensionValue = fallback;
        }
        dimensionToValues[dimension] = dimensionValue;
    }
    return {
        type: "success",
        dimensionContext: dimensionToValues
    };
}
module.exports.getDimensionContext = $6e51c7c28a67d567$var$getDimensionContext;

});

parcelRegister("9P145", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.assertUnreachable = void 0;
function $7269b3f523ad10e5$var$assertUnreachable(_x) {
    throw new Error("This function should never be called. This is for yielding compile errors on non-exhaustive case checking.");
}
module.exports.assertUnreachable = $7269b3f523ad10e5$var$assertUnreachable;

});

parcelRegister("3evgk", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.toPrettyJson = module.exports.toJson = void 0;
function $25aaedf68a816fe7$var$toJson(buffer) {
    return JSON.parse(buffer.toString());
}
module.exports.toJson = $25aaedf68a816fe7$var$toJson;
function $25aaedf68a816fe7$var$toPrettyJson(obj) {
    return JSON.stringify(obj, null, 2);
}
module.exports.toPrettyJson = $25aaedf68a816fe7$var$toPrettyJson;

});


parcelRegister("8Xjp5", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.parseArtifactManifest = void 0;

var $4DuZk = parcelRequire("4DuZk");
function $6852e290d659d0bd$var$parseMetricTags(metricTags) {
    var unparsedMetricTags = (0, $4DuZk.parseUnknownObject)(metricTags);
    var parsedMetricTags = {};
    for(var _i = 0, _a = Object.keys(unparsedMetricTags); _i < _a.length; _i++){
        var key = _a[_i];
        var tag = (0, $4DuZk.parseString)(unparsedMetricTags[key]);
        parsedMetricTags[key] = tag;
    }
    return parsedMetricTags;
}
function $6852e290d659d0bd$var$parsePublishMetadata(publishMetadata) {
    var unparsedPublishMetadata = (0, $4DuZk.parseUnknownObject)(publishMetadata);
    var metricTags = "metricTags" in unparsedPublishMetadata ? $6852e290d659d0bd$var$parseMetricTags(unparsedPublishMetadata.metricTags) : undefined;
    return {
        metricTags: metricTags
    };
}
function $6852e290d659d0bd$var$parseDimensions(dimensions) {
    var unparsedDimensions = (0, $4DuZk.parseUnknownObject)(dimensions);
    var supported = (0, $4DuZk.parseArray)(unparsedDimensions.supported).map($4DuZk.parseString);
    var fallback = (0, $4DuZk.parseUndefinedOr)($4DuZk.parseString, unparsedDimensions.fallback);
    return {
        fallback: fallback,
        supported: supported
    };
}
function $6852e290d659d0bd$var$parseDimensionsRecord(dimensionRecord) {
    var parsedDimensionRecord = {};
    var unparsedDimensionRecord = (0, $4DuZk.parseUnknownObject)(dimensionRecord);
    for(var _i = 0, _a = Object.keys(unparsedDimensionRecord); _i < _a.length; _i++){
        var key = _a[_i];
        var dimensionsSpec = $6852e290d659d0bd$var$parseDimensions(unparsedDimensionRecord[key]);
        parsedDimensionRecord[key] = dimensionsSpec;
    }
    return parsedDimensionRecord;
}
function $6852e290d659d0bd$var$parseArtifactManifest(potentialArtifactManifest) {
    var unparsedArtifactManifest = (0, $4DuZk.parseUnknownObject)(potentialArtifactManifest);
    var name = (0, $4DuZk.parseString)(unparsedArtifactManifest.name);
    var tagScheme = (0, $4DuZk.parseString)(unparsedArtifactManifest.tagScheme);
    var frontend = (0, $4DuZk.parseUndefinedOr)($4DuZk.parseBoolean, unparsedArtifactManifest.frontend);
    var dimensions = $6852e290d659d0bd$var$parseDimensionsRecord(unparsedArtifactManifest.dimensions);
    var publishMetadata = $6852e290d659d0bd$var$parsePublishMetadata(unparsedArtifactManifest.publishMetadata);
    return {
        name: name,
        frontend: frontend,
        tagScheme: tagScheme,
        dimensions: dimensions,
        publishMetadata: publishMetadata
    };
}
module.exports.parseArtifactManifest = $6852e290d659d0bd$var$parseArtifactManifest;

});
parcelRegister("4DuZk", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.parseUndefinedOr = module.exports.parseUnknownObject = module.exports.parseBoolean = module.exports.parseArray = module.exports.parseString = void 0;
function $3602d78656005db6$var$parseString(string) {
    if (typeof string === "string") return string;
    throw new Error("Couldn't parse String");
}
module.exports.parseString = $3602d78656005db6$var$parseString;
function $3602d78656005db6$var$parseArray(array) {
    if (Array.isArray(array)) return array;
    throw new Error("Couldn't parse List or Undefined");
}
module.exports.parseArray = $3602d78656005db6$var$parseArray;
function $3602d78656005db6$var$parseBoolean(boolean) {
    if (typeof boolean === "boolean") return boolean;
    throw new Error("Couldn't parse Boolean or undefined");
}
module.exports.parseBoolean = $3602d78656005db6$var$parseBoolean;
function $3602d78656005db6$var$parseUnknownObject(object) {
    if (typeof object === "object") return object;
    throw new Error("Couldn't parse object");
}
module.exports.parseUnknownObject = $3602d78656005db6$var$parseUnknownObject;
function $3602d78656005db6$var$parseUndefinedOr(parse, thing) {
    if (typeof thing === "undefined") return thing;
    else return parse(thing);
}
module.exports.parseUndefinedOr = $3602d78656005db6$var$parseUndefinedOr;

});


parcelRegister("1NPzc", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.parseVersionMetadata = void 0;

var $4DuZk = parcelRequire("4DuZk");
function $15025e265438bcca$var$parseVersionMetadata(possiblyVersionMetadata) {
    var unknownObject = (0, $4DuZk.parseUnknownObject)(possiblyVersionMetadata);
    var version = (0, $4DuZk.parseString)(unknownObject.version);
    var publishTime = new Date((0, $4DuZk.parseString)(unknownObject.publishTime));
    var sidecarImageDigestVersion = (0, $4DuZk.parseString)(unknownObject.sidecarImageDigestVersion);
    return {
        version: version,
        publishTime: publishTime,
        sidecarImageDigestVersion: sidecarImageDigestVersion
    };
}
module.exports.parseVersionMetadata = $15025e265438bcca$var$parseVersionMetadata;

});

parcelRegister("5LTws", function(module, exports) {
"use strict";
var $433c69239a917447$var$__spreadArray = module.exports && module.exports.__spreadArray || function(to, from, pack) {
    if (pack || arguments.length === 2) {
        for(var i = 0, l = from.length, ar; i < l; i++)if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.checkManifest = void 0;
/**
 * @param manifest manifest retrieved from data source
 * @param request request used to retrieve manifest (ie the artifact name and version specified)
 * @returns the manifest, but now it is guaranteed that the manifest name is the same as the requested name,
 * the version is the same as the requested version (if one is requested) and the version dimension (if it exists)
 * specifies exactly one version
 */ function $433c69239a917447$var$checkManifest(manifest, request) {
    if (manifest.name !== request.name) return {
        key: "mismatched-manifest-name"
    };
    var manifestVersionDimension = manifest.dimensions.version;
    if (request.version) {
        var manifestVersions = manifestVersionDimension ? $433c69239a917447$var$__spreadArray([
            manifestVersionDimension === null || manifestVersionDimension === void 0 ? void 0 : manifestVersionDimension.fallback
        ], manifestVersionDimension === null || manifestVersionDimension === void 0 ? void 0 : manifestVersionDimension.supported, true).filter(function(s) {
            return !!s;
        }) : [];
        var allVersionsMatch = manifestVersions.every(function(v) {
            return v === request.version;
        });
        if (!allVersionsMatch || manifestVersions.length === 0) return {
            key: "mismatched-manifest-version"
        };
    }
    return {
        key: "success"
    };
}
module.exports.checkManifest = $433c69239a917447$var$checkManifest;

});

parcelRegister("6FHvZ", function(module, exports) {
"use strict";
var $4db8538ddb439aee$var$__awaiter = module.exports && module.exports.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var $4db8538ddb439aee$var$__generator = module.exports && module.exports.__generator || function(thisArg, body) {
    var _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    }, f, y, t, g;
    return g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(g && (g = 0, op[0] && (_ = 0)), _)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.ConfigRegistryDataSource = void 0;

var $hdDPm = parcelRequire("hdDPm");

var $auuB0 = parcelRequire("auuB0");

var $8Xjp5 = parcelRequire("8Xjp5");

var $1NPzc = parcelRequire("1NPzc");
var $4db8538ddb439aee$var$ConfigRegistryDataSource = /** @class */ function() {
    function ConfigRegistryDataSource(manifestVersion, configRegistryHttpClient) {
        this.manifestVersion = manifestVersion;
        this.configRegistryHttpClient = configRegistryHttpClient;
    }
    ConfigRegistryDataSource.prototype.getManifest = function(artifactName, artifactVersion) {
        return $4db8538ddb439aee$var$__awaiter(this, void 0, void 0, function() {
            var tag, configRegistryResponse, e_1;
            return $4db8538ddb439aee$var$__generator(this, function(_a) {
                switch(_a.label){
                    case 0:
                        tag = (0, $hdDPm.getDataTagForManifest)(artifactName, this.manifestVersion, artifactVersion);
                        _a.label = 1;
                    case 1:
                        _a.trys.push([
                            1,
                            3,
                            ,
                            4
                        ]);
                        return [
                            4 /*yield*/ ,
                            this.configRegistryHttpClient.getBlob(tag)
                        ];
                    case 2:
                        configRegistryResponse = _a.sent();
                        return [
                            2 /*return*/ ,
                            configRegistryResponse.leftMap(function(e) {
                                return e;
                            }).map($8Xjp5.parseArtifactManifest)
                        ];
                    case 3:
                        e_1 = _a.sent();
                        return [
                            2 /*return*/ ,
                            $auuB0.Either.left({
                                key: "config-registry-error",
                                error: e_1
                            })
                        ];
                    case 4:
                        return [
                            2 /*return*/ 
                        ];
                }
            });
        });
    };
    ConfigRegistryDataSource.prototype.getArtifact = function(_artifactName, tag) {
        return $4db8538ddb439aee$var$__awaiter(this, void 0, void 0, function() {
            return $4db8538ddb439aee$var$__generator(this, function(_a) {
                switch(_a.label){
                    case 0:
                        return [
                            4 /*yield*/ ,
                            this.configRegistryHttpClient.getBlob(tag)
                        ];
                    case 1:
                        return [
                            2 /*return*/ ,
                            _a.sent()
                        ];
                }
            });
        });
    };
    ConfigRegistryDataSource.prototype.getLatestVersionMetadata = function() {
        return $4db8538ddb439aee$var$__awaiter(this, void 0, void 0, function() {
            var dataTag, configRegistryResponse;
            return $4db8538ddb439aee$var$__generator(this, function(_a) {
                switch(_a.label){
                    case 0:
                        dataTag = (0, $hdDPm.getVersionMetadataTag)();
                        return [
                            4 /*yield*/ ,
                            this.configRegistryHttpClient.getBlob(dataTag)
                        ];
                    case 1:
                        configRegistryResponse = _a.sent();
                        return [
                            2 /*return*/ ,
                            configRegistryResponse.bimap(function(error) {
                                return error;
                            }, function(response) {
                                return (0, $1NPzc.parseVersionMetadata)(response);
                            })
                        ];
                }
            });
        });
    };
    return ConfigRegistryDataSource;
}();
module.exports.ConfigRegistryDataSource = $4db8538ddb439aee$var$ConfigRegistryDataSource;

});

parcelRegister("3ijEk", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.Versions = module.exports.BaseUrls = void 0;
var $26624b831163931e$var$BaseUrls = /** @class */ function() {
    function BaseUrls() {}
    BaseUrls.ConfigRegistryProd = "https://config-registry.prod.atl-paas.net";
    return BaseUrls;
}();
module.exports.BaseUrls = $26624b831163931e$var$BaseUrls;
var $26624b831163931e$var$Versions = /** @class */ function() {
    function Versions() {}
    Versions.ManifestVersion = "v1";
    return Versions;
}();
module.exports.Versions = $26624b831163931e$var$Versions;

});


parcelRegister("3TdLx", function(module, exports) {

$parcel$export(module.exports, "BifrostDataSource", () => $2d512fbe779401ec$export$2cb8d79200775058);

var $6l8hg = parcelRequire("6l8hg");

var $hdDPm = parcelRequire("hdDPm");
class $2d512fbe779401ec$export$2cb8d79200775058 {
    constructor(bifrostClient, manifestVersion){
        this.bifrostClient = bifrostClient;
        this.manifestVersion = manifestVersion;
    }
    async getLatestVersionMetadata() {
        const tag = (0, $hdDPm.getVersionMetadataTag)();
        const bifrostResponse = await this.bifrostClient.getBlob(`${tag}.json`);
        return bifrostResponse.fold((error)=>{
            return (0, $6l8hg.Either).left(error);
        }, (response)=>{
            try {
                const parsedVersionMetadata = (0, $6l8hg.parseVersionMetadata)(response);
                return (0, $6l8hg.Either).right(parsedVersionMetadata);
            } catch (e) {
                const error = {
                    key: "invalid-version-metadata"
                };
                return (0, $6l8hg.Either).left(error);
            }
        });
    }
    async getManifest(artifactName, artifactVersion) {
        const manifestTag = (0, $hdDPm.getDataTagForManifest)(artifactName, this.manifestVersion, artifactVersion);
        const bifrostResponse = await this.bifrostClient.getBlob(`${manifestTag}.json`, artifactName);
        return bifrostResponse.fold((error)=>{
            return (0, $6l8hg.Either).left(error);
        }, (response)=>{
            try {
                const parsedArtifact = (0, $6l8hg.parseArtifactManifest)(response);
                return (0, $6l8hg.Either).right(parsedArtifact);
            } catch (e) {
                const error = {
                    key: "invalid-manifest"
                };
                return (0, $6l8hg.Either).left(error);
            }
        });
    }
    async getArtifact(artifactName, tag) {
        return this.bifrostClient.getBlob(`${tag}.json`, artifactName);
    }
}

});

parcelRegister("3Oidj", function(module, exports) {

$parcel$export(module.exports, "BifrostHttpClientImpl", () => $2c642b791ff52615$export$45c6d12ca9c14f83);

var $6l8hg = parcelRequire("6l8hg");
function $2c642b791ff52615$export$f654b28f82155665(env, perimeter) {
    if (perimeter === "commercial") switch(env){
        case "adev":
        case "ddev":
        case "pdev":
        case "stg":
            return "https://fd-config-bifrost.stg-east.frontend.public.atl-paas.net";
        case "prod":
            return "https://fd-config-bifrost.prod-east.frontend.public.atl-paas.net";
    }
    else if (perimeter === "fedramp-moderate") switch(env){
        case "stg":
            return "https://fd-config-bifrost.stg.frontend.cdn.atlassian-us-gov-mod.com";
        case "prod":
            return "https://fd-config-bifrost.frontend.cdn.atlassian-us-gov-mod.com";
    }
    return "https://fd-config-bifrost.prod-east.frontend.public.atl-paas.net";
}
class $2c642b791ff52615$export$45c6d12ca9c14f83 {
    constructor(env, perimeter){
        this.baseUrl = $2c642b791ff52615$export$f654b28f82155665(env, perimeter);
    }
    async getBlob(tag) {
        const endpoint = `${this.baseUrl}/assets/${tag}`;
        return new Promise((resolve)=>fetch(endpoint).then((response)=>{
                if (!response.ok) resolve((0, $6l8hg.Either).left({
                    key: "unexpected-response-code",
                    httpResponseCode: response.status,
                    httpResponseStatusText: response.statusText
                }));
                response.json().then((json)=>resolve((0, $6l8hg.Either).right(json)));
            }).catch((error)=>resolve((0, $6l8hg.Either).left({
                    key: "failed-fetch",
                    error: "message" in error ? error.message : "unknown error"
                }))));
    }
}

});

parcelRegister("d5LIN", function(module, exports) {

$parcel$export(module.exports, "ConfigClient", () => $9880c2778e17f5cd$export$8489e2f039bfcc4c);

var $eHiP8 = parcelRequire("eHiP8");

var $6l8hg = parcelRequire("6l8hg");

var $4gZ5I = parcelRequire("4gZ5I");
function $9880c2778e17f5cd$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $9880c2778e17f5cd$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $9880c2778e17f5cd$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, $eHiP8.default)(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $9880c2778e17f5cd$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
class $9880c2778e17f5cd$export$8489e2f039bfcc4c {
    constructor(dataSource, dataSourceName, fetchArtifactExperience, versionMetadataExperience){
        this.fetchArtifactExperience = fetchArtifactExperience;
        this.versionMetadataExperience = versionMetadataExperience;
        this.dataSource = new (0, $4gZ5I.ExperienceDataSourceWrapper)(dataSource, this.fetchArtifactExperience, this.versionMetadataExperience);
        this.dataSourceName = dataSourceName;
    }
    async getArtifact(artifactName, dimensions) {
        this.fetchArtifactExperience.addMetadata(dimensions);
        this.fetchArtifactExperience.start();
        const specifiedDimensions = $9880c2778e17f5cd$var$_objectSpread($9880c2778e17f5cd$var$_objectSpread({}, dimensions), {}, {
            name: artifactName
        });
        const artifact = await (0, $6l8hg.getArtifactFromSource)(this.dataSource, specifiedDimensions, "backend").catch((e)=>({
                type: "artifact-fetch-error",
                publishMetadata: {},
                error: {
                    key: "unexpected-error",
                    error: e
                }
            }));
        if (artifact.type === "success") this.fetchArtifactExperience.success();
        else {
            this.fetchArtifactExperience.addMetadata({
                errorType: artifact.type,
                error: "error" in artifact ? artifact.error.key : undefined
            });
            this.fetchArtifactExperience.failure();
        }
        return (0, $6l8hg.tryGetArtifactData)(artifact, this.dataSourceName);
    }
    async getLatestVersionMetadata() {
        this.versionMetadataExperience.start();
        const getVersionMetadataResult = await this.dataSource.getLatestVersionMetadata();
        return getVersionMetadataResult.fold((error)=>{
            this.versionMetadataExperience.addMetadata({
                error: error.key
            });
            this.versionMetadataExperience.failure();
            throw new Error(`Unable to get latest version metadata from ${this.dataSourceName} due to error: ${error.key}`);
        }, (data)=>{
            this.versionMetadataExperience.success();
            return data;
        });
    }
}

});
parcelRegister("4gZ5I", function(module, exports) {

$parcel$export(module.exports, "ExperienceDataSourceWrapper", () => $31c80b8146ec82d5$export$1cc944571619e6e8);
/**
 * Wraps a standard Datasource as defined by @atlassiansox/flight-deck-core && uses
 * the experience to mark when events happen.
 */ class $31c80b8146ec82d5$export$1cc944571619e6e8 {
    constructor(dataSource, artifactExperience, versionMetadataExperience){
        this.dataSource = dataSource;
        this.artifactExperience = artifactExperience;
        this.versionMetadataExperience = versionMetadataExperience;
    }
    getLatestVersionMetadata() {
        this.versionMetadataExperience.mark("start-fetch-metadata");
        const result = this.dataSource.getLatestVersionMetadata();
        this.versionMetadataExperience.mark("end-fetch-metadata");
        return result;
    }
    async getManifest(artifactName, artifactVersion) {
        this.artifactExperience.mark("start-fetch-artifact");
        const result = await this.dataSource.getManifest(artifactName, artifactVersion);
        result.leftMap((error)=>{
            this.artifactExperience.addMetadata({
                getManifestError: error
            });
            return error;
        });
        this.artifactExperience.mark("end-fetch-artifact");
        return result;
    }
    async getArtifact(artifactName, tag) {
        this.artifactExperience.mark("start-fetch-manifest");
        const result = await this.dataSource.getArtifact(artifactName, tag);
        result.leftMap((error)=>{
            this.artifactExperience.addMetadata({
                getArtifactError: error
            });
            return error;
        });
        this.artifactExperience.mark("end-fetch-manifest");
        return result;
    }
}

});


parcelRegister("95uqQ", function(module, exports) {

$parcel$export(module.exports, "getFlightDeckFetchExperience", () => $69dc2fdcb553c857$export$a3006f8f221c0a3b);
$parcel$export(module.exports, "getVersionMetadataFetchExperience", () => $69dc2fdcb553c857$export$c3ac7702bfd47c1b);
const $69dc2fdcb553c857$var$SAMPLING_RATE = 10;
class $69dc2fdcb553c857$var$UFOExperienceWrapper {
    constructor(experience){
        this.experience = experience;
    }
    start(startTime) {
        return this.experience.start(startTime);
    }
    success() {
        return this.experience.success();
    }
    failure() {
        return this.experience.failure();
    }
    addMetadata(data) {
        return this.experience.addMetadata(data);
    }
    mark(mark) {
        return this.experience.mark(mark);
    }
}
class $69dc2fdcb553c857$export$5e7536cf7bc56fee {
    start() {
        return Promise.resolve();
    }
    success() {
        return Promise.resolve(null);
    }
    failure() {
        return Promise.resolve(null);
    }
    mark() {
        return;
    }
    addMetadata() {
        return;
    }
}

async function $69dc2fdcb553c857$var$flightDeckSDKOperationExperience(id, timings, metadata) {
    try {
        // only emit metrics 1 in every 10 times a Flight Deck Configuration is fetched
        // to not flood Perf Portal with logs.
        if (Math.random() * 100 > $69dc2fdcb553c857$var$SAMPLING_RATE) return new $69dc2fdcb553c857$export$5e7536cf7bc56fee();
        const { UFOExperience: UFOExperience, ExperienceTypes: ExperienceTypes, ExperiencePerformanceTypes: ExperiencePerformanceTypes } = await (parcelRequire("3fucY"));
        const ufoExperience = new UFOExperience(id, {
            type: ExperienceTypes.Operation,
            performanceType: ExperiencePerformanceTypes.Custom,
            platform: {
                component: "flight-deck-client"
            },
            timings: timings
        });
        ufoExperience.addMetadata(metadata);
        return new $69dc2fdcb553c857$var$UFOExperienceWrapper(ufoExperience);
    } catch (_unused) {
        return new $69dc2fdcb553c857$export$5e7536cf7bc56fee();
    }
}
const $69dc2fdcb553c857$export$a3006f8f221c0a3b = ()=>$69dc2fdcb553c857$var$flightDeckSDKOperationExperience("fetch", [
        {
            key: "fetch-artifact",
            endMark: "end-fetch-artifact",
            startMark: "start-fetch-artifact"
        },
        {
            key: "fetch-manifest",
            endMark: "end-fetch-manifest",
            startMark: "start-fetch-manifest"
        }
    ], {});
const $69dc2fdcb553c857$export$c3ac7702bfd47c1b = ()=>$69dc2fdcb553c857$var$flightDeckSDKOperationExperience("fetch-version-metadata", [
        {
            key: "fetch-metadata",
            startMark: "start-fetch-metadata",
            endMark: "end-fetch-metadata"
        }
    ], {});

});
parcelRegister("3fucY", function(module, exports) {

let $25da34894d2180a6$var$load = (parcelRequire("28QjX"))(4);
module.exports = $25da34894d2180a6$var$load("zeQjY").then(()=>parcelRequire('8GXI8'));

});


parcelRegister("kJG1r", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.TargetedConfig = module.exports.parseConfigWithTargeting = void 0;

var $fiwxX = parcelRequire("fiwxX");
Object.defineProperty(module.exports, "parseConfigWithTargeting", {
    enumerable: true,
    get: function() {
        return $fiwxX.parseConfigWithTargeting;
    }
});

var $hTlW1 = parcelRequire("hTlW1");
Object.defineProperty(module.exports, "TargetedConfig", {
    enumerable: true,
    get: function() {
        return $hTlW1.TargetedConfig;
    }
});

});
parcelRegister("fiwxX", function(module, exports) {
"use strict";
var $b231c88986716fb9$var$__assign = module.exports && module.exports.__assign || function() {
    $b231c88986716fb9$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $b231c88986716fb9$var$__assign.apply(this, arguments);
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.parseConfigWithTargeting = void 0;

var $hTlW1 = parcelRequire("hTlW1");
/**
 * For a given configuration, return the same configuration back
 * with {@link TargetedConfig} substituted where applicable.
 *
 * So anywhere in the JSON that has the objects:
 * ```
 * {
 *   "defaultConfig": ...
 * }
 * ```
 *
 * OR
 *
 * ```
 * {
 *   "defaultConfig": ...
 *   "targeting": {
 *     "targets": [...]
 *     "targetedConfig": ...
 *   }
 * }
 * ```
 *
 * become an instance of {@link TargetedConfig}.
 *
 * @param config configuration that may contain unparsed {@link TargetedConfig}
 * @returns the same configuration with targeted config sub-objects transformed
 *     into {@link TargetedConfig}
 */ function $b231c88986716fb9$var$parseConfigWithTargeting(data) {
    // All "object" types will also need to have a null check because null is an "object", but an
    // invalid one for this use case.
    if (typeof data === "object") {
        if (Array.isArray(data)) return data.map(function(element) {
            return $b231c88986716fb9$var$parseConfigWithTargeting(element);
        });
        else if (data) {
            var parsedObject_1 = data;
            var keys = Object.keys(parsedObject_1);
            if (keys.length === 1 && parsedObject_1.defaultConfig) return new $hTlW1.TargetedConfig({
                defaultConfig: $b231c88986716fb9$var$parseConfigWithTargeting(parsedObject_1.defaultConfig)
            });
            else if (keys.length === 2 && parsedObject_1.defaultConfig && parsedObject_1.targeting) {
                var parseResult = $b231c88986716fb9$var$parseTargeting(parsedObject_1.targeting);
                if (parseResult.type === "match") return new $hTlW1.TargetedConfig({
                    targeting: parseResult.result,
                    defaultConfig: $b231c88986716fb9$var$parseConfigWithTargeting(parsedObject_1.defaultConfig)
                });
            }
            return keys.reduce(function(accObject, key) {
                var _a;
                return $b231c88986716fb9$var$__assign($b231c88986716fb9$var$__assign({}, accObject), (_a = {}, _a[key] = $b231c88986716fb9$var$parseConfigWithTargeting(parsedObject_1[key]), _a));
            }, {});
        } else return null;
    } else return data;
}
module.exports.parseConfigWithTargeting = $b231c88986716fb9$var$parseConfigWithTargeting;
function $b231c88986716fb9$var$parseTargeting(targeting) {
    if (typeof targeting === "object" && targeting && !Array.isArray(targeting)) {
        var targetingKeyValue = targeting;
        var targetingKeys = Object.keys(targetingKeyValue);
        if (targetingKeys.length == 2 && targetingKeyValue.targets && targetingKeyValue.targetedConfig) return {
            type: "match",
            result: {
                targets: $b231c88986716fb9$var$parseTargets(targetingKeyValue.targets),
                targetedConfig: $b231c88986716fb9$var$parseConfigWithTargeting(targetingKeyValue.targetedConfig)
            }
        };
    }
    return {
        type: "no-match"
    };
}
function $b231c88986716fb9$var$parseTargets(targets) {
    if (Array.isArray(targets)) return targets.map(function(target) {
        return {
            orgIds: $b231c88986716fb9$var$parseIdentifierList(target.orgIds),
            siteIds: $b231c88986716fb9$var$parseIdentifierList(target.siteIds),
            userIds: $b231c88986716fb9$var$parseIdentifierList(target.userIds)
        };
    });
    else throw new Error("The targets for Flight Deck targeted configuration must come in an array.");
}
function $b231c88986716fb9$var$parseIdentifierList(identifierList) {
    if (identifierList === undefined) return undefined;
    if (Array.isArray(identifierList)) return identifierList.map(function(id) {
        if (typeof id === "string") return id;
        else throw new Error("Identifiers for targets must be strings!");
    });
    else throw new Error("Identifier list must be an array!");
}

});
parcelRegister("hTlW1", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.TargetedConfig = void 0;
/**
 * Defines a part of the overall configuration that has different
 * values based on the intended target. The target is a specification
 * of a combination of site id, user id and org id.
 */ var $d068968b22fc3b5a$var$TargetedConfig = /** @class */ function() {
    function TargetedConfig(targetedConfigDefinition) {
        this.targetedConfigDefinition = targetedConfigDefinition;
    }
    /**
     * Determines whether to use the targeted configuration value or the default value
     * depending on whether the specified values match any of the target's rules.
     *
     * @param target the values to use to evaluate the config
     * @returns the {@link TargetingResult}, which would be the default value
     *     if the specified target did not match, or the targeted value if there
     *     was a match
     */ TargetedConfig.prototype.resolve = function(target) {
        var targeting = this.targetedConfigDefinition.targeting;
        if (targeting) {
            var targeted = targeting.targets.some(function(configuredTarget) {
                var criteria = [];
                if (configuredTarget.orgIds) criteria.push({
                    allowList: configuredTarget.orgIds,
                    identifier: target.orgId
                });
                if (configuredTarget.siteIds) criteria.push({
                    allowList: configuredTarget.siteIds,
                    identifier: target.siteId
                });
                if (configuredTarget.userIds) criteria.push({
                    allowList: configuredTarget.userIds,
                    identifier: target.userId
                });
                if (criteria.length === 0) return false;
                else return criteria.every(function(criteria) {
                    return $d068968b22fc3b5a$var$resolveForTargetCriteria(criteria);
                });
            });
            if (targeted) return {
                type: "targeted",
                value: targeting.targetedConfig
            };
        }
        return {
            type: "default",
            value: this.targetedConfigDefinition.defaultConfig
        };
    };
    return TargetedConfig;
}();
module.exports.TargetedConfig = $d068968b22fc3b5a$var$TargetedConfig;
function $d068968b22fc3b5a$var$resolveForTargetCriteria(criteria) {
    return !!criteria.identifier && criteria.allowList.includes(criteria.identifier);
}

});




parcelRegister("lKWnb", function(module, exports) {

$parcel$export(module.exports, "default", () => $fd6b2c7e02ec3fe7$export$2e2bcd8739ae039);
class $fd6b2c7e02ec3fe7$export$2e2bcd8739ae039 extends Error {
    constructor({ artifact: artifact, dimensions: dimensions, error: error }){
        super(error instanceof Error && error.message ? error.message : "Unknown Flight Deck SDK error");
        this.name = "FlightDeckSDKError";
        this.error = error;
        this.artifact = artifact;
        this.environmentType = dimensions === null || dimensions === void 0 ? void 0 : dimensions.environmentType;
        this.locale = dimensions === null || dimensions === void 0 ? void 0 : dimensions.locale;
    }
}
const $fd6b2c7e02ec3fe7$export$1d76d155060824c9 = (e)=>e instanceof $fd6b2c7e02ec3fe7$export$2e2bcd8739ae039;

});

parcelRegister("4r7nA", function(module, exports) {

$parcel$export(module.exports, "artifactKey", () => $33af6871e9658618$export$e3553dc63541d477);
const $33af6871e9658618$export$e3553dc63541d477 = (artifactName, dimensions)=>{
    return `${artifactName}${dimensions ? "_" + Object.keys(dimensions).sort().map((key)=>dimensions[key]).filter(Boolean).join("_") : ""}`;
};

});

parcelRegister("814TT", function(module, exports) {

$parcel$export(module.exports, "flightDeckClientExperience", () => $5d6237e1ec8a6bfc$export$1e3a41a51f6457c5);
$parcel$export(module.exports, "exceptionToMetadata", () => $5d6237e1ec8a6bfc$export$f33622abb5224195);

var $eHiP8 = parcelRequire("eHiP8");

var $atdLB = parcelRequire("atdLB");
var $duUGa = parcelRequire("duUGa");
function $5d6237e1ec8a6bfc$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $5d6237e1ec8a6bfc$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $5d6237e1ec8a6bfc$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, $eHiP8.default)(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $5d6237e1ec8a6bfc$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
const $5d6237e1ec8a6bfc$export$6061a1a9a61f2e21 = ()=>new (0, $duUGa.UFOExperience)("fetch", {
        type: (0, $atdLB.ExperienceTypes).Operation,
        performanceType: (0, $atdLB.ExperiencePerformanceTypes).Custom,
        platform: {
            component: "flight-deck-client"
        }
    });
const $5d6237e1ec8a6bfc$export$1e3a41a51f6457c5 = ()=>new (0, $duUGa.UFOExperience)("retrieve-artifact", {
        type: (0, $atdLB.ExperienceTypes).Operation,
        performanceType: (0, $atdLB.ExperiencePerformanceTypes).Custom,
        platform: {
            component: "flight-deck-client"
        }
    });
const $5d6237e1ec8a6bfc$export$f33622abb5224195 = (e)=>{
    return e instanceof Error ? $5d6237e1ec8a6bfc$var$_objectSpread($5d6237e1ec8a6bfc$var$_objectSpread({}, e), {}, {
        cause: undefined
    }) : "unknown";
};

});



parcelRegister("3LJ9C", function(module, exports) {

$parcel$export(module.exports, "FD_CLIENT_FETCH_PROPS", () => $974e1d856d308c8e$export$c270c412a04ff3e6);
$parcel$export(module.exports, "default", () => $974e1d856d308c8e$export$2e2bcd8739ae039);

var $6HV40 = parcelRequire("6HV40");

var $4Zo3D = parcelRequire("4Zo3D");
const $974e1d856d308c8e$var$RECENT_WORK_ARTIFACT = 'recent-work-service';
const $974e1d856d308c8e$var$FD_ENVIRONMENT = 'prod';
const $974e1d856d308c8e$export$c270c412a04ff3e6 = {
    name: $974e1d856d308c8e$var$RECENT_WORK_ARTIFACT,
    dimensions: {
        environmentType: $974e1d856d308c8e$var$FD_ENVIRONMENT
    }
};
class $974e1d856d308c8e$export$2e2bcd8739ae039 {
    constructor(handlers, product, artifactFetch){
        this.fetchConfig = async ()=>{
            const artifact = await this.fetchArtifact();
            const { queryFragments: fragments, hydrators: hydrators } = artifact;
            return {
                fragments: fragments,
                hydrators: hydrators
            };
        };
        this.flightDeck = new (0, $6HV40.default)(product || 'recent-work-client', {
            handlers: handlers
        }, [
            {
                name: 'recent-work-service',
                dimensions: {
                    environmentType: $974e1d856d308c8e$var$FD_ENVIRONMENT
                },
                value: (0, $4Zo3D.default)
            }
        ]);
        this.artifactFetch = artifactFetch;
    }
    async fetchArtifact() {
        if (this.artifactFetch) return this.artifactFetch();
        return this.flightDeck.fetchConfigFromFlightDeck($974e1d856d308c8e$export$c270c412a04ff3e6, // Retries are for the background refresh, so not too aggressive
        {
            intervalsMS: [
                100,
                500
            ]
        });
    }
}

});
parcelRegister("4Zo3D", function(module, exports) {

$parcel$export(module.exports, "default", () => $cc65f19f715aa294$export$2e2bcd8739ae039);
var $cc65f19f715aa294$export$2e2bcd8739ae039 = {
    localization: {
        eventTypes: {
            commented: {
                absolute: 'You commented on {absoluteTime}',
                relative: 'You commented {relativeTime}',
                standalone: 'You commented',
                multiAbsolute: 'Commented on {absoluteTime}',
                multiRelative: 'Commented {relativeTime}',
                multiStandalone: 'Commented'
            },
            created: {
                absolute: 'You created on {absoluteTime}',
                relative: 'You created {relativeTime}',
                standalone: 'You created',
                multiAbsolute: 'Created on {absoluteTime}',
                multiRelative: 'Created {relativeTime}',
                multiStandalone: 'Created'
            },
            edited: {
                absolute: 'You edited on {absoluteTime}',
                relative: 'You edited {relativeTime}',
                standalone: 'You edited',
                multiAbsolute: 'Edited on {absoluteTime}',
                multiRelative: 'Edited {relativeTime}',
                multiStandalone: 'Edited'
            },
            published: {
                absolute: 'You published on {absoluteTime}',
                relative: 'You published {relativeTime}',
                standalone: 'You published',
                multiAbsolute: 'Published on {absoluteTime}',
                multiRelative: 'Published {relativeTime}',
                multiStandalone: 'Published'
            },
            updated: {
                absolute: 'You updated on {absoluteTime}',
                relative: 'You updated {relativeTime}',
                standalone: 'You updated',
                multiAbsolute: 'Updated on {absoluteTime}',
                multiRelative: 'Updated {relativeTime}',
                multiStandalone: 'Updated'
            },
            viewed: {
                absolute: 'You viewed on {absoluteTime}',
                relative: 'You viewed {relativeTime}',
                standalone: 'You viewed',
                multiAbsolute: 'Viewed on {absoluteTime}',
                multiRelative: 'Viewed {relativeTime}',
                multiStandalone: 'Viewed'
            }
        }
    },
    hydrators: {
        TownsquareGoal: {
            hydratorPaths: {
                id: [
                    'id'
                ],
                key: [
                    'key'
                ],
                name: [
                    'name'
                ],
                url: [
                    'url'
                ],
                icon: [
                    'iconData'
                ]
            }
        },
        TownsquareProject: {
            hydratorPaths: {
                id: [
                    'id'
                ],
                key: [
                    'key'
                ],
                name: [
                    'name'
                ],
                url: [
                    'url'
                ],
                icon: [
                    'iconData'
                ]
            }
        },
        TownsquareComment: {
            hydratorPaths: {
                id: [
                    'id'
                ],
                key: [
                    'container.key'
                ],
                name: [
                    'container.name'
                ],
                url: [
                    'container.url'
                ],
                icon: [
                    'container.iconData'
                ],
                deduplicateId: [
                    'container.id'
                ]
            }
        },
        ConfluencePage: {
            hydratorPaths: {
                id: [
                    'id'
                ],
                name: [
                    'title'
                ],
                localResourceId: [
                    'pageId'
                ],
                subtype: [
                    'subtype'
                ],
                url: [
                    'links.base',
                    'links.webUi'
                ],
                containers: [
                    'space.name'
                ]
            },
            staticFallbacks: {
                icon: 'https://fd-assets.prod.atl-paas.net/image/misc-icons/confluence/page.svg',
                confluenceLiveDocIcon: 'https://fd-assets.prod.atl-paas.net/image/misc-icons/confluence/live-doc.svg'
            }
        },
        ConfluenceBlogPost: {
            hydratorPaths: {
                id: [
                    'id'
                ],
                name: [
                    'title'
                ],
                localResourceId: [
                    'blogPostId'
                ],
                url: [
                    'links.base',
                    'links.webUi'
                ],
                containers: [
                    'space.name'
                ]
            },
            staticFallbacks: {
                icon: 'https://fd-assets.prod.atl-paas.net/image/misc-icons/confluence/blogpost.svg'
            }
        },
        ConfluenceComment: {
            hydratorPaths: {
                id: [
                    'id'
                ],
                name: [
                    'container.title'
                ],
                url: [
                    'links.base',
                    'links.webUi'
                ],
                containers: [
                    'container.space.name'
                ],
                deduplicateId: [
                    'container.id'
                ]
            },
            staticFallbacks: {
                icon: 'https://fd-assets.prod.atl-paas.net/image/misc-icons/confluence/page.svg',
                confluenceBlogIcon: 'https://fd-assets.prod.atl-paas.net/image/misc-icons/confluence/blogpost.svg',
                confluencePageIcon: 'https://fd-assets.prod.atl-paas.net/image/misc-icons/confluence/page.svg'
            }
        },
        ConfluenceFooterComment: {
            hydratorPaths: {
                id: [
                    'id'
                ],
                name: [
                    'container.title'
                ],
                url: [
                    'links.base',
                    'links.webUi'
                ],
                containers: [
                    'container.space.name'
                ],
                deduplicateId: [
                    'container.id'
                ]
            },
            staticFallbacks: {
                icon: 'https://fd-assets.prod.atl-paas.net/image/misc-icons/confluence/page.svg',
                confluenceBlogIcon: 'https://fd-assets.prod.atl-paas.net/image/misc-icons/confluence/blogpost.svg',
                confluencePageIcon: 'https://fd-assets.prod.atl-paas.net/image/misc-icons/confluence/page.svg'
            }
        },
        ConfluenceInlineComment: {
            hydratorPaths: {
                id: [
                    'id'
                ],
                name: [
                    'container.title'
                ],
                url: [
                    'links.base',
                    'links.webUi'
                ],
                containers: [
                    'container.space.name'
                ],
                deduplicateId: [
                    'container.id'
                ]
            },
            staticFallbacks: {
                icon: 'https://fd-assets.prod.atl-paas.net/image/misc-icons/confluence/page.svg',
                confluenceBlogIcon: 'https://fd-assets.prod.atl-paas.net/image/misc-icons/confluence/blogpost.svg',
                confluencePageIcon: 'https://fd-assets.prod.atl-paas.net/image/misc-icons/confluence/page.svg'
            }
        },
        JiraIssue: {
            hydratorPaths: {
                id: [
                    'id'
                ],
                name: [
                    'fieldsById.edges(node.fieldId: "summary").node.text'
                ],
                url: [
                    'webUrl'
                ],
                containers: [
                    'fieldsById.edges(node.fieldId: "project").node.project.name'
                ],
                icon: [
                    'fieldsById.edges(node.fieldId: "issuetype").node.issueType.avatar.xsmall'
                ],
                key: [
                    'key'
                ]
            }
        },
        JiraPlatformComment: {
            hydratorPaths: {
                id: [
                    'commentId'
                ],
                name: [
                    'issue.fieldsById.edges(node.fieldId: "summary").node.text'
                ],
                url: [
                    'webUrl'
                ],
                containers: [
                    'issue.fieldsById.edges(node.fieldId: "project").node.project.name'
                ],
                icon: [
                    'issue.fieldsById.edges(node.fieldId: "issuetype").node.issueType.avatar.xsmall'
                ],
                key: [
                    'issue.key'
                ],
                deduplicateId: [
                    'issue.id'
                ]
            }
        },
        JiraServiceManagementComment: {
            hydratorPaths: {
                id: [
                    'commentId'
                ],
                name: [
                    'issue.fieldsById.edges(node.fieldId: "summary").node.text'
                ],
                url: [
                    'webUrl'
                ],
                containers: [
                    'issue.fieldsById.edges(node.fieldId: "project").node.project.name'
                ],
                icon: [
                    'issue.fieldsById.edges(node.fieldId: "issuetype").node.issueType.avatar.xsmall'
                ],
                key: [
                    'issue.key'
                ],
                deduplicateId: [
                    'issue.id'
                ]
            }
        }
    },
    queryFragments: '\n\n  fragment townsquareGoal on TownsquareGoal {\n    id\n    key\n    name\n    url\n    iconData\n  }\n\n\n  fragment townsquareProject on TownsquareProject {\n    id\n    key\n    name\n    url\n    iconData\n  }\n\n\n  fragment townsquareComment on TownsquareComment {\n    id\n    url\n    container {\n      __typename\n      ...townsquareGoal\n      ...townsquareProject\n    }\n  }\n\n\n  fragment confluencePage on ConfluencePage {\n    id\n    title\n    pageId\n    links {\n      base\n      webUi\n    }\n    space {\n      name\n    }\n  }\n\n\n  fragment confluenceBlogPost on ConfluenceBlogPost {\n    id\n    title\n    blogPostId\n    links {\n      base\n      webUi\n    }\n    space {\n      name\n    }\n  }\n\n\n  fragment confluenceComment on ConfluenceComment {\n    id\n    links {\n      base\n      webUi\n    }\n    container {\n      __typename\n      ...confluenceBlogPost\n      ...confluencePage\n    }\n  }\n\n\n  fragment confluenceFooterComment on ConfluenceFooterComment {\n    id\n    links {\n      base\n      webUi\n    }\n    container {\n      __typename\n      ...confluenceBlogPost\n      ...confluencePage\n    }\n  }\n\n\n  fragment confluenceInlineComment on ConfluenceInlineComment {\n    id\n    links {\n      base\n      webUi\n    }\n    container {\n      __typename\n      ...confluenceBlogPost\n      ...confluencePage\n    }\n  }\n\n\nfragment jiraIssue on JiraIssue {\n  id\n  key\n  webUrl\n  fieldsById(ids: ["summary", "issuetype", "project"]) {\n    edges {\n      node {\n        __typename\n        fieldId\n        ...jiraSingleLineTextField\n        ...jiraIssueTypeField\n        ...jiraProjectField\n      }\n    }\n  }\n}\nfragment jiraSingleLineTextField on JiraSingleLineTextField {\n  text\n}\nfragment jiraIssueTypeField on JiraIssueTypeField {\n  issueType {\n    avatar {\n      xsmall\n    }\n  }\n}\nfragment jiraProjectField on JiraProjectField {\n  project {\n    name\n  }\n}\n\n\nfragment jiraPlatformComment on JiraPlatformComment {\n  commentId\n  webUrl\n  issue {\n    ...jiraIssue\n  }\n}\n\n\nfragment jiraServiceManagementComment on JiraServiceManagementComment {\n  commentId\n  webUrl\n  issue {\n    ...jiraIssue\n  }\n}\n\nfragment activityItemEdge on ActivityItemEdge {\n  cursor\n  node {\n    id\n    object {\n      id\n      type\n      product\n      subProduct\n      rootContainerId\n      contributors {\n        profile {\n          name\n          picture\n          accountId\n        }\n      }\n      data {\n        __typename\n\t...townsquareGoal\n\t...townsquareProject\n\t...townsquareComment\n\t...confluencePage\n\t...confluenceBlogPost\n\t...confluenceComment\n\t...confluenceFooterComment\n\t...confluenceInlineComment\n\t...jiraIssue\n\t...jiraPlatformComment\n\t...jiraServiceManagementComment\n      }\n    }\n    event {\n      id\n      timestamp\n      eventType\n      actor {\n        name\n        picture\n        accountId\n      }\n    }\n  }\n}\nfragment activityItemConnection on ActivityConnection {\n  edges {\n    ...activityItemEdge\n  }\n}\n\n'
};

});


parcelRegister("hoYXe", function(module, exports) {

$parcel$export(module.exports, "createActivityClient", () => $30574e88272de3f4$export$224367b01f71f2aa);

var $9yZqs = parcelRequire("9yZqs");

var $7trIV = parcelRequire("7trIV");
let $30574e88272de3f4$var$previousClientVersion;
const $30574e88272de3f4$export$224367b01f71f2aa = (version, product, logger, baseUrl, configFetch)=>{
    if ($30574e88272de3f4$var$previousClientVersion && $30574e88272de3f4$var$previousClientVersion !== version && logger?.captureWarning) logger.captureWarning(`ActivityClient version has changed, is this intentional?`);
    $30574e88272de3f4$var$previousClientVersion = version || 'v3';
    if (version === 'v2') return new (0, $9yZqs.ActivityClientV2)(product, baseUrl);
    return new (0, $7trIV.ActivityClientV3)(product, baseUrl, logger, configFetch);
};

});
parcelRegister("9yZqs", function(module, exports) {

$parcel$export(module.exports, "ActivityClientV2", () => $fff1f13eb7277558$export$330ab0047f2fb745);

var $cXq43 = parcelRequire("cXq43");

var $3Bknq = parcelRequire("3Bknq");

var $gVYg8 = parcelRequire("gVYg8");
class $fff1f13eb7277558$export$330ab0047f2fb745 extends (0, $3Bknq.ActivityClient) {
    constructor(product, baseUrl){
        super('v2', product, undefined, baseUrl), this.fetchActivities = async (retryMS, filters, activityQueries)=>{
            return (0, $cXq43.fetchActivitiesWithExperience)((experience)=>(0, $gVYg8.fetchActivitiesV2)({
                    experience: experience,
                    product: this.product,
                    retryMS: retryMS,
                    filters: filters,
                    activityQueries: activityQueries,
                    baseUrl: this.baseUrl
                }), 'v2');
        }, this.setProduct = (product)=>{
            this.product = product;
        };
    }
}

});
parcelRegister("cXq43", function(module, exports) {

$parcel$export(module.exports, "fetchActivitiesWithExperience", () => $12ea6ddffbcd8f57$export$4a906f16800734f3);

var $iFmUA = parcelRequire("iFmUA");

var $1b4ym = parcelRequire("1b4ym");

var $4cDQS = parcelRequire("4cDQS");
async function $12ea6ddffbcd8f57$export$4a906f16800734f3(fetchActivities, clientVersion) {
    const experience = clientVersion === 'v2' ? (0, $4cDQS.recentWorkClientExperienceV2)() : (0, $4cDQS.recentWorkClientExperienceV3)();
    try {
        experience.start();
        experience.addMetadata({
            clientVersion: clientVersion,
            packageName: $1b4ym.packageName,
            packageVersion: $1b4ym.packageVersion
        });
        const data = await fetchActivities(experience);
        experience.success();
        return data;
    } catch (e) {
        experience.failure({
            metadata: {
                error: $12ea6ddffbcd8f57$export$f33622abb5224195(e)
            }
        });
        throw e;
    }
}
const $12ea6ddffbcd8f57$export$f33622abb5224195 = (e)=>{
    if (e instanceof (0, $iFmUA.default)) return {
        ...e,
        xRequestId: e.xRequestId ?? undefined,
        cause: undefined
    };
    return e instanceof Error ? {
        ...e,
        cause: undefined
    } : 'unknown';
};

});
parcelRegister("iFmUA", function(module, exports) {

$parcel$export(module.exports, "default", () => $0aef1aaaf8d64fa1$export$2e2bcd8739ae039);
class $0aef1aaaf8d64fa1$export$2e2bcd8739ae039 extends Error {
    constructor({ message: message, statusCode: statusCode, path: path, method: method, xRequestId: xRequestId, headers: headers }){
        super();
        this.name = 'HttpError';
        this.message = message;
        const p = path.split('?')[0];
        this.path = /^[/-a-z]+$/i.test(p) ? p : '';
        this.method = method;
        this.statusCode = statusCode;
        this.xRequestId = xRequestId;
        // @ts-ignore - Property 'entries' does not exist on type 'Headers'.
        // This was added when enrolling `@atlassian/recent-work-client` into JFE local consumption
        this.headers = Array.from(headers.entries()).map((value, key)=>`${key}:${value}`).sort().join(',');
    }
}
const $0aef1aaaf8d64fa1$export$97b788730ba59845 = (e)=>e instanceof $0aef1aaaf8d64fa1$export$2e2bcd8739ae039;

});

parcelRegister("1b4ym", function(module, exports) {

$parcel$export(module.exports, "packageName", () => $42bb1ba4b82855c2$export$9345d7360ffe0722);
$parcel$export(module.exports, "packageVersion", () => $42bb1ba4b82855c2$export$91546b032799aa40);
const $42bb1ba4b82855c2$export$9345d7360ffe0722 = "platform-pkg";
const $42bb1ba4b82855c2$export$91546b032799aa40 = "0.0.0-use.local";

});

parcelRegister("4cDQS", function(module, exports) {

$parcel$export(module.exports, "recentWorkClientExperienceV2", () => $cf5f22aa1bc15bc4$export$d7769758f5eaa63b);
$parcel$export(module.exports, "recentWorkClientExperienceV3", () => $cf5f22aa1bc15bc4$export$9e32a4ed888f4717);

var $atdLB = parcelRequire("atdLB");
var $duUGa = parcelRequire("duUGa");
const $cf5f22aa1bc15bc4$var$keyToTiming = (key)=>({
        key: key,
        startMark: `${key}_start`,
        endMark: `${key}_end`
    });
const $cf5f22aa1bc15bc4$var$timings = [
    'FetchedActivities',
    'TransformedActivityItems',
    'GeneratedQueryWithFilters'
].map($cf5f22aa1bc15bc4$var$keyToTiming);
const $cf5f22aa1bc15bc4$export$d7769758f5eaa63b = ()=>{
    return new (0, $duUGa.UFOExperience)('client', {
        type: (0, $atdLB.ExperienceTypes).Load,
        performanceType: (0, $atdLB.ExperiencePerformanceTypes).Custom,
        platform: {
            component: 'recent-work'
        },
        timings: $cf5f22aa1bc15bc4$var$timings
    });
};
const $cf5f22aa1bc15bc4$export$9e32a4ed888f4717 = ()=>new (0, $duUGa.UFOExperience)('client-v3', {
        type: (0, $atdLB.ExperienceTypes).Load,
        performanceType: (0, $atdLB.ExperiencePerformanceTypes).Custom,
        platform: {
            component: 'recent-work'
        },
        timings: $cf5f22aa1bc15bc4$var$timings
    });

});


parcelRegister("3Bknq", function(module, exports) {

$parcel$export(module.exports, "ActivityClient", () => $d3363d88c8d5ff9b$export$157740f5433f3dbe);

var $3l0ly = parcelRequire("3l0ly");
class $d3363d88c8d5ff9b$export$157740f5433f3dbe {
    constructor(clientVersion, product, headers, baseUrl){
        this.product = 'unknown';
        this.baseUrl = (0, $3l0ly.GRAPHQL_GATEWAY_PATH);
        if (product) this.product = product;
        this.clientVersion = clientVersion;
        this.headers = headers ?? {};
        if (baseUrl) this.baseUrl = baseUrl;
    }
}

});
parcelRegister("3l0ly", function(module, exports) {

$parcel$export(module.exports, "GRAPHQL_GATEWAY_PATH", () => $4167449aedd1da1b$export$851c5df667ca24c8);
$parcel$export(module.exports, "WORKED_EVENT", () => $4167449aedd1da1b$export$eb4e9f525aef1cc3);
const $4167449aedd1da1b$export$851c5df667ca24c8 = '/gateway/api/graphql';
var $4167449aedd1da1b$export$d245b105c09339d8 = /*#__PURE__*/ function(VIEWED_EVENT) {
    VIEWED_EVENT["VIEWED"] = "viewed";
    return VIEWED_EVENT;
}({});
var $4167449aedd1da1b$export$eb4e9f525aef1cc3 = /*#__PURE__*/ function(WORKED_EVENT) {
    WORKED_EVENT["COMMENTED"] = "commented";
    WORKED_EVENT["CREATED"] = "created";
    WORKED_EVENT["EDITED"] = "edited";
    WORKED_EVENT["PUBLISHED"] = "published";
    WORKED_EVENT["UPDATED"] = "updated";
    return WORKED_EVENT;
}({});
var $4167449aedd1da1b$export$d02a56686be43f69 = /*#__PURE__*/ function(ActivityObjectType) {
    ActivityObjectType["BLOGPOST"] = "BLOGPOST";
    ActivityObjectType["COMMENT"] = "COMMENT";
    ActivityObjectType["ISSUE"] = "ISSUE";
    ActivityObjectType["PAGE"] = "PAGE";
    ActivityObjectType["PROJECT"] = "PROJECT";
    ActivityObjectType["SITE"] = "SITE";
    ActivityObjectType["SPACE"] = "SPACE";
    ActivityObjectType["TASK"] = "TASK";
    return ActivityObjectType;
}({});

});


parcelRegister("gVYg8", function(module, exports) {

$parcel$export(module.exports, "fetchActivitiesV2", () => $9bc87a88656ac7d1$export$750ec7816fdd2f9e);

var $f3gfD = parcelRequire("f3gfD");

var $e35Gx = parcelRequire("e35Gx");

var $aHtVh = parcelRequire("aHtVh");

var $lB6CZ = parcelRequire("lB6CZ");
const $9bc87a88656ac7d1$var$ACTIVITIES_LIMIT = 50;
// typescript guard for validating the activities connection type
const $9bc87a88656ac7d1$var$isMyActivitiesConnection = (activities)=>{
    return activities.myActivities !== undefined;
};
const $9bc87a88656ac7d1$var$V2_AVAILABLE_PRODUCTS = [
    'teamCentral',
    'editor',
    'people',
    'jira',
    'townsquare',
    'apOnboarding',
    'worklens',
    'confluence',
    'start'
];
const $9bc87a88656ac7d1$export$750ec7816fdd2f9e = async ({ experience: experience, product: product, retryMS: retryMS, filters: filters = {}, activityQueries: activityQueries, baseUrl: baseUrl })=>{
    const { limit: // we want to default limit if not applied
    limit = $9bc87a88656ac7d1$var$ACTIVITIES_LIMIT, ...restFilters } = filters;
    experience.mark('GeneratedQueryWithFilters_start');
    const { query: query, queryFilters: queryFilters } = (0, $aHtVh.generateActivityQueryWithFilters)(product, restFilters, activityQueries);
    experience.mark('GeneratedQueryWithFilters_end');
    // This is to make v2 forwards compatible. Defaulting to start as the product
    const operationProduct = $9bc87a88656ac7d1$var$V2_AVAILABLE_PRODUCTS.includes(product) ? product : 'start';
    experience.mark('FetchedActivities_start');
    let response;
    try {
        response = await (0, $e35Gx.postResource)(baseUrl, {
            operationName: (0, $f3gfD.getOperationName)(operationProduct),
            query: query,
            variables: {
                first: limit,
                filters: queryFilters
            }
        }, retryMS);
    } catch (error) {
        if (!error || error.statusCode !== 401 && error.message !== 'The operation was aborted.') throw error;
    }
    experience.mark('FetchedActivities_end');
    let workedOn = [], viewed = [], all = [];
    if (!response || !response.data?.activities) return {
        all: all,
        workedOn: workedOn,
        viewed: viewed
    };
    experience.mark('TransformedActivityItems_start');
    if ($9bc87a88656ac7d1$var$isMyActivitiesConnection(response.data.activities)) {
        if (response.data.activities.myActivities.workedOn && activityQueries.includes('workedOn')) workedOn = (0, $lB6CZ.transformActivitiesItems)('workedOn', response.data.activities.myActivities.workedOn);
        if (response.data.activities.myActivities.viewed && activityQueries.includes('viewed')) viewed = (0, $lB6CZ.transformActivitiesItems)('viewed', response.data.activities.myActivities.viewed);
        if (response.data.activities.myActivities.all && activityQueries.includes('all')) all = (0, $lB6CZ.transformActivitiesItems)('all', response.data.activities.myActivities.all);
    } else {
        if (response.data.activities.workedOn && activityQueries.includes('workedOn')) workedOn = (0, $lB6CZ.transformActivitiesItems)('workedOn', response.data.activities.workedOn);
        if (response.data.activities.all && activityQueries.includes('all')) all = (0, $lB6CZ.transformActivitiesItems)('all', response.data.activities.all);
    }
    experience.mark('TransformedActivityItems_end');
    return {
        all: all,
        viewed: viewed,
        workedOn: workedOn
    };
};

});
parcelRegister("f3gfD", function(module, exports) {

$parcel$export(module.exports, "getOperationName", () => $461d79ecc23ca794$export$41bca9dc6871dd4e);

var $e4eHl = parcelRequire("e4eHl");
const $461d79ecc23ca794$export$ad1e21d37f385bcb = (product)=>{
    return (0, (/*@__PURE__*/$parcel$interopDefault($e4eHl)))(product);
};
const $461d79ecc23ca794$export$41bca9dc6871dd4e = (product)=>{
    return `${$461d79ecc23ca794$export$ad1e21d37f385bcb(product)}_activity_recentWorkClient`;
};

});

parcelRegister("e35Gx", function(module, exports) {

$parcel$export(module.exports, "postResource", () => $e89fe5eb68802860$export$2ff3e1f219ccfad6);
parcelRequire("6fYNv");
var $6sAya = parcelRequire("6sAya");
var $6fYNv = parcelRequire("6fYNv");

var $lP65p = parcelRequire("lP65p");

var $iFmUA = parcelRequire("iFmUA");
const $e89fe5eb68802860$var$fetchResource = async (path, method, options = {})=>{
    const url = (0, $lP65p.getFullUrl)(path);
    const response = await fetch(url, {
        credentials: 'include',
        method: method,
        ...options
    }).catch((error)=>{
        throw new (0, $6sAya.default)({
            error: error,
            path: path,
            method: method
        });
    });
    const statusCode = response.status;
    if (!response.ok) {
        statusCode;
        const text = $e89fe5eb68802860$var$scrubTimestampFromErrorBody(await response.text());
        const httpError = new (0, $iFmUA.default)({
            message: text,
            method: method,
            path: path,
            statusCode: statusCode,
            xRequestId: response.headers.get('x-request-id'),
            headers: response.headers
        });
        throw httpError;
    }
    return response;
};
const $e89fe5eb68802860$var$makeJsonRquest = async (path, method, additionalFetchOptions = {})=>{
    const response = await $e89fe5eb68802860$var$fetchResource(path, method, additionalFetchOptions);
    const text = await response.text();
    // trying to parse empty response as JSON throws an error, but endpoints can return empty response in case of success
    return text ? JSON.parse(text) : {};
};
const $e89fe5eb68802860$export$2ff3e1f219ccfad6 = async (path, data, retryMS, extraHeaders)=>(0, $6fYNv.retryOnException)(()=>$e89fe5eb68802860$var$makeJsonRquest(path, 'POST', {
            body: JSON.stringify(data),
            headers: {
                'content-type': 'application/json',
                ...extraHeaders
            }
        }), {
        intervalsMS: retryMS ?? []
    });
// to dedup sentry, scrub non-unique 'timestamp' field from the error body
function $e89fe5eb68802860$var$scrubTimestampFromErrorBody(text) {
    let json;
    try {
        json = JSON.parse(text);
    } catch (err) {
        return text;
    }
    delete json.timestamp;
    return JSON.stringify(json);
}

});
parcelRegister("lP65p", function(module, exports) {

$parcel$export(module.exports, "getFullUrl", () => $196111106f21b511$export$2414511207262909);
const $196111106f21b511$var$urlRegex = new RegExp(/^https?:\/\//);
function $196111106f21b511$export$2414511207262909(path, // Add this param so we can test this function better
hostConfig = {
    host: window.location.hostname,
    port: window.location.port
}) {
    // always return a just the URL if one is provided
    if ($196111106f21b511$var$urlRegex.test(path)) return path;
    return hostConfig.host === 'localhost' ? `http://${hostConfig.host}:${hostConfig.port}${path}` : path;
}

});


parcelRegister("aHtVh", function(module, exports) {

$parcel$export(module.exports, "generateActivityQueryWithFilters", () => $3a68129fd7fbdd1f$export$855cd08371c65b8c);

var $f3gfD = parcelRequire("f3gfD");

var $dcvAS = parcelRequire("dcvAS");
const $3a68129fd7fbdd1f$var$ACTIVITIES = `
  nodes {
    id
    timestamp
    object {
      id
      name
      cloudId
      localResourceId
      product
      type
      url
      iconUrl
      containers {
        name
      }
      contributors {
        profile {
          accountId
          name
          picture
        }
      }
      events {
        eventType
      }
      extension {
        ... on ActivitiesJiraIssue {
          issueKey
        }
      }
    }
  }
`;
const $3a68129fd7fbdd1f$var$WORKED_ON_QUERY = `
   workedOn(first: $first, filters: $filters) {
     ${$3a68129fd7fbdd1f$var$ACTIVITIES}
   }
`;
const $3a68129fd7fbdd1f$var$VIEWED__QUERY = `
   viewed(first: $first, filters: $filters) {
     ${$3a68129fd7fbdd1f$var$ACTIVITIES}
   }
`;
const $3a68129fd7fbdd1f$var$ALL__QUERY = `
    all(first: $first, filters: $filters) {
      ${$3a68129fd7fbdd1f$var$ACTIVITIES}
    }
`;
const $3a68129fd7fbdd1f$var$activityQueryMap = new Map([
    [
        'workedOn',
        $3a68129fd7fbdd1f$var$WORKED_ON_QUERY
    ],
    [
        'viewed',
        $3a68129fd7fbdd1f$var$VIEWED__QUERY
    ],
    [
        'all',
        $3a68129fd7fbdd1f$var$ALL__QUERY
    ]
]);
const $3a68129fd7fbdd1f$var$getMyActivitiesQuery = (queries)=>`
      myActivities {
        ${queries.join('\n')}
      }
`;
const $3a68129fd7fbdd1f$var$getActivitiesQuery = (product, content)=>`
    query ${(0, $f3gfD.getOperationName)(product)}($first: Int, $filters: [ActivitiesFilter!]) {
      activities {
        ${content}
      }
    }
`;
const $3a68129fd7fbdd1f$export$855cd08371c65b8c = (product, filters, activityQueries)=>{
    /**
	 * If we are filtering by `accountIds` then we can't use the `myActivity` query.
	 */ if (Array.isArray(filters.actors)) {
        // you can't view `viewed` events for other accounts
        const filteredAccountQueries = activityQueries.filter((query)=>query !== 'viewed');
        return {
            query: $3a68129fd7fbdd1f$var$getActivitiesQuery(product, filteredAccountQueries.map((query)=>$3a68129fd7fbdd1f$var$activityQueryMap.get(query)).join('\n')),
            queryFilters: (0, $dcvAS.ACTIVITY_FILTER_COLLECTION).v2.get('activities')(filters)
        };
    } else return {
        query: $3a68129fd7fbdd1f$var$getActivitiesQuery(product, $3a68129fd7fbdd1f$var$getMyActivitiesQuery(activityQueries.map((query)=>$3a68129fd7fbdd1f$var$activityQueryMap.get(query)))),
        queryFilters: (0, $dcvAS.ACTIVITY_FILTER_COLLECTION).v2.get('myActivity')(filters)
    };
};

});
parcelRegister("dcvAS", function(module, exports) {

$parcel$export(module.exports, "ACTIVITY_FILTER_COLLECTION", () => $1d4997441d4b8586$export$5201d39848130041);

var $1THyP = parcelRequire("1THyP");

var $62oeH = parcelRequire("62oeH");
const $1d4997441d4b8586$export$5201d39848130041 = {
    v2: (0, $1THyP.ACTIVITY_FILTER_V2_MAP),
    v3: (0, $62oeH.ACTIVITY_FILTER_V3_MAP)
};

});
parcelRegister("1THyP", function(module, exports) {

$parcel$export(module.exports, "ACTIVITY_FILTER_V2_MAP", () => $a1a68e27645236e3$export$1dca7bc1ec360897);

var $4hkqF = parcelRequire("4hkqF");

var $afWIG = parcelRequire("afWIG");
const $a1a68e27645236e3$export$1dca7bc1ec360897 = new Map([
    [
        'myActivity',
        (0, $afWIG.default)
    ],
    [
        'activities',
        (0, $4hkqF.default)
    ]
]);

});
parcelRegister("4hkqF", function(module, exports) {

$parcel$export(module.exports, "default", () => $46c6a95053cc1f7b$export$2e2bcd8739ae039);

var $74JGD = parcelRequire("74JGD");
/**
 * This is the query builder for the v2 - activities API
 *
 * @param filters
 */ const $46c6a95053cc1f7b$var$generateV2ActivitiesFilters = (filters = {})=>{
    const { limit: // discard as these aren't supported by this query
    limit, // TODO: Enable the below code as we support multi-user queries and enable them in the main ActivityFilters interface
    // actors,
    // rootContainerIds,
    ...restFilters } = filters;
    return (0, $74JGD.generateActivityFiltersV2)(restFilters);
};
var $46c6a95053cc1f7b$export$2e2bcd8739ae039 = $46c6a95053cc1f7b$var$generateV2ActivitiesFilters;

});
parcelRegister("74JGD", function(module, exports) {

$parcel$export(module.exports, "generateActivityFiltersV2", () => $683b63762cac319c$export$ebef9c1f1e15c057);

var $MQuHl = parcelRequire("MQuHl");
// in V2 API the values for certain filters should be in UPPERCASE as are ENUMs in the GraphQL
// likewise for the V3 handler we should ensure we do appropriate lowercase conversion
const $683b63762cac319c$var$FILTERS_TO_TRANSFORM__UPPERCASE = [
    'products',
    'eventTypes',
    'objectTypes'
];
const $683b63762cac319c$var$KEYS_TO_TRANSFROM = new Map([
    [
        'actors',
        'accountIds'
    ]
]);
const $683b63762cac319c$export$ebef9c1f1e15c057 = (filters = {})=>(0, $MQuHl.generateActivityFilters)(filters, (originalkey, originalFilter)=>{
        const filter = Array.isArray(originalFilter) && $683b63762cac319c$var$FILTERS_TO_TRANSFORM__UPPERCASE.includes(originalkey) ? originalFilter.map((f)=>f.toUpperCase()) : originalFilter;
        const key = $683b63762cac319c$var$KEYS_TO_TRANSFROM.has(originalkey) ? $683b63762cac319c$var$KEYS_TO_TRANSFROM.get(originalkey) : originalkey;
        return {
            [key]: filter
        };
    });

});
parcelRegister("MQuHl", function(module, exports) {

$parcel$export(module.exports, "generateActivityFilters", () => $0ef7a6884f8128bf$export$23c75313f46dd54e);
const $0ef7a6884f8128bf$export$23c75313f46dd54e = (filters = {}, transform, rootLevelFilters)=>{
    return Object.entries(filters).reduce((acc, [key, filter])=>{
        const entry = transform ? transform(key, filter) : {
            [key]: filter
        };
        return rootLevelFilters?.includes(key) ? {
            ...acc,
            ...entry
        } : {
            ...acc,
            arguments: {
                ...acc.arguments,
                ...entry
            }
        };
    }, {
        type: 'AND',
        arguments: {}
    });
};

});



parcelRegister("afWIG", function(module, exports) {

$parcel$export(module.exports, "default", () => $b3c453a00bc0f6ca$export$2e2bcd8739ae039);

var $74JGD = parcelRequire("74JGD");
/**
 * This is the query builder for the v2 - myActivity API
 *
 * @param filters
 */ const $b3c453a00bc0f6ca$var$generateV2MyActivityFilters = (filters = {})=>{
    const { limit: // discard as these aren't supported by this query
    limit, actors: actors, // TODO: Enable the below code as we support multi-user queries and enable them in the main ActivityFilters interface
    // actors,
    // rootContainerIds,
    ...restFilters } = filters;
    return (0, $74JGD.generateActivityFiltersV2)(restFilters);
};
var $b3c453a00bc0f6ca$export$2e2bcd8739ae039 = $b3c453a00bc0f6ca$var$generateV2MyActivityFilters;

});


parcelRegister("62oeH", function(module, exports) {

$parcel$export(module.exports, "ACTIVITY_FILTER_V3_MAP", () => $a356d323f8207676$export$9a1782843b6e99d2);

var $hU3MB = parcelRequire("hU3MB");

var $gQxYK = parcelRequire("gQxYK");
const $a356d323f8207676$export$9a1782843b6e99d2 = new Map([
    [
        'myActivity',
        (0, $gQxYK.default)
    ],
    [
        'activities',
        (0, $hU3MB.default)
    ]
]);

});
parcelRegister("hU3MB", function(module, exports) {

$parcel$export(module.exports, "default", () => $84a6b56b296ed055$export$2e2bcd8739ae039);

var $glhs7 = parcelRequire("glhs7");
/**
 * This is the query builder for the v3 - activities API
 *
 * @param filters
 */ const $84a6b56b296ed055$var$generateV3ActivityFilters = (filters = {})=>{
    const { limit: // discard as these aren't supported by this query
    limit, ...restFilters } = filters;
    return (0, $glhs7.generateActivityFiltersV3)(restFilters);
};
var $84a6b56b296ed055$export$2e2bcd8739ae039 = $84a6b56b296ed055$var$generateV3ActivityFilters;

});
parcelRegister("glhs7", function(module, exports) {

$parcel$export(module.exports, "generateActivityFiltersV3", () => $3cb34394a8624fd6$export$e73fe7ded3fe2664);

var $MQuHl = parcelRequire("MQuHl");
// in V2 API the values for certain filters should be in UPPERCASE as are ENUMs in the GraphQL
// likewise for the V3 handler we should ensure we do appropriate lowercase conversion
const $3cb34394a8624fd6$var$FILTERS_TO_TRANSFORM__LOWERCASE = [
    'products',
    'eventTypes',
    'objectTypes'
];
const $3cb34394a8624fd6$var$ROOT_LEVEL_FILTERS = [
    'actors',
    'rootContainerIds'
];
const $3cb34394a8624fd6$export$e73fe7ded3fe2664 = (filters = {})=>(0, $MQuHl.generateActivityFilters)(filters, (key, filter)=>Array.isArray(filter) && $3cb34394a8624fd6$var$FILTERS_TO_TRANSFORM__LOWERCASE.includes(key) ? {
            [key]: filter.map((f)=>f.toLowerCase())
        } : {
            [key]: filter
        }, $3cb34394a8624fd6$var$ROOT_LEVEL_FILTERS);

});


parcelRegister("gQxYK", function(module, exports) {

$parcel$export(module.exports, "default", () => $840ac7ca8bd740a4$export$2e2bcd8739ae039);

var $glhs7 = parcelRequire("glhs7");
/**
 * This is the query builder for the v3 - myActivity API
 *
 * @param filters
 */ const $840ac7ca8bd740a4$var$generateV3MyActivityFilters = (filters = {})=>{
    const { limit: // discard as these aren't supported by this query
    limit, actors: actors, ...restFilters } = filters;
    return (0, $glhs7.generateActivityFiltersV3)(restFilters);
};
var $840ac7ca8bd740a4$export$2e2bcd8739ae039 = $840ac7ca8bd740a4$var$generateV3MyActivityFilters;

});




parcelRegister("lB6CZ", function(module, exports) {

$parcel$export(module.exports, "transformActivitiesItems", () => $ccb3637438790056$export$306a8b649360ca6f);
const $ccb3637438790056$var$SITE_ARI_PREFIX = 'ari:cloud:platform::site/';
function $ccb3637438790056$export$306a8b649360ca6f(query, activities = {}) {
    if (!activities || !activities.nodes) return [];
    return activities.nodes.map((item)=>{
        const { object: object, timestamp: timestamp } = item;
        const { cloudId: cloudId, events: events, extension: extension, iconUrl: iconUrl, id: id, localResourceId: localResourceId, name: name, product: product, url: url, type: type } = object;
        // V2 returns eventType captilised, V3 returns lowercase
        const eventType = events[0].eventType.toLowerCase();
        const issueKey = extension && extension.issueKey;
        let containers = [];
        if (issueKey) containers.push({
            name: issueKey
        });
        if (Array.isArray(object.containers)) containers = containers.concat(object.containers);
        containers = containers.filter((container)=>!!container.name);
        return {
            query: query,
            containers: containers,
            contributors: (object.contributors || []).reduce((contributors, contributor)=>{
                if (contributor.profile) {
                    const { accountId: accountId, picture: picture } = contributor.profile;
                    contributors.push({
                        accountId: accountId,
                        name: contributor.profile.name,
                        picture: picture
                    });
                }
                return contributors;
            }, []),
            eventType: eventType,
            object: {
                rootContainerIdentifier: {
                    id: cloudId,
                    type: 'SITE',
                    ari: `${$ccb3637438790056$var$SITE_ARI_PREFIX}${cloudId}`
                },
                deduplicateId: id,
                icon: {
                    type: 'URL',
                    value: iconUrl
                },
                id: id,
                localResourceId: localResourceId,
                name: name,
                product: product,
                subProduct: null,
                type: type,
                url: url
            },
            timestamp: timestamp
        };
    });
}

});



parcelRegister("7trIV", function(module, exports) {

$parcel$export(module.exports, "ActivityClientV3", () => $36bf5d2659940c95$export$3c3c237c92ca1fb9);

var $6fYNv = parcelRequire("6fYNv");

var $VSDnB = parcelRequire("VSDnB");

var $3l0ly = parcelRequire("3l0ly");

var $1b4ym = parcelRequire("1b4ym");

var $cXq43 = parcelRequire("cXq43");

var $e35Gx = parcelRequire("e35Gx");

var $dMJiM = parcelRequire("dMJiM");

var $4HxlV = parcelRequire("4HxlV");

var $fTeQf = parcelRequire("fTeQf");

var $jkCM1 = parcelRequire("jkCM1");

var $65vGW = parcelRequire("65vGW");

var $3LJ9C = parcelRequire("3LJ9C");

var $3Bknq = parcelRequire("3Bknq");

var $55Gxu = parcelRequire("55Gxu");

var $66K4V = parcelRequire("66K4V");

var $hTLIi = parcelRequire("hTLIi");
const $36bf5d2659940c95$var$CONFLUENCE_COMMENT_TYPENAMES = [
    'ConfluenceComment',
    'ConfluenceFooterComment',
    'ConfluenceInlineComment'
];
const $36bf5d2659940c95$var$IGNORED_HTTP_ERRORS = new Map([
    // ignore all 401 errors
    [
        401,
        [
            /.*/
        ]
    ],
    [
        403,
        [
            /Invalid CORS request/
        ]
    ]
]);
const $36bf5d2659940c95$var$IGNORED_ERROR_MESSAGES = [
    'The operation was aborted.'
];
const $36bf5d2659940c95$var$DEFAULT_TAGS = {
    source: (0, $1b4ym.packageName),
    sourcePackageVersion: (0, $1b4ym.packageVersion)
};
class $36bf5d2659940c95$export$3c3c237c92ca1fb9 extends (0, $3Bknq.ActivityClient) {
    constructor(product, baseUrl, logger, configFetch){
        super('v3', product, {
            'X-ExperimentalApi': 'ActivityV3Api'
        }, baseUrl), this.setProduct = (product)=>{
            this.product = product;
        }, this.captureException = (error, tags)=>{
            if (this.clientHandlers) this.clientHandlers.captureException(error, {
                ...$36bf5d2659940c95$var$DEFAULT_TAGS,
                ...tags
            });
        }, this.captureWarning = (message, tags)=>{
            if (this.clientHandlers) this.clientHandlers.captureWarning(message, {
                ...$36bf5d2659940c95$var$DEFAULT_TAGS,
                ...tags
            });
        }, this.fetchHydratorConfig = async ()=>await this.hydratorConfigClient.fetchConfig(), this.handleGraphQLErrors = (errors)=>{
            const invalidFragments = [];
            if (Array.isArray(errors)) {
                for (const err of errors){
                    this.captureException(new (0, $4HxlV.GraphQLJSError)(err));
                    const invalidFragment = (0, $55Gxu.default)(err);
                    if (invalidFragment) invalidFragments.push(invalidFragment);
                }
                return invalidFragments;
            }
            return [];
        }, this.fetchActivitiesV3 = async (experience, retryMS, filters, activityQueries, deduplicateActivities = true)=>{
            let { fragments: fragments, hydrators: hydrators } = await this.fetchHydratorConfig();
            experience.mark('GeneratedQueryWithFilters_start');
            let response;
            try {
                response = await (0, $6fYNv.retryOnException)(async ()=>{
                    const request = (0, $66K4V.generateGraphQLRequest)(this.product, filters, activityQueries, fragments);
                    experience.mark('GeneratedQueryWithFilters_end');
                    experience.mark('FetchedActivities_start');
                    experience.addMetadata({
                        filters: (0, $hTLIi.filtersToMetadata)(filters)
                    });
                    const res = await (0, $e35Gx.postResource)(this.baseUrl, request, retryMS, {
                        ...this.headers
                    });
                    experience.mark('FetchedActivities_end');
                    const invalidFragments = this.handleGraphQLErrors(res?.errors);
                    if (invalidFragments.length > 0) {
                        fragments = (0, $hTLIi.filterInvalidFragments)(invalidFragments, fragments);
                        throw new (0, $dMJiM.GraphQLFragmentError)(`Missing fragments: [${invalidFragments.toString()}]`);
                    }
                    return res;
                }, {
                    intervalsMS: [
                        0,
                        0,
                        0
                    ],
                    retryOn: (err)=>[
                            (0, $dMJiM.GraphQLFragmentError)
                        ].some((retriableErr)=>err instanceof retriableErr),
                    captureException: this.captureException
                });
            } catch (error) {
                if (!error || !$36bf5d2659940c95$var$IGNORED_HTTP_ERRORS.get(error.statusCode)?.some((regExp)=>regExp.test(error.message)) && !$36bf5d2659940c95$var$IGNORED_ERROR_MESSAGES.includes(error.message)) throw error;
            }
            if ((0, $hTLIi.isEmptyActivitiesWithErrorsResponse)(response)) throw new (0, $fTeQf.GraphQLNoResultsError)(response.errors);
            if (!response || !response.data?.activity) return {
                workedOn: [],
                viewed: [],
                all: []
            };
            experience.mark('TransformedActivityItems_start');
            const workedOn = $36bf5d2659940c95$var$transformActivityItem('workedOn', (0, $hTLIi.activityRoot)(response.data.activity)?.workedOn?.edges || [], hydrators, this.captureException);
            // We don't need the activity root function here as viewed only exists on myActivity
            const viewed = $36bf5d2659940c95$var$transformActivityItem('viewed', response.data.activity?.myActivity?.viewed?.edges || [], hydrators, this.captureException);
            const all = $36bf5d2659940c95$var$transformActivityItem('all', (0, $hTLIi.activityRoot)(response.data.activity)?.all?.edges || [], hydrators, this.captureException);
            experience.mark('TransformedActivityItems_end');
            const activities = {
                viewed: viewed,
                workedOn: workedOn,
                all: all
            };
            return deduplicateActivities ? (0, $hTLIi.rollupActivitiesData)(activities) : activities;
        }, this.fetchActivities = async (retryMS, filters, activityQueries, deduplicateActivities = true)=>{
            return (0, $cXq43.fetchActivitiesWithExperience)((experience)=>this.fetchActivitiesV3(experience, retryMS, filters, activityQueries, deduplicateActivities), 'v3');
        };
        this.clientHandlers = logger;
        this.hydratorConfigClient = new (0, $3LJ9C.default)({
            captureException: this.captureException,
            captureWarning: this.captureWarning
        }, product, configFetch);
    }
}
const $36bf5d2659940c95$var$setIconHydration = (object, hydratedData)=>{
    const isLiveDoc = object.data.__typename === 'ConfluencePage' && (0, $65vGW.hydratedValueToString)(hydratedData.subtype) === 'LIVE';
    if (isLiveDoc && (0, $VSDnB.fg)('platform_support_live_doc_icons_in_link_picker')) return (0, $65vGW.hydrateIcon)(hydratedData.icon, hydratedData.staticFallbacks, 'confluenceLiveDocIcon');
    return $36bf5d2659940c95$var$CONFLUENCE_COMMENT_TYPENAMES.includes(object.data.__typename) ? (0, $65vGW.hydrateConfluenceIcon)(object.data?.container?.__typename || object.data.__typename, hydratedData.icon, hydratedData.staticFallbacks) : (0, $65vGW.hydrateIcon)(hydratedData.icon, hydratedData.staticFallbacks);
};
function $36bf5d2659940c95$var$transformActivityItem(query, activities, hydrators, captureException) {
    return activities.reduce((acc, item)=>{
        if (item && item.node && item.node.object && item.node.event) {
            const { object: object, event: event } = item.node;
            if (!object.product || !object.type) return acc;
            const containers = [];
            let c = object.contributors || [];
            const contributors = c.reduce((contributors, contributor)=>{
                if (contributor.profile) {
                    const { accountId: accountId, picture: picture } = contributor.profile;
                    contributors.push({
                        accountId: accountId,
                        name: contributor.profile.name,
                        picture: picture
                    });
                }
                return contributors;
            }, []);
            const hydratedData = (0, $jkCM1.hydratePolymorphicData)(hydrators, object.data, captureException);
            if (hydratedData) {
                if (hydratedData.key) containers.push({
                    name: (0, $65vGW.hydratedValueToString)(hydratedData.key, ' ')
                });
                if (hydratedData.containers) containers.push({
                    name: (0, $65vGW.hydratedValueToString)(hydratedData.containers, ' ')
                });
                const actor = event.actor ? {
                    name: event.actor.name,
                    picture: event.actor.picture,
                    accountId: event.actor.accountId
                } : undefined;
                // The V3 API returns "Created" for a new comment, we want this to display as "Commented"
                const eventType = object.type === 'comment' && event.eventType === (0, $3l0ly.WORKED_EVENT).CREATED ? (0, $3l0ly.WORKED_EVENT).COMMENTED : event.eventType;
                acc.push({
                    actor: actor,
                    query: query,
                    containers: containers,
                    contributors: contributors,
                    eventType: eventType,
                    object: {
                        rootContainerIdentifier: (0, $hTLIi.parseRootContainerARI)(object.rootContainerId),
                        icon: $36bf5d2659940c95$var$setIconHydration(object, hydratedData),
                        id: object.id,
                        deduplicateId: (0, $65vGW.hydratedValueToString)(hydratedData.deduplicateId) || object.id,
                        localResourceId: (0, $65vGW.hydratedValueToString)(hydratedData.localResourceId),
                        name: (0, $65vGW.hydratedValueToString)(hydratedData.name, ' '),
                        product: object.product,
                        subProduct: object.subProduct,
                        type: object.type,
                        subtype: object.data.subtype,
                        url: (0, $65vGW.hydratedValueToString)(hydratedData.url),
                        objectTypeName: (0, $65vGW.hydratedValueToString)(hydratedData.objectTypeName)
                    },
                    timestamp: event.timestamp
                });
            }
        }
        return acc;
    }, []);
}

});
parcelRegister("dMJiM", function(module, exports) {

$parcel$export(module.exports, "GraphQLFragmentError", () => $37a211a3da9949b9$export$2d1b192199788179);
class $37a211a3da9949b9$export$2d1b192199788179 extends Error {
    constructor(message){
        super(message);
        this.name = 'GraphQLFragmentError';
        this.message = message;
    }
}

});

parcelRegister("4HxlV", function(module, exports) {

$parcel$export(module.exports, "GraphQLJSError", () => $098e0a3de69a420c$export$8d4af49ee2a0fbe2);
class $098e0a3de69a420c$export$8d4af49ee2a0fbe2 extends Error {
    constructor(graphQLError){
        super(graphQLError.message);
        this.name = 'GraphQLJSError';
        this.error = graphQLError;
        this.message = graphQLError.message;
    }
}

});

parcelRegister("fTeQf", function(module, exports) {

$parcel$export(module.exports, "GraphQLNoResultsError", () => $9ec383f2a327fd66$export$3f19ff30d409b70);
class $9ec383f2a327fd66$export$3f19ff30d409b70 extends Error {
    constructor(graphQLErrors){
        super();
        this.name = 'GraphQLNoResultsError';
        this.errors = graphQLErrors;
        this.message = 'GraphQL returned errors & no results';
        this.errorMessages = graphQLErrors.map((error)=>error.message);
    }
}

});

parcelRegister("jkCM1", function(module, exports) {

$parcel$export(module.exports, "hydratePolymorphicData", () => $d64b966f022ff0ad$export$d658049bf1a63492);

var $9XE6b = parcelRequire("9XE6b");

var $9cIED = parcelRequire("9cIED");
const $d64b966f022ff0ad$export$d658049bf1a63492 = (hydrators, data, captureException)=>{
    if (data) {
        if ('__typename' in data) {
            const hydrator = hydrators[data.__typename];
            if (hydrator) try {
                return $d64b966f022ff0ad$var$hydrateData(data, hydrator);
            } catch (error) {
                captureException && captureException(new (0, $9cIED.default)({
                    error: error,
                    message: `Hydrator failed for [${data.__typename}].`
                }));
            }
            else captureException && captureException(new (0, $9cIED.default)({
                message: `Missing hydrator for [${data.__typename}].`
            }));
        } else captureException && captureException(new (0, $9cIED.default)({
            message: `Missing [__typename] field from data.`
        }));
    }
    return null;
};
function $d64b966f022ff0ad$var$getOrSearch(object, path) {
    if (!object) return object;
    if (path.includes(':')) {
        const [searchField, searchValue] = path.split(':');
        return $d64b966f022ff0ad$var$findNodeByField(object, searchField.trim(), searchValue.trim().replace(/"/g, ''));
    }
    return (0, (/*@__PURE__*/$parcel$interopDefault($9XE6b)))(object, path);
}
function $d64b966f022ff0ad$var$resolvePath(object, path) {
    // Split the path on each bracket
    const splitPath = path.split(/\(|\)./);
    // Traverse the split path as a tree, resolving as we go
    let current = object;
    for (const split of splitPath)current = $d64b966f022ff0ad$var$getOrSearch(current, split);
    return current;
}
function $d64b966f022ff0ad$var$findNodeByField(edges, fieldId, searchValue) {
    return edges.find((edge)=>(0, (/*@__PURE__*/$parcel$interopDefault($9XE6b)))(edge, fieldId) === searchValue);
}
function $d64b966f022ff0ad$export$a5c4301012ad6f07(object, paths) {
    return paths.map((path)=>$d64b966f022ff0ad$var$resolvePath(object, path));
}
const $d64b966f022ff0ad$var$hydrateData = (data, hydrator)=>{
    const { hydratorPaths: hydratorPaths, staticFallbacks: staticFallbacks } = hydrator;
    return {
        staticFallbacks: staticFallbacks,
        ...Object.entries(hydratorPaths).reduce((acc, [key, dataValue])=>{
            const item = $d64b966f022ff0ad$export$a5c4301012ad6f07(data, dataValue);
            if (item) acc[key] = item;
            else throw new Error(`Bad hydrator path: ${key}`);
            return acc;
        }, {})
    };
};

});
parcelRegister("9cIED", function(module, exports) {

$parcel$export(module.exports, "default", () => $5eebec53575108e7$export$2e2bcd8739ae039);
class $5eebec53575108e7$export$2e2bcd8739ae039 extends Error {
    constructor({ error: error, message: message }){
        super();
        const err = error instanceof Error ? error : new Error();
        this.name = 'HydratorError';
        this.message = message;
        this.originalMessage = err.message;
        this.stack = err.stack;
        this.originalName = err.name;
    }
}

});


parcelRegister("65vGW", function(module, exports) {

$parcel$export(module.exports, "hydratedValueToString", () => $e885246460d7ca94$export$c5cea44a1f75b431);
$parcel$export(module.exports, "hydrateConfluenceIcon", () => $e885246460d7ca94$export$86b9f44277b105a6);
$parcel$export(module.exports, "hydrateIcon", () => $e885246460d7ca94$export$a328b2bb0d21d984);
const $e885246460d7ca94$export$c5cea44a1f75b431 = (value, separator = '')=>{
    if (!value) return null;
    return Array.isArray(value) ? value.join(separator) : value;
};
function $e885246460d7ca94$var$isURL(icon) {
    return typeof icon === 'string';
}
function $e885246460d7ca94$var$isValidEmoji(icon) {
    return typeof icon === 'object' && icon.value !== undefined && !!icon.value;
}
const $e885246460d7ca94$export$86b9f44277b105a6 = (confluenceContainerType, icons, fallbacks)=>{
    switch(confluenceContainerType){
        case 'ConfluenceBlogPost':
            return $e885246460d7ca94$export$a328b2bb0d21d984(icons, fallbacks, 'confluenceBlogIcon') || $e885246460d7ca94$export$a328b2bb0d21d984(icons, fallbacks);
        case 'ConfluencePage':
            return $e885246460d7ca94$export$a328b2bb0d21d984(icons, fallbacks, 'confluencePageIcon') || $e885246460d7ca94$export$a328b2bb0d21d984(icons, fallbacks);
        default:
            return $e885246460d7ca94$export$a328b2bb0d21d984(icons, fallbacks);
    }
};
const $e885246460d7ca94$export$a328b2bb0d21d984 = (icons, fallbacks, fallbackKey = 'icon')=>{
    if (Array.isArray(icons) && icons.length > 0) {
        const emojiIcons = icons.filter($e885246460d7ca94$var$isValidEmoji);
        if (emojiIcons.length > 0) return {
            type: 'EMOJI',
            value: emojiIcons[0].value,
            fallback: fallbacks?.[fallbackKey]
        };
        const urlIcons = icons.filter($e885246460d7ca94$var$isURL);
        if (urlIcons.length > 0) {
            const hydratedIcons = $e885246460d7ca94$export$c5cea44a1f75b431(urlIcons);
            if (hydratedIcons !== null) return {
                type: 'URL',
                value: hydratedIcons
            };
        }
    }
    if (fallbacks && fallbackKey in fallbacks && fallbacks[fallbackKey]) return {
        type: 'URL',
        value: fallbacks[fallbackKey]
    };
    return null;
};

});

parcelRegister("55Gxu", function(module, exports) {

$parcel$export(module.exports, "default", () => $33cd97b94b378eac$export$2e2bcd8739ae039);

var $fQ0JV = parcelRequire("fQ0JV");
const $33cd97b94b378eac$var$errorHandlerMap = new Map([
    [
        'ValidationError',
        (0, $fQ0JV.default)
    ]
]);
const $33cd97b94b378eac$var$graphQLErrorHandler = (err)=>{
    const errorHandler = $33cd97b94b378eac$var$errorHandlerMap.get(err.extensions.classification);
    if (typeof errorHandler === 'function') return errorHandler(err);
    return null;
};
var $33cd97b94b378eac$export$2e2bcd8739ae039 = $33cd97b94b378eac$var$graphQLErrorHandler;

});
parcelRegister("fQ0JV", function(module, exports) {

$parcel$export(module.exports, "default", () => $cc94d91a337842e7$export$2e2bcd8739ae039);
/**
 * ^Validation error - look for validation errors from the start
 * .*?@ ' - look through everything up to the first instance of "@ '"
 * (\w+) - capture the first word, that's our invalid fragment
 */ const $cc94d91a337842e7$var$captureRegex = new RegExp(/^Validation error.*?@ '(\w+)/);
const $cc94d91a337842e7$var$validationErrorHandler = (graphQLError)=>{
    const invalidFragmentMatch = $cc94d91a337842e7$var$captureRegex.exec(graphQLError.message);
    if (Array.isArray(invalidFragmentMatch)) {
        const invalidFragment = invalidFragmentMatch[1];
        if (invalidFragment) return invalidFragment;
    }
    return null;
};
var $cc94d91a337842e7$export$2e2bcd8739ae039 = $cc94d91a337842e7$var$validationErrorHandler;

});


parcelRegister("66K4V", function(module, exports) {

$parcel$export(module.exports, "generateGraphQLRequest", () => $cf1fca899d4c9068$export$7489a6ef09862e48);

var $f3gfD = parcelRequire("f3gfD");

var $dcvAS = parcelRequire("dcvAS");
const $cf1fca899d4c9068$var$ACTIVITIES_LIMIT = 50;
const $cf1fca899d4c9068$var$WORKED_ON_QUERY = `
   workedOn(first: $first, filter: $filter) {
     ...activityItemConnection
   }
`;
const $cf1fca899d4c9068$var$VIEWED__QUERY = `
   viewed(first: $first, filter: $filter) {
     ...activityItemConnection
   }
`;
const $cf1fca899d4c9068$var$ALL__QUERY = `
    all(first: $first, filter: $filter) {
      ...activityItemConnection
    }
`;
const $cf1fca899d4c9068$var$activityQueryMap = new Map([
    [
        'workedOn',
        $cf1fca899d4c9068$var$WORKED_ON_QUERY
    ],
    [
        'viewed',
        $cf1fca899d4c9068$var$VIEWED__QUERY
    ],
    [
        'all',
        $cf1fca899d4c9068$var$ALL__QUERY
    ]
]);
const $cf1fca899d4c9068$var$getMyActivitiesQuery = (queries)=>`
      myActivity {
        ${queries.join('\n')}
      }
`;
const $cf1fca899d4c9068$var$getActivitiesQuery = (product, content, fragments, activityFilterType = 'ActivityFilter')=>`
    query ${(0, $f3gfD.getOperationName)(product)}($first: Int, $filter: ${activityFilterType}) {
      activity {
        ${content}
      }
    }
${fragments}
`;
const $cf1fca899d4c9068$export$855cd08371c65b8c = (product, filters, activityQueries, fragments)=>{
    /**
	 * If we are filtering by `actors` then we can't use the `myActivity` query.
	 */ if (Array.isArray(filters.actors)) {
        // you can't view `viewed` events for other accounts
        const filteredAccountQueries = activityQueries.filter((query)=>query !== 'viewed');
        return {
            query: $cf1fca899d4c9068$var$getActivitiesQuery(product, filteredAccountQueries.map((query)=>$cf1fca899d4c9068$var$activityQueryMap.get(query)).join('\n'), fragments, 'ActivityFilter'),
            queryFilters: (0, $dcvAS.ACTIVITY_FILTER_COLLECTION).v3.get('activities')(filters)
        };
    } else return {
        query: $cf1fca899d4c9068$var$getActivitiesQuery(product, $cf1fca899d4c9068$var$getMyActivitiesQuery(activityQueries.map((query)=>$cf1fca899d4c9068$var$activityQueryMap.get(query))), fragments, 'MyActivityFilter'),
        queryFilters: (0, $dcvAS.ACTIVITY_FILTER_COLLECTION).v3.get('myActivity')(filters)
    };
};
const $cf1fca899d4c9068$export$7489a6ef09862e48 = (product, filters, activityQueries, fragments)=>{
    const { limit: // we want to default limit if not applied
    limit = $cf1fca899d4c9068$var$ACTIVITIES_LIMIT, ...restFilters } = filters;
    const { query: query, queryFilters: queryFilters } = $cf1fca899d4c9068$export$855cd08371c65b8c(product, restFilters, activityQueries, fragments);
    return {
        operationName: (0, $f3gfD.getOperationName)(product),
        query: query,
        variables: {
            first: limit,
            filter: queryFilters
        }
    };
};

});

parcelRegister("hTLIi", function(module, exports) {

$parcel$export(module.exports, "rollupActivitiesData", () => $56093000e314999c$export$750d93207e30f59a);
$parcel$export(module.exports, "activityRoot", () => $56093000e314999c$export$ea55e8e0446efa94);
$parcel$export(module.exports, "parseRootContainerARI", () => $56093000e314999c$export$788e6013936a6bb4);
$parcel$export(module.exports, "filtersToMetadata", () => $56093000e314999c$export$e8f56bed6776c7ea);
$parcel$export(module.exports, "filterInvalidFragments", () => $56093000e314999c$export$e22863ec502608d2);
$parcel$export(module.exports, "isEmptyActivitiesWithErrorsResponse", () => $56093000e314999c$export$c939d6148e47244a);
function $56093000e314999c$export$750d93207e30f59a(activitiesData) {
    const { all: all, viewed: viewed, workedOn: workedOn } = activitiesData;
    return {
        all: $56093000e314999c$var$rollUpActivityItems(all),
        viewed: $56093000e314999c$var$rollUpActivityItems(viewed),
        workedOn: $56093000e314999c$var$rollUpActivityItems(workedOn)
    };
}
function $56093000e314999c$var$rollUpActivityItems(activityItems) {
    // https://stackoverflow.com/a/49460534
    // creates an ordered 'hashmap' containing unique ids in the same order that the activity items appear
    const latestActivityItemsObjectWithLatestTimestamp = activityItems.reduce((acc, activityItem)=>{
        const deduplicateId = activityItem.object.deduplicateId || activityItem.object.id;
        const existingItem = acc[deduplicateId];
        if (existingItem) {
            const aggregatedItems = existingItem.aggregatedActivityItems || [];
            if (Date.parse(existingItem.timestamp) < Date.parse(activityItem.timestamp)) {
                activityItem.aggregatedActivityItems = [
                    ...aggregatedItems,
                    existingItem
                ];
                // remove the current activity for that id so when we add the more recent activity it is in the order that it appears
                delete acc[deduplicateId];
                acc[deduplicateId] = activityItem;
            } else acc[deduplicateId].aggregatedActivityItems = [
                ...aggregatedItems,
                activityItem
            ];
        } else acc[deduplicateId] = activityItem;
        return acc;
    }, {});
    return Object.values(latestActivityItemsObjectWithLatestTimestamp);
}
const $56093000e314999c$export$213ba2e9f2d143b9 = (key)=>{
    return new RegExp(`fragment ${$56093000e314999c$var$fragmentName(key)} on ${$56093000e314999c$var$fragmentType(key)} ({(.|\\n)+?(?=fragment))`, 'gm');
};
const $56093000e314999c$var$fragmentName = (key)=>key.charAt(0).toLowerCase() + key.slice(1);
const $56093000e314999c$var$fragmentType = (key)=>key.charAt(0).toUpperCase() + key.slice(1);
const $56093000e314999c$export$ea55e8e0446efa94 = (activity)=>{
    if (activity.myActivity) return activity.myActivity;
    return activity;
};
const $56093000e314999c$var$SITE_ARI_PREFIX = 'ari:cloud:platform::site/';
const $56093000e314999c$var$containerMapTypes = new Map([
    [
        $56093000e314999c$var$SITE_ARI_PREFIX,
        'SITE'
    ]
]);
function $56093000e314999c$export$788e6013936a6bb4(rootContainerARI) {
    // the "ID" portion of the ARI begins after the first '/'
    const ariSplitIndex = rootContainerARI.indexOf('/');
    return {
        ari: rootContainerARI,
        id: rootContainerARI.slice(ariSplitIndex + 1),
        type: $56093000e314999c$var$containerMapTypes.get(rootContainerARI.slice(0, ariSplitIndex + 1)) || 'OTHER'
    };
}
function $56093000e314999c$export$e8f56bed6776c7ea(filters) {
    return {
        ...filters,
        // These have V high cardinality, so using a length
        actors: filters.actors?.length,
        containerIds: filters.containerIds?.length,
        // comma separated lists
        products: filters.products?.join(','),
        eventTypes: filters.eventTypes?.join(','),
        objectTypes: filters.objectTypes?.join(','),
        rootContainerIds: filters.rootContainerIds?.join(',')
    };
}
/**
 * These fragments are the core of our query, without them it will always fail,
 * so we shouldn't remove them. It is possible that removing other offending fragments
 * will fix the error in these core fragments. (e.g. Field conflict)
 */ const $56093000e314999c$var$RESTRICTED_FRAGMENTS = [
    'activity',
    'all',
    'myActivity',
    'workedOn',
    'viewed',
    'activityItemConnection',
    'activityItemEdge'
];
function $56093000e314999c$export$e22863ec502608d2(invalidFragments, allFragments) {
    return invalidFragments.filter((fragment)=>!$56093000e314999c$var$RESTRICTED_FRAGMENTS.includes(fragment)).reduce((acc, invalidFragment)=>{
        return acc.replace(new RegExp(`...${invalidFragment}\n`, 'g'), '').replace($56093000e314999c$export$213ba2e9f2d143b9(invalidFragment), '');
    }, allFragments);
}
const $56093000e314999c$var$IGNORED_ERROR_CLASSIFICATIONS = [
    'IncorrectAuthException'
];
function $56093000e314999c$export$c939d6148e47244a(response) {
    if (!response?.data || !Array.isArray(response.errors)) return false;
    const filteredAggErrors = response.errors.filter((e)=>!e.extensions.classification || !$56093000e314999c$var$IGNORED_ERROR_CLASSIFICATIONS.includes(e.extensions.classification));
    return filteredAggErrors.length > 0 && $56093000e314999c$export$884573c560ed3600(response.data);
}
function $56093000e314999c$export$884573c560ed3600(queryData) {
    return !queryData.activity || $56093000e314999c$export$ea55e8e0446efa94(queryData.activity).all?.edges?.length === 0 && $56093000e314999c$export$ea55e8e0446efa94(queryData.activity).workedOn?.edges?.length === 0 && queryData.activity?.myActivity?.viewed?.edges?.length === 0;
}

});




parcelRegister("e8iSm", function(module, exports) {

$parcel$export(module.exports, "RecentActivityContainer", () => $468ae279ad84e880$export$7143acbf492040ba);
$parcel$export(module.exports, "useRecentActivities", () => $468ae279ad84e880$export$623d449f25492804);
$parcel$export(module.exports, "useRecentActivitiesActions", () => $468ae279ad84e880$export$394af696e502ba5d);
// eslint-disable-next-line jira/restricted/@atlassian/react-sweet-state

var $gg7kZ = parcelRequire("gg7kZ");
var $3sQ5x = parcelRequire("3sQ5x");
var $iXqE5 = parcelRequire("iXqE5");

var $8PtXb = parcelRequire("8PtXb");
const $468ae279ad84e880$var$initialState = {
    items: null,
    fetchError: null,
    hasSuccessOnce: false,
    isFetching: false,
    promise: null
};
const $468ae279ad84e880$var$store = (0, $iXqE5.createStore)({
    actions: $8PtXb.actions,
    initialState: $468ae279ad84e880$var$initialState,
    name: 'navigation-your-work-recent-activites'
});
const $468ae279ad84e880$export$7143acbf492040ba = (0, $gg7kZ.createContainer)($468ae279ad84e880$var$store);
const $468ae279ad84e880$export$623d449f25492804 = (0, $3sQ5x.createHook)($468ae279ad84e880$var$store);
const $468ae279ad84e880$export$394af696e502ba5d = (0, $3sQ5x.createHook)($468ae279ad84e880$var$store, {
    selector: null
});

});
parcelRegister("8PtXb", function(module, exports) {

$parcel$export(module.exports, "actions", () => $b1f4ac60f5b38eb1$export$e324594224ef24da);

var $4R6GH = parcelRequire("4R6GH");
const $b1f4ac60f5b38eb1$var$PRODUCTS = [
    'jira'
];
const $b1f4ac60f5b38eb1$var$loadRecentActivities = ()=>async ({ setState: setState }, meta)=>{
        setState({
            isFetching: true,
            fetchError: null
        });
        try {
            const filter = (0, $4R6GH.fg)('blu-3344-worked-on-menu-fix') ? {
                limit: 10,
                rootContainerIds: [
                    `ari:cloud:platform::site/${meta.cloudId}`
                ],
                products: $b1f4ac60f5b38eb1$var$PRODUCTS
            } : {
                limit: 10,
                rootContainerIds: [
                    `ari:cloud:platform::site/${meta.cloudId}`
                ],
                objectTypes: [
                    'issue'
                ],
                products: $b1f4ac60f5b38eb1$var$PRODUCTS
            };
            const promise = meta.activityClient.fetchActivities([
                50,
                125,
                250
            ], filter, [
                'workedOn'
            ]);
            setState({
                promise: promise
            });
            const activityItems = await promise;
            setState({
                hasSuccessOnce: true,
                items: activityItems,
                isFetching: false
            });
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        } catch (error) {
            setState({
                isFetching: false,
                fetchError: error
            });
        }
    };
const $b1f4ac60f5b38eb1$export$e324594224ef24da = {
    loadRecentActivities: $b1f4ac60f5b38eb1$var$loadRecentActivities
};

});


parcelRegister("bJsBT", function(module, exports) {

$parcel$export(module.exports, "AsyncMenu", () => $6ff062438cc4c15e$export$81adf29ff528dc9c);

var $5uXOq = parcelRequire("5uXOq");

var $7CMCs = parcelRequire("7CMCs");

var $lfTZh = parcelRequire("lfTZh");

var $kxZPA = parcelRequire("kxZPA");

var $Mp6qH = parcelRequire("Mp6qH");

// eslint-disable-next-line jira/deprecations/no-rll-client-async-experiences
const $6ff062438cc4c15e$var$LazyMenu = (0, $kxZPA.lazy)(()=>(parcelRequire("crKqf")).then(({ Menu: Menu })=>Menu), {
    moduleId: "./src/packages/navigation-apps/atlassian-navigation/src/ui/your-work-dropdown/menu/index.tsx"
});
const $6ff062438cc4c15e$export$81adf29ff528dc9c = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7CMCs.JSErrorBoundary), {
        id: "your-work-dropdown-menu",
        packageName: (0, $Mp6qH.PACKAGE_NAME),
        teamName: "navigation",
        fallback: "flag"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $lfTZh.default), {
        name: "your-work-dropdown-menu",
        fallback: null
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($6ff062438cc4c15e$var$LazyMenu, null)));

});
parcelRegister("crKqf", function(module, exports) {

let $90fc042a68eb48e8$var$load = (parcelRequire("28QjX"))(4);
module.exports = Promise.all([
    $90fc042a68eb48e8$var$load("kNFvF"),
    $90fc042a68eb48e8$var$load("jJplv")
]).then(()=>parcelRequire('j5yhG'));

});


parcelRegister("fFuPf", function(module, exports) {

$parcel$export(module.exports, "default", () => $29c95956b90fd313$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $29c95956b90fd313$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    title: {
        "id": "atlassian-navigation.your-work-dropdown.title",
        "defaultMessage": "Your work"
    }
});

});


parcelRegister("a5zoF", function(module, exports) {

$parcel$export(module.exports, "Projects", () => $a73319cb81e190a5$export$ca6fbb51b35e375c);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $8Uumt = parcelRequire("8Uumt");

var $cmzJ2 = parcelRequire("cmzJ2");

var $kklBj = parcelRequire("kklBj");

var $13iNl = parcelRequire("13iNl");

var $kaHBi = parcelRequire("kaHBi");

var $bcn6L = parcelRequire("bcn6L");

var $koVbs = parcelRequire("koVbs");

var $d40Fj = parcelRequire("d40Fj");

var $lmyls = parcelRequire("lmyls");

var $8zOmE = parcelRequire("8zOmE");
var $2NMNM = parcelRequire("2NMNM");

var $apeap = parcelRequire("apeap");

var $hchBL = parcelRequire("hchBL");

var $90yGq = parcelRequire("90yGq");

var $k9JTq = parcelRequire("k9JTq");

var $cZpsT = parcelRequire("cZpsT");

var $DVljb = parcelRequire("DVljb");

var $9OXo1 = parcelRequire("9OXo1");

var $c04PQ = parcelRequire("c04PQ");

var $Mp6qH = parcelRequire("Mp6qH");

var $4uXxK = parcelRequire("4uXxK");

var $fVbkk = parcelRequire("fVbkk");

var $ebYJ0 = parcelRequire("ebYJ0");

var $f7TWB = parcelRequire("f7TWB");

var $b21tm = parcelRequire("b21tm");
const $a73319cb81e190a5$var$ProjectsAnonymous = ()=>{
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const baseUrl = '';
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $fVbkk.MenuTrigger), {
        href: `${baseUrl}/jira/projects`,
        menuId: (0, $lmyls.MENU_ID).PROJECTS,
        navigationItemId: (0, $Mp6qH.NAVIGATION_ITEM_ID).PROJECTS
    }, formatMessage((0, $b21tm.default).projects));
};
const $a73319cb81e190a5$var$ProjectsLoggedIn = ()=>{
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const locale = (0, $DVljb.useLocale)();
    const accountId = (0, $90yGq.useAccountId)();
    const isInFedRamp = (0, $c04PQ.isFedRamp)();
    const { cloudId: cloudId, licensedProducts: licensedProducts, firstActivationDateMs: firstActivationDateMs, areProductSuggestionsEnabled: areProductSuggestionsEnabled } = (0, $9OXo1.useTenantContext)();
    const [, { register: register }] = (0, $hchBL.useGlobalRefStoreActions)();
    const [{ hasFetchedOnce: hasFetchedOnceFavorites }, { loadFavoriteProjects: loadFavorite }] = (0, $bcn6L.useFavoriteProjects)();
    const [, { loadRecentProjects: loadRecent }] = (0, $apeap.useRecentProjects)();
    const [, { loadRecommendations: loadRecommendations }] = (0, $cmzJ2.useProjectMenuRecommendations)();
    const { software: edition } = (0, $k9JTq.useAppEditions)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $2NMNM.useAnalyticsEvents)();
    const environment = (0, $8Uumt.useRelayEnvironment)();
    const [{ hasSuccessOnce: hasFetchedCreateProjectPermissions, canCreateProject: canCreateProject }] = (0, $d40Fj.useCreateProjectPermission)();
    const onStart = (0, $kaHBi.useExperienceStart)({
        experience: (0, $Mp6qH.EXPERIENCE_NAVIGATION_TOP_MENU),
        experienceId: (0, $Mp6qH.NAVIGATION_ITEM_ID).PROJECTS,
        analyticsSource: 'atlassian-navigation'
    });
    const onBeforeMenuOpen = (0, $5uXOq.useCallback)(()=>{
        onStart();
        (0, $kklBj.projectsMenuDropdownRecommendationSelector).start();
        // refresh recents on open to add recently visited pages
        loadRecent((0, $Mp6qH.DEFAULT_LOAD_COUNT_RECENT));
        if (accountId) {
            (0, $8zOmE.fireUIAnalytics)(createAnalyticsEvent({}), 'dropdown viewed', 'projectsMenuDropdown');
            if (hasFetchedCreateProjectPermissions) loadRecommendations((0, $13iNl.recommendations), {
                locale: locale,
                cloudId: cloudId,
                accountId: accountId,
                licensedProducts: licensedProducts,
                edition: edition,
                firstActivationDateMs: firstActivationDateMs,
                areProductSuggestionsEnabled: areProductSuggestionsEnabled,
                environment: environment,
                canCreateProject: canCreateProject,
                isInFedRamp: isInFedRamp
            }, createAnalyticsEvent({}));
        }
        // load favourites only if not loaded already (optimisation to reduce requests)
        if (!hasFetchedOnceFavorites) loadFavorite((0, $Mp6qH.DEFAULT_LOAD_COUNT_FAV));
    }, [
        onStart,
        loadRecent,
        accountId,
        hasFetchedOnceFavorites,
        loadFavorite,
        createAnalyticsEvent,
        hasFetchedCreateProjectPermissions,
        loadRecommendations,
        locale,
        cloudId,
        licensedProducts,
        edition,
        firstActivationDateMs,
        areProductSuggestionsEnabled,
        environment,
        canCreateProject,
        isInFedRamp
    ]);
    const onRef = (0, $5uXOq.useCallback)((ref)=>{
        // We want the last of these nodes, but can spotlight as a fallback any intermediaries
        // It may cause the spotlight border to be bigger than intended (around the entire block element)
        // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
        const refToFirstChild = ref && ref.firstChild;
        const refToFirstGrandchild = // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
        refToFirstChild && refToFirstChild.firstChild;
        const refToFirstGreatGrandchild = // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
        refToFirstGrandchild && refToFirstGrandchild.firstChild;
        register(`NAVIGATION_${(0, $lmyls.MENU_ID).PROJECTS}`, refToFirstGreatGrandchild || refToFirstGrandchild || refToFirstChild || ref);
    }, [
        register
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($a73319cb81e190a5$export$e6dfd72ab29f8598, {
        ref: onRef
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $ebYJ0.Popup), {
        menuId: (0, $lmyls.MENU_ID).PROJECTS,
        navigationItemId: (0, $Mp6qH.NAVIGATION_ITEM_ID).PROJECTS,
        Menu: (0, $f7TWB.Menu),
        onBeforeMenuOpen: onBeforeMenuOpen,
        label: formatMessage((0, $b21tm.default).projects)
    }, formatMessage((0, $b21tm.default).projects)));
};
const $a73319cb81e190a5$var$ProjectWithAuth = ()=>{
    const isAnonymous = (0, $cZpsT.useIsAnonymous)();
    return isAnonymous ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($a73319cb81e190a5$var$ProjectsAnonymous, null) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($a73319cb81e190a5$var$ProjectsLoggedIn, null);
};
const $a73319cb81e190a5$export$ca6fbb51b35e375c = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $4uXxK.TopLevelErrorBoundary), {
        id: (0, $lmyls.MENU_ID).PROJECTS
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($a73319cb81e190a5$var$ProjectWithAuth, null)); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
const $a73319cb81e190a5$export$e6dfd72ab29f8598 = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_syaz1fxt _4t3i1osq _ae4v1h6o _11l41osq",
            false && "_1kibidpf _1laeidpf _1f5yidpf _kq8jidpf",
            __cmplp.className
        ])
    });
});

});
parcelRegister("hchBL", function(module, exports) {

$parcel$export(module.exports, "useGlobalRef", () => $b03364e48d8512c5$export$361e4f658203e95);
$parcel$export(module.exports, "useGlobalRefStoreActions", () => $b03364e48d8512c5$export$3c6c6911d09d7d8a);
$parcel$export(module.exports, "withGlobalRef", () => $b03364e48d8512c5$export$6b4b878b04fd3017);

var $5uXOq = parcelRequire("5uXOq");

var $gg7kZ = parcelRequire("gg7kZ");
var $3sQ5x = parcelRequire("3sQ5x");
var $iXqE5 = parcelRequire("iXqE5");
const $b03364e48d8512c5$var$store = (0, $iXqE5.createStore)({
    initialState: {},
    actions: {
        register: (key, ref)=>({ setState: setState })=>{
                setState({
                    [key]: ref || undefined
                });
            }
    },
    name: 'refs-store'
});
const $b03364e48d8512c5$export$4beaa3baa53198e4 = (0, $gg7kZ.createContainer)($b03364e48d8512c5$var$store);
const $b03364e48d8512c5$var$useGlobalRefStateSelector = (0, $3sQ5x.createStateHook)($b03364e48d8512c5$var$store, {
    selector: (state, key)=>state[key]
});
const $b03364e48d8512c5$export$361e4f658203e95 = (key)=>[
        // eslint-disable-next-line @typescript-eslint/consistent-type-assertions, @typescript-eslint/no-explicit-any
        $b03364e48d8512c5$var$useGlobalRefStateSelector(key)
    ];
const $b03364e48d8512c5$export$3c6c6911d09d7d8a = (0, $3sQ5x.createHook)($b03364e48d8512c5$var$store, {
    selector: null
});
const $b03364e48d8512c5$export$6b4b878b04fd3017 = (propName, refName)=>(Component)=>(props)=>{
            const [ref] = $b03364e48d8512c5$export$361e4f658203e95(refName);
            // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(Component, {
                ...props,
                [propName]: ref
            });
        };

});

parcelRegister("f7TWB", function(module, exports) {

$parcel$export(module.exports, "Menu", () => $14a03ca5c167a73f$export$d9b273488cd8ce6f);

var $5uXOq = parcelRequire("5uXOq");

var $9UCCQ = parcelRequire("9UCCQ");

var $5Fk4Z = parcelRequire("5Fk4Z");

var $13iNl = parcelRequire("13iNl");

var $bEK4U = parcelRequire("bEK4U");

var $kLaXN = parcelRequire("kLaXN");

var $7CMCs = parcelRequire("7CMCs");

var $93jKl = parcelRequire("93jKl");

var $bcn6L = parcelRequire("bcn6L");

var $d40Fj = parcelRequire("d40Fj");

var $lmyls = parcelRequire("lmyls");

var $6cNb0 = parcelRequire("6cNb0");

var $lfTZh = parcelRequire("lfTZh");

var $Mp6qH = parcelRequire("Mp6qH");

var $8vzcp = parcelRequire("8vzcp");

var $ag3sS = parcelRequire("ag3sS");

var $9TMfX = parcelRequire("9TMfX");

var $6WLja = parcelRequire("6WLja");

var $2KGAL = parcelRequire("2KGAL");

var $1xLtH = parcelRequire("1xLtH");

var $4nCpW = parcelRequire("4nCpW");

var $4ci63 = parcelRequire("4ci63");

var $i4bJa = parcelRequire("i4bJa");
const $14a03ca5c167a73f$var$EVENT_DATA = {
    id: (0, $lmyls.MENU_ID).PROJECTS
};
const $14a03ca5c167a73f$export$d9b273488cd8ce6f = ({ AuthenticationErrorBoundary: AuthenticationErrorBoundary = (0, $kLaXN.AuthenticationErrorBoundary), Empty: Empty = (0, $2KGAL.Empty), Error: Error = (0, $8vzcp.MenuError), FavoriteContent: FavoriteContent = (0, $1xLtH.FavoriteContent), Footer: Footer = (0, $4nCpW.Footer), JSErrorBoundary: JSErrorBoundary = (0, $7CMCs.JSErrorBoundary), Layout: Layout = (0, $ag3sS.MenuLayout), LoadStatus: LoadStatus = (0, $4ci63.LoadStatus), RecentContent: RecentContent = (0, $i4bJa.RecentContent), RecommendationSelector: RecommendationSelector = (0, $bEK4U.RecommendationSelector), recommendations: recommendations = (0, $13iNl.recommendations), Section: Section = (0, $9UCCQ.default), SkeletonContent: SkeletonContent = (0, $9TMfX.MenuSkeletonContent), SkeletonFooter: SkeletonFooter = (0, $6WLja.MenuSkeletonFooter), SpotlightTarget: SpotlightTarget = (0, $5Fk4Z.default), testIdPrefix: testIdPrefix, useCreateProjectPermission: // @ts-expect-error - TS2322 - Type 'HookFunction<State, BoundActions<State, { readonly fetchCreateProjectPermission: (baseUrl: string) => Action<State, void, void | Promise<void>>; }>, void>' is not assignable to type 'UseCreateProjectPermissionType'.
useCreateProjectPermission = (0, $d40Fj.useCreateProjectPermission), useExperienceFail: useExperienceFail = (0, $93jKl.useExperienceFail), useFavorite: useFavorite = (0, $bcn6L.useFavoriteProjects) })=>{
    const [, { loadFavoriteProjects: loadFavorite }] = useFavorite();
    const [{ hasFetchedOnce: hasFetchedOncePermissions, isFetching: isFetching }, { fetchCreateProjectPermission: fetchCreateProjectPermission }] = useCreateProjectPermission();
    const onFail = useExperienceFail({
        experience: (0, $Mp6qH.EXPERIENCE_NAVIGATION_TOP_MENU)
    });
    (0, $5uXOq.useEffect)(()=>()=>{
            // Refresh favourites on close to update if user has toggled any item
            loadFavorite((0, $Mp6qH.DEFAULT_LOAD_COUNT_FAV));
        }, [
        loadFavorite
    ]);
    (0, $5uXOq.useEffect)(()=>{
        if (!hasFetchedOncePermissions && !isFetching) fetchCreateProjectPermission();
    }, [
        hasFetchedOncePermissions,
        isFetching,
        fetchCreateProjectPermission
    ]);
    const testIdContent = (0, $6cNb0.testIdConcat)(testIdPrefix, 'content');
    const testIdFooter = (0, $6cNb0.testIdConcat)(testIdPrefix, 'footer');
    const errorFallback = (0, $5uXOq.useCallback)(()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(Error, {
            testIdPrefix: testIdContent
        }), // eslint-disable-next-line react-hooks/exhaustive-deps
    [
        testIdContent
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(SpotlightTarget, {
        name: (0, $Mp6qH.PROJECTS_SPOTLIGHT_KEY)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(Layout, {
        isWide: true
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(Section, {
        isScrollable: true
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(JSErrorBoundary, {
        id: (0, $lmyls.MENU_ID).PROJECTS,
        packageName: (0, $Mp6qH.PACKAGE_NAME),
        fallback: errorFallback,
        withExperienceTracker: true,
        extraEventData: $14a03ca5c167a73f$var$EVENT_DATA,
        onError: onFail
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(AuthenticationErrorBoundary, {
        render: errorFallback
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(Empty, {
        testIdPrefix: testIdContent
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $lfTZh.default), {
        name: "filters",
        fallback: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(SkeletonContent, {
            testIdPrefix: testIdContent
        })
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(LoadStatus, {
        shouldThrowError: true
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(FavoriteContent, {
        testIdPrefix: testIdContent
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(RecentContent, {
        testIdPrefix: testIdContent
    })))))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(RecommendationSelector, {
        recommendations: recommendations
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(Section, {
        hasSeparator: true
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $lfTZh.default), {
        name: "footer",
        fallback: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(SkeletonFooter, {
            testIdPrefix: testIdFooter
        })
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(LoadStatus, null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(Footer, {
        testIdPrefix: testIdFooter
    })))));
};

});
parcelRegister("bEK4U", function(module, exports) {

$parcel$export(module.exports, "RecommendationSelector", () => $3c478d901993099b$export$f97cd4c3e697ffee);

var $5uXOq = parcelRequire("5uXOq");

var $7CMCs = parcelRequire("7CMCs");

var $iXVV6 = parcelRequire("iXVV6");

var $ce4pa = parcelRequire("ce4pa");

var $cmzJ2 = parcelRequire("cmzJ2");

var $kklBj = parcelRequire("kklBj");
const $3c478d901993099b$export$f97cd4c3e697ffee = ({ recommendations: recommendations })=>{
    const [state] = (0, $cmzJ2.useProjectMenuRecommendations)();
    if (state.status !== 'success') return null;
    const selectedRecommendation = recommendations.find((recommendation)=>recommendation.key === state.recommendationKey);
    return selectedRecommendation ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7CMCs.JSErrorBoundary), {
        id: `projects-menu-recommendation.${selectedRecommendation.key}`,
        packageName: "jiraAtlassianNavigationRecommendations",
        onError: ()=>(0, $kklBj.projectsMenuDropdownRecommendationSelector).failure(),
        fallback: "unmount",
        teamName: "navigation"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $iXVV6.ContextualAnalyticsData), {
        attributes: {
            recommendationKey: selectedRecommendation.key
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $ce4pa.ExperienceSuccess), {
        experience: (0, $kklBj.projectsMenuDropdownRecommendationSelector)
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(selectedRecommendation.Component, null))) : null;
};

});

parcelRegister("kLaXN", function(module, exports) {

$parcel$export(module.exports, "AuthenticationErrorBoundary", () => $2792454dc55144b9$export$124b2dc1d1aab5e6);

var $5uXOq = parcelRequire("5uXOq");

var $fPruT = parcelRequire("fPruT");
class $2792454dc55144b9$export$124b2dc1d1aab5e6 extends (0, $5uXOq.Component) {
    componentDidCatch(error, info) {
        if (error instanceof (0, $fPruT.AuthenticationError)) {
            this.setState({
                caughtError: {
                    error: error,
                    info: info
                }
            });
            return;
        }
        throw error;
    }
    render() {
        const { caughtError: caughtError } = this.state;
        const { children: children, render: renderFallback } = this.props;
        if (!caughtError) return children;
        return renderFallback();
    }
    constructor(...args){
        super(...args), this.state = {
            caughtError: null
        };
    }
}

});

parcelRegister("2KGAL", function(module, exports) {

$parcel$export(module.exports, "Empty", () => $bae626c9288cadc7$export$1f74963c34e8bfec);

var $5uXOq = parcelRequire("5uXOq");

var $e4yMr = parcelRequire("e4yMr");

var $dS3PR = parcelRequire("dS3PR");

var $4R6GH = parcelRequire("4R6GH");

var $3bQtK = parcelRequire("3bQtK");

var $bcn6L = parcelRequire("bcn6L");

var $aWse0 = parcelRequire("aWse0");

var $6cNb0 = parcelRequire("6cNb0");

var $apeap = parcelRequire("apeap");

var $cZpsT = parcelRequire("cZpsT");

var $Mp6qH = parcelRequire("Mp6qH");

var $jyltl = parcelRequire("jyltl");

var $dMJS0 = parcelRequire("dMJS0");

var $ih3MM = parcelRequire("ih3MM");

var $RQqjE = parcelRequire("RQqjE");
const $bae626c9288cadc7$var$learnMoreHref = 'https://confluence.atlassian.com/adminjiracloud/creating-editing-deleting-and-hiding-projects-844500729.html';
const $bae626c9288cadc7$export$1f74963c34e8bfec = ({ MenuInfo: MenuInfo = (0, $jyltl.MenuInfo), children: children, testIdPrefix: testIdPrefix, useExperienceSuccess: useExperienceSuccess = (0, $3bQtK.useExperienceSuccess), useFavorite: useFavorite = (0, $bcn6L.useFavoriteProjects), useIntl: useIntl = (0, $aWse0.useIntlV2), useIsAnonymous: useIsAnonymous = (0, $cZpsT.useIsAnonymous), useItems: useItems = (0, $dMJS0.useProjectNavItems), useRecent: useRecent = (0, $apeap.useRecentProjects) })=>{
    const { formatMessage: formatMessage } = useIntl();
    const isAnonymous = useIsAnonymous();
    const onSuccess = useExperienceSuccess({
        experience: (0, $Mp6qH.EXPERIENCE_NAVIGATION_TOP_MENU)
    });
    const text = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("div", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dS3PR.default), {
        as: "p"
    }, formatMessage((0, $RQqjE.default).emptyText))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("div", null, (0, $4R6GH.fg)('replace-anchor-with-link__navigation') ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $e4yMr.default), {
        href: $bae626c9288cadc7$var$learnMoreHref,
        target: "_blank",
        rel: "noopener noreferrer"
    }, formatMessage((0, $RQqjE.default).learnMore)) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("a", {
        href: $bae626c9288cadc7$var$learnMoreHref,
        target: "_blank",
        rel: "noopener noreferrer"
    }, formatMessage((0, $RQqjE.default).learnMore))));
    const [{ isFetching: isFetchingFavorite, hasSuccessOnce: hasSuccessOnceFavorite, fetchError: fetchErrorFavorite }] = useFavorite();
    const [{ isFetching: isFetchingRecent, hasSuccessOnce: hasSuccessOnceRecent, fetchError: fetchErrorRecent }] = useRecent();
    const { favoriteItems: favoriteItems, recentItems: recentItems } = useItems();
    const notEmpty = favoriteItems.length || //  should show fav items
    recentItems.length || // should show recent items
    isFetchingFavorite && !hasSuccessOnceFavorite || // should show fav skeleton
    isFetchingRecent && !hasSuccessOnceRecent || // should show recent skeleton
    fetchErrorFavorite || // should show error
    fetchErrorRecent; // should show error
    // it appears that when fetch error get thrown in loadstatus, the promise is still pending here
    // let's take the most simple approach for now
    const shouldShowEmptyForAnonymous = isAnonymous;
    const testId = (0, $6cNb0.testIdConcat)(testIdPrefix, 'empty');
    (0, $5uXOq.useEffect)(()=>{
        const isSuccess = hasSuccessOnceFavorite && hasSuccessOnceRecent;
        if (isSuccess) onSuccess();
    }, [
        hasSuccessOnceFavorite,
        hasSuccessOnceRecent,
        onSuccess
    ]);
    return notEmpty && !shouldShowEmptyForAnonymous ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, children) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(MenuInfo, {
        imgAltText: formatMessage((0, $RQqjE.default).emptyImg),
        imgSrc: (0, (/*@__PURE__*/$parcel$interopDefault($ih3MM))),
        imgHeight: 138,
        testId: testId,
        text: text
    });
};

});
parcelRegister("ih3MM", function(module, exports) {
module.exports = new URL("project-empty.0864e274.svg", import.meta.url).toString();

});

parcelRegister("RQqjE", function(module, exports) {

$parcel$export(module.exports, "default", () => $15aec9727c6dd925$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $15aec9727c6dd925$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    emptyText: {
        "id": "atlassian-navigation.projects.menu.empty.empty-text",
        "defaultMessage": "Make the most of your Atlassian products by extending them with projects."
    },
    learnMore: {
        "id": "atlassian-navigation.projects.menu.empty.learn-more",
        "defaultMessage": "Learn more"
    },
    emptyImg: {
        "id": "atlassian-navigation.projects.menu.empty.empty-img",
        "defaultMessage": "An image showing that the projects dropdown menu is empty"
    }
});

});


parcelRegister("1xLtH", function(module, exports) {

$parcel$export(module.exports, "FavoriteContent", () => $e1a4963a7cc4d825$export$297af018011b145a);

var $5uXOq = parcelRequire("5uXOq");

var $ujWmd = parcelRequire("ujWmd");

var $4mNf3 = parcelRequire("4mNf3");

var $eXQym = parcelRequire("eXQym");

var $koVbs = parcelRequire("koVbs");

var $2EqxS = parcelRequire("2EqxS");

var $6cNb0 = parcelRequire("6cNb0");

var $Mp6qH = parcelRequire("Mp6qH");

var $fhtpB = parcelRequire("fhtpB");

var $d4B4Y = parcelRequire("d4B4Y");

var $7ilb8 = parcelRequire("7ilb8");

var $56fXm = parcelRequire("56fXm");

var $dMJS0 = parcelRequire("dMJS0");

var $Yyrw8 = parcelRequire("Yyrw8");
const $e1a4963a7cc4d825$export$297af018011b145a = ({ testIdPrefix: testIdPrefix })=>{
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const { favoriteItems: favoriteItems, changeFavorite: onChangeFavorite, changedItems: changedItems } = (0, $dMJS0.useProjectNavItems)();
    const itemsToShow = (0, $5uXOq.useMemo)(()=>favoriteItems.slice(0, (0, $Mp6qH.DEFAULT_LOAD_COUNT_FAV)), [
        favoriteItems
    ]);
    const testId = (0, $6cNb0.testIdConcat)(testIdPrefix, 'items-starred');
    const projectsUrl = '/jira/projects?page=1&sortKey=favourite&sortOrder=DESC';
    return favoriteItems.length > 0 ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("span", {
        "data-testid": testId
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $4mNf3.default), {
        testId: (0, $6cNb0.testIdConcat)(testId, 'heading')
    }, formatMessage((0, $Yyrw8.default).starred)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7ilb8.MenuList), null, itemsToShow.map((item, idx)=>{
        const { url: url, id: id, favourite: isFavourite, metadata: metadata, title: title } = item;
        const contextItem = changedItems[item.id.toString()];
        const isPending = contextItem && contextItem.pending === true ? contextItem.pending : false;
        const { params: params, query: query, route: to } = (0, $2EqxS.getLinkFromProject)(item);
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7ilb8.MenuListItem), {
            key: id,
            ariaLabel: formatMessage((0, $Yyrw8.default).starred)
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $d4B4Y.MenuItem), {
            analytics: {
                actionSubjectId: 'projectsNavigationMenuItem',
                menuItemId: id,
                menuItemType: 'starred',
                position: idx,
                starred: Boolean(isFavourite)
            },
            description: metadata,
            href: url,
            iconBefore: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $ujWmd.default), {
                appearance: "square",
                size: "small",
                borderColor: "transparent",
                src: item.avatarUrl
            }),
            iconAfter: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $fhtpB.FavoriteButton), {
                id: String(id),
                isFavorite: Boolean(isFavourite),
                favoriteItemName: title,
                isPending: isPending,
                menuItemType: "starred",
                onChangeFavorite: onChangeFavorite,
                type: (0, $eXQym.PROJECTS_ITEM_TYPE)
            }),
            params: params,
            query: query,
            testId: (0, $6cNb0.testIdConcat)(testId, `item-${idx}`),
            to: to,
            "aria-label": `${title} ${metadata || ''}`
        }, title));
    })), favoriteItems.length >= (0, $Mp6qH.DEFAULT_LOAD_COUNT_FAV) && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $56fXm.MenuItemViewAll), {
        analytics: {
            actionSubjectId: 'projectsNavigationMenuItem',
            menuItemId: 'viewAll',
            // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
            position: (0, $Mp6qH.DEFAULT_LOAD_COUNT_FAV)
        },
        href: projectsUrl,
        testId: (0, $6cNb0.testIdConcat)(testId, 'item-view-all'),
        to: projectsUrl
    })) : null;
};

});
parcelRegister("Yyrw8", function(module, exports) {

$parcel$export(module.exports, "default", () => $826ed05c79892831$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $826ed05c79892831$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    starred: {
        "id": "atlassian-navigation.projects.menu.favorite-content.starred",
        "defaultMessage": "Starred"
    }
});

});


parcelRegister("4nCpW", function(module, exports) {

$parcel$export(module.exports, "Footer", () => $feb4a5abece4d737$export$a06f1c675e846f6f);

var $5uXOq = parcelRequire("5uXOq");

var $koVbs = parcelRequire("koVbs");

var $d40Fj = parcelRequire("d40Fj");

var $6cNb0 = parcelRequire("6cNb0");

var $foR3E = parcelRequire("foR3E");

var $e9QkH = parcelRequire("e9QkH");

var $cZpsT = parcelRequire("cZpsT");

var $Mp6qH = parcelRequire("Mp6qH");

var $d4B4Y = parcelRequire("d4B4Y");

var $kdlJi = parcelRequire("kdlJi");
const $feb4a5abece4d737$export$a06f1c675e846f6f = ({ testIdPrefix: testIdPrefix })=>{
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const isAnonymous = (0, $cZpsT.useIsAnonymous)();
    const [, { on: openProjectCreateDrawer }] = (0, $e9QkH.useSwitchModals)((0, $Mp6qH.MODAL_ID).PROJECT_CREATE);
    const [{ canCreateProject: canCreateProject }] = (0, $d40Fj.useCreateProjectPermission)();
    const testId = (0, $6cNb0.testIdConcat)(testIdPrefix, 'items');
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("span", {
        "data-testid": testId
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $d4B4Y.MenuItem), {
        analytics: {
            actionSubjectId: 'projectsNavigationMenuItem',
            menuItemId: 'viewAll',
            menuItemType: 'action',
            position: 0
        },
        href: "/jira/projects",
        testId: (0, $6cNb0.testIdConcat)(testId, 'item-view-all'),
        to: (0, $foR3E.projectsDirectoryRoute)
    }, formatMessage((0, $kdlJi.default).viewAll)), !isAnonymous && canCreateProject && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $d4B4Y.MenuItem), {
        analytics: {
            actionSubjectId: 'projectsNavigationMenuItem',
            menuItemId: 'create',
            menuItemType: 'action',
            position: 1
        },
        onClick: openProjectCreateDrawer,
        testId: (0, $6cNb0.testIdConcat)(testId, 'item-create')
    }, formatMessage((0, $kdlJi.default).createProject)));
};

});
parcelRegister("foR3E", function(module, exports) {

$parcel$export(module.exports, "projectsDirectoryRoute", () => $00577c595d2649c4$export$74114064f06cd71b);
const $00577c595d2649c4$export$74114064f06cd71b = {
    name: 'projects-directory',
    path: '/jira/projects',
    exact: true
};

});

parcelRegister("e9QkH", function(module, exports) {

$parcel$export(module.exports, "useSwitchModals", () => $bbe85969245206f0$export$5ed4b99cbad4ebd6);

var $2qauD = parcelRequire("2qauD");
const { useSwitch: $bbe85969245206f0$var$useSwitch } = (0, $2qauD.createSwitchController)('jira-switch-modals');
const $bbe85969245206f0$export$5ed4b99cbad4ebd6 = $bbe85969245206f0$var$useSwitch;

});

parcelRegister("kdlJi", function(module, exports) {

$parcel$export(module.exports, "default", () => $54e62ef08eaa20a3$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $54e62ef08eaa20a3$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    createProject: {
        "id": "atlassian-navigation.projects.menu.footer.create-project",
        "defaultMessage": "Create project"
    },
    viewAll: {
        "id": "atlassian-navigation.projects.menu.footer.view-all",
        "defaultMessage": "View all projects"
    },
    importProject: {
        "id": "atlassian-navigation.projects.menu.footer.import-project",
        "defaultMessage": "Import project"
    }
});

});


parcelRegister("4ci63", function(module, exports) {

$parcel$export(module.exports, "LoadStatus", () => $0e36b7ec65a0b373$export$c7df4a3f1b89de01);

var $5uXOq = parcelRequire("5uXOq");

var $bcn6L = parcelRequire("bcn6L");

var $d40Fj = parcelRequire("d40Fj");

var $apeap = parcelRequire("apeap");

var $dHtVS = parcelRequire("dHtVS");
const $0e36b7ec65a0b373$export$c7df4a3f1b89de01 = ({ LoadStatusCommon: LoadStatusCommon = (0, $dHtVS.LoadStatus), shouldThrowError: shouldThrowError = false, useCreateProjectPermission: // @ts-expect-error - TS2322 - Type 'HookFunction<State, BoundActions<State, { readonly fetchCreateProjectPermission: (baseUrl: string) => Action<State, void, void | Promise<void>>; }>, void>' is not assignable to type 'UseCreateProjectPermissionType'.
useCreateProjectPermission = (0, $d40Fj.useCreateProjectPermission), useFavorite: useFavorite = (0, $bcn6L.useFavoriteProjects), useRecent: useRecent = (0, $apeap.useRecentProjects) })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(LoadStatusCommon, {
        shouldThrowError: shouldThrowError,
        useProvider: useCreateProjectPermission
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(LoadStatusCommon, {
        shouldThrowError: shouldThrowError,
        useProvider: useFavorite
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(LoadStatusCommon, {
        shouldThrowError: shouldThrowError,
        useProvider: useRecent
    }));

});

parcelRegister("i4bJa", function(module, exports) {

$parcel$export(module.exports, "RecentContent", () => $dd89c0b17853b373$export$a2873dc4e96d8e90);

var $5uXOq = parcelRequire("5uXOq");

var $ujWmd = parcelRequire("ujWmd");

var $4mNf3 = parcelRequire("4mNf3");

var $eXQym = parcelRequire("eXQym");

var $koVbs = parcelRequire("koVbs");

var $2EqxS = parcelRequire("2EqxS");

var $6cNb0 = parcelRequire("6cNb0");

var $Mp6qH = parcelRequire("Mp6qH");

var $fhtpB = parcelRequire("fhtpB");

var $d4B4Y = parcelRequire("d4B4Y");

var $7ilb8 = parcelRequire("7ilb8");

var $dMJS0 = parcelRequire("dMJS0");

var $9uulb = parcelRequire("9uulb");
const $dd89c0b17853b373$export$a2873dc4e96d8e90 = ({ testIdPrefix: testIdPrefix })=>{
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const { recentItems: recentItems, favoriteItems: favoriteItems, changeFavorite: onChangeFavorite, changedItems: changedItems } = (0, $dMJS0.useProjectNavItems)();
    const itemsToShow = (0, $5uXOq.useMemo)(()=>recentItems.slice(0, (0, $Mp6qH.DEFAULT_LOAD_COUNT_RECENT)), [
        recentItems
    ]);
    const testId = (0, $6cNb0.testIdConcat)(testIdPrefix, 'items-recent');
    return recentItems.length > 0 ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("span", {
        "data-testid": testId
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $4mNf3.default), {
        testId: (0, $6cNb0.testIdConcat)(testId, 'heading')
    }, formatMessage((0, $9uulb.default).recent)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7ilb8.MenuList), null, itemsToShow.map((item, idx)=>{
        const { url: url, id: id, favourite: isFavourite, metadata: metadata, title: title } = item;
        const contextItem = changedItems[item.id.toString()];
        const isPending = contextItem && contextItem.pending === true ? contextItem.pending : false;
        const { id: beforeEntityId, type: beforeEntityType } = (0, $2EqxS.getBeforeEntity)(favoriteItems);
        const { params: params, query: query, route: to } = (0, $2EqxS.getLinkFromProject)(item);
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7ilb8.MenuListItem), {
            key: id,
            ariaLabel: formatMessage((0, $9uulb.default).recent)
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $d4B4Y.MenuItem), {
            analytics: {
                actionSubjectId: 'projectsNavigationMenuItem',
                menuItemId: id,
                menuItemType: 'recent',
                position: idx,
                starred: Boolean(isFavourite)
            },
            description: metadata,
            href: url,
            iconBefore: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $ujWmd.default), {
                appearance: "square",
                size: "small",
                borderColor: "transparent",
                src: item.avatarUrl
            }),
            iconAfter: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $fhtpB.FavoriteButton), {
                beforeEntityId: beforeEntityId,
                beforeEntityType: beforeEntityType,
                id: String(id),
                isFavorite: Boolean(isFavourite),
                favoriteItemName: title,
                isPending: isPending,
                menuItemType: "recent",
                onChangeFavorite: onChangeFavorite,
                type: (0, $eXQym.PROJECTS_ITEM_TYPE)
            }),
            params: params,
            query: query,
            testId: (0, $6cNb0.testIdConcat)(testId, `item-${idx}`),
            to: to,
            "aria-label": `${title} ${metadata || ''}`
        }, title));
    }))) : null;
};

});
parcelRegister("9uulb", function(module, exports) {

$parcel$export(module.exports, "default", () => $58ba7fa57975d970$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $58ba7fa57975d970$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    recent: {
        "id": "atlassian-navigation.projects.menu.recent-content.recent",
        "defaultMessage": "Recent"
    }
});

});



parcelRegister("b21tm", function(module, exports) {

$parcel$export(module.exports, "default", () => $7d7261af77ace424$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $7d7261af77ace424$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    projects: {
        "id": "atlassian-navigation.projects.projects",
        "defaultMessage": "Projects"
    }
});

});


parcelRegister("jSplz", function(module, exports) {

$parcel$export(module.exports, "Filters", () => $05595fb4c275b9c8$export$92a576f896a9bf72);

var $5uXOq = parcelRequire("5uXOq");

var $kaHBi = parcelRequire("kaHBi");

var $bcn6L = parcelRequire("bcn6L");

var $koVbs = parcelRequire("koVbs");

var $lmyls = parcelRequire("lmyls");

var $apeap = parcelRequire("apeap");

var $cZpsT = parcelRequire("cZpsT");

var $Mp6qH = parcelRequire("Mp6qH");

var $4uXxK = parcelRequire("4uXxK");

var $fVbkk = parcelRequire("fVbkk");

var $4XiFK = parcelRequire("4XiFK");

var $ebYJ0 = parcelRequire("ebYJ0");

var $kawVZ = parcelRequire("kawVZ");

var $7ikvo = parcelRequire("7ikvo");
const $05595fb4c275b9c8$var$FiltersAnonymous = ()=>{
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $fVbkk.MenuTrigger), {
        href: "/jira/filters?searchName=&Search=Search&filterView=search",
        menuId: (0, $lmyls.MENU_ID).FILTERS,
        navigationItemId: (0, $Mp6qH.NAVIGATION_ITEM_ID).FILTERS
    }, formatMessage((0, $7ikvo.default).filters));
};
const $05595fb4c275b9c8$var$FiltersLoggedIn = ()=>{
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const [{ hasFetchedOnce: hasFetchedOnceFavorites }, { loadFavoriteFilters: loadFavorite }] = (0, $bcn6L.useFavoriteFilters)();
    const [, { loadRecentFilters: loadRecent }] = (0, $apeap.useRecentFilters)();
    const onStart = (0, $kaHBi.useExperienceStart)({
        experience: (0, $Mp6qH.EXPERIENCE_NAVIGATION_TOP_MENU),
        experienceId: (0, $Mp6qH.NAVIGATION_ITEM_ID).FILTERS,
        analyticsSource: 'atlassian-navigation'
    });
    const onBeforeMenuOpen = (0, $5uXOq.useCallback)(()=>{
        onStart();
        // refresh recents on open to add recently visited pages
        loadRecent((0, $Mp6qH.DEFAULT_LOAD_COUNT_RECENT));
        // load favourites only if not loaded already (optimisation to reduce requests)
        if (!hasFetchedOnceFavorites) loadFavorite((0, $Mp6qH.DEFAULT_LOAD_COUNT_FAV));
    }, [
        hasFetchedOnceFavorites,
        loadFavorite,
        loadRecent,
        onStart
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $4XiFK.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $ebYJ0.Popup), {
        menuId: (0, $lmyls.MENU_ID).FILTERS,
        navigationItemId: (0, $Mp6qH.NAVIGATION_ITEM_ID).FILTERS,
        Menu: (0, $kawVZ.Menu),
        onBeforeMenuOpen: onBeforeMenuOpen,
        label: formatMessage((0, $7ikvo.default).filters)
    }, formatMessage((0, $7ikvo.default).filters)));
};
const $05595fb4c275b9c8$var$FiltersWithAuth = ()=>{
    const isAnonymous = (0, $cZpsT.useIsAnonymous)();
    return isAnonymous ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($05595fb4c275b9c8$var$FiltersAnonymous, null) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($05595fb4c275b9c8$var$FiltersLoggedIn, null);
};
const $05595fb4c275b9c8$export$92a576f896a9bf72 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $4uXxK.TopLevelErrorBoundary), {
        id: (0, $lmyls.MENU_ID).FILTERS
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($05595fb4c275b9c8$var$FiltersWithAuth, null));

});
parcelRegister("kawVZ", function(module, exports) {

$parcel$export(module.exports, "Menu", () => $37b6403ac89429a0$export$d9b273488cd8ce6f);

var $5uXOq = parcelRequire("5uXOq");

var $9UCCQ = parcelRequire("9UCCQ");

var $kLaXN = parcelRequire("kLaXN");

var $7CMCs = parcelRequire("7CMCs");

var $93jKl = parcelRequire("93jKl");

var $bcn6L = parcelRequire("bcn6L");

var $lmyls = parcelRequire("lmyls");

var $6cNb0 = parcelRequire("6cNb0");

var $lfTZh = parcelRequire("lfTZh");

var $Mp6qH = parcelRequire("Mp6qH");

var $8vzcp = parcelRequire("8vzcp");

var $ag3sS = parcelRequire("ag3sS");

var $9TMfX = parcelRequire("9TMfX");

var $6WLja = parcelRequire("6WLja");

var $aC6ao = parcelRequire("aC6ao");

var $bBBg3 = parcelRequire("bBBg3");

var $7xt41 = parcelRequire("7xt41");

var $1Q2KE = parcelRequire("1Q2KE");

var $lQ0sa = parcelRequire("lQ0sa");
const $37b6403ac89429a0$var$EVENT_DATA = {
    id: (0, $lmyls.MENU_ID).FILTERS
};
const $37b6403ac89429a0$export$d9b273488cd8ce6f = ({ AuthenticationErrorBoundary: AuthenticationErrorBoundary = (0, $kLaXN.AuthenticationErrorBoundary), Empty: Empty = (0, $aC6ao.Empty), Error: Error = (0, $8vzcp.MenuError), FavoriteContent: FavoriteContent = (0, $bBBg3.FavoriteContent), Footer: Footer = (0, $7xt41.Footer), JSErrorBoundary: JSErrorBoundary = (0, $7CMCs.JSErrorBoundary), Layout: Layout = (0, $ag3sS.MenuLayout), LoadStatus: LoadStatus = (0, $1Q2KE.LoadStatus), RecentContent: RecentContent = (0, $lQ0sa.RecentContent), Section: Section = (0, $9UCCQ.default), SkeletonContent: SkeletonContent = (0, $9TMfX.MenuSkeletonContent), SkeletonFooter: SkeletonFooter = (0, $6WLja.MenuSkeletonFooter), testIdPrefix: testIdPrefix, useExperienceFail: useExperienceFail = (0, $93jKl.useExperienceFail), useFavorite: useFavorite = (0, $bcn6L.useFavoriteFilters) })=>{
    const [, { loadFavoriteFilters: loadFavorite }] = useFavorite();
    const onFail = useExperienceFail({
        experience: (0, $Mp6qH.EXPERIENCE_NAVIGATION_TOP_MENU)
    });
    (0, $5uXOq.useEffect)(()=>()=>{
            // Refresh favourites on close to update if user has toggled any item
            loadFavorite((0, $Mp6qH.DEFAULT_LOAD_COUNT_FAV));
        }, [
        loadFavorite
    ]);
    const testIdContent = (0, $6cNb0.testIdConcat)(testIdPrefix, 'content');
    const testIdFooter = (0, $6cNb0.testIdConcat)(testIdPrefix, 'footer');
    const errorFallback = (0, $5uXOq.useCallback)(()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(Error, {
            testIdPrefix: testIdContent
        }), // eslint-disable-next-line react-hooks/exhaustive-deps
    [
        testIdContent
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(Layout, {
        isWide: true
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(Section, {
        isScrollable: true
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(JSErrorBoundary, {
        id: (0, $lmyls.MENU_ID).FILTERS,
        packageName: (0, $Mp6qH.PACKAGE_NAME),
        fallback: errorFallback,
        withExperienceTracker: true,
        extraEventData: $37b6403ac89429a0$var$EVENT_DATA,
        onError: onFail
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(AuthenticationErrorBoundary, {
        render: errorFallback
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(Empty, {
        testIdPrefix: testIdContent
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $lfTZh.default), {
        name: "atlassian-navigation-filters-menu",
        fallback: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(SkeletonContent, {
            testIdPrefix: testIdContent
        })
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(LoadStatus, {
        shouldThrowError: true
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(FavoriteContent, {
        testIdPrefix: testIdContent
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(RecentContent, {
        testIdPrefix: testIdContent
    })))))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(Section, {
        hasSeparator: true
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $lfTZh.default), {
        name: "atlassian-navigation-filters-footer",
        fallback: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(SkeletonFooter, {
            testIdPrefix: testIdFooter
        })
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(LoadStatus, null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(Footer, {
        testIdPrefix: testIdFooter
    }))));
};

});
parcelRegister("aC6ao", function(module, exports) {

$parcel$export(module.exports, "Empty", () => $c74c3409b5a3434a$export$1f74963c34e8bfec);

var $5uXOq = parcelRequire("5uXOq");

var $e4yMr = parcelRequire("e4yMr");

var $dS3PR = parcelRequire("dS3PR");

var $3bQtK = parcelRequire("3bQtK");

var $bcn6L = parcelRequire("bcn6L");

var $4R6GH = parcelRequire("4R6GH");

var $aWse0 = parcelRequire("aWse0");

var $6cNb0 = parcelRequire("6cNb0");

var $apeap = parcelRequire("apeap");

var $cZpsT = parcelRequire("cZpsT");

var $Mp6qH = parcelRequire("Mp6qH");

var $jyltl = parcelRequire("jyltl");

var $dMJS0 = parcelRequire("dMJS0");

var $c071b = parcelRequire("c071b");

var $dODGv = parcelRequire("dODGv");
const $c74c3409b5a3434a$var$learnMoreHref = 'https://confluence.atlassian.com/jirasoftwarecloud/searching-for-issues-764478280.html#Searchingforissues-SearchallofJira';
const $c74c3409b5a3434a$export$1f74963c34e8bfec = ({ MenuInfo: MenuInfo = (0, $jyltl.MenuInfo), children: children, testIdPrefix: testIdPrefix, useExperienceSuccess: useExperienceSuccess = (0, $3bQtK.useExperienceSuccess), useFavorite: useFavorite = (0, $bcn6L.useFavoriteFilters), useIntl: useIntl = (0, $aWse0.useIntlV2), useIsAnonymous: useIsAnonymous = (0, $cZpsT.useIsAnonymous), useItems: useItems = (0, $dMJS0.useFilterNavItems), useRecent: useRecent = (0, $apeap.useRecentFilters) })=>{
    const { formatMessage: formatMessage } = useIntl();
    const isAnonymous = useIsAnonymous();
    const onSuccess = useExperienceSuccess({
        experience: (0, $Mp6qH.EXPERIENCE_NAVIGATION_TOP_MENU)
    });
    const text = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("div", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dS3PR.default), {
        as: "p"
    }, formatMessage((0, $4R6GH.fg)('jira-issue-terminology-refresh-m3') ? (0, $dODGv.default).emptyTextIssueTermRefresh : (0, $dODGv.default).emptyText))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("div", null, (0, $4R6GH.fg)('replace-anchor-with-link__navigation') ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $e4yMr.default), {
        href: $c74c3409b5a3434a$var$learnMoreHref,
        target: "_blank",
        rel: "noopener noreferrer"
    }, formatMessage((0, $dODGv.default).learnMore)) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("a", {
        href: $c74c3409b5a3434a$var$learnMoreHref,
        target: "_blank",
        rel: "noopener noreferrer"
    }, formatMessage((0, $dODGv.default).learnMore))));
    const [{ isFetching: isFetchingFavorite, hasSuccessOnce: hasSuccessOnceFavorite, fetchError: fetchErrorFavorite }] = useFavorite();
    const [{ isFetching: isFetchingRecent, hasSuccessOnce: hasSuccessOnceRecent, fetchError: fetchErrorRecent }] = useRecent();
    const { favoriteItems: favoriteItems, recentItems: recentItems } = useItems();
    const notEmpty = favoriteItems.length || //  should show fav items
    recentItems.length || // should show recent items
    isFetchingFavorite && !hasSuccessOnceFavorite || // should show fav skeleton
    isFetchingRecent && !hasSuccessOnceRecent || // should show recent skeleton
    fetchErrorFavorite || // should show error
    fetchErrorRecent; // should show error
    const shouldShowEmptyForAnonymous = isAnonymous;
    (0, $5uXOq.useEffect)(()=>{
        const isSuccess = hasSuccessOnceFavorite && hasSuccessOnceRecent;
        if (isSuccess) onSuccess();
    }, [
        hasSuccessOnceFavorite,
        hasSuccessOnceRecent,
        onSuccess
    ]);
    const testId = (0, $6cNb0.testIdConcat)(testIdPrefix, 'empty');
    return notEmpty && !shouldShowEmptyForAnonymous ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, children) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(MenuInfo, {
        imgSrc: (0, (/*@__PURE__*/$parcel$interopDefault($c071b))),
        testId: testId,
        text: text
    });
};

});
parcelRegister("c071b", function(module, exports) {
module.exports = new URL("filter-empty.4c92f05b.svg", import.meta.url).toString();

});

parcelRegister("dODGv", function(module, exports) {

$parcel$export(module.exports, "default", () => $56a795574a4eb398$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $56a795574a4eb398$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    emptyText: {
        "id": "atlassian-navigation.filters.menu.empty.empty-text",
        "defaultMessage": "Search for issues across all projects and save them as filters."
    },
    learnMore: {
        "id": "atlassian-navigation.filters.menu.empty.learn-more",
        "defaultMessage": "Learn more"
    },
    emptyImg: {
        "id": "atlassian-navigation.filters.menu.empty.empty-img",
        "defaultMessage": "An image showing that the apps dropdown menu is empty"
    },
    emptyTextIssueTermRefresh: {
        "id": "atlassian-navigation.filters.menu.empty.empty-text-issue-term-refresh",
        "defaultMessage": "Search for work items across all projects and save them as filters."
    }
});

});


parcelRegister("bBBg3", function(module, exports) {

$parcel$export(module.exports, "FavoriteContent", () => $e72dd94e33471bbd$export$297af018011b145a);

var $5uXOq = parcelRequire("5uXOq");

var $2o8gl = parcelRequire("2o8gl");

var $4mNf3 = parcelRequire("4mNf3");

var $eXQym = parcelRequire("eXQym");

var $koVbs = parcelRequire("koVbs");

var $4zlUA = parcelRequire("4zlUA");

var $6cNb0 = parcelRequire("6cNb0");

var $f4La7 = parcelRequire("f4La7");

var $Mp6qH = parcelRequire("Mp6qH");

var $fhtpB = parcelRequire("fhtpB");

var $d4B4Y = parcelRequire("d4B4Y");

var $7ilb8 = parcelRequire("7ilb8");

var $56fXm = parcelRequire("56fXm");

var $dMJS0 = parcelRequire("dMJS0");

var $31jbO = parcelRequire("31jbO");
const $e72dd94e33471bbd$export$297af018011b145a = ({ testIdPrefix: testIdPrefix })=>{
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const { favoriteItems: favoriteItems, changeFavorite: onChangeFavorite, changedItems: changedItems } = (0, $dMJS0.useFilterNavItems)();
    const itemsToShow = (0, $5uXOq.useMemo)(()=>favoriteItems.slice(0, (0, $Mp6qH.DEFAULT_LOAD_COUNT_FAV)), [
        favoriteItems
    ]);
    const testId = (0, $6cNb0.testIdConcat)(testIdPrefix, 'items-starred');
    const filtersUrl = '/jira/filters?page=1&sortKey=favourite&sortOrder=DESC';
    return favoriteItems.length > 0 ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("span", {
        "data-testid": testId
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $4mNf3.default), {
        testId: (0, $6cNb0.testIdConcat)(testId, 'heading')
    }, formatMessage((0, $31jbO.default).starred)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7ilb8.MenuList), null, itemsToShow.map((item, idx)=>{
        const { url: url, id: id, favourite: isFavourite, title: title } = item;
        const contextItem = changedItems[item.id.toString()];
        const isPending = contextItem && contextItem.pending === true ? contextItem.pending : false;
        const filterParams = {
            issueKey: ''
        };
        const filterQuery = {
            filter: String(id)
        };
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7ilb8.MenuListItem), {
            key: id,
            ariaLabel: formatMessage((0, $31jbO.default).starred)
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $d4B4Y.MenuItem), {
            analytics: {
                actionSubjectId: 'filtersNavigationMenuItem',
                menuItemId: id,
                menuItemType: 'starred',
                position: idx,
                starred: Boolean(isFavourite)
            },
            href: url,
            iconBefore: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($2o8gl))), {
                spacing: "spacious",
                label: ""
            }),
            iconAfter: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $fhtpB.FavoriteButton), {
                id: String(id),
                isFavorite: Boolean(isFavourite),
                favoriteItemName: title,
                isPending: isPending,
                menuItemType: "starred",
                onChangeFavorite: onChangeFavorite,
                type: (0, $eXQym.FILTERS_ITEM_TYPE)
            }),
            params: filterParams,
            query: filterQuery,
            testId: (0, $6cNb0.testIdConcat)(testId, `item-${idx}`),
            to: (0, $f4La7.globalIssueNavigatorRoute),
            onClick: (0, $4zlUA.handleGinSPAClick),
            "aria-label": title
        }, title));
    })), favoriteItems.length >= (0, $Mp6qH.DEFAULT_LOAD_COUNT_FAV) && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $56fXm.MenuItemViewAll), {
        analytics: {
            actionSubjectId: 'filtersNavigationMenuItem',
            menuItemId: 'viewAll',
            // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
            position: (0, $Mp6qH.DEFAULT_LOAD_COUNT_FAV)
        },
        href: filtersUrl,
        testId: (0, $6cNb0.testIdConcat)(testId, 'item-view-all'),
        to: filtersUrl
    })) : null;
};

});
parcelRegister("2o8gl", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::289d4f542a1ed26db6d28b87ad2efcf4>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $1bd43b75b5db29b6$var$_react = $1bd43b75b5db29b6$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $1bd43b75b5db29b6$var$_filter = $1bd43b75b5db29b6$var$_interopRequireDefault((parcelRequire("jX361")));

var $1bd43b75b5db29b6$var$_filter2 = $1bd43b75b5db29b6$var$_interopRequireDefault((parcelRequire("bTqXB")));
function $1bd43b75b5db29b6$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Migration Icon component for FilterIcon.
 * This component is FilterIcon, with `UNSAFE_fallbackIcon` set to "FilterIcon".
 *
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for filterting data or objects.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $1bd43b75b5db29b6$var$FilterIcon = (props)=>/*#__PURE__*/ $1bd43b75b5db29b6$var$_react.default.createElement($1bd43b75b5db29b6$var$_filter.default, Object.assign({
        LEGACY_fallbackIcon: $1bd43b75b5db29b6$var$_filter2.default
    }, props));
$1bd43b75b5db29b6$var$FilterIcon.Name = 'FilterIconMigration';
var $1bd43b75b5db29b6$var$_default = module.exports.default = $1bd43b75b5db29b6$var$FilterIcon;

});
parcelRegister("bTqXB", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $8a89be8174ef75ee$var$_react = $8a89be8174ef75ee$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $c7fbr = parcelRequire("c7fbr");

var $8a89be8174ef75ee$var$_filter = $8a89be8174ef75ee$var$_interopRequireDefault((parcelRequire("jX361")));
function $8a89be8174ef75ee$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $8a89be8174ef75ee$var$FilterIcon = (props)=>/*#__PURE__*/ $8a89be8174ef75ee$var$_react.default.createElement($c7fbr.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="currentcolor" fill-rule="evenodd" d="M7 13h10l1-2H6zM3.99 6c-.55 0-.79.41-.55.9L4 8h16l.55-1.1c.25-.5.01-.9-.54-.9zm6.79 11.56a.87.87 0 0 0 .73.44h.99c.28 0 .61-.2.73-.44L14 16h-4z"/></svg>`
    }, props, {
        newIcon: $8a89be8174ef75ee$var$_filter.default
    }));
$8a89be8174ef75ee$var$FilterIcon.displayName = 'FilterIcon';
var $8a89be8174ef75ee$var$_default = module.exports.default = $8a89be8174ef75ee$var$FilterIcon;

});


parcelRegister("4zlUA", function(module, exports) {

$parcel$export(module.exports, "handleGinSPAClick", () => $7b30a009e09f47e3$export$f74673b086629362);
const $7b30a009e09f47e3$export$f74673b086629362 = (e)=>{
    const href = // @ts-expect-error - TS2339 - Property 'href' does not exist on type 'EventTarget | (EventTarget & HTMLAnchorElement)'. | TS2339 - Property 'href' does not exist on type 'EventTarget | (EventTarget & HTMLAnchorElement)'.
    typeof e.currentTarget.href === 'string' ? e.currentTarget.href : undefined;
    const openInNewTab = // @ts-expect-error - TS2339 - Property 'button' does not exist on type 'KeyboardEvent<HTMLAnchorElement> | MouseEvent<HTMLAnchorElement, MouseEvent> | MouseEvent<EventTarget, MouseEvent> | KeyboardEvent<...>'. | TS2339 - Property 'button' does not exist on type 'KeyboardEvent<HTMLAnchorElement> | MouseEvent<HTMLAnchorElement, MouseEvent> | MouseEvent<EventTarget, MouseEvent> | KeyboardEvent<...>'.
    e.metaKey || e.altKey || e.ctrlKey || e.shiftKey || e.button != null && e.button === 1;
    if (href == null || href === '' || e.defaultPrevented || openInNewTab) return;
    // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
    if (window.JIRA?.Issues?.Application) {
        e.preventDefault();
        // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
        window.JIRA.Issues.Application.execute('navigation:navigateToUrl', href, {
            forceRefresh: true,
            checkPermission: true,
            replace: false,
            reset: true,
            routerEvent: true
        });
    }
};

});

parcelRegister("f4La7", function(module, exports) {

$parcel$export(module.exports, "globalIssueNavigatorRoute", () => $4d3f2b1accc05e7a$export$f4c8e8bc55cd2008);
const $4d3f2b1accc05e7a$export$f4c8e8bc55cd2008 = {
    name: 'legacy-gin',
    path: '/issues/:issueKey(.*)?'
};

});

parcelRegister("31jbO", function(module, exports) {

$parcel$export(module.exports, "default", () => $1350230aaed398a9$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $1350230aaed398a9$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    starred: {
        "id": "atlassian-navigation.filters.menu.favorite-content.starred",
        "defaultMessage": "Starred"
    }
});

});


parcelRegister("7xt41", function(module, exports) {

$parcel$export(module.exports, "Footer", () => $8201760f444f9d16$export$a06f1c675e846f6f);
/* main.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $bwpsq = parcelRequire("bwpsq");

var $5uXOq = parcelRequire("5uXOq");

var $4R6GH = parcelRequire("4R6GH");

var $koVbs = parcelRequire("koVbs");

var $6cNb0 = parcelRequire("6cNb0");

var $b6S3k = parcelRequire("b6S3k");

var $d4B4Y = parcelRequire("d4B4Y");

var $aXYEG = parcelRequire("aXYEG");
// Removes the bullet (•) and padding from <li>
const $8201760f444f9d16$var$filterUnorderedList = null;
const $8201760f444f9d16$export$a06f1c675e846f6f = ({ testIdPrefix: testIdPrefix })=>{
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const testId = (0, $6cNb0.testIdConcat)(testIdPrefix, 'items');
    return (0, $4R6GH.fg)('camptasks-1105-filter-menu-list-markup') ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("ul", {
        "data-testid": testId,
        className: (0, $bwpsq.default)([
            "_qtt8glyw _ca0qidpf _u5f3idpf _n3tdidpf _19bvidpf"
        ])
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("li", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $d4B4Y.MenuItem), {
        analytics: {
            actionSubjectId: 'filtersNavigationMenuItem',
            menuItemId: 'viewAll',
            menuItemType: 'action',
            position: 0
        },
        href: "/jira/filters?searchName=&Search=Search&filterView=search",
        testId: (0, $6cNb0.testIdConcat)(testId, 'item-view-all'),
        to: (0, $b6S3k.filtersDirectoryRoute)
    }, formatMessage((0, $aXYEG.default).viewAll))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("li", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $d4B4Y.MenuItem), {
        analytics: {
            actionSubjectId: 'filtersNavigationMenuItem',
            menuItemId: 'create',
            menuItemType: 'action',
            position: 1
        },
        href: `/issues/?jql=${encodeURIComponent('created >= -30d order by created DESC')}`,
        testId: (0, $6cNb0.testIdConcat)(testId, 'item-create')
    }, formatMessage((0, $4R6GH.fg)('jira-issue-terminology-refresh-m3') ? (0, $aXYEG.default).viewAllIssuesIssueTermRefresh : (0, $aXYEG.default).viewAllIssues)))) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("span", {
        "data-testid": testId
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $d4B4Y.MenuItem), {
        analytics: {
            actionSubjectId: 'filtersNavigationMenuItem',
            menuItemId: 'viewAll',
            menuItemType: 'action',
            position: 0
        },
        href: "/jira/filters?searchName=&Search=Search&filterView=search",
        testId: (0, $6cNb0.testIdConcat)(testId, 'item-view-all'),
        to: (0, $b6S3k.filtersDirectoryRoute)
    }, formatMessage((0, $aXYEG.default).viewAll)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $d4B4Y.MenuItem), {
        analytics: {
            actionSubjectId: 'filtersNavigationMenuItem',
            menuItemId: 'create',
            menuItemType: 'action',
            position: 1
        },
        href: `/issues/?jql=${encodeURIComponent('created >= -30d order by created DESC')}`,
        testId: (0, $6cNb0.testIdConcat)(testId, 'item-create')
    }, formatMessage((0, $4R6GH.fg)('jira-issue-terminology-refresh-m3') ? (0, $aXYEG.default).viewAllIssuesIssueTermRefresh : (0, $aXYEG.default).viewAllIssues)));
};

});
parcelRegister("b6S3k", function(module, exports) {

$parcel$export(module.exports, "filtersDirectoryRoute", () => $45a85df0dbaf23d9$export$6350f52c8b40042d);
const $45a85df0dbaf23d9$export$6350f52c8b40042d = {
    name: 'filters-directory',
    path: '/jira/filters'
};

});

parcelRegister("aXYEG", function(module, exports) {

$parcel$export(module.exports, "default", () => $04b207ae58b19dda$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $04b207ae58b19dda$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    viewAllIssues: {
        "id": "atlassian-navigation.filters.menu.footer.view-all-issues",
        "defaultMessage": "View all issues"
    },
    viewAll: {
        "id": "atlassian-navigation.filters.menu.footer.view-all",
        "defaultMessage": "View all filters"
    },
    viewAllIssuesIssueTermRefresh: {
        "id": "atlassian-navigation.filters.menu.footer.view-all-issues-issue-term-refresh",
        "defaultMessage": "View all work items"
    }
});

});


parcelRegister("1Q2KE", function(module, exports) {

$parcel$export(module.exports, "LoadStatus", () => $5044ac4fa9b31340$export$c7df4a3f1b89de01);

var $5uXOq = parcelRequire("5uXOq");

var $bcn6L = parcelRequire("bcn6L");

var $apeap = parcelRequire("apeap");

var $dHtVS = parcelRequire("dHtVS");
const $5044ac4fa9b31340$export$c7df4a3f1b89de01 = ({ LoadStatusCommon: LoadStatusCommon = (0, $dHtVS.LoadStatus), shouldThrowError: shouldThrowError = false, useFavorite: useFavorite = (0, $bcn6L.useFavoriteFilters), useRecent: useRecent = (0, $apeap.useRecentFilters) })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(LoadStatusCommon, {
        shouldThrowError: shouldThrowError,
        useProvider: useFavorite
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(LoadStatusCommon, {
        shouldThrowError: shouldThrowError,
        useProvider: useRecent
    }));

});

parcelRegister("lQ0sa", function(module, exports) {

$parcel$export(module.exports, "RecentContent", () => $2e9bf8b639eae23f$export$a2873dc4e96d8e90);

var $5uXOq = parcelRequire("5uXOq");

var $2o8gl = parcelRequire("2o8gl");

var $4mNf3 = parcelRequire("4mNf3");

var $eXQym = parcelRequire("eXQym");

var $koVbs = parcelRequire("koVbs");

var $4zlUA = parcelRequire("4zlUA");

var $2EqxS = parcelRequire("2EqxS");

var $6cNb0 = parcelRequire("6cNb0");

var $f4La7 = parcelRequire("f4La7");

var $Mp6qH = parcelRequire("Mp6qH");

var $fhtpB = parcelRequire("fhtpB");

var $d4B4Y = parcelRequire("d4B4Y");

var $7ilb8 = parcelRequire("7ilb8");

var $dMJS0 = parcelRequire("dMJS0");

var $k3GIG = parcelRequire("k3GIG");
const $2e9bf8b639eae23f$export$a2873dc4e96d8e90 = ({ testIdPrefix: testIdPrefix })=>{
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const { recentItems: recentItems, favoriteItems: favoriteItems, changeFavorite: onChangeFavorite, changedItems: changedItems } = (0, $dMJS0.useFilterNavItems)();
    const itemsToShow = (0, $5uXOq.useMemo)(()=>recentItems.slice(0, (0, $Mp6qH.DEFAULT_LOAD_COUNT_RECENT)), [
        recentItems
    ]);
    const testId = (0, $6cNb0.testIdConcat)(testIdPrefix, 'items-recent');
    return recentItems.length > 0 ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("span", {
        "data-testid": testId
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $4mNf3.default), {
        testId: (0, $6cNb0.testIdConcat)(testId, 'heading')
    }, formatMessage((0, $k3GIG.default).recent)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7ilb8.MenuList), null, itemsToShow.map((item, idx)=>{
        const { url: url, id: id, favourite: isFavourite, title: title } = item;
        const contextItem = changedItems[item.id.toString()];
        const isPending = contextItem && contextItem.pending === true ? contextItem.pending : false;
        const { id: beforeEntityId, type: beforeEntityType } = (0, $2EqxS.getBeforeEntity)(favoriteItems);
        const filterParams = {
            issueKey: ''
        };
        const filterQuery = {
            filter: String(id)
        };
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7ilb8.MenuListItem), {
            key: id,
            ariaLabel: formatMessage((0, $k3GIG.default).recent)
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $d4B4Y.MenuItem), {
            analytics: {
                actionSubjectId: 'filtersNavigationMenuItem',
                menuItemId: id,
                menuItemType: 'recent',
                position: idx,
                starred: Boolean(isFavourite)
            },
            href: url,
            iconBefore: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($2o8gl))), {
                spacing: "spacious",
                label: ""
            }),
            iconAfter: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $fhtpB.FavoriteButton), {
                beforeEntityId: beforeEntityId,
                beforeEntityType: beforeEntityType,
                id: String(id),
                isFavorite: Boolean(isFavourite),
                favoriteItemName: title,
                isPending: isPending,
                menuItemType: "recent",
                onChangeFavorite: onChangeFavorite,
                type: (0, $eXQym.FILTERS_ITEM_TYPE)
            }),
            params: filterParams,
            query: filterQuery,
            testId: (0, $6cNb0.testIdConcat)(testId, `item-${idx}`),
            to: (0, $f4La7.globalIssueNavigatorRoute),
            onClick: (0, $4zlUA.handleGinSPAClick),
            "aria-label": title
        }, title));
    }))) : null;
};

});
parcelRegister("k3GIG", function(module, exports) {

$parcel$export(module.exports, "default", () => $e96da9bc3d6ed1b2$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $e96da9bc3d6ed1b2$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    recent: {
        "id": "atlassian-navigation.filters.menu.recent-content.recent",
        "defaultMessage": "Recent"
    }
});

});



parcelRegister("7ikvo", function(module, exports) {

$parcel$export(module.exports, "default", () => $49764f41cba0da7b$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $49764f41cba0da7b$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    filters: {
        "id": "atlassian-navigation.filters.filters",
        "defaultMessage": "Filters"
    }
});

});


parcelRegister("3bzLW", function(module, exports) {

$parcel$export(module.exports, "Dashboards", () => $f1da5b4afde35356$export$dd47e695f88fad71);

var $5uXOq = parcelRequire("5uXOq");

var $kaHBi = parcelRequire("kaHBi");

var $bcn6L = parcelRequire("bcn6L");

var $koVbs = parcelRequire("koVbs");

var $lmyls = parcelRequire("lmyls");

var $apeap = parcelRequire("apeap");

var $cZpsT = parcelRequire("cZpsT");

var $Mp6qH = parcelRequire("Mp6qH");

var $4uXxK = parcelRequire("4uXxK");

var $fVbkk = parcelRequire("fVbkk");

var $4XiFK = parcelRequire("4XiFK");

var $ebYJ0 = parcelRequire("ebYJ0");

var $7HJPM = parcelRequire("7HJPM");

var $lQgHF = parcelRequire("lQgHF");
const $f1da5b4afde35356$var$DashboardsAnonymous = ()=>{
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $fVbkk.MenuTrigger), {
        href: "/jira/dashboards",
        menuId: (0, $lmyls.MENU_ID).DASHBOARDS,
        navigationItemId: (0, $Mp6qH.NAVIGATION_ITEM_ID).DASHBOARDS
    }, formatMessage((0, $lQgHF.default).dashboards));
};
const $f1da5b4afde35356$var$DashboardsLoggedIn = ()=>{
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const [{ hasFetchedOnce: hasFetchedOnceFavorites }, { loadFavoriteDashboards: loadFavorite }] = (0, $bcn6L.useFavoriteDashboards)();
    const [, { loadRecentDashboards: loadRecent }] = (0, $apeap.useRecentDashboards)();
    const onStart = (0, $kaHBi.useExperienceStart)({
        experience: (0, $Mp6qH.EXPERIENCE_NAVIGATION_TOP_MENU),
        experienceId: (0, $Mp6qH.NAVIGATION_ITEM_ID).DASHBOARDS,
        analyticsSource: 'atlassian-navigation'
    });
    const onBeforeMenuOpen = (0, $5uXOq.useCallback)(()=>{
        onStart();
        // refresh recents on open to add recently visited pages
        loadRecent((0, $Mp6qH.DEFAULT_LOAD_COUNT_RECENT));
        // load favourites only if not loaded already (optimisation to reduce requests)
        if (!hasFetchedOnceFavorites) loadFavorite((0, $Mp6qH.DEFAULT_LOAD_COUNT_FAV));
    }, [
        hasFetchedOnceFavorites,
        loadFavorite,
        loadRecent,
        onStart
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $4XiFK.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $ebYJ0.Popup), {
        menuId: (0, $lmyls.MENU_ID).DASHBOARDS,
        navigationItemId: (0, $Mp6qH.NAVIGATION_ITEM_ID).DASHBOARDS,
        Menu: (0, $7HJPM.Menu),
        onBeforeMenuOpen: onBeforeMenuOpen,
        label: formatMessage((0, $lQgHF.default).dashboards)
    }, formatMessage((0, $lQgHF.default).dashboards)));
};
const $f1da5b4afde35356$var$DashboardsComponent = ()=>{
    const isAnonymous = (0, $cZpsT.useIsAnonymous)();
    return isAnonymous ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($f1da5b4afde35356$var$DashboardsAnonymous, null) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($f1da5b4afde35356$var$DashboardsLoggedIn, null);
};
const $f1da5b4afde35356$export$dd47e695f88fad71 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $4uXxK.TopLevelErrorBoundary), {
        id: (0, $lmyls.MENU_ID).DASHBOARDS
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($f1da5b4afde35356$var$DashboardsComponent, null));

});
parcelRegister("7HJPM", function(module, exports) {

$parcel$export(module.exports, "Menu", () => $9f76f48ca86ed8d3$export$d9b273488cd8ce6f);

var $5uXOq = parcelRequire("5uXOq");

var $9UCCQ = parcelRequire("9UCCQ");

var $kLaXN = parcelRequire("kLaXN");

var $7CMCs = parcelRequire("7CMCs");

var $93jKl = parcelRequire("93jKl");

var $bcn6L = parcelRequire("bcn6L");

var $lmyls = parcelRequire("lmyls");

var $6cNb0 = parcelRequire("6cNb0");

var $lfTZh = parcelRequire("lfTZh");

var $Mp6qH = parcelRequire("Mp6qH");

var $8vzcp = parcelRequire("8vzcp");

var $ag3sS = parcelRequire("ag3sS");

var $9TMfX = parcelRequire("9TMfX");

var $6WLja = parcelRequire("6WLja");

var $e8DNP = parcelRequire("e8DNP");

var $6gxIx = parcelRequire("6gxIx");

var $7qz2O = parcelRequire("7qz2O");

var $8nbY6 = parcelRequire("8nbY6");

var $dKlaW = parcelRequire("dKlaW");
const $9f76f48ca86ed8d3$var$EVENT_DATA = {
    id: (0, $lmyls.MENU_ID).DASHBOARDS
};
const $9f76f48ca86ed8d3$export$d9b273488cd8ce6f = ({ testIdPrefix: testIdPrefix })=>{
    const [, { loadFavoriteDashboards: loadFavorite }] = (0, $bcn6L.useFavoriteDashboards)();
    const onFail = (0, $93jKl.useExperienceFail)({
        experience: (0, $Mp6qH.EXPERIENCE_NAVIGATION_TOP_MENU)
    });
    (0, $5uXOq.useEffect)(()=>()=>{
            // Refresh favourites on close to update if user has toggled any item
            loadFavorite((0, $Mp6qH.DEFAULT_LOAD_COUNT_FAV));
        }, [
        loadFavorite
    ]);
    const testIdContent = (0, $6cNb0.testIdConcat)(testIdPrefix, 'content');
    const testIdFooter = (0, $6cNb0.testIdConcat)(testIdPrefix, 'footer');
    const errorFallback = (0, $5uXOq.useCallback)(()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $8vzcp.MenuError), {
            testIdPrefix: testIdContent
        }), [
        testIdContent
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $ag3sS.MenuLayout), {
        isWide: true
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $9UCCQ.default), {
        isScrollable: true
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7CMCs.JSErrorBoundary), {
        id: (0, $lmyls.MENU_ID).DASHBOARDS,
        packageName: (0, $Mp6qH.PACKAGE_NAME),
        fallback: errorFallback,
        withExperienceTracker: true,
        extraEventData: $9f76f48ca86ed8d3$var$EVENT_DATA,
        onError: onFail
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $kLaXN.AuthenticationErrorBoundary), {
        render: errorFallback
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $e8DNP.Empty), {
        testIdPrefix: testIdContent
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $lfTZh.default), {
        name: "navigation-apps-dashboards-menu",
        fallback: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $9TMfX.MenuSkeletonContent), {
            testIdPrefix: testIdContent
        })
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $8nbY6.LoadStatus), {
        shouldThrowError: true
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $6gxIx.FavoriteContent), {
        testIdPrefix: testIdContent
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dKlaW.RecentContent), {
        testIdPrefix: testIdContent
    })))))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $9UCCQ.default), {
        hasSeparator: true
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $lfTZh.default), {
        name: "navigation-apps-dashboards-footer",
        fallback: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $6WLja.MenuSkeletonFooter), {
            testIdPrefix: testIdFooter
        })
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $8nbY6.LoadStatus), null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7qz2O.Footer), {
        testIdPrefix: testIdFooter
    }))));
};

});
parcelRegister("e8DNP", function(module, exports) {

$parcel$export(module.exports, "Empty", () => $281eb0020f130a6b$export$1f74963c34e8bfec);

var $5uXOq = parcelRequire("5uXOq");

var $e4yMr = parcelRequire("e4yMr");

var $dS3PR = parcelRequire("dS3PR");

var $4R6GH = parcelRequire("4R6GH");

var $3bQtK = parcelRequire("3bQtK");

var $bcn6L = parcelRequire("bcn6L");

var $koVbs = parcelRequire("koVbs");

var $6cNb0 = parcelRequire("6cNb0");

var $apeap = parcelRequire("apeap");

var $cZpsT = parcelRequire("cZpsT");

var $Mp6qH = parcelRequire("Mp6qH");

var $jyltl = parcelRequire("jyltl");

var $dMJS0 = parcelRequire("dMJS0");

var $eQZYv = parcelRequire("eQZYv");

var $4MIFv = parcelRequire("4MIFv");
const $281eb0020f130a6b$var$learnMoreHref = 'https://confluence.atlassian.com/jiracorecloud/configuring-dashboards-765593585.html';
const $281eb0020f130a6b$export$1f74963c34e8bfec = ({ children: children, testIdPrefix: testIdPrefix })=>{
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const isAnonymous = (0, $cZpsT.useIsAnonymous)();
    const onSuccess = (0, $3bQtK.useExperienceSuccess)({
        experience: (0, $Mp6qH.EXPERIENCE_NAVIGATION_TOP_MENU)
    });
    const text = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("div", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dS3PR.default), {
        as: "p"
    }, formatMessage((0, $4MIFv.default).emptyText))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("div", null, (0, $4R6GH.fg)('replace-anchor-with-link__navigation') ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $e4yMr.default), {
        href: $281eb0020f130a6b$var$learnMoreHref,
        target: "_blank",
        rel: "noopener noreferrer"
    }, formatMessage((0, $4MIFv.default).learnMore)) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("a", {
        href: $281eb0020f130a6b$var$learnMoreHref,
        target: "_blank",
        rel: "noopener noreferrer"
    }, formatMessage((0, $4MIFv.default).learnMore))));
    const [{ hasSuccessOnce: hasSuccessOnceFavorite, isFetching: isFetchingFavorite, fetchError: fetchErrorFavorite }] = (0, $bcn6L.useFavoriteDashboards)();
    const [{ hasSuccessOnce: hasSuccessOnceRecent, isFetching: isFetchingRecent, fetchError: fetchErrorRecent }] = (0, $apeap.useRecentDashboards)();
    const { favoriteItems: favoriteItems, recentItems: recentItems } = (0, $dMJS0.useDashboardNavItems)();
    const notEmpty = favoriteItems.length || //  should show fav items
    recentItems.length || // should show recent items
    isFetchingFavorite && !hasSuccessOnceFavorite || // should show fav skeleton
    isFetchingRecent && !hasSuccessOnceRecent || // should show recent skeleton
    fetchErrorFavorite || // should show error
    fetchErrorRecent; // should show error
    const shouldShowEmptyForAnonymous = isAnonymous;
    (0, $5uXOq.useEffect)(()=>{
        const isSuccess = hasSuccessOnceFavorite && hasSuccessOnceRecent;
        if (isSuccess) onSuccess();
    }, [
        hasSuccessOnceFavorite,
        hasSuccessOnceRecent,
        onSuccess
    ]);
    const testId = (0, $6cNb0.testIdConcat)(testIdPrefix, 'empty');
    return notEmpty && !shouldShowEmptyForAnonymous ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, children) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $jyltl.MenuInfo), {
        imgSrc: (0, (/*@__PURE__*/$parcel$interopDefault($eQZYv))),
        testId: testId,
        text: text
    });
};

});
parcelRegister("eQZYv", function(module, exports) {
module.exports = new URL("dashboards-empty.ed2e5362.svg", import.meta.url).toString();

});

parcelRegister("4MIFv", function(module, exports) {

$parcel$export(module.exports, "default", () => $69bb4571f94cb527$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $69bb4571f94cb527$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    emptyText: {
        "id": "atlassian-navigation.dashboards.menu.empty.empty-text",
        "defaultMessage": "Create a dashboard to track the status of your projects."
    },
    learnMore: {
        "id": "atlassian-navigation.dashboards.menu.empty.learn-more",
        "defaultMessage": "More about dashboards"
    },
    emptyImg: {
        "id": "atlassian-navigation.dashboards.menu.empty.empty-img",
        "defaultMessage": "An image showing that the apps dropdown menu is empty"
    }
});

});


parcelRegister("6gxIx", function(module, exports) {

$parcel$export(module.exports, "FavoriteContent", () => $96d17f8a5c6dc94c$export$297af018011b145a);

var $5uXOq = parcelRequire("5uXOq");

var $50Bjx = parcelRequire("50Bjx");

var $4mNf3 = parcelRequire("4mNf3");

var $eXQym = parcelRequire("eXQym");

var $koVbs = parcelRequire("koVbs");

var $6cNb0 = parcelRequire("6cNb0");

var $5gOBf = parcelRequire("5gOBf");

var $Mp6qH = parcelRequire("Mp6qH");

var $fhtpB = parcelRequire("fhtpB");

var $d4B4Y = parcelRequire("d4B4Y");

var $56fXm = parcelRequire("56fXm");

var $dMJS0 = parcelRequire("dMJS0");

var $fBffT = parcelRequire("fBffT");
const $96d17f8a5c6dc94c$export$297af018011b145a = ({ testIdPrefix: testIdPrefix })=>{
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const { favoriteItems: favoriteItems, changeFavorite: onChangeFavorite, changedItems: changedItems } = (0, $dMJS0.useDashboardNavItems)();
    const itemsToShow = (0, $5uXOq.useMemo)(()=>favoriteItems.slice(0, (0, $Mp6qH.DEFAULT_LOAD_COUNT_FAV)), [
        favoriteItems
    ]);
    const testId = (0, $6cNb0.testIdConcat)(testIdPrefix, 'items-starred');
    const dashboardsUrl = '/jira/dashboards?page=1&sortKey=favourite&sortOrder=DESC';
    return favoriteItems.length > 0 ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("span", {
        "data-testid": testId
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $4mNf3.default), {
        testId: (0, $6cNb0.testIdConcat)(testId, 'heading')
    }, formatMessage((0, $fBffT.default).starred)), itemsToShow.map((item, idx)=>{
        const { url: url, id: id, favourite: isFavourite, metadata: metadata, title: title } = item;
        const contextItem = changedItems[id.toString()];
        const isPending = contextItem && contextItem.pending === true ? contextItem.pending : false;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $d4B4Y.MenuItem), {
            analytics: {
                actionSubjectId: 'dashboardsNavigationMenuItem',
                menuItemId: id,
                menuItemType: 'starred',
                position: idx,
                starred: Boolean(isFavourite)
            },
            description: metadata,
            href: url,
            iconBefore: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($50Bjx))), {
                spacing: "spacious",
                label: "dashboard"
            }),
            iconAfter: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $fhtpB.FavoriteButton), {
                id: String(id),
                isFavorite: Boolean(isFavourite),
                favoriteItemName: title,
                isPending: isPending,
                menuItemType: "starred",
                onChangeFavorite: onChangeFavorite,
                type: (0, $eXQym.DASHBOARDS_ITEM_TYPE)
            }),
            key: id,
            testId: (0, $6cNb0.testIdConcat)(testId, `item-${idx}`),
            to: (0, $5gOBf.dashboardViewRoute),
            params: {
                dashboardId: String(id)
            },
            "aria-label": `${title} ${metadata || ''}`
        }, title);
    }), favoriteItems.length >= (0, $Mp6qH.DEFAULT_LOAD_COUNT_FAV) && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $56fXm.MenuItemViewAll), {
        analytics: {
            actionSubjectId: 'dashboardsNavigationMenuItem',
            menuItemId: 'viewAll',
            // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
            position: (0, $Mp6qH.DEFAULT_LOAD_COUNT_FAV)
        },
        href: dashboardsUrl,
        testId: (0, $6cNb0.testIdConcat)(testId, 'item-view-all'),
        to: dashboardsUrl
    })) : null;
};

});
parcelRegister("50Bjx", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::7183201509c40b5c08006bcaf851f797>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $3a59e5a58dbd64b5$var$_react = $3a59e5a58dbd64b5$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $3a59e5a58dbd64b5$var$_dashboard = $3a59e5a58dbd64b5$var$_interopRequireDefault((parcelRequire("gsyzJ")));

var $3a59e5a58dbd64b5$var$_dashboard2 = $3a59e5a58dbd64b5$var$_interopRequireDefault((parcelRequire("hSLU7")));
function $3a59e5a58dbd64b5$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Migration Icon component for DashboardIcon.
 * This component is DashboardIcon, with `UNSAFE_fallbackIcon` set to "DashboardIcon".
 *
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for dashboards in Jira.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $3a59e5a58dbd64b5$var$DashboardIcon = (props)=>/*#__PURE__*/ $3a59e5a58dbd64b5$var$_react.default.createElement($3a59e5a58dbd64b5$var$_dashboard.default, Object.assign({
        LEGACY_fallbackIcon: $3a59e5a58dbd64b5$var$_dashboard2.default
    }, props));
$3a59e5a58dbd64b5$var$DashboardIcon.Name = 'DashboardIconMigration';
var $3a59e5a58dbd64b5$var$_default = module.exports.default = $3a59e5a58dbd64b5$var$DashboardIcon;

});
parcelRegister("hSLU7", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $d04ca3956c274a75$var$_react = $d04ca3956c274a75$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $c7fbr = parcelRequire("c7fbr");

var $d04ca3956c274a75$var$_dashboard = $d04ca3956c274a75$var$_interopRequireDefault((parcelRequire("gsyzJ")));
function $d04ca3956c274a75$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $d04ca3956c274a75$var$DashboardIcon = (props)=>/*#__PURE__*/ $d04ca3956c274a75$var$_react.default.createElement($c7fbr.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><g fill="currentcolor"><path d="M4 18h16.008C20 18 20 6 20 6H3.992C4 6 4 18 4 18M2 5.994C2 4.893 2.898 4 3.99 4h16.02C21.108 4 22 4.895 22 5.994v12.012A1.997 1.997 0 0 1 20.01 20H3.99A1.994 1.994 0 0 1 2 18.006z"/><path d="M7 5v14h2V5z"/><path d="M7 11h14V9H7z"/></g></svg>`
    }, props, {
        newIcon: $d04ca3956c274a75$var$_dashboard.default
    }));
$d04ca3956c274a75$var$DashboardIcon.displayName = 'DashboardIcon';
var $d04ca3956c274a75$var$_default = module.exports.default = $d04ca3956c274a75$var$DashboardIcon;

});


parcelRegister("5gOBf", function(module, exports) {

$parcel$export(module.exports, "dashboardViewRoute", () => $1aac2fbaf8a5979b$export$24f1b2ff97b9d3e6);
const $1aac2fbaf8a5979b$export$24f1b2ff97b9d3e6 = {
    name: 'dashboard-view',
    path: '/jira/dashboards/:dashboardId(\\d+|last-visited)',
    query: [
        'maximized?'
    ],
    exact: true
};

});

parcelRegister("fBffT", function(module, exports) {

$parcel$export(module.exports, "default", () => $4e9605aa9ba39b44$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $4e9605aa9ba39b44$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    starred: {
        "id": "atlassian-navigation.dashboards.menu.favorite-content.starred",
        "defaultMessage": "Starred"
    }
});

});


parcelRegister("7qz2O", function(module, exports) {

$parcel$export(module.exports, "Footer", () => $9ea4139d651cf8bc$export$a06f1c675e846f6f);

var $5uXOq = parcelRequire("5uXOq");

var $koVbs = parcelRequire("koVbs");

var $6cNb0 = parcelRequire("6cNb0");

var $dDmlh = parcelRequire("dDmlh");

var $cZpsT = parcelRequire("cZpsT");

var $d4B4Y = parcelRequire("d4B4Y");

var $a3jaK = parcelRequire("a3jaK");

var $cuZpl = parcelRequire("cuZpl");
const $9ea4139d651cf8bc$export$a06f1c675e846f6f = ({ testIdPrefix: testIdPrefix })=>{
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const isAnonymous = (0, $cZpsT.useIsAnonymous)();
    const testId = (0, $6cNb0.testIdConcat)(testIdPrefix, 'items');
    const dashboardsUrl = '/jira/dashboards';
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("span", {
        "data-testid": testId
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $d4B4Y.MenuItem), {
        analytics: {
            actionSubjectId: 'dashboardsNavigationMenuItem',
            menuItemId: 'viewAll',
            menuItemType: 'action',
            position: 0
        },
        href: dashboardsUrl,
        testId: (0, $6cNb0.testIdConcat)(testId, 'item-view-all'),
        to: (0, $dDmlh.dashboardsDirectoryRoute)
    }, formatMessage((0, $cuZpl.default).viewAll)), !isAnonymous && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $a3jaK.CreateButton), {
        testId: (0, $6cNb0.testIdConcat)(testId, 'item-create')
    }));
};

});
parcelRegister("dDmlh", function(module, exports) {

$parcel$export(module.exports, "dashboardsDirectoryRoute", () => $fd66dc0239264856$export$41bba408475cab16);
const $fd66dc0239264856$export$41bba408475cab16 = {
    name: 'dashboards-directory',
    path: '/jira/dashboards'
};

});

parcelRegister("a3jaK", function(module, exports) {

$parcel$export(module.exports, "CreateButton", () => $2b806b55754512d0$export$6d3c345ce7c38fd9);

var $5uXOq = parcelRequire("5uXOq");

var $koVbs = parcelRequire("koVbs");

var $e9QkH = parcelRequire("e9QkH");

var $Mp6qH = parcelRequire("Mp6qH");

var $d4B4Y = parcelRequire("d4B4Y");

var $eqacc = parcelRequire("eqacc");
const $2b806b55754512d0$export$6d3c345ce7c38fd9 = ({ testId: testId })=>{
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const [, { on: modalOpen }] = (0, $e9QkH.useSwitchModals)((0, $Mp6qH.MODAL_ID).DASHBOARD_CREATE);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $d4B4Y.MenuItem), {
        analytics: {
            actionSubjectId: 'dashboardsNavigationMenuItem',
            menuItemId: 'create',
            menuItemType: 'action',
            position: 1
        },
        onClick: modalOpen,
        testId: testId
    }, formatMessage((0, $eqacc.default).createButton));
};

});
parcelRegister("eqacc", function(module, exports) {

$parcel$export(module.exports, "default", () => $956db87aa6fc3521$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $956db87aa6fc3521$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    createButton: {
        "id": "atlassian-navigation.dashboards.menu.footer.create-button.create-button",
        "defaultMessage": "Create dashboard"
    },
    notAllowed: {
        "id": "atlassian-navigation.dashboards.menu.footer.create-button.not-allowed",
        "defaultMessage": "You must be logged in to create dashboards"
    }
});

});


parcelRegister("cuZpl", function(module, exports) {

$parcel$export(module.exports, "default", () => $55607ccb6f8aac9f$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $55607ccb6f8aac9f$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    viewAll: {
        "id": "atlassian-navigation.dashboards.menu.footer.view-all",
        "defaultMessage": "View all dashboards"
    }
});

});


parcelRegister("8nbY6", function(module, exports) {

$parcel$export(module.exports, "LoadStatus", () => $e364b42a3e2b8e03$export$c7df4a3f1b89de01);

var $5uXOq = parcelRequire("5uXOq");

var $bcn6L = parcelRequire("bcn6L");

var $apeap = parcelRequire("apeap");

var $dHtVS = parcelRequire("dHtVS");
const $e364b42a3e2b8e03$export$c7df4a3f1b89de01 = ({ shouldThrowError: shouldThrowError = false })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dHtVS.LoadStatus), {
        shouldThrowError: shouldThrowError,
        useProvider: (0, $bcn6L.useFavoriteDashboards)
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dHtVS.LoadStatus), {
        shouldThrowError: shouldThrowError,
        useProvider: (0, $apeap.useRecentDashboards)
    }));

});

parcelRegister("dKlaW", function(module, exports) {

$parcel$export(module.exports, "RecentContent", () => $e3bdcf72a295ac60$export$a2873dc4e96d8e90);

var $5uXOq = parcelRequire("5uXOq");

var $50Bjx = parcelRequire("50Bjx");

var $4mNf3 = parcelRequire("4mNf3");

var $eXQym = parcelRequire("eXQym");

var $koVbs = parcelRequire("koVbs");

var $2EqxS = parcelRequire("2EqxS");

var $6cNb0 = parcelRequire("6cNb0");

var $5gOBf = parcelRequire("5gOBf");

var $Mp6qH = parcelRequire("Mp6qH");

var $fhtpB = parcelRequire("fhtpB");

var $d4B4Y = parcelRequire("d4B4Y");

var $dMJS0 = parcelRequire("dMJS0");

var $pwPQz = parcelRequire("pwPQz");
const $e3bdcf72a295ac60$export$a2873dc4e96d8e90 = ({ testIdPrefix: testIdPrefix })=>{
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const { recentItems: recentItems, favoriteItems: favoriteItems, changeFavorite: onChangeFavorite, changedItems: changedItems } = (0, $dMJS0.useDashboardNavItems)();
    const itemsToShow = (0, $5uXOq.useMemo)(()=>recentItems.slice(0, (0, $Mp6qH.DEFAULT_LOAD_COUNT_RECENT)), [
        recentItems
    ]);
    const testId = (0, $6cNb0.testIdConcat)(testIdPrefix, 'items-recent');
    return recentItems.length > 0 ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("span", {
        "data-testid": testId
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $4mNf3.default), {
        testId: (0, $6cNb0.testIdConcat)(testId, 'heading')
    }, formatMessage((0, $pwPQz.default).recent)), itemsToShow.map((item, idx)=>{
        const { url: url, id: id, favourite: isFavourite, metadata: metadata, title: title } = item;
        const contextItem = changedItems[item.id.toString()];
        const isPending = contextItem && contextItem.pending === true ? contextItem.pending : false;
        const { id: beforeEntityId, type: beforeEntityType } = (0, $2EqxS.getBeforeEntity)(favoriteItems);
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $d4B4Y.MenuItem), {
            analytics: {
                actionSubjectId: 'dashboardsNavigationMenuItem',
                menuItemId: id,
                menuItemType: 'recent',
                position: idx,
                starred: Boolean(isFavourite)
            },
            description: metadata,
            href: url,
            iconBefore: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($50Bjx))), {
                spacing: "spacious",
                label: ""
            }),
            iconAfter: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $fhtpB.FavoriteButton), {
                beforeEntityId: beforeEntityId,
                beforeEntityType: beforeEntityType,
                id: String(id),
                isFavorite: Boolean(isFavourite),
                favoriteItemName: title,
                isPending: isPending,
                menuItemType: "recent",
                onChangeFavorite: onChangeFavorite,
                type: (0, $eXQym.DASHBOARDS_ITEM_TYPE)
            }),
            key: id,
            testId: (0, $6cNb0.testIdConcat)(testId, `item-${idx}`),
            to: (0, $5gOBf.dashboardViewRoute),
            params: {
                dashboardId: String(id)
            },
            "aria-label": `${title} ${metadata || ''}`
        }, title);
    })) : null;
};

});
parcelRegister("pwPQz", function(module, exports) {

$parcel$export(module.exports, "default", () => $037213aaba1faf3d$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $037213aaba1faf3d$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    recent: {
        "id": "atlassian-navigation.dashboards.menu.recent-content.recent",
        "defaultMessage": "Recent"
    },
    viewAll: {
        "id": "atlassian-navigation.dashboards.menu.recent-content.view-all",
        "defaultMessage": "View all recent"
    }
});

});



parcelRegister("lQgHF", function(module, exports) {

$parcel$export(module.exports, "default", () => $4360ba769f596109$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $4360ba769f596109$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    dashboards: {
        "id": "atlassian-navigation.dashboards.dashboards",
        "defaultMessage": "Dashboards"
    }
});

});


parcelRegister("cvQRb", function(module, exports) {

$parcel$export(module.exports, "People", () => $c53dc2abd00215a4$export$8d3edc4d62e152ad);

var $5uXOq = parcelRequire("5uXOq");

var $euiLX = parcelRequire("euiLX");

var $koVbs = parcelRequire("koVbs");

var $0Wtmq = parcelRequire("0Wtmq");

var $57aZp = parcelRequire("57aZp");

const $c53dc2abd00215a4$export$8d3edc4d62e152ad = ()=>{
    const { locale: locale } = (0, $koVbs.default)();
    return(// this won't have any effect on those using the old people-menu except it will still cache
    // the remotely configured result for when they are rolled out to the new version
    /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $0Wtmq.PeopleAndTeamsConfigurationProvider), {
        product: "jira",
        locale: (0, $euiLX.default)(locale)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $57aZp.People), null)));
};

});
parcelRegister("0Wtmq", function(module, exports) {

$parcel$export(module.exports, "PeopleAndTeamsConfigurationProvider", () => $7fcc2b6dd0426004$export$d3f5bd36d1c6597e);
$parcel$export(module.exports, "usePeopleAndTeamsConfigurationContext", () => $7fcc2b6dd0426004$export$130340d16a670190);

var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $btDaU = parcelRequire("btDaU");

var $fkT8h = parcelRequire("fkT8h");

var $9Xnkh = parcelRequire("9Xnkh");

var $epGv3 = parcelRequire("epGv3");
const $7fcc2b6dd0426004$export$8a37839ac1e08b25 = /*#__PURE__*/ (0, $5uXOq.createContext)((0, $9Xnkh.DEFAULT_CONTEXT));
const $7fcc2b6dd0426004$export$3bf19eb896b777b8 = ({ children: children, locale: locale, product: product, teamPermissions: teamPermissions, orgId: orgId, teamPermissionCheckEnabled: teamPermissionCheckEnabled = false })=>{
    const overrides = (0, $epGv3.usePeopleAndTeamsConfigurationOverrides)(teamPermissionCheckEnabled, orgId, teamPermissions);
    const artifact = (0, $fkT8h.usePeopleAndTeamsRemoteArtifact)(product, locale, overrides);
    return /*#__PURE__*/ (0, $2OMIu.jsx)($7fcc2b6dd0426004$export$8a37839ac1e08b25.Provider, {
        value: artifact || (0, $9Xnkh.DEFAULT_CONTEXT),
        children: children
    });
};
const $7fcc2b6dd0426004$export$d3f5bd36d1c6597e = ({ children: children, locale: locale, product: product, teamPermissions: teamPermissions, teamPermissionCheckEnabled: teamPermissionCheckEnabled, orgId: orgId, ...flightDeckProps })=>{
    return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $btDaU.FlightDeckProvider), {
        product: product,
        ...flightDeckProps,
        children: /*#__PURE__*/ (0, $2OMIu.jsx)($7fcc2b6dd0426004$export$3bf19eb896b777b8, {
            locale: locale,
            product: product,
            teamPermissions: teamPermissions,
            teamPermissionCheckEnabled: teamPermissionCheckEnabled,
            orgId: orgId,
            children: children
        })
    });
};
const $7fcc2b6dd0426004$export$130340d16a670190 = ()=>(0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).useContext($7fcc2b6dd0426004$export$8a37839ac1e08b25);

});
parcelRegister("fkT8h", function(module, exports) {

$parcel$export(module.exports, "usePeopleAndTeamsRemoteArtifact", () => $540fc5e41500614e$export$233293b7afb7b362);

var $5uXOq = parcelRequire("5uXOq");

var $btDaU = parcelRequire("btDaU");

var $a5HGt = parcelRequire("a5HGt");
const $540fc5e41500614e$var$transformArtifactsWithOverrides = (artifact, overrideKeys)=>{
    if (!artifact?.overrides?.length || overrideKeys.length === 0) return artifact;
    return overrideKeys.reduce((acc, overrideKey)=>{
        return {
            ...acc,
            ...artifact.overrides && artifact.overrides.find((override)=>override.key === overrideKey)?.item || null
        };
    }, artifact);
};
const $540fc5e41500614e$export$233293b7afb7b362 = (product, locale, overridesKeys)=>{
    const dimensions = (0, $5uXOq.useMemo)(()=>({
            ...(0, $a5HGt.FD_CLIENT_FETCH_PROPS).dimensions,
            locale: locale
        }), [
        locale
    ]);
    const artifact = (0, $btDaU.useFlightDeckArtifact)((0, $a5HGt.FD_CLIENT_FETCH_PROPS).name, dimensions);
    /**
	 * FlightDeck doesn't allow custom, a 'product', dimension so we must handle this ourselves.
	 * We can probably remove this memo once that functionality is available
	 */ return (0, $5uXOq.useMemo)(()=>{
        const productArtifact = artifact ? product in artifact['people-menu'] ? artifact['people-menu'][product] : artifact['people-menu'].default : null;
        return {
            ['people-menu']: $540fc5e41500614e$var$transformArtifactsWithOverrides(productArtifact, overridesKeys ? overridesKeys['people-menu'] : [])
        };
    }, [
        artifact,
        product,
        overridesKeys
    ]);
};

});
parcelRegister("a5HGt", function(module, exports) {

$parcel$export(module.exports, "FD_CLIENT_FETCH_PROPS", () => $72142315cc1ea029$export$c270c412a04ff3e6);

var $c04PQ = parcelRequire("c04PQ");
const $72142315cc1ea029$export$953923d576277fd6 = 'people-and-teams-configuration-service';
const $72142315cc1ea029$export$71f196808ce40e60 = 'prod';
const $72142315cc1ea029$export$6392ca3738ed1e9 = 'fedramp-moderate';
const $72142315cc1ea029$export$e836203c1e95eac3 = 'commercial';
const $72142315cc1ea029$export$c270c412a04ff3e6 = {
    name: $72142315cc1ea029$export$953923d576277fd6,
    dimensions: {
        environmentType: $72142315cc1ea029$export$71f196808ce40e60,
        perimeter: (0, $c04PQ.isFedRamp)() ? $72142315cc1ea029$export$6392ca3738ed1e9 : $72142315cc1ea029$export$e836203c1e95eac3
    }
};

});


parcelRegister("9Xnkh", function(module, exports) {

$parcel$export(module.exports, "DEFAULT_CONTEXT", () => $68376ad28bbe1625$export$9c542858adf7dcd0);
const $68376ad28bbe1625$export$9c542858adf7dcd0 = {
    ['people-menu']: null
};

});

parcelRegister("epGv3", function(module, exports) {

$parcel$export(module.exports, "usePeopleAndTeamsConfigurationOverrides", () => $9b52f5c51e77c65a$export$66d7d96ce076bcd6);

var $95nUS = parcelRequire("95nUS");

var $5wXDQ = parcelRequire("5wXDQ");
const $9b52f5c51e77c65a$export$66d7d96ce076bcd6 = (teamPermissionCheckEnabled, orgId, teamPermissionsProps)=>{
    const { permissions: teamPermissionsFromHook } = (0, $95nUS.useTeamsPermissionsService)(orgId, {
        enabled: teamPermissionCheckEnabled && !teamPermissionsProps
    });
    const teamPermissions = teamPermissionsProps || teamPermissionsFromHook;
    return {
        'people-menu': [
            ...!teamPermissions?.canCreateTeams ? [
                (0, $5wXDQ.PeopleMenuOverrides).createTeamsDisabled
            ] : [],
            ...!teamPermissions?.canViewTeams ? [
                (0, $5wXDQ.PeopleMenuOverrides).viewTeamsDisabled
            ] : []
        ]
    };
};

});
parcelRegister("95nUS", function(module, exports) {

$parcel$export(module.exports, "useTeamsPermissionsService", () => $6e4bacc142514b25$export$b24dcbe1ec677a8);

var $5uXOq = parcelRequire("5uXOq");

var $2NMNM = parcelRequire("2NMNM");

var $3mE7N = parcelRequire("3mE7N");

var $lXyXX = parcelRequire("lXyXX");
const $6e4bacc142514b25$export$b24dcbe1ec677a8 = (scope, { enabled: enabled, attributes: attributes } = {
    enabled: false,
    attributes: {}
})=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $2NMNM.useAnalyticsEvents)();
    // backwards compatibility allow orgId to be passed as a string
    const { orgId: orgId, cloudId: cloudId } = typeof scope === 'string' || !scope ? {
        orgId: scope,
        cloudId: undefined
    } : scope;
    const [state, { getPermissions: getPermissions }] = (0, $lXyXX.useTeamsPermissionsStore)();
    const fetchData = (0, $5uXOq.useCallback)(async ()=>{
        getPermissions({
            orgId: orgId,
            cloudId: cloudId,
            enabled: enabled
        }, {
            onFetch: ()=>(0, $3mE7N.fireOperationalEvent)(createAnalyticsEvent, {
                    action: 'fetched',
                    actionSubject: 'use-team-permissions',
                    attributes: {
                        userId: attributes?.userId,
                        orgId: orgId,
                        cloudId: cloudId
                    }
                })
        });
    }, [
        orgId,
        cloudId,
        enabled,
        getPermissions,
        createAnalyticsEvent,
        attributes?.userId
    ]);
    (0, $5uXOq.useEffect)(()=>{
        fetchData();
    }, [
        fetchData
    ]);
    return {
        loading: state.isLoading,
        data: state.permissionsResponse,
        error: state.error,
        ...state
    };
};

});
parcelRegister("3mE7N", function(module, exports) {

$parcel$export(module.exports, "fireOperationalEvent", () => $f93bde5d7fdaaaab$export$a1fb57756f0de62b);
$parcel$export(module.exports, "fireScreenEvent", () => $f93bde5d7fdaaaab$export$59608e0169622110);
$parcel$export(module.exports, "fireTrackEvent", () => $f93bde5d7fdaaaab$export$574d2f19a52d67ca);
$parcel$export(module.exports, "fireUIEvent", () => $f93bde5d7fdaaaab$export$7eca133280843f9e);
$parcel$export(module.exports, "isSeriousError", () => $f93bde5d7fdaaaab$export$91c413c8a5c77e19);
const $f93bde5d7fdaaaab$var$ANALYTICS_CHANNEL = 'peopleTeams';
const $f93bde5d7fdaaaab$var$runItLater = (cb)=>{
    if (window.requestIdleCallback === 'function') return window.requestIdleCallback(cb);
    if (typeof window.requestAnimationFrame === 'function') return window.requestAnimationFrame(cb);
    return ()=>setTimeout(cb);
};
const $f93bde5d7fdaaaab$var$fireEvent = (kind)=>(createAnalyticsEvent, body)=>{
        if (!createAnalyticsEvent) return;
        $f93bde5d7fdaaaab$var$runItLater(()=>{
            createAnalyticsEvent({
                eventType: kind,
                ...body
            }).fire($f93bde5d7fdaaaab$var$ANALYTICS_CHANNEL);
        });
    };
const $f93bde5d7fdaaaab$export$a1fb57756f0de62b = $f93bde5d7fdaaaab$var$fireEvent('operational');
const $f93bde5d7fdaaaab$export$59608e0169622110 = $f93bde5d7fdaaaab$var$fireEvent('screen');
const $f93bde5d7fdaaaab$export$574d2f19a52d67ca = $f93bde5d7fdaaaab$var$fireEvent('track');
const $f93bde5d7fdaaaab$export$7eca133280843f9e = $f93bde5d7fdaaaab$var$fireEvent('ui');
const $f93bde5d7fdaaaab$export$91c413c8a5c77e19 = (error)=>{
    if (!error) return false;
    // Check for ' 403' with space beforehand to not count urls containing 403 in cloud or team id
    if ('status' in error && error['status'] === 403 || error?.message?.includes(' 403')) return false;
    if ('status' in error && error['status'] === 401 || error?.message?.includes(' 401')) return false;
    if ('status' in error && error['status'] === 429 || error?.message?.includes(' 429')) return false;
    if (error.message === 'Failed to fetch') return false;
    return true;
};

});

parcelRegister("lXyXX", function(module, exports) {

$parcel$export(module.exports, "useTeamsPermissionsStore", () => $20332b07e72ce3e2$export$4e7a1c55cba5a168);

var $3sQ5x = parcelRequire("3sQ5x");
var $iXqE5 = parcelRequire("iXqE5");

var $1K4T6 = parcelRequire("1K4T6");
var $dmOdc = parcelRequire("dmOdc");

var $ddoT6 = parcelRequire("ddoT6");
const $20332b07e72ce3e2$var$actions = {
    getPermissions: ({ orgId: orgId, cloudId: cloudId, enabled: enabled }, { onFetch: onFetch })=>async ({ setState: setState, getState: getState, dispatch: dispatch })=>{
            const { hasLoaded: hasLoaded, isLoading: isLoading } = getState();
            if (hasLoaded || isLoading || !enabled || !orgId || !cloudId) return;
            try {
                setState({
                    isLoading: true
                });
                (0, $dmOdc.teamsClient).setContext({
                    orgId: orgId,
                    cloudId: cloudId
                });
                const response = await (0, $dmOdc.teamsClient).getPermissions();
                dispatch($20332b07e72ce3e2$var$actions.setPermissions(response.permissions));
                onFetch?.();
            } catch (error) {
                dispatch($20332b07e72ce3e2$var$actions.setError(error instanceof (0, $1K4T6.HttpError) ? error : new Error('Failed to fetch permissions')));
            }
        },
    setError: (error)=>({ setState: setState })=>{
            setState({
                hasLoaded: true,
                isLoading: false,
                error: error
            });
        },
    setLoading: (isLoading)=>({ setState: setState })=>{
            setState({
                isLoading: isLoading
            });
        },
    setPermissions: (permissions)=>({ setState: setState })=>{
            setState({
                hasLoaded: true,
                isLoading: false,
                permissions: (0, $ddoT6.transformPermissions)(permissions),
                permissionsResponse: {
                    permissions: permissions
                }
            });
        }
};
const $20332b07e72ce3e2$var$Store = (0, $iXqE5.createStore)({
    initialState: {
        error: undefined,
        hasLoaded: false,
        isLoading: false,
        permissions: {
            canCreateTeams: true,
            canViewTeams: true,
            canAdminTeams: false
        }
    },
    actions: $20332b07e72ce3e2$var$actions,
    name: 'teams-permissions'
});
const $20332b07e72ce3e2$export$4e7a1c55cba5a168 = (0, $3sQ5x.createHook)($20332b07e72ce3e2$var$Store);

});
parcelRegister("1K4T6", function(module, exports) {

$parcel$export(module.exports, "StatusCode", () => $5767c51dc6f9e25d$export$f66f92b8741acd5b);
$parcel$export(module.exports, "isAuthError", () => $5767c51dc6f9e25d$export$cde1786a482f9a1c);
$parcel$export(module.exports, "isErrorStatusCode", () => $5767c51dc6f9e25d$export$9677d7c364ada66c);
$parcel$export(module.exports, "DefaultError", () => $5767c51dc6f9e25d$export$c73ca302efeda3b4);
$parcel$export(module.exports, "SLOIgnoreError", () => $5767c51dc6f9e25d$export$d87f401f8106d7a2);
$parcel$export(module.exports, "HttpError", () => $5767c51dc6f9e25d$export$65bd6083489bd8bb);
$parcel$export(module.exports, "SLOIgnoreHttpError", () => $5767c51dc6f9e25d$export$826a3d65b8435adf);
$parcel$export(module.exports, "GraphQLError", () => $5767c51dc6f9e25d$export$92d6ed0888e7cb7f);
$parcel$export(module.exports, "isNetworkError", () => $5767c51dc6f9e25d$export$476aa014e2fd89d5);
var $5767c51dc6f9e25d$export$fe4bb20808298551 = /*#__PURE__*/ function(ErrorCategory) {
    ErrorCategory["NotFound"] = "NotFound";
    ErrorCategory["NotPermitted"] = "NotPermitted";
    ErrorCategory["MalformedInput"] = "MalformedInput";
    ErrorCategory["Internal"] = "Internal";
    return ErrorCategory;
}({});
var $5767c51dc6f9e25d$export$f66f92b8741acd5b = /*#__PURE__*/ function(StatusCode) {
    StatusCode[StatusCode["UNAUTHORIZED"] = 401] = "UNAUTHORIZED";
    StatusCode[StatusCode["FORBIDDEN"] = 403] = "FORBIDDEN";
    StatusCode[StatusCode["TIMEOUT"] = 408] = "TIMEOUT";
    StatusCode[StatusCode["GONE"] = 410] = "GONE";
    StatusCode[StatusCode["PAYLOAD_TOO_LARGE"] = 413] = "PAYLOAD_TOO_LARGE";
    return StatusCode;
}({});
function $5767c51dc6f9e25d$export$cde1786a482f9a1c(error) {
    return $5767c51dc6f9e25d$export$9677d7c364ada66c(401, error) || $5767c51dc6f9e25d$export$9677d7c364ada66c(403, error);
}
function $5767c51dc6f9e25d$export$9677d7c364ada66c(statusCode, error) {
    if (!error) return false;
    if (error['status'] === statusCode || // error can be `ProperNetworkError` from `packages/graphql-client/src/links/error.ts`
    error['statusCode'] === statusCode) return true;
    const reg = new RegExp(`status (code)?.*(${statusCode})`);
    return !!error?.message?.match(reg);
}
function $5767c51dc6f9e25d$export$7c7624f23566b6ff(statusCode, message) {
    const reg = new RegExp(`status .*(${statusCode})`);
    return reg.test(message);
}
var $5767c51dc6f9e25d$export$c33cd4757598521c = /*#__PURE__*/ function(TeamErrorType) {
    TeamErrorType["TEAM_NOT_ACTIVE"] = "Team must be active";
    return TeamErrorType;
}({});
// Extending new custom Error types with `Object.setPrototypeOf`
// https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Object/setPrototypeOf
class $5767c51dc6f9e25d$var$CommonError extends Error {
    constructor(message){
        super(message);
        this.name = this.constructor.name;
        this.message = message || 'UnknownError';
        this.stack = new Error(message).stack || '';
    }
}
class $5767c51dc6f9e25d$export$c73ca302efeda3b4 extends $5767c51dc6f9e25d$var$CommonError {
    constructor({ message: message }){
        super(message || 'UnknownError');
        Object.setPrototypeOf(this, $5767c51dc6f9e25d$export$c73ca302efeda3b4.prototype);
    }
}
class $5767c51dc6f9e25d$export$d87f401f8106d7a2 extends $5767c51dc6f9e25d$var$CommonError {
    constructor({ message: message }){
        super(`SentryIgnore: ${message || 'UnknownError'}`);
        Object.setPrototypeOf(this, $5767c51dc6f9e25d$export$d87f401f8106d7a2.prototype);
    }
}
class $5767c51dc6f9e25d$export$65bd6083489bd8bb extends $5767c51dc6f9e25d$var$CommonError {
    constructor({ message: message, status: status, traceId: traceId, path: path }){
        super(message);
        Object.setPrototypeOf(this, $5767c51dc6f9e25d$export$65bd6083489bd8bb.prototype);
        this.status = status;
        this.traceId = traceId;
        this.path = path;
    }
}
class $5767c51dc6f9e25d$export$826a3d65b8435adf extends $5767c51dc6f9e25d$export$65bd6083489bd8bb {
    constructor(props){
        super(props);
        Object.setPrototypeOf(this, $5767c51dc6f9e25d$export$826a3d65b8435adf.prototype);
    }
}
class $5767c51dc6f9e25d$export$92d6ed0888e7cb7f extends $5767c51dc6f9e25d$var$CommonError {
    constructor({ message: message, category: category = 'default', fields: fields }){
        super(message);
        Object.setPrototypeOf(this, $5767c51dc6f9e25d$export$92d6ed0888e7cb7f.prototype);
        this.category = category;
        if (fields) this.fields = fields;
    }
    static{
        this.from = (rawErrors)=>{
            const firstError = rawErrors[0];
            const errorData = {
                category: firstError.category,
                message: firstError.message
            };
            if (firstError.fields) errorData.fields = firstError.fields.reduce((obj, item)=>{
                obj[item.field] = item.message;
                return obj;
            }, {});
            return new $5767c51dc6f9e25d$export$92d6ed0888e7cb7f(errorData);
        };
    }
}
function $5767c51dc6f9e25d$export$476aa014e2fd89d5(error) {
    return error && !!error.message && // Firefox
    (error.message.includes('NetworkError') || // Chrome
    error.message.startsWith('Failed to fetch') || error.message.includes('GraphQL error: Failed to fetch') || // cancel by users or unknown reason
    error.message.includes('GraphQL error: The operation was aborted') || error.message.includes('GraphQL error: cancelled') || error.message.includes('Abgebrochen') || error.message.includes("\u043E\u0442\u043C\u0435\u043D\u0435\u043D\u043E") || error.message.includes("\u0421\u0435\u0442\u0435\u0432\u043E\u0435 \u0441\u043E\u0435\u0434\u0438\u043D\u0435\u043D\u0438\u0435 \u043F\u043E\u0442\u0435\u0440\u044F\u043D\u043E.") || error.message.includes('anulowane') || error.message.includes("annul\xe9") || error.message.includes("\u5DF2\u53D6\u6D88") || error.message.includes('cancelado') || error.message.includes("\u30AD\u30E3\u30F3\u30BB\u30EB\u3057\u307E\u3057\u305F") || error.message.includes('cancelled') || error.message.includes('Network error') || // GraphQL-wrapping network error
    !!(error['graphQLErrors'] && error['networkError']));
}

});

parcelRegister("dmOdc", function(module, exports) {

$parcel$export(module.exports, "teamsClient", () => $1a92ea71d53eeb2b$export$5ed932c3646b89c6);

var $hzxsr = parcelRequire("hzxsr");

var $gTh2z = parcelRequire("gTh2z");

var $cHmJ2 = parcelRequire("cHmJ2");

var $49fYn = parcelRequire("49fYn");

var $gnKBB = parcelRequire("gnKBB");

var $7pLOg = parcelRequire("7pLOg");

var $8MCmh = parcelRequire("8MCmh");

var $13Kx5 = parcelRequire("13Kx5");

var $h46cM = parcelRequire("h46cM");

var $1B4EX = parcelRequire("1B4EX");

var $7thbw = parcelRequire("7thbw");

var $60KbN = parcelRequire("60KbN");

var $doDlD = parcelRequire("doDlD");

var $93qCC = parcelRequire("93qCC");

var $9zuJU = parcelRequire("9zuJU");
class $1a92ea71d53eeb2b$export$db59823f35bf78ce {
    constructor(/**
		 * @param {ClientContextProps} context - Context including CloudId & OrgId to be used for all requests
		 */ context){
        this._aggClient = (0, $gTh2z.aggClient);
        this._directoryClient = (0, $49fYn.directoryClient);
        this._legionClient = (0, $8MCmh.defaultLegionClient);
        this._mutabilityClient = (0, $13Kx5.default);
        this._permsClient = (0, $1B4EX.default);
        this._publicApiClient = (0, $7thbw.default);
        this._invitationsClient = (0, $7pLOg.default);
        this._userPreferencesClient = (0, $9zuJU.default);
        this._objectResolverClient = (0, $h46cM.default);
        this._teamsInSlackClient = (0, $93qCC.default);
        this._collaborationGraphClient = (0, $cHmJ2.default);
        this._identityClient = (0, $gnKBB.default);
        this._teamCentralClient = (0, $doDlD.default);
        this._replinesClient = (0, $60KbN.default);
        if (context) this.setContext(context);
    }
    async measurePerformance(name, fn) {
        const exp = (0, $hzxsr.TEAMS_CLIENT_EXPERIENCES).get(name);
        if (!exp) return fn();
        exp.start();
        try {
            const result = await fn();
            exp.success();
            return result;
        } catch (e) {
            exp.failWithError(e);
            throw e;
        }
    }
    /**
	 * Sets the base URL to be used in the client requests
	 * @param {string} baseUrl - The new base URL
	 */ setBaseUrl(baseUrl) {
        this._aggClient.setBaseUrl(baseUrl);
        this._directoryClient.setBaseUrl(baseUrl);
    }
    /**
	 * Sets context including CloudId & OrgId to be used for all requests
	 */ setContext(context) {
        this._aggClient.setContext(context);
        this._directoryClient.setContext(context);
        this._legionClient.setContext(context);
        this._permsClient.setContext(context);
        this._mutabilityClient.setContext(context);
        this._publicApiClient.setContext(context);
        this._invitationsClient.setContext(context);
        this._replinesClient.setContext(context);
    }
    setTeamCentralContext(baseUrl, context) {
        this._teamCentralClient.setContext(context);
        this._teamCentralClient.setBaseUrl(baseUrl);
    }
    /**
	 * @private
	 * @deprecated use setBaseUrl instead
	 */ setDirectoryBaseUrl(baseUrl) {
        // eslint-disable-next-line no-console
        console.warn('setDirectoryBaseUrl is deprecated, use setBaseUrl instead');
        return this._directoryClient.setBaseUrl(baseUrl);
    }
    /**
	 * Fetches Browse user settings
	 */ async querySettings(cloudId, product) {
        if (cloudId) this.setContext({
            cloudId: cloudId
        });
        return this.measurePerformance('querySettings', async ()=>{
            if (!product) throw new Error('Product is required');
            const response = await this._legionClient.retrieveBrowseUserPermission(product);
            return {
                'internal.browse-users-allowed': response.canSearchUsers
            };
        });
    }
    /**
	 * This will return all of the teams-related permissions that your user has for the org and site in the client context.
	 */ async getPermissions() {
        return this.measurePerformance('getPermissions', ()=>this._legionClient.getPermissions());
    }
    /**
	 * Fetches feature flags from Directory
	 * @deprecated As part of decommisioning pf-directoy
	 */ async queryFeatureFlags(...args) {
        return this.measurePerformance('queryFeatureFlags', ()=>this._directoryClient.queryFeatureFlags(...args));
    }
    /**
	 * Get user information of members of a team, paginated
	 * @param {string} teamId
	 * @returns {Promise}
	 */ async queryTeamMemberships(teamId, membershipState = [
        'FULL_MEMBER'
    ], pageInfo = {
        first: 100
    }) {
        return this._aggClient.queryTeamMemberships(teamId, membershipState, pageInfo);
    }
    /**
	 * Get user information given an user id
	 * @param {string} userId
	 * @returns {Promise}
	 */ async queryAGGUser(userId) {
        return this._aggClient.queryAGGUser(userId);
    }
    /**
	 * Get user information of a member of a team
	 * @param {string} userId
	 * @returns {Promise<CloudUser>}
	 */ queryUser(...args) {
        return this.measurePerformance('queryUser', ()=>this._directoryClient.queryUser(...args));
    }
    setLegionRootUrl(url) {
        return this._legionClient.setRootUrl(url);
    }
    /**
	 *
	 * @param teamId
	 * @returns {Promise<TeamWithImageUrls>}
	 */ async getTeamById(teamId) {
        return this.measurePerformance('getTeamById', ()=>this._legionClient.getTeamById(teamId));
    }
    /**
	 * Search teams based on query
	 */ async getAllTeams(...args) {
        return this.measurePerformance('getAllTeams', ()=>this._legionClient.getAllTeams(...args));
    }
    /**
	 * Update team details
	 */ async updateTeamById(...args) {
        return this.measurePerformance('updateTeamById', ()=>this._legionClient.updateTeamById(...args));
    }
    /**
	 * @private
	 * @deprecated use addUsersToTeam instead
	 */ async inviteUsersToTeam(...args) {
        return this.measurePerformance('inviteUsersToTeam', ()=>this._legionClient.inviteUsersToTeam(...args));
    }
    /**
	 * Get the current user's team membership
	 */ async getMyTeamMembership(...args) {
        return this.measurePerformance('getMyTeamMembership', ()=>this._legionClient.getMyTeamMembership(...args));
    }
    /**
	 * Get a teams "Links"
	 */ async getTeamLinksByTeamId(teamId) {
        return this.measurePerformance('getTeamLinksByTeamId', ()=>this._legionClient.getTeamLinksByTeamId(teamId));
    }
    /**
	 * Create a team link
	 */ async createTeamLink(...args) {
        return this.measurePerformance('createTeamLink', ()=>this._legionClient.createTeamLink(...args));
    }
    /**
	 * Update a team link
	 */ async updateTeamLink(...args) {
        return this.measurePerformance('updateTeamLink', ()=>this._legionClient.updateTeamLink(...args));
    }
    /**
	 * Delete a team link
	 */ async deleteTeamLink(...args) {
        return this.measurePerformance('deleteTeamLink', ()=>this._legionClient.deleteTeamLink(...args));
    }
    /**
	 * Reorder a team link
	 */ async reorderTeamLink(...args) {
        return this.measurePerformance('reorderTeamLink', ()=>this._legionClient.reorderTeamLink(...args));
    }
    /**
	 * Get org's eligibility for managed teams
	 */ async getOrgEligibilityForManagedTeams() {
        return this.measurePerformance('getOrgEligibilityForManagedTeams', ()=>this._legionClient.getOrgEligibilityForManagedTeams());
    }
    /**
	 * @deprecated Invitation status no longer exists
	 * Accept a team invitation
	 */ async acceptTeamInvitation(...args) {
        return this.measurePerformance('acceptTeamInvitation', ()=>this._legionClient.acceptTeamInvitation(...args));
    }
    /**
	 * @deprecated Invitation status no longer exists
	 * Decline a team invitation
	 */ async declineTeamInvitation(...args) {
        return this.measurePerformance('declineTeamInvitation', ()=>this._legionClient.declineTeamInvitation(...args));
    }
    /**
	 * Add current user to a team
	 */ async selfJoinTeam(...args) {
        return this.measurePerformance('selfJoinTeam', ()=>this._legionClient.selfJoinTeam(...args));
    }
    /**
	 * Cancel a join request to a private team
	 */ async cancelJoinRequest(teamId) {
        return this.measurePerformance('cancelJoinRequest', ()=>this._legionClient.cancelJoinRequest(teamId));
    }
    /**
	 * Accept a join request to a private team
	 */ async acceptJoinRequest(...args) {
        return this.measurePerformance('acceptJoinRequest', ()=>this._legionClient.acceptJoinRequest(...args));
    }
    /**
	 * Decline a join request to a private team
	 */ async declineJoinRequest(...args) {
        return this.measurePerformance('declineJoinRequest', ()=>this._legionClient.declineJoinRequest(...args));
    }
    /**
	 * @deprecated use removeTeamMemberships instead
	 */ async deleteTeamMembership(...args) {
        return this.measurePerformance('deleteTeamMembership', ()=>this._legionClient.deleteTeamMembership(...args));
    }
    /**
	 * @deprecated INVITED status has been deprecated
	 */ async revokeTeamInvite(...args) {
        return this.measurePerformance('revokeTeamInvite', ()=>this._legionClient.revokeTeamInvite(...args));
    }
    /**
	 * Delete a team
	 */ async deleteTeam(teamId) {
        return this.measurePerformance('deleteTeam', ()=>this._legionClient.deleteTeam(teamId));
    }
    /**
	 * @private
	 * @deprecated should be other means to solve this issue
	 */ async isSingleFullMemberTeam(teamId) {
        return this._legionClient.isSingleFullMemberTeam(teamId);
    }
    /**
	 * Create a team
	 */ async createTeam(...args) {
        return this.measurePerformance('createTeam', ()=>this._legionClient.createTeam(...args));
    }
    /**
	 * Create containers for a team
	 */ async createTeamContainers(...args) {
        return this.measurePerformance('createTeamContainers', ()=>this._legionClient.createTeamContainers(...args));
    }
    /**
	 * Create a external team
	 * @param {string} groupDescription - The description of the group, which will be used as the team description. The group name will be fetched from the identity service, so it does not need to be provided.
	 * @param {ExternalReference} externalReference
	 */ async createExternalTeam(...args) {
        return this.measurePerformance('createExternalTeam', ()=>this._legionClient.createExternalTeam(...args));
    }
    /**
	 * Get linked teams for a groups in bulk
	 * @param {string} groupIds - The group ids to fetch linked teams for
	 */ async getLinkedTeamsBulk(...args) {
        return this.measurePerformance('getLinkedTeamsBulk', ()=>this._legionClient.getLinkedTeamsBulk(...args));
    }
    /**
	 * Get Org scope
	 */ async getOrgScope(...args) {
        return this.measurePerformance('getOrgScope', ()=>this._legionClient.getOrgScope(...args));
    }
    /**
	 * Restore soft-deleted team and sync to group
	 */ async restoreTeamToSyncedGroup(...args) {
        return this.measurePerformance('restoreTeamToSyncedGroup', ()=>this._legionClient.restoreTeamToSyncedGroup(...args));
    }
    /**
	 * Get the difference between a team and a group
	 * @param teamId
	 * @param {ExternalReference} externalReference
	 * @returns {Promise<TeamAndGroupDifference>}
	 */ async getTeamAndGroupDiff(...args) {
        return this.measurePerformance('getTeamAndGroupDiff', ()=>this._legionClient.getTeamAndGroupDiff(...args));
    }
    /**
	 * Link an existing team to a group
	 * @param teamId
	 * @param {ExternalReference} externalReference
	 */ async linkExistingTeamToGroup(...args) {
        return this.measurePerformance('linkExistingTeamToGroup', ()=>this._legionClient.linkExistingTeamToGroup(...args));
    }
    /**
	 *
	 * @param teamId
	 * @returns {Promise<LinkedTeamsProfileDetails>}
	 */ async getTeamProfileDetailsByTeamId(...args) {
        return this.measurePerformance('getTeamProfileDetails', ()=>this._legionClient.getTeamProfileDetails(...args));
    }
    /**
	 *
	 * @param teamId
	 * @returns {Promise<SoftDeletedTeam>}
	 */ async getSoftDeletdTeamById(teamId) {
        return this.measurePerformance('getSoftDeletedTeamById', ()=>this._legionClient.getSoftDeletedTeamById(teamId));
    }
    /**
	 * Shoud only be used within Teams (P&T) packages
	 * @param userId
	 * @returns {Promise<SoftDeletedTeam>}
	 */ async getUserInSiteUserBase(userId) {
        return this.measurePerformance('getUserInSiteUserBase', ()=>this._legionClient.getUserInSiteUserBase(userId));
    }
    trimTeamARI(teamId = '') {
        return this._legionClient.trimTeamARI(teamId);
    }
    /**
	 * Get user profile with mutability constraints
	 */ async getProfileWithMutability(...args) {
        return this.measurePerformance('getProfileWithMutability', ()=>this._mutabilityClient.getProfileWithMutability(...args));
    }
    /**
	 * Is the current user a site admin
	 */ getIsSiteAdmin(...args) {
        return this.measurePerformance('getIsSiteAdmin', ()=>this._permsClient.getIsSiteAdmin(...args));
    }
    /**
	 * Add users to a team
	 */ addUsersToTeam(...args) {
        return this.measurePerformance('addUsersToTeam', ()=>this._publicApiClient.addUsersToTeam(...args));
    }
    /**
	 * Remove users from a team
	 */ removeTeamMemberships(...args) {
        return this.measurePerformance('removeTeamMemberships', ()=>this._publicApiClient.removeTeamMemberships(...args));
    }
    /**
	 * Restore a deleted team
	 */ restoreTeam(...args) {
        return this.measurePerformance('restoreTeam', ()=>this._publicApiClient.restoreTeam(...args));
    }
    getRecommendedProducts(...args) {
        return this.measurePerformance('getRecommendedProducts', ()=>this._invitationsClient.getProductRecommendations(...args));
    }
    joinOrRequestDefaultAccessToProductsBulk(...args) {
        return this.measurePerformance('joinOrRequestDefaultAccessToProductsBulk', ()=>this._invitationsClient.joinOrRequestDefaultAccessToProductsBulk(...args));
    }
    /**
	 * Get token to upload media for a team
	 */ async getWriteTeamMediaToken() {
        return this.measurePerformance('getWriteTeamMediaToken', ()=>this._legionClient.getWriteMediaToken());
    }
    /**
	 * Get token to read media for a user
	 */ async getReadMediaToken(...args) {
        return this.measurePerformance('getReadMediaToken', ()=>this._userPreferencesClient.getReadMediaToken(...args));
    }
    /**
	 * Get token to upload media for a user
	 */ async getWriteUserMediaToken() {
        return this.measurePerformance('getWriteUserMediaToken', ()=>this._userPreferencesClient.getWriteMediaToken());
    }
    /**
	 * Update header image for a user
	 */ async updateUserHeaderImage(headerImageId) {
        return this.measurePerformance('updateUserHeaderImage', ()=>this._userPreferencesClient.updateUserHeaderImage(headerImageId));
    }
    /**
	 * Fetch user containers from collboration graph
	 */ async getUserContainers(...args) {
        return this.measurePerformance('getUserContainers', ()=>this._collaborationGraphClient.getUserContainers(...args));
    }
    /**
	 * Fetch mutatability of external managed user fields
	 */ async getUserManageConfig(...args) {
        return this.measurePerformance('getUserManageConfig', ()=>this._identityClient.getUserManageConfig(...args));
    }
    /**
	 * Fetch user avatar uploaded status
	 */ async getMyAvatarUploadedStatus(...args) {
        return this.measurePerformance('getMyAvatarUploadedStatus', ()=>this._identityClient.getMyAvatarUploadedStatus(...args));
    }
    /**
	 * Delete user avatar
	 */ async deleteAvatar(...args) {
        return this.measurePerformance('deleteUserAvatar', ()=>this._identityClient.deleteAvatar(...args));
    }
    async fetchUserAvatarInfo(...args) {
        return this.measurePerformance('fetchUserAvatarInfo', ()=>this._identityClient.fetchUserAvatarInfo(...args));
    }
    /**
	 * Fetch Team link icons
	 */ async getTeamLinkIcons(...args) {
        return this.measurePerformance('getTeamLinkIcons', ()=>this._objectResolverClient.getTeamLinkIcons(...args));
    }
    /**
	 * Fetch ARI from URL
	 */ async getAriFromUrl(...args) {
        return this.measurePerformance('getAriFromUrl', ()=>this._objectResolverClient.getAriFromUrl(...args));
    }
    /**
	 * Fetch team in slack details
	 */ async getTeamInSlack(...args) {
        return this.measurePerformance('getTeamInSlack', ()=>this._teamsInSlackClient.getTeamInSlack(...args));
    }
    /**
	 * Delete team in slack
	 */ async disconnectTeamInSlack(...args) {
        return this.measurePerformance('disconnectTeamInSlack', ()=>this._teamsInSlackClient.disconnectTeamInSlack(...args));
    }
    /**
	 * Update team in slack
	 */ async updateTeamInSlack(...args) {
        return this.measurePerformance('updateTeamInSlack', ()=>this._teamsInSlackClient.updateTeamInSlack(...args));
    }
    /**
	 * Update user details
	 */ async updateUser(...args) {
        return this.measurePerformance('updateUser', ()=>this._identityClient.updateUser(...args));
    }
    async updateUserAvatar(...args) {
        return this.measurePerformance('updateUserAvatar', ()=>this._identityClient.updateUserAvatar(...args));
    }
    async addTeamWatcher(...args) {
        return this._teamCentralClient.addTeamWatcher(...args);
    }
    async removeTeamWatcher(...args) {
        return this._teamCentralClient.removeTeamWatcher(...args);
    }
    async deleteKudos(...args) {
        return this._teamCentralClient.deleteKudos(...args);
    }
    async queryTagList(...args) {
        return this._teamCentralClient.queryTagList(...args);
    }
    async createTag(...args) {
        return this._teamCentralClient.createTag(...args);
    }
    async createHelpPointer(...args) {
        return this._teamCentralClient.createHelpPointer(...args);
    }
    async updateHelpPointer(...args) {
        return this._teamCentralClient.updateHelpPointer(...args);
    }
    async deleteHelpPointer(...args) {
        return this._teamCentralClient.deleteHelpPointer(...args);
    }
    async getUserTenure(...args) {
        return this.measurePerformance('getUserTenure', ()=>this._replinesClient.getUserTenure(...args));
    }
}
const $1a92ea71d53eeb2b$export$5ed932c3646b89c6 = new $1a92ea71d53eeb2b$export$db59823f35bf78ce();

});
parcelRegister("hzxsr", function(module, exports) {

$parcel$export(module.exports, "TEAMS_CLIENT_EXPERIENCES", () => $e069606520fb7fe4$export$879344107b04120c);

var $7Zbvr = parcelRequire("7Zbvr");

var $baNgi = parcelRequire("baNgi");
const $e069606520fb7fe4$var$TeamsClientExperienceKeyList = [
    'getAllTeams',
    'getTeamById',
    'updateTeamById',
    'querySettings',
    'queryFeatureFlags',
    'queryTeamMemberships',
    'queryUser',
    'inviteUsersToTeam',
    'getMyTeamMembership',
    'getTeamLinksByTeamId',
    'createTeamLink',
    'updateTeamLink',
    'deleteTeamLink',
    'reorderTeamLink',
    'acceptTeamInvitation',
    'declineTeamInvitation',
    'selfJoinTeam',
    'cancelJoinRequest',
    'acceptJoinRequest',
    'declineJoinRequest',
    'deleteTeamMembership',
    'revokeTeamInvite',
    'deleteTeam',
    'isSingleFullMemberTeam',
    'createTeam',
    'createTeamContainers',
    'createExternalTeam',
    'getProfileWithMutability',
    'getIsSiteAdmin',
    'addUsersToTeam',
    'removeTeamMemberships',
    'getRecommendedProducts',
    'joinOrRequestDefaultAccessToProductsBulk',
    'getReadMediaToken',
    'getWriteUserMediaToken',
    'updateUserHeaderImage',
    'getWriteTeamMediaToken',
    'getSoftDeletedTeamById',
    'restoreTeam',
    'getUserInSiteUserBase',
    'getLinkedTeamsBulk',
    'getTeamProfileDetails',
    'getUserContainers',
    'getPermissions',
    'getUserManageConfig',
    'getMyAvatarUploadedStatus',
    'deleteUserAvatar',
    'getTeamLinkIcons',
    'getTeamInSlack',
    'getOrgScope',
    'restoreTeamToSyncedGroup',
    'getTeamAndGroupDiff',
    'linkExistingTeamToGroup',
    'fetchUserAvatarInfo',
    'getOrgEligibilityForManagedTeams',
    'updateUser',
    'updateUserAvatar',
    'disconnectTeamInSlack',
    'updateTeamInSlack',
    'getUserTenure',
    'getAriFromUrl'
];
const $e069606520fb7fe4$export$879344107b04120c = new Map([
    ...$e069606520fb7fe4$var$TeamsClientExperienceKeyList.map((key)=>[
            key,
            // camelCase to kebab-case
            new (0, $baNgi.TeamsUFOExperience)(`teams-client-${key.replace(/([a-z])([A-Z])/g, '$1-$2').toLowerCase()}`, {
                type: (0, $7Zbvr.ExperienceTypes).Operation,
                performanceType: (0, $7Zbvr.ExperiencePerformanceTypes).Custom,
                platform: {
                    component: 'people'
                }
            })
        ])
]);

});
parcelRegister("7Zbvr", function(module, exports) {

$parcel$export(module.exports, "ExperienceTypes", () => $e40e68027603de60$export$994164cf3ae1cc9a);
$parcel$export(module.exports, "ExperiencePerformanceTypes", () => $e40e68027603de60$export$cc26007c03242fff);
var $e40e68027603de60$export$994164cf3ae1cc9a = /*#__PURE__*/ function(ExperienceTypes) {
    ExperienceTypes["Load"] = "load";
    ExperienceTypes["Experience"] = "experience";
    ExperienceTypes["Operation"] = "operation";
    return ExperienceTypes;
}({});
var $e40e68027603de60$export$cc26007c03242fff = /*#__PURE__*/ function(ExperiencePerformanceTypes) {
    ExperiencePerformanceTypes["PageLoad"] = "page-load";
    ExperiencePerformanceTypes["PageSegmentLoad"] = "page-segment-load";
    ExperiencePerformanceTypes["InlineResult"] = "inline-result";
    ExperiencePerformanceTypes["Custom"] = "custom";
    return ExperiencePerformanceTypes;
}({});

});

parcelRegister("baNgi", function(module, exports) {

$parcel$export(module.exports, "TeamsUFOExperience", () => $01e6318fcd37fd21$export$9a18529d1e90e81a);

var $boHLC = parcelRequire("boHLC");

var $1K4T6 = parcelRequire("1K4T6");

var $139Gm = parcelRequire("139Gm");
class $01e6318fcd37fd21$export$9a18529d1e90e81a extends (0, $boHLC.UFOExperience) {
    abortWithError(error, reason) {
        return super.abort({
            metadata: {
                error: (0, $139Gm.createErrorMetadata)(error),
                reason: reason
            }
        });
    }
    failWithError(error) {
        if (error instanceof Error) {
            if ((0, $1K4T6.isAuthError)(error)) return this.abortWithError(error, 'Abort due to user unauthenticated');
            if ((0, $1K4T6.isErrorStatusCode)((0, $1K4T6.StatusCode).GONE, error)) return this.abortWithError(error, 'Abort due to unavailable resource');
            if ((0, $139Gm.isIgnoredError)(error)) return this.abortWithError(error, 'Abort due to an error in ignore list');
            if ((0, $1K4T6.isNetworkError)(error)) return this.abortWithError(error, 'Abort due to network error');
            return super.failure({
                metadata: {
                    error: (0, $139Gm.createErrorMetadata)(error),
                    packageVersion: "0.0.0-use.local",
                    packageName: "platform-pkg"
                }
            });
        }
        return super.failure({
            metadata: {
                error: 'unknown error',
                packageVersion: "0.0.0-use.local",
                packageName: "platform-pkg"
            }
        });
    }
}

});
parcelRegister("boHLC", function(module, exports) {

$parcel$export(module.exports, "UFOExperience", () => $69d53cdb5241e240$export$c00d22927c60484a);

var $iLwDN = parcelRequire("iLwDN");
class $69d53cdb5241e240$export$c00d22927c60484a extends (0, $iLwDN.UFOAbstractExperience) {
}

});
parcelRegister("iLwDN", function(module, exports) {

$parcel$export(module.exports, "UFOAbstractExperience", () => $cc70575b2203e361$export$d31c89db257648c);

var $7Jxgt = parcelRequire("7Jxgt");


var $1vlV8 = parcelRequire("1vlV8");

var $dCAsn = parcelRequire("dCAsn");

var $dlucd = parcelRequire("dlucd");

var $blQsS = parcelRequire("blQsS");

var $9tjMO = parcelRequire("9tjMO");

var $1CRHx = parcelRequire("1CRHx");

var $jZA09 = parcelRequire("jZA09");

var $hM2B6 = parcelRequire("hM2B6");

var $7Zbvr = parcelRequire("7Zbvr");
const $cc70575b2203e361$var$getPageVisibleState = ()=>{
    return !(0, $1CRHx.isWindowObjectAvailable)() || !window.document || window.document.visibilityState === 'visible' ? (0, $blQsS.PageVisibleState).VISIBLE : (0, $blQsS.PageVisibleState).HIDDEN;
};
const $cc70575b2203e361$export$c753e8669d30c8ad = (timestamp)=>{
    if (timestamp !== undefined) return ~~timestamp;
    return (0, $9tjMO.roundPerfNow)();
};
class $cc70575b2203e361$export$d31c89db257648c {
    constructor(id, config, instanceId = null){
        this.state = (0, $jZA09.UFOExperienceState).NOT_STARTED;
        this.instanceId = null // for concurrent
        ;
        this.parent = null;
        this.category = null;
        this.metadata = {};
        this.onDoneCallbacks = [];
        this.childExperiences = [];
        this.explicitTimings = {};
        // @todo move to page load experience when proper classes/inheritance prepared
        this.isSSROutputAsFMP = false;
        this.uuid = null;
        this._until = null;
        this.metrics = {
            startTime: null,
            endTime: null,
            marks: []
        };
        this.performanceConfig = {};
        this.setPageVisibleStateToMixed = ()=>{
            this.pageVisibleState = (0, $blQsS.PageVisibleState).MIXED;
            (0, $dlucd.visibilityChangeObserver).unsubscribe(this.setPageVisibleStateToMixed);
        };
        this.id = id;
        this.category = config?.category || null;
        this.until = config?.until || null;
        this.instanceId = instanceId;
        this.handleDoneBind = this._handleDoneExperience.bind(this);
        this.type = config.type;
        this.performanceType = config.performanceType;
        this.performanceConfig = config.performanceConfig || {};
        this.config = config;
        this.pageVisibleState = $cc70575b2203e361$var$getPageVisibleState();
        this.featureFlags = config.featureFlags || [];
        this.timings = config.timings || [];
        if (config.performanceType === (0, $7Zbvr.ExperiencePerformanceTypes).PageLoad || config.performanceType === (0, $7Zbvr.ExperiencePerformanceTypes).PageSegmentLoad) this.isSSROutputAsFMP = config.isSSROutputAsFMP || false;
    }
    async transition(newState, timestamp) {
        (0, $dCAsn.ufolog)('async transition', this.id, this.state.id, newState.id);
        if ((0, $hM2B6.canTransition)(this.state, newState)) {
            (0, $dCAsn.ufolog)(`TRANSITION: ${this.id} from ${this.state.id} to ${newState.id} successful`, this.state.final, !newState.final);
            if (newState === (0, $jZA09.UFOExperienceState).STARTED) this._reset();
            if (this.state.final && !newState.final) {
                this.metrics.startTime = $cc70575b2203e361$export$c753e8669d30c8ad(timestamp);
                this.uuid = (0, $7Jxgt.v4)();
            }
            this.state = newState;
            if (newState.final) {
                this.metrics.endTime = $cc70575b2203e361$export$c753e8669d30c8ad(timestamp);
                if (!this._isManualStateEnabled()) (0, $1vlV8.getGlobalEventStream)().push((0, $1vlV8.unsubscribeEvent)((0, $blQsS.SUBSCRIBE_ALL), this.handleDoneBind));
                const data = await this.exportData();
                (0, $dCAsn.ufolog)('this.parent', this.parent);
                (0, $1vlV8.getGlobalEventStream)().push((0, $1vlV8.experiencePayloadEvent)(data));
            }
            return true;
        }
        (0, $dCAsn.ufolog)(`TRANSITION: ${this.id} from ${this.state.id} to ${newState.id} unsuccessful`);
        (0, $dCAsn.ufowarn)(`transition of ${this.id} from ${this.state} to ${newState} is not possible`);
        return false;
    }
    async start(startTime) {
        const transitionSuccessful = await this.transition((0, $jZA09.UFOExperienceState).STARTED, startTime);
        if (transitionSuccessful) {
            this.pageVisibleState = $cc70575b2203e361$var$getPageVisibleState();
            (0, $dlucd.visibilityChangeObserver).subscribe(this.setPageVisibleStateToMixed);
            if (!this._isManualStateEnabled()) {
                (0, $dCAsn.ufolog)('subscribed', this.id);
                (0, $1vlV8.getGlobalEventStream)().push((0, $1vlV8.subscribeEvent)((0, $blQsS.SUBSCRIBE_ALL), this.handleDoneBind));
            }
        }
    }
    mark(name, timestamp) {
        if (name !== (0, $blQsS.FMP_MARK) && name !== (0, $blQsS.INLINE_RESPONSE_MARK)) this._mark(name, timestamp);
        else (0, $dCAsn.ufowarn)('please use markFMP or markInlineResponse for specialised marks');
    }
    _mark(name, timestamp) {
        this.metrics.marks.push({
            name: name,
            time: $cc70575b2203e361$export$c753e8669d30c8ad(timestamp)
        });
        this.transition((0, $jZA09.UFOExperienceState).IN_PROGRESS);
    }
    markFMP(timestamp) {
        this._mark((0, $blQsS.FMP_MARK), timestamp);
    }
    markInlineResponse(timestamp) {
        this._mark((0, $blQsS.INLINE_RESPONSE_MARK), timestamp);
    }
    _isManualStateEnabled() {
        return this.until === null;
    }
    _validateManualState() {
        if (!this._isManualStateEnabled()) {
            (0, $dCAsn.ufowarn)('manual change of state not allowed as "until" is defined');
            return false;
        }
        return true;
    }
    switchToEndState(state, config) {
        if (!config?.force && !this._validateManualState()) return null;
        if (config?.metadata) this.addMetadata(config.metadata);
        (0, $dlucd.visibilityChangeObserver).unsubscribe(this.setPageVisibleStateToMixed);
        return this.transition(state);
    }
    async success(config) {
        return this.switchToEndState((0, $jZA09.UFOExperienceState).SUCCEEDED, config);
    }
    async failure(config) {
        return this.switchToEndState((0, $jZA09.UFOExperienceState).FAILED, config);
    }
    async abort(config) {
        return this.switchToEndState((0, $jZA09.UFOExperienceState).ABORTED, config);
    }
    addMetadata(data) {
        Object.assign(this.metadata, data);
    }
    _handleDoneExperience(data) {
        (0, $dCAsn.ufolog)('_handleDoneExperience in', this.id, data.state, data, this._until);
        if (data.state.final) {
            if (this._until !== null) {
                const { done: done, state: state } = this._until(data);
                if (done && !this.state.final) this.transition(state);
            }
        }
    }
    async getId() {
        return this.id;
    }
    async exportData() {
        return {
            id: await this.getId(),
            uuid: this.uuid,
            type: this.type,
            schemaVersion: (0, $bbbd8b5766b053fb$export$2295b861f318254a) || 'unknown',
            performanceType: this.performanceType,
            category: this.category,
            state: this.state,
            metadata: {
                ...this.metadata
            },
            metrics: {
                ...this.metrics
            },
            children: [
                ...this.childExperiences
            ],
            result: {
                success: !!this.state.success,
                startTime: this.metrics.startTime,
                duration: (this.metrics.endTime || 0) - (this.metrics.startTime || 0)
            },
            platform: this.config.platform || null,
            pageVisibleState: this.pageVisibleState,
            featureFlags: this.featureFlags,
            isSSROutputAsFMP: this.isSSROutputAsFMP,
            timings: this.timings,
            explicitTimings: this.explicitTimings,
            performanceConfig: this.performanceConfig
        };
    }
    _reset() {
        this.parent = null;
        this.metadata = {};
        this.onDoneCallbacks = [];
        this.childExperiences = [];
        this.metrics = {
            startTime: null,
            endTime: null,
            marks: []
        };
        this._until = this.until ? this.until() : null;
    }
}

});
// temp solution until we can get it automated
const $bbbd8b5766b053fb$export$2295b861f318254a = '0.1.5';

parcelRegister("1vlV8", function(module, exports) {

$parcel$export(module.exports, "getGlobalEventStream", () => $d117cb8be5e8747a$export$6123a44dc2384540);
$parcel$export(module.exports, "subscribeEvent", () => $d117cb8be5e8747a$export$37863216db4b714d);
$parcel$export(module.exports, "unsubscribeEvent", () => $d117cb8be5e8747a$export$ee1a7bd1fc9ea85e);
$parcel$export(module.exports, "experiencePayloadEvent", () => $d117cb8be5e8747a$export$7c957416596ca127);

var $dCAsn = parcelRequire("dCAsn");

var $blQsS = parcelRequire("blQsS");
const $d117cb8be5e8747a$var$MAX_EARLY_QUEUE_LENGTH = 250;
const $d117cb8be5e8747a$export$6123a44dc2384540 = ()=>{
    if (!globalThis.__UFO_GLOBAL_EVENT_STREAM__) {
        const earlyStream = (()=>{
            const stream = [];
            return {
                __buffer_only__: true,
                push: (event)=>{
                    if (stream.length < $d117cb8be5e8747a$var$MAX_EARLY_QUEUE_LENGTH) stream.push(event);
                },
                getStream: ()=>stream
            };
        })();
        globalThis.__UFO_GLOBAL_EVENT_STREAM__ = earlyStream;
    }
    return globalThis.__UFO_GLOBAL_EVENT_STREAM__;
};
const $d117cb8be5e8747a$export$c1522520b417b066 = (eventStream)=>{
    if (globalThis.__UFO_GLOBAL_EVENT_STREAM__ && !globalThis.__UFO_GLOBAL_EVENT_STREAM__?.__buffer_only__) {
        (0, $dCAsn.ufowarn)('Global Event Stream already initialised. Ignoring new event stream setup');
        return;
    }
    if (globalThis.__UFO_GLOBAL_EVENT_STREAM__?.__buffer_only__) globalThis.__UFO_GLOBAL_EVENT_STREAM__.getStream().forEach(eventStream.push.bind(eventStream));
    globalThis.__UFO_GLOBAL_EVENT_STREAM__ = eventStream;
};
const $d117cb8be5e8747a$export$37863216db4b714d = (experienceId, callback)=>{
    return {
        type: (0, $blQsS.UFOGlobalEventStreamEventType).SUBSCRIBE,
        payload: {
            experienceId: experienceId,
            callback: callback
        }
    };
};
const $d117cb8be5e8747a$export$ee1a7bd1fc9ea85e = (experienceId, callback)=>{
    return {
        type: (0, $blQsS.UFOGlobalEventStreamEventType).UNSUBSCRIBE,
        payload: {
            experienceId: experienceId,
            callback: callback
        }
    };
};
const $d117cb8be5e8747a$export$7c957416596ca127 = (data)=>{
    return {
        type: (0, $blQsS.UFOGlobalEventStreamEventType).EXPERIENCE_PAYLOAD,
        payload: data
    };
};

});
parcelRegister("dCAsn", function(module, exports) {

$parcel$export(module.exports, "ufolog", () => $c8856379f9e2d7e8$export$b4958caff08a0960);
$parcel$export(module.exports, "ufowarn", () => $c8856379f9e2d7e8$export$d53d07b6034c4560);
class $c8856379f9e2d7e8$var$UFOLogger {
    static{
        this.UFOprefix = "[ufo\uD83D\uDEF8]";
    }
    log(...args) {
        // eslint-disable-next-line no-console
        this.enabled && console.log($c8856379f9e2d7e8$var$UFOLogger.UFOprefix, ...args);
    }
    warn(...args) {
        // eslint-disable-next-line no-console
        this.enabled && console.warn($c8856379f9e2d7e8$var$UFOLogger.UFOprefix, ...args);
    }
    enable() {
        this.enabled = true;
    }
    disable() {
        this.enabled = false;
    }
    constructor(){
        this.enabled = false;
    }
}
const $c8856379f9e2d7e8$export$4ab84f6f04f6566d = new $c8856379f9e2d7e8$var$UFOLogger();
const $c8856379f9e2d7e8$export$b4958caff08a0960 = (...args)=>{
    $c8856379f9e2d7e8$export$4ab84f6f04f6566d.log(...args);
};
const $c8856379f9e2d7e8$export$d53d07b6034c4560 = (...args)=>{
    $c8856379f9e2d7e8$export$4ab84f6f04f6566d.warn(...args);
};

});

parcelRegister("blQsS", function(module, exports) {

$parcel$export(module.exports, "UFOGlobalEventStreamEventType", () => $2d245cff606eb60d$export$96253c35c37cf96b);
$parcel$export(module.exports, "PageVisibleState", () => $2d245cff606eb60d$export$a12c67b37a306b13);
$parcel$export(module.exports, "SUBSCRIBE_ALL", () => $2d245cff606eb60d$export$79bf131685ad41d7);
$parcel$export(module.exports, "FMP_MARK", () => $2d245cff606eb60d$export$9f2bf58999404c75);
$parcel$export(module.exports, "INLINE_RESPONSE_MARK", () => $2d245cff606eb60d$export$837e0f79a8056912);
var $2d245cff606eb60d$export$96253c35c37cf96b = /*#__PURE__*/ function(UFOGlobalEventStreamEventType) {
    UFOGlobalEventStreamEventType[UFOGlobalEventStreamEventType["EXPERIENCE_PAYLOAD"] = 0] = "EXPERIENCE_PAYLOAD";
    UFOGlobalEventStreamEventType[UFOGlobalEventStreamEventType["SUBSCRIBE"] = 1] = "SUBSCRIBE";
    UFOGlobalEventStreamEventType[UFOGlobalEventStreamEventType["UNSUBSCRIBE"] = 2] = "UNSUBSCRIBE";
    return UFOGlobalEventStreamEventType;
}({});
var $2d245cff606eb60d$export$a12c67b37a306b13 = /*#__PURE__*/ function(PageVisibleState) {
    PageVisibleState["VISIBLE"] = "visible";
    PageVisibleState["HIDDEN"] = "hidden";
    PageVisibleState["MIXED"] = "mixed";
    return PageVisibleState;
}({});
var $2d245cff606eb60d$export$66b33c055cbb625e = /*#__PURE__*/ function(PageLoadMetrics) {
    PageLoadMetrics["fmp"] = "fmp";
    PageLoadMetrics["tti"] = "tti";
    return PageLoadMetrics;
}({});
var $2d245cff606eb60d$export$3ce489cbe02dc21b = /*#__PURE__*/ function(PageSegmentLoadMetrics) {
    PageSegmentLoadMetrics["fmp"] = "fmp";
    PageSegmentLoadMetrics["tti"] = "tti";
    return PageSegmentLoadMetrics;
}({});
var $2d245cff606eb60d$export$341b330828bd3906 = /*#__PURE__*/ function(InteractionMetrics) {
    InteractionMetrics["response"] = "response";
    InteractionMetrics["result"] = "result";
    return InteractionMetrics;
}({});
var $2d245cff606eb60d$export$b9b20160f581e4f8 = /*#__PURE__*/ function(CustomMetrics) {
    CustomMetrics["duration"] = "duration";
    return CustomMetrics;
}({});
const $2d245cff606eb60d$export$79bf131685ad41d7 = '__SUBSCRIBE_ALL__';
const $2d245cff606eb60d$export$9f2bf58999404c75 = 'fmp';
const $2d245cff606eb60d$export$837e0f79a8056912 = 'inline-response';

});


parcelRegister("dlucd", function(module, exports) {

$parcel$export(module.exports, "visibilityChangeObserver", () => $46b8336a04974a29$export$13e680397ec8f3eb);

var $1CRHx = parcelRequire("1CRHx");
class $46b8336a04974a29$var$VisibilityChangeObserver {
    start() {
        if (this.started) return;
        this.started = true;
        document.addEventListener('visibilitychange', this.broadcast);
        /**
		 * According to https://developer.mozilla.org/en-US/docs/Web/API/Document/visibilitychange_event
		 * Safari doesn’t fire visibilitychange as expected when the value of the visibilityState property transitions to hidden;
		 * so for that case, you need to also include code to listen for the pagehide event.
		 */ if ((0, $1CRHx.isWindowObjectAvailable)()) window.addEventListener('pagehide', this.broadcast);
    }
    subscribe(callback) {
        this.observers.push(callback);
    }
    unsubscribe(callback) {
        this.observers = this.observers.filter((fn)=>fn !== callback);
    }
    constructor(){
        this.started = false;
        this.observers = [];
        this.broadcast = ()=>{
            this.observers.forEach((fn)=>fn());
            this.observers = [];
        };
    }
}
const $46b8336a04974a29$export$13e680397ec8f3eb = new $46b8336a04974a29$var$VisibilityChangeObserver();

});
parcelRegister("1CRHx", function(module, exports) {

$parcel$export(module.exports, "isWindowObjectAvailable", () => $5d24ea5e24f61a4f$export$15e172712955e18f);
const $5d24ea5e24f61a4f$export$15e172712955e18f = ()=>{
    return typeof window !== 'undefined';
};

});


parcelRegister("9tjMO", function(module, exports) {

$parcel$export(module.exports, "roundPerfNow", () => $29608d3bcf65c265$export$5f490af6b2b115cf);
const $29608d3bcf65c265$export$5f490af6b2b115cf = ()=>~~performance.now();

});

parcelRegister("jZA09", function(module, exports) {

$parcel$export(module.exports, "UFOExperienceState", () => $175f7a63840c5fab$export$81b70111112841a0);
const $175f7a63840c5fab$export$81b70111112841a0 = {
    NOT_STARTED: {
        id: 'NOT_STARTED',
        final: true
    },
    STARTED: {
        id: 'STARTED'
    },
    IN_PROGRESS: {
        id: 'IN_PROGRESS'
    },
    BLOCKED: {
        id: 'BLOCKED'
    },
    RECOVERED: {
        id: 'RECOVERED'
    },
    SUCCEEDED: {
        id: 'SUCCEEDED',
        final: true,
        success: true
    },
    SUCCEEDED_WAITING_FOR_DEPS: {
        id: 'SUCCEEDED_WAITING_FOR_DEPS'
    },
    FAILED: {
        id: 'FAILED',
        final: true
    },
    ABORTED: {
        id: 'ABORTED',
        final: true
    }
};

});

parcelRegister("hM2B6", function(module, exports) {

$parcel$export(module.exports, "canTransition", () => $6edf4365ea9733d4$export$178881f329fdb81f);

var $jZA09 = parcelRequire("jZA09");
const $6edf4365ea9733d4$var$UFOStateAvailableTransitions = {
    [(0, $jZA09.UFOExperienceState).NOT_STARTED.id]: [
        (0, $jZA09.UFOExperienceState).STARTED.id
    ],
    [(0, $jZA09.UFOExperienceState).STARTED.id]: [
        (0, $jZA09.UFOExperienceState).IN_PROGRESS.id,
        (0, $jZA09.UFOExperienceState).BLOCKED.id,
        (0, $jZA09.UFOExperienceState).SUCCEEDED.id,
        (0, $jZA09.UFOExperienceState).SUCCEEDED_WAITING_FOR_DEPS.id,
        (0, $jZA09.UFOExperienceState).FAILED.id,
        (0, $jZA09.UFOExperienceState).ABORTED.id
    ],
    [(0, $jZA09.UFOExperienceState).IN_PROGRESS.id]: [
        (0, $jZA09.UFOExperienceState).BLOCKED.id,
        (0, $jZA09.UFOExperienceState).SUCCEEDED.id,
        (0, $jZA09.UFOExperienceState).SUCCEEDED_WAITING_FOR_DEPS.id,
        (0, $jZA09.UFOExperienceState).FAILED.id,
        (0, $jZA09.UFOExperienceState).ABORTED.id
    ],
    [(0, $jZA09.UFOExperienceState).BLOCKED.id]: [
        (0, $jZA09.UFOExperienceState).RECOVERED.id,
        (0, $jZA09.UFOExperienceState).ABORTED.id
    ],
    [(0, $jZA09.UFOExperienceState).RECOVERED.id]: [
        (0, $jZA09.UFOExperienceState).STARTED.id,
        (0, $jZA09.UFOExperienceState).SUCCEEDED.id,
        (0, $jZA09.UFOExperienceState).SUCCEEDED_WAITING_FOR_DEPS.id,
        (0, $jZA09.UFOExperienceState).FAILED.id,
        (0, $jZA09.UFOExperienceState).ABORTED.id
    ],
    [(0, $jZA09.UFOExperienceState).SUCCEEDED.id]: [
        (0, $jZA09.UFOExperienceState).STARTED.id
    ],
    [(0, $jZA09.UFOExperienceState).SUCCEEDED_WAITING_FOR_DEPS.id]: [
        (0, $jZA09.UFOExperienceState).SUCCEEDED.id,
        (0, $jZA09.UFOExperienceState).FAILED.id,
        (0, $jZA09.UFOExperienceState).ABORTED.id
    ],
    [(0, $jZA09.UFOExperienceState).FAILED.id]: [
        (0, $jZA09.UFOExperienceState).STARTED.id
    ],
    [(0, $jZA09.UFOExperienceState).ABORTED.id]: [
        (0, $jZA09.UFOExperienceState).STARTED.id
    ]
};
const $6edf4365ea9733d4$export$178881f329fdb81f = (state1, state2)=>{
    return $6edf4365ea9733d4$var$UFOStateAvailableTransitions[state1.id] && $6edf4365ea9733d4$var$UFOStateAvailableTransitions[state1.id].includes(state2.id);
};

});



parcelRegister("139Gm", function(module, exports) {

$parcel$export(module.exports, "createErrorMetadata", () => $07d4c8a32da63d6e$export$7286a0fb7b5aab6b);
$parcel$export(module.exports, "isIgnoredError", () => $07d4c8a32da63d6e$export$a8da197a8bcc7e95);

var $1K4T6 = parcelRequire("1K4T6");
const $07d4c8a32da63d6e$export$7286a0fb7b5aab6b = (error)=>({
        error: {
            name: error.name,
            message: error.message,
            stack: error.stack,
            traceId: error instanceof (0, $1K4T6.HttpError) ? error.traceId : undefined,
            status: error instanceof (0, $1K4T6.HttpError) ? error.status : undefined
        }
    });
const $07d4c8a32da63d6e$var$ignoredErrors = [
    'SLOIgnoreError',
    'SLOIgnoreHttpError'
];
const $07d4c8a32da63d6e$export$a8da197a8bcc7e95 = (error)=>{
    const errorName = error?.constructor.name;
    if (!errorName) return false;
    return $07d4c8a32da63d6e$var$ignoredErrors.includes(errorName);
};

});



parcelRegister("gTh2z", function(module, exports) {

$parcel$export(module.exports, "aggClient", () => $68dbf55e48e6d3f1$export$464c991dbf0b2393);

var $7FbBq = parcelRequire("7FbBq");

var $aOgFy = parcelRequire("aOgFy");

var $cPPyF = parcelRequire("cPPyF");

var $6laLp = parcelRequire("6laLp");

var $7KcJC = parcelRequire("7KcJC");

var $iPviR = parcelRequire("iPviR");

var $dEcp8 = parcelRequire("dEcp8");
class $68dbf55e48e6d3f1$export$b44e5dafe13af7b3 extends (0, $cPPyF.BaseGraphQlClient) {
    constructor(baseUrl, config){
        super(`${baseUrl}/graphql`, config);
    }
    setBaseUrl(baseUrl) {
        this.setServiceUrl(`${baseUrl}/graphql`);
    }
    async queryTeamMemberships(teamId, membershipState = [
        'FULL_MEMBER'
    ], pageInfo = {
        first: 100
    }) {
        const response = await this.makeGraphQLRequest({
            query: (0, $7KcJC.default),
            variables: {
                teamId: teamId,
                membershipState: membershipState,
                siteId: this.getCloudId(),
                ...pageInfo
            }
        }, {
            operationName: 'TeamMembership'
        });
        return {
            edges: response.team.teamV2.members.edges.map(({ node: node })=>({
                    membershipId: {
                        teamId: teamId,
                        memberId: (0, $7FbBq.toUserId)(node.member.id)
                    },
                    state: node.state,
                    role: node.role,
                    user: {
                        id: (0, $7FbBq.toUserId)(node.member.id),
                        fullName: node.member.name,
                        avatarUrl: node.member.picture,
                        status: node.member.accountStatus,
                        title: node.member.extendedProfile?.jobTitle ?? undefined,
                        userType: (0, $dEcp8.toUserType)({
                            appType: node.member.appType
                        })
                    }
                })),
            pageInfo: response.team.teamV2.members.pageInfo
        };
    }
    async queryAGGUser(userId) {
        const response = await this.makeGraphQLRequest({
            query: (0, $iPviR.TeamsUserQuery),
            variables: {
                userId: userId
            }
        }, {
            operationName: 'TeamsUserQuery'
        });
        return response.user;
    }
}
const $68dbf55e48e6d3f1$export$464c991dbf0b2393 = new $68dbf55e48e6d3f1$export$b44e5dafe13af7b3((0, $aOgFy.DEFAULT_CONFIG).stargateRoot, {
    logException: $6laLp.logException
});

});
parcelRegister("7FbBq", function(module, exports) {

$parcel$export(module.exports, "toUserId", () => $17ec50633f4e2e7f$export$1d0eef1d33b05366);
$parcel$export(module.exports, "toTeamARI", () => $17ec50633f4e2e7f$export$2bcc6e4924859c6f);

const $17ec50633f4e2e7f$export$caac29844ad91f64 = (ari)=>ari.startsWith((0, $11a0bc56687bdc88$export$470b0d72e4fdc43a));
const $17ec50633f4e2e7f$export$1d0eef1d33b05366 = (ari)=>{
    if ($17ec50633f4e2e7f$export$caac29844ad91f64(ari)) return ari.replace((0, $11a0bc56687bdc88$export$470b0d72e4fdc43a), '');
    throw new Error('Invalid UserARI');
};
const $17ec50633f4e2e7f$export$fca6a88adb58674a = (userId)=>{
    return $17ec50633f4e2e7f$export$caac29844ad91f64(userId) ? userId : `${0, $11a0bc56687bdc88$export$470b0d72e4fdc43a}${userId}`;
};
const $17ec50633f4e2e7f$export$7b81d5dfd83c8166 = (ari)=>ari.startsWith((0, $11a0bc56687bdc88$export$cfedc369802e0c68));
const $17ec50633f4e2e7f$export$e78216c959b9f3af = (ari)=>{
    if ($17ec50633f4e2e7f$export$7b81d5dfd83c8166(ari)) return ari.replace((0, $11a0bc56687bdc88$export$cfedc369802e0c68), '');
    throw new Error('Invalid TeamARI');
};
const $17ec50633f4e2e7f$export$2bcc6e4924859c6f = (teamId)=>{
    return $17ec50633f4e2e7f$export$7b81d5dfd83c8166(teamId) ? teamId : `${0, $11a0bc56687bdc88$export$cfedc369802e0c68}${teamId}`;
};

});
const $11a0bc56687bdc88$export$470b0d72e4fdc43a = 'ari:cloud:identity::user/';
const $11a0bc56687bdc88$export$cfedc369802e0c68 = 'ari:cloud:identity::team/';


parcelRegister("aOgFy", function(module, exports) {

$parcel$export(module.exports, "DEFAULT_CONFIG", () => $63e5f3a0103519a1$export$c2f8e0cc249a8d8f);
const $63e5f3a0103519a1$export$c2f8e0cc249a8d8f = {
    stargateRoot: '/gateway/api',
    permsServiceUrl: '/gateway/api/permissions',
    publicApiRoot: '/gateway/api/public',
    invitationsServiceUrl: '/gateway/api/invitations',
    collaborationGraphUrl: '/gateway/api/collaboration'
};

});

parcelRegister("cPPyF", function(module, exports) {

$parcel$export(module.exports, "BaseGraphQlClient", () => $50423a8c851cd9c1$export$42f6d6baced34b2d);

var $1K4T6 = parcelRequire("1K4T6");

var $cIUqK = parcelRequire("cIUqK");

var $e5X66 = parcelRequire("e5X66");
class $50423a8c851cd9c1$export$42f6d6baced34b2d extends (0, $cIUqK.BaseClient) {
    constructor(serviceUrl, config){
        super(config);
        this.serviceUrl = serviceUrl;
    }
    setServiceUrl(serviceUrl) {
        this.serviceUrl = serviceUrl;
    }
    async makeGraphQLRequest(body, options = {}) {
        try {
            return (0, $e5X66.handleGraphQLRequest)(this.serviceUrl, body, options);
        } catch (error) {
            if (error instanceof (0, $1K4T6.GraphQLError)) throw error;
            this.logException(error, 'UnknownError in GraphQLClient.makeGraphQLRequestWithoutRetries');
            throw new (0, $1K4T6.DefaultError)({});
        }
    }
}

});
parcelRegister("cIUqK", function(module, exports) {

$parcel$export(module.exports, "BaseClient", () => $f6a5ca6563f596bf$export$4f22f74eddb7716a);

var $6laLp = parcelRequire("6laLp");
class $f6a5ca6563f596bf$export$4f22f74eddb7716a {
    constructor(config){
        this.cache = {};
        this.logException = (ex, name, context)=>{
            (0, $6laLp.logException)(ex, name, context);
            this.config.logException(ex, name, context);
        };
        this.config = config;
        this.context = {
            cloudId: 'None'
        };
    }
    setContext(context) {
        this.context = {
            ...context,
            cloudId: context.cloudId || 'None'
        };
    }
    getContext() {
        return this.context;
    }
    /**
	 *
	 * @param localValue is used for backwards compatibility
	 * @returns
	 */ getOrgId(localValue) {
        const orgId = localValue || this.getContext().orgId;
        if (!orgId) {
            const err = new Error('No orgId set');
            this.logException(err, 'No orgId set');
            throw err;
        }
        return orgId;
    }
    /**
	 *
	 * @param localValue is used for backwards compatibility
	 * @returns
	 */ getCloudId(localValue) {
        return localValue || this.getContext().cloudId;
    }
    keyWithContext(key) {
        return `${this.getContext().cloudId}-${this.getContext().orgId ?? 'no-org-id'}-${this.getContext().userId ?? 'no-user-id'}-${key}`;
    }
    // Default expiration is 5 minutes
    cacheValue(key, value, expiryMs = 300000) {
        this.cache[this.keyWithContext(key)] = {
            data: value,
            expiration: Date.now() + expiryMs
        };
    }
    getCachedValue(key) {
        const record = this.cache[this.keyWithContext(key)];
        if (record && record.expiration > Date.now()) return record.data;
        return undefined;
    }
}

});
parcelRegister("6laLp", function(module, exports) {

$parcel$export(module.exports, "logException", () => $b8ae333ac130caf8$export$f86b2a1a2ce291b3);
$parcel$export(module.exports, "logErrorMessage", () => $b8ae333ac130caf8$export$ece28f5cfa04608);
$parcel$export(module.exports, "logInfoMessage", () => $b8ae333ac130caf8$export$386587bcf05ee8ea);
$parcel$export(module.exports, "logExceptionWithPackageContext", () => $b8ae333ac130caf8$export$7208e9272a946c36);
$parcel$export(module.exports, "logErrorMessageWithPackageContext", () => $b8ae333ac130caf8$export$dbd2da61a76fb8d2);
$parcel$export(module.exports, "logInfoMessageWithPackageContext", () => $b8ae333ac130caf8$export$f242834c5699e597);
$parcel$export(module.exports, "createErrorHandlerWithPackageContext", () => $b8ae333ac130caf8$export$6b2a307bf7c6c1dc);
$parcel$export(module.exports, "addBreadcrumb", () => $b8ae333ac130caf8$export$efda9a273d7a036d);
// See Sentry accepted options in here https://docs.sentry.io/error-reporting/configuration/?platform=javascript

var $6jQUd = parcelRequire("6jQUd");
function $b8ae333ac130caf8$var$decorateScope(scope, context) {
    const { tags: tags, ...otherContext } = context;
    if (tags) scope.setTags(tags);
    if (Object.keys(otherContext).length) scope.setExtras(otherContext);
    return scope;
}
async function $b8ae333ac130caf8$export$f86b2a1a2ce291b3(ex, name, context = {}) {
    try {
        const sentryClient = await (0, $6jQUd.getSentryClient)();
        if (!sentryClient || typeof sentryClient.captureException !== 'function') return;
        sentryClient.withScope((scope)=>{
            $b8ae333ac130caf8$var$decorateScope(scope, context);
            scope.setTag('name', name);
            scope.setTag('packageName', context.packageName ?? 'unknown');
            scope.setTag('packageVersion', context.packageVersion ?? 'unknown');
            sentryClient.captureException(ex, scope);
        });
    } catch  {
    // silence sentry exceptions
    }
}
async function $b8ae333ac130caf8$var$logMessage(severity, message, context = {}) {
    const sentryClient = await (0, $6jQUd.getSentryClient)();
    if (!sentryClient || typeof sentryClient.captureException !== 'function') return;
    sentryClient.withScope((scope)=>{
        $b8ae333ac130caf8$var$decorateScope(scope, context);
        // The Severity enum is being replaced by SeverityLevel type in v7 anyway
        scope.setLevel(severity);
        scope.setTag('packageName', context.packageName ?? 'unknown');
        scope.setTag('packageVersion', context.packageVersion ?? 'unknown');
        sentryClient.captureMessage(message, scope);
    });
}
function $b8ae333ac130caf8$export$ece28f5cfa04608(message, context = {}) {
    $b8ae333ac130caf8$var$logMessage('error', message, context).catch(()=>{});
}
function $b8ae333ac130caf8$export$386587bcf05ee8ea(message, context = {}) {
    $b8ae333ac130caf8$var$logMessage('info', message, context).catch(()=>{});
}
const $b8ae333ac130caf8$export$9edc7d6f1c33ddc = (details)=>{
    return (error, message, tags = {})=>{
        $b8ae333ac130caf8$export$f86b2a1a2ce291b3(error, message, {
            tags: {
                ...details,
                ...tags
            }
        });
    };
};
const $b8ae333ac130caf8$export$7208e9272a946c36 = (packageContext)=>(...args)=>{
        // Intentionally not awaiting the promise here as we don't need the result
        $b8ae333ac130caf8$export$f86b2a1a2ce291b3(args[0], args[1], {
            ...args[2],
            packageName: packageContext.packageName,
            packageVersion: packageContext.packageVersion
        });
    };
const $b8ae333ac130caf8$export$dbd2da61a76fb8d2 = (packageContext)=>(...args)=>{
        // Intentionally not awaiting the promise here as we don't need the result
        $b8ae333ac130caf8$export$ece28f5cfa04608(args[0], {
            ...args[1],
            packageName: packageContext.packageName,
            packageVersion: packageContext.packageVersion
        });
    };
const $b8ae333ac130caf8$export$f242834c5699e597 = (packageContext)=>(...args)=>{
        // Intentionally not awaiting the promise here as we don't need the result
        $b8ae333ac130caf8$export$386587bcf05ee8ea(args[0], {
            ...args[1],
            packageName: packageContext.packageName,
            packageVersion: packageContext.packageVersion
        });
    };
const $b8ae333ac130caf8$export$6b2a307bf7c6c1dc = (packageContext)=>(...args)=>$b8ae333ac130caf8$export$9edc7d6f1c33ddc({
            ...args[0],
            packageName: packageContext.packageName,
            packageVersion: packageContext.packageVersion
        });
async function $b8ae333ac130caf8$export$efda9a273d7a036d(crumb) {
    const sentryClient = await (0, $6jQUd.getSentryClient)();
    sentryClient.withScope((scope)=>{
        scope.addBreadcrumb(typeof crumb === 'string' ? {
            message: crumb
        } : crumb);
    });
}

});
parcelRegister("6jQUd", function(module, exports) {

$parcel$export(module.exports, "sentryClient", () => $1a080a899118f506$export$ac71c212168fcd2b);
$parcel$export(module.exports, "setSentryClient", () => $1a080a899118f506$export$7d446c6f4e54de82);
$parcel$export(module.exports, "getSentryClient", () => $1a080a899118f506$export$f553e8b08ef59d31);
$parcel$export(module.exports, "setupSentryClient", () => $1a080a899118f506$export$d8bd0edf6c978788);

var $cESX7 = parcelRequire("cESX7");

var $f90f5 = parcelRequire("f90f5");
let $1a080a899118f506$export$ac71c212168fcd2b;
const $1a080a899118f506$export$7d446c6f4e54de82 = (client)=>{
    $1a080a899118f506$export$ac71c212168fcd2b = client;
};
const $1a080a899118f506$export$f553e8b08ef59d31 = async ()=>{
    if (!$1a080a899118f506$export$ac71c212168fcd2b) await $1a080a899118f506$export$d8bd0edf6c978788({});
    return $1a080a899118f506$export$ac71c212168fcd2b;
};
async function $1a080a899118f506$export$d8bd0edf6c978788({ appName: appName, env: env }) {
    const sentryClient = await $1a080a899118f506$var$requireSentryLib();
    if (!sentryClient) return;
    // initialiseSentry sets the sentry client
    (0, $f90f5.initialiseSentry)(sentryClient, {
        initialScope: {
            tags: {
                renderMode: appName || 'unknown',
                productBuild: // @ts-ignore Jira  - window.BUILD_KEY, confluence - window.__buildInfo
                window.BUILD_KEY || window.__buildInfo?.FRONTEND_VERSION || 'unknown',
                product: $1a080a899118f506$var$getProduct()
            }
        },
        env: env,
        noGlobals: true,
        dsn: (0, $cESX7.SENTRY_DSN),
        attachStacktrace: true
    });
}

async function $1a080a899118f506$var$requireSentryLib() {
    // saving ~40K
    try {
        return (parcelRequire("61QSy"));
    } catch (error) {
        // eslint-disable-next-line no-console
        console.warn('Ignoring rejected promise when loading sentry resource.', error);
    }
}
function $1a080a899118f506$var$getProduct() {
    const path = window.location.pathname;
    if (path.includes('/jira/people')) return 'jira';
    else if (path.includes('/wiki/people')) return 'confluence';
    return 'unknown';
}

});
parcelRegister("cESX7", function(module, exports) {

$parcel$export(module.exports, "SENTRY_DSN", () => $7172257c54583cfa$export$6faa4a850bc4d0ce);

var $c04PQ = parcelRequire("c04PQ");
const $7172257c54583cfa$export$9cf97fd92bea5d81 = '1dc056d49dfe4df8961dc1b810e4620d';
const $7172257c54583cfa$export$68c35ed3898e185a = '5988845';
const $7172257c54583cfa$export$b03be5cdb5af5197 = '067abcc494be9a87b3cdf9416f2b97d5';
const $7172257c54583cfa$export$97db6664a1e55fa6 = '47';
const $7172257c54583cfa$var$SENTRY_COMMERCIAL_DSN = `https://${$7172257c54583cfa$export$9cf97fd92bea5d81}@o55978.ingest.sentry.io/${$7172257c54583cfa$export$68c35ed3898e185a}`;
const $7172257c54583cfa$var$SENTRY_FEDRAMP_DSN = `https://${$7172257c54583cfa$export$b03be5cdb5af5197}@sentry.atlassian-us-gov-mod.com/${$7172257c54583cfa$export$97db6664a1e55fa6}`;
const $7172257c54583cfa$export$6faa4a850bc4d0ce = (0, $c04PQ.isFedRamp)() ? $7172257c54583cfa$var$SENTRY_FEDRAMP_DSN : $7172257c54583cfa$var$SENTRY_COMMERCIAL_DSN;

});

parcelRegister("f90f5", function(module, exports) {

$parcel$export(module.exports, "initialiseSentry", () => $bb873a2430dbd9e0$export$357606956af25316);

var $lqMqM = parcelRequire("lqMqM");

var $6jQUd = parcelRequire("6jQUd");
const $bb873a2430dbd9e0$var$DISABLED_INTEGRATIONS = [
    'onerror',
    'onunhandledrejection',
    // In Jira this integration is being initialised twice, resulting in no events being sent to Sentry
    'Dedupe'
];
async function $bb873a2430dbd9e0$export$357606956af25316(client, options) {
    if (0, $6jQUd.sentryClient) return;
    if (!client) return;
    (0, $6jQUd.setSentryClient)(client);
    const sentryConfig = (0, $lqMqM.getSentryConfig)(options);
    (0, $6jQUd.sentryClient).init({
        ...sentryConfig,
        integrations: function(integrations) {
            return integrations.filter(function(integration) {
                return $bb873a2430dbd9e0$var$DISABLED_INTEGRATIONS.indexOf(integration.name) === -1;
            });
        }
    });
}

});
parcelRegister("lqMqM", function(module, exports) {

$parcel$export(module.exports, "getSentryConfig", () => $0ea77fabdacad2ed$export$5580e6304e95c792);

var $cESX7 = parcelRequire("cESX7");
const $0ea77fabdacad2ed$var$DEFAULT_SENTRY_CONFIG = {
    whitelistUrls: [
        /atl-paas.net/,
        // test local host
        /localhost/
    ],
    ignoreErrors: [
        /^SentryIgnore:/,
        // Network related errors
        'The operation was aborted',
        'Software caused connection abort',
        'GraphQL error: Failed to fetch',
        'TypeError: Failed to fetch',
        'TypeError: NetworkError when attempting to fetch resource.',
        'AbortError: The user aborted a request.',
        /^network error/i,
        /^network failure/i,
        /^NetworkError/i,
        /^Unexpected token ..*/
    ],
    ignoreUrls: [
        // Chrome extensions
        /extensions\//i,
        /^chrome:\/\//i
    ],
    dsn: (0, $cESX7.SENTRY_DSN),
    attachStacktrace: true
};
function $0ea77fabdacad2ed$export$5580e6304e95c792(options) {
    const { env: env, version: version, noGlobals: _, ...otherOptions } = options;
    return {
        ...otherOptions,
        ...$0ea77fabdacad2ed$var$DEFAULT_SENTRY_CONFIG,
        // Standalone __VERSION__ is set from `bin/set-release-version.sh`
        // when building to deploy to production
        release: `${"platform-pkg"}@${"0.0.0-use.local"}` || // @ts-ignore Jira  - window.BUILD_KEY
        window.BUILD_KEY || // @ts-ignore Confluence - window.__buildInfo
        window.__buildInfo?.FRONTEND_VERSION || '---',
        environment: env || 'prod'
    };
}

});


parcelRegister("61QSy", function(module, exports) {

let $463bdab5e8d2e224$var$load = (parcelRequire("28QjX"))(4);
module.exports = $463bdab5e8d2e224$var$load("cc1Au").then(()=>parcelRequire('godCI'));

});




parcelRegister("e5X66", function(module, exports) {

$parcel$export(module.exports, "handleGraphQLRequest", () => $dacc5a55576333f2$export$7feffc86760ee7ce);

var $1K4T6 = parcelRequire("1K4T6");

var $4F5SC = parcelRequire("4F5SC");

var $hdjej = parcelRequire("hdjej");
async function $dacc5a55576333f2$export$93d33e3b46bf00e7(serviceUrl, body, options = {}) {
    const operationNameQuery = options.operationName ? `?q=${options.operationName}` : '';
    const errorPolicy = options.errorPolicy || 'none';
    const url = serviceUrl + operationNameQuery;
    const request = fetch(url, {
        method: 'POST',
        headers: new Headers({
            'Content-Type': 'application/json'
        }),
        credentials: 'include',
        body: JSON.stringify(body)
    }).then((res)=>{
        if (res.status < 300 || res.status === 400) return res.json();
        else throw res;
    });
    try {
        const response = await request;
        const errors = response.errors;
        if (errors) {
            if (errorPolicy === 'none') throw (0, $1K4T6.GraphQLError).from(errors);
            else if (errorPolicy === 'all') // Set timeout will postpone error throwing and de-touch it to another event loop,
            // so we can return data along with throwing error
            return new Promise((resolve, reject)=>{
                setTimeout(()=>{
                    reject((0, $1K4T6.GraphQLError).from(errors));
                }, 0);
            });
        }
        return response.data;
    } catch (error) {
        if (error instanceof Response) return {
            response: error
        };
        if (Object(error).hasOwnProperty('response')) throw error;
        return error;
    }
}
async function $dacc5a55576333f2$export$7feffc86760ee7ce(serviceUrl, body, options = {}) {
    const makeGraphQLRequestWithRetries = (0, $4F5SC.withExponentialBackoff)($dacc5a55576333f2$export$93d33e3b46bf00e7, {
        initial: (0, $4F5SC.EXPONENTIAL_BACKOFF_RETRY_POLICY).INITIAL_DELAY,
        jitter: (0, $4F5SC.EXPONENTIAL_BACKOFF_RETRY_POLICY).JITTER,
        max: (0, $4F5SC.EXPONENTIAL_BACKOFF_RETRY_POLICY).MAX_RETRIES,
        retryIf: (data)=>{
            return (0, $4F5SC.isFetchResponse)(data) && (0, $4F5SC.is5xx)(data.response.status);
        }
    });
    const result = await makeGraphQLRequestWithRetries(serviceUrl, body, options);
    const response = result?.response;
    if (response) {
        const status = response.status;
        const statusText = response.statusText;
        const traceId = response.headers.get('atl-traceid');
        (0, $hdjej.handleResponse)(response);
        if (status > 400 && status <= 599) throw new (0, $1K4T6.HttpError)({
            message: statusText,
            status: status,
            traceId: traceId ?? undefined
        });
    }
    return result;
}

});
parcelRegister("4F5SC", function(module, exports) {

$parcel$export(module.exports, "EXPONENTIAL_BACKOFF_RETRY_POLICY", () => $0bcb1394a3249358$export$8f4286bf21155381);
$parcel$export(module.exports, "is5xx", () => $0bcb1394a3249358$export$55b2fbd5d4a32495);
$parcel$export(module.exports, "isFetchResponse", () => $0bcb1394a3249358$export$81f27058be86d7ea);
$parcel$export(module.exports, "withExponentialBackoff", () => $0bcb1394a3249358$export$20eaa22f2295996f);
$parcel$export(module.exports, "fetchWithExponentialBackoff", () => $0bcb1394a3249358$export$b4c0bf5325504bf3);
const $0bcb1394a3249358$export$8f4286bf21155381 = {
    INITIAL_DELAY: 200,
    MAX_RETRIES: 5,
    JITTER: true
};
function $0bcb1394a3249358$export$55b2fbd5d4a32495(status) {
    return 500 <= status && status <= 599;
}
function $0bcb1394a3249358$export$81f27058be86d7ea(data) {
    if (!data || !data.hasOwnProperty('response')) return false;
    return data.response instanceof Response;
}
// tslint:disable-next-line no-any
const $0bcb1394a3249358$var$defaultRetryIfCallback = (a)=>!a;
const $0bcb1394a3249358$var$defaultOptions = {
    initial: 200,
    jitter: false,
    max: 5,
    retryIf: $0bcb1394a3249358$var$defaultRetryIfCallback
};
function $0bcb1394a3249358$export$20eaa22f2295996f(toTry, hofOptions = $0bcb1394a3249358$var$defaultOptions) {
    const { initial: initial, jitter: jitter, max: max, retryIf: retryIf } = hofOptions;
    // Initialize max retry decrementing counter (range of max...0)
    let attemptsRemaining = max;
    // Initialize delay. This will exponentially increase each retry (delay = intial * 2^n)
    let delay = initial;
    /**
	 * This function calls itself recursively until `retryIf` evaluates false or the retry limit is reached.
	 * The functioned-to-be-retried is called on each recursion.
	 */ return async function tryWithExponentialBackoff(...args) {
        // "An attempt was made"
        const result = await toTry(...args);
        --attemptsRemaining;
        // If tried function was unsuccessful and there are still retries remaining, retry!
        if (retryIf && retryIf(result) && attemptsRemaining > 0) {
            // Wait for delay
            await new Promise((resolve)=>setTimeout(resolve, jitter ? Math.random() * delay : delay));
            // Exponentially increase delay
            delay *= 2;
            // Initiate retry
            return tryWithExponentialBackoff(...args);
        }
        // Return result of tried function if it is successful or if the retry limit
        // was reached regardless of success.
        return result;
    };
}
const $0bcb1394a3249358$export$b4c0bf5325504bf3 = $0bcb1394a3249358$export$20eaa22f2295996f((url, init)=>fetch(url, init), {
    initial: $0bcb1394a3249358$export$8f4286bf21155381.INITIAL_DELAY,
    jitter: $0bcb1394a3249358$export$8f4286bf21155381.JITTER,
    max: $0bcb1394a3249358$export$8f4286bf21155381.MAX_RETRIES,
    retryIf: (response)=>$0bcb1394a3249358$export$55b2fbd5d4a32495(response.status)
});

});

parcelRegister("hdjej", function(module, exports) {

$parcel$export(module.exports, "handleResponse", () => $9c1b9c6605e9f581$export$c113a67a6762ad2e);
/**
 * Our REST clients are initialised when their module loads which makes it tricky for them to consume the `statusCodeHandlers` prop passed to App from the host application.
 * This is a temporary measure to enable the clients to consume `statusCodeHandlers`.
 * The long term solution is to replace our REST clients with Apollo client custom resolvers
 * This will unify all remote data handling under the apollo-client module which is able to easily receive `statusCodeHandlers` as it is initialised within the React portion of our app.
 */ const $9c1b9c6605e9f581$export$8c005e458e12d501 = {
    handlers: {},
    get () {
        return $9c1b9c6605e9f581$export$8c005e458e12d501.handlers;
    },
    setHandlers (handlers) {
        $9c1b9c6605e9f581$export$8c005e458e12d501.handlers = handlers;
    }
};
function $9c1b9c6605e9f581$export$c113a67a6762ad2e(response) {
    const { status: status } = response;
    const handler = $9c1b9c6605e9f581$export$8c005e458e12d501.get()[status];
    if (typeof handler === 'function') handler(response);
}

});



parcelRegister("7KcJC", function(module, exports) {

$parcel$export(module.exports, "default", () => $db20d2370669efd9$export$2e2bcd8739ae039);
const $db20d2370669efd9$var$TeamMembershipQuery = `query app_user_characteristics($teamId: ID!, $siteId: String!, $membershipState: [TeamMembershipState!]!, $first: Int!, $after: String) {
    team {
      teamV2(
        id: $teamId
        siteId: $siteId
      ) @optIn(to: "Team-v2") {
        members(state: $membershipState, first: $first, after: $after) {
          edges {
            node {
              member {
                id
                name
                picture
                accountStatus
                ... on AtlassianAccountUser {
                  extendedProfile {
                    jobTitle
                  }
                }
                ... on AppUser {
                  appType
                }
              }
              role
              state
            }
          }
          pageInfo {
            endCursor
            hasNextPage
          }
        }
      }
    }
  }`;
var $db20d2370669efd9$export$2e2bcd8739ae039 = $db20d2370669efd9$var$TeamMembershipQuery;

});

parcelRegister("iPviR", function(module, exports) {

$parcel$export(module.exports, "TeamsUserQuery", () => $35ae14e4e07b2810$export$9963ed3cbf7b791c);

var $1c8Um = parcelRequire("1c8Um");

var $5cllN = parcelRequire("5cllN");
const $35ae14e4e07b2810$export$9963ed3cbf7b791c = (0, $1c8Um.print)((0, $5cllN.default)`
	query TeamsUserQuery($userId: ID!) {
		user(accountId: $userId) {
			id
			name
			picture
			accountStatus
			__typename
			... on AtlassianAccountUser {
				email
				nickname
				locale
				zoneinfo
				extendedProfile {
					jobTitle
					organization
					department
					location
					phoneNumbers {
						type
						value
					}
					closedDate
					inactiveDate
				}
			}
			... on CustomerUser {
				email
				locale
				zoneinfo
			}
			... on AppUser {
				appType
			}
		}
	}
`);

});
parcelRegister("1c8Um", function(module, exports) {

$parcel$export(module.exports, "print", () => $0dedd2672864572f$export$c2d084dc44961371);

var $12QNw = parcelRequire("12QNw");

var $541Mz = parcelRequire("541Mz");
function $0dedd2672864572f$export$c2d084dc44961371(ast) {
    return (0, $12QNw.visit)(ast, {
        leave: $0dedd2672864572f$var$printDocASTReducer
    });
}
var $0dedd2672864572f$var$MAX_LINE_LENGTH = 80; // TODO: provide better type coverage in future
var $0dedd2672864572f$var$printDocASTReducer = {
    Name: function Name(node) {
        return node.value;
    },
    Variable: function Variable(node) {
        return '$' + node.name;
    },
    // Document
    Document: function Document(node) {
        return $0dedd2672864572f$var$join(node.definitions, '\n\n') + '\n';
    },
    OperationDefinition: function OperationDefinition(node) {
        var op = node.operation;
        var name = node.name;
        var varDefs = $0dedd2672864572f$var$wrap('(', $0dedd2672864572f$var$join(node.variableDefinitions, ', '), ')');
        var directives = $0dedd2672864572f$var$join(node.directives, ' ');
        var selectionSet = node.selectionSet; // Anonymous queries with no directives or variable definitions can use
        // the query short form.
        return !name && !directives && !varDefs && op === 'query' ? selectionSet : $0dedd2672864572f$var$join([
            op,
            $0dedd2672864572f$var$join([
                name,
                varDefs
            ]),
            directives,
            selectionSet
        ], ' ');
    },
    VariableDefinition: function VariableDefinition(_ref) {
        var variable = _ref.variable, type = _ref.type, defaultValue = _ref.defaultValue, directives = _ref.directives;
        return variable + ': ' + type + $0dedd2672864572f$var$wrap(' = ', defaultValue) + $0dedd2672864572f$var$wrap(' ', $0dedd2672864572f$var$join(directives, ' '));
    },
    SelectionSet: function SelectionSet(_ref2) {
        var selections = _ref2.selections;
        return $0dedd2672864572f$var$block(selections);
    },
    Field: function Field(_ref3) {
        var alias = _ref3.alias, name = _ref3.name, args = _ref3.arguments, directives = _ref3.directives, selectionSet = _ref3.selectionSet;
        var prefix = $0dedd2672864572f$var$wrap('', alias, ': ') + name;
        var argsLine = prefix + $0dedd2672864572f$var$wrap('(', $0dedd2672864572f$var$join(args, ', '), ')');
        if (argsLine.length > $0dedd2672864572f$var$MAX_LINE_LENGTH) argsLine = prefix + $0dedd2672864572f$var$wrap('(\n', $0dedd2672864572f$var$indent($0dedd2672864572f$var$join(args, '\n')), '\n)');
        return $0dedd2672864572f$var$join([
            argsLine,
            $0dedd2672864572f$var$join(directives, ' '),
            selectionSet
        ], ' ');
    },
    Argument: function Argument(_ref4) {
        var name = _ref4.name, value = _ref4.value;
        return name + ': ' + value;
    },
    // Fragments
    FragmentSpread: function FragmentSpread(_ref5) {
        var name = _ref5.name, directives = _ref5.directives;
        return '...' + name + $0dedd2672864572f$var$wrap(' ', $0dedd2672864572f$var$join(directives, ' '));
    },
    InlineFragment: function InlineFragment(_ref6) {
        var typeCondition = _ref6.typeCondition, directives = _ref6.directives, selectionSet = _ref6.selectionSet;
        return $0dedd2672864572f$var$join([
            '...',
            $0dedd2672864572f$var$wrap('on ', typeCondition),
            $0dedd2672864572f$var$join(directives, ' '),
            selectionSet
        ], ' ');
    },
    FragmentDefinition: function FragmentDefinition(_ref7) {
        var name = _ref7.name, typeCondition = _ref7.typeCondition, variableDefinitions = _ref7.variableDefinitions, directives = _ref7.directives, selectionSet = _ref7.selectionSet;
        return(// or removed in the future.
        "fragment ".concat(name).concat($0dedd2672864572f$var$wrap('(', $0dedd2672864572f$var$join(variableDefinitions, ', '), ')'), " ") + "on ".concat(typeCondition, " ").concat($0dedd2672864572f$var$wrap('', $0dedd2672864572f$var$join(directives, ' '), ' ')) + selectionSet);
    },
    // Value
    IntValue: function IntValue(_ref8) {
        var value = _ref8.value;
        return value;
    },
    FloatValue: function FloatValue(_ref9) {
        var value = _ref9.value;
        return value;
    },
    StringValue: function StringValue(_ref10, key) {
        var value = _ref10.value, isBlockString = _ref10.block;
        return isBlockString ? (0, $541Mz.printBlockString)(value, key === 'description' ? '' : '  ') : JSON.stringify(value);
    },
    BooleanValue: function BooleanValue(_ref11) {
        var value = _ref11.value;
        return value ? 'true' : 'false';
    },
    NullValue: function NullValue() {
        return 'null';
    },
    EnumValue: function EnumValue(_ref12) {
        var value = _ref12.value;
        return value;
    },
    ListValue: function ListValue(_ref13) {
        var values = _ref13.values;
        return '[' + $0dedd2672864572f$var$join(values, ', ') + ']';
    },
    ObjectValue: function ObjectValue(_ref14) {
        var fields = _ref14.fields;
        return '{' + $0dedd2672864572f$var$join(fields, ', ') + '}';
    },
    ObjectField: function ObjectField(_ref15) {
        var name = _ref15.name, value = _ref15.value;
        return name + ': ' + value;
    },
    // Directive
    Directive: function Directive(_ref16) {
        var name = _ref16.name, args = _ref16.arguments;
        return '@' + name + $0dedd2672864572f$var$wrap('(', $0dedd2672864572f$var$join(args, ', '), ')');
    },
    // Type
    NamedType: function NamedType(_ref17) {
        var name = _ref17.name;
        return name;
    },
    ListType: function ListType(_ref18) {
        var type = _ref18.type;
        return '[' + type + ']';
    },
    NonNullType: function NonNullType(_ref19) {
        var type = _ref19.type;
        return type + '!';
    },
    // Type System Definitions
    SchemaDefinition: $0dedd2672864572f$var$addDescription(function(_ref20) {
        var directives = _ref20.directives, operationTypes = _ref20.operationTypes;
        return $0dedd2672864572f$var$join([
            'schema',
            $0dedd2672864572f$var$join(directives, ' '),
            $0dedd2672864572f$var$block(operationTypes)
        ], ' ');
    }),
    OperationTypeDefinition: function OperationTypeDefinition(_ref21) {
        var operation = _ref21.operation, type = _ref21.type;
        return operation + ': ' + type;
    },
    ScalarTypeDefinition: $0dedd2672864572f$var$addDescription(function(_ref22) {
        var name = _ref22.name, directives = _ref22.directives;
        return $0dedd2672864572f$var$join([
            'scalar',
            name,
            $0dedd2672864572f$var$join(directives, ' ')
        ], ' ');
    }),
    ObjectTypeDefinition: $0dedd2672864572f$var$addDescription(function(_ref23) {
        var name = _ref23.name, interfaces = _ref23.interfaces, directives = _ref23.directives, fields = _ref23.fields;
        return $0dedd2672864572f$var$join([
            'type',
            name,
            $0dedd2672864572f$var$wrap('implements ', $0dedd2672864572f$var$join(interfaces, ' & ')),
            $0dedd2672864572f$var$join(directives, ' '),
            $0dedd2672864572f$var$block(fields)
        ], ' ');
    }),
    FieldDefinition: $0dedd2672864572f$var$addDescription(function(_ref24) {
        var name = _ref24.name, args = _ref24.arguments, type = _ref24.type, directives = _ref24.directives;
        return name + ($0dedd2672864572f$var$hasMultilineItems(args) ? $0dedd2672864572f$var$wrap('(\n', $0dedd2672864572f$var$indent($0dedd2672864572f$var$join(args, '\n')), '\n)') : $0dedd2672864572f$var$wrap('(', $0dedd2672864572f$var$join(args, ', '), ')')) + ': ' + type + $0dedd2672864572f$var$wrap(' ', $0dedd2672864572f$var$join(directives, ' '));
    }),
    InputValueDefinition: $0dedd2672864572f$var$addDescription(function(_ref25) {
        var name = _ref25.name, type = _ref25.type, defaultValue = _ref25.defaultValue, directives = _ref25.directives;
        return $0dedd2672864572f$var$join([
            name + ': ' + type,
            $0dedd2672864572f$var$wrap('= ', defaultValue),
            $0dedd2672864572f$var$join(directives, ' ')
        ], ' ');
    }),
    InterfaceTypeDefinition: $0dedd2672864572f$var$addDescription(function(_ref26) {
        var name = _ref26.name, interfaces = _ref26.interfaces, directives = _ref26.directives, fields = _ref26.fields;
        return $0dedd2672864572f$var$join([
            'interface',
            name,
            $0dedd2672864572f$var$wrap('implements ', $0dedd2672864572f$var$join(interfaces, ' & ')),
            $0dedd2672864572f$var$join(directives, ' '),
            $0dedd2672864572f$var$block(fields)
        ], ' ');
    }),
    UnionTypeDefinition: $0dedd2672864572f$var$addDescription(function(_ref27) {
        var name = _ref27.name, directives = _ref27.directives, types = _ref27.types;
        return $0dedd2672864572f$var$join([
            'union',
            name,
            $0dedd2672864572f$var$join(directives, ' '),
            types && types.length !== 0 ? '= ' + $0dedd2672864572f$var$join(types, ' | ') : ''
        ], ' ');
    }),
    EnumTypeDefinition: $0dedd2672864572f$var$addDescription(function(_ref28) {
        var name = _ref28.name, directives = _ref28.directives, values = _ref28.values;
        return $0dedd2672864572f$var$join([
            'enum',
            name,
            $0dedd2672864572f$var$join(directives, ' '),
            $0dedd2672864572f$var$block(values)
        ], ' ');
    }),
    EnumValueDefinition: $0dedd2672864572f$var$addDescription(function(_ref29) {
        var name = _ref29.name, directives = _ref29.directives;
        return $0dedd2672864572f$var$join([
            name,
            $0dedd2672864572f$var$join(directives, ' ')
        ], ' ');
    }),
    InputObjectTypeDefinition: $0dedd2672864572f$var$addDescription(function(_ref30) {
        var name = _ref30.name, directives = _ref30.directives, fields = _ref30.fields;
        return $0dedd2672864572f$var$join([
            'input',
            name,
            $0dedd2672864572f$var$join(directives, ' '),
            $0dedd2672864572f$var$block(fields)
        ], ' ');
    }),
    DirectiveDefinition: $0dedd2672864572f$var$addDescription(function(_ref31) {
        var name = _ref31.name, args = _ref31.arguments, repeatable = _ref31.repeatable, locations = _ref31.locations;
        return 'directive @' + name + ($0dedd2672864572f$var$hasMultilineItems(args) ? $0dedd2672864572f$var$wrap('(\n', $0dedd2672864572f$var$indent($0dedd2672864572f$var$join(args, '\n')), '\n)') : $0dedd2672864572f$var$wrap('(', $0dedd2672864572f$var$join(args, ', '), ')')) + (repeatable ? ' repeatable' : '') + ' on ' + $0dedd2672864572f$var$join(locations, ' | ');
    }),
    SchemaExtension: function SchemaExtension(_ref32) {
        var directives = _ref32.directives, operationTypes = _ref32.operationTypes;
        return $0dedd2672864572f$var$join([
            'extend schema',
            $0dedd2672864572f$var$join(directives, ' '),
            $0dedd2672864572f$var$block(operationTypes)
        ], ' ');
    },
    ScalarTypeExtension: function ScalarTypeExtension(_ref33) {
        var name = _ref33.name, directives = _ref33.directives;
        return $0dedd2672864572f$var$join([
            'extend scalar',
            name,
            $0dedd2672864572f$var$join(directives, ' ')
        ], ' ');
    },
    ObjectTypeExtension: function ObjectTypeExtension(_ref34) {
        var name = _ref34.name, interfaces = _ref34.interfaces, directives = _ref34.directives, fields = _ref34.fields;
        return $0dedd2672864572f$var$join([
            'extend type',
            name,
            $0dedd2672864572f$var$wrap('implements ', $0dedd2672864572f$var$join(interfaces, ' & ')),
            $0dedd2672864572f$var$join(directives, ' '),
            $0dedd2672864572f$var$block(fields)
        ], ' ');
    },
    InterfaceTypeExtension: function InterfaceTypeExtension(_ref35) {
        var name = _ref35.name, interfaces = _ref35.interfaces, directives = _ref35.directives, fields = _ref35.fields;
        return $0dedd2672864572f$var$join([
            'extend interface',
            name,
            $0dedd2672864572f$var$wrap('implements ', $0dedd2672864572f$var$join(interfaces, ' & ')),
            $0dedd2672864572f$var$join(directives, ' '),
            $0dedd2672864572f$var$block(fields)
        ], ' ');
    },
    UnionTypeExtension: function UnionTypeExtension(_ref36) {
        var name = _ref36.name, directives = _ref36.directives, types = _ref36.types;
        return $0dedd2672864572f$var$join([
            'extend union',
            name,
            $0dedd2672864572f$var$join(directives, ' '),
            types && types.length !== 0 ? '= ' + $0dedd2672864572f$var$join(types, ' | ') : ''
        ], ' ');
    },
    EnumTypeExtension: function EnumTypeExtension(_ref37) {
        var name = _ref37.name, directives = _ref37.directives, values = _ref37.values;
        return $0dedd2672864572f$var$join([
            'extend enum',
            name,
            $0dedd2672864572f$var$join(directives, ' '),
            $0dedd2672864572f$var$block(values)
        ], ' ');
    },
    InputObjectTypeExtension: function InputObjectTypeExtension(_ref38) {
        var name = _ref38.name, directives = _ref38.directives, fields = _ref38.fields;
        return $0dedd2672864572f$var$join([
            'extend input',
            name,
            $0dedd2672864572f$var$join(directives, ' '),
            $0dedd2672864572f$var$block(fields)
        ], ' ');
    }
};
function $0dedd2672864572f$var$addDescription(cb) {
    return function(node) {
        return $0dedd2672864572f$var$join([
            node.description,
            cb(node)
        ], '\n');
    };
}
/**
 * Given maybeArray, print an empty string if it is null or empty, otherwise
 * print all items together separated by separator if provided
 */ function $0dedd2672864572f$var$join(maybeArray) {
    var _maybeArray$filter$jo;
    var separator = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';
    return (_maybeArray$filter$jo = maybeArray === null || maybeArray === void 0 ? void 0 : maybeArray.filter(function(x) {
        return x;
    }).join(separator)) !== null && _maybeArray$filter$jo !== void 0 ? _maybeArray$filter$jo : '';
}
/**
 * Given array, print each item on its own line, wrapped in an
 * indented "{ }" block.
 */ function $0dedd2672864572f$var$block(array) {
    return $0dedd2672864572f$var$wrap('{\n', $0dedd2672864572f$var$indent($0dedd2672864572f$var$join(array, '\n')), '\n}');
}
/**
 * If maybeString is not null or empty, then wrap with start and end, otherwise print an empty string.
 */ function $0dedd2672864572f$var$wrap(start, maybeString) {
    var end = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : '';
    return maybeString != null && maybeString !== '' ? start + maybeString + end : '';
}
function $0dedd2672864572f$var$indent(str) {
    return $0dedd2672864572f$var$wrap('  ', str.replace(/\n/g, '\n  '));
}
function $0dedd2672864572f$var$isMultiline(str) {
    return str.indexOf('\n') !== -1;
}
function $0dedd2672864572f$var$hasMultilineItems(maybeArray) {
    return maybeArray != null && maybeArray.some($0dedd2672864572f$var$isMultiline);
}

});
parcelRegister("12QNw", function(module, exports) {

$parcel$export(module.exports, "BREAK", () => $0c2eeee3dc68c900$export$a89c95c098ac2a58);
$parcel$export(module.exports, "visit", () => $0c2eeee3dc68c900$export$bf638b60ea8b89b7);

var $yEDl8 = parcelRequire("yEDl8");

var $98oUl = parcelRequire("98oUl");
var $0c2eeee3dc68c900$export$4fcd777a40ccf407 = {
    Name: [],
    Document: [
        'definitions'
    ],
    OperationDefinition: [
        'name',
        'variableDefinitions',
        'directives',
        'selectionSet'
    ],
    VariableDefinition: [
        'variable',
        'type',
        'defaultValue',
        'directives'
    ],
    Variable: [
        'name'
    ],
    SelectionSet: [
        'selections'
    ],
    Field: [
        'alias',
        'name',
        'arguments',
        'directives',
        'selectionSet'
    ],
    Argument: [
        'name',
        'value'
    ],
    FragmentSpread: [
        'name',
        'directives'
    ],
    InlineFragment: [
        'typeCondition',
        'directives',
        'selectionSet'
    ],
    FragmentDefinition: [
        'name',
        // or removed in the future.
        'variableDefinitions',
        'typeCondition',
        'directives',
        'selectionSet'
    ],
    IntValue: [],
    FloatValue: [],
    StringValue: [],
    BooleanValue: [],
    NullValue: [],
    EnumValue: [],
    ListValue: [
        'values'
    ],
    ObjectValue: [
        'fields'
    ],
    ObjectField: [
        'name',
        'value'
    ],
    Directive: [
        'name',
        'arguments'
    ],
    NamedType: [
        'name'
    ],
    ListType: [
        'type'
    ],
    NonNullType: [
        'type'
    ],
    SchemaDefinition: [
        'description',
        'directives',
        'operationTypes'
    ],
    OperationTypeDefinition: [
        'type'
    ],
    ScalarTypeDefinition: [
        'description',
        'name',
        'directives'
    ],
    ObjectTypeDefinition: [
        'description',
        'name',
        'interfaces',
        'directives',
        'fields'
    ],
    FieldDefinition: [
        'description',
        'name',
        'arguments',
        'type',
        'directives'
    ],
    InputValueDefinition: [
        'description',
        'name',
        'type',
        'defaultValue',
        'directives'
    ],
    InterfaceTypeDefinition: [
        'description',
        'name',
        'interfaces',
        'directives',
        'fields'
    ],
    UnionTypeDefinition: [
        'description',
        'name',
        'directives',
        'types'
    ],
    EnumTypeDefinition: [
        'description',
        'name',
        'directives',
        'values'
    ],
    EnumValueDefinition: [
        'description',
        'name',
        'directives'
    ],
    InputObjectTypeDefinition: [
        'description',
        'name',
        'directives',
        'fields'
    ],
    DirectiveDefinition: [
        'description',
        'name',
        'arguments',
        'locations'
    ],
    SchemaExtension: [
        'directives',
        'operationTypes'
    ],
    ScalarTypeExtension: [
        'name',
        'directives'
    ],
    ObjectTypeExtension: [
        'name',
        'interfaces',
        'directives',
        'fields'
    ],
    InterfaceTypeExtension: [
        'name',
        'interfaces',
        'directives',
        'fields'
    ],
    UnionTypeExtension: [
        'name',
        'directives',
        'types'
    ],
    EnumTypeExtension: [
        'name',
        'directives',
        'values'
    ],
    InputObjectTypeExtension: [
        'name',
        'directives',
        'fields'
    ]
};
var $0c2eeee3dc68c900$export$a89c95c098ac2a58 = Object.freeze({});
function $0c2eeee3dc68c900$export$bf638b60ea8b89b7(root, visitor) {
    var visitorKeys = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : $0c2eeee3dc68c900$export$4fcd777a40ccf407;
    /* eslint-disable no-undef-init */ var stack = undefined;
    var inArray = Array.isArray(root);
    var keys = [
        root
    ];
    var index = -1;
    var edits = [];
    var node = undefined;
    var key = undefined;
    var parent = undefined;
    var path = [];
    var ancestors = [];
    var newRoot = root;
    /* eslint-enable no-undef-init */ do {
        index++;
        var isLeaving = index === keys.length;
        var isEdited = isLeaving && edits.length !== 0;
        if (isLeaving) {
            key = ancestors.length === 0 ? undefined : path[path.length - 1];
            node = parent;
            parent = ancestors.pop();
            if (isEdited) {
                if (inArray) node = node.slice();
                else {
                    var clone = {};
                    for(var _i2 = 0, _Object$keys2 = Object.keys(node); _i2 < _Object$keys2.length; _i2++){
                        var k = _Object$keys2[_i2];
                        clone[k] = node[k];
                    }
                    node = clone;
                }
                var editOffset = 0;
                for(var ii = 0; ii < edits.length; ii++){
                    var editKey = edits[ii][0];
                    var editValue = edits[ii][1];
                    if (inArray) editKey -= editOffset;
                    if (inArray && editValue === null) {
                        node.splice(editKey, 1);
                        editOffset++;
                    } else node[editKey] = editValue;
                }
            }
            index = stack.index;
            keys = stack.keys;
            edits = stack.edits;
            inArray = stack.inArray;
            stack = stack.prev;
        } else {
            key = parent ? inArray ? index : keys[index] : undefined;
            node = parent ? parent[key] : newRoot;
            if (node === null || node === undefined) continue;
            if (parent) path.push(key);
        }
        var result = void 0;
        if (!Array.isArray(node)) {
            if (!(0, $98oUl.isNode)(node)) throw new Error("Invalid AST Node: ".concat((0, $yEDl8.default)(node), "."));
            var visitFn = $0c2eeee3dc68c900$export$c9c25cca74db6e70(visitor, node.kind, isLeaving);
            if (visitFn) {
                result = visitFn.call(visitor, node, key, parent, path, ancestors);
                if (result === $0c2eeee3dc68c900$export$a89c95c098ac2a58) break;
                if (result === false) {
                    if (!isLeaving) {
                        path.pop();
                        continue;
                    }
                } else if (result !== undefined) {
                    edits.push([
                        key,
                        result
                    ]);
                    if (!isLeaving) {
                        if ((0, $98oUl.isNode)(result)) node = result;
                        else {
                            path.pop();
                            continue;
                        }
                    }
                }
            }
        }
        if (result === undefined && isEdited) edits.push([
            key,
            node
        ]);
        if (isLeaving) path.pop();
        else {
            var _visitorKeys$node$kin;
            stack = {
                inArray: inArray,
                index: index,
                keys: keys,
                edits: edits,
                prev: stack
            };
            inArray = Array.isArray(node);
            keys = inArray ? node : (_visitorKeys$node$kin = visitorKeys[node.kind]) !== null && _visitorKeys$node$kin !== void 0 ? _visitorKeys$node$kin : [];
            index = -1;
            edits = [];
            if (parent) ancestors.push(parent);
            parent = node;
        }
    }while (stack !== undefined);
    if (edits.length !== 0) newRoot = edits[edits.length - 1][1];
    return newRoot;
}
function $0c2eeee3dc68c900$export$728beebeea393478(visitors) {
    var skipping = new Array(visitors.length);
    return {
        enter: function enter(node) {
            for(var i = 0; i < visitors.length; i++)if (skipping[i] == null) {
                var fn = $0c2eeee3dc68c900$export$c9c25cca74db6e70(visitors[i], node.kind, /* isLeaving */ false);
                if (fn) {
                    var result = fn.apply(visitors[i], arguments);
                    if (result === false) skipping[i] = node;
                    else if (result === $0c2eeee3dc68c900$export$a89c95c098ac2a58) skipping[i] = $0c2eeee3dc68c900$export$a89c95c098ac2a58;
                    else if (result !== undefined) return result;
                }
            }
        },
        leave: function leave(node) {
            for(var i = 0; i < visitors.length; i++){
                if (skipping[i] == null) {
                    var fn = $0c2eeee3dc68c900$export$c9c25cca74db6e70(visitors[i], node.kind, /* isLeaving */ true);
                    if (fn) {
                        var result = fn.apply(visitors[i], arguments);
                        if (result === $0c2eeee3dc68c900$export$a89c95c098ac2a58) skipping[i] = $0c2eeee3dc68c900$export$a89c95c098ac2a58;
                        else if (result !== undefined && result !== false) return result;
                    }
                } else if (skipping[i] === node) skipping[i] = null;
            }
        }
    };
}
function $0c2eeee3dc68c900$export$c9c25cca74db6e70(visitor, kind, isLeaving) {
    var kindVisitor = visitor[kind];
    if (kindVisitor) {
        if (!isLeaving && typeof kindVisitor === 'function') // { Kind() {} }
        return kindVisitor;
        var kindSpecificVisitor = isLeaving ? kindVisitor.leave : kindVisitor.enter;
        if (typeof kindSpecificVisitor === 'function') // { Kind: { enter() {}, leave() {} } }
        return kindSpecificVisitor;
    } else {
        var specificVisitor = isLeaving ? visitor.leave : visitor.enter;
        if (specificVisitor) {
            if (typeof specificVisitor === 'function') // { enter() {}, leave() {} }
            return specificVisitor;
            var specificKindVisitor = specificVisitor[kind];
            if (typeof specificKindVisitor === 'function') // { enter: { Kind() {} }, leave: { Kind() {} } }
            return specificKindVisitor;
        }
    }
}

});
parcelRegister("yEDl8", function(module, exports) {

$parcel$export(module.exports, "default", () => $0682b20f61c706c4$export$2e2bcd8739ae039);

var $7NbHY = parcelRequire("7NbHY");
function $0682b20f61c706c4$var$_typeof(obj) {
    "@babel/helpers - typeof";
    if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") $0682b20f61c706c4$var$_typeof = function _typeof(obj) {
        return typeof obj;
    };
    else $0682b20f61c706c4$var$_typeof = function _typeof(obj) {
        return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
    return $0682b20f61c706c4$var$_typeof(obj);
}
var $0682b20f61c706c4$var$MAX_ARRAY_LENGTH = 10;
var $0682b20f61c706c4$var$MAX_RECURSIVE_DEPTH = 2;
function $0682b20f61c706c4$export$2e2bcd8739ae039(value) {
    return $0682b20f61c706c4$var$formatValue(value, []);
}
function $0682b20f61c706c4$var$formatValue(value, seenValues) {
    switch($0682b20f61c706c4$var$_typeof(value)){
        case 'string':
            return JSON.stringify(value);
        case 'function':
            return value.name ? "[function ".concat(value.name, "]") : '[function]';
        case 'object':
            if (value === null) return 'null';
            return $0682b20f61c706c4$var$formatObjectValue(value, seenValues);
        default:
            return String(value);
    }
}
function $0682b20f61c706c4$var$formatObjectValue(value, previouslySeenValues) {
    if (previouslySeenValues.indexOf(value) !== -1) return '[Circular]';
    var seenValues = [].concat(previouslySeenValues, [
        value
    ]);
    var customInspectFn = $0682b20f61c706c4$var$getCustomFn(value);
    if (customInspectFn !== undefined) {
        var customValue = customInspectFn.call(value); // check for infinite recursion
        if (customValue !== value) return typeof customValue === 'string' ? customValue : $0682b20f61c706c4$var$formatValue(customValue, seenValues);
    } else if (Array.isArray(value)) return $0682b20f61c706c4$var$formatArray(value, seenValues);
    return $0682b20f61c706c4$var$formatObject(value, seenValues);
}
function $0682b20f61c706c4$var$formatObject(object, seenValues) {
    var keys = Object.keys(object);
    if (keys.length === 0) return '{}';
    if (seenValues.length > $0682b20f61c706c4$var$MAX_RECURSIVE_DEPTH) return '[' + $0682b20f61c706c4$var$getObjectTag(object) + ']';
    var properties = keys.map(function(key) {
        var value = $0682b20f61c706c4$var$formatValue(object[key], seenValues);
        return key + ': ' + value;
    });
    return '{ ' + properties.join(', ') + ' }';
}
function $0682b20f61c706c4$var$formatArray(array, seenValues) {
    if (array.length === 0) return '[]';
    if (seenValues.length > $0682b20f61c706c4$var$MAX_RECURSIVE_DEPTH) return '[Array]';
    var len = Math.min($0682b20f61c706c4$var$MAX_ARRAY_LENGTH, array.length);
    var remaining = array.length - len;
    var items = [];
    for(var i = 0; i < len; ++i)items.push($0682b20f61c706c4$var$formatValue(array[i], seenValues));
    if (remaining === 1) items.push('... 1 more item');
    else if (remaining > 1) items.push("... ".concat(remaining, " more items"));
    return '[' + items.join(', ') + ']';
}
function $0682b20f61c706c4$var$getCustomFn(object) {
    var customInspectFn = object[String((0, $7NbHY.default))];
    if (typeof customInspectFn === 'function') return customInspectFn;
    if (typeof object.inspect === 'function') return object.inspect;
}
function $0682b20f61c706c4$var$getObjectTag(object) {
    var tag = Object.prototype.toString.call(object).replace(/^\[object /, '').replace(/]$/, '');
    if (tag === 'Object' && typeof object.constructor === 'function') {
        var name = object.constructor.name;
        if (typeof name === 'string' && name !== '') return name;
    }
    return tag;
}

});
parcelRegister("7NbHY", function(module, exports) {

$parcel$export(module.exports, "default", () => $5ac63109fd04dae2$export$2e2bcd8739ae039);
// istanbul ignore next (See: 'https://github.com/graphql/graphql-js/issues/2317')
var $5ac63109fd04dae2$var$nodejsCustomInspectSymbol = typeof Symbol === 'function' && typeof Symbol.for === 'function' ? Symbol.for('nodejs.util.inspect.custom') : undefined;
var $5ac63109fd04dae2$export$2e2bcd8739ae039 = $5ac63109fd04dae2$var$nodejsCustomInspectSymbol;

});


parcelRegister("98oUl", function(module, exports) {

$parcel$export(module.exports, "Location", () => $6a682e985d2af3c5$export$18a2be9195644f38);
$parcel$export(module.exports, "Token", () => $6a682e985d2af3c5$export$50792b0e93539fde);
$parcel$export(module.exports, "isNode", () => $6a682e985d2af3c5$export$8ee0fc9ee280b4ee);

var $520Pd = parcelRequire("520Pd");
var $6a682e985d2af3c5$export$18a2be9195644f38 = /*#__PURE__*/ function() {
    /**
   * The character offset at which this Node begins.
   */ /**
   * The character offset at which this Node ends.
   */ /**
   * The Token at which this Node begins.
   */ /**
   * The Token at which this Node ends.
   */ /**
   * The Source document the AST represents.
   */ function Location(startToken, endToken, source) {
        this.start = startToken.start;
        this.end = endToken.end;
        this.startToken = startToken;
        this.endToken = endToken;
        this.source = source;
    }
    var _proto = Location.prototype;
    _proto.toJSON = function toJSON() {
        return {
            start: this.start,
            end: this.end
        };
    };
    return Location;
}(); // Print a simplified form when appearing in `inspect` and `util.inspect`.
(0, $520Pd.default)($6a682e985d2af3c5$export$18a2be9195644f38);
var $6a682e985d2af3c5$export$50792b0e93539fde = /*#__PURE__*/ function() {
    /**
   * The kind of Token.
   */ /**
   * The character offset at which this Node begins.
   */ /**
   * The character offset at which this Node ends.
   */ /**
   * The 1-indexed line number on which this Token appears.
   */ /**
   * The 1-indexed column number at which this Token begins.
   */ /**
   * For non-punctuation tokens, represents the interpreted value of the token.
   */ /**
   * Tokens exist as nodes in a double-linked-list amongst all tokens
   * including ignored tokens. <SOF> is always the first node and <EOF>
   * the last.
   */ function Token(kind, start, end, line, column, prev, value) {
        this.kind = kind;
        this.start = start;
        this.end = end;
        this.line = line;
        this.column = column;
        this.value = value;
        this.prev = prev;
        this.next = null;
    }
    var _proto2 = Token.prototype;
    _proto2.toJSON = function toJSON() {
        return {
            kind: this.kind,
            value: this.value,
            line: this.line,
            column: this.column
        };
    };
    return Token;
}(); // Print a simplified form when appearing in `inspect` and `util.inspect`.
(0, $520Pd.default)($6a682e985d2af3c5$export$50792b0e93539fde);
function $6a682e985d2af3c5$export$8ee0fc9ee280b4ee(maybeNode) {
    return maybeNode != null && typeof maybeNode.kind === 'string';
} /**
 * The list of all possible AST node types.
 */ 

});
parcelRegister("520Pd", function(module, exports) {

$parcel$export(module.exports, "default", () => $3a9dc77a0e8a6949$export$2e2bcd8739ae039);

var $fM9AB = parcelRequire("fM9AB");

var $7NbHY = parcelRequire("7NbHY");
function $3a9dc77a0e8a6949$export$2e2bcd8739ae039(classObject) {
    var fn = classObject.prototype.toJSON;
    typeof fn === 'function' || (0, $fM9AB.default)(0);
    classObject.prototype.inspect = fn; // istanbul ignore else (See: 'https://github.com/graphql/graphql-js/issues/2317')
    if (0, $7NbHY.default) classObject.prototype[0, $7NbHY.default] = fn;
}

});
parcelRegister("fM9AB", function(module, exports) {

$parcel$export(module.exports, "default", () => $b7c2c6f03066157d$export$2e2bcd8739ae039);
function $b7c2c6f03066157d$export$2e2bcd8739ae039(condition, message) {
    var booleanCondition = Boolean(condition); // istanbul ignore else (See transformation done in './resources/inlineInvariant.js')
    if (!booleanCondition) throw new Error(message != null ? message : 'Unexpected invariant triggered.');
}

});




parcelRegister("541Mz", function(module, exports) {

$parcel$export(module.exports, "dedentBlockStringValue", () => $3afeb56b3b6851c5$export$fd88c0b652c46ccc);
$parcel$export(module.exports, "printBlockString", () => $3afeb56b3b6851c5$export$adb6ca997eeb1f45);
/**
 * Produces the value of a block string from its parsed raw value, similar to
 * CoffeeScript's block string, Python's docstring trim or Ruby's strip_heredoc.
 *
 * This implements the GraphQL spec's BlockStringValue() static algorithm.
 *
 * @internal
 */ function $3afeb56b3b6851c5$export$fd88c0b652c46ccc(rawString) {
    // Expand a block string's raw value into independent lines.
    var lines = rawString.split(/\r\n|[\n\r]/g); // Remove common indentation from all lines but first.
    var commonIndent = $3afeb56b3b6851c5$export$3c95bfdc680af0c(rawString);
    if (commonIndent !== 0) for(var i = 1; i < lines.length; i++)lines[i] = lines[i].slice(commonIndent);
     // Remove leading and trailing blank lines.
    var startLine = 0;
    while(startLine < lines.length && $3afeb56b3b6851c5$var$isBlank(lines[startLine]))++startLine;
    var endLine = lines.length;
    while(endLine > startLine && $3afeb56b3b6851c5$var$isBlank(lines[endLine - 1]))--endLine;
     // Return a string of the lines joined with U+000A.
    return lines.slice(startLine, endLine).join('\n');
}
function $3afeb56b3b6851c5$var$isBlank(str) {
    for(var i = 0; i < str.length; ++i){
        if (str[i] !== ' ' && str[i] !== '\t') return false;
    }
    return true;
}
function $3afeb56b3b6851c5$export$3c95bfdc680af0c(value) {
    var _commonIndent;
    var isFirstLine = true;
    var isEmptyLine = true;
    var indent = 0;
    var commonIndent = null;
    for(var i = 0; i < value.length; ++i)switch(value.charCodeAt(i)){
        case 13:
            //  \r
            if (value.charCodeAt(i + 1) === 10) ++i; // skip \r\n as one symbol
        // falls through
        case 10:
            //  \n
            isFirstLine = false;
            isEmptyLine = true;
            indent = 0;
            break;
        case 9:
        case 32:
            //  <space>
            ++indent;
            break;
        default:
            if (isEmptyLine && !isFirstLine && (commonIndent === null || indent < commonIndent)) commonIndent = indent;
            isEmptyLine = false;
    }
    return (_commonIndent = commonIndent) !== null && _commonIndent !== void 0 ? _commonIndent : 0;
}
function $3afeb56b3b6851c5$export$adb6ca997eeb1f45(value) {
    var indentation = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';
    var preferMultipleLines = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
    var isSingleLine = value.indexOf('\n') === -1;
    var hasLeadingSpace = value[0] === ' ' || value[0] === '\t';
    var hasTrailingQuote = value[value.length - 1] === '"';
    var hasTrailingSlash = value[value.length - 1] === '\\';
    var printAsMultipleLines = !isSingleLine || hasTrailingQuote || hasTrailingSlash || preferMultipleLines;
    var result = ''; // Format a multi-line block quote to account for leading space.
    if (printAsMultipleLines && !(isSingleLine && hasLeadingSpace)) result += '\n' + indentation;
    result += indentation ? value.replace(/\n/g, '\n' + indentation) : value;
    if (printAsMultipleLines) result += '\n';
    return '"""' + result.replace(/"""/g, '\\"""') + '"""';
}

});


parcelRegister("5cllN", function(module, exports) {

$parcel$export(module.exports, "gql", () => $3c8ea2810a9abcde$export$72e4926bf8358653);
$parcel$export(module.exports, "default", () => $3c8ea2810a9abcde$export$2e2bcd8739ae039);

var $3VFsf = parcelRequire("3VFsf");

var $8uUC9 = parcelRequire("8uUC9");
var $3c8ea2810a9abcde$var$docCache = new Map();
var $3c8ea2810a9abcde$var$fragmentSourceMap = new Map();
var $3c8ea2810a9abcde$var$printFragmentWarnings = true;
var $3c8ea2810a9abcde$var$experimentalFragmentVariables = false;
function $3c8ea2810a9abcde$var$normalize(string) {
    return string.replace(/[\s,]+/g, ' ').trim();
}
function $3c8ea2810a9abcde$var$cacheKeyFromLoc(loc) {
    return $3c8ea2810a9abcde$var$normalize(loc.source.body.substring(loc.start, loc.end));
}
function $3c8ea2810a9abcde$var$processFragments(ast) {
    var seenKeys = new Set();
    var definitions = [];
    ast.definitions.forEach(function(fragmentDefinition) {
        if (fragmentDefinition.kind === 'FragmentDefinition') {
            var fragmentName = fragmentDefinition.name.value;
            var sourceKey = $3c8ea2810a9abcde$var$cacheKeyFromLoc(fragmentDefinition.loc);
            var sourceKeySet = $3c8ea2810a9abcde$var$fragmentSourceMap.get(fragmentName);
            if (sourceKeySet && !sourceKeySet.has(sourceKey)) {
                if ($3c8ea2810a9abcde$var$printFragmentWarnings) console.warn("Warning: fragment with name " + fragmentName + " already exists.\n" + "graphql-tag enforces all fragment names across your application to be unique; read more about\n" + "this in the docs: http://dev.apollodata.com/core/fragments.html#unique-names");
            } else if (!sourceKeySet) $3c8ea2810a9abcde$var$fragmentSourceMap.set(fragmentName, sourceKeySet = new Set);
            sourceKeySet.add(sourceKey);
            if (!seenKeys.has(sourceKey)) {
                seenKeys.add(sourceKey);
                definitions.push(fragmentDefinition);
            }
        } else definitions.push(fragmentDefinition);
    });
    return (0, $3VFsf.__assign)((0, $3VFsf.__assign)({}, ast), {
        definitions: definitions
    });
}
function $3c8ea2810a9abcde$var$stripLoc(doc) {
    var workSet = new Set(doc.definitions);
    workSet.forEach(function(node) {
        if (node.loc) delete node.loc;
        Object.keys(node).forEach(function(key) {
            var value = node[key];
            if (value && typeof value === 'object') workSet.add(value);
        });
    });
    var loc = doc.loc;
    if (loc) {
        delete loc.startToken;
        delete loc.endToken;
    }
    return doc;
}
function $3c8ea2810a9abcde$var$parseDocument(source) {
    var cacheKey = $3c8ea2810a9abcde$var$normalize(source);
    if (!$3c8ea2810a9abcde$var$docCache.has(cacheKey)) {
        var parsed = (0, $8uUC9.parse)(source, {
            experimentalFragmentVariables: $3c8ea2810a9abcde$var$experimentalFragmentVariables,
            allowLegacyFragmentVariables: $3c8ea2810a9abcde$var$experimentalFragmentVariables
        });
        if (!parsed || parsed.kind !== 'Document') throw new Error('Not a valid GraphQL document.');
        $3c8ea2810a9abcde$var$docCache.set(cacheKey, $3c8ea2810a9abcde$var$stripLoc($3c8ea2810a9abcde$var$processFragments(parsed)));
    }
    return $3c8ea2810a9abcde$var$docCache.get(cacheKey);
}
function $3c8ea2810a9abcde$export$72e4926bf8358653(literals) {
    var args = [];
    for(var _i = 1; _i < arguments.length; _i++)args[_i - 1] = arguments[_i];
    if (typeof literals === 'string') literals = [
        literals
    ];
    var result = literals[0];
    args.forEach(function(arg, i) {
        if (arg && arg.kind === 'Document') result += arg.loc.source.body;
        else result += arg;
        result += literals[i + 1];
    });
    return $3c8ea2810a9abcde$var$parseDocument(result);
}
function $3c8ea2810a9abcde$export$657554ef4dc7ac2d() {
    $3c8ea2810a9abcde$var$docCache.clear();
    $3c8ea2810a9abcde$var$fragmentSourceMap.clear();
}
function $3c8ea2810a9abcde$export$e4294e638636c6ab() {
    $3c8ea2810a9abcde$var$printFragmentWarnings = false;
}
function $3c8ea2810a9abcde$export$78cf889af350c840() {
    $3c8ea2810a9abcde$var$experimentalFragmentVariables = true;
}
function $3c8ea2810a9abcde$export$5290df9bbbd3cfa() {
    $3c8ea2810a9abcde$var$experimentalFragmentVariables = false;
}
var $3c8ea2810a9abcde$var$extras = {
    gql: $3c8ea2810a9abcde$export$72e4926bf8358653,
    resetCaches: $3c8ea2810a9abcde$export$657554ef4dc7ac2d,
    disableFragmentWarnings: $3c8ea2810a9abcde$export$e4294e638636c6ab,
    enableExperimentalFragmentVariables: $3c8ea2810a9abcde$export$78cf889af350c840,
    disableExperimentalFragmentVariables: $3c8ea2810a9abcde$export$5290df9bbbd3cfa
};
(function(gql_1) {
    gql_1.gql = $3c8ea2810a9abcde$var$extras.gql, gql_1.resetCaches = $3c8ea2810a9abcde$var$extras.resetCaches, gql_1.disableFragmentWarnings = $3c8ea2810a9abcde$var$extras.disableFragmentWarnings, gql_1.enableExperimentalFragmentVariables = $3c8ea2810a9abcde$var$extras.enableExperimentalFragmentVariables, gql_1.disableExperimentalFragmentVariables = $3c8ea2810a9abcde$var$extras.disableExperimentalFragmentVariables;
})($3c8ea2810a9abcde$export$72e4926bf8358653 || ($3c8ea2810a9abcde$export$72e4926bf8358653 = {}));
$3c8ea2810a9abcde$export$72e4926bf8358653["default"] = $3c8ea2810a9abcde$export$72e4926bf8358653;
var $3c8ea2810a9abcde$export$2e2bcd8739ae039 = $3c8ea2810a9abcde$export$72e4926bf8358653;

});
parcelRegister("8uUC9", function(module, exports) {

$parcel$export(module.exports, "parse", () => $62fd0a8327627af8$export$98e6a39c04603d36);

var $7ZXKi = parcelRequire("7ZXKi");

var $bzIlO = parcelRequire("bzIlO");

var $98oUl = parcelRequire("98oUl");

var $2z7TS = parcelRequire("2z7TS");

var $6vk4Q = parcelRequire("6vk4Q");

var $jADQJ = parcelRequire("jADQJ");

var $jkcJk = parcelRequire("jkcJk");
function $62fd0a8327627af8$export$98e6a39c04603d36(source, options) {
    var parser = new $62fd0a8327627af8$export$7acfa6ed01010e37(source, options);
    return parser.parseDocument();
}
function $62fd0a8327627af8$export$5303528d1070ff6f(source, options) {
    var parser = new $62fd0a8327627af8$export$7acfa6ed01010e37(source, options);
    parser.expectToken((0, $2z7TS.TokenKind).SOF);
    var value = parser.parseValueLiteral(false);
    parser.expectToken((0, $2z7TS.TokenKind).EOF);
    return value;
}
function $62fd0a8327627af8$export$28b8f402ccc88182(source, options) {
    var parser = new $62fd0a8327627af8$export$7acfa6ed01010e37(source, options);
    parser.expectToken((0, $2z7TS.TokenKind).SOF);
    var type = parser.parseTypeReference();
    parser.expectToken((0, $2z7TS.TokenKind).EOF);
    return type;
}
var $62fd0a8327627af8$export$7acfa6ed01010e37 = /*#__PURE__*/ function() {
    function Parser(source, options) {
        var sourceObj = (0, $6vk4Q.isSource)(source) ? source : new (0, $6vk4Q.Source)(source);
        this._lexer = new (0, $jkcJk.Lexer)(sourceObj);
        this._options = options;
    }
    /**
   * Converts a name lex token into a name parse node.
   */ var _proto = Parser.prototype;
    _proto.parseName = function parseName() {
        var token = this.expectToken((0, $2z7TS.TokenKind).NAME);
        return {
            kind: (0, $bzIlO.Kind).NAME,
            value: token.value,
            loc: this.loc(token)
        };
    } // Implements the parsing rules in the Document section.
     /**
   * Document : Definition+
   */ ;
    _proto.parseDocument = function parseDocument() {
        var start = this._lexer.token;
        return {
            kind: (0, $bzIlO.Kind).DOCUMENT,
            definitions: this.many((0, $2z7TS.TokenKind).SOF, this.parseDefinition, (0, $2z7TS.TokenKind).EOF),
            loc: this.loc(start)
        };
    } /**
   * Definition :
   *   - ExecutableDefinition
   *   - TypeSystemDefinition
   *   - TypeSystemExtension
   *
   * ExecutableDefinition :
   *   - OperationDefinition
   *   - FragmentDefinition
   */ ;
    _proto.parseDefinition = function parseDefinition() {
        if (this.peek((0, $2z7TS.TokenKind).NAME)) switch(this._lexer.token.value){
            case 'query':
            case 'mutation':
            case 'subscription':
                return this.parseOperationDefinition();
            case 'fragment':
                return this.parseFragmentDefinition();
            case 'schema':
            case 'scalar':
            case 'type':
            case 'interface':
            case 'union':
            case 'enum':
            case 'input':
            case 'directive':
                return this.parseTypeSystemDefinition();
            case 'extend':
                return this.parseTypeSystemExtension();
        }
        else if (this.peek((0, $2z7TS.TokenKind).BRACE_L)) return this.parseOperationDefinition();
        else if (this.peekDescription()) return this.parseTypeSystemDefinition();
        throw this.unexpected();
    } // Implements the parsing rules in the Operations section.
     /**
   * OperationDefinition :
   *  - SelectionSet
   *  - OperationType Name? VariableDefinitions? Directives? SelectionSet
   */ ;
    _proto.parseOperationDefinition = function parseOperationDefinition() {
        var start = this._lexer.token;
        if (this.peek((0, $2z7TS.TokenKind).BRACE_L)) return {
            kind: (0, $bzIlO.Kind).OPERATION_DEFINITION,
            operation: 'query',
            name: undefined,
            variableDefinitions: [],
            directives: [],
            selectionSet: this.parseSelectionSet(),
            loc: this.loc(start)
        };
        var operation = this.parseOperationType();
        var name;
        if (this.peek((0, $2z7TS.TokenKind).NAME)) name = this.parseName();
        return {
            kind: (0, $bzIlO.Kind).OPERATION_DEFINITION,
            operation: operation,
            name: name,
            variableDefinitions: this.parseVariableDefinitions(),
            directives: this.parseDirectives(false),
            selectionSet: this.parseSelectionSet(),
            loc: this.loc(start)
        };
    } /**
   * OperationType : one of query mutation subscription
   */ ;
    _proto.parseOperationType = function parseOperationType() {
        var operationToken = this.expectToken((0, $2z7TS.TokenKind).NAME);
        switch(operationToken.value){
            case 'query':
                return 'query';
            case 'mutation':
                return 'mutation';
            case 'subscription':
                return 'subscription';
        }
        throw this.unexpected(operationToken);
    } /**
   * VariableDefinitions : ( VariableDefinition+ )
   */ ;
    _proto.parseVariableDefinitions = function parseVariableDefinitions() {
        return this.optionalMany((0, $2z7TS.TokenKind).PAREN_L, this.parseVariableDefinition, (0, $2z7TS.TokenKind).PAREN_R);
    } /**
   * VariableDefinition : Variable : Type DefaultValue? Directives[Const]?
   */ ;
    _proto.parseVariableDefinition = function parseVariableDefinition() {
        var start = this._lexer.token;
        return {
            kind: (0, $bzIlO.Kind).VARIABLE_DEFINITION,
            variable: this.parseVariable(),
            type: (this.expectToken((0, $2z7TS.TokenKind).COLON), this.parseTypeReference()),
            defaultValue: this.expectOptionalToken((0, $2z7TS.TokenKind).EQUALS) ? this.parseValueLiteral(true) : undefined,
            directives: this.parseDirectives(true),
            loc: this.loc(start)
        };
    } /**
   * Variable : $ Name
   */ ;
    _proto.parseVariable = function parseVariable() {
        var start = this._lexer.token;
        this.expectToken((0, $2z7TS.TokenKind).DOLLAR);
        return {
            kind: (0, $bzIlO.Kind).VARIABLE,
            name: this.parseName(),
            loc: this.loc(start)
        };
    } /**
   * SelectionSet : { Selection+ }
   */ ;
    _proto.parseSelectionSet = function parseSelectionSet() {
        var start = this._lexer.token;
        return {
            kind: (0, $bzIlO.Kind).SELECTION_SET,
            selections: this.many((0, $2z7TS.TokenKind).BRACE_L, this.parseSelection, (0, $2z7TS.TokenKind).BRACE_R),
            loc: this.loc(start)
        };
    } /**
   * Selection :
   *   - Field
   *   - FragmentSpread
   *   - InlineFragment
   */ ;
    _proto.parseSelection = function parseSelection() {
        return this.peek((0, $2z7TS.TokenKind).SPREAD) ? this.parseFragment() : this.parseField();
    } /**
   * Field : Alias? Name Arguments? Directives? SelectionSet?
   *
   * Alias : Name :
   */ ;
    _proto.parseField = function parseField() {
        var start = this._lexer.token;
        var nameOrAlias = this.parseName();
        var alias;
        var name;
        if (this.expectOptionalToken((0, $2z7TS.TokenKind).COLON)) {
            alias = nameOrAlias;
            name = this.parseName();
        } else name = nameOrAlias;
        return {
            kind: (0, $bzIlO.Kind).FIELD,
            alias: alias,
            name: name,
            arguments: this.parseArguments(false),
            directives: this.parseDirectives(false),
            selectionSet: this.peek((0, $2z7TS.TokenKind).BRACE_L) ? this.parseSelectionSet() : undefined,
            loc: this.loc(start)
        };
    } /**
   * Arguments[Const] : ( Argument[?Const]+ )
   */ ;
    _proto.parseArguments = function parseArguments(isConst) {
        var item = isConst ? this.parseConstArgument : this.parseArgument;
        return this.optionalMany((0, $2z7TS.TokenKind).PAREN_L, item, (0, $2z7TS.TokenKind).PAREN_R);
    } /**
   * Argument[Const] : Name : Value[?Const]
   */ ;
    _proto.parseArgument = function parseArgument() {
        var start = this._lexer.token;
        var name = this.parseName();
        this.expectToken((0, $2z7TS.TokenKind).COLON);
        return {
            kind: (0, $bzIlO.Kind).ARGUMENT,
            name: name,
            value: this.parseValueLiteral(false),
            loc: this.loc(start)
        };
    };
    _proto.parseConstArgument = function parseConstArgument() {
        var start = this._lexer.token;
        return {
            kind: (0, $bzIlO.Kind).ARGUMENT,
            name: this.parseName(),
            value: (this.expectToken((0, $2z7TS.TokenKind).COLON), this.parseValueLiteral(true)),
            loc: this.loc(start)
        };
    } // Implements the parsing rules in the Fragments section.
     /**
   * Corresponds to both FragmentSpread and InlineFragment in the spec.
   *
   * FragmentSpread : ... FragmentName Directives?
   *
   * InlineFragment : ... TypeCondition? Directives? SelectionSet
   */ ;
    _proto.parseFragment = function parseFragment() {
        var start = this._lexer.token;
        this.expectToken((0, $2z7TS.TokenKind).SPREAD);
        var hasTypeCondition = this.expectOptionalKeyword('on');
        if (!hasTypeCondition && this.peek((0, $2z7TS.TokenKind).NAME)) return {
            kind: (0, $bzIlO.Kind).FRAGMENT_SPREAD,
            name: this.parseFragmentName(),
            directives: this.parseDirectives(false),
            loc: this.loc(start)
        };
        return {
            kind: (0, $bzIlO.Kind).INLINE_FRAGMENT,
            typeCondition: hasTypeCondition ? this.parseNamedType() : undefined,
            directives: this.parseDirectives(false),
            selectionSet: this.parseSelectionSet(),
            loc: this.loc(start)
        };
    } /**
   * FragmentDefinition :
   *   - fragment FragmentName on TypeCondition Directives? SelectionSet
   *
   * TypeCondition : NamedType
   */ ;
    _proto.parseFragmentDefinition = function parseFragmentDefinition() {
        var _this$_options;
        var start = this._lexer.token;
        this.expectKeyword('fragment'); // Experimental support for defining variables within fragments changes
        // the grammar of FragmentDefinition:
        //   - fragment FragmentName VariableDefinitions? on TypeCondition Directives? SelectionSet
        if (((_this$_options = this._options) === null || _this$_options === void 0 ? void 0 : _this$_options.experimentalFragmentVariables) === true) return {
            kind: (0, $bzIlO.Kind).FRAGMENT_DEFINITION,
            name: this.parseFragmentName(),
            variableDefinitions: this.parseVariableDefinitions(),
            typeCondition: (this.expectKeyword('on'), this.parseNamedType()),
            directives: this.parseDirectives(false),
            selectionSet: this.parseSelectionSet(),
            loc: this.loc(start)
        };
        return {
            kind: (0, $bzIlO.Kind).FRAGMENT_DEFINITION,
            name: this.parseFragmentName(),
            typeCondition: (this.expectKeyword('on'), this.parseNamedType()),
            directives: this.parseDirectives(false),
            selectionSet: this.parseSelectionSet(),
            loc: this.loc(start)
        };
    } /**
   * FragmentName : Name but not `on`
   */ ;
    _proto.parseFragmentName = function parseFragmentName() {
        if (this._lexer.token.value === 'on') throw this.unexpected();
        return this.parseName();
    } // Implements the parsing rules in the Values section.
     /**
   * Value[Const] :
   *   - [~Const] Variable
   *   - IntValue
   *   - FloatValue
   *   - StringValue
   *   - BooleanValue
   *   - NullValue
   *   - EnumValue
   *   - ListValue[?Const]
   *   - ObjectValue[?Const]
   *
   * BooleanValue : one of `true` `false`
   *
   * NullValue : `null`
   *
   * EnumValue : Name but not `true`, `false` or `null`
   */ ;
    _proto.parseValueLiteral = function parseValueLiteral(isConst) {
        var token = this._lexer.token;
        switch(token.kind){
            case (0, $2z7TS.TokenKind).BRACKET_L:
                return this.parseList(isConst);
            case (0, $2z7TS.TokenKind).BRACE_L:
                return this.parseObject(isConst);
            case (0, $2z7TS.TokenKind).INT:
                this._lexer.advance();
                return {
                    kind: (0, $bzIlO.Kind).INT,
                    value: token.value,
                    loc: this.loc(token)
                };
            case (0, $2z7TS.TokenKind).FLOAT:
                this._lexer.advance();
                return {
                    kind: (0, $bzIlO.Kind).FLOAT,
                    value: token.value,
                    loc: this.loc(token)
                };
            case (0, $2z7TS.TokenKind).STRING:
            case (0, $2z7TS.TokenKind).BLOCK_STRING:
                return this.parseStringLiteral();
            case (0, $2z7TS.TokenKind).NAME:
                this._lexer.advance();
                switch(token.value){
                    case 'true':
                        return {
                            kind: (0, $bzIlO.Kind).BOOLEAN,
                            value: true,
                            loc: this.loc(token)
                        };
                    case 'false':
                        return {
                            kind: (0, $bzIlO.Kind).BOOLEAN,
                            value: false,
                            loc: this.loc(token)
                        };
                    case 'null':
                        return {
                            kind: (0, $bzIlO.Kind).NULL,
                            loc: this.loc(token)
                        };
                    default:
                        return {
                            kind: (0, $bzIlO.Kind).ENUM,
                            value: token.value,
                            loc: this.loc(token)
                        };
                }
            case (0, $2z7TS.TokenKind).DOLLAR:
                if (!isConst) return this.parseVariable();
                break;
        }
        throw this.unexpected();
    };
    _proto.parseStringLiteral = function parseStringLiteral() {
        var token = this._lexer.token;
        this._lexer.advance();
        return {
            kind: (0, $bzIlO.Kind).STRING,
            value: token.value,
            block: token.kind === (0, $2z7TS.TokenKind).BLOCK_STRING,
            loc: this.loc(token)
        };
    } /**
   * ListValue[Const] :
   *   - [ ]
   *   - [ Value[?Const]+ ]
   */ ;
    _proto.parseList = function parseList(isConst) {
        var _this = this;
        var start = this._lexer.token;
        var item = function item() {
            return _this.parseValueLiteral(isConst);
        };
        return {
            kind: (0, $bzIlO.Kind).LIST,
            values: this.any((0, $2z7TS.TokenKind).BRACKET_L, item, (0, $2z7TS.TokenKind).BRACKET_R),
            loc: this.loc(start)
        };
    } /**
   * ObjectValue[Const] :
   *   - { }
   *   - { ObjectField[?Const]+ }
   */ ;
    _proto.parseObject = function parseObject(isConst) {
        var _this2 = this;
        var start = this._lexer.token;
        var item = function item() {
            return _this2.parseObjectField(isConst);
        };
        return {
            kind: (0, $bzIlO.Kind).OBJECT,
            fields: this.any((0, $2z7TS.TokenKind).BRACE_L, item, (0, $2z7TS.TokenKind).BRACE_R),
            loc: this.loc(start)
        };
    } /**
   * ObjectField[Const] : Name : Value[?Const]
   */ ;
    _proto.parseObjectField = function parseObjectField(isConst) {
        var start = this._lexer.token;
        var name = this.parseName();
        this.expectToken((0, $2z7TS.TokenKind).COLON);
        return {
            kind: (0, $bzIlO.Kind).OBJECT_FIELD,
            name: name,
            value: this.parseValueLiteral(isConst),
            loc: this.loc(start)
        };
    } // Implements the parsing rules in the Directives section.
     /**
   * Directives[Const] : Directive[?Const]+
   */ ;
    _proto.parseDirectives = function parseDirectives(isConst) {
        var directives = [];
        while(this.peek((0, $2z7TS.TokenKind).AT))directives.push(this.parseDirective(isConst));
        return directives;
    } /**
   * Directive[Const] : @ Name Arguments[?Const]?
   */ ;
    _proto.parseDirective = function parseDirective(isConst) {
        var start = this._lexer.token;
        this.expectToken((0, $2z7TS.TokenKind).AT);
        return {
            kind: (0, $bzIlO.Kind).DIRECTIVE,
            name: this.parseName(),
            arguments: this.parseArguments(isConst),
            loc: this.loc(start)
        };
    } // Implements the parsing rules in the Types section.
     /**
   * Type :
   *   - NamedType
   *   - ListType
   *   - NonNullType
   */ ;
    _proto.parseTypeReference = function parseTypeReference() {
        var start = this._lexer.token;
        var type;
        if (this.expectOptionalToken((0, $2z7TS.TokenKind).BRACKET_L)) {
            type = this.parseTypeReference();
            this.expectToken((0, $2z7TS.TokenKind).BRACKET_R);
            type = {
                kind: (0, $bzIlO.Kind).LIST_TYPE,
                type: type,
                loc: this.loc(start)
            };
        } else type = this.parseNamedType();
        if (this.expectOptionalToken((0, $2z7TS.TokenKind).BANG)) return {
            kind: (0, $bzIlO.Kind).NON_NULL_TYPE,
            type: type,
            loc: this.loc(start)
        };
        return type;
    } /**
   * NamedType : Name
   */ ;
    _proto.parseNamedType = function parseNamedType() {
        var start = this._lexer.token;
        return {
            kind: (0, $bzIlO.Kind).NAMED_TYPE,
            name: this.parseName(),
            loc: this.loc(start)
        };
    } // Implements the parsing rules in the Type Definition section.
     /**
   * TypeSystemDefinition :
   *   - SchemaDefinition
   *   - TypeDefinition
   *   - DirectiveDefinition
   *
   * TypeDefinition :
   *   - ScalarTypeDefinition
   *   - ObjectTypeDefinition
   *   - InterfaceTypeDefinition
   *   - UnionTypeDefinition
   *   - EnumTypeDefinition
   *   - InputObjectTypeDefinition
   */ ;
    _proto.parseTypeSystemDefinition = function parseTypeSystemDefinition() {
        // Many definitions begin with a description and require a lookahead.
        var keywordToken = this.peekDescription() ? this._lexer.lookahead() : this._lexer.token;
        if (keywordToken.kind === (0, $2z7TS.TokenKind).NAME) switch(keywordToken.value){
            case 'schema':
                return this.parseSchemaDefinition();
            case 'scalar':
                return this.parseScalarTypeDefinition();
            case 'type':
                return this.parseObjectTypeDefinition();
            case 'interface':
                return this.parseInterfaceTypeDefinition();
            case 'union':
                return this.parseUnionTypeDefinition();
            case 'enum':
                return this.parseEnumTypeDefinition();
            case 'input':
                return this.parseInputObjectTypeDefinition();
            case 'directive':
                return this.parseDirectiveDefinition();
        }
        throw this.unexpected(keywordToken);
    };
    _proto.peekDescription = function peekDescription() {
        return this.peek((0, $2z7TS.TokenKind).STRING) || this.peek((0, $2z7TS.TokenKind).BLOCK_STRING);
    } /**
   * Description : StringValue
   */ ;
    _proto.parseDescription = function parseDescription() {
        if (this.peekDescription()) return this.parseStringLiteral();
    } /**
   * SchemaDefinition : Description? schema Directives[Const]? { OperationTypeDefinition+ }
   */ ;
    _proto.parseSchemaDefinition = function parseSchemaDefinition() {
        var start = this._lexer.token;
        var description = this.parseDescription();
        this.expectKeyword('schema');
        var directives = this.parseDirectives(true);
        var operationTypes = this.many((0, $2z7TS.TokenKind).BRACE_L, this.parseOperationTypeDefinition, (0, $2z7TS.TokenKind).BRACE_R);
        return {
            kind: (0, $bzIlO.Kind).SCHEMA_DEFINITION,
            description: description,
            directives: directives,
            operationTypes: operationTypes,
            loc: this.loc(start)
        };
    } /**
   * OperationTypeDefinition : OperationType : NamedType
   */ ;
    _proto.parseOperationTypeDefinition = function parseOperationTypeDefinition() {
        var start = this._lexer.token;
        var operation = this.parseOperationType();
        this.expectToken((0, $2z7TS.TokenKind).COLON);
        var type = this.parseNamedType();
        return {
            kind: (0, $bzIlO.Kind).OPERATION_TYPE_DEFINITION,
            operation: operation,
            type: type,
            loc: this.loc(start)
        };
    } /**
   * ScalarTypeDefinition : Description? scalar Name Directives[Const]?
   */ ;
    _proto.parseScalarTypeDefinition = function parseScalarTypeDefinition() {
        var start = this._lexer.token;
        var description = this.parseDescription();
        this.expectKeyword('scalar');
        var name = this.parseName();
        var directives = this.parseDirectives(true);
        return {
            kind: (0, $bzIlO.Kind).SCALAR_TYPE_DEFINITION,
            description: description,
            name: name,
            directives: directives,
            loc: this.loc(start)
        };
    } /**
   * ObjectTypeDefinition :
   *   Description?
   *   type Name ImplementsInterfaces? Directives[Const]? FieldsDefinition?
   */ ;
    _proto.parseObjectTypeDefinition = function parseObjectTypeDefinition() {
        var start = this._lexer.token;
        var description = this.parseDescription();
        this.expectKeyword('type');
        var name = this.parseName();
        var interfaces = this.parseImplementsInterfaces();
        var directives = this.parseDirectives(true);
        var fields = this.parseFieldsDefinition();
        return {
            kind: (0, $bzIlO.Kind).OBJECT_TYPE_DEFINITION,
            description: description,
            name: name,
            interfaces: interfaces,
            directives: directives,
            fields: fields,
            loc: this.loc(start)
        };
    } /**
   * ImplementsInterfaces :
   *   - implements `&`? NamedType
   *   - ImplementsInterfaces & NamedType
   */ ;
    _proto.parseImplementsInterfaces = function parseImplementsInterfaces() {
        var _this$_options2;
        if (!this.expectOptionalKeyword('implements')) return [];
        if (((_this$_options2 = this._options) === null || _this$_options2 === void 0 ? void 0 : _this$_options2.allowLegacySDLImplementsInterfaces) === true) {
            var types = []; // Optional leading ampersand
            this.expectOptionalToken((0, $2z7TS.TokenKind).AMP);
            do types.push(this.parseNamedType());
            while (this.expectOptionalToken((0, $2z7TS.TokenKind).AMP) || this.peek((0, $2z7TS.TokenKind).NAME));
            return types;
        }
        return this.delimitedMany((0, $2z7TS.TokenKind).AMP, this.parseNamedType);
    } /**
   * FieldsDefinition : { FieldDefinition+ }
   */ ;
    _proto.parseFieldsDefinition = function parseFieldsDefinition() {
        var _this$_options3;
        // Legacy support for the SDL?
        if (((_this$_options3 = this._options) === null || _this$_options3 === void 0 ? void 0 : _this$_options3.allowLegacySDLEmptyFields) === true && this.peek((0, $2z7TS.TokenKind).BRACE_L) && this._lexer.lookahead().kind === (0, $2z7TS.TokenKind).BRACE_R) {
            this._lexer.advance();
            this._lexer.advance();
            return [];
        }
        return this.optionalMany((0, $2z7TS.TokenKind).BRACE_L, this.parseFieldDefinition, (0, $2z7TS.TokenKind).BRACE_R);
    } /**
   * FieldDefinition :
   *   - Description? Name ArgumentsDefinition? : Type Directives[Const]?
   */ ;
    _proto.parseFieldDefinition = function parseFieldDefinition() {
        var start = this._lexer.token;
        var description = this.parseDescription();
        var name = this.parseName();
        var args = this.parseArgumentDefs();
        this.expectToken((0, $2z7TS.TokenKind).COLON);
        var type = this.parseTypeReference();
        var directives = this.parseDirectives(true);
        return {
            kind: (0, $bzIlO.Kind).FIELD_DEFINITION,
            description: description,
            name: name,
            arguments: args,
            type: type,
            directives: directives,
            loc: this.loc(start)
        };
    } /**
   * ArgumentsDefinition : ( InputValueDefinition+ )
   */ ;
    _proto.parseArgumentDefs = function parseArgumentDefs() {
        return this.optionalMany((0, $2z7TS.TokenKind).PAREN_L, this.parseInputValueDef, (0, $2z7TS.TokenKind).PAREN_R);
    } /**
   * InputValueDefinition :
   *   - Description? Name : Type DefaultValue? Directives[Const]?
   */ ;
    _proto.parseInputValueDef = function parseInputValueDef() {
        var start = this._lexer.token;
        var description = this.parseDescription();
        var name = this.parseName();
        this.expectToken((0, $2z7TS.TokenKind).COLON);
        var type = this.parseTypeReference();
        var defaultValue;
        if (this.expectOptionalToken((0, $2z7TS.TokenKind).EQUALS)) defaultValue = this.parseValueLiteral(true);
        var directives = this.parseDirectives(true);
        return {
            kind: (0, $bzIlO.Kind).INPUT_VALUE_DEFINITION,
            description: description,
            name: name,
            type: type,
            defaultValue: defaultValue,
            directives: directives,
            loc: this.loc(start)
        };
    } /**
   * InterfaceTypeDefinition :
   *   - Description? interface Name Directives[Const]? FieldsDefinition?
   */ ;
    _proto.parseInterfaceTypeDefinition = function parseInterfaceTypeDefinition() {
        var start = this._lexer.token;
        var description = this.parseDescription();
        this.expectKeyword('interface');
        var name = this.parseName();
        var interfaces = this.parseImplementsInterfaces();
        var directives = this.parseDirectives(true);
        var fields = this.parseFieldsDefinition();
        return {
            kind: (0, $bzIlO.Kind).INTERFACE_TYPE_DEFINITION,
            description: description,
            name: name,
            interfaces: interfaces,
            directives: directives,
            fields: fields,
            loc: this.loc(start)
        };
    } /**
   * UnionTypeDefinition :
   *   - Description? union Name Directives[Const]? UnionMemberTypes?
   */ ;
    _proto.parseUnionTypeDefinition = function parseUnionTypeDefinition() {
        var start = this._lexer.token;
        var description = this.parseDescription();
        this.expectKeyword('union');
        var name = this.parseName();
        var directives = this.parseDirectives(true);
        var types = this.parseUnionMemberTypes();
        return {
            kind: (0, $bzIlO.Kind).UNION_TYPE_DEFINITION,
            description: description,
            name: name,
            directives: directives,
            types: types,
            loc: this.loc(start)
        };
    } /**
   * UnionMemberTypes :
   *   - = `|`? NamedType
   *   - UnionMemberTypes | NamedType
   */ ;
    _proto.parseUnionMemberTypes = function parseUnionMemberTypes() {
        return this.expectOptionalToken((0, $2z7TS.TokenKind).EQUALS) ? this.delimitedMany((0, $2z7TS.TokenKind).PIPE, this.parseNamedType) : [];
    } /**
   * EnumTypeDefinition :
   *   - Description? enum Name Directives[Const]? EnumValuesDefinition?
   */ ;
    _proto.parseEnumTypeDefinition = function parseEnumTypeDefinition() {
        var start = this._lexer.token;
        var description = this.parseDescription();
        this.expectKeyword('enum');
        var name = this.parseName();
        var directives = this.parseDirectives(true);
        var values = this.parseEnumValuesDefinition();
        return {
            kind: (0, $bzIlO.Kind).ENUM_TYPE_DEFINITION,
            description: description,
            name: name,
            directives: directives,
            values: values,
            loc: this.loc(start)
        };
    } /**
   * EnumValuesDefinition : { EnumValueDefinition+ }
   */ ;
    _proto.parseEnumValuesDefinition = function parseEnumValuesDefinition() {
        return this.optionalMany((0, $2z7TS.TokenKind).BRACE_L, this.parseEnumValueDefinition, (0, $2z7TS.TokenKind).BRACE_R);
    } /**
   * EnumValueDefinition : Description? EnumValue Directives[Const]?
   *
   * EnumValue : Name
   */ ;
    _proto.parseEnumValueDefinition = function parseEnumValueDefinition() {
        var start = this._lexer.token;
        var description = this.parseDescription();
        var name = this.parseName();
        var directives = this.parseDirectives(true);
        return {
            kind: (0, $bzIlO.Kind).ENUM_VALUE_DEFINITION,
            description: description,
            name: name,
            directives: directives,
            loc: this.loc(start)
        };
    } /**
   * InputObjectTypeDefinition :
   *   - Description? input Name Directives[Const]? InputFieldsDefinition?
   */ ;
    _proto.parseInputObjectTypeDefinition = function parseInputObjectTypeDefinition() {
        var start = this._lexer.token;
        var description = this.parseDescription();
        this.expectKeyword('input');
        var name = this.parseName();
        var directives = this.parseDirectives(true);
        var fields = this.parseInputFieldsDefinition();
        return {
            kind: (0, $bzIlO.Kind).INPUT_OBJECT_TYPE_DEFINITION,
            description: description,
            name: name,
            directives: directives,
            fields: fields,
            loc: this.loc(start)
        };
    } /**
   * InputFieldsDefinition : { InputValueDefinition+ }
   */ ;
    _proto.parseInputFieldsDefinition = function parseInputFieldsDefinition() {
        return this.optionalMany((0, $2z7TS.TokenKind).BRACE_L, this.parseInputValueDef, (0, $2z7TS.TokenKind).BRACE_R);
    } /**
   * TypeSystemExtension :
   *   - SchemaExtension
   *   - TypeExtension
   *
   * TypeExtension :
   *   - ScalarTypeExtension
   *   - ObjectTypeExtension
   *   - InterfaceTypeExtension
   *   - UnionTypeExtension
   *   - EnumTypeExtension
   *   - InputObjectTypeDefinition
   */ ;
    _proto.parseTypeSystemExtension = function parseTypeSystemExtension() {
        var keywordToken = this._lexer.lookahead();
        if (keywordToken.kind === (0, $2z7TS.TokenKind).NAME) switch(keywordToken.value){
            case 'schema':
                return this.parseSchemaExtension();
            case 'scalar':
                return this.parseScalarTypeExtension();
            case 'type':
                return this.parseObjectTypeExtension();
            case 'interface':
                return this.parseInterfaceTypeExtension();
            case 'union':
                return this.parseUnionTypeExtension();
            case 'enum':
                return this.parseEnumTypeExtension();
            case 'input':
                return this.parseInputObjectTypeExtension();
        }
        throw this.unexpected(keywordToken);
    } /**
   * SchemaExtension :
   *  - extend schema Directives[Const]? { OperationTypeDefinition+ }
   *  - extend schema Directives[Const]
   */ ;
    _proto.parseSchemaExtension = function parseSchemaExtension() {
        var start = this._lexer.token;
        this.expectKeyword('extend');
        this.expectKeyword('schema');
        var directives = this.parseDirectives(true);
        var operationTypes = this.optionalMany((0, $2z7TS.TokenKind).BRACE_L, this.parseOperationTypeDefinition, (0, $2z7TS.TokenKind).BRACE_R);
        if (directives.length === 0 && operationTypes.length === 0) throw this.unexpected();
        return {
            kind: (0, $bzIlO.Kind).SCHEMA_EXTENSION,
            directives: directives,
            operationTypes: operationTypes,
            loc: this.loc(start)
        };
    } /**
   * ScalarTypeExtension :
   *   - extend scalar Name Directives[Const]
   */ ;
    _proto.parseScalarTypeExtension = function parseScalarTypeExtension() {
        var start = this._lexer.token;
        this.expectKeyword('extend');
        this.expectKeyword('scalar');
        var name = this.parseName();
        var directives = this.parseDirectives(true);
        if (directives.length === 0) throw this.unexpected();
        return {
            kind: (0, $bzIlO.Kind).SCALAR_TYPE_EXTENSION,
            name: name,
            directives: directives,
            loc: this.loc(start)
        };
    } /**
   * ObjectTypeExtension :
   *  - extend type Name ImplementsInterfaces? Directives[Const]? FieldsDefinition
   *  - extend type Name ImplementsInterfaces? Directives[Const]
   *  - extend type Name ImplementsInterfaces
   */ ;
    _proto.parseObjectTypeExtension = function parseObjectTypeExtension() {
        var start = this._lexer.token;
        this.expectKeyword('extend');
        this.expectKeyword('type');
        var name = this.parseName();
        var interfaces = this.parseImplementsInterfaces();
        var directives = this.parseDirectives(true);
        var fields = this.parseFieldsDefinition();
        if (interfaces.length === 0 && directives.length === 0 && fields.length === 0) throw this.unexpected();
        return {
            kind: (0, $bzIlO.Kind).OBJECT_TYPE_EXTENSION,
            name: name,
            interfaces: interfaces,
            directives: directives,
            fields: fields,
            loc: this.loc(start)
        };
    } /**
   * InterfaceTypeExtension :
   *  - extend interface Name ImplementsInterfaces? Directives[Const]? FieldsDefinition
   *  - extend interface Name ImplementsInterfaces? Directives[Const]
   *  - extend interface Name ImplementsInterfaces
   */ ;
    _proto.parseInterfaceTypeExtension = function parseInterfaceTypeExtension() {
        var start = this._lexer.token;
        this.expectKeyword('extend');
        this.expectKeyword('interface');
        var name = this.parseName();
        var interfaces = this.parseImplementsInterfaces();
        var directives = this.parseDirectives(true);
        var fields = this.parseFieldsDefinition();
        if (interfaces.length === 0 && directives.length === 0 && fields.length === 0) throw this.unexpected();
        return {
            kind: (0, $bzIlO.Kind).INTERFACE_TYPE_EXTENSION,
            name: name,
            interfaces: interfaces,
            directives: directives,
            fields: fields,
            loc: this.loc(start)
        };
    } /**
   * UnionTypeExtension :
   *   - extend union Name Directives[Const]? UnionMemberTypes
   *   - extend union Name Directives[Const]
   */ ;
    _proto.parseUnionTypeExtension = function parseUnionTypeExtension() {
        var start = this._lexer.token;
        this.expectKeyword('extend');
        this.expectKeyword('union');
        var name = this.parseName();
        var directives = this.parseDirectives(true);
        var types = this.parseUnionMemberTypes();
        if (directives.length === 0 && types.length === 0) throw this.unexpected();
        return {
            kind: (0, $bzIlO.Kind).UNION_TYPE_EXTENSION,
            name: name,
            directives: directives,
            types: types,
            loc: this.loc(start)
        };
    } /**
   * EnumTypeExtension :
   *   - extend enum Name Directives[Const]? EnumValuesDefinition
   *   - extend enum Name Directives[Const]
   */ ;
    _proto.parseEnumTypeExtension = function parseEnumTypeExtension() {
        var start = this._lexer.token;
        this.expectKeyword('extend');
        this.expectKeyword('enum');
        var name = this.parseName();
        var directives = this.parseDirectives(true);
        var values = this.parseEnumValuesDefinition();
        if (directives.length === 0 && values.length === 0) throw this.unexpected();
        return {
            kind: (0, $bzIlO.Kind).ENUM_TYPE_EXTENSION,
            name: name,
            directives: directives,
            values: values,
            loc: this.loc(start)
        };
    } /**
   * InputObjectTypeExtension :
   *   - extend input Name Directives[Const]? InputFieldsDefinition
   *   - extend input Name Directives[Const]
   */ ;
    _proto.parseInputObjectTypeExtension = function parseInputObjectTypeExtension() {
        var start = this._lexer.token;
        this.expectKeyword('extend');
        this.expectKeyword('input');
        var name = this.parseName();
        var directives = this.parseDirectives(true);
        var fields = this.parseInputFieldsDefinition();
        if (directives.length === 0 && fields.length === 0) throw this.unexpected();
        return {
            kind: (0, $bzIlO.Kind).INPUT_OBJECT_TYPE_EXTENSION,
            name: name,
            directives: directives,
            fields: fields,
            loc: this.loc(start)
        };
    } /**
   * DirectiveDefinition :
   *   - Description? directive @ Name ArgumentsDefinition? `repeatable`? on DirectiveLocations
   */ ;
    _proto.parseDirectiveDefinition = function parseDirectiveDefinition() {
        var start = this._lexer.token;
        var description = this.parseDescription();
        this.expectKeyword('directive');
        this.expectToken((0, $2z7TS.TokenKind).AT);
        var name = this.parseName();
        var args = this.parseArgumentDefs();
        var repeatable = this.expectOptionalKeyword('repeatable');
        this.expectKeyword('on');
        var locations = this.parseDirectiveLocations();
        return {
            kind: (0, $bzIlO.Kind).DIRECTIVE_DEFINITION,
            description: description,
            name: name,
            arguments: args,
            repeatable: repeatable,
            locations: locations,
            loc: this.loc(start)
        };
    } /**
   * DirectiveLocations :
   *   - `|`? DirectiveLocation
   *   - DirectiveLocations | DirectiveLocation
   */ ;
    _proto.parseDirectiveLocations = function parseDirectiveLocations() {
        return this.delimitedMany((0, $2z7TS.TokenKind).PIPE, this.parseDirectiveLocation);
    } /*
   * DirectiveLocation :
   *   - ExecutableDirectiveLocation
   *   - TypeSystemDirectiveLocation
   *
   * ExecutableDirectiveLocation : one of
   *   `QUERY`
   *   `MUTATION`
   *   `SUBSCRIPTION`
   *   `FIELD`
   *   `FRAGMENT_DEFINITION`
   *   `FRAGMENT_SPREAD`
   *   `INLINE_FRAGMENT`
   *
   * TypeSystemDirectiveLocation : one of
   *   `SCHEMA`
   *   `SCALAR`
   *   `OBJECT`
   *   `FIELD_DEFINITION`
   *   `ARGUMENT_DEFINITION`
   *   `INTERFACE`
   *   `UNION`
   *   `ENUM`
   *   `ENUM_VALUE`
   *   `INPUT_OBJECT`
   *   `INPUT_FIELD_DEFINITION`
   */ ;
    _proto.parseDirectiveLocation = function parseDirectiveLocation() {
        var start = this._lexer.token;
        var name = this.parseName();
        if ((0, $jADQJ.DirectiveLocation)[name.value] !== undefined) return name;
        throw this.unexpected(start);
    } // Core parsing utility functions
     /**
   * Returns a location object, used to identify the place in the source that created a given parsed object.
   */ ;
    _proto.loc = function loc(startToken) {
        var _this$_options4;
        if (((_this$_options4 = this._options) === null || _this$_options4 === void 0 ? void 0 : _this$_options4.noLocation) !== true) return new (0, $98oUl.Location)(startToken, this._lexer.lastToken, this._lexer.source);
    } /**
   * Determines if the next token is of a given kind
   */ ;
    _proto.peek = function peek(kind) {
        return this._lexer.token.kind === kind;
    } /**
   * If the next token is of the given kind, return that token after advancing the lexer.
   * Otherwise, do not change the parser state and throw an error.
   */ ;
    _proto.expectToken = function expectToken(kind) {
        var token = this._lexer.token;
        if (token.kind === kind) {
            this._lexer.advance();
            return token;
        }
        throw (0, $7ZXKi.syntaxError)(this._lexer.source, token.start, "Expected ".concat($62fd0a8327627af8$var$getTokenKindDesc(kind), ", found ").concat($62fd0a8327627af8$var$getTokenDesc(token), "."));
    } /**
   * If the next token is of the given kind, return that token after advancing the lexer.
   * Otherwise, do not change the parser state and return undefined.
   */ ;
    _proto.expectOptionalToken = function expectOptionalToken(kind) {
        var token = this._lexer.token;
        if (token.kind === kind) {
            this._lexer.advance();
            return token;
        }
        return undefined;
    } /**
   * If the next token is a given keyword, advance the lexer.
   * Otherwise, do not change the parser state and throw an error.
   */ ;
    _proto.expectKeyword = function expectKeyword(value) {
        var token = this._lexer.token;
        if (token.kind === (0, $2z7TS.TokenKind).NAME && token.value === value) this._lexer.advance();
        else throw (0, $7ZXKi.syntaxError)(this._lexer.source, token.start, "Expected \"".concat(value, "\", found ").concat($62fd0a8327627af8$var$getTokenDesc(token), "."));
    } /**
   * If the next token is a given keyword, return "true" after advancing the lexer.
   * Otherwise, do not change the parser state and return "false".
   */ ;
    _proto.expectOptionalKeyword = function expectOptionalKeyword(value) {
        var token = this._lexer.token;
        if (token.kind === (0, $2z7TS.TokenKind).NAME && token.value === value) {
            this._lexer.advance();
            return true;
        }
        return false;
    } /**
   * Helper function for creating an error when an unexpected lexed token is encountered.
   */ ;
    _proto.unexpected = function unexpected(atToken) {
        var token = atToken !== null && atToken !== void 0 ? atToken : this._lexer.token;
        return (0, $7ZXKi.syntaxError)(this._lexer.source, token.start, "Unexpected ".concat($62fd0a8327627af8$var$getTokenDesc(token), "."));
    } /**
   * Returns a possibly empty list of parse nodes, determined by the parseFn.
   * This list begins with a lex token of openKind and ends with a lex token of closeKind.
   * Advances the parser to the next lex token after the closing token.
   */ ;
    _proto.any = function any(openKind, parseFn, closeKind) {
        this.expectToken(openKind);
        var nodes = [];
        while(!this.expectOptionalToken(closeKind))nodes.push(parseFn.call(this));
        return nodes;
    } /**
   * Returns a list of parse nodes, determined by the parseFn.
   * It can be empty only if open token is missing otherwise it will always return non-empty list
   * that begins with a lex token of openKind and ends with a lex token of closeKind.
   * Advances the parser to the next lex token after the closing token.
   */ ;
    _proto.optionalMany = function optionalMany(openKind, parseFn, closeKind) {
        if (this.expectOptionalToken(openKind)) {
            var nodes = [];
            do nodes.push(parseFn.call(this));
            while (!this.expectOptionalToken(closeKind));
            return nodes;
        }
        return [];
    } /**
   * Returns a non-empty list of parse nodes, determined by the parseFn.
   * This list begins with a lex token of openKind and ends with a lex token of closeKind.
   * Advances the parser to the next lex token after the closing token.
   */ ;
    _proto.many = function many(openKind, parseFn, closeKind) {
        this.expectToken(openKind);
        var nodes = [];
        do nodes.push(parseFn.call(this));
        while (!this.expectOptionalToken(closeKind));
        return nodes;
    } /**
   * Returns a non-empty list of parse nodes, determined by the parseFn.
   * This list may begin with a lex token of delimiterKind followed by items separated by lex tokens of tokenKind.
   * Advances the parser to the next lex token after last item in the list.
   */ ;
    _proto.delimitedMany = function delimitedMany(delimiterKind, parseFn) {
        this.expectOptionalToken(delimiterKind);
        var nodes = [];
        do nodes.push(parseFn.call(this));
        while (this.expectOptionalToken(delimiterKind));
        return nodes;
    };
    return Parser;
}();
/**
 * A helper function to describe a token as a string for debugging.
 */ function $62fd0a8327627af8$var$getTokenDesc(token) {
    var value = token.value;
    return $62fd0a8327627af8$var$getTokenKindDesc(token.kind) + (value != null ? " \"".concat(value, "\"") : '');
}
/**
 * A helper function to describe a token kind as a string for debugging.
 */ function $62fd0a8327627af8$var$getTokenKindDesc(kind) {
    return (0, $jkcJk.isPunctuatorTokenKind)(kind) ? "\"".concat(kind, "\"") : kind;
}

});
parcelRegister("7ZXKi", function(module, exports) {

$parcel$export(module.exports, "syntaxError", () => $5d2c9324f08528ec$export$bbee0c6176c019d4);

var $g5yZB = parcelRequire("g5yZB");
function $5d2c9324f08528ec$export$bbee0c6176c019d4(source, position, description) {
    return new (0, $g5yZB.GraphQLError)("Syntax Error: ".concat(description), undefined, source, [
        position
    ]);
}

});
parcelRegister("g5yZB", function(module, exports) {

$parcel$export(module.exports, "GraphQLError", () => $bb6841c873fb42f5$export$92d6ed0888e7cb7f);

var $a1qmV = parcelRequire("a1qmV");

var $cJPdE = parcelRequire("cJPdE");

var $6DBwa = parcelRequire("6DBwa");

var $3DTMg = parcelRequire("3DTMg");

var $4Zjco = parcelRequire("4Zjco");
function $bb6841c873fb42f5$var$_typeof(obj) {
    "@babel/helpers - typeof";
    if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") $bb6841c873fb42f5$var$_typeof = function _typeof(obj) {
        return typeof obj;
    };
    else $bb6841c873fb42f5$var$_typeof = function _typeof(obj) {
        return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
    return $bb6841c873fb42f5$var$_typeof(obj);
}
function $bb6841c873fb42f5$var$ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        });
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function $bb6841c873fb42f5$var$_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        if (i % 2) $bb6841c873fb42f5$var$ownKeys(Object(source), true).forEach(function(key) {
            $bb6841c873fb42f5$var$_defineProperty(target, key, source[key]);
        });
        else if (Object.getOwnPropertyDescriptors) Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
        else $bb6841c873fb42f5$var$ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function $bb6841c873fb42f5$var$_defineProperty(obj, key, value) {
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $bb6841c873fb42f5$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function $bb6841c873fb42f5$var$_defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function $bb6841c873fb42f5$var$_createClass(Constructor, protoProps, staticProps) {
    if (protoProps) $bb6841c873fb42f5$var$_defineProperties(Constructor.prototype, protoProps);
    if (staticProps) $bb6841c873fb42f5$var$_defineProperties(Constructor, staticProps);
    return Constructor;
}
function $bb6841c873fb42f5$var$_inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function");
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            writable: true,
            configurable: true
        }
    });
    if (superClass) $bb6841c873fb42f5$var$_setPrototypeOf(subClass, superClass);
}
function $bb6841c873fb42f5$var$_createSuper(Derived) {
    var hasNativeReflectConstruct = $bb6841c873fb42f5$var$_isNativeReflectConstruct();
    return function _createSuperInternal() {
        var Super = $bb6841c873fb42f5$var$_getPrototypeOf(Derived), result;
        if (hasNativeReflectConstruct) {
            var NewTarget = $bb6841c873fb42f5$var$_getPrototypeOf(this).constructor;
            result = Reflect.construct(Super, arguments, NewTarget);
        } else result = Super.apply(this, arguments);
        return $bb6841c873fb42f5$var$_possibleConstructorReturn(this, result);
    };
}
function $bb6841c873fb42f5$var$_possibleConstructorReturn(self, call) {
    if (call && ($bb6841c873fb42f5$var$_typeof(call) === "object" || typeof call === "function")) return call;
    return $bb6841c873fb42f5$var$_assertThisInitialized(self);
}
function $bb6841c873fb42f5$var$_assertThisInitialized(self) {
    if (self === void 0) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return self;
}
function $bb6841c873fb42f5$var$_wrapNativeSuper(Class) {
    var _cache = typeof Map === "function" ? new Map() : undefined;
    $bb6841c873fb42f5$var$_wrapNativeSuper = function _wrapNativeSuper(Class) {
        if (Class === null || !$bb6841c873fb42f5$var$_isNativeFunction(Class)) return Class;
        if (typeof Class !== "function") throw new TypeError("Super expression must either be null or a function");
        if (typeof _cache !== "undefined") {
            if (_cache.has(Class)) return _cache.get(Class);
            _cache.set(Class, Wrapper);
        }
        function Wrapper() {
            return $bb6841c873fb42f5$var$_construct(Class, arguments, $bb6841c873fb42f5$var$_getPrototypeOf(this).constructor);
        }
        Wrapper.prototype = Object.create(Class.prototype, {
            constructor: {
                value: Wrapper,
                enumerable: false,
                writable: true,
                configurable: true
            }
        });
        return $bb6841c873fb42f5$var$_setPrototypeOf(Wrapper, Class);
    };
    return $bb6841c873fb42f5$var$_wrapNativeSuper(Class);
}
function $bb6841c873fb42f5$var$_construct(Parent, args, Class) {
    if ($bb6841c873fb42f5$var$_isNativeReflectConstruct()) $bb6841c873fb42f5$var$_construct = Reflect.construct;
    else $bb6841c873fb42f5$var$_construct = function _construct(Parent, args, Class) {
        var a = [
            null
        ];
        a.push.apply(a, args);
        var Constructor = Function.bind.apply(Parent, a);
        var instance = new Constructor();
        if (Class) $bb6841c873fb42f5$var$_setPrototypeOf(instance, Class.prototype);
        return instance;
    };
    return $bb6841c873fb42f5$var$_construct.apply(null, arguments);
}
function $bb6841c873fb42f5$var$_isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
        Date.prototype.toString.call(Reflect.construct(Date, [], function() {}));
        return true;
    } catch (e) {
        return false;
    }
}
function $bb6841c873fb42f5$var$_isNativeFunction(fn) {
    return Function.toString.call(fn).indexOf("[native code]") !== -1;
}
function $bb6841c873fb42f5$var$_setPrototypeOf(o, p) {
    $bb6841c873fb42f5$var$_setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return $bb6841c873fb42f5$var$_setPrototypeOf(o, p);
}
function $bb6841c873fb42f5$var$_getPrototypeOf(o) {
    $bb6841c873fb42f5$var$_getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
    };
    return $bb6841c873fb42f5$var$_getPrototypeOf(o);
}
var $bb6841c873fb42f5$export$92d6ed0888e7cb7f = /*#__PURE__*/ function(_Error) {
    $bb6841c873fb42f5$var$_inherits(GraphQLError, _Error);
    var _super = $bb6841c873fb42f5$var$_createSuper(GraphQLError);
    /**
   * An array of { line, column } locations within the source GraphQL document
   * which correspond to this error.
   *
   * Errors during validation often contain multiple locations, for example to
   * point out two things with the same name. Errors during execution include a
   * single location, the field which produced the error.
   *
   * Enumerable, and appears in the result of JSON.stringify().
   */ /**
   * An array describing the JSON-path into the execution response which
   * corresponds to this error. Only included for errors during execution.
   *
   * Enumerable, and appears in the result of JSON.stringify().
   */ /**
   * An array of GraphQL AST Nodes corresponding to this error.
   */ /**
   * The source GraphQL document for the first location of this error.
   *
   * Note that if this Error represents more than one node, the source may not
   * represent nodes after the first node.
   */ /**
   * An array of character offsets within the source GraphQL document
   * which correspond to this error.
   */ /**
   * The original error thrown from a field resolver during execution.
   */ /**
   * Extension fields to add to the formatted error.
   */ function GraphQLError(message, nodes, source, positions, path, originalError, extensions) {
        var _nodeLocations, _nodeLocations2, _nodeLocations3;
        var _this;
        $bb6841c873fb42f5$var$_classCallCheck(this, GraphQLError);
        _this = _super.call(this, message);
        _this.name = 'GraphQLError';
        _this.originalError = originalError !== null && originalError !== void 0 ? originalError : undefined; // Compute list of blame nodes.
        _this.nodes = $bb6841c873fb42f5$var$undefinedIfEmpty(Array.isArray(nodes) ? nodes : nodes ? [
            nodes
        ] : undefined);
        var nodeLocations = [];
        for(var _i2 = 0, _ref3 = (_this$nodes = _this.nodes) !== null && _this$nodes !== void 0 ? _this$nodes : []; _i2 < _ref3.length; _i2++){
            var _this$nodes;
            var _ref4 = _ref3[_i2];
            var loc = _ref4.loc;
            if (loc != null) nodeLocations.push(loc);
        }
        nodeLocations = $bb6841c873fb42f5$var$undefinedIfEmpty(nodeLocations); // Compute locations in the source for the given nodes/positions.
        _this.source = source !== null && source !== void 0 ? source : (_nodeLocations = nodeLocations) === null || _nodeLocations === void 0 ? void 0 : _nodeLocations[0].source;
        _this.positions = positions !== null && positions !== void 0 ? positions : (_nodeLocations2 = nodeLocations) === null || _nodeLocations2 === void 0 ? void 0 : _nodeLocations2.map(function(loc) {
            return loc.start;
        });
        _this.locations = positions && source ? positions.map(function(pos) {
            return (0, $3DTMg.getLocation)(source, pos);
        }) : (_nodeLocations3 = nodeLocations) === null || _nodeLocations3 === void 0 ? void 0 : _nodeLocations3.map(function(loc) {
            return (0, $3DTMg.getLocation)(loc.source, loc.start);
        });
        _this.path = path !== null && path !== void 0 ? path : undefined;
        var originalExtensions = originalError === null || originalError === void 0 ? void 0 : originalError.extensions;
        if (extensions == null && (0, $cJPdE.default)(originalExtensions)) _this.extensions = $bb6841c873fb42f5$var$_objectSpread({}, originalExtensions);
        else _this.extensions = extensions !== null && extensions !== void 0 ? extensions : {};
         // By being enumerable, JSON.stringify will include bellow properties in the resulting output.
        // This ensures that the simplest possible GraphQL service adheres to the spec.
        Object.defineProperties($bb6841c873fb42f5$var$_assertThisInitialized(_this), {
            message: {
                enumerable: true
            },
            locations: {
                enumerable: _this.locations != null
            },
            path: {
                enumerable: _this.path != null
            },
            extensions: {
                enumerable: _this.extensions != null && Object.keys(_this.extensions).length > 0
            },
            name: {
                enumerable: false
            },
            nodes: {
                enumerable: false
            },
            source: {
                enumerable: false
            },
            positions: {
                enumerable: false
            },
            originalError: {
                enumerable: false
            }
        }); // Include (non-enumerable) stack trace.
        if (originalError !== null && originalError !== void 0 && originalError.stack) {
            Object.defineProperty($bb6841c873fb42f5$var$_assertThisInitialized(_this), 'stack', {
                value: originalError.stack,
                writable: true,
                configurable: true
            });
            return $bb6841c873fb42f5$var$_possibleConstructorReturn(_this);
        } // istanbul ignore next (See: 'https://github.com/graphql/graphql-js/issues/2317')
        if (Error.captureStackTrace) Error.captureStackTrace($bb6841c873fb42f5$var$_assertThisInitialized(_this), GraphQLError);
        else Object.defineProperty($bb6841c873fb42f5$var$_assertThisInitialized(_this), 'stack', {
            value: Error().stack,
            writable: true,
            configurable: true
        });
        return _this;
    }
    $bb6841c873fb42f5$var$_createClass(GraphQLError, [
        {
            key: "toString",
            value: function toString() {
                return $bb6841c873fb42f5$export$55ee1551a3f962e6(this);
            }
        },
        {
            key: "toJSON",
            value: function toJSON() {
                return $bb6841c873fb42f5$export$7b5b869ee98c16ab(this);
            } // FIXME: workaround to not break chai comparisons, should be remove in v16
        },
        {
            key: (0, $6DBwa.SYMBOL_TO_STRING_TAG),
            get: function get() {
                return 'Object';
            }
        }
    ]);
    return GraphQLError;
}(/*#__PURE__*/ $bb6841c873fb42f5$var$_wrapNativeSuper(Error));
function $bb6841c873fb42f5$var$undefinedIfEmpty(array) {
    return array === undefined || array.length === 0 ? undefined : array;
}
function $bb6841c873fb42f5$export$55ee1551a3f962e6(error) {
    var output = error.message;
    if (error.nodes) for(var _i4 = 0, _error$nodes2 = error.nodes; _i4 < _error$nodes2.length; _i4++){
        var node = _error$nodes2[_i4];
        if (node.loc) output += '\n\n' + (0, $4Zjco.printLocation)(node.loc);
    }
    else if (error.source && error.locations) for(var _i6 = 0, _error$locations2 = error.locations; _i6 < _error$locations2.length; _i6++){
        var location = _error$locations2[_i6];
        output += '\n\n' + (0, $4Zjco.printSourceLocation)(error.source, location);
    }
    return output;
}
function $bb6841c873fb42f5$export$7b5b869ee98c16ab(error) {
    var _error$message;
    error || (0, $a1qmV.default)(0, 'Received null or undefined error.');
    var message = (_error$message = error.message) !== null && _error$message !== void 0 ? _error$message : 'An unknown error occurred.';
    var locations = error.locations;
    var path = error.path;
    var extensions = error.extensions;
    return extensions && Object.keys(extensions).length > 0 ? {
        message: message,
        locations: locations,
        path: path,
        extensions: extensions
    } : {
        message: message,
        locations: locations,
        path: path
    };
} /**
 * @see https://github.com/graphql/graphql-spec/blob/master/spec/Section%207%20--%20Response.md#errors
 */ 

});
parcelRegister("a1qmV", function(module, exports) {

$parcel$export(module.exports, "default", () => $74be73ae076c40a2$export$2e2bcd8739ae039);
function $74be73ae076c40a2$export$2e2bcd8739ae039(condition, message) {
    var booleanCondition = Boolean(condition); // istanbul ignore else (See transformation done in './resources/inlineInvariant.js')
    if (!booleanCondition) throw new Error(message);
}

});

parcelRegister("cJPdE", function(module, exports) {

$parcel$export(module.exports, "default", () => $94616b0c7295e50a$export$2e2bcd8739ae039);
function $94616b0c7295e50a$var$_typeof(obj) {
    "@babel/helpers - typeof";
    if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") $94616b0c7295e50a$var$_typeof = function _typeof(obj) {
        return typeof obj;
    };
    else $94616b0c7295e50a$var$_typeof = function _typeof(obj) {
        return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
    return $94616b0c7295e50a$var$_typeof(obj);
}
function $94616b0c7295e50a$export$2e2bcd8739ae039(value) {
    return $94616b0c7295e50a$var$_typeof(value) == 'object' && value !== null;
}

});

parcelRegister("6DBwa", function(module, exports) {

$parcel$export(module.exports, "SYMBOL_TO_STRING_TAG", () => $4d537cd703fb8e64$export$5deadc579ccc7c9c);
// In ES2015 (or a polyfilled) environment, this will be Symbol.iterator
// istanbul ignore next (See: 'https://github.com/graphql/graphql-js/issues/2317')
var $4d537cd703fb8e64$export$f6cdee3c26d6da57 = typeof Symbol === 'function' && Symbol.iterator != null ? Symbol.iterator : '@@iterator'; // In ES2017 (or a polyfilled) environment, this will be Symbol.asyncIterator
var $4d537cd703fb8e64$export$8d0083df0471478e = typeof Symbol === 'function' && Symbol.asyncIterator != null ? Symbol.asyncIterator : '@@asyncIterator'; // istanbul ignore next (See: 'https://github.com/graphql/graphql-js/issues/2317')
var $4d537cd703fb8e64$export$5deadc579ccc7c9c = typeof Symbol === 'function' && Symbol.toStringTag != null ? Symbol.toStringTag : '@@toStringTag';

});

parcelRegister("3DTMg", function(module, exports) {

$parcel$export(module.exports, "getLocation", () => $2a7047dfe88e1e3e$export$e7fd20fad3cf4b5f);
/**
 * Represents a location in a Source.
 */ /**
 * Takes a Source and a UTF-8 character offset, and returns the corresponding
 * line and column as a SourceLocation.
 */ function $2a7047dfe88e1e3e$export$e7fd20fad3cf4b5f(source, position) {
    var lineRegexp = /\r\n|[\n\r]/g;
    var line = 1;
    var column = position + 1;
    var match;
    while((match = lineRegexp.exec(source.body)) && match.index < position){
        line += 1;
        column = position + 1 - (match.index + match[0].length);
    }
    return {
        line: line,
        column: column
    };
}

});

parcelRegister("4Zjco", function(module, exports) {

$parcel$export(module.exports, "printLocation", () => $3a1bc06740b7fb42$export$96a9681e539deed);
$parcel$export(module.exports, "printSourceLocation", () => $3a1bc06740b7fb42$export$867940333fd9f869);

var $3DTMg = parcelRequire("3DTMg");
function $3a1bc06740b7fb42$export$96a9681e539deed(location) {
    return $3a1bc06740b7fb42$export$867940333fd9f869(location.source, (0, $3DTMg.getLocation)(location.source, location.start));
}
function $3a1bc06740b7fb42$export$867940333fd9f869(source, sourceLocation) {
    var firstLineColumnOffset = source.locationOffset.column - 1;
    var body = $3a1bc06740b7fb42$var$whitespace(firstLineColumnOffset) + source.body;
    var lineIndex = sourceLocation.line - 1;
    var lineOffset = source.locationOffset.line - 1;
    var lineNum = sourceLocation.line + lineOffset;
    var columnOffset = sourceLocation.line === 1 ? firstLineColumnOffset : 0;
    var columnNum = sourceLocation.column + columnOffset;
    var locationStr = "".concat(source.name, ":").concat(lineNum, ":").concat(columnNum, "\n");
    var lines = body.split(/\r\n|[\n\r]/g);
    var locationLine = lines[lineIndex]; // Special case for minified documents
    if (locationLine.length > 120) {
        var subLineIndex = Math.floor(columnNum / 80);
        var subLineColumnNum = columnNum % 80;
        var subLines = [];
        for(var i = 0; i < locationLine.length; i += 80)subLines.push(locationLine.slice(i, i + 80));
        return locationStr + $3a1bc06740b7fb42$var$printPrefixedLines([
            [
                "".concat(lineNum),
                subLines[0]
            ]
        ].concat(subLines.slice(1, subLineIndex + 1).map(function(subLine) {
            return [
                '',
                subLine
            ];
        }), [
            [
                ' ',
                $3a1bc06740b7fb42$var$whitespace(subLineColumnNum - 1) + '^'
            ],
            [
                '',
                subLines[subLineIndex + 1]
            ]
        ]));
    }
    return locationStr + $3a1bc06740b7fb42$var$printPrefixedLines([
        [
            "".concat(lineNum - 1),
            lines[lineIndex - 1]
        ],
        [
            "".concat(lineNum),
            locationLine
        ],
        [
            '',
            $3a1bc06740b7fb42$var$whitespace(columnNum - 1) + '^'
        ],
        [
            "".concat(lineNum + 1),
            lines[lineIndex + 1]
        ]
    ]);
}
function $3a1bc06740b7fb42$var$printPrefixedLines(lines) {
    var existingLines = lines.filter(function(_ref) {
        var _ = _ref[0], line = _ref[1];
        return line !== undefined;
    });
    var padLen = Math.max.apply(Math, existingLines.map(function(_ref2) {
        var prefix = _ref2[0];
        return prefix.length;
    }));
    return existingLines.map(function(_ref3) {
        var prefix = _ref3[0], line = _ref3[1];
        return $3a1bc06740b7fb42$var$leftPad(padLen, prefix) + (line ? ' | ' + line : ' |');
    }).join('\n');
}
function $3a1bc06740b7fb42$var$whitespace(len) {
    return Array(len + 1).join(' ');
}
function $3a1bc06740b7fb42$var$leftPad(len, str) {
    return $3a1bc06740b7fb42$var$whitespace(len - str.length) + str;
}

});



parcelRegister("bzIlO", function(module, exports) {

$parcel$export(module.exports, "Kind", () => $86d55dbd37d1d598$export$a84bdc57c5122798);
/**
 * The set of allowed kind values for AST nodes.
 */ var $86d55dbd37d1d598$export$a84bdc57c5122798 = Object.freeze({
    // Name
    NAME: 'Name',
    // Document
    DOCUMENT: 'Document',
    OPERATION_DEFINITION: 'OperationDefinition',
    VARIABLE_DEFINITION: 'VariableDefinition',
    SELECTION_SET: 'SelectionSet',
    FIELD: 'Field',
    ARGUMENT: 'Argument',
    // Fragments
    FRAGMENT_SPREAD: 'FragmentSpread',
    INLINE_FRAGMENT: 'InlineFragment',
    FRAGMENT_DEFINITION: 'FragmentDefinition',
    // Values
    VARIABLE: 'Variable',
    INT: 'IntValue',
    FLOAT: 'FloatValue',
    STRING: 'StringValue',
    BOOLEAN: 'BooleanValue',
    NULL: 'NullValue',
    ENUM: 'EnumValue',
    LIST: 'ListValue',
    OBJECT: 'ObjectValue',
    OBJECT_FIELD: 'ObjectField',
    // Directives
    DIRECTIVE: 'Directive',
    // Types
    NAMED_TYPE: 'NamedType',
    LIST_TYPE: 'ListType',
    NON_NULL_TYPE: 'NonNullType',
    // Type System Definitions
    SCHEMA_DEFINITION: 'SchemaDefinition',
    OPERATION_TYPE_DEFINITION: 'OperationTypeDefinition',
    // Type Definitions
    SCALAR_TYPE_DEFINITION: 'ScalarTypeDefinition',
    OBJECT_TYPE_DEFINITION: 'ObjectTypeDefinition',
    FIELD_DEFINITION: 'FieldDefinition',
    INPUT_VALUE_DEFINITION: 'InputValueDefinition',
    INTERFACE_TYPE_DEFINITION: 'InterfaceTypeDefinition',
    UNION_TYPE_DEFINITION: 'UnionTypeDefinition',
    ENUM_TYPE_DEFINITION: 'EnumTypeDefinition',
    ENUM_VALUE_DEFINITION: 'EnumValueDefinition',
    INPUT_OBJECT_TYPE_DEFINITION: 'InputObjectTypeDefinition',
    // Directive Definitions
    DIRECTIVE_DEFINITION: 'DirectiveDefinition',
    // Type System Extensions
    SCHEMA_EXTENSION: 'SchemaExtension',
    // Type Extensions
    SCALAR_TYPE_EXTENSION: 'ScalarTypeExtension',
    OBJECT_TYPE_EXTENSION: 'ObjectTypeExtension',
    INTERFACE_TYPE_EXTENSION: 'InterfaceTypeExtension',
    UNION_TYPE_EXTENSION: 'UnionTypeExtension',
    ENUM_TYPE_EXTENSION: 'EnumTypeExtension',
    INPUT_OBJECT_TYPE_EXTENSION: 'InputObjectTypeExtension'
}); /**
 * The enum type representing the possible kind values of AST nodes.
 */ 

});

parcelRegister("2z7TS", function(module, exports) {

$parcel$export(module.exports, "TokenKind", () => $1de4fa7b8080613f$export$8b9d26ab11394711);
/**
 * An exported enum describing the different kinds of tokens that the
 * lexer emits.
 */ var $1de4fa7b8080613f$export$8b9d26ab11394711 = Object.freeze({
    SOF: '<SOF>',
    EOF: '<EOF>',
    BANG: '!',
    DOLLAR: '$',
    AMP: '&',
    PAREN_L: '(',
    PAREN_R: ')',
    SPREAD: '...',
    COLON: ':',
    EQUALS: '=',
    AT: '@',
    BRACKET_L: '[',
    BRACKET_R: ']',
    BRACE_L: '{',
    PIPE: '|',
    BRACE_R: '}',
    NAME: 'Name',
    INT: 'Int',
    FLOAT: 'Float',
    STRING: 'String',
    BLOCK_STRING: 'BlockString',
    COMMENT: 'Comment'
}); /**
 * The enum type representing the token kinds values.
 */ 

});

parcelRegister("6vk4Q", function(module, exports) {

$parcel$export(module.exports, "Source", () => $4bc536350d5671b9$export$1d2df86270c81ecb);
$parcel$export(module.exports, "isSource", () => $4bc536350d5671b9$export$75135ee9ed6e435b);

var $6DBwa = parcelRequire("6DBwa");

var $yEDl8 = parcelRequire("yEDl8");

var $a1qmV = parcelRequire("a1qmV");

var $6B4dU = parcelRequire("6B4dU");
function $4bc536350d5671b9$var$_defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function $4bc536350d5671b9$var$_createClass(Constructor, protoProps, staticProps) {
    if (protoProps) $4bc536350d5671b9$var$_defineProperties(Constructor.prototype, protoProps);
    if (staticProps) $4bc536350d5671b9$var$_defineProperties(Constructor, staticProps);
    return Constructor;
}
var $4bc536350d5671b9$export$1d2df86270c81ecb = /*#__PURE__*/ function() {
    function Source(body) {
        var name = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'GraphQL request';
        var locationOffset = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {
            line: 1,
            column: 1
        };
        typeof body === 'string' || (0, $a1qmV.default)(0, "Body must be a string. Received: ".concat((0, $yEDl8.default)(body), "."));
        this.body = body;
        this.name = name;
        this.locationOffset = locationOffset;
        this.locationOffset.line > 0 || (0, $a1qmV.default)(0, 'line in locationOffset is 1-indexed and must be positive.');
        this.locationOffset.column > 0 || (0, $a1qmV.default)(0, 'column in locationOffset is 1-indexed and must be positive.');
    } // $FlowFixMe[unsupported-syntax] Flow doesn't support computed properties yet
    $4bc536350d5671b9$var$_createClass(Source, [
        {
            key: (0, $6DBwa.SYMBOL_TO_STRING_TAG),
            get: function get() {
                return 'Source';
            }
        }
    ]);
    return Source;
}();
function $4bc536350d5671b9$export$75135ee9ed6e435b(source) {
    return (0, $6B4dU.default)(source, $4bc536350d5671b9$export$1d2df86270c81ecb);
}

});
parcelRegister("6B4dU", function(module, exports) {

$parcel$export(module.exports, "default", () => $4cd9796d6ab57d14$export$2e2bcd8739ae039);

function $4cd9796d6ab57d14$var$_typeof(obj) {
    "@babel/helpers - typeof";
    if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") $4cd9796d6ab57d14$var$_typeof = function _typeof(obj) {
        return typeof obj;
    };
    else $4cd9796d6ab57d14$var$_typeof = function _typeof(obj) {
        return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
    return $4cd9796d6ab57d14$var$_typeof(obj);
}
var /**
 * A replacement for instanceof which includes an error warning when multi-realm
 * constructors are detected.
 */ // See: https://expressjs.com/en/advanced/best-practice-performance.html#set-node_env-to-production
// See: https://webpack.js.org/guides/production/
$4cd9796d6ab57d14$export$2e2bcd8739ae039 = // eslint-disable-next-line no-shadow
function instanceOf(value, constructor) {
    return value instanceof constructor;
};

});


parcelRegister("jADQJ", function(module, exports) {

$parcel$export(module.exports, "DirectiveLocation", () => $e4304a67ae3cac6f$export$b45ffd2948484c41);
/**
 * The set of allowed directive location values.
 */ var $e4304a67ae3cac6f$export$b45ffd2948484c41 = Object.freeze({
    // Request Definitions
    QUERY: 'QUERY',
    MUTATION: 'MUTATION',
    SUBSCRIPTION: 'SUBSCRIPTION',
    FIELD: 'FIELD',
    FRAGMENT_DEFINITION: 'FRAGMENT_DEFINITION',
    FRAGMENT_SPREAD: 'FRAGMENT_SPREAD',
    INLINE_FRAGMENT: 'INLINE_FRAGMENT',
    VARIABLE_DEFINITION: 'VARIABLE_DEFINITION',
    // Type System Definitions
    SCHEMA: 'SCHEMA',
    SCALAR: 'SCALAR',
    OBJECT: 'OBJECT',
    FIELD_DEFINITION: 'FIELD_DEFINITION',
    ARGUMENT_DEFINITION: 'ARGUMENT_DEFINITION',
    INTERFACE: 'INTERFACE',
    UNION: 'UNION',
    ENUM: 'ENUM',
    ENUM_VALUE: 'ENUM_VALUE',
    INPUT_OBJECT: 'INPUT_OBJECT',
    INPUT_FIELD_DEFINITION: 'INPUT_FIELD_DEFINITION'
}); /**
 * The enum type representing the directive location values.
 */ 

});

parcelRegister("jkcJk", function(module, exports) {

$parcel$export(module.exports, "Lexer", () => $e119c27db9a87f5b$export$6168dc8908a6c652);
$parcel$export(module.exports, "isPunctuatorTokenKind", () => $e119c27db9a87f5b$export$59ac0f4da287406a);

var $7ZXKi = parcelRequire("7ZXKi");

var $98oUl = parcelRequire("98oUl");

var $2z7TS = parcelRequire("2z7TS");

var $541Mz = parcelRequire("541Mz");
var $e119c27db9a87f5b$export$6168dc8908a6c652 = /*#__PURE__*/ function() {
    /**
   * The previously focused non-ignored token.
   */ /**
   * The currently focused non-ignored token.
   */ /**
   * The (1-indexed) line containing the current token.
   */ /**
   * The character offset at which the current line begins.
   */ function Lexer(source) {
        var startOfFileToken = new (0, $98oUl.Token)((0, $2z7TS.TokenKind).SOF, 0, 0, 0, 0, null);
        this.source = source;
        this.lastToken = startOfFileToken;
        this.token = startOfFileToken;
        this.line = 1;
        this.lineStart = 0;
    }
    /**
   * Advances the token stream to the next non-ignored token.
   */ var _proto = Lexer.prototype;
    _proto.advance = function advance() {
        this.lastToken = this.token;
        var token = this.token = this.lookahead();
        return token;
    } /**
   * Looks ahead and returns the next non-ignored token, but does not change
   * the state of Lexer.
   */ ;
    _proto.lookahead = function lookahead() {
        var token = this.token;
        if (token.kind !== (0, $2z7TS.TokenKind).EOF) do {
            var _token$next;
            // Note: next is only mutable during parsing, so we cast to allow this.
            token = (_token$next = token.next) !== null && _token$next !== void 0 ? _token$next : token.next = $e119c27db9a87f5b$var$readToken(this, token);
        }while (token.kind === (0, $2z7TS.TokenKind).COMMENT);
        return token;
    };
    return Lexer;
}();
function $e119c27db9a87f5b$export$59ac0f4da287406a(kind) {
    return kind === (0, $2z7TS.TokenKind).BANG || kind === (0, $2z7TS.TokenKind).DOLLAR || kind === (0, $2z7TS.TokenKind).AMP || kind === (0, $2z7TS.TokenKind).PAREN_L || kind === (0, $2z7TS.TokenKind).PAREN_R || kind === (0, $2z7TS.TokenKind).SPREAD || kind === (0, $2z7TS.TokenKind).COLON || kind === (0, $2z7TS.TokenKind).EQUALS || kind === (0, $2z7TS.TokenKind).AT || kind === (0, $2z7TS.TokenKind).BRACKET_L || kind === (0, $2z7TS.TokenKind).BRACKET_R || kind === (0, $2z7TS.TokenKind).BRACE_L || kind === (0, $2z7TS.TokenKind).PIPE || kind === (0, $2z7TS.TokenKind).BRACE_R;
}
function $e119c27db9a87f5b$var$printCharCode(code) {
    return isNaN(code) ? (0, $2z7TS.TokenKind).EOF : code < 0x007f ? JSON.stringify(String.fromCharCode(code)) : "\"\\u".concat(('00' + code.toString(16).toUpperCase()).slice(-4), "\"");
}
/**
 * Gets the next token from the source starting at the given position.
 *
 * This skips over whitespace until it finds the next lexable token, then lexes
 * punctuators immediately or calls the appropriate helper function for more
 * complicated tokens.
 */ function $e119c27db9a87f5b$var$readToken(lexer, prev) {
    var source = lexer.source;
    var body = source.body;
    var bodyLength = body.length;
    var pos = prev.end;
    while(pos < bodyLength){
        var code = body.charCodeAt(pos);
        var _line = lexer.line;
        var _col = 1 + pos - lexer.lineStart; // SourceCharacter
        switch(code){
            case 0xfeff:
            case 9:
            case 32:
            case 44:
                //  ,
                ++pos;
                continue;
            case 10:
                //  \n
                ++pos;
                ++lexer.line;
                lexer.lineStart = pos;
                continue;
            case 13:
                //  \r
                if (body.charCodeAt(pos + 1) === 10) pos += 2;
                else ++pos;
                ++lexer.line;
                lexer.lineStart = pos;
                continue;
            case 33:
                //  !
                return new (0, $98oUl.Token)((0, $2z7TS.TokenKind).BANG, pos, pos + 1, _line, _col, prev);
            case 35:
                //  #
                return $e119c27db9a87f5b$var$readComment(source, pos, _line, _col, prev);
            case 36:
                //  $
                return new (0, $98oUl.Token)((0, $2z7TS.TokenKind).DOLLAR, pos, pos + 1, _line, _col, prev);
            case 38:
                //  &
                return new (0, $98oUl.Token)((0, $2z7TS.TokenKind).AMP, pos, pos + 1, _line, _col, prev);
            case 40:
                //  (
                return new (0, $98oUl.Token)((0, $2z7TS.TokenKind).PAREN_L, pos, pos + 1, _line, _col, prev);
            case 41:
                //  )
                return new (0, $98oUl.Token)((0, $2z7TS.TokenKind).PAREN_R, pos, pos + 1, _line, _col, prev);
            case 46:
                //  .
                if (body.charCodeAt(pos + 1) === 46 && body.charCodeAt(pos + 2) === 46) return new (0, $98oUl.Token)((0, $2z7TS.TokenKind).SPREAD, pos, pos + 3, _line, _col, prev);
                break;
            case 58:
                //  :
                return new (0, $98oUl.Token)((0, $2z7TS.TokenKind).COLON, pos, pos + 1, _line, _col, prev);
            case 61:
                //  =
                return new (0, $98oUl.Token)((0, $2z7TS.TokenKind).EQUALS, pos, pos + 1, _line, _col, prev);
            case 64:
                //  @
                return new (0, $98oUl.Token)((0, $2z7TS.TokenKind).AT, pos, pos + 1, _line, _col, prev);
            case 91:
                //  [
                return new (0, $98oUl.Token)((0, $2z7TS.TokenKind).BRACKET_L, pos, pos + 1, _line, _col, prev);
            case 93:
                //  ]
                return new (0, $98oUl.Token)((0, $2z7TS.TokenKind).BRACKET_R, pos, pos + 1, _line, _col, prev);
            case 123:
                // {
                return new (0, $98oUl.Token)((0, $2z7TS.TokenKind).BRACE_L, pos, pos + 1, _line, _col, prev);
            case 124:
                // |
                return new (0, $98oUl.Token)((0, $2z7TS.TokenKind).PIPE, pos, pos + 1, _line, _col, prev);
            case 125:
                // }
                return new (0, $98oUl.Token)((0, $2z7TS.TokenKind).BRACE_R, pos, pos + 1, _line, _col, prev);
            case 34:
                //  "
                if (body.charCodeAt(pos + 1) === 34 && body.charCodeAt(pos + 2) === 34) return $e119c27db9a87f5b$var$readBlockString(source, pos, _line, _col, prev, lexer);
                return $e119c27db9a87f5b$var$readString(source, pos, _line, _col, prev);
            case 45:
            case 48:
            case 49:
            case 50:
            case 51:
            case 52:
            case 53:
            case 54:
            case 55:
            case 56:
            case 57:
                //  9
                return $e119c27db9a87f5b$var$readNumber(source, pos, code, _line, _col, prev);
            case 65:
            case 66:
            case 67:
            case 68:
            case 69:
            case 70:
            case 71:
            case 72:
            case 73:
            case 74:
            case 75:
            case 76:
            case 77:
            case 78:
            case 79:
            case 80:
            case 81:
            case 82:
            case 83:
            case 84:
            case 85:
            case 86:
            case 87:
            case 88:
            case 89:
            case 90:
            case 95:
            case 97:
            case 98:
            case 99:
            case 100:
            case 101:
            case 102:
            case 103:
            case 104:
            case 105:
            case 106:
            case 107:
            case 108:
            case 109:
            case 110:
            case 111:
            case 112:
            case 113:
            case 114:
            case 115:
            case 116:
            case 117:
            case 118:
            case 119:
            case 120:
            case 121:
            case 122:
                // z
                return $e119c27db9a87f5b$var$readName(source, pos, _line, _col, prev);
        }
        throw (0, $7ZXKi.syntaxError)(source, pos, $e119c27db9a87f5b$var$unexpectedCharacterMessage(code));
    }
    var line = lexer.line;
    var col = 1 + pos - lexer.lineStart;
    return new (0, $98oUl.Token)((0, $2z7TS.TokenKind).EOF, bodyLength, bodyLength, line, col, prev);
}
/**
 * Report a message that an unexpected character was encountered.
 */ function $e119c27db9a87f5b$var$unexpectedCharacterMessage(code) {
    if (code < 0x0020 && code !== 0x0009 && code !== 0x000a && code !== 0x000d) return "Cannot contain the invalid character ".concat($e119c27db9a87f5b$var$printCharCode(code), ".");
    if (code === 39) // '
    return 'Unexpected single quote character (\'), did you mean to use a double quote (")?';
    return "Cannot parse the unexpected character ".concat($e119c27db9a87f5b$var$printCharCode(code), ".");
}
/**
 * Reads a comment token from the source file.
 *
 * #[\u0009\u0020-\uFFFF]*
 */ function $e119c27db9a87f5b$var$readComment(source, start, line, col, prev) {
    var body = source.body;
    var code;
    var position = start;
    do code = body.charCodeAt(++position);
    while (!isNaN(code) && (code > 0x001f || code === 0x0009));
    return new (0, $98oUl.Token)((0, $2z7TS.TokenKind).COMMENT, start, position, line, col, prev, body.slice(start + 1, position));
}
/**
 * Reads a number token from the source file, either a float
 * or an int depending on whether a decimal point appears.
 *
 * Int:   -?(0|[1-9][0-9]*)
 * Float: -?(0|[1-9][0-9]*)(\.[0-9]+)?((E|e)(+|-)?[0-9]+)?
 */ function $e119c27db9a87f5b$var$readNumber(source, start, firstCode, line, col, prev) {
    var body = source.body;
    var code = firstCode;
    var position = start;
    var isFloat = false;
    if (code === 45) // -
    code = body.charCodeAt(++position);
    if (code === 48) {
        // 0
        code = body.charCodeAt(++position);
        if (code >= 48 && code <= 57) throw (0, $7ZXKi.syntaxError)(source, position, "Invalid number, unexpected digit after 0: ".concat($e119c27db9a87f5b$var$printCharCode(code), "."));
    } else {
        position = $e119c27db9a87f5b$var$readDigits(source, position, code);
        code = body.charCodeAt(position);
    }
    if (code === 46) {
        // .
        isFloat = true;
        code = body.charCodeAt(++position);
        position = $e119c27db9a87f5b$var$readDigits(source, position, code);
        code = body.charCodeAt(position);
    }
    if (code === 69 || code === 101) {
        // E e
        isFloat = true;
        code = body.charCodeAt(++position);
        if (code === 43 || code === 45) // + -
        code = body.charCodeAt(++position);
        position = $e119c27db9a87f5b$var$readDigits(source, position, code);
        code = body.charCodeAt(position);
    } // Numbers cannot be followed by . or NameStart
    if (code === 46 || $e119c27db9a87f5b$var$isNameStart(code)) throw (0, $7ZXKi.syntaxError)(source, position, "Invalid number, expected digit but got: ".concat($e119c27db9a87f5b$var$printCharCode(code), "."));
    return new (0, $98oUl.Token)(isFloat ? (0, $2z7TS.TokenKind).FLOAT : (0, $2z7TS.TokenKind).INT, start, position, line, col, prev, body.slice(start, position));
}
/**
 * Returns the new position in the source after reading digits.
 */ function $e119c27db9a87f5b$var$readDigits(source, start, firstCode) {
    var body = source.body;
    var position = start;
    var code = firstCode;
    if (code >= 48 && code <= 57) {
        // 0 - 9
        do code = body.charCodeAt(++position);
        while (code >= 48 && code <= 57); // 0 - 9
        return position;
    }
    throw (0, $7ZXKi.syntaxError)(source, position, "Invalid number, expected digit but got: ".concat($e119c27db9a87f5b$var$printCharCode(code), "."));
}
/**
 * Reads a string token from the source file.
 *
 * "([^"\\\u000A\u000D]|(\\(u[0-9a-fA-F]{4}|["\\/bfnrt])))*"
 */ function $e119c27db9a87f5b$var$readString(source, start, line, col, prev) {
    var body = source.body;
    var position = start + 1;
    var chunkStart = position;
    var code = 0;
    var value = '';
    while(position < body.length && !isNaN(code = body.charCodeAt(position)) && // not LineTerminator
    code !== 0x000a && code !== 0x000d){
        // Closing Quote (")
        if (code === 34) {
            value += body.slice(chunkStart, position);
            return new (0, $98oUl.Token)((0, $2z7TS.TokenKind).STRING, start, position + 1, line, col, prev, value);
        } // SourceCharacter
        if (code < 0x0020 && code !== 0x0009) throw (0, $7ZXKi.syntaxError)(source, position, "Invalid character within String: ".concat($e119c27db9a87f5b$var$printCharCode(code), "."));
        ++position;
        if (code === 92) {
            // \
            value += body.slice(chunkStart, position - 1);
            code = body.charCodeAt(position);
            switch(code){
                case 34:
                    value += '"';
                    break;
                case 47:
                    value += '/';
                    break;
                case 92:
                    value += '\\';
                    break;
                case 98:
                    value += '\b';
                    break;
                case 102:
                    value += '\f';
                    break;
                case 110:
                    value += '\n';
                    break;
                case 114:
                    value += '\r';
                    break;
                case 116:
                    value += '\t';
                    break;
                case 117:
                    // uXXXX
                    var charCode = $e119c27db9a87f5b$var$uniCharCode(body.charCodeAt(position + 1), body.charCodeAt(position + 2), body.charCodeAt(position + 3), body.charCodeAt(position + 4));
                    if (charCode < 0) {
                        var invalidSequence = body.slice(position + 1, position + 5);
                        throw (0, $7ZXKi.syntaxError)(source, position, "Invalid character escape sequence: \\u".concat(invalidSequence, "."));
                    }
                    value += String.fromCharCode(charCode);
                    position += 4;
                    break;
                default:
                    throw (0, $7ZXKi.syntaxError)(source, position, "Invalid character escape sequence: \\".concat(String.fromCharCode(code), "."));
            }
            ++position;
            chunkStart = position;
        }
    }
    throw (0, $7ZXKi.syntaxError)(source, position, 'Unterminated string.');
}
/**
 * Reads a block string token from the source file.
 *
 * """("?"?(\\"""|\\(?!=""")|[^"\\]))*"""
 */ function $e119c27db9a87f5b$var$readBlockString(source, start, line, col, prev, lexer) {
    var body = source.body;
    var position = start + 3;
    var chunkStart = position;
    var code = 0;
    var rawValue = '';
    while(position < body.length && !isNaN(code = body.charCodeAt(position))){
        // Closing Triple-Quote (""")
        if (code === 34 && body.charCodeAt(position + 1) === 34 && body.charCodeAt(position + 2) === 34) {
            rawValue += body.slice(chunkStart, position);
            return new (0, $98oUl.Token)((0, $2z7TS.TokenKind).BLOCK_STRING, start, position + 3, line, col, prev, (0, $541Mz.dedentBlockStringValue)(rawValue));
        } // SourceCharacter
        if (code < 0x0020 && code !== 0x0009 && code !== 0x000a && code !== 0x000d) throw (0, $7ZXKi.syntaxError)(source, position, "Invalid character within String: ".concat($e119c27db9a87f5b$var$printCharCode(code), "."));
        if (code === 10) {
            // new line
            ++position;
            ++lexer.line;
            lexer.lineStart = position;
        } else if (code === 13) {
            // carriage return
            if (body.charCodeAt(position + 1) === 10) position += 2;
            else ++position;
            ++lexer.line;
            lexer.lineStart = position;
        } else if (code === 92 && body.charCodeAt(position + 1) === 34 && body.charCodeAt(position + 2) === 34 && body.charCodeAt(position + 3) === 34) {
            rawValue += body.slice(chunkStart, position) + '"""';
            position += 4;
            chunkStart = position;
        } else ++position;
    }
    throw (0, $7ZXKi.syntaxError)(source, position, 'Unterminated string.');
}
/**
 * Converts four hexadecimal chars to the integer that the
 * string represents. For example, uniCharCode('0','0','0','f')
 * will return 15, and uniCharCode('0','0','f','f') returns 255.
 *
 * Returns a negative number on error, if a char was invalid.
 *
 * This is implemented by noting that char2hex() returns -1 on error,
 * which means the result of ORing the char2hex() will also be negative.
 */ function $e119c27db9a87f5b$var$uniCharCode(a, b, c, d) {
    return $e119c27db9a87f5b$var$char2hex(a) << 12 | $e119c27db9a87f5b$var$char2hex(b) << 8 | $e119c27db9a87f5b$var$char2hex(c) << 4 | $e119c27db9a87f5b$var$char2hex(d);
}
/**
 * Converts a hex character to its integer value.
 * '0' becomes 0, '9' becomes 9
 * 'A' becomes 10, 'F' becomes 15
 * 'a' becomes 10, 'f' becomes 15
 *
 * Returns -1 on error.
 */ function $e119c27db9a87f5b$var$char2hex(a) {
    return a >= 48 && a <= 57 ? a - 48 // 0-9
     : a >= 65 && a <= 70 ? a - 55 // A-F
     : a >= 97 && a <= 102 ? a - 87 // a-f
     : -1;
}
/**
 * Reads an alphanumeric + underscore name from the source.
 *
 * [_A-Za-z][_0-9A-Za-z]*
 */ function $e119c27db9a87f5b$var$readName(source, start, line, col, prev) {
    var body = source.body;
    var bodyLength = body.length;
    var position = start + 1;
    var code = 0;
    while(position !== bodyLength && !isNaN(code = body.charCodeAt(position)) && (code === 95 || // _
    code >= 48 && code <= 57 || // 0-9
    code >= 65 && code <= 90 || // A-Z
    code >= 97 && code <= 122 // a-z
    ))++position;
    return new (0, $98oUl.Token)((0, $2z7TS.TokenKind).NAME, start, position, line, col, prev, body.slice(start, position));
} // _ A-Z a-z
function $e119c27db9a87f5b$var$isNameStart(code) {
    return code === 95 || code >= 65 && code <= 90 || code >= 97 && code <= 122;
}

});




parcelRegister("dEcp8", function(module, exports) {

$parcel$export(module.exports, "toUserType", () => $ed1cf12a11d1cbd9$export$6b53fef091c7e27d);
function $ed1cf12a11d1cbd9$export$6b53fef091c7e27d({ isBot: isBot, appType: appType }) {
    // Note, the order of these checks is important
    if (appType?.toLocaleLowerCase() === 'agent') return 'agent';
    if (isBot) return 'bot';
    return 'user';
}

});


parcelRegister("cHmJ2", function(module, exports) {

$parcel$export(module.exports, "default", () => $6a1db79055c7f98d$export$2e2bcd8739ae039);

var $aOgFy = parcelRequire("aOgFy");

var $hrPaF = parcelRequire("hrPaF");
var $6a1db79055c7f98d$var$CONTAINER_TYPE = /*#__PURE__*/ function(CONTAINER_TYPE) {
    CONTAINER_TYPE["JIRA_PROJECT"] = "jiraProject";
    CONTAINER_TYPE["CONFLUENCE_SPACE"] = "confluenceSpace";
    return CONTAINER_TYPE;
}($6a1db79055c7f98d$var$CONTAINER_TYPE || {});
var $6a1db79055c7f98d$var$ENTITY_TYPE = /*#__PURE__*/ function(ENTITY_TYPE) {
    ENTITY_TYPE["CONTAINER"] = "CONTAINER";
    ENTITY_TYPE["USER"] = "USER";
    return ENTITY_TYPE;
}($6a1db79055c7f98d$var$ENTITY_TYPE || {});
class $6a1db79055c7f98d$export$cd5b4a06db0ea4e2 extends (0, $hrPaF.RestClient) {
    getUserContainers({ userId: userId, principalId: principalId, siteId: siteId, sessionId: sessionId, maxNumberOfResults: maxNumberOfResults }) {
        return this.postResource('/v1/collaborationgraph/user/container', {
            context: {
                contextType: 'atlassianDirectory',
                principalId: principalId,
                siteId: siteId,
                sessionId: sessionId
            },
            containerTypes: [
                'confluenceSpace',
                'jiraProject'
            ],
            maxNumberOfResults: maxNumberOfResults,
            userId: userId,
            expanded: true
        });
    }
}
var $6a1db79055c7f98d$export$2e2bcd8739ae039 = new $6a1db79055c7f98d$export$cd5b4a06db0ea4e2({
    serviceUrl: (0, $aOgFy.DEFAULT_CONFIG).collaborationGraphUrl
});

});
parcelRegister("hrPaF", function(module, exports) {

$parcel$export(module.exports, "RestClient", () => $0c6f97fa956e6402$export$ea8b5b3aea9558ce);

var $bxYf9 = parcelRequire("bxYf9");

var $1K4T6 = parcelRequire("1K4T6");

var $4F5SC = parcelRequire("4F5SC");

var $hdjej = parcelRequire("hdjej");

var $cIUqK = parcelRequire("cIUqK");

var $9WYOs = parcelRequire("9WYOs");

var $gnGnQ = parcelRequire("gnGnQ");

var $cKoHA = parcelRequire("cKoHA");

var $3lXoL = parcelRequire("3lXoL");
const $0c6f97fa956e6402$var$defaultFetchOptions = {
    credentials: 'include',
    headers: {
        Accept: 'application/json'
    },
    mode: 'cors'
};
let $0c6f97fa956e6402$var$incrementRedirectCount;
let $0c6f97fa956e6402$var$clearRedirectCount;
$0c6f97fa956e6402$export$7a0fc52d8c359feb();
function $0c6f97fa956e6402$export$7a0fc52d8c359feb() {
    $0c6f97fa956e6402$var$incrementRedirectCount = (0, (/*@__PURE__*/$parcel$interopDefault($bxYf9)))(()=>(0, $9WYOs.setCookie)((0, $9WYOs.REDIRECT_COUNT), (0, $9WYOs.getCookieAsInteger)((0, $9WYOs.REDIRECT_COUNT)) + 1));
    $0c6f97fa956e6402$var$clearRedirectCount = (0, (/*@__PURE__*/$parcel$interopDefault($bxYf9)))(()=>(0, $9WYOs.clearCookie)((0, $9WYOs.REDIRECT_COUNT)));
}
class $0c6f97fa956e6402$export$ea8b5b3aea9558ce extends (0, $cIUqK.BaseClient) {
    constructor({ serviceUrl: serviceUrl = '', config: config = {
        logException: ()=>{}
    } }){
        super(config), /**
	 * This function is necessary for if `statusCodeHandler` prescribes a login
	 * redirect upon a 401 response.
	 * While the default redirect behaviour may be overriden, this function has
	 * been kept separate to ensure it cannot be overriden, lest a host
	 * application supply embeddable-directory with a custom handler that suffers
	 * the infinite redirect bug.
	 */ this.preventInfiniteRedirectLoop = (response)=>{
            if (!response.ok) {
                const responseStatusCode = response.status;
                if (responseStatusCode === 401) $0c6f97fa956e6402$var$incrementRedirectCount();
            } else $0c6f97fa956e6402$var$clearRedirectCount();
        };
        this.serviceUrl = serviceUrl;
    }
    setServiceUrl(serviceUrl) {
        this.serviceUrl = serviceUrl;
    }
    async getResource(path, fetchOptions = {}) {
        return this.makeRequest(path, fetchOptions);
    }
    async getResourceCached(path, fetchOptions = {}, cacheOptions) {
        const cacheKey = path;
        const cacheRecord = this.getCachedValue(cacheKey);
        if (cacheRecord) return cacheRecord;
        const response = await this.getResource(path, fetchOptions);
        this.cacheValue(cacheKey, response, cacheOptions?.expiration);
        return response;
    }
    async postResource(path, data, fetchOptions = {}) {
        return this.postResourceRaw(path, JSON.stringify(data), fetchOptions);
    }
    async postResourceRaw(path, data, fetchOptions = {}) {
        fetchOptions = {
            method: 'post',
            headers: {},
            ...fetchOptions
        };
        if (data) fetchOptions = {
            body: data,
            ...fetchOptions,
            headers: {
                'Content-Type': 'application/json',
                ...fetchOptions.headers
            }
        };
        return this.makeRequest(path, fetchOptions);
    }
    async patchResource(path, data) {
        let fetchOptions = {
            /**
			 * PATCH must be uppercase as per fetch spec only
			 * DELETE, GET, HEAD, OPTIONS, POST, and PUT methods
			 * are normalised to uppercase.
			 *
			 * https://github.com/github/fetch/issues/37
			 * https://fetch.spec.whatwg.org/#methods
			 */ method: 'PATCH'
        };
        if (data) fetchOptions = {
            ...fetchOptions,
            body: JSON.stringify(data),
            headers: {
                'Content-Type': 'application/json'
            }
        };
        return this.makeRequest(path, fetchOptions);
    }
    async putResource(path, data, additionalFetchOptions = {}) {
        const fetchOptions = {
            method: 'put'
        };
        if (data) Object.assign(fetchOptions, {
            body: JSON.stringify(data),
            headers: {
                'Content-Type': 'application/json'
            }
        });
        return this.makeRequest(path, {
            ...fetchOptions,
            ...additionalFetchOptions
        });
    }
    async deleteResource(path, options = {}) {
        const fetchOptions = {
            ...options,
            method: 'delete'
        };
        return this.makeRequest(path, fetchOptions);
    }
    async makeRequest(path, additionalFetchOptions = {
        shouldLogError: (e)=>e.status !== 429
    }) {
        const url = this.serviceUrl + path;
        const options = {
            ...$0c6f97fa956e6402$var$defaultFetchOptions,
            ...additionalFetchOptions
        };
        const response = await (0, $4F5SC.fetchWithExponentialBackoff)(url, options);
        this.preventInfiniteRedirectLoop(response);
        (0, $hdjej.handleResponse)(response);
        const responseStatusCode = response.status;
        const traceId = response.headers.get('atl-traceid');
        if (!response.ok) {
            if (responseStatusCode === 401) throw new (0, $1K4T6.SLOIgnoreError)({
                message: 'Unauthorized Request - incrementing redirect count'
            });
            else {
                const message = await (0, $gnGnQ.parseErrorMessage)(response);
                const httpError = new (0, $1K4T6.HttpError)({
                    message: message,
                    status: responseStatusCode,
                    traceId: traceId ?? undefined,
                    path: path
                });
                if (options.shouldLogError && options.shouldLogError(httpError)) this.logException(httpError, (0, $3lXoL.stripUUIDFromPath)(path), {
                    method: options.method || 'GET',
                    url: url,
                    status: responseStatusCode
                });
                throw httpError;
            }
        }
        return additionalFetchOptions.ignoreResponse ? null : (0, $cKoHA.parseResponse)(response);
    }
}

});
parcelRegister("9WYOs", function(module, exports) {

$parcel$export(module.exports, "REDIRECT_COUNT", () => $bf41c8766f9a88e5$export$f6101897f0230549);
$parcel$export(module.exports, "setCookie", () => $bf41c8766f9a88e5$export$110700823644f4a6);
$parcel$export(module.exports, "getCookieAsInteger", () => $bf41c8766f9a88e5$export$6a289e5003f59269);
$parcel$export(module.exports, "clearCookie", () => $bf41c8766f9a88e5$export$ad3506281d5a5e5d);
const $bf41c8766f9a88e5$export$f6101897f0230549 = 'redirectCount';
const $bf41c8766f9a88e5$export$5a7d8afb87170e45 = 'avatar.csrf.token';
function $bf41c8766f9a88e5$export$110700823644f4a6(key, value) {
    document.cookie = `${key}=${value};path=/;max-age=30`;
}
function $bf41c8766f9a88e5$export$6a289e5003f59269(key, defaultValue = 0) {
    const regex = new RegExp(`${key}=(\\d+)`);
    const result = document.cookie.match(regex);
    return result ? parseInt(result[1], 10) : defaultValue;
}
function $bf41c8766f9a88e5$export$ad3506281d5a5e5d(key) {
    document.cookie = `${key}=doesntmatter;path=/;expires=Thu, 01 Jan 1970 00:00:01 GMT`;
}

});

parcelRegister("gnGnQ", function(module, exports) {

$parcel$export(module.exports, "parseErrorMessage", () => $dbd61437f2184940$export$91c32f1b22d29b2d);
async function $dbd61437f2184940$export$91c32f1b22d29b2d(response) {
    let json;
    const text = await response.text();
    try {
        json = JSON.parse(text);
    } catch (err) {
        return text;
    }
    delete json.timestamp; // to dedupe sentry, scrub non-unique 'timestamp' field from the error body
    if (json.error) return `${json.status || 'UNKNOWN_STATUS'} ${json.error || 'MISSING_ERROR_MESSAGE'}`;
    else if (json.status) return `${json.status} MISSING_ERROR_MESSAGE`;
    else if (json.errors) {
        const errs = json.errors.map((error)=>typeof error === 'string' ? error : error.code || error.message || 'MISSING_ERROR_MESSAGE');
        return errs.join('\n - ');
    }
    return JSON.stringify(json);
}

});

parcelRegister("cKoHA", function(module, exports) {

$parcel$export(module.exports, "parseResponse", () => $571f67df8e1c13fb$export$ba14d9a5a581e827);
function $571f67df8e1c13fb$export$ba14d9a5a581e827(response) {
    const responseStatusCode = response.status;
    if (responseStatusCode === 204 || responseStatusCode === 202) return null;
    const contentType = response.headers.get('content-type');
    if (!contentType || contentType.includes('text/html') || contentType.includes('text/plain')) return response.text();
    if (contentType.includes('application/json')) return response.json();
    return null;
}

});

parcelRegister("3lXoL", function(module, exports) {

$parcel$export(module.exports, "stripUUIDFromPath", () => $a95ff77b07a38502$export$6bd073e2c6dda996);
const $a95ff77b07a38502$var$UUID_REGEX = new RegExp(/((\w{4,12}-?)){5}/g);
const $a95ff77b07a38502$export$6bd073e2c6dda996 = (path)=>{
    return path.replace($a95ff77b07a38502$var$UUID_REGEX, '<UUID>');
};

});



parcelRegister("49fYn", function(module, exports) {

$parcel$export(module.exports, "directoryClient", () => $4b31d9e631f37e0f$export$ead519165de472de);

var $aOgFy = parcelRequire("aOgFy");

var $cPPyF = parcelRequire("cPPyF");

var $6laLp = parcelRequire("6laLp");
const $4b31d9e631f37e0f$export$28456d095a642fd = 'internal.browse-users-allowed';
const $4b31d9e631f37e0f$var$buildTeamMembershipQuery = (teamId, membershipState)=>({
        query: `query TeamMembership($teamId: String!, $membershipState: [TeamMembershipStatus]) {
    TeamMembership: TeamMembership(teamId: $teamId, membershipStates: $membershipState) {
      user: profile {
        id,
        fullName,
        title,
        avatarUrl,
        timezone,
        status
      },
      state:membershipStatus,
      role,
      membershipId {
        teamId, memberId
      }
    }
  }`,
        variables: {
            teamId: teamId,
            membershipState: membershipState
        }
    });
const $4b31d9e631f37e0f$var$buildUserQuery = (userId, cloudId)=>({
        query: `query CloudUser($userId: String!, $cloudId: String!) {
    CloudUser(userId: $userId, cloudId: $cloudId) {
      avatarUrl
      id
      fullName
      title
    }
  }`,
        variables: {
            userId: userId,
            cloudId: cloudId
        }
    });
const $4b31d9e631f37e0f$var$delay = (millis)=>new Promise((resolve)=>{
        setTimeout(resolve, millis);
    });
class $4b31d9e631f37e0f$export$c8a50bf6c196fc10 extends (0, $cPPyF.BaseGraphQlClient) {
    constructor(baseUrl, config){
        super(`${baseUrl}/directory/graphql`, config);
    }
    setBaseUrl(baseUrl) {
        this.setServiceUrl(`${baseUrl}/directory/graphql`);
    }
    async queryFeatureFlags(/**
   * @private
   * @deprecated don't need to pass param, value is taken from `this.getCloudId()` instead
   */ cloudId, flags) {
        const queryFeatureFlags = {
            query: `query FeatureFlags($cloudId: String!, $flags: [String]!) {
        FeatureFlags(cloudId: $cloudId, flags: $flags) {
          flag
          enabled
        }
      }`,
            variables: {
                cloudId: this.getCloudId(cloudId),
                flags: flags
            }
        };
        const { FeatureFlags: FeatureFlags } = await this.makeGraphQLRequest(queryFeatureFlags, {
            operationName: 'FeatureFlags'
        });
        return FeatureFlags.map(({ flag: flag, enabled: enabled })=>[
                flag,
                enabled
            ]).reduce((acc, val)=>(acc[val[0]] = val[1], acc), {});
    }
    canRetryError(pendingRetries, error) {
        return pendingRetries > 0 && !!error && typeof error === 'object' && 'category' in error && error.category === 'NotFound';
    }
    /**
   * Get user information of all members of a team
   * @param {string} teamId
   * @returns {Promise}
   * @private
   * @deprecated use AGG instead
   */ queryTeamMemberships(teamId, membershipStatus = [
        'FULL_MEMBER'
    ]) {
        // eslint-disable-next-line no-console
        console.warn('Directory queryTeamMemberships is deprecated, use AGG instead');
        const teamMembershipsQuery = $4b31d9e631f37e0f$var$buildTeamMembershipQuery(teamId, membershipStatus);
        const performRequest = async (pendingRetries = 3, backoffMaxDelay = 2000)=>{
            try {
                return await this.makeGraphQLRequest(teamMembershipsQuery, {
                    operationName: 'TeamMembership'
                });
            } catch (error) {
                if (this.canRetryError(pendingRetries, error)) {
                    await $4b31d9e631f37e0f$var$delay(backoffMaxDelay / pendingRetries);
                    return performRequest(pendingRetries - 1);
                }
                throw error;
            }
        };
        return performRequest().then(({ TeamMembership: TeamMembership })=>TeamMembership);
    }
    /**
   * Get user information of all members of a team
   * @param {string} userId
   * @returns {Promise}
   */ queryUser(userId, /**
   * @private
   * @deprecated don't need to pass param, value is taken from `this.getCloudId()` instead
   */ cloudId) {
        const userQuery = $4b31d9e631f37e0f$var$buildUserQuery(userId, this.getCloudId(cloudId));
        const performRequest = async (pendingRetries = 3, backoffMaxDelay = 2000)=>{
            try {
                return await this.makeGraphQLRequest(userQuery, {
                    operationName: 'CloudUser'
                });
            } catch (error) {
                if (this.canRetryError(pendingRetries, error)) {
                    await $4b31d9e631f37e0f$var$delay(backoffMaxDelay / pendingRetries);
                    return performRequest(pendingRetries - 1);
                }
                throw error;
            }
        };
        return performRequest();
    }
}
const $4b31d9e631f37e0f$export$ead519165de472de = new $4b31d9e631f37e0f$export$c8a50bf6c196fc10((0, $aOgFy.DEFAULT_CONFIG).stargateRoot, {
    logException: $6laLp.logException
});

});

parcelRegister("gnKBB", function(module, exports) {

$parcel$export(module.exports, "default", () => $38997081039c300e$export$2e2bcd8739ae039);

var $aOgFy = parcelRequire("aOgFy");

var $hrPaF = parcelRequire("hrPaF");

var $hcbtx = parcelRequire("hcbtx");
const $38997081039c300e$var$defaultConfig = {
    serviceUrl: `${(0, $aOgFy.DEFAULT_CONFIG).stargateRoot}/users`
};
class $38997081039c300e$export$f9c003efee04f318 extends (0, $hrPaF.RestClient) {
    constructor(config = {}){
        super({
            ...$38997081039c300e$var$defaultConfig,
            ...config
        });
    }
    async getUserManageConfig(userId) {
        return this.getResourceCached(`/${userId}/manage`).then((resp)=>{
            return (0, $hcbtx.transformUserManageConfig)(resp);
        });
    }
    /**
	 * @deprecated
	 * User fetchUserAvatarInfo instead
	 */ async getMyAvatarUploadedStatus(userId) {
        return this.fetchUserAvatarInfo(userId);
    }
    async deleteAvatar(userId) {
        return this.deleteResource(`/${userId}/manage/avatar`);
    }
    async fetchUserAvatarInfo(userId) {
        return this.getResource(`/${userId}/manage/avatar`);
    }
    async updateUser({ id: id, ...user }) {
        return this.patchResource(`/${id}/manage/profile`, (0, $hcbtx.toManageAPIInput)(user));
    }
    async updateUserAvatar({ id: id, fileURI: fileURI }) {
        const fileObject = (0, $hcbtx.dataURItoFile)(fileURI);
        const formData = new FormData();
        formData.append('file', fileObject);
        const response = await this.makeRequest(`/${id}/manage/avatar`, {
            method: 'PUT',
            body: formData
        });
        return response.url;
    }
}
var $38997081039c300e$export$2e2bcd8739ae039 = new $38997081039c300e$export$f9c003efee04f318();

});
parcelRegister("hcbtx", function(module, exports) {

$parcel$export(module.exports, "transformUserManageConfig", () => $e90b5aaa9134b760$export$d7725d3d27b80a68);
$parcel$export(module.exports, "toManageAPIInput", () => $e90b5aaa9134b760$export$7b103107c889cb67);
$parcel$export(module.exports, "dataURItoFile", () => $e90b5aaa9134b760$export$80d19edb7b1ae293);
parcelRequire("fzTVj");
var $iwMEb = parcelRequire("iwMEb");
// Key (left-side) is field name which is used in our app.
// Value (right-side) is field name which is used by data in services
const $e90b5aaa9134b760$var$PROFILE_PROPS_MAP = new Map([
    [
        'id',
        'account_id'
    ],
    [
        'fullName',
        'name'
    ],
    [
        'nickname',
        'nickname'
    ],
    [
        'timezone',
        'zoneinfo'
    ],
    [
        'locale',
        'locale'
    ],
    [
        'avatarUrl',
        'picture'
    ],
    [
        'email',
        'email'
    ]
]);
// Key (left-side) is field name which is used in our app.
// Value (right-side) is field name which is used by data in services
const $e90b5aaa9134b760$var$EXTENDED_PROFILE_PROPS_MAP = new Map([
    [
        'title',
        'job_title'
    ],
    [
        'department',
        'department'
    ],
    [
        'companyName',
        'organization'
    ],
    [
        'location',
        'location'
    ],
    [
        'phoneNumber',
        'phone_number'
    ]
]);
const $e90b5aaa9134b760$export$5299664357e4f3dd = (res)=>{
    const data = res.account;
    const extendedData = data && data.extended_profile || {};
    if (!data) return null;
    const timeZone = data.zoneinfo;
    const localTime = ({ format: format })=>{
        if (!timeZone) return null;
        try {
            return (0, $iwMEb.default)(new Date(), timeZone, format);
        } catch (error) {
            // TODO: PTC-4908 send error to sentry for reporting
            return null;
        }
    };
    const profileProps = Array.from($e90b5aaa9134b760$var$PROFILE_PROPS_MAP.keys()).reduce((acc, key)=>{
        if ($e90b5aaa9134b760$var$PROFILE_PROPS_MAP.has(key)) acc[key] = data[$e90b5aaa9134b760$var$PROFILE_PROPS_MAP.get(key)];
        return acc;
    }, {});
    const extendedProfileProps = Array.from($e90b5aaa9134b760$var$EXTENDED_PROFILE_PROPS_MAP.keys()).reduce((acc, key)=>{
        if ($e90b5aaa9134b760$var$EXTENDED_PROFILE_PROPS_MAP.has(key)) acc[key] = extendedData[$e90b5aaa9134b760$var$EXTENDED_PROFILE_PROPS_MAP.get(key)];
        return acc;
    }, {});
    return {
        ...profileProps,
        ...extendedProfileProps,
        localTime: localTime
    };
};
var $e90b5aaa9134b760$export$ed12481c953b8653 = /*#__PURE__*/ function(FieldType) {
    FieldType["FullName"] = "fullName";
    FieldType["Nickname"] = "nickname";
    FieldType["Title"] = "title";
    FieldType["Department"] = "department";
    FieldType["CompanyName"] = "companyName";
    FieldType["Location"] = "location";
    FieldType["Timezone"] = "timezone";
    FieldType["Email"] = "email";
    FieldType["PhoneNumber"] = "phoneNumber";
    FieldType["Avatar"] = "picture";
    FieldType["Language"] = "language";
    FieldType["LocalTime"] = "localTime";
    FieldType["RemoteWeekdayIndex"] = "remoteWeekdayIndex";
    FieldType["RemoteWeekdayString"] = "remoteWeekdayString";
    FieldType["RemoteTimeString"] = "remoteTimeString";
    return FieldType;
}({});
const $e90b5aaa9134b760$export$78158d2c2c6998d9 = {
    fullName: 'name',
    nickname: 'nickname',
    timezone: 'zoneinfo',
    locale: 'locale',
    email: 'email',
    // extended profile
    title: 'extended_profile.job_title',
    phoneNumber: 'extended_profile.phone_number',
    companyName: 'extended_profile.organization',
    department: 'extended_profile.department',
    location: 'extended_profile.location'
};
const $e90b5aaa9134b760$export$2ff7b92b9e1bb4d2 = {
    email: 'email.initiateChange',
    picture: 'avatar'
};
const $e90b5aaa9134b760$var$getFieldConfig = (data, field)=>{
    if ((field === 'email' || field === 'picture') && $e90b5aaa9134b760$export$2ff7b92b9e1bb4d2[field]) return data[$e90b5aaa9134b760$export$2ff7b92b9e1bb4d2[field]];
    const mappedFieldKey = field in $e90b5aaa9134b760$export$78158d2c2c6998d9 ? $e90b5aaa9134b760$export$78158d2c2c6998d9[field] : undefined;
    if (!mappedFieldKey) return undefined;
    const profileWrite = data['profile.write'];
    return profileWrite[mappedFieldKey];
};
const $e90b5aaa9134b760$var$convertFieldKeyToFieldType = (key)=>{
    // Check if the key can be mapped to a FieldType value
    if (Object.values($e90b5aaa9134b760$export$ed12481c953b8653).includes(key)) return key;
    return undefined;
};
const $e90b5aaa9134b760$var$getMutabilityConstraintFor = (data, field)=>{
    const fieldConfig = $e90b5aaa9134b760$var$getFieldConfig(data, field);
    if (!fieldConfig || fieldConfig.allowed) return undefined;
    const convertedField = $e90b5aaa9134b760$var$convertFieldKeyToFieldType(field);
    if (!convertedField) return undefined;
    const reason = fieldConfig.reason;
    return {
        field: convertedField,
        reason: reason && reason.key || null
    };
};
const $e90b5aaa9134b760$export$d7725d3d27b80a68 = (data)=>({
        mutabilityConstraints: Object.keys($e90b5aaa9134b760$export$78158d2c2c6998d9).map((field)=>$e90b5aaa9134b760$var$getMutabilityConstraintFor(data, field)).filter((constraint)=>constraint !== undefined)
    });
const $e90b5aaa9134b760$export$7b103107c889cb67 = (input)=>{
    const output = {
        extended_profile: {}
    };
    Object.keys(input).forEach((key)=>{
        if ($e90b5aaa9134b760$var$PROFILE_PROPS_MAP.has(key)) output[$e90b5aaa9134b760$var$PROFILE_PROPS_MAP.get(key)] = input[key];
        if ($e90b5aaa9134b760$var$EXTENDED_PROFILE_PROPS_MAP.has(key)) output.extended_profile[$e90b5aaa9134b760$var$EXTENDED_PROFILE_PROPS_MAP.get(key)] = input[key];
    });
    return output;
};
function $e90b5aaa9134b760$export$80d19edb7b1ae293(dataURI, filename = 'untitled') {
    if (dataURI.length === 0) throw new Error('dataURI not found');
    // convert base64/URLEncoded data component to raw binary data held in a string
    const byteString = dataURI.split(',')[0].includes('base64') ? atob(dataURI.split(',')[1]) : decodeURIComponent(dataURI.split(',')[1]);
    // separate out the mime component
    let mimeString;
    try {
        mimeString = dataURI.split(',')[0].split(':')[1].split(';')[0];
    } catch (e) {
        mimeString = 'unknown';
    }
    // write the bytes of the string to a typed array
    const intArray = new Uint8Array(byteString.length);
    for(let i = 0; i < byteString.length; i++)intArray[i] = byteString.charCodeAt(i);
    const blob = new Blob([
        intArray
    ], {
        type: mimeString
    });
    try {
        return new File([
            blob
        ], filename, {
            type: mimeString
        });
    } catch (e) {
        // IE11 and Safari does not support the File constructor.
        return blob;
    }
}

});
parcelRegister("fzTVj", function(module, exports) {

$parcel$export(module.exports, "formatInTimeZone", () => (parcelRequire("iwMEb")).default);
// This file is generated automatically by `scripts/build/indices.js`. Please, don't change it.


var $iwMEb = parcelRequire("iwMEb");





});
parcelRegister("iwMEb", function(module, exports) {

$parcel$export(module.exports, "default", () => $037b1cb35b9ac277$export$2e2bcd8739ae039);

var $fwbX5 = parcelRequire("fwbX5");

var $3bby5 = parcelRequire("3bby5");

var $iEBtW = parcelRequire("iEBtW");
function $037b1cb35b9ac277$export$2e2bcd8739ae039(date, timeZone, formatStr, options) {
    var extendedOptions = (0, (/*@__PURE__*/$parcel$interopDefault($fwbX5)))(options);
    extendedOptions.timeZone = timeZone;
    extendedOptions.originalDate = date;
    return (0, $3bby5.default)((0, $iEBtW.default)(date, timeZone), formatStr, extendedOptions);
}

});
parcelRegister("fwbX5", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $b4c31d9870379ac2$var$cloneObject;

var $b4c31d9870379ac2$var$_index = $b4c31d9870379ac2$var$_interopRequireDefault((parcelRequire("cpl5v")));
function $b4c31d9870379ac2$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $b4c31d9870379ac2$var$cloneObject(dirtyObject) {
    return (0, $b4c31d9870379ac2$var$_index.default)({}, dirtyObject);
}
module.exports = module.exports.default;

});
parcelRegister("cpl5v", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $90882d6ff669df4d$var$assign;
function $90882d6ff669df4d$var$assign(target, dirtyObject) {
    if (target == null) throw new TypeError('assign requires that input parameter not be null or undefined');
    dirtyObject = dirtyObject || {};
    for(var property in dirtyObject)if (Object.prototype.hasOwnProperty.call(dirtyObject, property)) target[property] = dirtyObject[property];
    return target;
}
module.exports = module.exports.default;

});


parcelRegister("3bby5", function(module, exports) {

$parcel$export(module.exports, "default", () => $250b5b880d4c3a29$export$2e2bcd8739ae039);

var $aR9Qf = parcelRequire("aR9Qf");

var $5wWnR = parcelRequire("5wWnR");

var $sNI8p = parcelRequire("sNI8p");
var $250b5b880d4c3a29$var$tzFormattingTokensRegExp = /([xXOz]+)|''|'(''|[^'])+('|$)/g;
function $250b5b880d4c3a29$export$2e2bcd8739ae039(dirtyDate, dirtyFormatStr, dirtyOptions) {
    var formatStr = String(dirtyFormatStr);
    var options = dirtyOptions || {};
    var matches = formatStr.match($250b5b880d4c3a29$var$tzFormattingTokensRegExp);
    if (matches) {
        var date = (0, $sNI8p.default)(options.originalDate || dirtyDate, options);
        // Work through each match and replace the tz token in the format string with the quoted
        // formatted time zone so the remaining tokens can be filled in by date-fns#format.
        formatStr = matches.reduce(function(result, token) {
            if (token[0] === "'") return result // This is a quoted portion, matched only to ensure we don't match inside it
            ;
            var pos = result.indexOf(token);
            var precededByQuotedSection = result[pos - 1] === "'";
            var replaced = result.replace(token, "'" + (0, $5wWnR.default)[token[0]](date, token, null, options) + "'");
            // If the replacement results in two adjoining quoted strings, the back to back quotes
            // are removed, so it doesn't look like an escaped quote.
            return precededByQuotedSection ? replaced.substring(0, pos - 1) + replaced.substring(pos + 1) : replaced;
        }, formatStr);
    }
    return (0, (/*@__PURE__*/$parcel$interopDefault($aR9Qf)))(dirtyDate, formatStr, options);
}

});
parcelRegister("aR9Qf", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $7e767cfeba790ebe$var$format;

var $7e767cfeba790ebe$var$_index = $7e767cfeba790ebe$var$_interopRequireDefault((parcelRequire("ck8JK")));

var $7e767cfeba790ebe$var$_index2 = $7e767cfeba790ebe$var$_interopRequireDefault((parcelRequire("kvNR5")));

var $7e767cfeba790ebe$var$_index3 = $7e767cfeba790ebe$var$_interopRequireDefault((parcelRequire("bQkcE")));

var $7e767cfeba790ebe$var$_index4 = $7e767cfeba790ebe$var$_interopRequireDefault((parcelRequire("2pWQP")));

var $7e767cfeba790ebe$var$_index5 = $7e767cfeba790ebe$var$_interopRequireDefault((parcelRequire("3ckvK")));

var $7e767cfeba790ebe$var$_index6 = $7e767cfeba790ebe$var$_interopRequireDefault((parcelRequire("awKAW")));

var $7e767cfeba790ebe$var$_index7 = $7e767cfeba790ebe$var$_interopRequireDefault((parcelRequire("jGQTC")));

var $5qguX = parcelRequire("5qguX");

var $7e767cfeba790ebe$var$_index9 = $7e767cfeba790ebe$var$_interopRequireDefault((parcelRequire("aSksP")));

var $7e767cfeba790ebe$var$_index10 = $7e767cfeba790ebe$var$_interopRequireDefault((parcelRequire("6eBfj")));
function $7e767cfeba790ebe$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
// This RegExp consists of three parts separated by `|`:
// - [yYQqMLwIdDecihHKkms]o matches any available ordinal number token
//   (one of the certain letters followed by `o`)
// - (\w)\1* matches any sequences of the same letter
// - '' matches two quote characters in a row
// - '(''|[^'])+('|$) matches anything surrounded by two quote characters ('),
//   except a single quote symbol, which ends the sequence.
//   Two quote characters do not end the sequence.
//   If there is no matching single quote
//   then the sequence will continue until the end of the string.
// - . matches any single character unmatched by previous parts of the RegExps
var $7e767cfeba790ebe$var$formattingTokensRegExp = /[yYQqMLwIdDecihHKkms]o|(\w)\1*|''|'(''|[^'])+('|$)|./g; // This RegExp catches symbols escaped by quotes, and also
// sequences of symbols P, p, and the combinations like `PPPPPPPppppp`
var $7e767cfeba790ebe$var$longFormattingTokensRegExp = /P+p+|P+|p+|''|'(''|[^'])+('|$)|./g;
var $7e767cfeba790ebe$var$escapedStringRegExp = /^'([^]*?)'?$/;
var $7e767cfeba790ebe$var$doubleQuoteRegExp = /''/g;
var $7e767cfeba790ebe$var$unescapedLatinCharacterRegExp = /[a-zA-Z]/;
/**
 * @name format
 * @category Common Helpers
 * @summary Format the date.
 *
 * @description
 * Return the formatted date string in the given format. The result may vary by locale.
 *
 * > ⚠️ Please note that the `format` tokens differ from Moment.js and other libraries.
 * > See: https://git.io/fxCyr
 *
 * The characters wrapped between two single quotes characters (') are escaped.
 * Two single quotes in a row, whether inside or outside a quoted sequence, represent a 'real' single quote.
 * (see the last example)
 *
 * Format of the string is based on Unicode Technical Standard #35:
 * https://www.unicode.org/reports/tr35/tr35-dates.html#Date_Field_Symbol_Table
 * with a few additions (see note 7 below the table).
 *
 * Accepted patterns:
 * | Unit                            | Pattern | Result examples                   | Notes |
 * |---------------------------------|---------|-----------------------------------|-------|
 * | Era                             | G..GGG  | AD, BC                            |       |
 * |                                 | GGGG    | Anno Domini, Before Christ        | 2     |
 * |                                 | GGGGG   | A, B                              |       |
 * | Calendar year                   | y       | 44, 1, 1900, 2017                 | 5     |
 * |                                 | yo      | 44th, 1st, 0th, 17th              | 5,7   |
 * |                                 | yy      | 44, 01, 00, 17                    | 5     |
 * |                                 | yyy     | 044, 001, 1900, 2017              | 5     |
 * |                                 | yyyy    | 0044, 0001, 1900, 2017            | 5     |
 * |                                 | yyyyy   | ...                               | 3,5   |
 * | Local week-numbering year       | Y       | 44, 1, 1900, 2017                 | 5     |
 * |                                 | Yo      | 44th, 1st, 1900th, 2017th         | 5,7   |
 * |                                 | YY      | 44, 01, 00, 17                    | 5,8   |
 * |                                 | YYY     | 044, 001, 1900, 2017              | 5     |
 * |                                 | YYYY    | 0044, 0001, 1900, 2017            | 5,8   |
 * |                                 | YYYYY   | ...                               | 3,5   |
 * | ISO week-numbering year         | R       | -43, 0, 1, 1900, 2017             | 5,7   |
 * |                                 | RR      | -43, 00, 01, 1900, 2017           | 5,7   |
 * |                                 | RRR     | -043, 000, 001, 1900, 2017        | 5,7   |
 * |                                 | RRRR    | -0043, 0000, 0001, 1900, 2017     | 5,7   |
 * |                                 | RRRRR   | ...                               | 3,5,7 |
 * | Extended year                   | u       | -43, 0, 1, 1900, 2017             | 5     |
 * |                                 | uu      | -43, 01, 1900, 2017               | 5     |
 * |                                 | uuu     | -043, 001, 1900, 2017             | 5     |
 * |                                 | uuuu    | -0043, 0001, 1900, 2017           | 5     |
 * |                                 | uuuuu   | ...                               | 3,5   |
 * | Quarter (formatting)            | Q       | 1, 2, 3, 4                        |       |
 * |                                 | Qo      | 1st, 2nd, 3rd, 4th                | 7     |
 * |                                 | QQ      | 01, 02, 03, 04                    |       |
 * |                                 | QQQ     | Q1, Q2, Q3, Q4                    |       |
 * |                                 | QQQQ    | 1st quarter, 2nd quarter, ...     | 2     |
 * |                                 | QQQQQ   | 1, 2, 3, 4                        | 4     |
 * | Quarter (stand-alone)           | q       | 1, 2, 3, 4                        |       |
 * |                                 | qo      | 1st, 2nd, 3rd, 4th                | 7     |
 * |                                 | qq      | 01, 02, 03, 04                    |       |
 * |                                 | qqq     | Q1, Q2, Q3, Q4                    |       |
 * |                                 | qqqq    | 1st quarter, 2nd quarter, ...     | 2     |
 * |                                 | qqqqq   | 1, 2, 3, 4                        | 4     |
 * | Month (formatting)              | M       | 1, 2, ..., 12                     |       |
 * |                                 | Mo      | 1st, 2nd, ..., 12th               | 7     |
 * |                                 | MM      | 01, 02, ..., 12                   |       |
 * |                                 | MMM     | Jan, Feb, ..., Dec                |       |
 * |                                 | MMMM    | January, February, ..., December  | 2     |
 * |                                 | MMMMM   | J, F, ..., D                      |       |
 * | Month (stand-alone)             | L       | 1, 2, ..., 12                     |       |
 * |                                 | Lo      | 1st, 2nd, ..., 12th               | 7     |
 * |                                 | LL      | 01, 02, ..., 12                   |       |
 * |                                 | LLL     | Jan, Feb, ..., Dec                |       |
 * |                                 | LLLL    | January, February, ..., December  | 2     |
 * |                                 | LLLLL   | J, F, ..., D                      |       |
 * | Local week of year              | w       | 1, 2, ..., 53                     |       |
 * |                                 | wo      | 1st, 2nd, ..., 53th               | 7     |
 * |                                 | ww      | 01, 02, ..., 53                   |       |
 * | ISO week of year                | I       | 1, 2, ..., 53                     | 7     |
 * |                                 | Io      | 1st, 2nd, ..., 53th               | 7     |
 * |                                 | II      | 01, 02, ..., 53                   | 7     |
 * | Day of month                    | d       | 1, 2, ..., 31                     |       |
 * |                                 | do      | 1st, 2nd, ..., 31st               | 7     |
 * |                                 | dd      | 01, 02, ..., 31                   |       |
 * | Day of year                     | D       | 1, 2, ..., 365, 366               | 9     |
 * |                                 | Do      | 1st, 2nd, ..., 365th, 366th       | 7     |
 * |                                 | DD      | 01, 02, ..., 365, 366             | 9     |
 * |                                 | DDD     | 001, 002, ..., 365, 366           |       |
 * |                                 | DDDD    | ...                               | 3     |
 * | Day of week (formatting)        | E..EEE  | Mon, Tue, Wed, ..., Sun           |       |
 * |                                 | EEEE    | Monday, Tuesday, ..., Sunday      | 2     |
 * |                                 | EEEEE   | M, T, W, T, F, S, S               |       |
 * |                                 | EEEEEE  | Mo, Tu, We, Th, Fr, Su, Sa        |       |
 * | ISO day of week (formatting)    | i       | 1, 2, 3, ..., 7                   | 7     |
 * |                                 | io      | 1st, 2nd, ..., 7th                | 7     |
 * |                                 | ii      | 01, 02, ..., 07                   | 7     |
 * |                                 | iii     | Mon, Tue, Wed, ..., Sun           | 7     |
 * |                                 | iiii    | Monday, Tuesday, ..., Sunday      | 2,7   |
 * |                                 | iiiii   | M, T, W, T, F, S, S               | 7     |
 * |                                 | iiiiii  | Mo, Tu, We, Th, Fr, Su, Sa        | 7     |
 * | Local day of week (formatting)  | e       | 2, 3, 4, ..., 1                   |       |
 * |                                 | eo      | 2nd, 3rd, ..., 1st                | 7     |
 * |                                 | ee      | 02, 03, ..., 01                   |       |
 * |                                 | eee     | Mon, Tue, Wed, ..., Sun           |       |
 * |                                 | eeee    | Monday, Tuesday, ..., Sunday      | 2     |
 * |                                 | eeeee   | M, T, W, T, F, S, S               |       |
 * |                                 | eeeeee  | Mo, Tu, We, Th, Fr, Su, Sa        |       |
 * | Local day of week (stand-alone) | c       | 2, 3, 4, ..., 1                   |       |
 * |                                 | co      | 2nd, 3rd, ..., 1st                | 7     |
 * |                                 | cc      | 02, 03, ..., 01                   |       |
 * |                                 | ccc     | Mon, Tue, Wed, ..., Sun           |       |
 * |                                 | cccc    | Monday, Tuesday, ..., Sunday      | 2     |
 * |                                 | ccccc   | M, T, W, T, F, S, S               |       |
 * |                                 | cccccc  | Mo, Tu, We, Th, Fr, Su, Sa        |       |
 * | AM, PM                          | a..aa   | AM, PM                            |       |
 * |                                 | aaa     | am, pm                            |       |
 * |                                 | aaaa    | a.m., p.m.                        | 2     |
 * |                                 | aaaaa   | a, p                              |       |
 * | AM, PM, noon, midnight          | b..bb   | AM, PM, noon, midnight            |       |
 * |                                 | bbb     | am, pm, noon, midnight            |       |
 * |                                 | bbbb    | a.m., p.m., noon, midnight        | 2     |
 * |                                 | bbbbb   | a, p, n, mi                       |       |
 * | Flexible day period             | B..BBB  | at night, in the morning, ...     |       |
 * |                                 | BBBB    | at night, in the morning, ...     | 2     |
 * |                                 | BBBBB   | at night, in the morning, ...     |       |
 * | Hour [1-12]                     | h       | 1, 2, ..., 11, 12                 |       |
 * |                                 | ho      | 1st, 2nd, ..., 11th, 12th         | 7     |
 * |                                 | hh      | 01, 02, ..., 11, 12               |       |
 * | Hour [0-23]                     | H       | 0, 1, 2, ..., 23                  |       |
 * |                                 | Ho      | 0th, 1st, 2nd, ..., 23rd          | 7     |
 * |                                 | HH      | 00, 01, 02, ..., 23               |       |
 * | Hour [0-11]                     | K       | 1, 2, ..., 11, 0                  |       |
 * |                                 | Ko      | 1st, 2nd, ..., 11th, 0th          | 7     |
 * |                                 | KK      | 01, 02, ..., 11, 00               |       |
 * | Hour [1-24]                     | k       | 24, 1, 2, ..., 23                 |       |
 * |                                 | ko      | 24th, 1st, 2nd, ..., 23rd         | 7     |
 * |                                 | kk      | 24, 01, 02, ..., 23               |       |
 * | Minute                          | m       | 0, 1, ..., 59                     |       |
 * |                                 | mo      | 0th, 1st, ..., 59th               | 7     |
 * |                                 | mm      | 00, 01, ..., 59                   |       |
 * | Second                          | s       | 0, 1, ..., 59                     |       |
 * |                                 | so      | 0th, 1st, ..., 59th               | 7     |
 * |                                 | ss      | 00, 01, ..., 59                   |       |
 * | Fraction of second              | S       | 0, 1, ..., 9                      |       |
 * |                                 | SS      | 00, 01, ..., 99                   |       |
 * |                                 | SSS     | 000, 001, ..., 999                |       |
 * |                                 | SSSS    | ...                               | 3     |
 * | Timezone (ISO-8601 w/ Z)        | X       | -08, +0530, Z                     |       |
 * |                                 | XX      | -0800, +0530, Z                   |       |
 * |                                 | XXX     | -08:00, +05:30, Z                 |       |
 * |                                 | XXXX    | -0800, +0530, Z, +123456          | 2     |
 * |                                 | XXXXX   | -08:00, +05:30, Z, +12:34:56      |       |
 * | Timezone (ISO-8601 w/o Z)       | x       | -08, +0530, +00                   |       |
 * |                                 | xx      | -0800, +0530, +0000               |       |
 * |                                 | xxx     | -08:00, +05:30, +00:00            | 2     |
 * |                                 | xxxx    | -0800, +0530, +0000, +123456      |       |
 * |                                 | xxxxx   | -08:00, +05:30, +00:00, +12:34:56 |       |
 * | Timezone (GMT)                  | O...OOO | GMT-8, GMT+5:30, GMT+0            |       |
 * |                                 | OOOO    | GMT-08:00, GMT+05:30, GMT+00:00   | 2     |
 * | Timezone (specific non-locat.)  | z...zzz | GMT-8, GMT+5:30, GMT+0            | 6     |
 * |                                 | zzzz    | GMT-08:00, GMT+05:30, GMT+00:00   | 2,6   |
 * | Seconds timestamp               | t       | 512969520                         | 7     |
 * |                                 | tt      | ...                               | 3,7   |
 * | Milliseconds timestamp          | T       | 512969520900                      | 7     |
 * |                                 | TT      | ...                               | 3,7   |
 * | Long localized date             | P       | 04/29/1453                        | 7     |
 * |                                 | PP      | Apr 29, 1453                      | 7     |
 * |                                 | PPP     | April 29th, 1453                  | 7     |
 * |                                 | PPPP    | Friday, April 29th, 1453          | 2,7   |
 * | Long localized time             | p       | 12:00 AM                          | 7     |
 * |                                 | pp      | 12:00:00 AM                       | 7     |
 * |                                 | ppp     | 12:00:00 AM GMT+2                 | 7     |
 * |                                 | pppp    | 12:00:00 AM GMT+02:00             | 2,7   |
 * | Combination of date and time    | Pp      | 04/29/1453, 12:00 AM              | 7     |
 * |                                 | PPpp    | Apr 29, 1453, 12:00:00 AM         | 7     |
 * |                                 | PPPppp  | April 29th, 1453 at ...           | 7     |
 * |                                 | PPPPpppp| Friday, April 29th, 1453 at ...   | 2,7   |
 * Notes:
 * 1. "Formatting" units (e.g. formatting quarter) in the default en-US locale
 *    are the same as "stand-alone" units, but are different in some languages.
 *    "Formatting" units are declined according to the rules of the language
 *    in the context of a date. "Stand-alone" units are always nominative singular:
 *
 *    `format(new Date(2017, 10, 6), 'do LLLL', {locale: cs}) //=> '6. listopad'`
 *
 *    `format(new Date(2017, 10, 6), 'do MMMM', {locale: cs}) //=> '6. listopadu'`
 *
 * 2. Any sequence of the identical letters is a pattern, unless it is escaped by
 *    the single quote characters (see below).
 *    If the sequence is longer than listed in table (e.g. `EEEEEEEEEEE`)
 *    the output will be the same as default pattern for this unit, usually
 *    the longest one (in case of ISO weekdays, `EEEE`). Default patterns for units
 *    are marked with "2" in the last column of the table.
 *
 *    `format(new Date(2017, 10, 6), 'MMM') //=> 'Nov'`
 *
 *    `format(new Date(2017, 10, 6), 'MMMM') //=> 'November'`
 *
 *    `format(new Date(2017, 10, 6), 'MMMMM') //=> 'N'`
 *
 *    `format(new Date(2017, 10, 6), 'MMMMMM') //=> 'November'`
 *
 *    `format(new Date(2017, 10, 6), 'MMMMMMM') //=> 'November'`
 *
 * 3. Some patterns could be unlimited length (such as `yyyyyyyy`).
 *    The output will be padded with zeros to match the length of the pattern.
 *
 *    `format(new Date(2017, 10, 6), 'yyyyyyyy') //=> '00002017'`
 *
 * 4. `QQQQQ` and `qqqqq` could be not strictly numerical in some locales.
 *    These tokens represent the shortest form of the quarter.
 *
 * 5. The main difference between `y` and `u` patterns are B.C. years:
 *
 *    | Year | `y` | `u` |
 *    |------|-----|-----|
 *    | AC 1 |   1 |   1 |
 *    | BC 1 |   1 |   0 |
 *    | BC 2 |   2 |  -1 |
 *
 *    Also `yy` always returns the last two digits of a year,
 *    while `uu` pads single digit years to 2 characters and returns other years unchanged:
 *
 *    | Year | `yy` | `uu` |
 *    |------|------|------|
 *    | 1    |   01 |   01 |
 *    | 14   |   14 |   14 |
 *    | 376  |   76 |  376 |
 *    | 1453 |   53 | 1453 |
 *
 *    The same difference is true for local and ISO week-numbering years (`Y` and `R`),
 *    except local week-numbering years are dependent on `options.weekStartsOn`
 *    and `options.firstWeekContainsDate` (compare [getISOWeekYear]{@link https://date-fns.org/docs/getISOWeekYear}
 *    and [getWeekYear]{@link https://date-fns.org/docs/getWeekYear}).
 *
 * 6. Specific non-location timezones are currently unavailable in `date-fns`,
 *    so right now these tokens fall back to GMT timezones.
 *
 * 7. These patterns are not in the Unicode Technical Standard #35:
 *    - `i`: ISO day of week
 *    - `I`: ISO week of year
 *    - `R`: ISO week-numbering year
 *    - `t`: seconds timestamp
 *    - `T`: milliseconds timestamp
 *    - `o`: ordinal number modifier
 *    - `P`: long localized date
 *    - `p`: long localized time
 *
 * 8. `YY` and `YYYY` tokens represent week-numbering years but they are often confused with years.
 *    You should enable `options.useAdditionalWeekYearTokens` to use them. See: https://git.io/fxCyr
 *
 * 9. `D` and `DD` tokens represent days of the year but they are ofthen confused with days of the month.
 *    You should enable `options.useAdditionalDayOfYearTokens` to use them. See: https://git.io/fxCyr
 *
 * ### v2.0.0 breaking changes:
 *
 * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
 *
 * - The second argument is now required for the sake of explicitness.
 *
 *   ```javascript
 *   // Before v2.0.0
 *   format(new Date(2016, 0, 1))
 *
 *   // v2.0.0 onward
 *   format(new Date(2016, 0, 1), "yyyy-MM-dd'T'HH:mm:ss.SSSxxx")
 *   ```
 *
 * - New format string API for `format` function
 *   which is based on [Unicode Technical Standard #35](https://www.unicode.org/reports/tr35/tr35-dates.html#Date_Field_Symbol_Table).
 *   See [this post](https://blog.date-fns.org/post/unicode-tokens-in-date-fns-v2-sreatyki91jg) for more details.
 *
 * - Characters are now escaped using single quote symbols (`'`) instead of square brackets.
 *
 * @param {Date|Number} date - the original date
 * @param {String} format - the string of tokens
 * @param {Object} [options] - an object with options.
 * @param {Locale} [options.locale=defaultLocale] - the locale object. See [Locale]{@link https://date-fns.org/docs/Locale}
 * @param {0|1|2|3|4|5|6} [options.weekStartsOn=0] - the index of the first day of the week (0 - Sunday)
 * @param {Number} [options.firstWeekContainsDate=1] - the day of January, which is
 * @param {Boolean} [options.useAdditionalWeekYearTokens=false] - if true, allows usage of the week-numbering year tokens `YY` and `YYYY`;
 *   see: https://git.io/fxCyr
 * @param {Boolean} [options.useAdditionalDayOfYearTokens=false] - if true, allows usage of the day of year tokens `D` and `DD`;
 *   see: https://git.io/fxCyr
 * @returns {String} the formatted date string
 * @throws {TypeError} 2 arguments required
 * @throws {RangeError} `date` must not be Invalid Date
 * @throws {RangeError} `options.locale` must contain `localize` property
 * @throws {RangeError} `options.locale` must contain `formatLong` property
 * @throws {RangeError} `options.weekStartsOn` must be between 0 and 6
 * @throws {RangeError} `options.firstWeekContainsDate` must be between 1 and 7
 * @throws {RangeError} use `yyyy` instead of `YYYY` for formatting years using [format provided] to the input [input provided]; see: https://git.io/fxCyr
 * @throws {RangeError} use `yy` instead of `YY` for formatting years using [format provided] to the input [input provided]; see: https://git.io/fxCyr
 * @throws {RangeError} use `d` instead of `D` for formatting days of the month using [format provided] to the input [input provided]; see: https://git.io/fxCyr
 * @throws {RangeError} use `dd` instead of `DD` for formatting days of the month using [format provided] to the input [input provided]; see: https://git.io/fxCyr
 * @throws {RangeError} format string contains an unescaped latin alphabet character
 *
 * @example
 * // Represent 11 February 2014 in middle-endian format:
 * var result = format(new Date(2014, 1, 11), 'MM/dd/yyyy')
 * //=> '02/11/2014'
 *
 * @example
 * // Represent 2 July 2014 in Esperanto:
 * import { eoLocale } from 'date-fns/locale/eo'
 * var result = format(new Date(2014, 6, 2), "do 'de' MMMM yyyy", {
 *   locale: eoLocale
 * })
 * //=> '2-a de julio 2014'
 *
 * @example
 * // Escape string by single quote characters:
 * var result = format(new Date(2014, 6, 2, 15), "h 'o''clock'")
 * //=> "3 o'clock"
 */ function $7e767cfeba790ebe$var$format(dirtyDate, dirtyFormatStr, dirtyOptions) {
    (0, $7e767cfeba790ebe$var$_index10.default)(2, arguments);
    var formatStr = String(dirtyFormatStr);
    var options = dirtyOptions || {};
    var locale = options.locale || $7e767cfeba790ebe$var$_index2.default;
    var localeFirstWeekContainsDate = locale.options && locale.options.firstWeekContainsDate;
    var defaultFirstWeekContainsDate = localeFirstWeekContainsDate == null ? 1 : (0, $7e767cfeba790ebe$var$_index9.default)(localeFirstWeekContainsDate);
    var firstWeekContainsDate = options.firstWeekContainsDate == null ? defaultFirstWeekContainsDate : (0, $7e767cfeba790ebe$var$_index9.default)(options.firstWeekContainsDate); // Test if weekStartsOn is between 1 and 7 _and_ is not NaN
    if (!(firstWeekContainsDate >= 1 && firstWeekContainsDate <= 7)) throw new RangeError('firstWeekContainsDate must be between 1 and 7 inclusively');
    var localeWeekStartsOn = locale.options && locale.options.weekStartsOn;
    var defaultWeekStartsOn = localeWeekStartsOn == null ? 0 : (0, $7e767cfeba790ebe$var$_index9.default)(localeWeekStartsOn);
    var weekStartsOn = options.weekStartsOn == null ? defaultWeekStartsOn : (0, $7e767cfeba790ebe$var$_index9.default)(options.weekStartsOn); // Test if weekStartsOn is between 0 and 6 _and_ is not NaN
    if (!(weekStartsOn >= 0 && weekStartsOn <= 6)) throw new RangeError('weekStartsOn must be between 0 and 6 inclusively');
    if (!locale.localize) throw new RangeError('locale must contain localize property');
    if (!locale.formatLong) throw new RangeError('locale must contain formatLong property');
    var originalDate = (0, $7e767cfeba790ebe$var$_index4.default)(dirtyDate);
    if (!(0, $7e767cfeba790ebe$var$_index.default)(originalDate)) throw new RangeError('Invalid time value');
     // Convert the date in system timezone to the same date in UTC+00:00 timezone.
    // This ensures that when UTC functions will be implemented, locales will be compatible with them.
    // See an issue about UTC functions: https://github.com/date-fns/date-fns/issues/376
    var timezoneOffset = (0, $7e767cfeba790ebe$var$_index7.default)(originalDate);
    var utcDate = (0, $7e767cfeba790ebe$var$_index3.default)(originalDate, timezoneOffset);
    var formatterOptions = {
        firstWeekContainsDate: firstWeekContainsDate,
        weekStartsOn: weekStartsOn,
        locale: locale,
        _originalDate: originalDate
    };
    var result = formatStr.match($7e767cfeba790ebe$var$longFormattingTokensRegExp).map(function(substring) {
        var firstCharacter = substring[0];
        if (firstCharacter === 'p' || firstCharacter === 'P') {
            var longFormatter = $7e767cfeba790ebe$var$_index6.default[firstCharacter];
            return longFormatter(substring, locale.formatLong, formatterOptions);
        }
        return substring;
    }).join('').match($7e767cfeba790ebe$var$formattingTokensRegExp).map(function(substring) {
        // Replace two single quote characters with one single quote character
        if (substring === "''") return "'";
        var firstCharacter = substring[0];
        if (firstCharacter === "'") return $7e767cfeba790ebe$var$cleanEscapedString(substring);
        var formatter = $7e767cfeba790ebe$var$_index5.default[firstCharacter];
        if (formatter) {
            if (!options.useAdditionalWeekYearTokens && (0, $5qguX.isProtectedWeekYearToken)(substring)) (0, $5qguX.throwProtectedError)(substring, dirtyFormatStr, dirtyDate);
            if (!options.useAdditionalDayOfYearTokens && (0, $5qguX.isProtectedDayOfYearToken)(substring)) (0, $5qguX.throwProtectedError)(substring, dirtyFormatStr, dirtyDate);
            return formatter(utcDate, substring, locale.localize, formatterOptions);
        }
        if (firstCharacter.match($7e767cfeba790ebe$var$unescapedLatinCharacterRegExp)) throw new RangeError('Format string contains an unescaped latin alphabet character `' + firstCharacter + '`');
        return substring;
    }).join('');
    return result;
}
function $7e767cfeba790ebe$var$cleanEscapedString(input) {
    return input.match($7e767cfeba790ebe$var$escapedStringRegExp)[1].replace($7e767cfeba790ebe$var$doubleQuoteRegExp, "'");
}
module.exports = module.exports.default;

});
parcelRegister("ck8JK", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $8f8e2146dfa1d727$var$isValid;

var $8f8e2146dfa1d727$var$_index = $8f8e2146dfa1d727$var$_interopRequireDefault((parcelRequire("2pWQP")));

var $8f8e2146dfa1d727$var$_index2 = $8f8e2146dfa1d727$var$_interopRequireDefault((parcelRequire("6eBfj")));
function $8f8e2146dfa1d727$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
/**
 * @name isValid
 * @category Common Helpers
 * @summary Is the given date valid?
 *
 * @description
 * Returns false if argument is Invalid Date and true otherwise.
 * Argument is converted to Date using `toDate`. See [toDate]{@link https://date-fns.org/docs/toDate}
 * Invalid Date is a Date, whose time value is NaN.
 *
 * Time value of Date: http://es5.github.io/#x15.9.1.1
 *
 * ### v2.0.0 breaking changes:
 *
 * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
 *
 * - Now `isValid` doesn't throw an exception
 *   if the first argument is not an instance of Date.
 *   Instead, argument is converted beforehand using `toDate`.
 *
 *   Examples:
 *
 *   | `isValid` argument        | Before v2.0.0 | v2.0.0 onward |
 *   |---------------------------|---------------|---------------|
 *   | `new Date()`              | `true`        | `true`        |
 *   | `new Date('2016-01-01')`  | `true`        | `true`        |
 *   | `new Date('')`            | `false`       | `false`       |
 *   | `new Date(1488370835081)` | `true`        | `true`        |
 *   | `new Date(NaN)`           | `false`       | `false`       |
 *   | `'2016-01-01'`            | `TypeError`   | `false`       |
 *   | `''`                      | `TypeError`   | `false`       |
 *   | `1488370835081`           | `TypeError`   | `true`        |
 *   | `NaN`                     | `TypeError`   | `false`       |
 *
 *   We introduce this change to make *date-fns* consistent with ECMAScript behavior
 *   that try to coerce arguments to the expected type
 *   (which is also the case with other *date-fns* functions).
 *
 * @param {*} date - the date to check
 * @returns {Boolean} the date is valid
 * @throws {TypeError} 1 argument required
 *
 * @example
 * // For the valid date:
 * var result = isValid(new Date(2014, 1, 31))
 * //=> true
 *
 * @example
 * // For the value, convertable into a date:
 * var result = isValid(1393804800000)
 * //=> true
 *
 * @example
 * // For the invalid date:
 * var result = isValid(new Date(''))
 * //=> false
 */ function $8f8e2146dfa1d727$var$isValid(dirtyDate) {
    (0, $8f8e2146dfa1d727$var$_index2.default)(1, arguments);
    var date = (0, $8f8e2146dfa1d727$var$_index.default)(dirtyDate);
    return !isNaN(date);
}
module.exports = module.exports.default;

});
parcelRegister("2pWQP", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $1c2b912e6615b0b5$var$toDate;

var $1c2b912e6615b0b5$var$_index = $1c2b912e6615b0b5$var$_interopRequireDefault((parcelRequire("6eBfj")));
function $1c2b912e6615b0b5$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
/**
 * @name toDate
 * @category Common Helpers
 * @summary Convert the given argument to an instance of Date.
 *
 * @description
 * Convert the given argument to an instance of Date.
 *
 * If the argument is an instance of Date, the function returns its clone.
 *
 * If the argument is a number, it is treated as a timestamp.
 *
 * If the argument is none of the above, the function returns Invalid Date.
 *
 * **Note**: *all* Date arguments passed to any *date-fns* function is processed by `toDate`.
 *
 * @param {Date|Number} argument - the value to convert
 * @returns {Date} the parsed date in the local time zone
 * @throws {TypeError} 1 argument required
 *
 * @example
 * // Clone the date:
 * const result = toDate(new Date(2014, 1, 11, 11, 30, 30))
 * //=> Tue Feb 11 2014 11:30:30
 *
 * @example
 * // Convert the timestamp to date:
 * const result = toDate(1392098430000)
 * //=> Tue Feb 11 2014 11:30:30
 */ function $1c2b912e6615b0b5$var$toDate(argument) {
    (0, $1c2b912e6615b0b5$var$_index.default)(1, arguments);
    var argStr = Object.prototype.toString.call(argument); // Clone the date
    if (argument instanceof Date || typeof argument === 'object' && argStr === '[object Date]') // Prevent the date to lose the milliseconds when passed to new Date() in IE10
    return new Date(argument.getTime());
    else if (typeof argument === 'number' || argStr === '[object Number]') return new Date(argument);
    else {
        if ((typeof argument === 'string' || argStr === '[object String]') && typeof console !== 'undefined') {
            // eslint-disable-next-line no-console
            console.warn("Starting with v2.0.0-beta.1 date-fns doesn't accept strings as date arguments. Please use `parseISO` to parse strings. See: https://git.io/fjule"); // eslint-disable-next-line no-console
            console.warn(new Error().stack);
        }
        return new Date(NaN);
    }
}
module.exports = module.exports.default;

});
parcelRegister("6eBfj", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $48a0f126c2293ab3$var$requiredArgs;
function $48a0f126c2293ab3$var$requiredArgs(required, args) {
    if (args.length < required) throw new TypeError(required + ' argument' + (required > 1 ? 's' : '') + ' required, but only ' + args.length + ' present');
}
module.exports = module.exports.default;

});



parcelRegister("kvNR5", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $eeed6020e120f946$var$_index = $eeed6020e120f946$var$_interopRequireDefault((parcelRequire("5u9TK")));

var $eeed6020e120f946$var$_index2 = $eeed6020e120f946$var$_interopRequireDefault((parcelRequire("e7AgV")));

var $eeed6020e120f946$var$_index3 = $eeed6020e120f946$var$_interopRequireDefault((parcelRequire("8U2eY")));

var $eeed6020e120f946$var$_index4 = $eeed6020e120f946$var$_interopRequireDefault((parcelRequire("b9d75")));

var $eeed6020e120f946$var$_index5 = $eeed6020e120f946$var$_interopRequireDefault((parcelRequire("hHwuU")));
function $eeed6020e120f946$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
/**
 * @type {Locale}
 * @category Locales
 * @summary English locale (United States).
 * @language English
 * @iso-639-2 eng
 * @author Sasha Koss [@kossnocorp]{@link https://github.com/kossnocorp}
 * @author Lesha Koss [@leshakoss]{@link https://github.com/leshakoss}
 */ var $eeed6020e120f946$var$locale = {
    code: 'en-US',
    formatDistance: $eeed6020e120f946$var$_index.default,
    formatLong: $eeed6020e120f946$var$_index2.default,
    formatRelative: $eeed6020e120f946$var$_index3.default,
    localize: $eeed6020e120f946$var$_index4.default,
    match: $eeed6020e120f946$var$_index5.default,
    options: {
        weekStartsOn: 0,
        firstWeekContainsDate: 1
    }
};
var $eeed6020e120f946$var$_default = $eeed6020e120f946$var$locale;
module.exports.default = $eeed6020e120f946$var$_default;
module.exports = module.exports.default;

});
parcelRegister("5u9TK", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $3fe76ea3cd34e32f$var$formatDistance;
var $3fe76ea3cd34e32f$var$formatDistanceLocale = {
    lessThanXSeconds: {
        one: 'less than a second',
        other: 'less than {{count}} seconds'
    },
    xSeconds: {
        one: '1 second',
        other: '{{count}} seconds'
    },
    halfAMinute: 'half a minute',
    lessThanXMinutes: {
        one: 'less than a minute',
        other: 'less than {{count}} minutes'
    },
    xMinutes: {
        one: '1 minute',
        other: '{{count}} minutes'
    },
    aboutXHours: {
        one: 'about 1 hour',
        other: 'about {{count}} hours'
    },
    xHours: {
        one: '1 hour',
        other: '{{count}} hours'
    },
    xDays: {
        one: '1 day',
        other: '{{count}} days'
    },
    aboutXWeeks: {
        one: 'about 1 week',
        other: 'about {{count}} weeks'
    },
    xWeeks: {
        one: '1 week',
        other: '{{count}} weeks'
    },
    aboutXMonths: {
        one: 'about 1 month',
        other: 'about {{count}} months'
    },
    xMonths: {
        one: '1 month',
        other: '{{count}} months'
    },
    aboutXYears: {
        one: 'about 1 year',
        other: 'about {{count}} years'
    },
    xYears: {
        one: '1 year',
        other: '{{count}} years'
    },
    overXYears: {
        one: 'over 1 year',
        other: 'over {{count}} years'
    },
    almostXYears: {
        one: 'almost 1 year',
        other: 'almost {{count}} years'
    }
};
function $3fe76ea3cd34e32f$var$formatDistance(token, count, options) {
    options = options || {};
    var result;
    if (typeof $3fe76ea3cd34e32f$var$formatDistanceLocale[token] === 'string') result = $3fe76ea3cd34e32f$var$formatDistanceLocale[token];
    else if (count === 1) result = $3fe76ea3cd34e32f$var$formatDistanceLocale[token].one;
    else result = $3fe76ea3cd34e32f$var$formatDistanceLocale[token].other.replace('{{count}}', count);
    if (options.addSuffix) {
        if (options.comparison > 0) return 'in ' + result;
        else return result + ' ago';
    }
    return result;
}
module.exports = module.exports.default;

});

parcelRegister("e7AgV", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $a47ddb0366100c31$var$_index = $a47ddb0366100c31$var$_interopRequireDefault((parcelRequire("4raqC")));
function $a47ddb0366100c31$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
var $a47ddb0366100c31$var$dateFormats = {
    full: 'EEEE, MMMM do, y',
    long: 'MMMM do, y',
    medium: 'MMM d, y',
    short: 'MM/dd/yyyy'
};
var $a47ddb0366100c31$var$timeFormats = {
    full: 'h:mm:ss a zzzz',
    long: 'h:mm:ss a z',
    medium: 'h:mm:ss a',
    short: 'h:mm a'
};
var $a47ddb0366100c31$var$dateTimeFormats = {
    full: "{{date}} 'at' {{time}}",
    long: "{{date}} 'at' {{time}}",
    medium: '{{date}}, {{time}}',
    short: '{{date}}, {{time}}'
};
var $a47ddb0366100c31$var$formatLong = {
    date: (0, $a47ddb0366100c31$var$_index.default)({
        formats: $a47ddb0366100c31$var$dateFormats,
        defaultWidth: 'full'
    }),
    time: (0, $a47ddb0366100c31$var$_index.default)({
        formats: $a47ddb0366100c31$var$timeFormats,
        defaultWidth: 'full'
    }),
    dateTime: (0, $a47ddb0366100c31$var$_index.default)({
        formats: $a47ddb0366100c31$var$dateTimeFormats,
        defaultWidth: 'full'
    })
};
var $a47ddb0366100c31$var$_default = $a47ddb0366100c31$var$formatLong;
module.exports.default = $a47ddb0366100c31$var$_default;
module.exports = module.exports.default;

});
parcelRegister("4raqC", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $33b1c5e9f7814c0e$var$buildFormatLongFn;
function $33b1c5e9f7814c0e$var$buildFormatLongFn(args) {
    return function() {
        var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
        // TODO: Remove String()
        var width = options.width ? String(options.width) : args.defaultWidth;
        var format = args.formats[width] || args.formats[args.defaultWidth];
        return format;
    };
}
module.exports = module.exports.default;

});


parcelRegister("8U2eY", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $67b54aa1e07b4b42$var$formatRelative;
var $67b54aa1e07b4b42$var$formatRelativeLocale = {
    lastWeek: "'last' eeee 'at' p",
    yesterday: "'yesterday at' p",
    today: "'today at' p",
    tomorrow: "'tomorrow at' p",
    nextWeek: "eeee 'at' p",
    other: 'P'
};
function $67b54aa1e07b4b42$var$formatRelative(token, _date, _baseDate, _options) {
    return $67b54aa1e07b4b42$var$formatRelativeLocale[token];
}
module.exports = module.exports.default;

});

parcelRegister("b9d75", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $81dab50370972ecd$var$_index = $81dab50370972ecd$var$_interopRequireDefault((parcelRequire("llBmH")));
function $81dab50370972ecd$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
var $81dab50370972ecd$var$eraValues = {
    narrow: [
        'B',
        'A'
    ],
    abbreviated: [
        'BC',
        'AD'
    ],
    wide: [
        'Before Christ',
        'Anno Domini'
    ]
};
var $81dab50370972ecd$var$quarterValues = {
    narrow: [
        '1',
        '2',
        '3',
        '4'
    ],
    abbreviated: [
        'Q1',
        'Q2',
        'Q3',
        'Q4'
    ],
    wide: [
        '1st quarter',
        '2nd quarter',
        '3rd quarter',
        '4th quarter'
    ]
}; // Note: in English, the names of days of the week and months are capitalized.
// If you are making a new locale based on this one, check if the same is true for the language you're working on.
// Generally, formatted dates should look like they are in the middle of a sentence,
// e.g. in Spanish language the weekdays and months should be in the lowercase.
var $81dab50370972ecd$var$monthValues = {
    narrow: [
        'J',
        'F',
        'M',
        'A',
        'M',
        'J',
        'J',
        'A',
        'S',
        'O',
        'N',
        'D'
    ],
    abbreviated: [
        'Jan',
        'Feb',
        'Mar',
        'Apr',
        'May',
        'Jun',
        'Jul',
        'Aug',
        'Sep',
        'Oct',
        'Nov',
        'Dec'
    ],
    wide: [
        'January',
        'February',
        'March',
        'April',
        'May',
        'June',
        'July',
        'August',
        'September',
        'October',
        'November',
        'December'
    ]
};
var $81dab50370972ecd$var$dayValues = {
    narrow: [
        'S',
        'M',
        'T',
        'W',
        'T',
        'F',
        'S'
    ],
    short: [
        'Su',
        'Mo',
        'Tu',
        'We',
        'Th',
        'Fr',
        'Sa'
    ],
    abbreviated: [
        'Sun',
        'Mon',
        'Tue',
        'Wed',
        'Thu',
        'Fri',
        'Sat'
    ],
    wide: [
        'Sunday',
        'Monday',
        'Tuesday',
        'Wednesday',
        'Thursday',
        'Friday',
        'Saturday'
    ]
};
var $81dab50370972ecd$var$dayPeriodValues = {
    narrow: {
        am: 'a',
        pm: 'p',
        midnight: 'mi',
        noon: 'n',
        morning: 'morning',
        afternoon: 'afternoon',
        evening: 'evening',
        night: 'night'
    },
    abbreviated: {
        am: 'AM',
        pm: 'PM',
        midnight: 'midnight',
        noon: 'noon',
        morning: 'morning',
        afternoon: 'afternoon',
        evening: 'evening',
        night: 'night'
    },
    wide: {
        am: 'a.m.',
        pm: 'p.m.',
        midnight: 'midnight',
        noon: 'noon',
        morning: 'morning',
        afternoon: 'afternoon',
        evening: 'evening',
        night: 'night'
    }
};
var $81dab50370972ecd$var$formattingDayPeriodValues = {
    narrow: {
        am: 'a',
        pm: 'p',
        midnight: 'mi',
        noon: 'n',
        morning: 'in the morning',
        afternoon: 'in the afternoon',
        evening: 'in the evening',
        night: 'at night'
    },
    abbreviated: {
        am: 'AM',
        pm: 'PM',
        midnight: 'midnight',
        noon: 'noon',
        morning: 'in the morning',
        afternoon: 'in the afternoon',
        evening: 'in the evening',
        night: 'at night'
    },
    wide: {
        am: 'a.m.',
        pm: 'p.m.',
        midnight: 'midnight',
        noon: 'noon',
        morning: 'in the morning',
        afternoon: 'in the afternoon',
        evening: 'in the evening',
        night: 'at night'
    }
};
function $81dab50370972ecd$var$ordinalNumber(dirtyNumber, _dirtyOptions) {
    var number = Number(dirtyNumber); // If ordinal numbers depend on context, for example,
    // if they are different for different grammatical genders,
    // use `options.unit`:
    //
    //   var options = dirtyOptions || {}
    //   var unit = String(options.unit)
    //
    // where `unit` can be 'year', 'quarter', 'month', 'week', 'date', 'dayOfYear',
    // 'day', 'hour', 'minute', 'second'
    var rem100 = number % 100;
    if (rem100 > 20 || rem100 < 10) switch(rem100 % 10){
        case 1:
            return number + 'st';
        case 2:
            return number + 'nd';
        case 3:
            return number + 'rd';
    }
    return number + 'th';
}
var $81dab50370972ecd$var$localize = {
    ordinalNumber: $81dab50370972ecd$var$ordinalNumber,
    era: (0, $81dab50370972ecd$var$_index.default)({
        values: $81dab50370972ecd$var$eraValues,
        defaultWidth: 'wide'
    }),
    quarter: (0, $81dab50370972ecd$var$_index.default)({
        values: $81dab50370972ecd$var$quarterValues,
        defaultWidth: 'wide',
        argumentCallback: function(quarter) {
            return Number(quarter) - 1;
        }
    }),
    month: (0, $81dab50370972ecd$var$_index.default)({
        values: $81dab50370972ecd$var$monthValues,
        defaultWidth: 'wide'
    }),
    day: (0, $81dab50370972ecd$var$_index.default)({
        values: $81dab50370972ecd$var$dayValues,
        defaultWidth: 'wide'
    }),
    dayPeriod: (0, $81dab50370972ecd$var$_index.default)({
        values: $81dab50370972ecd$var$dayPeriodValues,
        defaultWidth: 'wide',
        formattingValues: $81dab50370972ecd$var$formattingDayPeriodValues,
        defaultFormattingWidth: 'wide'
    })
};
var $81dab50370972ecd$var$_default = $81dab50370972ecd$var$localize;
module.exports.default = $81dab50370972ecd$var$_default;
module.exports = module.exports.default;

});
parcelRegister("llBmH", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $f8a88b0d5d631bc1$var$buildLocalizeFn;
function $f8a88b0d5d631bc1$var$buildLocalizeFn(args) {
    return function(dirtyIndex, dirtyOptions) {
        var options = dirtyOptions || {};
        var context = options.context ? String(options.context) : 'standalone';
        var valuesArray;
        if (context === 'formatting' && args.formattingValues) {
            var defaultWidth = args.defaultFormattingWidth || args.defaultWidth;
            var width = options.width ? String(options.width) : defaultWidth;
            valuesArray = args.formattingValues[width] || args.formattingValues[defaultWidth];
        } else {
            var _defaultWidth = args.defaultWidth;
            var _width = options.width ? String(options.width) : args.defaultWidth;
            valuesArray = args.values[_width] || args.values[_defaultWidth];
        }
        var index = args.argumentCallback ? args.argumentCallback(dirtyIndex) : dirtyIndex; // @ts-ignore: For some reason TypeScript just don't want to match it, no matter how hard we try. I challange you to try to remove it!
        return valuesArray[index];
    };
}
module.exports = module.exports.default;

});


parcelRegister("hHwuU", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $ce2fa922bf4a591b$var$_index = $ce2fa922bf4a591b$var$_interopRequireDefault((parcelRequire("1IY7t")));

var $ce2fa922bf4a591b$var$_index2 = $ce2fa922bf4a591b$var$_interopRequireDefault((parcelRequire("liduU")));
function $ce2fa922bf4a591b$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
var $ce2fa922bf4a591b$var$matchOrdinalNumberPattern = /^(\d+)(th|st|nd|rd)?/i;
var $ce2fa922bf4a591b$var$parseOrdinalNumberPattern = /\d+/i;
var $ce2fa922bf4a591b$var$matchEraPatterns = {
    narrow: /^(b|a)/i,
    abbreviated: /^(b\.?\s?c\.?|b\.?\s?c\.?\s?e\.?|a\.?\s?d\.?|c\.?\s?e\.?)/i,
    wide: /^(before christ|before common era|anno domini|common era)/i
};
var $ce2fa922bf4a591b$var$parseEraPatterns = {
    any: [
        /^b/i,
        /^(a|c)/i
    ]
};
var $ce2fa922bf4a591b$var$matchQuarterPatterns = {
    narrow: /^[1234]/i,
    abbreviated: /^q[1234]/i,
    wide: /^[1234](th|st|nd|rd)? quarter/i
};
var $ce2fa922bf4a591b$var$parseQuarterPatterns = {
    any: [
        /1/i,
        /2/i,
        /3/i,
        /4/i
    ]
};
var $ce2fa922bf4a591b$var$matchMonthPatterns = {
    narrow: /^[jfmasond]/i,
    abbreviated: /^(jan|feb|mar|apr|may|jun|jul|aug|sep|oct|nov|dec)/i,
    wide: /^(january|february|march|april|may|june|july|august|september|october|november|december)/i
};
var $ce2fa922bf4a591b$var$parseMonthPatterns = {
    narrow: [
        /^j/i,
        /^f/i,
        /^m/i,
        /^a/i,
        /^m/i,
        /^j/i,
        /^j/i,
        /^a/i,
        /^s/i,
        /^o/i,
        /^n/i,
        /^d/i
    ],
    any: [
        /^ja/i,
        /^f/i,
        /^mar/i,
        /^ap/i,
        /^may/i,
        /^jun/i,
        /^jul/i,
        /^au/i,
        /^s/i,
        /^o/i,
        /^n/i,
        /^d/i
    ]
};
var $ce2fa922bf4a591b$var$matchDayPatterns = {
    narrow: /^[smtwf]/i,
    short: /^(su|mo|tu|we|th|fr|sa)/i,
    abbreviated: /^(sun|mon|tue|wed|thu|fri|sat)/i,
    wide: /^(sunday|monday|tuesday|wednesday|thursday|friday|saturday)/i
};
var $ce2fa922bf4a591b$var$parseDayPatterns = {
    narrow: [
        /^s/i,
        /^m/i,
        /^t/i,
        /^w/i,
        /^t/i,
        /^f/i,
        /^s/i
    ],
    any: [
        /^su/i,
        /^m/i,
        /^tu/i,
        /^w/i,
        /^th/i,
        /^f/i,
        /^sa/i
    ]
};
var $ce2fa922bf4a591b$var$matchDayPeriodPatterns = {
    narrow: /^(a|p|mi|n|(in the|at) (morning|afternoon|evening|night))/i,
    any: /^([ap]\.?\s?m\.?|midnight|noon|(in the|at) (morning|afternoon|evening|night))/i
};
var $ce2fa922bf4a591b$var$parseDayPeriodPatterns = {
    any: {
        am: /^a/i,
        pm: /^p/i,
        midnight: /^mi/i,
        noon: /^no/i,
        morning: /morning/i,
        afternoon: /afternoon/i,
        evening: /evening/i,
        night: /night/i
    }
};
var $ce2fa922bf4a591b$var$match = {
    ordinalNumber: (0, $ce2fa922bf4a591b$var$_index.default)({
        matchPattern: $ce2fa922bf4a591b$var$matchOrdinalNumberPattern,
        parsePattern: $ce2fa922bf4a591b$var$parseOrdinalNumberPattern,
        valueCallback: function(value) {
            return parseInt(value, 10);
        }
    }),
    era: (0, $ce2fa922bf4a591b$var$_index2.default)({
        matchPatterns: $ce2fa922bf4a591b$var$matchEraPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: $ce2fa922bf4a591b$var$parseEraPatterns,
        defaultParseWidth: 'any'
    }),
    quarter: (0, $ce2fa922bf4a591b$var$_index2.default)({
        matchPatterns: $ce2fa922bf4a591b$var$matchQuarterPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: $ce2fa922bf4a591b$var$parseQuarterPatterns,
        defaultParseWidth: 'any',
        valueCallback: function(index) {
            return index + 1;
        }
    }),
    month: (0, $ce2fa922bf4a591b$var$_index2.default)({
        matchPatterns: $ce2fa922bf4a591b$var$matchMonthPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: $ce2fa922bf4a591b$var$parseMonthPatterns,
        defaultParseWidth: 'any'
    }),
    day: (0, $ce2fa922bf4a591b$var$_index2.default)({
        matchPatterns: $ce2fa922bf4a591b$var$matchDayPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: $ce2fa922bf4a591b$var$parseDayPatterns,
        defaultParseWidth: 'any'
    }),
    dayPeriod: (0, $ce2fa922bf4a591b$var$_index2.default)({
        matchPatterns: $ce2fa922bf4a591b$var$matchDayPeriodPatterns,
        defaultMatchWidth: 'any',
        parsePatterns: $ce2fa922bf4a591b$var$parseDayPeriodPatterns,
        defaultParseWidth: 'any'
    })
};
var $ce2fa922bf4a591b$var$_default = $ce2fa922bf4a591b$var$match;
module.exports.default = $ce2fa922bf4a591b$var$_default;
module.exports = module.exports.default;

});
parcelRegister("1IY7t", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $141888fa04c95812$var$buildMatchPatternFn;
function $141888fa04c95812$var$buildMatchPatternFn(args) {
    return function(string) {
        var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
        var matchResult = string.match(args.matchPattern);
        if (!matchResult) return null;
        var matchedString = matchResult[0];
        var parseResult = string.match(args.parsePattern);
        if (!parseResult) return null;
        var value = args.valueCallback ? args.valueCallback(parseResult[0]) : parseResult[0];
        value = options.valueCallback ? options.valueCallback(value) : value;
        var rest = string.slice(matchedString.length);
        return {
            value: value,
            rest: rest
        };
    };
}
module.exports = module.exports.default;

});

parcelRegister("liduU", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $f805bfb7f96f3bcc$var$buildMatchFn;
function $f805bfb7f96f3bcc$var$buildMatchFn(args) {
    return function(string) {
        var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
        var width = options.width;
        var matchPattern = width && args.matchPatterns[width] || args.matchPatterns[args.defaultMatchWidth];
        var matchResult = string.match(matchPattern);
        if (!matchResult) return null;
        var matchedString = matchResult[0];
        var parsePatterns = width && args.parsePatterns[width] || args.parsePatterns[args.defaultParseWidth];
        var key = Array.isArray(parsePatterns) ? $f805bfb7f96f3bcc$var$findIndex(parsePatterns, function(pattern) {
            return pattern.test(matchedString);
        }) : $f805bfb7f96f3bcc$var$findKey(parsePatterns, function(pattern) {
            return pattern.test(matchedString);
        });
        var value;
        value = args.valueCallback ? args.valueCallback(key) : key;
        value = options.valueCallback ? options.valueCallback(value) : value;
        var rest = string.slice(matchedString.length);
        return {
            value: value,
            rest: rest
        };
    };
}
function $f805bfb7f96f3bcc$var$findKey(object, predicate) {
    for(var key in object){
        if (object.hasOwnProperty(key) && predicate(object[key])) return key;
    }
    return undefined;
}
function $f805bfb7f96f3bcc$var$findIndex(array, predicate) {
    for(var key = 0; key < array.length; key++){
        if (predicate(array[key])) return key;
    }
    return undefined;
}
module.exports = module.exports.default;

});



parcelRegister("bQkcE", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $89f438ee982b4fb2$var$subMilliseconds;

var $89f438ee982b4fb2$var$_index = $89f438ee982b4fb2$var$_interopRequireDefault((parcelRequire("aSksP")));

var $89f438ee982b4fb2$var$_index2 = $89f438ee982b4fb2$var$_interopRequireDefault((parcelRequire("7f9OM")));

var $89f438ee982b4fb2$var$_index3 = $89f438ee982b4fb2$var$_interopRequireDefault((parcelRequire("6eBfj")));
function $89f438ee982b4fb2$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
/**
 * @name subMilliseconds
 * @category Millisecond Helpers
 * @summary Subtract the specified number of milliseconds from the given date.
 *
 * @description
 * Subtract the specified number of milliseconds from the given date.
 *
 * ### v2.0.0 breaking changes:
 *
 * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
 *
 * @param {Date|Number} date - the date to be changed
 * @param {Number} amount - the amount of milliseconds to be subtracted. Positive decimals will be rounded using `Math.floor`, decimals less than zero will be rounded using `Math.ceil`.
 * @returns {Date} the new date with the milliseconds subtracted
 * @throws {TypeError} 2 arguments required
 *
 * @example
 * // Subtract 750 milliseconds from 10 July 2014 12:45:30.000:
 * const result = subMilliseconds(new Date(2014, 6, 10, 12, 45, 30, 0), 750)
 * //=> Thu Jul 10 2014 12:45:29.250
 */ function $89f438ee982b4fb2$var$subMilliseconds(dirtyDate, dirtyAmount) {
    (0, $89f438ee982b4fb2$var$_index3.default)(2, arguments);
    var amount = (0, $89f438ee982b4fb2$var$_index.default)(dirtyAmount);
    return (0, $89f438ee982b4fb2$var$_index2.default)(dirtyDate, -amount);
}
module.exports = module.exports.default;

});
parcelRegister("aSksP", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $7eaed23c7cdcf6c0$var$toInteger;
function $7eaed23c7cdcf6c0$var$toInteger(dirtyNumber) {
    if (dirtyNumber === null || dirtyNumber === true || dirtyNumber === false) return NaN;
    var number = Number(dirtyNumber);
    if (isNaN(number)) return number;
    return number < 0 ? Math.ceil(number) : Math.floor(number);
}
module.exports = module.exports.default;

});

parcelRegister("7f9OM", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $54618cc00c3fb8fc$var$addMilliseconds;

var $54618cc00c3fb8fc$var$_index = $54618cc00c3fb8fc$var$_interopRequireDefault((parcelRequire("aSksP")));

var $54618cc00c3fb8fc$var$_index2 = $54618cc00c3fb8fc$var$_interopRequireDefault((parcelRequire("2pWQP")));

var $54618cc00c3fb8fc$var$_index3 = $54618cc00c3fb8fc$var$_interopRequireDefault((parcelRequire("6eBfj")));
function $54618cc00c3fb8fc$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
/**
 * @name addMilliseconds
 * @category Millisecond Helpers
 * @summary Add the specified number of milliseconds to the given date.
 *
 * @description
 * Add the specified number of milliseconds to the given date.
 *
 * ### v2.0.0 breaking changes:
 *
 * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
 *
 * @param {Date|Number} date - the date to be changed
 * @param {Number} amount - the amount of milliseconds to be added. Positive decimals will be rounded using `Math.floor`, decimals less than zero will be rounded using `Math.ceil`.
 * @returns {Date} the new date with the milliseconds added
 * @throws {TypeError} 2 arguments required
 *
 * @example
 * // Add 750 milliseconds to 10 July 2014 12:45:30.000:
 * const result = addMilliseconds(new Date(2014, 6, 10, 12, 45, 30, 0), 750)
 * //=> Thu Jul 10 2014 12:45:30.750
 */ function $54618cc00c3fb8fc$var$addMilliseconds(dirtyDate, dirtyAmount) {
    (0, $54618cc00c3fb8fc$var$_index3.default)(2, arguments);
    var timestamp = (0, $54618cc00c3fb8fc$var$_index2.default)(dirtyDate).getTime();
    var amount = (0, $54618cc00c3fb8fc$var$_index.default)(dirtyAmount);
    return new Date(timestamp + amount);
}
module.exports = module.exports.default;

});


parcelRegister("3ckvK", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $2542672a600cd2b8$var$_index = $2542672a600cd2b8$var$_interopRequireDefault((parcelRequire("kFGp1")));

var $2542672a600cd2b8$var$_index2 = $2542672a600cd2b8$var$_interopRequireDefault((parcelRequire("3xdEO")));

var $2542672a600cd2b8$var$_index3 = $2542672a600cd2b8$var$_interopRequireDefault((parcelRequire("6Falt")));

var $2542672a600cd2b8$var$_index4 = $2542672a600cd2b8$var$_interopRequireDefault((parcelRequire("gUvh1")));

var $2542672a600cd2b8$var$_index5 = $2542672a600cd2b8$var$_interopRequireDefault((parcelRequire("46m4m")));

var $2542672a600cd2b8$var$_index6 = $2542672a600cd2b8$var$_interopRequireDefault((parcelRequire("3ihh3")));

var $2542672a600cd2b8$var$_index7 = $2542672a600cd2b8$var$_interopRequireDefault((parcelRequire("bQ2eo")));
function $2542672a600cd2b8$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
var $2542672a600cd2b8$var$dayPeriodEnum = {
    am: 'am',
    pm: 'pm',
    midnight: 'midnight',
    noon: 'noon',
    morning: 'morning',
    afternoon: 'afternoon',
    evening: 'evening',
    night: 'night'
};
/*
 * |     | Unit                           |     | Unit                           |
 * |-----|--------------------------------|-----|--------------------------------|
 * |  a  | AM, PM                         |  A* | Milliseconds in day            |
 * |  b  | AM, PM, noon, midnight         |  B  | Flexible day period            |
 * |  c  | Stand-alone local day of week  |  C* | Localized hour w/ day period   |
 * |  d  | Day of month                   |  D  | Day of year                    |
 * |  e  | Local day of week              |  E  | Day of week                    |
 * |  f  |                                |  F* | Day of week in month           |
 * |  g* | Modified Julian day            |  G  | Era                            |
 * |  h  | Hour [1-12]                    |  H  | Hour [0-23]                    |
 * |  i! | ISO day of week                |  I! | ISO week of year               |
 * |  j* | Localized hour w/ day period   |  J* | Localized hour w/o day period  |
 * |  k  | Hour [1-24]                    |  K  | Hour [0-11]                    |
 * |  l* | (deprecated)                   |  L  | Stand-alone month              |
 * |  m  | Minute                         |  M  | Month                          |
 * |  n  |                                |  N  |                                |
 * |  o! | Ordinal number modifier        |  O  | Timezone (GMT)                 |
 * |  p! | Long localized time            |  P! | Long localized date            |
 * |  q  | Stand-alone quarter            |  Q  | Quarter                        |
 * |  r* | Related Gregorian year         |  R! | ISO week-numbering year        |
 * |  s  | Second                         |  S  | Fraction of second             |
 * |  t! | Seconds timestamp              |  T! | Milliseconds timestamp         |
 * |  u  | Extended year                  |  U* | Cyclic year                    |
 * |  v* | Timezone (generic non-locat.)  |  V* | Timezone (location)            |
 * |  w  | Local week of year             |  W* | Week of month                  |
 * |  x  | Timezone (ISO-8601 w/o Z)      |  X  | Timezone (ISO-8601)            |
 * |  y  | Year (abs)                     |  Y  | Local week-numbering year      |
 * |  z  | Timezone (specific non-locat.) |  Z* | Timezone (aliases)             |
 *
 * Letters marked by * are not implemented but reserved by Unicode standard.
 *
 * Letters marked by ! are non-standard, but implemented by date-fns:
 * - `o` modifies the previous token to turn it into an ordinal (see `format` docs)
 * - `i` is ISO day of week. For `i` and `ii` is returns numeric ISO week days,
 *   i.e. 7 for Sunday, 1 for Monday, etc.
 * - `I` is ISO week of year, as opposed to `w` which is local week of year.
 * - `R` is ISO week-numbering year, as opposed to `Y` which is local week-numbering year.
 *   `R` is supposed to be used in conjunction with `I` and `i`
 *   for universal ISO week-numbering date, whereas
 *   `Y` is supposed to be used in conjunction with `w` and `e`
 *   for week-numbering date specific to the locale.
 * - `P` is long localized date format
 * - `p` is long localized time format
 */ var $2542672a600cd2b8$var$formatters = {
    // Era
    G: function(date, token, localize) {
        var era = date.getUTCFullYear() > 0 ? 1 : 0;
        switch(token){
            // AD, BC
            case 'G':
            case 'GG':
            case 'GGG':
                return localize.era(era, {
                    width: 'abbreviated'
                });
            // A, B
            case 'GGGGG':
                return localize.era(era, {
                    width: 'narrow'
                });
            // Anno Domini, Before Christ
            case 'GGGG':
            default:
                return localize.era(era, {
                    width: 'wide'
                });
        }
    },
    // Year
    y: function(date, token, localize) {
        // Ordinal number
        if (token === 'yo') {
            var signedYear = date.getUTCFullYear(); // Returns 1 for 1 BC (which is year 0 in JavaScript)
            var year = signedYear > 0 ? signedYear : 1 - signedYear;
            return localize.ordinalNumber(year, {
                unit: 'year'
            });
        }
        return $2542672a600cd2b8$var$_index.default.y(date, token);
    },
    // Local week-numbering year
    Y: function(date, token, localize, options) {
        var signedWeekYear = (0, $2542672a600cd2b8$var$_index6.default)(date, options); // Returns 1 for 1 BC (which is year 0 in JavaScript)
        var weekYear = signedWeekYear > 0 ? signedWeekYear : 1 - signedWeekYear; // Two digit year
        if (token === 'YY') {
            var twoDigitYear = weekYear % 100;
            return (0, $2542672a600cd2b8$var$_index7.default)(twoDigitYear, 2);
        } // Ordinal number
        if (token === 'Yo') return localize.ordinalNumber(weekYear, {
            unit: 'year'
        });
         // Padding
        return (0, $2542672a600cd2b8$var$_index7.default)(weekYear, token.length);
    },
    // ISO week-numbering year
    R: function(date, token) {
        var isoWeekYear = (0, $2542672a600cd2b8$var$_index4.default)(date); // Padding
        return (0, $2542672a600cd2b8$var$_index7.default)(isoWeekYear, token.length);
    },
    // Extended year. This is a single number designating the year of this calendar system.
    // The main difference between `y` and `u` localizers are B.C. years:
    // | Year | `y` | `u` |
    // |------|-----|-----|
    // | AC 1 |   1 |   1 |
    // | BC 1 |   1 |   0 |
    // | BC 2 |   2 |  -1 |
    // Also `yy` always returns the last two digits of a year,
    // while `uu` pads single digit years to 2 characters and returns other years unchanged.
    u: function(date, token) {
        var year = date.getUTCFullYear();
        return (0, $2542672a600cd2b8$var$_index7.default)(year, token.length);
    },
    // Quarter
    Q: function(date, token, localize) {
        var quarter = Math.ceil((date.getUTCMonth() + 1) / 3);
        switch(token){
            // 1, 2, 3, 4
            case 'Q':
                return String(quarter);
            // 01, 02, 03, 04
            case 'QQ':
                return (0, $2542672a600cd2b8$var$_index7.default)(quarter, 2);
            // 1st, 2nd, 3rd, 4th
            case 'Qo':
                return localize.ordinalNumber(quarter, {
                    unit: 'quarter'
                });
            // Q1, Q2, Q3, Q4
            case 'QQQ':
                return localize.quarter(quarter, {
                    width: 'abbreviated',
                    context: 'formatting'
                });
            // 1, 2, 3, 4 (narrow quarter; could be not numerical)
            case 'QQQQQ':
                return localize.quarter(quarter, {
                    width: 'narrow',
                    context: 'formatting'
                });
            // 1st quarter, 2nd quarter, ...
            case 'QQQQ':
            default:
                return localize.quarter(quarter, {
                    width: 'wide',
                    context: 'formatting'
                });
        }
    },
    // Stand-alone quarter
    q: function(date, token, localize) {
        var quarter = Math.ceil((date.getUTCMonth() + 1) / 3);
        switch(token){
            // 1, 2, 3, 4
            case 'q':
                return String(quarter);
            // 01, 02, 03, 04
            case 'qq':
                return (0, $2542672a600cd2b8$var$_index7.default)(quarter, 2);
            // 1st, 2nd, 3rd, 4th
            case 'qo':
                return localize.ordinalNumber(quarter, {
                    unit: 'quarter'
                });
            // Q1, Q2, Q3, Q4
            case 'qqq':
                return localize.quarter(quarter, {
                    width: 'abbreviated',
                    context: 'standalone'
                });
            // 1, 2, 3, 4 (narrow quarter; could be not numerical)
            case 'qqqqq':
                return localize.quarter(quarter, {
                    width: 'narrow',
                    context: 'standalone'
                });
            // 1st quarter, 2nd quarter, ...
            case 'qqqq':
            default:
                return localize.quarter(quarter, {
                    width: 'wide',
                    context: 'standalone'
                });
        }
    },
    // Month
    M: function(date, token, localize) {
        var month = date.getUTCMonth();
        switch(token){
            case 'M':
            case 'MM':
                return $2542672a600cd2b8$var$_index.default.M(date, token);
            // 1st, 2nd, ..., 12th
            case 'Mo':
                return localize.ordinalNumber(month + 1, {
                    unit: 'month'
                });
            // Jan, Feb, ..., Dec
            case 'MMM':
                return localize.month(month, {
                    width: 'abbreviated',
                    context: 'formatting'
                });
            // J, F, ..., D
            case 'MMMMM':
                return localize.month(month, {
                    width: 'narrow',
                    context: 'formatting'
                });
            // January, February, ..., December
            case 'MMMM':
            default:
                return localize.month(month, {
                    width: 'wide',
                    context: 'formatting'
                });
        }
    },
    // Stand-alone month
    L: function(date, token, localize) {
        var month = date.getUTCMonth();
        switch(token){
            // 1, 2, ..., 12
            case 'L':
                return String(month + 1);
            // 01, 02, ..., 12
            case 'LL':
                return (0, $2542672a600cd2b8$var$_index7.default)(month + 1, 2);
            // 1st, 2nd, ..., 12th
            case 'Lo':
                return localize.ordinalNumber(month + 1, {
                    unit: 'month'
                });
            // Jan, Feb, ..., Dec
            case 'LLL':
                return localize.month(month, {
                    width: 'abbreviated',
                    context: 'standalone'
                });
            // J, F, ..., D
            case 'LLLLL':
                return localize.month(month, {
                    width: 'narrow',
                    context: 'standalone'
                });
            // January, February, ..., December
            case 'LLLL':
            default:
                return localize.month(month, {
                    width: 'wide',
                    context: 'standalone'
                });
        }
    },
    // Local week of year
    w: function(date, token, localize, options) {
        var week = (0, $2542672a600cd2b8$var$_index5.default)(date, options);
        if (token === 'wo') return localize.ordinalNumber(week, {
            unit: 'week'
        });
        return (0, $2542672a600cd2b8$var$_index7.default)(week, token.length);
    },
    // ISO week of year
    I: function(date, token, localize) {
        var isoWeek = (0, $2542672a600cd2b8$var$_index3.default)(date);
        if (token === 'Io') return localize.ordinalNumber(isoWeek, {
            unit: 'week'
        });
        return (0, $2542672a600cd2b8$var$_index7.default)(isoWeek, token.length);
    },
    // Day of the month
    d: function(date, token, localize) {
        if (token === 'do') return localize.ordinalNumber(date.getUTCDate(), {
            unit: 'date'
        });
        return $2542672a600cd2b8$var$_index.default.d(date, token);
    },
    // Day of year
    D: function(date, token, localize) {
        var dayOfYear = (0, $2542672a600cd2b8$var$_index2.default)(date);
        if (token === 'Do') return localize.ordinalNumber(dayOfYear, {
            unit: 'dayOfYear'
        });
        return (0, $2542672a600cd2b8$var$_index7.default)(dayOfYear, token.length);
    },
    // Day of week
    E: function(date, token, localize) {
        var dayOfWeek = date.getUTCDay();
        switch(token){
            // Tue
            case 'E':
            case 'EE':
            case 'EEE':
                return localize.day(dayOfWeek, {
                    width: 'abbreviated',
                    context: 'formatting'
                });
            // T
            case 'EEEEE':
                return localize.day(dayOfWeek, {
                    width: 'narrow',
                    context: 'formatting'
                });
            // Tu
            case 'EEEEEE':
                return localize.day(dayOfWeek, {
                    width: 'short',
                    context: 'formatting'
                });
            // Tuesday
            case 'EEEE':
            default:
                return localize.day(dayOfWeek, {
                    width: 'wide',
                    context: 'formatting'
                });
        }
    },
    // Local day of week
    e: function(date, token, localize, options) {
        var dayOfWeek = date.getUTCDay();
        var localDayOfWeek = (dayOfWeek - options.weekStartsOn + 8) % 7 || 7;
        switch(token){
            // Numerical value (Nth day of week with current locale or weekStartsOn)
            case 'e':
                return String(localDayOfWeek);
            // Padded numerical value
            case 'ee':
                return (0, $2542672a600cd2b8$var$_index7.default)(localDayOfWeek, 2);
            // 1st, 2nd, ..., 7th
            case 'eo':
                return localize.ordinalNumber(localDayOfWeek, {
                    unit: 'day'
                });
            case 'eee':
                return localize.day(dayOfWeek, {
                    width: 'abbreviated',
                    context: 'formatting'
                });
            // T
            case 'eeeee':
                return localize.day(dayOfWeek, {
                    width: 'narrow',
                    context: 'formatting'
                });
            // Tu
            case 'eeeeee':
                return localize.day(dayOfWeek, {
                    width: 'short',
                    context: 'formatting'
                });
            // Tuesday
            case 'eeee':
            default:
                return localize.day(dayOfWeek, {
                    width: 'wide',
                    context: 'formatting'
                });
        }
    },
    // Stand-alone local day of week
    c: function(date, token, localize, options) {
        var dayOfWeek = date.getUTCDay();
        var localDayOfWeek = (dayOfWeek - options.weekStartsOn + 8) % 7 || 7;
        switch(token){
            // Numerical value (same as in `e`)
            case 'c':
                return String(localDayOfWeek);
            // Padded numerical value
            case 'cc':
                return (0, $2542672a600cd2b8$var$_index7.default)(localDayOfWeek, token.length);
            // 1st, 2nd, ..., 7th
            case 'co':
                return localize.ordinalNumber(localDayOfWeek, {
                    unit: 'day'
                });
            case 'ccc':
                return localize.day(dayOfWeek, {
                    width: 'abbreviated',
                    context: 'standalone'
                });
            // T
            case 'ccccc':
                return localize.day(dayOfWeek, {
                    width: 'narrow',
                    context: 'standalone'
                });
            // Tu
            case 'cccccc':
                return localize.day(dayOfWeek, {
                    width: 'short',
                    context: 'standalone'
                });
            // Tuesday
            case 'cccc':
            default:
                return localize.day(dayOfWeek, {
                    width: 'wide',
                    context: 'standalone'
                });
        }
    },
    // ISO day of week
    i: function(date, token, localize) {
        var dayOfWeek = date.getUTCDay();
        var isoDayOfWeek = dayOfWeek === 0 ? 7 : dayOfWeek;
        switch(token){
            // 2
            case 'i':
                return String(isoDayOfWeek);
            // 02
            case 'ii':
                return (0, $2542672a600cd2b8$var$_index7.default)(isoDayOfWeek, token.length);
            // 2nd
            case 'io':
                return localize.ordinalNumber(isoDayOfWeek, {
                    unit: 'day'
                });
            // Tue
            case 'iii':
                return localize.day(dayOfWeek, {
                    width: 'abbreviated',
                    context: 'formatting'
                });
            // T
            case 'iiiii':
                return localize.day(dayOfWeek, {
                    width: 'narrow',
                    context: 'formatting'
                });
            // Tu
            case 'iiiiii':
                return localize.day(dayOfWeek, {
                    width: 'short',
                    context: 'formatting'
                });
            // Tuesday
            case 'iiii':
            default:
                return localize.day(dayOfWeek, {
                    width: 'wide',
                    context: 'formatting'
                });
        }
    },
    // AM or PM
    a: function(date, token, localize) {
        var hours = date.getUTCHours();
        var dayPeriodEnumValue = hours / 12 >= 1 ? 'pm' : 'am';
        switch(token){
            case 'a':
            case 'aa':
                return localize.dayPeriod(dayPeriodEnumValue, {
                    width: 'abbreviated',
                    context: 'formatting'
                });
            case 'aaa':
                return localize.dayPeriod(dayPeriodEnumValue, {
                    width: 'abbreviated',
                    context: 'formatting'
                }).toLowerCase();
            case 'aaaaa':
                return localize.dayPeriod(dayPeriodEnumValue, {
                    width: 'narrow',
                    context: 'formatting'
                });
            case 'aaaa':
            default:
                return localize.dayPeriod(dayPeriodEnumValue, {
                    width: 'wide',
                    context: 'formatting'
                });
        }
    },
    // AM, PM, midnight, noon
    b: function(date, token, localize) {
        var hours = date.getUTCHours();
        var dayPeriodEnumValue;
        if (hours === 12) dayPeriodEnumValue = $2542672a600cd2b8$var$dayPeriodEnum.noon;
        else if (hours === 0) dayPeriodEnumValue = $2542672a600cd2b8$var$dayPeriodEnum.midnight;
        else dayPeriodEnumValue = hours / 12 >= 1 ? 'pm' : 'am';
        switch(token){
            case 'b':
            case 'bb':
                return localize.dayPeriod(dayPeriodEnumValue, {
                    width: 'abbreviated',
                    context: 'formatting'
                });
            case 'bbb':
                return localize.dayPeriod(dayPeriodEnumValue, {
                    width: 'abbreviated',
                    context: 'formatting'
                }).toLowerCase();
            case 'bbbbb':
                return localize.dayPeriod(dayPeriodEnumValue, {
                    width: 'narrow',
                    context: 'formatting'
                });
            case 'bbbb':
            default:
                return localize.dayPeriod(dayPeriodEnumValue, {
                    width: 'wide',
                    context: 'formatting'
                });
        }
    },
    // in the morning, in the afternoon, in the evening, at night
    B: function(date, token, localize) {
        var hours = date.getUTCHours();
        var dayPeriodEnumValue;
        if (hours >= 17) dayPeriodEnumValue = $2542672a600cd2b8$var$dayPeriodEnum.evening;
        else if (hours >= 12) dayPeriodEnumValue = $2542672a600cd2b8$var$dayPeriodEnum.afternoon;
        else if (hours >= 4) dayPeriodEnumValue = $2542672a600cd2b8$var$dayPeriodEnum.morning;
        else dayPeriodEnumValue = $2542672a600cd2b8$var$dayPeriodEnum.night;
        switch(token){
            case 'B':
            case 'BB':
            case 'BBB':
                return localize.dayPeriod(dayPeriodEnumValue, {
                    width: 'abbreviated',
                    context: 'formatting'
                });
            case 'BBBBB':
                return localize.dayPeriod(dayPeriodEnumValue, {
                    width: 'narrow',
                    context: 'formatting'
                });
            case 'BBBB':
            default:
                return localize.dayPeriod(dayPeriodEnumValue, {
                    width: 'wide',
                    context: 'formatting'
                });
        }
    },
    // Hour [1-12]
    h: function(date, token, localize) {
        if (token === 'ho') {
            var hours = date.getUTCHours() % 12;
            if (hours === 0) hours = 12;
            return localize.ordinalNumber(hours, {
                unit: 'hour'
            });
        }
        return $2542672a600cd2b8$var$_index.default.h(date, token);
    },
    // Hour [0-23]
    H: function(date, token, localize) {
        if (token === 'Ho') return localize.ordinalNumber(date.getUTCHours(), {
            unit: 'hour'
        });
        return $2542672a600cd2b8$var$_index.default.H(date, token);
    },
    // Hour [0-11]
    K: function(date, token, localize) {
        var hours = date.getUTCHours() % 12;
        if (token === 'Ko') return localize.ordinalNumber(hours, {
            unit: 'hour'
        });
        return (0, $2542672a600cd2b8$var$_index7.default)(hours, token.length);
    },
    // Hour [1-24]
    k: function(date, token, localize) {
        var hours = date.getUTCHours();
        if (hours === 0) hours = 24;
        if (token === 'ko') return localize.ordinalNumber(hours, {
            unit: 'hour'
        });
        return (0, $2542672a600cd2b8$var$_index7.default)(hours, token.length);
    },
    // Minute
    m: function(date, token, localize) {
        if (token === 'mo') return localize.ordinalNumber(date.getUTCMinutes(), {
            unit: 'minute'
        });
        return $2542672a600cd2b8$var$_index.default.m(date, token);
    },
    // Second
    s: function(date, token, localize) {
        if (token === 'so') return localize.ordinalNumber(date.getUTCSeconds(), {
            unit: 'second'
        });
        return $2542672a600cd2b8$var$_index.default.s(date, token);
    },
    // Fraction of second
    S: function(date, token) {
        return $2542672a600cd2b8$var$_index.default.S(date, token);
    },
    // Timezone (ISO-8601. If offset is 0, output is always `'Z'`)
    X: function(date, token, _localize, options) {
        var originalDate = options._originalDate || date;
        var timezoneOffset = originalDate.getTimezoneOffset();
        if (timezoneOffset === 0) return 'Z';
        switch(token){
            // Hours and optional minutes
            case 'X':
                return $2542672a600cd2b8$var$formatTimezoneWithOptionalMinutes(timezoneOffset);
            // Hours, minutes and optional seconds without `:` delimiter
            // Note: neither ISO-8601 nor JavaScript supports seconds in timezone offsets
            // so this token always has the same output as `XX`
            case 'XXXX':
            case 'XX':
                // Hours and minutes without `:` delimiter
                return $2542672a600cd2b8$var$formatTimezone(timezoneOffset);
            // Hours, minutes and optional seconds with `:` delimiter
            // Note: neither ISO-8601 nor JavaScript supports seconds in timezone offsets
            // so this token always has the same output as `XXX`
            case 'XXXXX':
            case 'XXX':
            default:
                return $2542672a600cd2b8$var$formatTimezone(timezoneOffset, ':');
        }
    },
    // Timezone (ISO-8601. If offset is 0, output is `'+00:00'` or equivalent)
    x: function(date, token, _localize, options) {
        var originalDate = options._originalDate || date;
        var timezoneOffset = originalDate.getTimezoneOffset();
        switch(token){
            // Hours and optional minutes
            case 'x':
                return $2542672a600cd2b8$var$formatTimezoneWithOptionalMinutes(timezoneOffset);
            // Hours, minutes and optional seconds without `:` delimiter
            // Note: neither ISO-8601 nor JavaScript supports seconds in timezone offsets
            // so this token always has the same output as `xx`
            case 'xxxx':
            case 'xx':
                // Hours and minutes without `:` delimiter
                return $2542672a600cd2b8$var$formatTimezone(timezoneOffset);
            // Hours, minutes and optional seconds with `:` delimiter
            // Note: neither ISO-8601 nor JavaScript supports seconds in timezone offsets
            // so this token always has the same output as `xxx`
            case 'xxxxx':
            case 'xxx':
            default:
                return $2542672a600cd2b8$var$formatTimezone(timezoneOffset, ':');
        }
    },
    // Timezone (GMT)
    O: function(date, token, _localize, options) {
        var originalDate = options._originalDate || date;
        var timezoneOffset = originalDate.getTimezoneOffset();
        switch(token){
            // Short
            case 'O':
            case 'OO':
            case 'OOO':
                return 'GMT' + $2542672a600cd2b8$var$formatTimezoneShort(timezoneOffset, ':');
            // Long
            case 'OOOO':
            default:
                return 'GMT' + $2542672a600cd2b8$var$formatTimezone(timezoneOffset, ':');
        }
    },
    // Timezone (specific non-location)
    z: function(date, token, _localize, options) {
        var originalDate = options._originalDate || date;
        var timezoneOffset = originalDate.getTimezoneOffset();
        switch(token){
            // Short
            case 'z':
            case 'zz':
            case 'zzz':
                return 'GMT' + $2542672a600cd2b8$var$formatTimezoneShort(timezoneOffset, ':');
            // Long
            case 'zzzz':
            default:
                return 'GMT' + $2542672a600cd2b8$var$formatTimezone(timezoneOffset, ':');
        }
    },
    // Seconds timestamp
    t: function(date, token, _localize, options) {
        var originalDate = options._originalDate || date;
        var timestamp = Math.floor(originalDate.getTime() / 1000);
        return (0, $2542672a600cd2b8$var$_index7.default)(timestamp, token.length);
    },
    // Milliseconds timestamp
    T: function(date, token, _localize, options) {
        var originalDate = options._originalDate || date;
        var timestamp = originalDate.getTime();
        return (0, $2542672a600cd2b8$var$_index7.default)(timestamp, token.length);
    }
};
function $2542672a600cd2b8$var$formatTimezoneShort(offset, dirtyDelimiter) {
    var sign = offset > 0 ? '-' : '+';
    var absOffset = Math.abs(offset);
    var hours = Math.floor(absOffset / 60);
    var minutes = absOffset % 60;
    if (minutes === 0) return sign + String(hours);
    var delimiter = dirtyDelimiter || '';
    return sign + String(hours) + delimiter + (0, $2542672a600cd2b8$var$_index7.default)(minutes, 2);
}
function $2542672a600cd2b8$var$formatTimezoneWithOptionalMinutes(offset, dirtyDelimiter) {
    if (offset % 60 === 0) {
        var sign = offset > 0 ? '-' : '+';
        return sign + (0, $2542672a600cd2b8$var$_index7.default)(Math.abs(offset) / 60, 2);
    }
    return $2542672a600cd2b8$var$formatTimezone(offset, dirtyDelimiter);
}
function $2542672a600cd2b8$var$formatTimezone(offset, dirtyDelimiter) {
    var delimiter = dirtyDelimiter || '';
    var sign = offset > 0 ? '-' : '+';
    var absOffset = Math.abs(offset);
    var hours = (0, $2542672a600cd2b8$var$_index7.default)(Math.floor(absOffset / 60), 2);
    var minutes = (0, $2542672a600cd2b8$var$_index7.default)(absOffset % 60, 2);
    return sign + hours + delimiter + minutes;
}
var $2542672a600cd2b8$var$_default = $2542672a600cd2b8$var$formatters;
module.exports.default = $2542672a600cd2b8$var$_default;
module.exports = module.exports.default;

});
parcelRegister("kFGp1", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $f0c88744bd108133$var$_index = $f0c88744bd108133$var$_interopRequireDefault((parcelRequire("bQ2eo")));
function $f0c88744bd108133$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
/*
 * |     | Unit                           |     | Unit                           |
 * |-----|--------------------------------|-----|--------------------------------|
 * |  a  | AM, PM                         |  A* |                                |
 * |  d  | Day of month                   |  D  |                                |
 * |  h  | Hour [1-12]                    |  H  | Hour [0-23]                    |
 * |  m  | Minute                         |  M  | Month                          |
 * |  s  | Second                         |  S  | Fraction of second             |
 * |  y  | Year (abs)                     |  Y  |                                |
 *
 * Letters marked by * are not implemented but reserved by Unicode standard.
 */ var $f0c88744bd108133$var$formatters = {
    // Year
    y: function(date, token) {
        // From http://www.unicode.org/reports/tr35/tr35-31/tr35-dates.html#Date_Format_tokens
        // | Year     |     y | yy |   yyy |  yyyy | yyyyy |
        // |----------|-------|----|-------|-------|-------|
        // | AD 1     |     1 | 01 |   001 |  0001 | 00001 |
        // | AD 12    |    12 | 12 |   012 |  0012 | 00012 |
        // | AD 123   |   123 | 23 |   123 |  0123 | 00123 |
        // | AD 1234  |  1234 | 34 |  1234 |  1234 | 01234 |
        // | AD 12345 | 12345 | 45 | 12345 | 12345 | 12345 |
        var signedYear = date.getUTCFullYear(); // Returns 1 for 1 BC (which is year 0 in JavaScript)
        var year = signedYear > 0 ? signedYear : 1 - signedYear;
        return (0, $f0c88744bd108133$var$_index.default)(token === 'yy' ? year % 100 : year, token.length);
    },
    // Month
    M: function(date, token) {
        var month = date.getUTCMonth();
        return token === 'M' ? String(month + 1) : (0, $f0c88744bd108133$var$_index.default)(month + 1, 2);
    },
    // Day of the month
    d: function(date, token) {
        return (0, $f0c88744bd108133$var$_index.default)(date.getUTCDate(), token.length);
    },
    // AM or PM
    a: function(date, token) {
        var dayPeriodEnumValue = date.getUTCHours() / 12 >= 1 ? 'pm' : 'am';
        switch(token){
            case 'a':
            case 'aa':
                return dayPeriodEnumValue.toUpperCase();
            case 'aaa':
                return dayPeriodEnumValue;
            case 'aaaaa':
                return dayPeriodEnumValue[0];
            case 'aaaa':
            default:
                return dayPeriodEnumValue === 'am' ? 'a.m.' : 'p.m.';
        }
    },
    // Hour [1-12]
    h: function(date, token) {
        return (0, $f0c88744bd108133$var$_index.default)(date.getUTCHours() % 12 || 12, token.length);
    },
    // Hour [0-23]
    H: function(date, token) {
        return (0, $f0c88744bd108133$var$_index.default)(date.getUTCHours(), token.length);
    },
    // Minute
    m: function(date, token) {
        return (0, $f0c88744bd108133$var$_index.default)(date.getUTCMinutes(), token.length);
    },
    // Second
    s: function(date, token) {
        return (0, $f0c88744bd108133$var$_index.default)(date.getUTCSeconds(), token.length);
    },
    // Fraction of second
    S: function(date, token) {
        var numberOfDigits = token.length;
        var milliseconds = date.getUTCMilliseconds();
        var fractionalSeconds = Math.floor(milliseconds * Math.pow(10, numberOfDigits - 3));
        return (0, $f0c88744bd108133$var$_index.default)(fractionalSeconds, token.length);
    }
};
var $f0c88744bd108133$var$_default = $f0c88744bd108133$var$formatters;
module.exports.default = $f0c88744bd108133$var$_default;
module.exports = module.exports.default;

});
parcelRegister("bQ2eo", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $89e6481d20123ee2$var$addLeadingZeros;
function $89e6481d20123ee2$var$addLeadingZeros(number, targetLength) {
    var sign = number < 0 ? '-' : '';
    var output = Math.abs(number).toString();
    while(output.length < targetLength)output = '0' + output;
    return sign + output;
}
module.exports = module.exports.default;

});


parcelRegister("3xdEO", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $292f0c3a5495486a$var$getUTCDayOfYear;

var $292f0c3a5495486a$var$_index = $292f0c3a5495486a$var$_interopRequireDefault((parcelRequire("2pWQP")));

var $292f0c3a5495486a$var$_index2 = $292f0c3a5495486a$var$_interopRequireDefault((parcelRequire("6eBfj")));
function $292f0c3a5495486a$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
var $292f0c3a5495486a$var$MILLISECONDS_IN_DAY = 86400000; // This function will be a part of public API when UTC function will be implemented.
// See issue: https://github.com/date-fns/date-fns/issues/376
function $292f0c3a5495486a$var$getUTCDayOfYear(dirtyDate) {
    (0, $292f0c3a5495486a$var$_index2.default)(1, arguments);
    var date = (0, $292f0c3a5495486a$var$_index.default)(dirtyDate);
    var timestamp = date.getTime();
    date.setUTCMonth(0, 1);
    date.setUTCHours(0, 0, 0, 0);
    var startOfYearTimestamp = date.getTime();
    var difference = timestamp - startOfYearTimestamp;
    return Math.floor(difference / $292f0c3a5495486a$var$MILLISECONDS_IN_DAY) + 1;
}
module.exports = module.exports.default;

});

parcelRegister("6Falt", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $4d9e98caba6dac2d$var$getUTCISOWeek;

var $4d9e98caba6dac2d$var$_index = $4d9e98caba6dac2d$var$_interopRequireDefault((parcelRequire("2pWQP")));

var $4d9e98caba6dac2d$var$_index2 = $4d9e98caba6dac2d$var$_interopRequireDefault((parcelRequire("6nDqw")));

var $4d9e98caba6dac2d$var$_index3 = $4d9e98caba6dac2d$var$_interopRequireDefault((parcelRequire("hI2kM")));

var $4d9e98caba6dac2d$var$_index4 = $4d9e98caba6dac2d$var$_interopRequireDefault((parcelRequire("6eBfj")));
function $4d9e98caba6dac2d$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
var $4d9e98caba6dac2d$var$MILLISECONDS_IN_WEEK = 604800000; // This function will be a part of public API when UTC function will be implemented.
// See issue: https://github.com/date-fns/date-fns/issues/376
function $4d9e98caba6dac2d$var$getUTCISOWeek(dirtyDate) {
    (0, $4d9e98caba6dac2d$var$_index4.default)(1, arguments);
    var date = (0, $4d9e98caba6dac2d$var$_index.default)(dirtyDate);
    var diff = (0, $4d9e98caba6dac2d$var$_index2.default)(date).getTime() - (0, $4d9e98caba6dac2d$var$_index3.default)(date).getTime(); // Round the number of days to the nearest integer
    // because the number of milliseconds in a week is not constant
    // (e.g. it's different in the week of the daylight saving time clock shift)
    return Math.round(diff / $4d9e98caba6dac2d$var$MILLISECONDS_IN_WEEK) + 1;
}
module.exports = module.exports.default;

});
parcelRegister("6nDqw", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $4a53796a96b58804$var$startOfUTCISOWeek;

var $4a53796a96b58804$var$_index = $4a53796a96b58804$var$_interopRequireDefault((parcelRequire("2pWQP")));

var $4a53796a96b58804$var$_index2 = $4a53796a96b58804$var$_interopRequireDefault((parcelRequire("6eBfj")));
function $4a53796a96b58804$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
// This function will be a part of public API when UTC function will be implemented.
// See issue: https://github.com/date-fns/date-fns/issues/376
function $4a53796a96b58804$var$startOfUTCISOWeek(dirtyDate) {
    (0, $4a53796a96b58804$var$_index2.default)(1, arguments);
    var weekStartsOn = 1;
    var date = (0, $4a53796a96b58804$var$_index.default)(dirtyDate);
    var day = date.getUTCDay();
    var diff = (day < weekStartsOn ? 7 : 0) + day - weekStartsOn;
    date.setUTCDate(date.getUTCDate() - diff);
    date.setUTCHours(0, 0, 0, 0);
    return date;
}
module.exports = module.exports.default;

});

parcelRegister("hI2kM", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $ce485b424b643216$var$startOfUTCISOWeekYear;

var $ce485b424b643216$var$_index = $ce485b424b643216$var$_interopRequireDefault((parcelRequire("gUvh1")));

var $ce485b424b643216$var$_index2 = $ce485b424b643216$var$_interopRequireDefault((parcelRequire("6nDqw")));

var $ce485b424b643216$var$_index3 = $ce485b424b643216$var$_interopRequireDefault((parcelRequire("6eBfj")));
function $ce485b424b643216$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
// This function will be a part of public API when UTC function will be implemented.
// See issue: https://github.com/date-fns/date-fns/issues/376
function $ce485b424b643216$var$startOfUTCISOWeekYear(dirtyDate) {
    (0, $ce485b424b643216$var$_index3.default)(1, arguments);
    var year = (0, $ce485b424b643216$var$_index.default)(dirtyDate);
    var fourthOfJanuary = new Date(0);
    fourthOfJanuary.setUTCFullYear(year, 0, 4);
    fourthOfJanuary.setUTCHours(0, 0, 0, 0);
    var date = (0, $ce485b424b643216$var$_index2.default)(fourthOfJanuary);
    return date;
}
module.exports = module.exports.default;

});
parcelRegister("gUvh1", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $c4fa22996f39566a$var$getUTCISOWeekYear;

var $c4fa22996f39566a$var$_index = $c4fa22996f39566a$var$_interopRequireDefault((parcelRequire("2pWQP")));

var $c4fa22996f39566a$var$_index2 = $c4fa22996f39566a$var$_interopRequireDefault((parcelRequire("6nDqw")));

var $c4fa22996f39566a$var$_index3 = $c4fa22996f39566a$var$_interopRequireDefault((parcelRequire("6eBfj")));
function $c4fa22996f39566a$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
// This function will be a part of public API when UTC function will be implemented.
// See issue: https://github.com/date-fns/date-fns/issues/376
function $c4fa22996f39566a$var$getUTCISOWeekYear(dirtyDate) {
    (0, $c4fa22996f39566a$var$_index3.default)(1, arguments);
    var date = (0, $c4fa22996f39566a$var$_index.default)(dirtyDate);
    var year = date.getUTCFullYear();
    var fourthOfJanuaryOfNextYear = new Date(0);
    fourthOfJanuaryOfNextYear.setUTCFullYear(year + 1, 0, 4);
    fourthOfJanuaryOfNextYear.setUTCHours(0, 0, 0, 0);
    var startOfNextYear = (0, $c4fa22996f39566a$var$_index2.default)(fourthOfJanuaryOfNextYear);
    var fourthOfJanuaryOfThisYear = new Date(0);
    fourthOfJanuaryOfThisYear.setUTCFullYear(year, 0, 4);
    fourthOfJanuaryOfThisYear.setUTCHours(0, 0, 0, 0);
    var startOfThisYear = (0, $c4fa22996f39566a$var$_index2.default)(fourthOfJanuaryOfThisYear);
    if (date.getTime() >= startOfNextYear.getTime()) return year + 1;
    else if (date.getTime() >= startOfThisYear.getTime()) return year;
    else return year - 1;
}
module.exports = module.exports.default;

});



parcelRegister("46m4m", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $2fc8d772b38d0976$var$getUTCWeek;

var $2fc8d772b38d0976$var$_index = $2fc8d772b38d0976$var$_interopRequireDefault((parcelRequire("2pWQP")));

var $2fc8d772b38d0976$var$_index2 = $2fc8d772b38d0976$var$_interopRequireDefault((parcelRequire("clhRK")));

var $2fc8d772b38d0976$var$_index3 = $2fc8d772b38d0976$var$_interopRequireDefault((parcelRequire("cbqvD")));

var $2fc8d772b38d0976$var$_index4 = $2fc8d772b38d0976$var$_interopRequireDefault((parcelRequire("6eBfj")));
function $2fc8d772b38d0976$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
var $2fc8d772b38d0976$var$MILLISECONDS_IN_WEEK = 604800000; // This function will be a part of public API when UTC function will be implemented.
// See issue: https://github.com/date-fns/date-fns/issues/376
function $2fc8d772b38d0976$var$getUTCWeek(dirtyDate, options) {
    (0, $2fc8d772b38d0976$var$_index4.default)(1, arguments);
    var date = (0, $2fc8d772b38d0976$var$_index.default)(dirtyDate);
    var diff = (0, $2fc8d772b38d0976$var$_index2.default)(date, options).getTime() - (0, $2fc8d772b38d0976$var$_index3.default)(date, options).getTime(); // Round the number of days to the nearest integer
    // because the number of milliseconds in a week is not constant
    // (e.g. it's different in the week of the daylight saving time clock shift)
    return Math.round(diff / $2fc8d772b38d0976$var$MILLISECONDS_IN_WEEK) + 1;
}
module.exports = module.exports.default;

});
parcelRegister("clhRK", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $8fc54dfcfb604fc4$var$startOfUTCWeek;

var $8fc54dfcfb604fc4$var$_index = $8fc54dfcfb604fc4$var$_interopRequireDefault((parcelRequire("aSksP")));

var $8fc54dfcfb604fc4$var$_index2 = $8fc54dfcfb604fc4$var$_interopRequireDefault((parcelRequire("2pWQP")));

var $8fc54dfcfb604fc4$var$_index3 = $8fc54dfcfb604fc4$var$_interopRequireDefault((parcelRequire("6eBfj")));
function $8fc54dfcfb604fc4$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
// This function will be a part of public API when UTC function will be implemented.
// See issue: https://github.com/date-fns/date-fns/issues/376
function $8fc54dfcfb604fc4$var$startOfUTCWeek(dirtyDate, dirtyOptions) {
    (0, $8fc54dfcfb604fc4$var$_index3.default)(1, arguments);
    var options = dirtyOptions || {};
    var locale = options.locale;
    var localeWeekStartsOn = locale && locale.options && locale.options.weekStartsOn;
    var defaultWeekStartsOn = localeWeekStartsOn == null ? 0 : (0, $8fc54dfcfb604fc4$var$_index.default)(localeWeekStartsOn);
    var weekStartsOn = options.weekStartsOn == null ? defaultWeekStartsOn : (0, $8fc54dfcfb604fc4$var$_index.default)(options.weekStartsOn); // Test if weekStartsOn is between 0 and 6 _and_ is not NaN
    if (!(weekStartsOn >= 0 && weekStartsOn <= 6)) throw new RangeError('weekStartsOn must be between 0 and 6 inclusively');
    var date = (0, $8fc54dfcfb604fc4$var$_index2.default)(dirtyDate);
    var day = date.getUTCDay();
    var diff = (day < weekStartsOn ? 7 : 0) + day - weekStartsOn;
    date.setUTCDate(date.getUTCDate() - diff);
    date.setUTCHours(0, 0, 0, 0);
    return date;
}
module.exports = module.exports.default;

});

parcelRegister("cbqvD", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $8deb134e55cb5294$var$startOfUTCWeekYear;

var $8deb134e55cb5294$var$_index = $8deb134e55cb5294$var$_interopRequireDefault((parcelRequire("aSksP")));

var $8deb134e55cb5294$var$_index2 = $8deb134e55cb5294$var$_interopRequireDefault((parcelRequire("3ihh3")));

var $8deb134e55cb5294$var$_index3 = $8deb134e55cb5294$var$_interopRequireDefault((parcelRequire("clhRK")));

var $8deb134e55cb5294$var$_index4 = $8deb134e55cb5294$var$_interopRequireDefault((parcelRequire("6eBfj")));
function $8deb134e55cb5294$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
// This function will be a part of public API when UTC function will be implemented.
// See issue: https://github.com/date-fns/date-fns/issues/376
function $8deb134e55cb5294$var$startOfUTCWeekYear(dirtyDate, dirtyOptions) {
    (0, $8deb134e55cb5294$var$_index4.default)(1, arguments);
    var options = dirtyOptions || {};
    var locale = options.locale;
    var localeFirstWeekContainsDate = locale && locale.options && locale.options.firstWeekContainsDate;
    var defaultFirstWeekContainsDate = localeFirstWeekContainsDate == null ? 1 : (0, $8deb134e55cb5294$var$_index.default)(localeFirstWeekContainsDate);
    var firstWeekContainsDate = options.firstWeekContainsDate == null ? defaultFirstWeekContainsDate : (0, $8deb134e55cb5294$var$_index.default)(options.firstWeekContainsDate);
    var year = (0, $8deb134e55cb5294$var$_index2.default)(dirtyDate, dirtyOptions);
    var firstWeek = new Date(0);
    firstWeek.setUTCFullYear(year, 0, firstWeekContainsDate);
    firstWeek.setUTCHours(0, 0, 0, 0);
    var date = (0, $8deb134e55cb5294$var$_index3.default)(firstWeek, dirtyOptions);
    return date;
}
module.exports = module.exports.default;

});
parcelRegister("3ihh3", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $266073c9a73c0f7b$var$getUTCWeekYear;

var $266073c9a73c0f7b$var$_index = $266073c9a73c0f7b$var$_interopRequireDefault((parcelRequire("aSksP")));

var $266073c9a73c0f7b$var$_index2 = $266073c9a73c0f7b$var$_interopRequireDefault((parcelRequire("2pWQP")));

var $266073c9a73c0f7b$var$_index3 = $266073c9a73c0f7b$var$_interopRequireDefault((parcelRequire("clhRK")));

var $266073c9a73c0f7b$var$_index4 = $266073c9a73c0f7b$var$_interopRequireDefault((parcelRequire("6eBfj")));
function $266073c9a73c0f7b$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
// This function will be a part of public API when UTC function will be implemented.
// See issue: https://github.com/date-fns/date-fns/issues/376
function $266073c9a73c0f7b$var$getUTCWeekYear(dirtyDate, dirtyOptions) {
    (0, $266073c9a73c0f7b$var$_index4.default)(1, arguments);
    var date = (0, $266073c9a73c0f7b$var$_index2.default)(dirtyDate, dirtyOptions);
    var year = date.getUTCFullYear();
    var options = dirtyOptions || {};
    var locale = options.locale;
    var localeFirstWeekContainsDate = locale && locale.options && locale.options.firstWeekContainsDate;
    var defaultFirstWeekContainsDate = localeFirstWeekContainsDate == null ? 1 : (0, $266073c9a73c0f7b$var$_index.default)(localeFirstWeekContainsDate);
    var firstWeekContainsDate = options.firstWeekContainsDate == null ? defaultFirstWeekContainsDate : (0, $266073c9a73c0f7b$var$_index.default)(options.firstWeekContainsDate); // Test if weekStartsOn is between 1 and 7 _and_ is not NaN
    if (!(firstWeekContainsDate >= 1 && firstWeekContainsDate <= 7)) throw new RangeError('firstWeekContainsDate must be between 1 and 7 inclusively');
    var firstWeekOfNextYear = new Date(0);
    firstWeekOfNextYear.setUTCFullYear(year + 1, 0, firstWeekContainsDate);
    firstWeekOfNextYear.setUTCHours(0, 0, 0, 0);
    var startOfNextYear = (0, $266073c9a73c0f7b$var$_index3.default)(firstWeekOfNextYear, dirtyOptions);
    var firstWeekOfThisYear = new Date(0);
    firstWeekOfThisYear.setUTCFullYear(year, 0, firstWeekContainsDate);
    firstWeekOfThisYear.setUTCHours(0, 0, 0, 0);
    var startOfThisYear = (0, $266073c9a73c0f7b$var$_index3.default)(firstWeekOfThisYear, dirtyOptions);
    if (date.getTime() >= startOfNextYear.getTime()) return year + 1;
    else if (date.getTime() >= startOfThisYear.getTime()) return year;
    else return year - 1;
}
module.exports = module.exports.default;

});




parcelRegister("awKAW", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;
function $7aa109506ceedd4b$var$dateLongFormatter(pattern, formatLong) {
    switch(pattern){
        case 'P':
            return formatLong.date({
                width: 'short'
            });
        case 'PP':
            return formatLong.date({
                width: 'medium'
            });
        case 'PPP':
            return formatLong.date({
                width: 'long'
            });
        case 'PPPP':
        default:
            return formatLong.date({
                width: 'full'
            });
    }
}
function $7aa109506ceedd4b$var$timeLongFormatter(pattern, formatLong) {
    switch(pattern){
        case 'p':
            return formatLong.time({
                width: 'short'
            });
        case 'pp':
            return formatLong.time({
                width: 'medium'
            });
        case 'ppp':
            return formatLong.time({
                width: 'long'
            });
        case 'pppp':
        default:
            return formatLong.time({
                width: 'full'
            });
    }
}
function $7aa109506ceedd4b$var$dateTimeLongFormatter(pattern, formatLong) {
    var matchResult = pattern.match(/(P+)(p+)?/);
    var datePattern = matchResult[1];
    var timePattern = matchResult[2];
    if (!timePattern) return $7aa109506ceedd4b$var$dateLongFormatter(pattern, formatLong);
    var dateTimeFormat;
    switch(datePattern){
        case 'P':
            dateTimeFormat = formatLong.dateTime({
                width: 'short'
            });
            break;
        case 'PP':
            dateTimeFormat = formatLong.dateTime({
                width: 'medium'
            });
            break;
        case 'PPP':
            dateTimeFormat = formatLong.dateTime({
                width: 'long'
            });
            break;
        case 'PPPP':
        default:
            dateTimeFormat = formatLong.dateTime({
                width: 'full'
            });
            break;
    }
    return dateTimeFormat.replace('{{date}}', $7aa109506ceedd4b$var$dateLongFormatter(datePattern, formatLong)).replace('{{time}}', $7aa109506ceedd4b$var$timeLongFormatter(timePattern, formatLong));
}
var $7aa109506ceedd4b$var$longFormatters = {
    p: $7aa109506ceedd4b$var$timeLongFormatter,
    P: $7aa109506ceedd4b$var$dateTimeLongFormatter
};
var $7aa109506ceedd4b$var$_default = $7aa109506ceedd4b$var$longFormatters;
module.exports.default = $7aa109506ceedd4b$var$_default;
module.exports = module.exports.default;

});

parcelRegister("jGQTC", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $e55af8a2cb6edd32$var$getTimezoneOffsetInMilliseconds;
/**
 * Google Chrome as of 67.0.3396.87 introduced timezones with offset that includes seconds.
 * They usually appear for dates that denote time before the timezones were introduced
 * (e.g. for 'Europe/Prague' timezone the offset is GMT+00:57:44 before 1 October 1891
 * and GMT+01:00:00 after that date)
 *
 * Date#getTimezoneOffset returns the offset in minutes and would return 57 for the example above,
 * which would lead to incorrect calculations.
 *
 * This function returns the timezone offset in milliseconds that takes seconds in account.
 */ function $e55af8a2cb6edd32$var$getTimezoneOffsetInMilliseconds(date) {
    var utcDate = new Date(Date.UTC(date.getFullYear(), date.getMonth(), date.getDate(), date.getHours(), date.getMinutes(), date.getSeconds(), date.getMilliseconds()));
    utcDate.setUTCFullYear(date.getFullYear());
    return date.getTime() - utcDate.getTime();
}
module.exports = module.exports.default;

});

parcelRegister("5qguX", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.isProtectedDayOfYearToken = $3f2c2dab40599caa$var$isProtectedDayOfYearToken;
module.exports.isProtectedWeekYearToken = $3f2c2dab40599caa$var$isProtectedWeekYearToken;
module.exports.throwProtectedError = $3f2c2dab40599caa$var$throwProtectedError;
var $3f2c2dab40599caa$var$protectedDayOfYearTokens = [
    'D',
    'DD'
];
var $3f2c2dab40599caa$var$protectedWeekYearTokens = [
    'YY',
    'YYYY'
];
function $3f2c2dab40599caa$var$isProtectedDayOfYearToken(token) {
    return $3f2c2dab40599caa$var$protectedDayOfYearTokens.indexOf(token) !== -1;
}
function $3f2c2dab40599caa$var$isProtectedWeekYearToken(token) {
    return $3f2c2dab40599caa$var$protectedWeekYearTokens.indexOf(token) !== -1;
}
function $3f2c2dab40599caa$var$throwProtectedError(token, format, input) {
    if (token === 'YYYY') throw new RangeError("Use `yyyy` instead of `YYYY` (in `".concat(format, "`) for formatting years to the input `").concat(input, "`; see: https://git.io/fxCyr"));
    else if (token === 'YY') throw new RangeError("Use `yy` instead of `YY` (in `".concat(format, "`) for formatting years to the input `").concat(input, "`; see: https://git.io/fxCyr"));
    else if (token === 'D') throw new RangeError("Use `d` instead of `D` (in `".concat(format, "`) for formatting days of the month to the input `").concat(input, "`; see: https://git.io/fxCyr"));
    else if (token === 'DD') throw new RangeError("Use `dd` instead of `DD` (in `".concat(format, "`) for formatting days of the month to the input `").concat(input, "`; see: https://git.io/fxCyr"));
}

});


parcelRegister("5wWnR", function(module, exports) {

$parcel$export(module.exports, "default", () => $406d3abc4f70c331$export$2e2bcd8739ae039);

var $1nruv = parcelRequire("1nruv");

var $6ZkUj = parcelRequire("6ZkUj");
var $406d3abc4f70c331$var$MILLISECONDS_IN_MINUTE = 60000;
var $406d3abc4f70c331$var$formatters = {
    // Timezone (ISO-8601. If offset is 0, output is always `'Z'`)
    X: function(date, token, localize, options) {
        var timezoneOffset = $406d3abc4f70c331$var$getTimeZoneOffset(options.timeZone, date);
        if (timezoneOffset === 0) return 'Z';
        switch(token){
            // Hours and optional minutes
            case 'X':
                return $406d3abc4f70c331$var$formatTimezoneWithOptionalMinutes(timezoneOffset);
            // Hours, minutes and optional seconds without `:` delimeter
            // Note: neither ISO-8601 nor JavaScript supports seconds in timezone offsets
            // so this token always has the same output as `XX`
            case 'XXXX':
            case 'XX':
                return $406d3abc4f70c331$var$formatTimezone(timezoneOffset);
            // Hours, minutes and optional seconds with `:` delimeter
            // Note: neither ISO-8601 nor JavaScript supports seconds in timezone offsets
            // so this token always has the same output as `XXX`
            case 'XXXXX':
            case 'XXX':
            default:
                return $406d3abc4f70c331$var$formatTimezone(timezoneOffset, ':');
        }
    },
    // Timezone (ISO-8601. If offset is 0, output is `'+00:00'` or equivalent)
    x: function(date, token, localize, options) {
        var timezoneOffset = $406d3abc4f70c331$var$getTimeZoneOffset(options.timeZone, date);
        switch(token){
            // Hours and optional minutes
            case 'x':
                return $406d3abc4f70c331$var$formatTimezoneWithOptionalMinutes(timezoneOffset);
            // Hours, minutes and optional seconds without `:` delimeter
            // Note: neither ISO-8601 nor JavaScript supports seconds in timezone offsets
            // so this token always has the same output as `xx`
            case 'xxxx':
            case 'xx':
                return $406d3abc4f70c331$var$formatTimezone(timezoneOffset);
            // Hours, minutes and optional seconds with `:` delimeter
            // Note: neither ISO-8601 nor JavaScript supports seconds in timezone offsets
            // so this token always has the same output as `xxx`
            case 'xxxxx':
            case 'xxx':
            default:
                return $406d3abc4f70c331$var$formatTimezone(timezoneOffset, ':');
        }
    },
    // Timezone (GMT)
    O: function(date, token, localize, options) {
        var timezoneOffset = $406d3abc4f70c331$var$getTimeZoneOffset(options.timeZone, date);
        switch(token){
            // Short
            case 'O':
            case 'OO':
            case 'OOO':
                return 'GMT' + $406d3abc4f70c331$var$formatTimezoneShort(timezoneOffset, ':');
            // Long
            case 'OOOO':
            default:
                return 'GMT' + $406d3abc4f70c331$var$formatTimezone(timezoneOffset, ':');
        }
    },
    // Timezone (specific non-location)
    z: function(date, token, localize, options) {
        switch(token){
            // Short
            case 'z':
            case 'zz':
            case 'zzz':
                return (0, $1nruv.default)('short', date, options);
            // Long
            case 'zzzz':
            default:
                return (0, $1nruv.default)('long', date, options);
        }
    }
};
function $406d3abc4f70c331$var$getTimeZoneOffset(timeZone, originalDate) {
    var timeZoneOffset = timeZone ? (0, $6ZkUj.default)(timeZone, originalDate, true) / $406d3abc4f70c331$var$MILLISECONDS_IN_MINUTE : originalDate.getTimezoneOffset();
    if (Number.isNaN(timeZoneOffset)) throw new RangeError('Invalid time zone specified: ' + timeZone);
    return timeZoneOffset;
}
function $406d3abc4f70c331$var$addLeadingZeros(number, targetLength) {
    var sign = number < 0 ? '-' : '';
    var output = Math.abs(number).toString();
    while(output.length < targetLength)output = '0' + output;
    return sign + output;
}
function $406d3abc4f70c331$var$formatTimezone(offset, dirtyDelimeter) {
    var delimeter = dirtyDelimeter || '';
    var sign = offset > 0 ? '-' : '+';
    var absOffset = Math.abs(offset);
    var hours = $406d3abc4f70c331$var$addLeadingZeros(Math.floor(absOffset / 60), 2);
    var minutes = $406d3abc4f70c331$var$addLeadingZeros(Math.floor(absOffset % 60), 2);
    return sign + hours + delimeter + minutes;
}
function $406d3abc4f70c331$var$formatTimezoneWithOptionalMinutes(offset, dirtyDelimeter) {
    if (offset % 60 === 0) {
        var sign = offset > 0 ? '-' : '+';
        return sign + $406d3abc4f70c331$var$addLeadingZeros(Math.abs(offset) / 60, 2);
    }
    return $406d3abc4f70c331$var$formatTimezone(offset, dirtyDelimeter);
}
function $406d3abc4f70c331$var$formatTimezoneShort(offset, dirtyDelimiter) {
    var sign = offset > 0 ? '-' : '+';
    var absOffset = Math.abs(offset);
    var hours = Math.floor(absOffset / 60);
    var minutes = absOffset % 60;
    if (minutes === 0) return sign + String(hours);
    var delimiter = dirtyDelimiter || '';
    return sign + String(hours) + delimiter + $406d3abc4f70c331$var$addLeadingZeros(minutes, 2);
}
var $406d3abc4f70c331$export$2e2bcd8739ae039 = $406d3abc4f70c331$var$formatters;

});
parcelRegister("1nruv", function(module, exports) {

$parcel$export(module.exports, "default", () => $100d43922c522b8e$export$2e2bcd8739ae039);
/**
 * Returns the formatted time zone name of the provided `timeZone` or the current
 * system time zone if omitted, accounting for DST according to the UTC value of
 * the date.
 */ function $100d43922c522b8e$export$2e2bcd8739ae039(length, date, options) {
    var dtf = $100d43922c522b8e$var$getDTF(length, options.timeZone, options.locale);
    return dtf.formatToParts ? $100d43922c522b8e$var$partsTimeZone(dtf, date) : $100d43922c522b8e$var$hackyTimeZone(dtf, date);
}
function $100d43922c522b8e$var$partsTimeZone(dtf, date) {
    var formatted = dtf.formatToParts(date);
    for(var i = formatted.length - 1; i >= 0; --i){
        if (formatted[i].type === 'timeZoneName') return formatted[i].value;
    }
}
function $100d43922c522b8e$var$hackyTimeZone(dtf, date) {
    var formatted = dtf.format(date).replace(/\u200E/g, '');
    var tzNameMatch = / [\w-+ ]+$/.exec(formatted);
    return tzNameMatch ? tzNameMatch[0].substr(1) : '';
}
// If a locale has been provided `en-US` is used as a fallback in case it is an
// invalid locale, otherwise the locale is left undefined to use the system locale.
function $100d43922c522b8e$var$getDTF(length, timeZone, locale) {
    if (locale && !locale.code) throw new Error("date-fns-tz error: Please set a language code on the locale object imported from date-fns, e.g. `locale.code = 'en-US'`");
    return new Intl.DateTimeFormat(locale ? [
        locale.code,
        'en-US'
    ] : undefined, {
        timeZone: timeZone,
        timeZoneName: length
    });
}

});

parcelRegister("6ZkUj", function(module, exports) {

$parcel$export(module.exports, "default", () => $5168a8572a4ea5fa$export$2e2bcd8739ae039);

var $lLNDp = parcelRequire("lLNDp");

var $h3kEp = parcelRequire("h3kEp");
var $5168a8572a4ea5fa$var$MILLISECONDS_IN_HOUR = 3600000;
var $5168a8572a4ea5fa$var$MILLISECONDS_IN_MINUTE = 60000;
var $5168a8572a4ea5fa$var$patterns = {
    timezone: /([Z+-].*)$/,
    timezoneZ: /^(Z)$/,
    timezoneHH: /^([+-]\d{2})$/,
    timezoneHHMM: /^([+-])(\d{2}):?(\d{2})$/
};
function $5168a8572a4ea5fa$export$2e2bcd8739ae039(timezoneString, date, isUtcDate) {
    var token;
    var absoluteOffset;
    // Empty string
    if (!timezoneString) return 0;
    // Z
    token = $5168a8572a4ea5fa$var$patterns.timezoneZ.exec(timezoneString);
    if (token) return 0;
    var hours;
    // ±hh
    token = $5168a8572a4ea5fa$var$patterns.timezoneHH.exec(timezoneString);
    if (token) {
        hours = parseInt(token[1], 10);
        if (!$5168a8572a4ea5fa$var$validateTimezone(hours)) return NaN;
        return -(hours * $5168a8572a4ea5fa$var$MILLISECONDS_IN_HOUR);
    }
    // ±hh:mm or ±hhmm
    token = $5168a8572a4ea5fa$var$patterns.timezoneHHMM.exec(timezoneString);
    if (token) {
        hours = parseInt(token[2], 10);
        var minutes = parseInt(token[3], 10);
        if (!$5168a8572a4ea5fa$var$validateTimezone(hours, minutes)) return NaN;
        absoluteOffset = Math.abs(hours) * $5168a8572a4ea5fa$var$MILLISECONDS_IN_HOUR + minutes * $5168a8572a4ea5fa$var$MILLISECONDS_IN_MINUTE;
        return token[1] === '+' ? -absoluteOffset : absoluteOffset;
    }
    // IANA time zone
    if ($5168a8572a4ea5fa$var$isValidTimezoneIANAString(timezoneString)) {
        date = new Date(date || Date.now());
        var utcDate = isUtcDate ? date : $5168a8572a4ea5fa$var$toUtcDate(date);
        var offset = $5168a8572a4ea5fa$var$calcOffset(utcDate, timezoneString);
        var fixedOffset = isUtcDate ? offset : $5168a8572a4ea5fa$var$fixOffset(date, offset, timezoneString);
        return -fixedOffset;
    }
    return NaN;
}
function $5168a8572a4ea5fa$var$toUtcDate(date) {
    return (0, $h3kEp.default)(date.getFullYear(), date.getMonth(), date.getDate(), date.getHours(), date.getMinutes(), date.getSeconds(), date.getMilliseconds());
}
function $5168a8572a4ea5fa$var$calcOffset(date, timezoneString) {
    var tokens = (0, $lLNDp.default)(date, timezoneString);
    // ms dropped because it's not provided by tzTokenizeDate
    var asUTC = (0, $h3kEp.default)(tokens[0], tokens[1] - 1, tokens[2], tokens[3] % 24, tokens[4], tokens[5], 0).getTime();
    var asTS = date.getTime();
    var over = asTS % 1000;
    asTS -= over >= 0 ? over : 1000 + over;
    return asUTC - asTS;
}
function $5168a8572a4ea5fa$var$fixOffset(date, offset, timezoneString) {
    var localTS = date.getTime();
    // Our UTC time is just a guess because our offset is just a guess
    var utcGuess = localTS - offset;
    // Test whether the zone matches the offset for this ts
    var o2 = $5168a8572a4ea5fa$var$calcOffset(new Date(utcGuess), timezoneString);
    // If so, offset didn't change, and we're done
    if (offset === o2) return offset;
    // If not, change the ts by the difference in the offset
    utcGuess -= o2 - offset;
    // If that gives us the local time we want, we're done
    var o3 = $5168a8572a4ea5fa$var$calcOffset(new Date(utcGuess), timezoneString);
    if (o2 === o3) return o2;
    // If it's different, we're in a hole time. The offset has changed, but we don't adjust the time
    return Math.max(o2, o3);
}
function $5168a8572a4ea5fa$var$validateTimezone(hours, minutes) {
    return -23 <= hours && hours <= 23 && (minutes == null || 0 <= minutes && minutes <= 59);
}
var $5168a8572a4ea5fa$var$validIANATimezoneCache = {};
function $5168a8572a4ea5fa$var$isValidTimezoneIANAString(timeZoneString) {
    if ($5168a8572a4ea5fa$var$validIANATimezoneCache[timeZoneString]) return true;
    try {
        new Intl.DateTimeFormat(undefined, {
            timeZone: timeZoneString
        });
        $5168a8572a4ea5fa$var$validIANATimezoneCache[timeZoneString] = true;
        return true;
    } catch (error) {
        return false;
    }
}

});
parcelRegister("lLNDp", function(module, exports) {

$parcel$export(module.exports, "default", () => $fd947d245dec6ea5$export$2e2bcd8739ae039);
/**
 * Returns the [year, month, day, hour, minute, seconds] tokens of the provided
 * `date` as it will be rendered in the `timeZone`.
 */ function $fd947d245dec6ea5$export$2e2bcd8739ae039(date, timeZone) {
    var dtf = $fd947d245dec6ea5$var$getDateTimeFormat(timeZone);
    return dtf.formatToParts ? $fd947d245dec6ea5$var$partsOffset(dtf, date) : $fd947d245dec6ea5$var$hackyOffset(dtf, date);
}
var $fd947d245dec6ea5$var$typeToPos = {
    year: 0,
    month: 1,
    day: 2,
    hour: 3,
    minute: 4,
    second: 5
};
function $fd947d245dec6ea5$var$partsOffset(dtf, date) {
    try {
        var formatted = dtf.formatToParts(date);
        var filled = [];
        for(var i = 0; i < formatted.length; i++){
            var pos = $fd947d245dec6ea5$var$typeToPos[formatted[i].type];
            if (pos >= 0) filled[pos] = parseInt(formatted[i].value, 10);
        }
        return filled;
    } catch (error) {
        if (error instanceof RangeError) return [
            NaN
        ];
        throw error;
    }
}
function $fd947d245dec6ea5$var$hackyOffset(dtf, date) {
    var formatted = dtf.format(date);
    var parsed = /(\d+)\/(\d+)\/(\d+),? (\d+):(\d+):(\d+)/.exec(formatted);
    // var [, fMonth, fDay, fYear, fHour, fMinute, fSecond] = parsed
    // return [fYear, fMonth, fDay, fHour, fMinute, fSecond]
    return [
        parsed[3],
        parsed[1],
        parsed[2],
        parsed[4],
        parsed[5],
        parsed[6]
    ];
}
// Get a cached Intl.DateTimeFormat instance for the IANA `timeZone`. This can be used
// to get deterministic local date/time output according to the `en-US` locale which
// can be used to extract local time parts as necessary.
var $fd947d245dec6ea5$var$dtfCache = {};
function $fd947d245dec6ea5$var$getDateTimeFormat(timeZone) {
    if (!$fd947d245dec6ea5$var$dtfCache[timeZone]) {
        // New browsers use `hourCycle`, IE and Chrome <73 does not support it and uses `hour12`
        var testDateFormatted = new Intl.DateTimeFormat('en-US', {
            hourCycle: 'h23',
            timeZone: 'America/New_York',
            year: 'numeric',
            month: '2-digit',
            day: '2-digit',
            hour: '2-digit',
            minute: '2-digit',
            second: '2-digit'
        }).format(new Date('2014-06-25T04:00:00.123Z'));
        var hourCycleSupported = testDateFormatted === '06/25/2014, 00:00:00' || testDateFormatted === "\u200E06\u200E/\u200E25\u200E/\u200E2014\u200E \u200E00\u200E:\u200E00\u200E:\u200E00";
        $fd947d245dec6ea5$var$dtfCache[timeZone] = hourCycleSupported ? new Intl.DateTimeFormat('en-US', {
            hourCycle: 'h23',
            timeZone: timeZone,
            year: 'numeric',
            month: 'numeric',
            day: '2-digit',
            hour: '2-digit',
            minute: '2-digit',
            second: '2-digit'
        }) : new Intl.DateTimeFormat('en-US', {
            hour12: false,
            timeZone: timeZone,
            year: 'numeric',
            month: 'numeric',
            day: '2-digit',
            hour: '2-digit',
            minute: '2-digit',
            second: '2-digit'
        });
    }
    return $fd947d245dec6ea5$var$dtfCache[timeZone];
}

});

parcelRegister("h3kEp", function(module, exports) {

$parcel$export(module.exports, "default", () => $c6a2bc4b1d0fb732$export$2e2bcd8739ae039);
/**
 * Use instead of `new Date(Date.UTC(...))` to support years below 100 which doesn't work
 * otherwise due to the nature of the
 * [`Date` constructor](https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Date#interpretation_of_two-digit_years.
 *
 * For `Date.UTC(...)`, use `newDateUTC(...).getTime()`.
 */ function $c6a2bc4b1d0fb732$export$2e2bcd8739ae039(fullYear, month, day, hour, minute, second, millisecond) {
    var utcDate = new Date(0);
    utcDate.setUTCFullYear(fullYear, month, day);
    utcDate.setUTCHours(hour, minute, second, millisecond);
    return utcDate;
}

});



parcelRegister("sNI8p", function(module, exports) {

$parcel$export(module.exports, "default", () => $05692d2dadd400c6$export$2e2bcd8739ae039);

var $aSksP = parcelRequire("aSksP");

var $jGQTC = parcelRequire("jGQTC");

var $6ZkUj = parcelRequire("6ZkUj");

var $7koqM = parcelRequire("7koqM");
var $05692d2dadd400c6$var$MILLISECONDS_IN_HOUR = 3600000;
var $05692d2dadd400c6$var$MILLISECONDS_IN_MINUTE = 60000;
var $05692d2dadd400c6$var$DEFAULT_ADDITIONAL_DIGITS = 2;
var $05692d2dadd400c6$var$patterns = {
    dateTimePattern: /^([0-9W+-]+)(T| )(.*)/,
    datePattern: /^([0-9W+-]+)(.*)/,
    plainTime: /:/,
    // year tokens
    YY: /^(\d{2})$/,
    YYY: [
        /^([+-]\d{2})$/,
        /^([+-]\d{3})$/,
        /^([+-]\d{4})$/
    ],
    YYYY: /^(\d{4})/,
    YYYYY: [
        /^([+-]\d{4})/,
        /^([+-]\d{5})/,
        /^([+-]\d{6})/
    ],
    // date tokens
    MM: /^-(\d{2})$/,
    DDD: /^-?(\d{3})$/,
    MMDD: /^-?(\d{2})-?(\d{2})$/,
    Www: /^-?W(\d{2})$/,
    WwwD: /^-?W(\d{2})-?(\d{1})$/,
    HH: /^(\d{2}([.,]\d*)?)$/,
    HHMM: /^(\d{2}):?(\d{2}([.,]\d*)?)$/,
    HHMMSS: /^(\d{2}):?(\d{2}):?(\d{2}([.,]\d*)?)$/,
    // time zone tokens (to identify the presence of a tz)
    timeZone: (0, $7koqM.default)
};
function $05692d2dadd400c6$export$2e2bcd8739ae039(argument, dirtyOptions) {
    if (arguments.length < 1) throw new TypeError('1 argument required, but only ' + arguments.length + ' present');
    if (argument === null) return new Date(NaN);
    var options = dirtyOptions || {};
    var additionalDigits = options.additionalDigits == null ? $05692d2dadd400c6$var$DEFAULT_ADDITIONAL_DIGITS : (0, (/*@__PURE__*/$parcel$interopDefault($aSksP)))(options.additionalDigits);
    if (additionalDigits !== 2 && additionalDigits !== 1 && additionalDigits !== 0) throw new RangeError('additionalDigits must be 0, 1 or 2');
    // Clone the date
    if (argument instanceof Date || typeof argument === 'object' && Object.prototype.toString.call(argument) === '[object Date]') // Prevent the date to lose the milliseconds when passed to new Date() in IE10
    return new Date(argument.getTime());
    else if (typeof argument === 'number' || Object.prototype.toString.call(argument) === '[object Number]') return new Date(argument);
    else if (!(typeof argument === 'string' || Object.prototype.toString.call(argument) === '[object String]')) return new Date(NaN);
    var dateStrings = $05692d2dadd400c6$var$splitDateString(argument);
    var parseYearResult = $05692d2dadd400c6$var$parseYear(dateStrings.date, additionalDigits);
    var year = parseYearResult.year;
    var restDateString = parseYearResult.restDateString;
    var date = $05692d2dadd400c6$var$parseDate(restDateString, year);
    if (isNaN(date)) return new Date(NaN);
    if (date) {
        var timestamp = date.getTime();
        var time = 0;
        var offset;
        if (dateStrings.time) {
            time = $05692d2dadd400c6$var$parseTime(dateStrings.time);
            if (isNaN(time)) return new Date(NaN);
        }
        if (dateStrings.timeZone || options.timeZone) {
            offset = (0, $6ZkUj.default)(dateStrings.timeZone || options.timeZone, new Date(timestamp + time));
            if (isNaN(offset)) return new Date(NaN);
        } else {
            // get offset accurate to hour in time zones that change offset
            offset = (0, (/*@__PURE__*/$parcel$interopDefault($jGQTC)))(new Date(timestamp + time));
            offset = (0, (/*@__PURE__*/$parcel$interopDefault($jGQTC)))(new Date(timestamp + time + offset));
        }
        return new Date(timestamp + time + offset);
    } else return new Date(NaN);
}
function $05692d2dadd400c6$var$splitDateString(dateString) {
    var dateStrings = {};
    var parts = $05692d2dadd400c6$var$patterns.dateTimePattern.exec(dateString);
    var timeString;
    if (!parts) {
        parts = $05692d2dadd400c6$var$patterns.datePattern.exec(dateString);
        if (parts) {
            dateStrings.date = parts[1];
            timeString = parts[2];
        } else {
            dateStrings.date = null;
            timeString = dateString;
        }
    } else {
        dateStrings.date = parts[1];
        timeString = parts[3];
    }
    if (timeString) {
        var token = $05692d2dadd400c6$var$patterns.timeZone.exec(timeString);
        if (token) {
            dateStrings.time = timeString.replace(token[1], '');
            dateStrings.timeZone = token[1].trim();
        } else dateStrings.time = timeString;
    }
    return dateStrings;
}
function $05692d2dadd400c6$var$parseYear(dateString, additionalDigits) {
    var patternYYY = $05692d2dadd400c6$var$patterns.YYY[additionalDigits];
    var patternYYYYY = $05692d2dadd400c6$var$patterns.YYYYY[additionalDigits];
    var token;
    // YYYY or ±YYYYY
    token = $05692d2dadd400c6$var$patterns.YYYY.exec(dateString) || patternYYYYY.exec(dateString);
    if (token) {
        var yearString = token[1];
        return {
            year: parseInt(yearString, 10),
            restDateString: dateString.slice(yearString.length)
        };
    }
    // YY or ±YYY
    token = $05692d2dadd400c6$var$patterns.YY.exec(dateString) || patternYYY.exec(dateString);
    if (token) {
        var centuryString = token[1];
        return {
            year: parseInt(centuryString, 10) * 100,
            restDateString: dateString.slice(centuryString.length)
        };
    }
    // Invalid ISO-formatted year
    return {
        year: null
    };
}
function $05692d2dadd400c6$var$parseDate(dateString, year) {
    // Invalid ISO-formatted year
    if (year === null) return null;
    var token;
    var date;
    var month;
    var week;
    // YYYY
    if (dateString.length === 0) {
        date = new Date(0);
        date.setUTCFullYear(year);
        return date;
    }
    // YYYY-MM
    token = $05692d2dadd400c6$var$patterns.MM.exec(dateString);
    if (token) {
        date = new Date(0);
        month = parseInt(token[1], 10) - 1;
        if (!$05692d2dadd400c6$var$validateDate(year, month)) return new Date(NaN);
        date.setUTCFullYear(year, month);
        return date;
    }
    // YYYY-DDD or YYYYDDD
    token = $05692d2dadd400c6$var$patterns.DDD.exec(dateString);
    if (token) {
        date = new Date(0);
        var dayOfYear = parseInt(token[1], 10);
        if (!$05692d2dadd400c6$var$validateDayOfYearDate(year, dayOfYear)) return new Date(NaN);
        date.setUTCFullYear(year, 0, dayOfYear);
        return date;
    }
    // yyyy-MM-dd or YYYYMMDD
    token = $05692d2dadd400c6$var$patterns.MMDD.exec(dateString);
    if (token) {
        date = new Date(0);
        month = parseInt(token[1], 10) - 1;
        var day = parseInt(token[2], 10);
        if (!$05692d2dadd400c6$var$validateDate(year, month, day)) return new Date(NaN);
        date.setUTCFullYear(year, month, day);
        return date;
    }
    // YYYY-Www or YYYYWww
    token = $05692d2dadd400c6$var$patterns.Www.exec(dateString);
    if (token) {
        week = parseInt(token[1], 10) - 1;
        if (!$05692d2dadd400c6$var$validateWeekDate(year, week)) return new Date(NaN);
        return $05692d2dadd400c6$var$dayOfISOWeekYear(year, week);
    }
    // YYYY-Www-D or YYYYWwwD
    token = $05692d2dadd400c6$var$patterns.WwwD.exec(dateString);
    if (token) {
        week = parseInt(token[1], 10) - 1;
        var dayOfWeek = parseInt(token[2], 10) - 1;
        if (!$05692d2dadd400c6$var$validateWeekDate(year, week, dayOfWeek)) return new Date(NaN);
        return $05692d2dadd400c6$var$dayOfISOWeekYear(year, week, dayOfWeek);
    }
    // Invalid ISO-formatted date
    return null;
}
function $05692d2dadd400c6$var$parseTime(timeString) {
    var token;
    var hours;
    var minutes;
    // hh
    token = $05692d2dadd400c6$var$patterns.HH.exec(timeString);
    if (token) {
        hours = parseFloat(token[1].replace(',', '.'));
        if (!$05692d2dadd400c6$var$validateTime(hours)) return NaN;
        return hours % 24 * $05692d2dadd400c6$var$MILLISECONDS_IN_HOUR;
    }
    // hh:mm or hhmm
    token = $05692d2dadd400c6$var$patterns.HHMM.exec(timeString);
    if (token) {
        hours = parseInt(token[1], 10);
        minutes = parseFloat(token[2].replace(',', '.'));
        if (!$05692d2dadd400c6$var$validateTime(hours, minutes)) return NaN;
        return hours % 24 * $05692d2dadd400c6$var$MILLISECONDS_IN_HOUR + minutes * $05692d2dadd400c6$var$MILLISECONDS_IN_MINUTE;
    }
    // hh:mm:ss or hhmmss
    token = $05692d2dadd400c6$var$patterns.HHMMSS.exec(timeString);
    if (token) {
        hours = parseInt(token[1], 10);
        minutes = parseInt(token[2], 10);
        var seconds = parseFloat(token[3].replace(',', '.'));
        if (!$05692d2dadd400c6$var$validateTime(hours, minutes, seconds)) return NaN;
        return hours % 24 * $05692d2dadd400c6$var$MILLISECONDS_IN_HOUR + minutes * $05692d2dadd400c6$var$MILLISECONDS_IN_MINUTE + seconds * 1000;
    }
    // Invalid ISO-formatted time
    return null;
}
function $05692d2dadd400c6$var$dayOfISOWeekYear(isoWeekYear, week, day) {
    week = week || 0;
    day = day || 0;
    var date = new Date(0);
    date.setUTCFullYear(isoWeekYear, 0, 4);
    var fourthOfJanuaryDay = date.getUTCDay() || 7;
    var diff = week * 7 + day + 1 - fourthOfJanuaryDay;
    date.setUTCDate(date.getUTCDate() + diff);
    return date;
}
// Validation functions
var $05692d2dadd400c6$var$DAYS_IN_MONTH = [
    31,
    28,
    31,
    30,
    31,
    30,
    31,
    31,
    30,
    31,
    30,
    31
];
var $05692d2dadd400c6$var$DAYS_IN_MONTH_LEAP_YEAR = [
    31,
    29,
    31,
    30,
    31,
    30,
    31,
    31,
    30,
    31,
    30,
    31
];
function $05692d2dadd400c6$var$isLeapYearIndex(year) {
    return year % 400 === 0 || year % 4 === 0 && year % 100 !== 0;
}
function $05692d2dadd400c6$var$validateDate(year, month, date) {
    if (month < 0 || month > 11) return false;
    if (date != null) {
        if (date < 1) return false;
        var isLeapYear = $05692d2dadd400c6$var$isLeapYearIndex(year);
        if (isLeapYear && date > $05692d2dadd400c6$var$DAYS_IN_MONTH_LEAP_YEAR[month]) return false;
        if (!isLeapYear && date > $05692d2dadd400c6$var$DAYS_IN_MONTH[month]) return false;
    }
    return true;
}
function $05692d2dadd400c6$var$validateDayOfYearDate(year, dayOfYear) {
    if (dayOfYear < 1) return false;
    var isLeapYear = $05692d2dadd400c6$var$isLeapYearIndex(year);
    if (isLeapYear && dayOfYear > 366) return false;
    if (!isLeapYear && dayOfYear > 365) return false;
    return true;
}
function $05692d2dadd400c6$var$validateWeekDate(year, week, day) {
    if (week < 0 || week > 52) return false;
    if (day != null && (day < 0 || day > 6)) return false;
    return true;
}
function $05692d2dadd400c6$var$validateTime(hours, minutes, seconds) {
    if (hours != null && (hours < 0 || hours >= 25)) return false;
    if (minutes != null && (minutes < 0 || minutes >= 60)) return false;
    if (seconds != null && (seconds < 0 || seconds >= 60)) return false;
    return true;
}

});
parcelRegister("7koqM", function(module, exports) {

$parcel$export(module.exports, "default", () => $555d5a1d4b17cc17$export$2e2bcd8739ae039);
/** Regex to identify the presence of a time zone specifier in a date string */ var $555d5a1d4b17cc17$var$tzPattern = /(Z|[+-]\d{2}(?::?\d{2})?| UTC| [a-zA-Z]+\/[a-zA-Z_]+(?:\/[a-zA-Z_]+)?)$/;
var $555d5a1d4b17cc17$export$2e2bcd8739ae039 = $555d5a1d4b17cc17$var$tzPattern;

});



parcelRegister("iEBtW", function(module, exports) {

$parcel$export(module.exports, "default", () => $d9490987520dece7$export$2e2bcd8739ae039);

var $6ZkUj = parcelRequire("6ZkUj");

var $sNI8p = parcelRequire("sNI8p");
function $d9490987520dece7$export$2e2bcd8739ae039(dirtyDate, timeZone, options) {
    var date = (0, $sNI8p.default)(dirtyDate, options);
    var offsetMilliseconds = (0, $6ZkUj.default)(timeZone, date, true);
    var d = new Date(date.getTime() - offsetMilliseconds);
    var resultDate = new Date(0);
    resultDate.setFullYear(d.getUTCFullYear(), d.getUTCMonth(), d.getUTCDate());
    resultDate.setHours(d.getUTCHours(), d.getUTCMinutes(), d.getUTCSeconds(), d.getUTCMilliseconds());
    return resultDate;
}

});





parcelRegister("7pLOg", function(module, exports) {

$parcel$export(module.exports, "default", () => $b9ae585c7017b5f5$export$2e2bcd8739ae039);

var $aOgFy = parcelRequire("aOgFy");

var $hrPaF = parcelRequire("hrPaF");

var $6laLp = parcelRequire("6laLp");

var $9yQ7J = parcelRequire("9yQ7J");
const $b9ae585c7017b5f5$var$PRODUCT_RECCOMENDATIONS = '/v1/product-recommendations';
const $b9ae585c7017b5f5$var$PRODUCT_JOIN_OR_REQUEST_BULK = '/v1/access-requests/bulk/request';
const $b9ae585c7017b5f5$var$ALL_SUPPORTED_PRODUCTS = [
    'confluence',
    'jira',
    'jira-core',
    'jira-servicedesk',
    'jira-software',
    'jira-incident-manager',
    'jira-product-discovery',
    'opsgenie',
    'statuspage',
    'avocado',
    'townsquare',
    'compass',
    'avp',
    'beacon',
    'mercury'
];
class $b9ae585c7017b5f5$export$3209eb31343f39d extends (0, $hrPaF.RestClient) {
    constructor(serviceUrl, config){
        super({
            serviceUrl: serviceUrl,
            config: config
        });
    }
    async getProductRecommendationsInner(supportedProducts = $b9ae585c7017b5f5$var$ALL_SUPPORTED_PRODUCTS, capabilities) {
        try {
            const orgId = this.getOrgId();
            const queryProducts = supportedProducts && supportedProducts.length > 0 ? supportedProducts : $b9ae585c7017b5f5$var$ALL_SUPPORTED_PRODUCTS;
            const productQueryParams = queryProducts.map((product)=>`product=${product}`).join('&');
            const capabilityQueryParams = capabilities && capabilities.length > 0 ? '&' + capabilities.map((capability)=>`capability=${capability}`).join('&') : '';
            const url = `${$b9ae585c7017b5f5$var$PRODUCT_RECCOMENDATIONS}?orgId=${orgId}&${productQueryParams}${capabilityQueryParams}`;
            return await this.getResource(url);
        } catch (error) {
            this.logException(error, 'An error occurred while getting product recommendations.');
            throw error;
        }
    }
    async getProductRecommendations(supportedProducts = $b9ae585c7017b5f5$var$ALL_SUPPORTED_PRODUCTS, capabilities) {
        // This endpoint may return duplicate resource ARIs with a different mode.
        const result = await this.getProductRecommendationsInner(supportedProducts, capabilities);
        try {
            const deduplicatedResult = (0, $9yQ7J.removeDuplicateRecommendations)(result);
            return deduplicatedResult;
        } catch (error) {
            this.logException(error, 'An error occurred while deduplicating product recommendations.');
            throw error;
        }
    }
    async joinOrRequestDefaultAccessToProductsBulk(simplifiedRequest) {
        if (simplifiedRequest.productAris.length === 0) return Promise.resolve([]);
        try {
            const resources = simplifiedRequest.productAris.map((ari)=>({
                    ari: ari,
                    role: 'product/member'
                }));
            const request = {
                resources: resources,
                note: simplifiedRequest.note,
                accessMode: simplifiedRequest.accessMode,
                source: simplifiedRequest.source
            };
            return await this.postResource($b9ae585c7017b5f5$var$PRODUCT_JOIN_OR_REQUEST_BULK, request);
        } catch (error) {
            this.logException(error, 'An error occurred while joining or requesting access to products.');
            throw error;
        }
    }
}
var // eslint-disable-next-line import/no-anonymous-default-export
$b9ae585c7017b5f5$export$2e2bcd8739ae039 = new $b9ae585c7017b5f5$export$3209eb31343f39d((0, $aOgFy.DEFAULT_CONFIG).invitationsServiceUrl, {
    logException: $6laLp.logException
});

});
parcelRegister("9yQ7J", function(module, exports) {

$parcel$export(module.exports, "removeDuplicateRecommendations", () => $3c835b25600ef74b$export$d9d1c981635dd213);
/**
 * Determines which capability is more desirable.
 * Users desire direct access over request access since it's instant.
 * @returns 0 if equal, -1 if a is more desirable, 1 if b is more desirable.
 */ const $3c835b25600ef74b$var$compareCapability = (a, b)=>{
    if (a === b) return 0;
    return a === 'DIRECT_ACCESS' ? -1 : 1;
};
/**
 * Determines which mode is more desirable.
 * Atlassian prefers to provide open access over domain restricted access.
 * Both of these modes have already been enabled by an admin.
 * If mode is undefined, it is deemed least desirable.
 * @returns 0 if equal, -1 if a is more open, 1 if b is more open.
 */ const $3c835b25600ef74b$var$compareMode = (a, b)=>{
    if (a === b) return 0;
    if (!a) return 1;
    if (!b) return -1;
    return a === 'OPEN' ? -1 : 1;
};
/**
 * Determine if a recommendation is more desirable than another.
 * Atlassian prefers a better capability over any mode setting.
 * The mode will only be compared if the capabilities are equal.
 * If both capability and mode are equal, the recommendations are considered the same.
 *
 * Assumes recommendations have the same resource ID.
 * Do not compare recommendations with different resource IDs, as it does not make sense.
 *
 * @returns 0 if capability and mode are equal, -1 if a is more desirable, 1 if b is more desirable.
 */ const $3c835b25600ef74b$var$compareRecommendations = (a, b)=>{
    if (a.resourceId !== b.resourceId) throw new Error('Recommendations must have the same resource ID');
    if ($3c835b25600ef74b$var$compareCapability(a.capability, b.capability) < 0) return -1;
    else if ($3c835b25600ef74b$var$compareCapability(a.capability, b.capability) > 0) return 1;
    else if ($3c835b25600ef74b$var$compareMode(a.mode, b.mode) < 0) return -1;
    else if ($3c835b25600ef74b$var$compareMode(a.mode, b.mode) > 0) return 1;
    return 0;
};
const $3c835b25600ef74b$var$toRecommendation = (recommendation)=>{
    const { capability: capability, ...rest } = recommendation;
    return {
        ...rest
    };
};
const $3c835b25600ef74b$export$d9d1c981635dd213 = (recommendations)=>{
    const { DIRECT_ACCESS: DIRECT_ACCESS, REQUEST_ACCESS: REQUEST_ACCESS } = recommendations.capability;
    const uniqueRecommendations = {};
    const allRecommendations = [
        ...DIRECT_ACCESS.map((recommendation)=>({
                ...recommendation,
                capability: 'DIRECT_ACCESS'
            })),
        ...REQUEST_ACCESS.map((recommendation)=>({
                ...recommendation,
                capability: 'REQUEST_ACCESS'
            }))
    ];
    allRecommendations.forEach((recommendation)=>{
        const existing = uniqueRecommendations[recommendation.resourceId];
        if (existing && $3c835b25600ef74b$var$compareRecommendations(existing, recommendation) <= 0) return;
        uniqueRecommendations[recommendation.resourceId] = recommendation;
    });
    const allUniqueRecommendations = Object.values(uniqueRecommendations);
    return {
        capability: {
            DIRECT_ACCESS: allUniqueRecommendations.filter((recommendation)=>recommendation.capability === 'DIRECT_ACCESS').map($3c835b25600ef74b$var$toRecommendation),
            REQUEST_ACCESS: allUniqueRecommendations.filter((recommendation)=>recommendation.capability === 'REQUEST_ACCESS').map($3c835b25600ef74b$var$toRecommendation)
        }
    };
};

});


parcelRegister("8MCmh", function(module, exports) {

$parcel$export(module.exports, "defaultLegionClient", () => $2443af7a75778c61$export$95c697fe95d86a77);

var $aOgFy = parcelRequire("aOgFy");

var $hrPaF = parcelRequire("hrPaF");
const $2443af7a75778c61$var$v3UrlPath = `/v3/teams`;
const $2443af7a75778c61$var$v4UrlPath = `/v4/teams`;
class $2443af7a75778c61$export$68a6a391e3cf23be extends (0, $hrPaF.RestClient) {
    constructor(serviceUrl){
        super({
            serviceUrl: serviceUrl
        });
        this.serviceUrlRoot = serviceUrl;
    }
    setRootUrl(url) {
        if (url === this.serviceUrlRoot) return;
        this.serviceUrlRoot = url;
        this.setServiceUrl(url);
    }
    async getTeamById(teamId) {
        const siteId = this.getCloudId();
        const teamResponse = await this.getResource(`${$2443af7a75778c61$var$v4UrlPath}/${this.trimTeamARI(teamId)}?siteId=${siteId}`);
        return this.mapTeamResponseV4ToTeam(teamResponse);
    }
    async getAllTeams(allTeamsQuery) {
        try {
            const orgId = this.getOrgId(allTeamsQuery.orgId);
            const siteId = this.getCloudId();
            const { entities: entities, cursor: cursor } = await this.postResource(`${$2443af7a75778c61$var$v4UrlPath}/search`, {
                organizationId: orgId,
                siteId: siteId,
                limit: allTeamsQuery.limit,
                query: allTeamsQuery.searchQuery,
                cursor: allTeamsQuery.cursor || '',
                sortBy: allTeamsQuery.useDefaultSort ? null : [
                    {
                        field: 'displayName',
                        order: 'asc'
                    }
                ],
                membership: {
                    memberAccountIds: allTeamsQuery.memberAccountIds
                },
                showEmptyTeams: allTeamsQuery.showEmptyTeams
            });
            const teams = entities.map((t)=>this.mapTeamSearchResponseV4ToTeamWithMembership(t));
            return {
                cursor: cursor,
                teams: teams
            };
        } catch (error) {
            this.logException(error, 'getAllTeams');
            return {
                cursor: '',
                teams: [],
                error: error instanceof Error ? error : undefined
            };
        }
    }
    async updateTeamById(teamId, data) {
        const teamResponse = await this.patchResource(`${$2443af7a75778c61$var$v4UrlPath}/${this.trimTeamARI(teamId)}`, data);
        return this.mapTeamResponseV4ToTeam(teamResponse);
    }
    /**
	 * @private
	 * @deprecated use publicApiClient.addUsersToTeam instead
	 */ async inviteUsersToTeam(teamId, users, originQuery) {
        if (!users || users.length === 0) return Promise.resolve([]);
        const emails = [];
        const ids = [];
        users.forEach((user)=>{
            if (user.id) ids.push(user.id);
            else if (user.email) emails.push(user.email);
        });
        const url = `${$2443af7a75778c61$var$v3UrlPath}/ui/${this.trimTeamARI(teamId)}/membership/invite?${this.constructProductOriginParams(originQuery)}`;
        return this.postResource(url, {
            emailAddresses: emails,
            atlassianAccounts: ids
        });
    }
    async getMyTeamMembership(teamId) {
        return this.getResource(`${$2443af7a75778c61$var$v4UrlPath}/${this.trimTeamARI(teamId)}/membership/me?siteId=${this.getCloudId()}`, {
            shouldLogError: (e)=>e.status !== 400
        });
    }
    async getTeamLinksByTeamId(teamId) {
        let siteId = this.getCloudId();
        let response = await this.getResource(`${$2443af7a75778c61$var$v4UrlPath}/${this.trimTeamARI(teamId)}/links?siteId=${siteId}`);
        return this.mapLegionTeamLinksResponseV4ToTeamLinkResponse(response);
    }
    async createTeamLink(teamId, link) {
        const sanitisedTeamLink = {
            contentTitle: link.contentTitle.trim(),
            linkUri: link.linkUri.trim(),
            description: link.description.trim(),
            ...link.creationTime ? {
                creationTime: link.creationTime.trim()
            } : {},
            ...link.teamId ? {
                teamId: link.teamId.trim()
            } : {}
        };
        const response = await this.postResource(`${$2443af7a75778c61$var$v4UrlPath}/${this.trimTeamARI(teamId)}/links`, sanitisedTeamLink);
        return this.mapLegionTeamLinkResponseV4ToTeamLink(response);
    }
    async updateTeamLink(teamId, linkId, { linkUri: linkUri, ...linkFields }) {
        const response = await this.putResource(`${$2443af7a75778c61$var$v4UrlPath}/${this.trimTeamARI(teamId)}/links/${linkId}`, {
            linkUri: linkUri.trim(),
            ...linkFields
        });
        return this.mapLegionTeamLinkResponseV4ToTeamLink(response);
    }
    async deleteTeamLink(teamId, linkId) {
        return this.deleteResource(`${$2443af7a75778c61$var$v4UrlPath}/${this.trimTeamARI(teamId)}/links/${linkId}`);
    }
    async reorderTeamLink(teamId, linkId, newPosition) {
        const queryArgs = `?linkId=${linkId}&newPosition=${newPosition}`;
        return this.postResource(`${$2443af7a75778c61$var$v4UrlPath}/${this.trimTeamARI(teamId)}/links/order${queryArgs}`);
    }
    async getOrgEligibilityForManagedTeams() {
        const orgId = this.getOrgId();
        if (!orgId) {
            const err = new Error('Organization ID is required');
            this.logException(err, 'getOrgEligibilityForManagedTeams');
            throw err;
        }
        return this.getResourceCached(`${$2443af7a75778c61$var$v4UrlPath}/org/${orgId}/premium/eligibility`);
    }
    /**
	 * @private
	 * @deprecated in V4, as no invitation status for team membership anymore.
	 */ async acceptTeamInvitation(teamId) {
        return this.postResource(`${$2443af7a75778c61$var$v3UrlPath}/ui/${this.trimTeamARI(teamId)}/membership/accept`);
    }
    /**
	 * @private
	 * @deprecated in V4, as no invitation status for team membership anymore.
	 */ async declineTeamInvitation(teamId) {
        return this.postResource(`${$2443af7a75778c61$var$v3UrlPath}/ui/${this.trimTeamARI(teamId)}/membership/decline`);
    }
    async selfJoinTeam(// TODO Test me
    teamId, originQuery) {
        const url = `${$2443af7a75778c61$var$v4UrlPath}/${this.trimTeamARI(teamId)}/membership/join?${this.constructProductOriginParams(originQuery)}`;
        return this.postResource(url);
    }
    async cancelJoinRequest(teamId) {
        return this.deleteResource(`${$2443af7a75778c61$var$v4UrlPath}/${this.trimTeamARI(teamId)}/membership/request`);
    }
    async acceptJoinRequest(teamId, memberId) {
        return this.postResource(`${$2443af7a75778c61$var$v4UrlPath}/${this.trimTeamARI(teamId)}/membership/${memberId}/request/accept`);
    }
    async declineJoinRequest(teamId, memberId) {
        return this.postResource(`${$2443af7a75778c61$var$v4UrlPath}/${this.trimTeamARI(teamId)}/membership/${memberId}/request/decline`);
    }
    /**
	 * @private
	 * @deprecated use publicApiClient.removeTeamMemberships instead
	 */ async deleteTeamMembership(teamId, memberId) {
        return this.deleteResource(`${$2443af7a75778c61$var$v3UrlPath}/${this.trimTeamARI(teamId)}/members/${memberId}`);
    }
    /**
	 * @private
	 * @deprecated INVITED status has been deprecated
	 */ async revokeTeamInvite(teamId, memberId) {
        return this.deleteResource(`${$2443af7a75778c61$var$v3UrlPath}/ui/${this.trimTeamARI(teamId)}/membership/${memberId}/revoke`);
    }
    async deleteTeam(teamId) {
        return this.deleteResource(`${$2443af7a75778c61$var$v4UrlPath}/${this.trimTeamARI(teamId)}`);
    }
    /**
	 * @private
	 * @deprecated should be other means to solve this issue
	 */ async isSingleFullMemberTeam(teamId) {
        // This is still not working...
        const members = await this.getResource(`${$2443af7a75778c61$var$v4UrlPath}/${this.trimTeamARI(teamId)}/members?size=2&membershipState=FULL_MEMBER&siteId=${this.getCloudId()}`);
        return members.entities.length === 1;
    }
    async createTeam(displayName, originQuery, members, membershipSettings = 'OPEN') {
        const organizationId = this.getContext().orgId;
        if (!organizationId) {
            const err = new Error('Organization ID is required');
            this.logException(err, 'createTeam');
            throw err;
        }
        const url = `${$2443af7a75778c61$var$v4UrlPath}?${this.constructProductOriginParams(originQuery)}`;
        const legionTeam = await this.postResource(url, {
            displayName: displayName,
            description: '',
            membershipSettings: membershipSettings,
            siteId: this.getCloudId(),
            organizationId: organizationId,
            members: [
                ...new Set(members)
            ]
        });
        return this.mapTeamCreateResponseV4ToTeam(legionTeam);
    }
    async createExternalTeam(description, externalReference, teamName, siteId) {
        const organizationId = this.getContext().orgId;
        const cloudId = this.getContext().cloudId;
        if (!organizationId) {
            const err = new Error('Organization ID is required');
            this.logException(err, 'createTeam');
            throw err;
        }
        const url = `${$2443af7a75778c61$var$v4UrlPath}/external?origin.cloudId=${encodeURIComponent(this.getCloudId(siteId || cloudId))}`;
        const legionExternalTeam = await this.postResource(url, {
            description: description,
            externalReference: externalReference,
            organizationId: organizationId,
            siteId: siteId || cloudId,
            displayName: teamName
        });
        return this.mapTeamCreateResponseV4ToTeam(legionExternalTeam);
    }
    async getTeamAndGroupDiff(teamId, externalReference) {
        const siteId = this.getCloudId();
        return this.postResource(`${$2443af7a75778c61$var$v4UrlPath}/${this.trimTeamARI(teamId)}/external/diff`, {
            siteId: siteId,
            externalReference: externalReference
        });
    }
    async linkExistingTeamToGroup(teamId, externalReference) {
        const siteId = this.getCloudId();
        return this.postResource(`${$2443af7a75778c61$var$v4UrlPath}/${this.trimTeamARI(teamId)}/external/link`, {
            externalReference: externalReference,
            siteId: siteId
        });
    }
    async getWriteMediaToken() {
        return this.getResource('/v4/teams/header-image/media-upload').then((response)=>({
                ...response,
                baseUrl: response.baseUrl?.endsWith('/') ? response.baseUrl.slice(0, -1) : response.baseUrl
            }));
    }
    async getSoftDeletedTeamById(teamId) {
        const orgId = this.getOrgId();
        const siteId = this.getCloudId();
        return this.getResource(`${$2443af7a75778c61$var$v4UrlPath}/org/${orgId}/soft-deleted/${this.trimTeamARI(teamId)}?siteId=${siteId}`).then((response)=>({
                ...response.teamResponse,
                id: teamId
            }));
    }
    /**
	 * Shoud only be used within Teams (P&T) packages
	 */ async getUserInSiteUserBase(userId) {
        const siteId = this.getCloudId();
        return this.getResource(`/teams/site/${siteId}/users/${userId}/exists`, {
            headers: {
                Accept: 'application/json',
                'X-header-client-id': 'ptc-fe'
            }
        });
    }
    async retrieveBrowseUserPermission(product) {
        return this.getResourceCached(`/teams/site/${this.getCloudId()}/canSearchUsers?product=${product}`, undefined, // 2 minute expiration, resolves duplicate calls in initial load
        {
            expiration: 120000
        });
    }
    async getPermissions() {
        const orgId = this.getContext().orgId;
        const siteId = this.getCloudId();
        if (!orgId) {
            const err = new Error('Organization ID is required');
            this.logException(err, 'getPermissions');
            throw err;
        }
        return this.getResourceCached(`${$2443af7a75778c61$var$v4UrlPath}/permission/self/organization/${orgId}?siteId=${siteId}`);
    }
    async getLinkedTeamsBulk(groupIds) {
        const organizationId = this.getContext().orgId;
        if (!organizationId) {
            const err = new Error('Organization ID is required');
            this.logException(err, 'getLinkedTeamsBulk');
            throw err;
        }
        const legionExternalTeam = await this.postResource(`${$2443af7a75778c61$var$v4UrlPath}/external/bulk`, {
            organizationId: organizationId,
            source: 'ATLASSIAN_GROUP',
            externalIds: groupIds
        });
        return legionExternalTeam;
    }
    async getTeamProfileDetails(teamId) {
        const siteId = this.getCloudId();
        if (!siteId) {
            const err = new Error('Site ID is required');
            this.logException(err, 'getTeamProfileDetails');
            throw err;
        }
        const linkedTeamsProfileDetails = await this.getResource(`${$2443af7a75778c61$var$v4UrlPath}/${teamId}/profile?siteId=${this.getCloudId()}`);
        return linkedTeamsProfileDetails;
    }
    async getOrgScope() {
        const orgId = this.getContext().orgId;
        if (!orgId) {
            const err = new Error('Organization ID is required');
            this.logException(err, 'getOrgScope');
            throw err;
        }
        const orgScope = await this.getResourceCached(`${$2443af7a75778c61$var$v4UrlPath}/org/${orgId}/scope`);
        return orgScope;
    }
    async restoreTeamToSyncedGroup(teamId, externalReference) {
        const siteId = this.getCloudId();
        return await this.postResource(`${$2443af7a75778c61$var$v4UrlPath}/${teamId}/external/restore`, {
            externalReference: externalReference,
            siteId: siteId
        });
    }
    async createTeamContainers(payload) {
        return this.postResource(`${$2443af7a75778c61$var$v4UrlPath}/containers`, {
            ...payload
        });
    }
    // some Legion APIs return team id with the team ARI
    trimTeamARI(teamId = '') {
        const OLD_TEAM_ARI_PREFIX = 'ari:cloud:teams::team/';
        const TEAM_ARI_PREFIX = 'ari:cloud:identity::team/';
        return teamId.replace(TEAM_ARI_PREFIX, '').replace(OLD_TEAM_ARI_PREFIX, ''); // PTC-4213 will remove the references to the old team ARI
    }
    constructProductOriginParams(originQuery) {
        const product = (originQuery.product || '').toUpperCase();
        const queries = [
            `origin.cloudId=${encodeURIComponent(this.getCloudId(originQuery.cloudId))}`
        ];
        if (product) queries.push(`origin.product=${encodeURIComponent(product)}`);
        return queries.join('&');
    }
    mapTeamResponseV4ToTeam(teamResponse) {
        return {
            id: teamResponse.id,
            displayName: teamResponse.displayName,
            description: teamResponse.description,
            state: teamResponse.state,
            membershipSettings: teamResponse.membershipSettings,
            organizationId: teamResponse.organizationId,
            restriction: 'ORG_MEMBERS',
            creatorId: teamResponse.creatorId,
            permission: teamResponse.permission,
            orgId: teamResponse.organizationId,
            smallHeaderImageUrl: teamResponse.smallHeaderImageUrl,
            largeHeaderImageUrl: teamResponse.largeHeaderImageUrl,
            smallAvatarImageUrl: teamResponse.smallAvatarImageUrl,
            largeAvatarImageUrl: teamResponse.largeAvatarImageUrl,
            scopeMode: teamResponse.scopeMode,
            isVerified: teamResponse.isVerified,
            ...teamResponse.externalReference && {
                externalReference: {
                    id: teamResponse.externalReference.id,
                    source: teamResponse.externalReference.source
                }
            }
        };
    }
    mapTeamCreateResponseV4ToTeam(teamResponse) {
        return {
            id: teamResponse.id,
            displayName: teamResponse.displayName,
            description: teamResponse.description,
            state: teamResponse.state,
            membershipSettings: teamResponse.membershipSettings,
            organizationId: teamResponse.organizationId,
            restriction: 'ORG_MEMBERS',
            creatorId: teamResponse.creatorId,
            permission: teamResponse.permission,
            orgId: teamResponse.organizationId,
            memberIds: teamResponse.membership?.members?.map((m)=>m.membershipId.memberId) || [],
            membership: teamResponse.membership
        };
    }
    mapTeamSearchResponseV4ToTeamWithMembership(teamResponse) {
        return {
            id: teamResponse.id,
            displayName: teamResponse.displayName,
            description: teamResponse.description,
            state: teamResponse.state,
            membershipSettings: teamResponse.membershipSettings,
            organizationId: teamResponse.organizationId,
            restriction: 'ORG_MEMBERS',
            smallHeaderImageUrl: teamResponse.smallHeaderImageUrl,
            largeAvatarImageUrl: teamResponse.largeAvatarImageUrl,
            smallAvatarImageUrl: teamResponse.smallAvatarImageUrl,
            largeHeaderImageUrl: teamResponse.largeHeaderImageUrl,
            memberCount: teamResponse.memberCount,
            includesYou: teamResponse.includesYou,
            memberIds: [],
            members: [],
            membership: {
                members: [],
                errors: []
            },
            isVerified: teamResponse.isVerified
        };
    }
    mapLegionTeamLinksResponseV3ToTeamLinkResponse(response) {
        return {
            entities: response.entities.map(this.mapLegionTeamLinkResponseV3ToTeamLink)
        };
    }
    mapLegionTeamLinksResponseV4ToTeamLinkResponse(response) {
        return {
            entities: response.entities.map(this.mapLegionTeamLinkResponseV4ToTeamLink)
        };
    }
    mapLegionTeamLinkResponseV3ToTeamLink(legionLinkResponseV3) {
        return {
            contentTitle: legionLinkResponseV3.contentTitle,
            description: legionLinkResponseV3.description,
            creationTime: legionLinkResponseV3.creationTime,
            linkUri: legionLinkResponseV3.linkUri,
            linkId: legionLinkResponseV3.linkId,
            teamId: legionLinkResponseV3.teamId
        };
    }
    mapLegionTeamLinkResponseV4ToTeamLink(legionLinkResponseV4) {
        return {
            contentTitle: legionLinkResponseV4.contentTitle,
            description: legionLinkResponseV4.description,
            linkUri: legionLinkResponseV4.linkUri,
            linkId: legionLinkResponseV4.linkId,
            teamId: legionLinkResponseV4.teamId
        };
    }
}
const $2443af7a75778c61$export$95c697fe95d86a77 = new $2443af7a75778c61$export$68a6a391e3cf23be((0, $aOgFy.DEFAULT_CONFIG).stargateRoot);

});

parcelRegister("13Kx5", function(module, exports) {

$parcel$export(module.exports, "default", () => $96e9f24df4d329d9$export$2e2bcd8739ae039);

var $1K4T6 = parcelRequire("1K4T6");

var $aOgFy = parcelRequire("aOgFy");

var $hrPaF = parcelRequire("hrPaF");
const $96e9f24df4d329d9$var$defaultConfig = {
    serviceUrl: `${(0, $aOgFy.DEFAULT_CONFIG).stargateRoot}/users/manage`
};
const $96e9f24df4d329d9$var$NOT_EDITABLE = 'not_editable';
const $96e9f24df4d329d9$var$NOT_EDITABLE_FIELD = 'field';
const $96e9f24df4d329d9$var$NOT_EDITABLE_REASON = 'reason';
class $96e9f24df4d329d9$export$1f387592ab3ca6d0 extends (0, $hrPaF.RestClient) {
    constructor(config = {}){
        super({
            ...$96e9f24df4d329d9$var$defaultConfig,
            ...config
        });
    }
    async getProfileWithMutability(userId) {
        return this.getResource(`/${userId}/profile`).then((resp)=>{
            return $96e9f24df4d329d9$var$mapToMutabilityConstraints(resp);
        });
    }
}
function $96e9f24df4d329d9$var$mapToMutabilityConstraints(json) {
    let constraints = [];
    if (json[$96e9f24df4d329d9$var$NOT_EDITABLE] != null) for (const value of json[$96e9f24df4d329d9$var$NOT_EDITABLE])constraints = constraints.concat({
        field: value[$96e9f24df4d329d9$var$NOT_EDITABLE_FIELD],
        reason: $96e9f24df4d329d9$var$determineReason(value[$96e9f24df4d329d9$var$NOT_EDITABLE_REASON])
    });
    return constraints;
}
function $96e9f24df4d329d9$var$determineReason(value) {
    switch(value){
        case 'managed':
        case 'ext.dir.scim':
        case 'ext.dir.google':
            return value;
        default:
            throw new (0, $1K4T6.DefaultError)({
                message: `Unknown mutability constraint reason: ${value}`
            });
    }
}
var // eslint-disable-next-line import/no-anonymous-default-export
$96e9f24df4d329d9$export$2e2bcd8739ae039 = new $96e9f24df4d329d9$export$1f387592ab3ca6d0();

});

parcelRegister("h46cM", function(module, exports) {

$parcel$export(module.exports, "default", () => $6f2e78061b0eb028$export$2e2bcd8739ae039);

var $aOgFy = parcelRequire("aOgFy");

var $hrPaF = parcelRequire("hrPaF");

var $hjCdE = parcelRequire("hjCdE");
const $6f2e78061b0eb028$var$defaultConfig = {
    serviceUrl: `${(0, $aOgFy.DEFAULT_CONFIG).stargateRoot}`
};
class $6f2e78061b0eb028$export$a78b00aedb6cb3e9 extends (0, $hrPaF.RestClient) {
    constructor(config = {}){
        super({
            ...$6f2e78061b0eb028$var$defaultConfig,
            ...config
        });
    }
    async getTeamLinkIcons(teamLinkUrls) {
        const requestBody = teamLinkUrls.map((url)=>({
                resourceUrl: url
            }));
        return this.postResourceRaw(`/object-resolver/resolve/batch`, JSON.stringify(requestBody)).then((0, $hjCdE.transformIconData));
    }
    async getAriFromUrl(url) {
        return this.postResourceRaw(`/object-resolver/converter/toAri`, JSON.stringify({
            resourceUrl: url
        })).then((response)=>response?.data?.ari);
    }
}
var $6f2e78061b0eb028$export$2e2bcd8739ae039 = new $6f2e78061b0eb028$export$a78b00aedb6cb3e9();

});
parcelRegister("hjCdE", function(module, exports) {

$parcel$export(module.exports, "transformIconData", () => $9290a635b7c41737$export$39f4468adf4cb57c);

var $FZDfl = parcelRequire("FZDfl");
const $9290a635b7c41737$export$c64ca1c808335e8b = (jsonLd)=>{
    const { url: url, generator: { name: name, icon: icon } } = jsonLd;
    switch(name){
        case (0, $FZDfl.ProviderNames).CONFLUENCE:
            return {
                linkUrl: url,
                iconUrl: $9290a635b7c41737$var$getConfluenceFavicon(url),
                productName: name
            };
        case (0, $FZDfl.ProviderNames).JIRA:
            return {
                linkUrl: url,
                iconUrl: $9290a635b7c41737$var$getJiraFavicon(url),
                productName: name
            };
        default:
            return {
                linkUrl: url,
                iconUrl: typeof icon === 'object' ? icon['url'] : icon,
                productName: name
            };
    }
};
const $9290a635b7c41737$var$isIconItemSuccess = (response)=>{
    return response.status === 200;
};
const $9290a635b7c41737$export$39f4468adf4cb57c = (batchResp)=>batchResp.filter($9290a635b7c41737$var$isIconItemSuccess).map((resp)=>resp.body.data).map($9290a635b7c41737$export$c64ca1c808335e8b).filter((linkIconData)=>linkIconData.iconUrl !== undefined);
const $9290a635b7c41737$var$getConfluenceFavicon = (url)=>`https://${new URL(url).hostname}/wiki/favicon.ico`;
const $9290a635b7c41737$var$getJiraFavicon = (url)=>`https://${new URL(url).hostname}/favicon.ico`;

});
parcelRegister("FZDfl", function(module, exports) {

$parcel$export(module.exports, "ProviderNames", () => $584160994f259bf9$export$132d457a8475f4c8);
/**
 * This type matches the props for the TeamLinkIcon component in embeddable-directory
 */ var $584160994f259bf9$export$132d457a8475f4c8 = /*#__PURE__*/ function(ProviderNames) {
    ProviderNames["CONFLUENCE"] = "Confluence";
    ProviderNames["JIRA"] = "Jira";
    return ProviderNames;
}({});

});



parcelRegister("1B4EX", function(module, exports) {

$parcel$export(module.exports, "default", () => $4da5dc8a7e4131fb$export$2e2bcd8739ae039);

var $aOgFy = parcelRequire("aOgFy");

var $hrPaF = parcelRequire("hrPaF");
class $4da5dc8a7e4131fb$export$23820d8d740dd467 extends (0, $hrPaF.RestClient) {
    getIsSiteAdmin(/**
		 * @private
		 * @deprecated don't need to pass param, value is taken from `this.getCloudId()` instead
		 */ cloudId) {
        return this.postResource('/permitted', {
            permissionId: 'manage',
            resourceId: `ari:cloud:platform::site/${this.getCloudId(cloudId)}`
        }).then((response)=>response.permitted);
    }
}
var /**
 * REST Client to make calls to resources on the activity service.
 *
 * @type {RestClient}
 */ // eslint-disable-next-line import/no-anonymous-default-export
$4da5dc8a7e4131fb$export$2e2bcd8739ae039 = new $4da5dc8a7e4131fb$export$23820d8d740dd467({
    serviceUrl: (0, $aOgFy.DEFAULT_CONFIG).permsServiceUrl
});

});

parcelRegister("7thbw", function(module, exports) {

$parcel$export(module.exports, "default", () => $cc096c4ff7130f7b$export$2e2bcd8739ae039);

var $1K4T6 = parcelRequire("1K4T6");

var $aOgFy = parcelRequire("aOgFy");

var $hrPaF = parcelRequire("hrPaF");
const $cc096c4ff7130f7b$var$V1_URL = '/teams/v1';
const $cc096c4ff7130f7b$var$SENTRY_IGNORED_ERROR_MESSAGES_CREATE = [
    'TEAM_NOT_FOUND'
];
class $cc096c4ff7130f7b$export$38575d07403d67c extends (0, $hrPaF.RestClient) {
    constructor(serviceUrlRoot){
        super({
            serviceUrl: serviceUrlRoot
        });
    }
    async addUsersToTeam(teamId, members) {
        if (!members || members.length === 0) {
            const missingMembersError = new Error('Missing members to add');
            this.logException(missingMembersError, 'addUsersToTeam');
            throw missingMembersError;
        }
        const membersWithIds = members.filter((member)=>!!member.accountId);
        if (membersWithIds.length !== members.length) this.logException(new Error('Missing accountIds for some members'), 'addUsersToTeam');
        if (membersWithIds.length === 0) {
            const missingMembersError = new Error('Missing accountIds for all members');
            this.logException(missingMembersError, 'addUsersToTeam');
            throw missingMembersError;
        }
        try {
            const orgId = this.getOrgId();
            const url = `${$cc096c4ff7130f7b$var$V1_URL}/org/${orgId}/teams/${teamId}/members/add`;
            const response = await this.postResource(url, {
                members: membersWithIds
            });
            return response;
        } catch (e) {
            this.logException(e, 'addUsersToTeam');
            if (e instanceof (0, $1K4T6.HttpError) && $cc096c4ff7130f7b$var$SENTRY_IGNORED_ERROR_MESSAGES_CREATE.includes(e.message)) throw new (0, $1K4T6.SLOIgnoreHttpError)(e);
            throw e;
        }
    }
    async removeTeamMemberships(teamId, members) {
        if (!members || members.length === 0) {
            const missingMembersError = new Error('Missing members to remove');
            this.logException(missingMembersError, 'removeTeamMemberships');
            throw missingMembersError;
        }
        const membersWithIds = members.filter((member)=>!!member.accountId);
        if (membersWithIds.length !== members.length) this.logException(new Error('Missing accountIds for some members'), 'addUsersToTeam');
        if (membersWithIds.length === 0) {
            const missingMembersError = new Error('Missing accountIds for all members');
            this.logException(missingMembersError, 'removeTeamMemberships');
            throw missingMembersError;
        }
        try {
            const orgId = this.getOrgId();
            const url = `${$cc096c4ff7130f7b$var$V1_URL}/org/${orgId}/teams/${teamId}/members/remove`;
            const response = await this.postResource(url, {
                members: membersWithIds
            });
            return response;
        } catch (e) {
            this.logException(e, 'removeTeamMemberships');
            throw e;
        }
    }
    async getTeamDetails(teamId) {
        try {
            const orgId = this.getOrgId();
            const url = `${$cc096c4ff7130f7b$var$V1_URL}/org/${orgId}/teams/${teamId}`;
            const response = await this.getResource(url);
            return response;
        } catch (e) {
            this.logException(e, 'getTeamDetails');
            throw e;
        }
    }
    async getTeamMembers(teamId, first = 50, after) {
        try {
            const orgId = this.getOrgId();
            const url = `${$cc096c4ff7130f7b$var$V1_URL}/org/${orgId}/teams/${teamId}/members`;
            const response = await this.postResource(url, {
                after: after,
                first: first
            });
            return response;
        } catch (e) {
            this.logException(e, 'getTeamMembers');
            throw e;
        }
    }
    async restoreTeam(teamId) {
        try {
            const orgId = this.getOrgId();
            const url = `${$cc096c4ff7130f7b$var$V1_URL}/org/${orgId}/teams/${teamId}/restore`;
            return this.postResource(url);
        } catch (e) {
            this.logException(e, 'restoreTeam');
            throw e;
        }
    }
}
var // eslint-disable-next-line import/no-anonymous-default-export
$cc096c4ff7130f7b$export$2e2bcd8739ae039 = new $cc096c4ff7130f7b$export$38575d07403d67c((0, $aOgFy.DEFAULT_CONFIG).publicApiRoot);

});

parcelRegister("60KbN", function(module, exports) {

$parcel$export(module.exports, "default", () => $3da0a8fba8b7733c$export$2e2bcd8739ae039);

var $aOgFy = parcelRequire("aOgFy");

var $hrPaF = parcelRequire("hrPaF");
const $3da0a8fba8b7733c$var$defaultConfig = {
    serviceUrl: `${(0, $aOgFy.DEFAULT_CONFIG).stargateRoot}/user-tenure/v1`
};
class $3da0a8fba8b7733c$export$e019a6241c871c27 extends (0, $hrPaF.RestClient) {
    constructor(config = {}){
        super({
            ...$3da0a8fba8b7733c$var$defaultConfig,
            ...config
        });
    }
    async getUserTenure(userId) {
        const orgId = this.getOrgId();
        return this.getResource(`/${orgId}/${userId}`).then((response)=>({
                ...response,
                userHireDate: new Date(response.userHireDate)
            })).catch((error)=>{
            throw new Error('Failed to fetch user tenure');
        });
    }
}
var $3da0a8fba8b7733c$export$2e2bcd8739ae039 = new $3da0a8fba8b7733c$export$e019a6241c871c27();

});

parcelRegister("doDlD", function(module, exports) {

$parcel$export(module.exports, "default", () => $7d5edd21520bfcf7$export$2e2bcd8739ae039);

var $aOgFy = parcelRequire("aOgFy");

var $cPPyF = parcelRequire("cPPyF");

var $6laLp = parcelRequire("6laLp");

var $5q4oc = parcelRequire("5q4oc");

var $7HzJi = parcelRequire("7HzJi");

var $6MiDV = parcelRequire("6MiDV");

var $9rfX5 = parcelRequire("9rfX5");

var $1KerR = parcelRequire("1KerR");

var $ey2Vf = parcelRequire("ey2Vf");

var $h8V8v = parcelRequire("h8V8v");

var $7sahj = parcelRequire("7sahj");

var $1jHJB = parcelRequire("1jHJB");
class $7d5edd21520bfcf7$export$de0359e19b851166 extends (0, $cPPyF.BaseGraphQlClient) {
    constructor(baseUrl, config){
        super((0, $1jHJB.getUnshardedTeamCentralGraphqlUrl)(baseUrl), config);
    }
    // Team central url is a bit special, that it depends on cloudId.
    setBaseUrl(baseUrl) {
        const cloudId = this.getCloudId();
        this.setServiceUrl(cloudId && cloudId !== 'None' ? (0, $1jHJB.getTeamCentralGraphqlUrl)(baseUrl, cloudId) : (0, $1jHJB.getUnshardedTeamCentralGraphqlUrl)(baseUrl));
    }
    async addTeamWatcher(teamId, cloudId) {
        const response = await this.makeGraphQLRequest({
            query: (0, $5q4oc.AddTeamWatcherMutation),
            variables: {
                teamId: teamId,
                cloudId: cloudId
            }
        }, {
            operationName: 'addTeamWatcher'
        });
        return response.addTeamWatcher;
    }
    async removeTeamWatcher(teamId, cloudId) {
        const response = await this.makeGraphQLRequest({
            query: (0, $h8V8v.RemoveTeamWatcherMutation),
            variables: {
                teamId: teamId,
                cloudId: cloudId
            }
        }, {
            operationName: 'removeTeamWatcher'
        });
        return response.removeTeamWatcher;
    }
    async deleteKudos(id) {
        const response = await this.makeGraphQLRequest({
            query: (0, $ey2Vf.KudosDeleteMutation),
            variables: {
                id: id
            }
        }, {
            operationName: 'DeleteKudos'
        });
        return response.deleteKudos;
    }
    async queryTagList(variables) {
        const response = await this.makeGraphQLRequest({
            query: (0, $7sahj.TagListQuery),
            variables: variables
        }, {
            operationName: 'TagListByCloudId'
        });
        return response.tagSearchByCloudId;
    }
    async createTag(variables) {
        const response = await this.makeGraphQLRequest({
            query: (0, $7HzJi.CreateTagMutation),
            variables: variables
        }, {
            operationName: 'createTagForCloudId'
        });
        return response.createTagForCloudId;
    }
    async createHelpPointer(variables) {
        const response = await this.makeGraphQLRequest({
            query: (0, $6MiDV.HelpPointerCreateMutation),
            variables: variables
        }, {
            operationName: 'CreateHelpPointer'
        });
        return response.createHelpPointer;
    }
    async updateHelpPointer(variables) {
        const response = await this.makeGraphQLRequest({
            query: (0, $1KerR.HelpPointerUpdateMutation),
            variables: variables
        }, {
            operationName: 'UpdateHelpPointer'
        });
        return response.updateHelpPointer;
    }
    async deleteHelpPointer(variables) {
        const response = await this.makeGraphQLRequest({
            query: (0, $9rfX5.HelpPointerDeleteMutation),
            variables: variables
        }, {
            operationName: 'DeleteHelpPointer'
        });
        return response.deleteHelpPointer;
    }
}
var $7d5edd21520bfcf7$export$2e2bcd8739ae039 = new $7d5edd21520bfcf7$export$de0359e19b851166((0, $aOgFy.DEFAULT_CONFIG).stargateRoot, {
    logException: $6laLp.logException
});

});
parcelRegister("5q4oc", function(module, exports) {

$parcel$export(module.exports, "AddTeamWatcherMutation", () => $7a30a844cfa52ad0$export$2af9f827ad8bcf83);

var $1c8Um = parcelRequire("1c8Um");

var $5cllN = parcelRequire("5cllN");
const $7a30a844cfa52ad0$export$2af9f827ad8bcf83 = (0, $1c8Um.print)((0, $5cllN.default)`
	mutation addTeamWatcher($teamId: String!, $cloudId: String) {
		addTeamWatcher(input: { teamId: $teamId, cloudId: $cloudId }) {
			isWatching
			__typename
		}
	}
`);

});

parcelRegister("7HzJi", function(module, exports) {

$parcel$export(module.exports, "CreateTagMutation", () => $794445a2ca2b8bda$export$5e59562b4f09e8ef);

var $1c8Um = parcelRequire("1c8Um");

var $5cllN = parcelRequire("5cllN");
const $794445a2ca2b8bda$export$5e59562b4f09e8ef = (0, $1c8Um.print)((0, $5cllN.default)`
	mutation createTagForCloudId($name: String!, $cloudId: String!) {
		createTagForCloudId(input: { name: $name, cloudId: $cloudId }) {
			tag {
				id
				uuid
				name
			}
		}
	}
`);

});

parcelRegister("6MiDV", function(module, exports) {

$parcel$export(module.exports, "HelpPointerCreateMutation", () => $b73f166b153fa007$export$a563da8c932d52b1);

var $1c8Um = parcelRequire("1c8Um");

var $5cllN = parcelRequire("5cllN");
const $b73f166b153fa007$export$a563da8c932d52b1 = (0, $1c8Um.print)((0, $5cllN.default)`
	mutation CreateHelpPointer(
		$cloudId: String!
		$description: String
		$icon: IconInput
		$tagUuids: [UUID]
		$link: String!
		$name: String!
		$teamId: String!
		$type: HelpPointerType!
	) {
		createHelpPointer(
			input: {
				cloudId: $cloudId
				description: $description
				icon: $icon
				tagUuids: $tagUuids
				link: $link
				name: $name
				teamId: $teamId
				type: $type
			}
		) {
			helpPointer {
				id
			}
		}
	}
`);

});

parcelRegister("9rfX5", function(module, exports) {

$parcel$export(module.exports, "HelpPointerDeleteMutation", () => $666c98623886084e$export$558c9434019572a1);

var $1c8Um = parcelRequire("1c8Um");

var $5cllN = parcelRequire("5cllN");
const $666c98623886084e$export$558c9434019572a1 = (0, $1c8Um.print)((0, $5cllN.default)`
	mutation DeleteHelpPointer($id: ID!) {
		deleteHelpPointer(input: { id: $id }) {
			success
		}
	}
`);

});

parcelRegister("1KerR", function(module, exports) {

$parcel$export(module.exports, "HelpPointerUpdateMutation", () => $32a0765e7f988b7b$export$95b572ae48a37250);

var $1c8Um = parcelRequire("1c8Um");

var $5cllN = parcelRequire("5cllN");
const $32a0765e7f988b7b$export$95b572ae48a37250 = (0, $1c8Um.print)((0, $5cllN.default)`
	mutation UpdateHelpPointer(
		$id: ID!
		$description: String
		$teamId: String
		$newTeamName: String
		$icon: IconInput
		$tagUuids: [UUID]
		$link: String
		$name: String
		$type: HelpPointerType
	) {
		updateHelpPointer(
			input: {
				id: $id
				description: $description
				icon: $icon
				tagUuids: $tagUuids
				link: $link
				teamId: $teamId
				newTeamName: $newTeamName
				name: $name
				type: $type
			}
		) {
			helpPointer {
				id
			}
		}
	}
`);

});

parcelRegister("ey2Vf", function(module, exports) {

$parcel$export(module.exports, "KudosDeleteMutation", () => $affb8baa13372318$export$fc4c702e715ad2a4);

var $1c8Um = parcelRequire("1c8Um");

var $5cllN = parcelRequire("5cllN");
const $affb8baa13372318$export$fc4c702e715ad2a4 = (0, $1c8Um.print)((0, $5cllN.default)`
	mutation DeleteKudos($id: ID!) {
		deleteKudos(input: { id: $id }) {
			success
			kudos {
				id
			}
		}
	}
`);

});

parcelRegister("h8V8v", function(module, exports) {

$parcel$export(module.exports, "RemoveTeamWatcherMutation", () => $d9ec6e4b42d9aba6$export$d1957676c49feb6a);

var $1c8Um = parcelRequire("1c8Um");

var $5cllN = parcelRequire("5cllN");
const $d9ec6e4b42d9aba6$export$d1957676c49feb6a = (0, $1c8Um.print)((0, $5cllN.default)`
	mutation removeTeamWatcher($teamId: String!, $cloudId: String) {
		removeTeamWatcher(input: { teamId: $teamId, cloudId: $cloudId }) {
			isWatching
			__typename
		}
	}
`);

});

parcelRegister("7sahj", function(module, exports) {

$parcel$export(module.exports, "TagListQuery", () => $9c83200124dcc1a5$export$2c592b5c06672873);

var $1c8Um = parcelRequire("1c8Um");

var $5cllN = parcelRequire("5cllN");
const $9c83200124dcc1a5$export$2c592b5c06672873 = (0, $1c8Um.print)((0, $5cllN.default)`
	query TagListByCloudId($q: String!, $cloudId: String!, $first: Int) {
		tagSearchByCloudId(q: $q, cloudId: $cloudId, first: $first) {
			edges {
				node {
					id
					uuid
					name
					projects {
						count
					}

					goals {
						count
					}

					helpLinks {
						count
					}
				}
			}
		}
	}
`);

});

parcelRegister("1jHJB", function(module, exports) {

$parcel$export(module.exports, "getTeamCentralGraphqlUrl", () => $b11c2e8c473887f3$export$ada1892306a6b676);
$parcel$export(module.exports, "getUnshardedTeamCentralGraphqlUrl", () => $b11c2e8c473887f3$export$71356c4826ea823a);
const $b11c2e8c473887f3$export$ada1892306a6b676 = (baseUrl, cloudId)=>`${baseUrl}/townsquare/s/${cloudId}/graphql`;
const $b11c2e8c473887f3$export$71356c4826ea823a = (baseUrl)=>`${baseUrl}/watermelon/graphql`;

});


parcelRegister("93qCC", function(module, exports) {

$parcel$export(module.exports, "default", () => $105914cb6e0318f1$export$2e2bcd8739ae039);

var $aOgFy = parcelRequire("aOgFy");

var $hrPaF = parcelRequire("hrPaF");
const $105914cb6e0318f1$var$defaultConfig = {
    serviceUrl: `${(0, $aOgFy.DEFAULT_CONFIG).stargateRoot}/teamsslack/api/team`
};
class $105914cb6e0318f1$export$9509cbc6b0605446 extends (0, $hrPaF.RestClient) {
    constructor(config = {}){
        super({
            ...$105914cb6e0318f1$var$defaultConfig,
            ...config
        });
    }
    async getTeamInSlack(teamId, teamName) {
        return this.getResource(`/${teamId}?teamName=${encodeURIComponent(teamName)}`).then((response)=>({
                id: teamId,
                ...response
            }));
    }
    async disconnectTeamInSlack(teamId) {
        return this.deleteResource(`/${teamId}`).then((response)=>({
                id: teamId,
                ...response
            }));
    }
    async updateTeamInSlack(teamId, channelId, usergroupHandle) {
        return this.postResource(`/${teamId}?channel=${channelId}&groupName=${usergroupHandle}`).then((response)=>({
                id: teamId,
                ...response
            }));
    }
}
var $105914cb6e0318f1$export$2e2bcd8739ae039 = new $105914cb6e0318f1$export$9509cbc6b0605446();

});

parcelRegister("9zuJU", function(module, exports) {

$parcel$export(module.exports, "default", () => $257161ecf26ea5c9$export$2e2bcd8739ae039);

var $aOgFy = parcelRequire("aOgFy");

var $hrPaF = parcelRequire("hrPaF");
const $257161ecf26ea5c9$var$buildGetReadTokenURL = (accountId)=>`/api/user-image/${accountId}/header-image/read`;
class $257161ecf26ea5c9$export$3c27e20d1b94924 extends (0, $hrPaF.RestClient) {
    async getReadMediaToken(accountId) {
        return this.getResource($257161ecf26ea5c9$var$buildGetReadTokenURL(accountId)).then((response)=>response);
    }
    async getWriteMediaToken() {
        return this.getResource('/api/user-image/header-image/write').then((response)=>response);
    }
    async updateUserHeaderImage(headerImageId) {
        return await this.putResource('/api/user-image/self/header-image', {
            headerImageId: headerImageId
        });
    }
}
var $257161ecf26ea5c9$export$2e2bcd8739ae039 = new $257161ecf26ea5c9$export$3c27e20d1b94924({
    serviceUrl: (0, $aOgFy.DEFAULT_CONFIG).stargateRoot
});

});


parcelRegister("ddoT6", function(module, exports) {

$parcel$export(module.exports, "transformPermissions", () => $e6270b31ac69c64a$export$7fe0bfa353103198);
const $e6270b31ac69c64a$export$7fe0bfa353103198 = (permissions)=>{
    return permissions.reduce((acc, permission)=>{
        switch(permission){
            case 'CAN_CREATE_TEAMS':
                return {
                    ...acc,
                    canCreateTeams: true
                };
            case 'CAN_VIEW_TEAMS':
                return {
                    ...acc,
                    canViewTeams: true
                };
            case 'CAN_ADMIN_TEAMS':
                return {
                    ...acc,
                    canAdminTeams: true
                };
            default:
                return acc;
        }
    }, {
        canCreateTeams: false,
        canViewTeams: false,
        canAdminTeams: false
    });
};

});



parcelRegister("5wXDQ", function(module, exports) {

$parcel$export(module.exports, "PeopleMenuOverrides", () => $0d7d2d743503c251$export$c6e6fe52d34907dc);
var $0d7d2d743503c251$export$c6e6fe52d34907dc = /*#__PURE__*/ function(PeopleMenuOverrides) {
    PeopleMenuOverrides["createTeamsDisabled"] = "create-teams-disabled";
    PeopleMenuOverrides["viewTeamsDisabled"] = "view-teams-disabled";
    return PeopleMenuOverrides;
}({});

});



parcelRegister("57aZp", function(module, exports) {

$parcel$export(module.exports, "People", () => $73ab25b84abebed5$export$8d3edc4d62e152ad);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $8Rkzz = parcelRequire("8Rkzz");

var $9dZ1c = parcelRequire("9dZ1c");

var $2bzBV = parcelRequire("2bzBV");

var $joX8T = parcelRequire("joX8T");

var $7CMCs = parcelRequire("7CMCs");

var $6s1PB = parcelRequire("6s1PB");

var $4R6GH = parcelRequire("4R6GH");

var $pa9q9 = parcelRequire("pa9q9");

var $1wpPp = parcelRequire("1wpPp");

var $4ywcn = parcelRequire("4ywcn");

var $8igKv = parcelRequire("8igKv");

var $d5puk = parcelRequire("d5puk");

var $lmyls = parcelRequire("lmyls");

var $2Ui4E = parcelRequire("2Ui4E");

var $1J3t1 = parcelRequire("1J3t1");


var $8GOso = parcelRequire("8GOso");

var $6jY6G = parcelRequire("6jY6G");

var $cYlk7 = parcelRequire("cYlk7");

var $14XJw = parcelRequire("14XJw");

var $at1Nr = parcelRequire("at1Nr");

var $69X1g = parcelRequire("69X1g");

var $heI7y = parcelRequire("heI7y");

var $cZpsT = parcelRequire("cZpsT");

var $9OXo1 = parcelRequire("9OXo1");

var $fSeA2 = parcelRequire("fSeA2");

var $lVJAU = parcelRequire("lVJAU");

var $Mp6qH = parcelRequire("Mp6qH");

var $4uXxK = parcelRequire("4uXxK");

var $fVbkk = parcelRequire("fVbkk");

var $j94qH = parcelRequire("j94qH");

var $gAtvZ = parcelRequire("gAtvZ");

var $kAJ4Y = parcelRequire("kAJ4Y");

var $iPj86 = parcelRequire("iPj86");

var $annPD = parcelRequire("annPD");

var $ikNzk = parcelRequire("ikNzk");
const $73ab25b84abebed5$var$isNthUserOnBoardingProjectRecommendationEnrolled = ()=>{
    const [config] = (0, $6s1PB.UNSAFE_noExposureExp)('jira_nth_user_onboarding_proj_recommendation');
    // default value can't be a string to avoid type checking error
    return config.get('isEnabled', undefined) !== undefined;
};
const $73ab25b84abebed5$var$PeopleMenuDropdown = ()=>{
    const [isMenuOpen, { off: closeMenu, on: openMenu }] = (0, $2Ui4E.useTopMenus)((0, $lmyls.MENU_ID).PEOPLE);
    const baseUrl = '';
    const { showFlag: showFlag } = (0, $pa9q9.useFlagsService)();
    const route = (0, $6jY6G.useCurrentRoute)();
    const { push: push } = (0, $lVJAU.useRouterActions)();
    const isHighlighted = (0, $kAJ4Y.useMenuHighlighted)((0, $lmyls.MENU_ID).PEOPLE);
    const triggerAnalytics = (0, $iPj86.useNavigationItemAnalytics)({
        navigationItemId: (0, $Mp6qH.NAVIGATION_ITEM_ID).PEOPLE
    });
    const [isEventFromSpotlightTour] = (0, $gAtvZ.useFromSpotlightTour)('spotlight');
    const checkUsersGroupPermission = (0, $annPD.useBrowseUsersGroupsPermissions)();
    const checkUsersGroupPermissionNext = (0, $annPD.useBrowseUsersGroupsPermissionsNext)(isMenuOpen);
    const isEnabledForTailoredOnboardingM2 = (0, $8GOso.useIsTailoredOnboardingM2ForQuickstartEnabled)();
    const addFlag = (0, $5uXOq.useCallback)(// @ts-expect-error - TS7031 - Binding element 'appearance' implicitly has an 'any' type.
    ({ appearance: appearance, ...flagProps })=>{
        if (appearance === 'success' || appearance === 'normal') showFlag((serviceProps)=>{
            const props = {
                messageId: 'atlassian-navigation.ui.people.menu-with-configuration.props.success-flag',
                messageType: 'transactional',
                ...flagProps,
                ...serviceProps
            };
            // @ts-expect-error Type error after Flag props have been fixed globally, to be fixed by owning team
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $4ywcn.default), props);
        });
        if (appearance === 'warning') showFlag((serviceProps)=>{
            const props = {
                messageId: 'atlassian-navigation.ui.people.menu-with-configuration.props.warning-flag',
                messageType: 'transactional',
                ...flagProps,
                ...serviceProps
            };
            // @ts-expect-error Type error after Flag props have been fixed globally, to be fixed by owning team
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $8igKv.default), props);
        });
        if (appearance === 'error') showFlag((serviceProps)=>{
            const props = {
                messageId: 'atlassian-navigation.ui.people.menu-with-configuration.props.error-flag',
                messageType: 'transactional',
                ...flagProps,
                ...serviceProps
            };
            // @ts-expect-error Type error after Flag props have been fixed globally, to be fixed by owning team
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $1wpPp.default), props);
        });
    }, [
        showFlag
    ]);
    // @ts-expect-error - TS7006 - Parameter 'url' implicitly has an 'any' type.
    const pushRoute = (0, $5uXOq.useCallback)((url)=>push(`${baseUrl}${url}`), [
        baseUrl,
        push
    ]);
    const peopleMenuWrapperRef = (0, $9dZ1c.useRegisterNudgeTarget)((0, $6784cbc7d62e5d7c$export$77bc79debbf5c069), true).ref;
    const { data: { user: user } } = (0, $cYlk7.useCurrentUser)();
    const teamCreateDialogProps = (0, $5uXOq.useMemo)(()=>{
        const dialogProps = {
            currentUser: {
                id: user.accountId || '',
                fullName: user.userFullname,
                // @ts-expect-error - TS2339 - Property 'emailAddress' does not exist on type 'DataBasic | (DataBasic & ResponseSuccess)'. | TS2339 - Property 'emailAddress' does not exist on type 'DataBasic | (DataBasic & ResponseSuccess)'.
                email: user.emailAddress !== undefined ? user.emailAddress : '',
                // @ts-expect-error - TS2339 - Property 'avatarUrls' does not exist on type 'DataBasic | (DataBasic & ResponseSuccess)'. | TS2339 - Property 'avatarUrls' does not exist on type 'DataBasic | (DataBasic & ResponseSuccess)'.
                avatarUrl: user?.avatarUrls ? user.avatarUrls['16x16'] : '',
                nickname: user?.userFullname
            },
            enableMembershipSettingsChoice: true
        };
        dialogProps.onClose = ()=>{
            if (peopleMenuWrapperRef?.current) requestAnimationFrame(()=>{
                peopleMenuWrapperRef?.current?.querySelector('button')?.focus();
            });
        };
        return dialogProps;
    // the peopleMenuWrapperRef doesn't change as the condition if FG is static
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        user
    ]);
    (0, $5uXOq.useEffect)(()=>{
        // close menu when transitioning to other pages.
        if (!(0, $4R6GH.fg)('dont-auto-close-people-menu')) closeMenu();
        // close menu on unmount
        return ()=>{
            if (!(0, $4R6GH.fg)('dont-auto-close-people-menu')) closeMenu();
        };
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        route
    ]);
    const { data: projectSidebarNavigationData } = (0, $1J3t1.useProjectSidebarNavigation)();
    const subProduct = (0, $d5puk.projectTypeToSubProduct)(projectSidebarNavigationData?.projectType);
    const { cloudId: cloudId, atlassianAccountId: atlassianAccountId, appEditions: { software: software } } = (0, $9OXo1.useTenantContext)();
    const { data: orgId } = (0, $14XJw.useOrgId)();
    const invitePeopleExperimentalFeatures = (0, $5uXOq.useMemo)(()=>({
            inviteThirdPartyTeams: (0, $joX8T.VARIATION),
            coreInvitesDriveMultiProductInvites: true
        }), []);
    // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
    let continueUrl = window.location.href;
    if ($73ab25b84abebed5$var$isNthUserOnBoardingProjectRecommendationEnrolled() && user?.accountId) {
        const url = new URL(continueUrl);
        url.searchParams.append('inviterId', user.accountId);
        continueUrl = url.toString();
    }
    const { openModal: openModal } = (0, $ikNzk.useInvitePeopleModal)({
        continueUrl: continueUrl,
        enableThirdParty: true,
        experimentalFeatures: invitePeopleExperimentalFeatures,
        displayInfiSpotlight: true,
        orgId: orgId,
        resourceAri: `ari:cloud:jira::site/${cloudId}`,
        showFlag: addFlag,
        source: 'peopleMenu',
        subProduct: subProduct,
        experimental_applicationEdition: software,
        navigation: {
            directoryContextEntryPoint: '/jira'
        }
    });
    const invitePeopleHandlers = (0, $5uXOq.useMemo)(()=>({
            handleClick: openModal
        }), [
        openModal
    ]);
    if (!atlassianAccountId) return null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7CMCs.JSErrorBoundary), {
        id: (0, $lmyls.MENU_ID).PEOPLE,
        packageName: (0, $Mp6qH.PACKAGE_NAME),
        fallback: "unmount",
        teamName: "navigation"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($73ab25b84abebed5$export$5d16118c15d58d20, {
        ref: peopleMenuWrapperRef,
        "data-testid": `menu-${(0, $Mp6qH.NAVIGATION_ITEM_ID).PEOPLE}-wrapper`
    }, (isEnabledForTailoredOnboardingM2 || (0, $4R6GH.fg)('jira-always-render-invite-nudge')) && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $at1Nr.InviteTeamNudgeAsync), null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $fSeA2.default), {
        shouldRenderToParent: true,
        product: "jira",
        cloudId: cloudId,
        userId: atlassianAccountId,
        isBrowseUsersEnabled: (0, $4R6GH.fg)('dont-auto-close-people-menu') ? checkUsersGroupPermissionNext : checkUsersGroupPermission,
        // allow PeopleMenu to do transitions to in-product People Directory
        pushRoute: pushRoute,
        isHighlighted: isHighlighted,
        // @ts-expect-error - TS2322 - Type '({ appearance, ...flagProps }: { [x: string]: any; appearance: any; }) => void' is not assignable to type '(flag: Flag) => void'.
        addFlag: addFlag,
        onClick: triggerAnalytics,
        // manage open state
        isOpen: isMenuOpen,
        onOpen: openMenu,
        onClose: isEventFromSpotlightTour ? (0, (/*@__PURE__*/$parcel$interopDefault($8Rkzz))) : closeMenu,
        customChevronIcon: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $fVbkk.ChevronRightIcon), null),
        enablePreFetchingByHovering: false,
        subProduct: subProduct,
        isSSR: false,
        orgId: orgId ?? undefined,
        teamCreateDialogProps: teamCreateDialogProps,
        invitePeopleHandlers: invitePeopleHandlers,
        isSectionList: true
    })));
};
const $73ab25b84abebed5$var$PeopleWithAuth = ()=>{
    const isAnonymous = (0, $cZpsT.useIsAnonymous)();
    const { isVisible: isVisible } = (0, $2bzBV.useOverflowStatus)();
    const [{ hasOpened: shouldShowNudge }] = (0, $heI7y.useHasOpened)();
    if (isAnonymous) return null;
    if (!false) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7CMCs.JSErrorBoundary), {
        id: "navigation.people-menu.with-nudgetooltip",
        packageName: (0, $Mp6qH.PACKAGE_NAME),
        fallback: "unmount",
        teamName: "navigation"
    }, shouldShowNudge ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $69X1g.NavigationPeopleNavItemWrapperNudgeAsync), {
        isInsideMenu: !isVisible
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $j94qH.FullHeightTextColorWrapper), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $ikNzk.InvitePeopleModalContextProvider), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($73ab25b84abebed5$var$PeopleMenuDropdown, null)))) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $j94qH.FullHeightTextColorWrapper), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $ikNzk.InvitePeopleModalContextProvider), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($73ab25b84abebed5$var$PeopleMenuDropdown, null))));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($73ab25b84abebed5$var$PeopleMenuDropdown, null);
};
const $73ab25b84abebed5$export$8d3edc4d62e152ad = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $4uXxK.TopLevelErrorBoundary), {
        id: (0, $lmyls.MENU_ID).PEOPLE
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($73ab25b84abebed5$var$PeopleWithAuth, null));
const $73ab25b84abebed5$export$5d16118c15d58d20 = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_1e0c1txw _4t3i1osq _16jlkb7n _shj5kb7n",
            __cmplp.className
        ])
    });
});

});
parcelRegister("9dZ1c", function(module, exports) {

$parcel$export(module.exports, "useNudgeController", () => $6a0467752d0c968a$export$9a533735412babca);
$parcel$export(module.exports, "useRegisterNudgeTarget", () => $6a0467752d0c968a$export$eb8a96124d659f2d);

var $5uXOq = parcelRequire("5uXOq");
/**
 * This class tracks nudge target HTML DOM elements by ID.
 * It also tracks subscribers to updates of these elements.
 *  See some of the history here https://hello.atlassian.net/wiki/spaces/~620663553/pages/2896059847/Shipit+57+-+Out+of+Tree+Nudges
 */ class $6a0467752d0c968a$var$NudgeController {
    static{
        /**
	 * Singleton instance of this class.
	 * Alternatively multiple instances would be created and passed through context.
	 */ this.instance = new $6a0467752d0c968a$var$NudgeController();
    }
    /**
	 * Register the HTML DOM node for an ID
	 */ registerNudgeTarget(id, ref) {
        this.nudgeTargetsMap.set(id, ref);
        this.notifySubscribers(id);
        // Return a cleanup function that will remove this ID from the map
        return ()=>{
            this.nudgeTargetsMap.delete(id);
        };
    }
    /**
	 * Subscribe to updates to a certain DOM node
	 */ subscribe(id, callback) {
        const subscribers = this.subscribers.get(id) ?? [];
        subscribers.push(callback);
        this.subscribers.set(id, subscribers);
        // Return a cleanup function that will remove this callback from the list of subscribers
        return ()=>{
            const subscribersOnCleanup = this.subscribers.get(id) ?? [];
            this.subscribers.set(id, subscribersOnCleanup.filter((cb)=>cb !== callback));
        };
    }
    /**
	 * Notify subscribers that the HTML DOM node for an ID has been updated.
	 */ notifySubscribers(id) {
        const subscribers = this.subscribers.get(id) ?? [];
        subscribers.forEach((subscriber)=>{
            subscriber();
        });
    }
    constructor(){
        this.nudgeTargetsMap = new Map();
        this.subscribers = new Map();
    }
}
const $6a0467752d0c968a$export$9a533735412babca = ()=>$6a0467752d0c968a$var$NudgeController.instance;
const $6a0467752d0c968a$export$eb8a96124d659f2d = (id, shouldRegister = true)=>{
    const controller = $6a0467752d0c968a$export$9a533735412babca();
    const ref = (0, $5uXOq.useRef)(null);
    (0, $5uXOq.useLayoutEffect)(()=>{
        if (shouldRegister) {
            const unregister = controller.registerNudgeTarget(id, ref);
            return ()=>{
                unregister();
            };
        }
    }, [
        controller,
        id,
        shouldRegister
    ]);
    return {
        ref: ref
    };
};

});

parcelRegister("joX8T", function(module, exports) {

$parcel$export(module.exports, "NOT_ENROLLED", () => $a85d1363752adaec$export$5b7423264d48ab04);
$parcel$export(module.exports, "VARIATION", () => $a85d1363752adaec$export$fa04ad826acc90da);

var $co1wz = parcelRequire("co1wz");
const $a85d1363752adaec$export$3d370c33621572df = 'cohort';
const $a85d1363752adaec$export$5b7423264d48ab04 = 'not-enrolled';
const $a85d1363752adaec$export$43f367b3e957f219 = 'control';
const $a85d1363752adaec$export$9ba2bc3b1bdc1519 = 'experiment';
const $a85d1363752adaec$export$fa04ad826acc90da = 'variation';
const $a85d1363752adaec$export$6486974e39493fa6 = 'variation-1';
const $a85d1363752adaec$export$7d994996134ad562 = 'variation-2';
const $a85d1363752adaec$export$795e7d69b248dcd0 = 'variation-3';
const $a85d1363752adaec$export$c9c947c57470b787 = 'variation-4';
const $a85d1363752adaec$var$DEFAULT_VALID_EXPERIMENT_GROUPS = [
    $a85d1363752adaec$export$5b7423264d48ab04,
    $a85d1363752adaec$export$43f367b3e957f219,
    $a85d1363752adaec$export$9ba2bc3b1bdc1519,
    $a85d1363752adaec$export$fa04ad826acc90da,
    $a85d1363752adaec$export$6486974e39493fa6,
    $a85d1363752adaec$export$7d994996134ad562,
    $a85d1363752adaec$export$795e7d69b248dcd0,
    $a85d1363752adaec$export$c9c947c57470b787
];
var // Use optionalValidExperimentGroups to further restrict the list of cohorts
// eslint-disable-next-line jira/import/no-anonymous-default-export
$a85d1363752adaec$export$2e2bcd8739ae039 = (experimentFeatureFlag, validExperimentGroups = $a85d1363752adaec$var$DEFAULT_VALID_EXPERIMENT_GROUPS)=>(0, $co1wz.getMultivariateFeatureFlag)(experimentFeatureFlag, $a85d1363752adaec$export$5b7423264d48ab04, validExperimentGroups);

});

parcelRegister("1wpPp", function(module, exports) {

$parcel$export(module.exports, "default", () => $2ebed3b5115fbfc5$export$2e2bcd8739ae039);

var $3KRpp = parcelRequire("3KRpp");
var // eslint-disable-next-line @atlassian/eng-health/no-barrel-files/disallow-reexports
$2ebed3b5115fbfc5$export$2e2bcd8739ae039 = (0, $3KRpp.ErrorFlag);

});

parcelRegister("4ywcn", function(module, exports) {

$parcel$export(module.exports, "default", () => $1a612b92e24f3853$export$2e2bcd8739ae039);

var $3KRpp = parcelRequire("3KRpp");
var // eslint-disable-next-line @atlassian/eng-health/no-barrel-files/disallow-reexports
$1a612b92e24f3853$export$2e2bcd8739ae039 = (0, $3KRpp.SuccessFlag);

});

parcelRegister("8igKv", function(module, exports) {

$parcel$export(module.exports, "default", () => $87b804070d792a00$export$2e2bcd8739ae039);

var $3KRpp = parcelRequire("3KRpp");
var // eslint-disable-next-line @atlassian/eng-health/no-barrel-files/disallow-reexports
$87b804070d792a00$export$2e2bcd8739ae039 = (0, $3KRpp.WarningFlag);

});

parcelRegister("d5puk", function(module, exports) {

$parcel$export(module.exports, "stripUrlToIssueKey", () => $d13f96e7bcb31522$export$1f3c6284caef177b);
$parcel$export(module.exports, "useInvitePeopleFlags", () => $d13f96e7bcb31522$export$ab5fb7206b83c9ad);
$parcel$export(module.exports, "projectTypeToSubProduct", () => $d13f96e7bcb31522$export$3500077858760067);
$parcel$export(module.exports, "jiraProjectTypeToSubProduct", () => $d13f96e7bcb31522$export$9ce9c3ad0c2c5c71);

var $5uXOq = parcelRequire("5uXOq");

var $pa9q9 = parcelRequire("pa9q9");

var $1wpPp = parcelRequire("1wpPp");

var $g9eN3 = parcelRequire("g9eN3");

var $4ywcn = parcelRequire("4ywcn");

var $8igKv = parcelRequire("8igKv");
const $d13f96e7bcb31522$var$ISSUE_KEY_REGEXP = /(([A-Z][A-Z0-9]+)-([0-9]+))($|\?.*)/;
const $d13f96e7bcb31522$export$1f3c6284caef177b = (candidateUrl)=>{
    const match = candidateUrl.match($d13f96e7bcb31522$var$ISSUE_KEY_REGEXP);
    return match && match[1];
};
const $d13f96e7bcb31522$export$ab5fb7206b83c9ad = ()=>{
    const { showFlag: showFlag } = (0, $pa9q9.useFlagsService)();
    const addFlag = (0, $5uXOq.useCallback)(// @ts-expect-error - TS7031 - Binding element 'appearance' implicitly has an 'any' type.
    ({ appearance: appearance, ...flagProps })=>{
        let FlagComponent = (0, $g9eN3.default);
        // eslint-disable-next-line default-case
        switch(appearance){
            case 'success':
            case 'normal':
                FlagComponent = (0, $4ywcn.default);
                break;
            case 'warning':
                FlagComponent = (0, $8igKv.default);
                break;
            case 'error':
                FlagComponent = (0, $1wpPp.default);
                break;
        }
        showFlag((serviceProps)=>{
            const props = {
                ...flagProps,
                ...serviceProps,
                messageId: `invite-people-drawer.ui.content.flag-component.${appearance}.${flagProps.id}`,
                messageType: 'transactional'
            };
            // @ts-expect-error Type error after Flag props have been fixed globally, to be fixed by owning team
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(FlagComponent, props);
        });
    }, [
        showFlag
    ]);
    return {
        addFlag: addFlag
    };
};
const $d13f96e7bcb31522$export$3500077858760067 = (projectType)=>{
    switch(projectType){
        case 'jira_software':
            return 'software';
        case 'jira_service_management':
            return 'servicedesk';
        case 'jira_work_management':
            return 'core';
        case 'jira_product_discovery':
            return 'product-discovery';
        default:
            return undefined;
    }
};
const $d13f96e7bcb31522$export$9ce9c3ad0c2c5c71 = (projectType)=>{
    switch(projectType){
        case 'software':
            return 'software';
        case 'service_desk':
            return 'servicedesk';
        case 'business':
            return 'core';
        case 'product_discovery':
            return 'product-discovery';
        default:
            return undefined;
    }
};

});
parcelRegister("g9eN3", function(module, exports) {

$parcel$export(module.exports, "default", () => $100aabc6f0d895d9$export$2e2bcd8739ae039);

var $3KRpp = parcelRequire("3KRpp");
var // eslint-disable-next-line @atlassian/eng-health/no-barrel-files/disallow-reexports
$100aabc6f0d895d9$export$2e2bcd8739ae039 = (0, $3KRpp.InfoFlag);

});


parcelRegister("8GOso", function(module, exports) {

$parcel$export(module.exports, "usePersonalisationActions", () => $adde9919a40069db$export$5b1d43353c334c00);
$parcel$export(module.exports, "useCommonEligibilityConditionsForJtbdOnboarding", () => $adde9919a40069db$export$c89644b13b6e777f);
$parcel$export(module.exports, "useCommonEligibilityConditionsForTOM2P5", () => $adde9919a40069db$export$b633031bd0a88786);
$parcel$export(module.exports, "useTailoredOnboardingPersonalisationAttributes", () => $adde9919a40069db$export$9aad8798ea46e07f);
$parcel$export(module.exports, "useTailoredOnboardingPersonalisationM2", () => $adde9919a40069db$export$5875295cb096b1f2);
$parcel$export(module.exports, "useIsTailoredOnboardingM2ForQuickstartEnabled", () => $adde9919a40069db$export$6bc15f8ade1cf36);

var $5uXOq = parcelRequire("5uXOq");

var $2vSU6 = parcelRequire("2vSU6");

var $jcw0u = parcelRequire("jcw0u");

var $4R6GH = parcelRequire("4R6GH");

var $cNd4s = parcelRequire("cNd4s");

var $3sQ5x = parcelRequire("3sQ5x");
var $iXqE5 = parcelRequire("iXqE5");

var $dAfqg = parcelRequire("dAfqg");

var $AK64q = parcelRequire("AK64q");

var $8UmI9 = parcelRequire("8UmI9");

var $4mXzi = parcelRequire("4mXzi");

var $iAFnF = parcelRequire("iAFnF");
const $adde9919a40069db$var$store = (0, $iXqE5.createStore)({
    name: 'jira-onboarding-personalisation',
    initialState: (0, $AK64q.initialCachedEndpointState),
    actions: $4mXzi.actions
});
const $adde9919a40069db$export$5b1d43353c334c00 = (0, $3sQ5x.createActionsHook)($adde9919a40069db$var$store);
const $adde9919a40069db$export$31a443426d101362 = (0, $3sQ5x.createHook)($adde9919a40069db$var$store);
const $adde9919a40069db$export$c89644b13b6e777f = ()=>{
    const isSiteAdmin = (0, $cNd4s.useIsSiteAdmin)();
    const { data: projectContextData } = (0, $dAfqg.useProjectContext)();
    const isBusinessProject = projectContextData?.projectType === undefined || // letting undefined pass for non-project context usage, eg: onboarding
    projectContextData?.projectType === (0, $2vSU6.CORE_PROJECT); // limiting only to CORE for Tailired Onboarding M2 usage
    return isBusinessProject && isSiteAdmin;
};
const $adde9919a40069db$export$b633031bd0a88786 = ()=>{
    const isSiteAdmin = (0, $cNd4s.useIsSiteAdmin)();
    const { isBusinessProject: isBusinessProject } = (0, $8UmI9.useIsBusinessProject)();
    return isBusinessProject && isSiteAdmin && (0, $4R6GH.fg)('tailored_onboarding_m2p5_gate');
};
const $adde9919a40069db$export$6f87e1662a24f8b9 = ({ isEligible: isEligible, experienceTypes: experienceTypes, additionalParameters: additionalParameters })=>{
    const [{ fetchedOnce: fetchedOnce, isFetching: isFetching, data: data }, { fetchOnboardingPersonalisation: fetchOnboardingPersonalisation }] = $adde9919a40069db$export$31a443426d101362();
    (0, $5uXOq.useEffect)(()=>{
        if (isEligible && !fetchedOnce && !isFetching && data === undefined) fetchOnboardingPersonalisation({
            experienceTypes: experienceTypes,
            additionalParameters: additionalParameters
        });
    }, [
        additionalParameters,
        data,
        experienceTypes,
        fetchOnboardingPersonalisation,
        fetchedOnce,
        isEligible,
        isFetching
    ]);
    if (!isEligible) // If not eligible, no fetching is done. Data is ready to be read
    return {
        data: undefined,
        isReady: true
    };
    return {
        data: data,
        isReady: fetchedOnce && !isFetching
    };
};
const $adde9919a40069db$export$9aad8798ea46e07f = ()=>{
    const isEligibleForTailoredOnboardingM2 = $adde9919a40069db$export$c89644b13b6e777f();
    const { data: personalisationData, isReady: personalisationDataIsReady } = $adde9919a40069db$export$6f87e1662a24f8b9({
        isEligible: isEligibleForTailoredOnboardingM2
    });
    return {
        personalisationDataIsReady: personalisationDataIsReady,
        teamType: personalisationData?.matched.variants.find((variant)=>variant.startsWith('teamType.'))?.replace('teamType.', ''),
        jtbd: personalisationData?.matched.variants.filter((variant)=>variant.startsWith('jtbd.option_')).map((option)=>option.replace('jtbd.option_', '')).join(',')
    };
};
const $adde9919a40069db$export$5875295cb096b1f2 = ({ isEligible: isEligible, additionalParameters: additionalParameters })=>{
    const hasSentErrorOnce = (0, $5uXOq.useRef)(false);
    const { data: data, isReady: isReady } = $adde9919a40069db$export$6f87e1662a24f8b9({
        isEligible: isEligible,
        experienceTypes: [
            'QUICKSTART',
            'TEMPLATE',
            'LANDING_PAGE'
        ],
        additionalParameters: additionalParameters
    });
    try {
        const conditionalProjectType = `projectType.${additionalParameters?.projectType}`;
        // If projectType is not given as parameter, ignore restriction to match on projectType
        const isMatchingProjectType = Boolean(!additionalParameters?.projectType || data?.matched.variants.some((variant)=>variant === conditionalProjectType));
        const isMatchingTeamType = Boolean(data?.matched.variants.some((variant)=>variant.startsWith('teamType.') && (0, $iAFnF.ELIGIBLE_TEAM_TYPES_M2_FULL_NOTATION).includes(// eslint-disable-next-line @typescript-eslint/consistent-type-assertions
            variant.split('.')[1])));
        const isMatchingJtbd = Boolean(data?.matched.variants.some((variant)=>variant.startsWith('jtbd')));
        const matched = Boolean(data && isMatchingJtbd && isMatchingProjectType && isMatchingTeamType);
        return {
            isReady: isReady,
            data: {
                matched: matched,
                matchedVariants: {
                    projectType: isMatchingProjectType,
                    tt: isMatchingTeamType,
                    jtbd: isMatchingJtbd
                },
                QUICKSTART: matched && data ? data.experience.QUICKSTART : [],
                TEMPLATE: matched && data ? data.experience.TEMPLATE?.[0] : undefined,
                LANDING_PAGE: matched && data ? data.experience.LANDING_PAGE?.[0] : undefined
            }
        };
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    } catch (error) {
        if (!hasSentErrorOnce.current) {
            (0, $jcw0u.default)({
                error: error,
                meta: {
                    id: 'useTailoredOnboardingPersonalisationM2',
                    packageName: 'jiraOnboardingCore',
                    teamName: 'jlove-makkuro'
                },
                sendToPrivacyUnsafeSplunk: true
            });
            hasSentErrorOnce.current = true;
        }
    }
    return {
        isReady: isReady,
        data: {
            matched: false,
            matchedVariants: {
                jtbd: false,
                tt: false,
                projectType: false
            },
            QUICKSTART: [],
            TEMPLATE: undefined,
            LANDING_PAGE: undefined
        }
    };
};
const $adde9919a40069db$export$6bc15f8ade1cf36 = ()=>{
    const isEligibleForJtbdOnboarding = $adde9919a40069db$export$c89644b13b6e777f();
    const { data: projectContextData } = (0, $dAfqg.useProjectContext)();
    const projectType = (0, $4R6GH.fg)('tailored_onboarding_m3_gate') ? projectContextData?.projectType : (0, $2vSU6.CORE_PROJECT);
    const { isReady: personalisationDataIsReady, data: personalisationData } = $adde9919a40069db$export$5875295cb096b1f2({
        isEligible: isEligibleForJtbdOnboarding,
        additionalParameters: {
            projectType: projectType
        }
    });
    return Boolean(personalisationDataIsReady && personalisationData.QUICKSTART && personalisationData.QUICKSTART?.length > 0);
};

});
parcelRegister("8UmI9", function(module, exports) {

$parcel$export(module.exports, "useIsBusinessProject", () => $d1bed05bd9fbc7d5$export$f1bf366948a19b0f);

var $dAfqg = parcelRequire("dAfqg");

var $2vSU6 = parcelRequire("2vSU6");
const $d1bed05bd9fbc7d5$export$f1bf366948a19b0f = ()=>{
    const { data: data, loading: loading } = (0, $dAfqg.useProjectContext)();
    const isBusinessProject = data?.projectType === (0, $2vSU6.CORE_PROJECT);
    return {
        isBusinessProject: isBusinessProject,
        loading: loading
    };
};

});

parcelRegister("4mXzi", function(module, exports) {

$parcel$export(module.exports, "actions", () => $f50a5e3bb7b9f239$export$e324594224ef24da);
// eslint-disable-next-line jira/restricted/@atlassian/react-sweet-state

var $7bRcT = parcelRequire("7bRcT");

var $FroD7 = parcelRequire("FroD7");
const $f50a5e3bb7b9f239$var$fetchOnboardingPersonalisation = (0, $7bRcT.cachedEndpointCall)((args)=>(0, $FroD7.fetchOnboardingPersonalisationWithRethrow)(args));
const $f50a5e3bb7b9f239$var$trackPersonalisationAction = ({ additionalParameters: additionalParameters })=>()=>(0, $FroD7.trackPersonalisation)({
            additionalParameters: additionalParameters
        });
const $f50a5e3bb7b9f239$export$e324594224ef24da = {
    fetchOnboardingPersonalisation: $f50a5e3bb7b9f239$var$fetchOnboardingPersonalisation,
    trackPersonalisation: $f50a5e3bb7b9f239$var$trackPersonalisationAction
};

});
parcelRegister("FroD7", function(module, exports) {

$parcel$export(module.exports, "fetchOnboardingPersonalisationWithRethrow", () => $501ec097caecd266$export$6bc39428b6510a7c);
$parcel$export(module.exports, "trackPersonalisation", () => $501ec097caecd266$export$9835c32b78102887);

var $jcw0u = parcelRequire("jcw0u");

var $eusud = parcelRequire("eusud");

var $fv5ut = parcelRequire("fv5ut");
const $501ec097caecd266$var$PERSONALISATION_ENDPOINT = '/rest/personalisation/v1/experience';
const $501ec097caecd266$var$TRACK_PERSONALISATION_ENDPOINT = '/rest/personalisation/v1/track';
const $501ec097caecd266$var$responseHasAllRequestedExperienceTypes = ({ response: response, requestedExperienceTypes: requestedExperienceTypes })=>requestedExperienceTypes.every((requestedExperienceType)=>response.experience[requestedExperienceType]);
const $501ec097caecd266$export$6bc39428b6510a7c = async ({ experienceTypes: experienceTypes = [
    'QUICKSTART',
    'TEMPLATE',
    'LANDING_PAGE'
], additionalParameters: additionalParameters })=>{
    try {
        const localStorageOnboardingPersonalisationResponse = (0, $fv5ut.getLocalStorageOnboardingPersonalisationResponse)();
        if (localStorageOnboardingPersonalisationResponse && $501ec097caecd266$var$responseHasAllRequestedExperienceTypes({
            response: localStorageOnboardingPersonalisationResponse,
            requestedExperienceTypes: experienceTypes
        })) return localStorageOnboardingPersonalisationResponse;
        const response = await (0, $eusud.performPostRequestWithRetry)($501ec097caecd266$var$PERSONALISATION_ENDPOINT, {
            body: JSON.stringify({
                experienceTypes: experienceTypes,
                additionalParameters: additionalParameters
            })
        });
        if (response) {
            const mergedResponse = {
                experience: {
                    ...localStorageOnboardingPersonalisationResponse?.experience,
                    ...response.experience
                },
                matched: response.matched
            };
            (0, $fv5ut.setLocalStorageOnboardingPersonalisationResponse)(mergedResponse);
            return mergedResponse;
        }
        throw new Error('response from OnboardingPersonalisation is falsy');
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    } catch (error) {
        (0, $jcw0u.default)({
            error: error,
            meta: {
                id: 'fetchOnboardingPersonalisationWithRethrow',
                packageName: 'jiraOnboardingCore',
                teamName: 'jlove-makkuro'
            },
            sendToPrivacyUnsafeSplunk: true
        });
        throw error;
    }
};
const $501ec097caecd266$export$9835c32b78102887 = ({ additionalParameters: additionalParameters })=>{
    try {
        (0, $eusud.performPostRequestWithRetry)($501ec097caecd266$var$TRACK_PERSONALISATION_ENDPOINT, {
            body: JSON.stringify({
                additionalParameters: additionalParameters
            })
        });
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    } catch (error) {
        (0, $jcw0u.default)({
            error: error,
            meta: {
                id: 'trackOnboardingPersonalisation',
                packageName: 'jiraOnboardingCore',
                teamName: 'jlove-makkuro'
            },
            sendToPrivacyUnsafeSplunk: true
        });
    }
};

});
parcelRegister("fv5ut", function(module, exports) {

$parcel$export(module.exports, "getLocalStorageOnboardingPersonalisationResponse", () => $673c953eac85fdf0$export$e9fb5b94c03fa495);
$parcel$export(module.exports, "setLocalStorageOnboardingPersonalisationResponse", () => $673c953eac85fdf0$export$dda9cd59669fc243);

var $bSSG7 = parcelRequire("bSSG7");

var $jcw0u = parcelRequire("jcw0u");
const $673c953eac85fdf0$var$LOCALSTORAGE_ONBOARDING_PERSONALISATION_RESPONSE = 'response';
const $673c953eac85fdf0$var$localStorage = (0, $bSSG7.createLocalStorageProvider)('jira-onboarding-personalisation');
const $673c953eac85fdf0$export$e9fb5b94c03fa495 = ()=>{
    try {
        return $673c953eac85fdf0$var$localStorage.get($673c953eac85fdf0$var$LOCALSTORAGE_ONBOARDING_PERSONALISATION_RESPONSE);
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    } catch (error) {
        (0, $jcw0u.default)({
            error: error,
            meta: {
                id: 'localStorageGetOnboardingPersonalisation',
                packageName: 'jiraOnboardingCore',
                teamName: 'jlove-makkuro'
            },
            sendToPrivacyUnsafeSplunk: true
        });
        return undefined;
    }
};
const $673c953eac85fdf0$export$dda9cd59669fc243 = (response)=>{
    try {
        $673c953eac85fdf0$var$localStorage.set($673c953eac85fdf0$var$LOCALSTORAGE_ONBOARDING_PERSONALISATION_RESPONSE, response);
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    } catch (error) {
        (0, $jcw0u.default)({
            error: error,
            meta: {
                id: 'localStorageSetOnboardingPersonalisationResponse',
                packageName: 'jiraOnboardingCore',
                teamName: 'jlove-makkuro'
            },
            sendToPrivacyUnsafeSplunk: true
        });
    }
};

});



parcelRegister("iAFnF", function(module, exports) {

$parcel$export(module.exports, "ELIGIBLE_TEAM_TYPES_M2_FULL_NOTATION", () => $afa1ef0e1c3d15e2$export$1d38dc41bb005254);

var $5PxqD = parcelRequire("5PxqD");
const $afa1ef0e1c3d15e2$export$1d38dc41bb005254 = [
    (0, $5PxqD.USER_SEGMENTATION_TEAM_TYPE_MARKETING),
    (0, $5PxqD.USER_SEGMENTATION_TEAM_TYPE_OPERATIONS)
];

});
parcelRegister("5PxqD", function(module, exports) {

$parcel$export(module.exports, "USER_SEGMENTATION_TEAM_TYPE_MARKETING", () => $5d0851fa8905d151$export$e4824f74b9879164);
$parcel$export(module.exports, "USER_SEGMENTATION_TEAM_TYPE_OPERATIONS", () => $5d0851fa8905d151$export$4f3cb0844009af52);
$parcel$export(module.exports, "userBelongsToBusinessUserSegCategory", () => $5d0851fa8905d151$export$517f94ab07724226);

var $jcw0u = parcelRequire("jcw0u");
// Roles defined in user segmentation
const $5d0851fa8905d151$var$USER_SEGMENTATION_ROLE_DESIGNER = 'designer';
const $5d0851fa8905d151$export$572242e58bd07594 = 'customer-service';
const $5d0851fa8905d151$export$d7de553940261eba = 'it-support';
const $5d0851fa8905d151$export$4c29d0d04c15e55d = 'human-resources';
const $5d0851fa8905d151$export$3950f7f841bf94b6 = 'finance';
const $5d0851fa8905d151$export$881249b988b6030f = 'legal';
const $5d0851fa8905d151$export$e4824f74b9879164 = 'marketing';
const $5d0851fa8905d151$export$4f3cb0844009af52 = 'operations';
const $5d0851fa8905d151$export$1a65d50c4a641bb4 = 'sales';
const $5d0851fa8905d151$export$b8b1ac856ba1434b = 'software-development';
// Unique identifier used where all roles in a team type are eligible
const $5d0851fa8905d151$var$ALL_ROLES_ELIGIBLE = 'all-roles-eligible';
const $5d0851fa8905d151$export$2f3f9640393bd078 = 'unknown';
const $5d0851fa8905d151$export$4c9a72dac5ce80ae = '';
// @ts-expect-error - It seems to be missing some translations (for all-roles-eligible).
const $5d0851fa8905d151$var$USER_SEGMENTATION_CLIENT_MAPPING = {
    [$5d0851fa8905d151$var$USER_SEGMENTATION_ROLE_DESIGNER]: [
        'Designer',
        'Disainer',
        "Dise\xf1ador",
        'Formgivare',
        "Nh\xe0 thi\u1EBFt k\u1EBF",
        'Projektant',
        'Suunnittelija',
        "Tasar\u0131mc\u0131",
        "Tervez\u0151",
        "\u0414\u0438\u0437\u0430\u0439\u043D\u0435\u0440",
        "\u0E19\u0E31\u0E01\u0E2D\u0E2D\u0E01\u0E41\u0E1A\u0E1A",
        "\u30C7\u30B6\u30A4\u30CA\u30FC",
        "\u8A2D\u8A08\u5E2B",
        "\u8BBE\u8BA1\u5E08",
        "\uB514\uC790\uC774\uB108"
    ],
    [$5d0851fa8905d151$export$572242e58bd07594]: [
        'Asiakaspalvelu',
        'Atendimento ao cliente',
        'Customer Service',
        "D\u1ECBch v\u1EE5 kh\xe1ch h\xe0ng",
        'Klantenservice',
        'Klienditeenindus',
        'Kundenservice',
        'Kundeservice',
        'Kundservice',
        "M\xfc\u015Fteri Hizmetleri",
        "Obs\u0142uga klienta",
        "Service \xe0 la client\xe8le",
        "Servicio de atenci\xf3n al cliente",
        'Servizio clienti',
        "Servi\xe7o de apoio ao cliente",
        "Z\xe1kaznick\xfd servis",
        "Z\xe1kazn\xedcky servis",
        "\xdcgyf\xe9lszolg\xe1lati",
        "\u041E\u0431\u0441\u043B\u0443\u0436\u0438\u0432\u0430\u043D\u0438\u0435 \u043A\u043B\u0438\u0435\u043D\u0442\u043E\u0432",
        "\u0421\u043B\u0443\u0436\u0431\u0430 \u043F\u0456\u0434\u0442\u0440\u0438\u043C\u043A\u0438 \u043A\u043B\u0456\u0454\u043D\u0442\u0456\u0432",
        "\u0E1A\u0E23\u0E34\u0E01\u0E32\u0E23\u0E25\u0E39\u0E01\u0E04\u0E49\u0E32",
        "\u30AB\u30B9\u30BF\u30DE\u30FC \u30B5\u30FC\u30D3\u30B9",
        "\u5BA2\u6237\u670D\u52A1",
        "\u9867\u5BA2\u670D\u52D9",
        "\uACE0\uAC1D \uC11C\uBE44\uC2A4"
    ],
    [$5d0851fa8905d151$export$d7de553940261eba]: [
        'Assistenza IT',
        "BT Deste\u011Fi",
        "H\u1ED7 tr\u1EE3 CNTT",
        'IT',
        'IT Support',
        'IT podpora',
        "IT \u30B5\u30DD\u30FC\u30C8",
        "IT \u652F\u6301",
        "IT \u652F\u63F4",
        "IT \uC9C0\uC6D0",
        'IT_Support',
        "IT_st\xf8tte",
        'IT_support',
        'IT_tugi',
        'IT_tuki',
        "Informatikai t\xe1mogat\xe1si",
        'Soporte de TI',
        'Suporte de TI',
        "Support\xa0IT",
        'Wsparcie IT',
        "\u0418\u0422-\u043F\u043E\u0434\u0434\u0435\u0440\u0436\u043A\u0430",
        "\u0421\u043B\u0443\u0436\u0431\u0430 \u0442\u0435\u0445\u043D\u0456\u0447\u043D\u043E\u0457 \u043F\u0456\u0434\u0442\u0440\u0438\u043C\u043A\u0438",
        "\u0E1D\u0E48\u0E32\u0E22\u0E2A\u0E19\u0E31\u0E1A\u0E2A\u0E19\u0E38\u0E19 IT"
    ],
    [$5d0851fa8905d151$export$3950f7f841bf94b6]: [
        'Ekonomi',
        'Finance',
        'Financeiro',
        'Financie',
        'Finans',
        'Finanse',
        'Finants',
        'Finanza',
        'Finanzas',
        'Finanzen',
        "Finan\xe7as",
        "P\xe9nz\xfcgyi",
        'Rahoitus',
        "T\xe0i ch\xednh",
        "\xd8konomi",
        "\u0424\u0438\u043D\u0430\u043D\u0441\u044B",
        "\u0424\u0456\u043D\u0430\u043D\u0441\u0438",
        "\u0E01\u0E32\u0E23\u0E40\u0E07\u0E34\u0E19",
        "\u8CA1\u52D9",
        "\u91D1\u878D",
        "\uC7AC\uBB34"
    ],
    [$5d0851fa8905d151$export$4c29d0d04c15e55d]: [
        'HR',
        "Henkil\xf6st\xf6hallinto",
        'Human Resources',
        'Human resources',
        'human-resources',
        "Lidsk\xe9 zdroje",
        'Menneskelige ressourcer',
        "Nh\xe2n s\u1EF1",
        'Personal',
        "Personalfr\xe5gor",
        'RH',
        'Recursos Humanos',
        'Recursos humanos',
        'Risorse umane',
        "Szem\xe9lyzeti",
        'Zasoby ludzkie',
        "\u0130nsan Kaynaklar\u0131",
        "\u013Dudsk\xe9 zdroje",
        "\u0412\u0456\u0434\u0434\u0456\u043B \u043A\u0430\u0434\u0440\u0456\u0432",
        "\u041A\u0430\u0434\u0440\u043E\u0432\u044B\u0435 \u0432\u043E\u043F\u0440\u043E\u0441\u044B",
        "\u0E17\u0E23\u0E31\u0E1E\u0E22\u0E32\u0E01\u0E23\u0E1A\u0E38\u0E04\u0E04\u0E25",
        "\u4EBA\u4E8B",
        "\u4EBA\u529B\u8CC7\u6E90",
        "\u4EBA\u529B\u8D44\u6E90",
        "\uC778\uC0AC"
    ],
    [$5d0851fa8905d151$export$881249b988b6030f]: [
        "Departamento jur\xeddico",
        'Hukuk',
        'Jogi',
        'Jura',
        'Juridik',
        'Juridisk',
        "Jur\xeddico",
        'Legal',
        'Legale',
        'Oikeudelliset asiat',
        "Ph\xe1p l\xfd",
        'Prawo',
        "Pr\xe1vne oddelenie",
        "Pr\xe1vn\xed odd\u011Blen\xed",
        'Rechtliches',
        'Service juridique',
        "\xd5igus",
        "\u042E\u0440\u0438\u0434\u0438\u0447\u0435\u0441\u043A\u0438\u0435 \u0432\u043E\u043F\u0440\u043E\u0441\u044B",
        "\u042E\u0440\u0438\u0434\u0438\u0447\u043D\u0438\u0439 \u0432\u0456\u0434\u0434\u0456\u043B",
        "\u0E01\u0E0E\u0E2B\u0E21\u0E32\u0E22",
        "\u6CD5\u52D9",
        "\u6CD5\u5F8B",
        "\uBC95\uB960"
    ],
    [$5d0851fa8905d151$export$e4824f74b9879164]: [
        "Markedsf\xf8ring",
        'Marketing',
        'Markkinointi',
        "Marknadsf\xf6ring",
        'Pazarlama',
        "Ti\u1EBFp th\u1ECB",
        'Turundus',
        "\u041C\u0430\u0440\u043A\u0435\u0442\u0438\u043D\u0433",
        "\u0E01\u0E32\u0E23\u0E15\u0E25\u0E32\u0E14",
        "\u30DE\u30FC\u30B1\u30C6\u30A3\u30F3\u30B0",
        "\u8425\u9500",
        "\u884C\u92B7",
        "\uB9C8\uCF00\uD305"
    ],
    [$5d0851fa8905d151$export$4f3cb0844009af52]: [
        'Drift',
        'Haldus',
        'Operacional',
        'Operaciones',
        'Operacje',
        'Operasyonlar',
        'Operations',
        'Operativer Betrieb',
        'Operazioni',
        "Opera\xe7\xf5es",
        "Op\xe9rations",
        "Prev\xe1dzka",
        'Provoz',
        'Toiminnot',
        "V\u1EADn h\xe0nh",
        "\xdczemeltet\xe9si",
        "\u0412\u0438\u0440\u043E\u0431\u043D\u0438\u0447\u0438\u0439 \u0432\u0456\u0434\u0434\u0456\u043B",
        "\u041E\u043F\u0435\u0440\u0430\u0446\u0438\u043E\u043D\u043D\u044B\u0435 \u0432\u043E\u043F\u0440\u043E\u0441\u044B",
        "\u0E1D\u0E48\u0E32\u0E22\u0E1B\u0E0F\u0E34\u0E1A\u0E31\u0E15\u0E34\u0E01\u0E32\u0E23",
        "\u30AA\u30DA\u30EC\u30FC\u30B7\u30E7\u30F3",
        "\u71DF\u904B",
        "\u8FD0\u8425",
        "\uC6B4\uC601"
    ],
    [$5d0851fa8905d151$export$1a65d50c4a641bb4]: [
        "B\xe1n h\xe0ng",
        "F\xf6rs\xe4ljning",
        'Myynti',
        "M\xfc\xfck",
        'Predaj',
        'Prodej',
        'Sales',
        'Salg',
        "Sat\u0131\u015F",
        "Sprzeda\u017C",
        'Vendas',
        'Vendite',
        'Ventas',
        'Ventes',
        'Vertrieb',
        "\xc9rt\xe9kes\xedt\xe9si",
        "\u041F\u0440\u043E\u0434\u0430\u0436\u0438",
        "\u041F\u0440\u043E\u0434\u0430\u0436\u0456",
        "\u0E1D\u0E48\u0E32\u0E22\u0E02\u0E32\u0E22",
        "\u30BB\u30FC\u30EB\u30B9",
        "\u92B7\u552E",
        "\u9500\u552E",
        "\uC601\uC5C5"
    ],
    [$5d0851fa8905d151$export$b8b1ac856ba1434b]: [
        'Desarrollo de software',
        'Desenvolvimento de software',
        "D\xe9veloppement logiciel",
        'Ohjelmistokehitys',
        "Ph\xe1t tri\u1EC3n ph\u1EA7n m\u1EC1m",
        'Programutveckling',
        'Programvareutvikling',
        'Software Development',
        'Softwareentwicklung',
        'Softwareontwikkeling',
        'Softwareudvikling',
        'Sviluppo software',
        "Szoftverfejleszt\u0151",
        'Tarkvaraarendus',
        'Tworzenie oprogramowania',
        "V\xfdvoj softv\xe9ru",
        "V\xfdvoj softwaru",
        "Yaz\u0131l\u0131m Geli\u015Ftirme",
        "\u0420\u0430\u0437\u0440\u0430\u0431\u043E\u0442\u043A\u0430 \u041F\u041E",
        "\u0420\u043E\u0437\u0440\u043E\u0431\u043A\u0430 \u041F\u0417",
        "\u0E1E\u0E31\u0E12\u0E19\u0E32\u0E0B\u0E2D\u0E1F\u0E15\u0E4C\u0E41\u0E27\u0E23\u0E4C",
        "\u30BD\u30D5\u30C8\u30A6\u30A7\u30A2\u958B\u767A",
        "\u8EDF\u9AD4\u958B\u767C",
        "\u8F6F\u4EF6\u5F00\u53D1",
        "\uC18C\uD504\uD2B8\uC6E8\uC5B4 \uAC1C\uBC1C"
    ]
};
const $5d0851fa8905d151$var$BUSINESS_TEAM_TYPES = [
    $5d0851fa8905d151$export$4c29d0d04c15e55d,
    $5d0851fa8905d151$export$3950f7f841bf94b6,
    $5d0851fa8905d151$export$881249b988b6030f,
    $5d0851fa8905d151$export$e4824f74b9879164,
    $5d0851fa8905d151$export$4f3cb0844009af52,
    $5d0851fa8905d151$export$1a65d50c4a641bb4,
    $5d0851fa8905d151$export$b8b1ac856ba1434b
];
const $5d0851fa8905d151$var$BUSINESS_ROLES_PER_TEAM_TYPE = {
    [$5d0851fa8905d151$export$4c29d0d04c15e55d]: [
        $5d0851fa8905d151$var$ALL_ROLES_ELIGIBLE
    ],
    [$5d0851fa8905d151$export$3950f7f841bf94b6]: [
        $5d0851fa8905d151$var$ALL_ROLES_ELIGIBLE
    ],
    [$5d0851fa8905d151$export$881249b988b6030f]: [
        $5d0851fa8905d151$var$ALL_ROLES_ELIGIBLE
    ],
    [$5d0851fa8905d151$export$e4824f74b9879164]: [
        $5d0851fa8905d151$var$ALL_ROLES_ELIGIBLE
    ],
    [$5d0851fa8905d151$export$4f3cb0844009af52]: [
        $5d0851fa8905d151$var$ALL_ROLES_ELIGIBLE
    ],
    [$5d0851fa8905d151$export$1a65d50c4a641bb4]: [
        $5d0851fa8905d151$var$ALL_ROLES_ELIGIBLE
    ],
    [$5d0851fa8905d151$export$b8b1ac856ba1434b]: [
        $5d0851fa8905d151$var$USER_SEGMENTATION_ROLE_DESIGNER
    ]
};
const $5d0851fa8905d151$var$getNormalizedEntry = (userSegValue)=>{
    const lowerCaseUserSegValue = userSegValue.toLowerCase();
    return Object.entries($5d0851fa8905d151$var$USER_SEGMENTATION_CLIENT_MAPPING).find(// eslint-disable-next-line @typescript-eslint/no-explicit-any
    ([, translatedValues])=>translatedValues.map((v)=>v.toLowerCase()).includes(lowerCaseUserSegValue));
};
const $5d0851fa8905d151$export$d0bc507f0556398 = (value)=>{
    if (value === '') return $5d0851fa8905d151$export$4c9a72dac5ce80ae;
    const normalizedEntry = $5d0851fa8905d151$var$getNormalizedEntry(value);
    return normalizedEntry !== undefined ? normalizedEntry[0] : $5d0851fa8905d151$export$2f3f9640393bd078;
};
class $5d0851fa8905d151$var$SkipSentryError extends Error {
    constructor(message){
        super(message);
        this.skipSentry = true;
    }
}
const $5d0851fa8905d151$var$fireAnalyticsError = ({ id: id, field: field, error: error, unMatchedValue: unMatchedValue })=>{
    (0, $jcw0u.default)({
        meta: {
            id: id,
            packageName: 'jiraOnboardingCore'
        },
        attributes: {
            field: field,
            unMatchedValue: unMatchedValue
        },
        error: error,
        sendToPrivacyUnsafeSplunk: true
    });
};
const $5d0851fa8905d151$export$af8a28b856b3556f = (teamType)=>{
    if (!teamType) return false;
    const normalizedTeamType = $5d0851fa8905d151$export$d0bc507f0556398(teamType);
    if (normalizedTeamType === $5d0851fa8905d151$export$2f3f9640393bd078) $5d0851fa8905d151$var$fireAnalyticsError({
        id: 'isInSoftwareTeam',
        field: 'teamType',
        error: new $5d0851fa8905d151$var$SkipSentryError('teamType mapping is not found'),
        unMatchedValue: teamType
    });
    return normalizedTeamType === $5d0851fa8905d151$export$b8b1ac856ba1434b;
};
const $5d0851fa8905d151$export$517f94ab07724226 = (userAccountData)=>{
    const { teamType: teamType = '', role: role = '' } = userAccountData;
    const normalizedTeamType = $5d0851fa8905d151$export$d0bc507f0556398(teamType);
    if (normalizedTeamType === $5d0851fa8905d151$export$2f3f9640393bd078) $5d0851fa8905d151$var$fireAnalyticsError({
        id: 'userBelongsToBusinessUserSegCategory',
        field: 'teamType',
        error: new $5d0851fa8905d151$var$SkipSentryError('teamType mapping is not found'),
        unMatchedValue: teamType
    });
    const normalizedRole = $5d0851fa8905d151$export$d0bc507f0556398(role);
    if (normalizedRole === $5d0851fa8905d151$export$2f3f9640393bd078) $5d0851fa8905d151$var$fireAnalyticsError({
        id: 'userBelongsToBusinessUserSegCategory',
        field: 'role',
        error: new $5d0851fa8905d151$var$SkipSentryError('role mapping is not found'),
        unMatchedValue: role
    });
    // @ts-expect-error - TS2345 - Argument of type 'string' is not assignable to parameter of type 'UserSegmentationTeamTypes'.
    const isTeamTypeEligible = $5d0851fa8905d151$var$BUSINESS_TEAM_TYPES.includes(normalizedTeamType);
    const isRoleEligible = // @ts-expect-error - TS7053 - Element implicitly has an 'any' type because expression of type 'string' can't be used to index type 'Partial<Record<UserSegmentationTeamTypes, UserSegmentationRoleTypes[]>>'.
    $5d0851fa8905d151$var$BUSINESS_ROLES_PER_TEAM_TYPE[normalizedTeamType]?.includes($5d0851fa8905d151$var$ALL_ROLES_ELIGIBLE) || // @ts-expect-error - TS7053 - Element implicitly has an 'any' type because expression of type 'string' can't be used to index type 'Partial<Record<UserSegmentationTeamTypes, UserSegmentationRoleTypes[]>>'.
    $5d0851fa8905d151$var$BUSINESS_ROLES_PER_TEAM_TYPE[normalizedTeamType]?.includes(normalizedRole);
    return isTeamTypeEligible && isRoleEligible;
};
const $5d0851fa8905d151$export$6710e0127706b297 = (userAccountData)=>{
    const { teamType: teamType = '', role: role = '' } = userAccountData;
    const normalizedTeamType = $5d0851fa8905d151$export$d0bc507f0556398(teamType);
    if (normalizedTeamType === $5d0851fa8905d151$export$2f3f9640393bd078) $5d0851fa8905d151$var$fireAnalyticsError({
        id: 'userBelongsToSoftwareUserSegCategory',
        field: 'teamType',
        error: new $5d0851fa8905d151$var$SkipSentryError('teamType mapping is not found'),
        unMatchedValue: teamType
    });
    const normalizedRole = $5d0851fa8905d151$export$d0bc507f0556398(role);
    if (normalizedRole === $5d0851fa8905d151$export$2f3f9640393bd078) $5d0851fa8905d151$var$fireAnalyticsError({
        id: 'userBelongsToSoftwareUserSegCategory',
        field: 'role',
        error: new $5d0851fa8905d151$var$SkipSentryError('role mapping is not found'),
        unMatchedValue: role
    });
    const isTeamTypeEligible = normalizedTeamType === $5d0851fa8905d151$export$b8b1ac856ba1434b;
    const isRoleEligible = normalizedRole !== $5d0851fa8905d151$var$USER_SEGMENTATION_ROLE_DESIGNER;
    return isTeamTypeEligible && isRoleEligible;
};

});



parcelRegister("at1Nr", function(module, exports) {

$parcel$export(module.exports, "InviteTeamNudgeAsync", () => $8b5bfc2ae277a997$export$a4b4061b22dbc897);

var $5uXOq = parcelRequire("5uXOq");

var $7XluA = parcelRequire("7XluA");

var $4mO32 = parcelRequire("4mO32");


var $cE2Qr = parcelRequire("cE2Qr");


var $ahfXN = parcelRequire("ahfXN");
const $8b5bfc2ae277a997$var$runtimeProps = {};
const $8b5bfc2ae277a997$var$entryPointParams = {};
const $8b5bfc2ae277a997$export$a4b4061b22dbc897 = ()=>{
    const { entryPointActions: entryPointActions, entryPointReferenceSubject: entryPointReferenceSubject } = (0, $4mO32.useEntryPoint)((0, $ahfXN.inviteTeamNudgeEntryPoint), $8b5bfc2ae277a997$var$entryPointParams);
    const [nudgeStep] = (0, $cE2Qr.useNudgeStep)();
    const [hasNudgeActive] = (0, $cE2Qr.useHasNudgeActive)();
    const firstLoadRef = (0, $5uXOq.useRef)(true);
    // eslint-disable-next-line @atlassian/react-entrypoint/no-load-in-hooks
    (0, $5uXOq.useEffect)(()=>{
        if (firstLoadRef.current && hasNudgeActive && nudgeStep === (0, $6784cbc7d62e5d7c$export$77bc79debbf5c069)) {
            entryPointActions.load();
            firstLoadRef.current = false;
        }
    }, [
        entryPointActions,
        hasNudgeActive,
        nudgeStep
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7XluA.JiraEntryPointContainer), {
        id: (0, $dbbf68c32d8c4308$export$3bc551fe07069f89),
        packageName: "jiraInviteTeamOnboarding",
        entryPointReferenceSubject: entryPointReferenceSubject,
        fallback: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null),
        runtimeProps: $8b5bfc2ae277a997$var$runtimeProps
    });
};

});
const $dbbf68c32d8c4308$export$e0197e09cccd4e50 = 'backlogCreateSprintNudge';
const $dbbf68c32d8c4308$export$6770a2081a63fc15 = 'backlogStartSprintNudge';
const $dbbf68c32d8c4308$export$63b61f654ce3da3d = 'backlogCompleteSprintNudge';
const $dbbf68c32d8c4308$export$1c7a80b00ad9619 = 'backlogInsightsNudge';
const $dbbf68c32d8c4308$export$b8b9d90f9e5bd72b = 'jiraSoftwareOnboardingNudges';
const $dbbf68c32d8c4308$export$65fb0c4e534f03fc = 'asyncScrumTourNudge';
const $dbbf68c32d8c4308$export$f2fe211acb4aa81a = 'asyncKanbanTourNudge';
const $dbbf68c32d8c4308$export$fb9c6e63a7490968 = 'asyncJWMCalendarTourNudge';
const $dbbf68c32d8c4308$export$df53a339af97f102 = 'asyncJWMCalendarAndTimelineTourNudge';
const $dbbf68c32d8c4308$export$573d4bf1da6d2bc6 = 'asyncJWMBoardTourNudge';
const $dbbf68c32d8c4308$export$501e36925fa10eef = 'asyncJWMListTourNudge';
const $dbbf68c32d8c4308$export$2f06a16c987cc1a2 = 'asyncJWMTimelineTourNudge';
const $dbbf68c32d8c4308$export$226bdcb034c75951 = 'asyncJWMFormTourNudge';
const $dbbf68c32d8c4308$export$b72fce9f4cf11b5c = 'asyncJWMTrelloKeyDifferencesTourNudge';
const $dbbf68c32d8c4308$export$306510c7b1760652 = 'asyncJWMSummaryAndReportsTabNudge';
const $dbbf68c32d8c4308$export$cf1943561be3a3c2 = 'asyncJWMSummaryViewNudge';
const $dbbf68c32d8c4308$export$f8bf435a6066832c = 'button clicked';
const $dbbf68c32d8c4308$export$3bc551fe07069f89 = 'asyncJWMInviteTeamNudge';
const $dbbf68c32d8c4308$export$d99767a37baddfc = 'sampleProjectDataNudge';
const $dbbf68c32d8c4308$export$2ef41782ca91324c = 'businessSampleDataNudge';
const $dbbf68c32d8c4308$export$4db327e1949c2108 = 'boardInProgressColumnNudge';
const $dbbf68c32d8c4308$export$a402f2c11da96cd7 = 'boardCreateIssueNudge';
const $dbbf68c32d8c4308$export$1e174cd1e0212f3a = 'navigateCalendarNudge';
const $dbbf68c32d8c4308$export$a1398a6ef9526001 = 'inlineEditListNudge';
const $dbbf68c32d8c4308$export$5908fa8acd2c0739 = 'filterListNudge';
const $dbbf68c32d8c4308$export$50192b0fdc9bdacf = 'moreDropdownListNudge';
const $dbbf68c32d8c4308$export$e34e81ed4f255f6e = 'timelineAddDateNudge';
const $dbbf68c32d8c4308$export$aac6e5779d47ef37 = 'timelineAddChildItemNudge';
const $dbbf68c32d8c4308$export$dd4b359b5a58cdc0 = 'trelloCrossflowTimelineTabNudge';
const $dbbf68c32d8c4308$export$1e0e647cc08bb4d8 = 'trelloKeyDifferencesIssueNudge';
const $dbbf68c32d8c4308$export$762576896c225bd6 = 'trelloKeyDifferencesSummaryNudge';
const $dbbf68c32d8c4308$export$5a96f813312dc7fa = 'trelloKeyDifferencesBoardNudge';
const $dbbf68c32d8c4308$export$ae8eeb04e0b1e9af = 'availableFieldsFormNudge';
const $dbbf68c32d8c4308$export$a54d77300f1dddea = 'changeIssueTypeFormNudge';
const $dbbf68c32d8c4308$export$6afdc7e5f6d2e915 = 'previewSaveFormNudge';
const $dbbf68c32d8c4308$export$eb0b199de90a7ec2 = 'backgroundColorNudge';
const $dbbf68c32d8c4308$export$e9e47a7ad42e71f5 = 'feedbackNudge';
const $dbbf68c32d8c4308$export$791f56b3d78403cc = 'calendarReleasesNudge';
const $dbbf68c32d8c4308$export$a1be34032ee24f78 = 'shareProjectNudge';
const $dbbf68c32d8c4308$export$29fe6611cc093756 = 'summaryTabNudge';
const $dbbf68c32d8c4308$export$f107c06c0830f09d = 'reportsTabNudge';
const $dbbf68c32d8c4308$export$9749a972a54ad7ba = 'boardContainerNudge';
const $dbbf68c32d8c4308$export$fb4f98ca3ff0420 = 'businessSampleDataNudge';
const $dbbf68c32d8c4308$export$b7fd448c62b5fb97 = 'listview';
const $dbbf68c32d8c4308$export$10c63dc5c09466d2 = 'boardview';
const $dbbf68c32d8c4308$export$75b8d65228d517e9 = 'sampleProjectScrumTourNudge';
const $dbbf68c32d8c4308$export$59a47f76d45b99 = 'sampleProjectScrumSprintNudge';
const $dbbf68c32d8c4308$export$513a9459cd6c3f96 = 'sampleProjectScrumBacklogNudge';
const $dbbf68c32d8c4308$export$657cdc4d7e8d9e5f = 'sampleProjectScrumBoardNudge';
const $dbbf68c32d8c4308$export$e16b25a220be9f3b = 'sampleProjectBoardNudge';
const $dbbf68c32d8c4308$export$c2f124710ac3a3ab = 'sampleProjectListNudge';
const $dbbf68c32d8c4308$export$b1c1e2ff4cbedbe = 'sampleProjectScrumSprintNudgeErrorBoundary';
const $dbbf68c32d8c4308$export$b230ed22c9a186d5 = 'sampleProjectScrumBacklogNudgeErrorBoundary';
const $dbbf68c32d8c4308$export$a321b777cf077071 = 'sampleProjectScrumBoardNudgeErrorBoundary';
const $dbbf68c32d8c4308$export$b51b409cb5508624 = 'sampleProjectBoardNudgeErrorBoundary';
const $dbbf68c32d8c4308$export$9757a1f68dc7a9b = 'sampleProjectListNudgeErrorBoundary';
const $dbbf68c32d8c4308$export$63a886637b84800 = 'sampleProjectNavTourNudge';
const $dbbf68c32d8c4308$export$bb40993d16db4a4b = 'SampleProjectNavNudge';
const $dbbf68c32d8c4308$export$8c300ac9d8c53332 = 'SampleProjectNavNudgeErrorBoundary';

parcelRegister("ahfXN", function(module, exports) {

$parcel$export(module.exports, "inviteTeamNudgeEntryPoint", () => $140395164e9a1c0c$export$ff76bc343b4103b1);

var $eufEc = parcelRequire("eufEc");

var $fEDBv = parcelRequire("fEDBv");

const $140395164e9a1c0c$export$ff76bc343b4103b1 = (0, $fEDBv.createEntryPoint)({
    root: (0, $eufEc.JSResourceForInteraction)(()=>(parcelRequire("6PgXT")), {
        moduleId: "4ca4d8af"
    }),
    getPreloadProps: ()=>({})
});

});
parcelRegister("6PgXT", function(module, exports) {

let $4f84aa61ae3792ec$var$load = (parcelRequire("28QjX"))(4);
module.exports = $4f84aa61ae3792ec$var$load("keCTG").then(()=>parcelRequire('guBtq'));

});



parcelRegister("69X1g", function(module, exports) {

$parcel$export(module.exports, "NavigationPeopleNavItemWrapperNudgeAsync", () => $affd57fc52973db7$export$57ea67608b7cb448);

var $5uXOq = parcelRequire("5uXOq");


var $bBbEG = parcelRequire("bBbEG");

var $lfTZh = parcelRequire("lfTZh");

var $kxZPA = parcelRequire("kxZPA");

// eslint-disable-next-line jira/deprecations/no-rll-client-async-experiences
const $affd57fc52973db7$var$NavigationPeopleNavItemLazy = (0, $kxZPA.lazyAfterPaint)(()=>(parcelRequire("goUQn")).then((exportedModule)=>exportedModule.NavigationPeopleNavItemWrapperNudge), {
    ssr: false,
    moduleId: "./src/packages/software/onboarding-nudges/src/ui/navigation-people/index.tsx"
});
const $affd57fc52973db7$export$57ea67608b7cb448 = ({ children: children, isInsideMenu: isInsideMenu })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $bBbEG.OnboardingNudgeErrorBoundary), {
        id: (0, $6784cbc7d62e5d7c$export$b74a8fdb2c75b869),
        fallback: children,
        attributes: {
            nudgeId: (0, $6784cbc7d62e5d7c$export$b74a8fdb2c75b869)
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $lfTZh.default), {
        name: "navigation-people-nav-item-lazy",
        fallback: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, children)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($affd57fc52973db7$var$NavigationPeopleNavItemLazy, {
        nudgeId: (0, $6784cbc7d62e5d7c$export$b74a8fdb2c75b869),
        isInsideMenu: isInsideMenu
    }, children)));

});
parcelRegister("goUQn", function(module, exports) {

let $bf0afb40272755c9$var$load = (parcelRequire("28QjX"))(4);
module.exports = $bf0afb40272755c9$var$load("7cwm9").then(()=>parcelRequire('5NaVN'));

});


parcelRegister("fSeA2", function(module, exports) {

$parcel$export(module.exports, "default", () => $38abab37a6ae6abe$export$2e2bcd8739ae039);
// export main component

var $8D6em = parcelRequire("8D6em");
var $38abab37a6ae6abe$export$2e2bcd8739ae039 = (0, $8D6em.default);

});
parcelRegister("8D6em", function(module, exports) {

$parcel$export(module.exports, "default", () => $8b76e34713086949$export$2e2bcd8739ae039);

var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $cb25w = parcelRequire("cb25w");

var $2bzBV = parcelRequire("2bzBV");

var $1I7E8 = parcelRequire("1I7E8");

var $hEofo = parcelRequire("hEofo");

var $5iwOw = parcelRequire("5iwOw");

var $dS8wI = parcelRequire("dS8wI");

var $gFH8O = parcelRequire("gFH8O");

var $9iwCj = parcelRequire("9iwCj");

var $jHmRo = parcelRequire("jHmRo");

var $7U5E9 = parcelRequire("7U5E9");

var $4144s = parcelRequire("4144s");

var $4AXtg = parcelRequire("4AXtg");

var $14DM3 = parcelRequire("14DM3");
// if `@atlaskit/popup` is upgraded from 0.6.x to 1.x,
// we may need to change this to an array of numbers like [0, 12];.
const $8b76e34713086949$var$OFFSET_FOR_MORE_BUTTON_VIEW = '12px -11px';
const $8b76e34713086949$var$eventuallyClearHoverMeasure = ()=>{
    setTimeout(()=>{
        (0, $gFH8O.clearMeasure)('hoverAndClick');
    }, 5 * $8b76e34713086949$var$SECOND);
};
const $8b76e34713086949$var$SECOND = 1000;
function $8b76e34713086949$export$b26ac1e1a63fbe24(props) {
    const { customChevronIcon: customChevronIcon, isHighlighted: isHighlighted, enablePreFetchingByHovering: enablePreFetchingByHovering, createAnalyticsEvent: createAnalyticsEvent, peopleText: peopleText, onClick: onClick = (0, $dS8wI.VOID_FUNC) } = props;
    const [canPrefetch, setCanPrefetch] = (0, $5uXOq.useState)(false);
    const { testId: testId, isPeopleMenuOpen: isPeopleMenuOpen, isSSR: isSSR, cloudId: cloudId, orgId: orgId, userId: userId, product: product, tenantUrl: tenantUrl, togglePeopleMenu: togglePeopleMenu = (0, $dS8wI.VOID_FUNC), shouldRenderToParent: shouldRenderToParent = false } = (0, $5uXOq.useContext)((0, $hEofo.PeopleMenuContext));
    const { isVisible: isVisible } = (0, $2bzBV.useOverflowStatus)();
    const closeMenu = (0, $5uXOq.useCallback)(()=>togglePeopleMenu(false), [
        togglePeopleMenu
    ]);
    const handleClickOnTriggerButton = (0, $5uXOq.useCallback)(()=>{
        onClick(!isPeopleMenuOpen);
        togglePeopleMenu(!isPeopleMenuOpen);
        // measure duration of click and show menu
        (0, $gFH8O.startMeasure)('clickAndShow');
        (0, $gFH8O.stopMeasure)('hoverAndClick', (duration, startTime)=>{
            (0, $9iwCj.triggerAnalyticsForHoverAndClick)(createAnalyticsEvent, duration, startTime);
        });
    }, [
        createAnalyticsEvent,
        isPeopleMenuOpen,
        onClick,
        togglePeopleMenu
    ]);
    const handleMouseEnterTriggerButton = (0, $5uXOq.useCallback)(()=>{
        (0, $jHmRo.MenuContent).preload();
        if (!canPrefetch) {
            setCanPrefetch(true);
            // measure duration time between hovering and clicking
            (0, $gFH8O.startMeasure)('hoverAndClick');
            // clear all unwanted hovering after 5 seconds
            $8b76e34713086949$var$eventuallyClearHoverMeasure();
        }
    }, [
        canPrefetch,
        setCanPrefetch
    ]);
    const buttonProps = {
        isSelected: isPeopleMenuOpen,
        onClick: handleClickOnTriggerButton,
        onMouseEnter: handleMouseEnterTriggerButton,
        testId: `${testId}-people-primary-button`,
        peopleText: peopleText
    };
    const PopupContent = (0, $5uXOq.useCallback)(()=>/*#__PURE__*/ (0, $2OMIu.jsx)((0, $7U5E9.PeopleMenuContentInternal), {}), []);
    if (isSSR) return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $4AXtg.PeopleMenuTriggerSSR), {
        testId: testId,
        peopleText: peopleText
    });
    return /*#__PURE__*/ (0, $2OMIu.jsxs)((0, $2OMIu.Fragment), {
        children: [
            /*#__PURE__*/ (0, $2OMIu.jsx)((0, $1I7E8.default), {
                // @ts-ignore
                offset: isVisible ? undefined : $8b76e34713086949$var$OFFSET_FOR_MORE_BUTTON_VIEW,
                content: PopupContent,
                isOpen: isPeopleMenuOpen,
                placement: isVisible ? 'bottom-start' : 'right-start',
                onClose: closeMenu,
                shouldRenderToParent: shouldRenderToParent,
                trigger: (triggerProps)=>/*#__PURE__*/ (0, $2OMIu.jsx)((0, $4AXtg.default), {
                        isVisible: isVisible,
                        isHighlighted: isHighlighted,
                        customChevronIcon: customChevronIcon,
                        triggerProps: triggerProps,
                        ...buttonProps
                    })
            }),
            enablePreFetchingByHovering && canPrefetch && (0, $5iwOw.isCachedDataClear)() && /*#__PURE__*/ (0, $2OMIu.jsx)((0, $14DM3.UsersTeamsPreFetch), {
                cloudId: cloudId,
                orgId: orgId,
                userId: userId,
                product: product,
                tenantUrl: tenantUrl
            })
        ]
    });
}
const $8b76e34713086949$var$PeopleMenuInternalWithAnalytics = (0, $cb25w.default)()($8b76e34713086949$export$b26ac1e1a63fbe24);
function $8b76e34713086949$export$2e2bcd8739ae039(props) {
    const { isHighlighted: isHighlighted, onClick: onClick, enablePreFetchingByHovering: enablePreFetchingByHovering, customChevronIcon: customChevronIcon, peopleText: peopleText, ...providerProps } = {
        ...props
    };
    return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $4144s.default), {
        ...providerProps,
        children: /*#__PURE__*/ (0, $2OMIu.jsx)($8b76e34713086949$var$PeopleMenuInternalWithAnalytics, {
            customChevronIcon: customChevronIcon,
            isHighlighted: isHighlighted,
            onClick: onClick,
            enablePreFetchingByHovering: enablePreFetchingByHovering,
            peopleText: peopleText
        })
    });
}

});
parcelRegister("hEofo", function(module, exports) {

$parcel$export(module.exports, "PeopleMenuContext", () => $04cbb00093c742e6$export$c92ff8b73313c89);
$parcel$export(module.exports, "PeopleMenuContextProvider", () => $04cbb00093c742e6$export$4e812997de4564ae);
$parcel$export(module.exports, "usePeopleMenuContext", () => $04cbb00093c742e6$export$c8d82c28669da5dc);

var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $dC5iT = parcelRequire("dC5iT");
var $8CUq3 = parcelRequire("8CUq3");

var $7kP9q = parcelRequire("7kP9q");

const $04cbb00093c742e6$var$AKModalTransition = /*#__PURE__*/ (0, $5uXOq.lazy)(()=>(parcelRequire("5LSAq")).then((module)=>({
            default: module.ModalTransition
        })));

const $04cbb00093c742e6$var$TeamCreateDialog = /*#__PURE__*/ (0, $5uXOq.lazy)(()=>(parcelRequire("6yjYY")).then((module)=>({
            default: module.TeamCreateDialog
        })));
// this wrapper is for preventing changing layout of around elements
const $04cbb00093c742e6$var$DialogWrapper = (0, $8CUq3.xcss)({
    width: 'space.0',
    height: 'space.0',
    margin: '0',
    padding: '0',
    '::before': {
        width: 'space.0',
        height: 'space.0',
        margin: '0',
        padding: '0'
    },
    '::after': {
        width: 'space.0',
        height: 'space.0',
        margin: '0',
        padding: '0'
    }
});
const $04cbb00093c742e6$var$analyticsAttrsTeamCreateDialog = {
    ref: (0, $7kP9q.AnalyticsSource).PEOPLE_MENU
};
const $04cbb00093c742e6$export$c92ff8b73313c89 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createContext({
    orgId: '',
    cloudId: '',
    userId: '',
    product: 'confluence',
    testId: '',
    isPeopleMenuOpen: false,
    isSSR: false,
    onClickedItem: ()=>undefined,
    pushRoute: ()=>undefined,
    togglePeopleMenu: ()=>undefined,
    toggleTeamCreateDialog: ()=>undefined,
    _hasError: undefined,
    teamCreateDialogProps: {},
    shouldRenderToParent: false,
    isSectionList: false
});
function $04cbb00093c742e6$export$4e812997de4564ae(props) {
    const { isSSR: isSSR = false } = props;
    const [isOpenTeamCreateDialog, toggleOpenTeamCreateDialog] = (0, $5uXOq.useState)(false);
    const { children: children, isOpen: isOpen, onOpen: onOpen, onClose: onClose, ...otherProps } = props;
    const togglePeopleMenu = (0, $5uXOq.useCallback)((newState)=>{
        if (newState === isOpen) return;
        if (newState) onOpen();
        else onClose();
    }, [
        isOpen,
        onClose,
        onOpen
    ]);
    const toggleTeamCreateDialog = (0, $5uXOq.useCallback)((isOpen)=>{
        toggleOpenTeamCreateDialog(isOpen);
    }, [
        toggleOpenTeamCreateDialog
    ]);
    const values = (0, $5uXOq.useMemo)(()=>({
            teamCreateDialogProps: {},
            ...otherProps,
            // extra props
            isPeopleMenuOpen: isOpen,
            togglePeopleMenu: togglePeopleMenu,
            toggleTeamCreateDialog: toggleTeamCreateDialog
        }), [
        otherProps,
        isOpen,
        togglePeopleMenu,
        toggleTeamCreateDialog
    ]);
    const closeTeamCreateDialog = (0, $5uXOq.useCallback)(()=>{
        toggleOpenTeamCreateDialog(false);
        if (typeof values.teamCreateDialogProps?.onClose === 'function') values.teamCreateDialogProps.onClose();
    }, [
        toggleOpenTeamCreateDialog,
        values.teamCreateDialogProps
    ]);
    return /*#__PURE__*/ (0, $2OMIu.jsxs)($04cbb00093c742e6$export$c92ff8b73313c89.Provider, {
        value: values,
        children: [
            children,
            !isSSR && isOpenTeamCreateDialog && /*#__PURE__*/ (0, $2OMIu.jsx)((0, $dC5iT.default), {
                xcss: $04cbb00093c742e6$var$DialogWrapper,
                testId: `${otherProps.testId}-team-create-dialog-wrapper`,
                children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $5uXOq.Suspense), {
                    fallback: null,
                    children: /*#__PURE__*/ (0, $2OMIu.jsx)($04cbb00093c742e6$var$AKModalTransition, {
                        children: isOpenTeamCreateDialog && /*#__PURE__*/ (0, $2OMIu.jsx)($04cbb00093c742e6$var$TeamCreateDialog, {
                            cloudId: values.cloudId,
                            orgId: values.orgId,
                            product: values.product,
                            principalId: values.userId,
                            addFlag: values.addFlag,
                            pushRoute: values.pushRoute,
                            extraAnalyticsAttrs: $04cbb00093c742e6$var$analyticsAttrsTeamCreateDialog,
                            ...values.teamCreateDialogProps,
                            onClose: closeTeamCreateDialog
                        })
                    })
                })
            })
        ]
    });
}
const $04cbb00093c742e6$export$c8d82c28669da5dc = ()=>(0, $5uXOq.useContext)($04cbb00093c742e6$export$c92ff8b73313c89);

});
parcelRegister("7kP9q", function(module, exports) {

$parcel$export(module.exports, "AnalyticsActionSubject", () => $2156eaa79e4b3f27$export$4bce2c1f3a5d9f61);
$parcel$export(module.exports, "AnalyticsAction", () => $2156eaa79e4b3f27$export$30c16f5c43437fd7);
$parcel$export(module.exports, "AnalyticsSource", () => $2156eaa79e4b3f27$export$6890652a1aff7d1c);
var $2156eaa79e4b3f27$export$4bce2c1f3a5d9f61 = /*#__PURE__*/ function(AnalyticsActionSubject) {
    AnalyticsActionSubject["ERROR_BOUNDARY"] = "errorBoundary";
    AnalyticsActionSubject["VIEW_PEOPLE_ADDITIONAL_LINK"] = "additionalMenuLink";
    AnalyticsActionSubject["VIEW_PEOPLE_DIRECTORY_LINK"] = "viewAllPeopleDirectory";
    AnalyticsActionSubject["CREATE_NEW_TEAM_LINK"] = "createNewTeamLink";
    AnalyticsActionSubject["PEOPLE_MENU_LINK"] = "peopleMenuLink";
    AnalyticsActionSubject["TEAM_MENU_LINK"] = "teamMenuLink";
    AnalyticsActionSubject["PEOPLE_MENU"] = "peopleMenu";
    AnalyticsActionSubject["NAVIGATION_MENU_ITEM"] = "navigationMenuItem";
    AnalyticsActionSubject["PRE_FETCH_DATA"] = "preFetchData";
    AnalyticsActionSubject["FETCHING_USERS_TEAMS_DATA"] = "fetchingUsersTeamsData";
    AnalyticsActionSubject["HOVER_AND_CLICK_PEOPLE_BUTTON"] = "hoverAndClickPeopleButton";
    AnalyticsActionSubject["BUTTON"] = "button";
    return AnalyticsActionSubject;
}({});
var $2156eaa79e4b3f27$export$30c16f5c43437fd7 = /*#__PURE__*/ function(AnalyticsAction) {
    AnalyticsAction["RENDERED"] = "rendered";
    AnalyticsAction["CLICKED"] = "clicked";
    AnalyticsAction["EXPOSED"] = "exposed";
    AnalyticsAction["FAILED"] = "failed";
    AnalyticsAction["SUCCEEDED"] = "succeeded";
    AnalyticsAction["VIEWED"] = "viewed";
    AnalyticsAction["TRIGGERED"] = "triggered";
    AnalyticsAction["MEASURED"] = "measured";
    AnalyticsAction["INELIGIBLE"] = "ineligible";
    return AnalyticsAction;
}({});
var $2156eaa79e4b3f27$export$6890652a1aff7d1c = /*#__PURE__*/ function(AnalyticsSource) {
    AnalyticsSource["PEOPLE_MENU"] = "peopleMenu";
    return AnalyticsSource;
}({});

});

parcelRegister("5LSAq", function(module, exports) {

let $433baf47b06abf01$var$load = (parcelRequire("28QjX"))(4);
module.exports = $433baf47b06abf01$var$load("jELnc").then(()=>parcelRequire('3YJEd'));

});

parcelRegister("6yjYY", function(module, exports) {

let $4c556b215a9f5342$var$load = (parcelRequire("28QjX"))(4);
module.exports = Promise.all([
    $4c556b215a9f5342$var$load("kNFvF"),
    $4c556b215a9f5342$var$load("3L2aP")
]).then(()=>parcelRequire('8degK'));

});


parcelRegister("5iwOw", function(module, exports) {

$parcel$export(module.exports, "isCachedDataClear", () => $b65fff219f4109a7$export$cee8b843259f0f74);
$parcel$export(module.exports, "default", () => $b65fff219f4109a7$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $jm65K = parcelRequire("jm65K");
var $hOaMz = parcelRequire("hOaMz");
const $b65fff219f4109a7$export$50fd3325777ce4bc = new Map();
const $b65fff219f4109a7$export$cd84c175965a58da = 'collaborators';
const $b65fff219f4109a7$export$b5c382592ac689a7 = 'teams';
const $b65fff219f4109a7$var$ONE_SEC = 1000;
const $b65fff219f4109a7$var$ONE_MINUTE = $b65fff219f4109a7$var$ONE_SEC * 60;
const $b65fff219f4109a7$var$REQUEST_CACHE_TIMEOUT_TEAMS = $b65fff219f4109a7$var$ONE_MINUTE;
const $b65fff219f4109a7$var$REQUEST_CACHE_TIMEOUT_USERS = $b65fff219f4109a7$var$ONE_MINUTE * 5;
function $b65fff219f4109a7$export$cee8b843259f0f74() {
    return $b65fff219f4109a7$export$50fd3325777ce4bc.size === 0;
}
function $b65fff219f4109a7$export$2e2bcd8739ae039(cloudId, userId, product, tenantUrl, requestCacheTimeout, orgId) {
    const [dataUsers, setDataUsers] = (0, $5uXOq.useState)(undefined);
    const [dataTeams, setDataTeams] = (0, $5uXOq.useState)(undefined);
    const { loading: isLoadingUsers, error: errorUsers, data: users } = (0, $jm65K.useCollaboratorsService)(cloudId, 'context', tenantUrl, requestCacheTimeout === undefined ? $b65fff219f4109a7$var$REQUEST_CACHE_TIMEOUT_USERS : requestCacheTimeout);
    const { loading: isLoadingTeams, error: errorTeams, data: teams } = (0, $hOaMz.useTeamsOfService)(userId, cloudId, product, tenantUrl, requestCacheTimeout === undefined ? $b65fff219f4109a7$var$REQUEST_CACHE_TIMEOUT_TEAMS : requestCacheTimeout, orgId);
    // after the service return the latest data,
    // we store users data in cache store.
    (0, $5uXOq.useEffect)(()=>{
        if (!users || isLoadingUsers || errorUsers) return;
        $b65fff219f4109a7$export$50fd3325777ce4bc.set($b65fff219f4109a7$export$cd84c175965a58da, users);
        setDataUsers(users);
    }, [
        users,
        isLoadingUsers,
        errorUsers
    ]);
    // after the service return the latest data,
    // store teams data in cache store.
    (0, $5uXOq.useEffect)(()=>{
        if (!teams || isLoadingTeams || errorTeams) return;
        $b65fff219f4109a7$export$50fd3325777ce4bc.set($b65fff219f4109a7$export$b5c382592ac689a7, teams);
        setDataTeams(teams);
    }, [
        teams,
        isLoadingTeams,
        errorTeams
    ]);
    return {
        users: dataUsers && dataUsers.length ? dataUsers : $b65fff219f4109a7$export$50fd3325777ce4bc.get($b65fff219f4109a7$export$cd84c175965a58da),
        teams: dataTeams && dataTeams.length ? dataTeams : $b65fff219f4109a7$export$50fd3325777ce4bc.get($b65fff219f4109a7$export$b5c382592ac689a7),
        errorTeams: errorTeams,
        errorUsers: errorUsers,
        isLoading: isLoadingUsers || isLoadingTeams
    };
}

});
parcelRegister("jm65K", function(module, exports) {

$parcel$export(module.exports, "useCollaboratorsService", () => $a01b882127eb026f$export$979a4f9449b8be53);

var $5uXOq = parcelRequire("5uXOq");

var $7j6lB = parcelRequire("7j6lB");

var $4QMKv = parcelRequire("4QMKv");

var $jFIGx = parcelRequire("jFIGx");

var $lKN3j = parcelRequire("lKN3j");
const $a01b882127eb026f$var$mapFetchCollaboratorsFnByTimeout = new Map();
function $a01b882127eb026f$var$getFetchCollaboratorsCachedFn(timeout = (0, $jFIGx.DEFAULT_RELEASE_RESOLVED_PROMISE_DELAY)) {
    let fn = $a01b882127eb026f$var$mapFetchCollaboratorsFnByTimeout.get(timeout);
    if (fn) return fn;
    fn = (0, $jFIGx.withCached)((0, $7j6lB.fetchCollaborators), timeout);
    $a01b882127eb026f$var$mapFetchCollaboratorsFnByTimeout.set(timeout, fn);
    return fn;
}
function $a01b882127eb026f$export$979a4f9449b8be53(cloudId, userId = 'context', tenantUrl = '', cacheTimeout) {
    const request = (0, $5uXOq.useCallback)(()=>{
        if (cacheTimeout) {
            const fn = $a01b882127eb026f$var$getFetchCollaboratorsCachedFn(cacheTimeout);
            return fn(cloudId, userId, tenantUrl);
        }
        return (0, $7j6lB.fetchCollaborators)(cloudId, userId, tenantUrl);
    }, [
        cacheTimeout,
        cloudId,
        userId,
        tenantUrl
    ]);
    const { loading: loading, error: error, data: data, fetchData: fetchData } = (0, $lKN3j.useService)(request, {
        loading: true
    });
    // For reusable services, it is better not to hardcode fetching on mount, to make them more flexible. When possible, add this code to component which calls service instead.
    (0, $5uXOq.useEffect)(()=>{
        fetchData();
    /*
      NOTE: If you add `fetchData` to the dependency list (in this component or its children) - you have to define `request` function you pass to `useService()` via `useCallback()`.
      Otherwise you may get an infinite loop.
    */ }, [
        fetchData
    ]);
    const memoizedData = (0, $5uXOq.useMemo)(()=>(0, $4QMKv.transformCollabsDataToUsers)(data), [
        data
    ]);
    return {
        loading: loading,
        error: error,
        data: memoizedData,
        fetchData: fetchData
    };
}

});
parcelRegister("7j6lB", function(module, exports) {

$parcel$export(module.exports, "fetchCollaborators", () => $1e130a4c1c3e3780$export$cadad85c3acf2ad8);

var $jtAXU = parcelRequire("jtAXU");
const $1e130a4c1c3e3780$export$42623aff9edf525f = '/gateway/api/collaboration/v1/collaborationgraph/user/user';
const $1e130a4c1c3e3780$var$LIMIT_RESULTS = 5;
const $1e130a4c1c3e3780$export$cadad85c3acf2ad8 = (cloudId, userId = 'context', tenantUrl = '')=>(0, $jtAXU.postJson)(`${tenantUrl}${$1e130a4c1c3e3780$export$42623aff9edf525f}`, {
        context: {
            contextType: 'atlassianPeoplePackage',
            principalId: userId,
            siteId: cloudId
        },
        maxNumberOfResults: $1e130a4c1c3e3780$var$LIMIT_RESULTS,
        userId: userId,
        expanded: true
    });

});
parcelRegister("jtAXU", function(module, exports) {

$parcel$export(module.exports, "fetchJson", () => $ce30f9eae95058a3$export$6d71b655afe1638d);
$parcel$export(module.exports, "postJson", () => $ce30f9eae95058a3$export$c776284ef4b1209a);
const $ce30f9eae95058a3$export$83179404a61b001a = 'FetchError';
function $ce30f9eae95058a3$export$847691ec04985fa0(error, status, traceId) {
    return {
        name: $ce30f9eae95058a3$export$83179404a61b001a,
        message: error.message,
        stack: error.stack,
        status: status,
        traceId: traceId
    };
}
const $ce30f9eae95058a3$export$6d71b655afe1638d = (url, init)=>{
    return fetch(url, {
        credentials: 'include',
        ...init
    }).then((response)=>{
        if (response.ok) return response.json();
        const traceId = response?.headers?.get('atl-traceid') || undefined;
        throw $ce30f9eae95058a3$export$847691ec04985fa0(new Error(`Unable to fetch ${url} ${response.status} ${response.statusText}`), response.status, traceId);
    });
};
const $ce30f9eae95058a3$export$c776284ef4b1209a = (url, data, headers)=>$ce30f9eae95058a3$export$6d71b655afe1638d(url, {
        method: 'POST',
        credentials: 'include',
        headers: {
            'Content-Type': 'application/json',
            ...headers
        },
        body: JSON.stringify(data)
    });

});


parcelRegister("4QMKv", function(module, exports) {

$parcel$export(module.exports, "transformCollabsDataToUsers", () => $33301444de547d8e$export$1eb7590d078520b8);

var $dt9VY = parcelRequire("dt9VY");
const $33301444de547d8e$var$userMapper = (user)=>{
    const { userProfile: userProfile, entityType: entityType } = user;
    if (!userProfile || entityType !== (0, $dt9VY.ENTITY_TYPE).USER) return null;
    return {
        id: user.id,
        fullName: userProfile.name,
        nickname: userProfile.nickname,
        email: userProfile.email,
        avatarUrl: userProfile.picture,
        collaborationGraphScore: user.score,
        status: userProfile.account_status
    };
};
const $33301444de547d8e$export$1eb7590d078520b8 = (data)=>{
    if (!data) return [];
    const { collaborationGraphEntities: collaborationGraphEntities = [] } = data;
    return collaborationGraphEntities.map($33301444de547d8e$var$userMapper).filter((item)=>item) || [];
};

});
parcelRegister("dt9VY", function(module, exports) {

$parcel$export(module.exports, "ENTITY_TYPE", () => $c64d873f35a96cde$export$49be827a0aef75dd);
var $c64d873f35a96cde$export$49be827a0aef75dd = /*#__PURE__*/ function(ENTITY_TYPE) {
    ENTITY_TYPE["CONTAINER"] = "CONTAINER";
    ENTITY_TYPE["USER"] = "USER";
    return ENTITY_TYPE;
}({});
var $c64d873f35a96cde$export$fba7c3adda5094d9 = /*#__PURE__*/ function(CONTAINER_TYPE) {
    CONTAINER_TYPE["JIRA_PROJECT"] = "jiraProject";
    CONTAINER_TYPE["CONFLUENCE_SPACE"] = "confluenceSpace";
    return CONTAINER_TYPE;
}({});

});


parcelRegister("jFIGx", function(module, exports) {

$parcel$export(module.exports, "DEFAULT_RELEASE_RESOLVED_PROMISE_DELAY", () => $66b55f654aa333ec$export$d8b1aa62ff4847fc);
$parcel$export(module.exports, "withCached", () => $66b55f654aa333ec$export$7f51828d6b6af163);
const $66b55f654aa333ec$var$ONE_SECOND = 1000;
const $66b55f654aa333ec$export$d8b1aa62ff4847fc = 5 * $66b55f654aa333ec$var$ONE_SECOND;
const $66b55f654aa333ec$var$isPromise = (p)=>{
    return p !== undefined && typeof p.then === 'function' && typeof p.catch === 'function';
};
const $66b55f654aa333ec$export$7f51828d6b6af163 = (fn, timeout = $66b55f654aa333ec$export$d8b1aa62ff4847fc)=>{
    const resultCache = new Map();
    const promiseCache = new Map();
    function getCacheKey(...args) {
        return JSON.stringify(args);
    }
    const cached = (...args)=>{
        const cacheKey = getCacheKey(...args);
        return resultCache.get(cacheKey);
    };
    const reset = ()=>{
        resultCache.clear();
        promiseCache.clear();
    };
    const execute = (...args)=>{
        const cacheKey = getCacheKey(...args);
        const cachedPromise = promiseCache.get(cacheKey);
        if (cachedPromise !== undefined) return cachedPromise;
        const maybePromise = fn(...args);
        // we don't handle non-promise data so skip it
        if ($66b55f654aa333ec$var$isPromise(maybePromise)) {
            promiseCache.set(cacheKey, maybePromise);
            maybePromise.then((result)=>{
                resultCache.set(cacheKey, result);
                setTimeout(()=>{
                    promiseCache.delete(cacheKey);
                    resultCache.delete(cacheKey);
                }, timeout);
            }).catch(()=>{
                promiseCache.delete(cacheKey);
                resultCache.delete(cacheKey);
            });
        }
        return maybePromise;
    };
    return Object.assign(execute, fn, {
        cached: cached,
        reset: reset
    });
};

});

parcelRegister("lKN3j", function(module, exports) {

$parcel$export(module.exports, "useService", () => $72edefc047c53cbc$export$6de4685a6c88b4e9);

var $5uXOq = parcelRequire("5uXOq");
const $72edefc047c53cbc$export$6de4685a6c88b4e9 = (request, initialState = {})=>{
    const [state, setStateRaw] = (0, $5uXOq.useState)({
        loading: false,
        ...initialState
    });
    const isMounted = (0, $5uXOq.useRef)(true);
    (0, $5uXOq.useEffect)(()=>{
        isMounted.current = true;
        return ()=>{
            isMounted.current = false;
        };
    });
    const setState = (0, $5uXOq.useCallback)((state)=>{
        if (isMounted.current) setStateRaw(state);
    }, []);
    const fetchData = (0, $5uXOq.useCallback)(async ()=>{
        setState({
            loading: true,
            error: undefined,
            data: undefined
        });
        try {
            const data = await request();
            setState({
                loading: false,
                error: undefined,
                data: data
            });
        } catch (error) {
            setState({
                loading: false,
                error: error,
                data: undefined
            });
        }
    }, [
        request,
        setState
    ]);
    return {
        ...state,
        fetchData: fetchData
    };
};

});


parcelRegister("hOaMz", function(module, exports) {

$parcel$export(module.exports, "useTeamsOfService", () => $71e3afc4a862a4a9$export$668750a034956301);

var $5uXOq = parcelRequire("5uXOq");

var $b8vEv = parcelRequire("b8vEv");

var $eS2nd = parcelRequire("eS2nd");

var $jFIGx = parcelRequire("jFIGx");

var $lKN3j = parcelRequire("lKN3j");
const $71e3afc4a862a4a9$var$mapFetchMyTeamsFnByTimeout = new Map();
function $71e3afc4a862a4a9$var$getFetchMyTeamsCachedFn(timeout = (0, $jFIGx.DEFAULT_RELEASE_RESOLVED_PROMISE_DELAY)) {
    let fn = $71e3afc4a862a4a9$var$mapFetchMyTeamsFnByTimeout.get(timeout);
    if (fn) return fn;
    fn = (0, $jFIGx.withCached)((0, $b8vEv.searchTeamsOfUser), timeout);
    $71e3afc4a862a4a9$var$mapFetchMyTeamsFnByTimeout.set(timeout, fn);
    return fn;
}
function $71e3afc4a862a4a9$export$668750a034956301(userId, cloudId, product, tenantUrl = '', cacheTimeout, orgId) {
    const request = (0, $5uXOq.useCallback)(()=>{
        if (cacheTimeout) {
            const fn = $71e3afc4a862a4a9$var$getFetchMyTeamsCachedFn(cacheTimeout);
            return fn(userId, cloudId, product, tenantUrl, orgId);
        }
        return (0, $b8vEv.searchTeamsOfUser)(userId, cloudId, product, tenantUrl, orgId);
    }, [
        cacheTimeout,
        userId,
        cloudId,
        product,
        tenantUrl,
        orgId
    ]);
    const { loading: loading, error: error, data: data, fetchData: fetchData } = (0, $lKN3j.useService)(request, {
        loading: true
    });
    // For reusable services, it is better not to hardcode fetching on mount, to make them more flexible. When possible, add this code to component which calls service instead.
    (0, $5uXOq.useEffect)(()=>{
        fetchData();
    /*
      NOTE: If you add `fetchData` to the dependency list (in this component or its children) - you have to define `request` function you pass to `useService()` via `useCallback()`.
      Otherwise you may get an infinite loop.
    */ }, [
        fetchData
    ]);
    const memoizedData = (0, $5uXOq.useMemo)(()=>(0, $eS2nd.transformTeams)(data), [
        data
    ]);
    return {
        loading: loading,
        error: error,
        data: memoizedData,
        fetchData: fetchData
    };
}

});
parcelRegister("b8vEv", function(module, exports) {

$parcel$export(module.exports, "searchTeamsOfUser", () => $5b88913fa719a883$export$c52386bca71fd065);
$parcel$export(module.exports, "postCreateTeam", () => $5b88913fa719a883$export$db3c0c162386baf4);

var $dmOdc = parcelRequire("dmOdc");

var $3ys0B = parcelRequire("3ys0B");

var $1XkTN = parcelRequire("1XkTN");

var $v6X2P = parcelRequire("v6X2P");

var $jtAXU = parcelRequire("jtAXU");
const $5b88913fa719a883$var$LIMIT_RESULTS = 5;
const $5b88913fa719a883$export$51eb1e4b266d279a = '/gateway/api';
const $5b88913fa719a883$export$a6635dd972d6facf = `${$5b88913fa719a883$export$51eb1e4b266d279a}/v3/teams`;
const $5b88913fa719a883$export$8ebb304bc6fdbba2 = `${$5b88913fa719a883$export$51eb1e4b266d279a}/v4/teams`;
const $5b88913fa719a883$export$d6cee1ef1aa86c6d = `${$5b88913fa719a883$export$a6635dd972d6facf}/of-user`;
const $5b88913fa719a883$export$5c5040d455d75334 = `${$5b88913fa719a883$export$8ebb304bc6fdbba2}/search`;
const $5b88913fa719a883$export$2964ca5e058bf0b = (userId, cloudId, product, tenantUrl = '', orgId)=>{
    const params = [
        `limit=${$5b88913fa719a883$var$LIMIT_RESULTS}`,
        'cursor=',
        `organizationId=${orgId ?? ''}`,
        `origin.cloudId=${cloudId}`,
        `origin.product=${product.toUpperCase()}`
    ];
    return `${tenantUrl}${$5b88913fa719a883$export$d6cee1ef1aa86c6d}/${userId}?&${params.join('&')}`;
};
const $5b88913fa719a883$export$8c9e20a1ace4ac54 = (cloudId, product, tenantUrl = '')=>`${tenantUrl}${$5b88913fa719a883$export$5c5040d455d75334}${(0, $3ys0B.constructProductOriginParams)({
        product: product,
        cloudId: cloudId
    })}`;
const $5b88913fa719a883$export$d084da02a78b32a4 = (userId, cloudId, product, tenantUrl = '', orgId)=>orgId ? (0, $jtAXU.fetchJson)($5b88913fa719a883$export$2964ca5e058bf0b(userId, cloudId, product, tenantUrl, orgId)) : new Promise(()=>{});
const $5b88913fa719a883$export$c52386bca71fd065 = (userId, cloudId, product, tenantUrl = '', orgId)=>{
    if (!userId || !cloudId || !orgId) throw new (0, $v6X2P.ErrorWithContext)('Missing parameters', {
        userId: userId,
        cloudId: cloudId,
        orgId: orgId,
        product: product,
        tenantUrl: tenantUrl
    });
    const url = $5b88913fa719a883$export$8c9e20a1ace4ac54(cloudId, product, tenantUrl);
    const postData = {
        organizationId: orgId,
        siteId: cloudId,
        limit: $5b88913fa719a883$var$LIMIT_RESULTS,
        membership: {
            memberAccountIds: [
                userId
            ]
        }
    };
    return (0, $jtAXU.postJson)(url, postData);
};
const $5b88913fa719a883$export$db3c0c162386baf4 = async (teamName, membershipSettings, metaData)=>{
    (0, $dmOdc.teamsClient).setContext({
        cloudId: metaData.cloudId,
        orgId: metaData.orgId
    });
    (0, $dmOdc.teamsClient).setBaseUrl(`${metaData.tenantUrl ?? ''}${$5b88913fa719a883$export$51eb1e4b266d279a}`);
    const result = await (0, $dmOdc.teamsClient).createTeam(teamName, {
        product: metaData.product
    }, [
        ...new Set(metaData.members)
    ], membershipSettings === (0, $1XkTN.TeamMembershipSettings).OPEN ? 'OPEN' : 'MEMBER_INVITE');
    return {
        id: result.id,
        displayName: result.displayName,
        description: result.description,
        state: result.state === 'ACTIVE' ? (0, $1XkTN.TeamState).ACTIVE : (0, $1XkTN.TeamState).PURGED,
        membershipSettings: result.membershipSettings === 'OPEN' ? (0, $1XkTN.TeamMembershipSettings).OPEN : (0, $1XkTN.TeamMembershipSettings).INVITE_ONLY,
        memberCount: result.memberIds?.length ?? 0,
        teamAri: `ari:cloud:teams::team/${result.id}`,
        discoverable: (0, $1XkTN.TeamDiscoverability).DISCOVERABLE,
        organizationId: result.organizationId,
        restriction: (0, $1XkTN.TeamRestriction).NO_RESTRICTION,
        creatorId: result.creatorId,
        memberIds: result.memberIds,
        permission: result.permission === 'FULL_WRITE' ? (0, $1XkTN.TeamPermission).FULL_WRITE : result.permission === 'FULL_READ' ? (0, $1XkTN.TeamPermission).FULL_READ : (0, $1XkTN.TeamPermission).NONE
    };
};
const $5b88913fa719a883$export$27c5962a642c1a90 = async (teamCreationPayload, tenantUrl)=>{
    (0, $dmOdc.teamsClient).setBaseUrl(`${tenantUrl ?? ''}${$5b88913fa719a883$export$51eb1e4b266d279a}`);
    const result = await (0, $dmOdc.teamsClient).createTeamContainers(teamCreationPayload);
    return {
        teamId: result.teamId,
        containersNotCreated: result.containersNotCreated,
        containerDetails: result.containerDetails
    };
};
const $5b88913fa719a883$export$76780145274bc285 = (teamId, { product: product, cloudId: cloudId, tenantUrl: tenantUrl = '' })=>{
    return `${tenantUrl}${$5b88913fa719a883$export$a6635dd972d6facf}/ui/${teamId}/membership/invite${(0, $3ys0B.constructProductOriginParams)({
        product: product,
        cloudId: cloudId
    })}`;
};
const $5b88913fa719a883$export$9cb3b92426f8e2eb = async (teamId, users, metaData)=>{
    if (!users || users.length === 0) return Promise.resolve(undefined);
    const emails = [];
    const ids = [];
    users.forEach((user)=>{
        if (user.id) ids.push(user.id);
        else if (user.email) emails.push(user.email);
    });
    const url = $5b88913fa719a883$export$76780145274bc285(teamId, metaData);
    const postData = {
        emailAddresses: emails,
        atlassianAccounts: ids
    };
    return (0, $jtAXU.postJson)(url, postData);
};

});
parcelRegister("3ys0B", function(module, exports) {

$parcel$export(module.exports, "constructProductOriginParams", () => $3d96dc0719b6030c$export$d479c7e8f449d360);
$parcel$export(module.exports, "getPeopleDirectoryHomePageWithOrgId", () => $3d96dc0719b6030c$export$873f5b458fb2c7bd);
$parcel$export(module.exports, "getPeopleProfilePage", () => $3d96dc0719b6030c$export$8d1c08ae3a193cc5);
$parcel$export(module.exports, "getTeamProfilePageLinkWithOrgId", () => $3d96dc0719b6030c$export$143be302a1686103);
$parcel$export(module.exports, "trimLastForwardSlash", () => $3d96dc0719b6030c$export$41ba1f3da3359c4);
function $3d96dc0719b6030c$var$toStrParams(obj) {
    const str = Object.keys(obj).map((k)=>{
        const v = obj[k];
        return v ? `${k}=${encodeURIComponent(v)}` : undefined;
    }).filter((it)=>!!it).join('&');
    return str ? `?${str}` : '';
}
function $3d96dc0719b6030c$export$d479c7e8f449d360(originQuery) {
    return $3d96dc0719b6030c$var$toStrParams({
        'origin.cloudId': originQuery.cloudId,
        'origin.product': originQuery.product?.toUpperCase() || ''
    });
}
function $3d96dc0719b6030c$export$575daf737e125483(remoteConfigResources) {
    return remoteConfigResources?.baseUrl || '';
}
function $3d96dc0719b6030c$export$873f5b458fb2c7bd({ remoteConfigResources: remoteConfigResources, orgId: orgId, ref: ref, src: src }) {
    const params = {
        ref: ref,
        src: src
    };
    return `${$3d96dc0719b6030c$export$575daf737e125483(remoteConfigResources)}${(remoteConfigResources?.peopleDirectoryHome || '').replace(':orgId', orgId ?? '')}${$3d96dc0719b6030c$var$toStrParams(params)}`;
}
function $3d96dc0719b6030c$export$a8c794e14e33c8e9(remoteConfigResources, ref, src) {
    const params = {
        ref: ref,
        src: src
    };
    return `${$3d96dc0719b6030c$export$575daf737e125483(remoteConfigResources)}${remoteConfigResources?.peopleDirectoryHome || ''}${$3d96dc0719b6030c$var$toStrParams(params)}`;
}
function $3d96dc0719b6030c$export$8d1c08ae3a193cc5(remoteConfigResources, userId, ref, src) {
    const params = {
        ref: ref,
        src: src
    };
    return `${$3d96dc0719b6030c$export$575daf737e125483(remoteConfigResources)}${(remoteConfigResources?.peopleProfile || '').replace(':userId', userId)}${$3d96dc0719b6030c$var$toStrParams(params)}`;
}
function $3d96dc0719b6030c$export$143be302a1686103({ remoteConfigResources: remoteConfigResources, teamId: teamId, orgId: orgId, ref: ref, src: src }) {
    const params = {
        ref: ref,
        src: src
    };
    return `${$3d96dc0719b6030c$export$575daf737e125483(remoteConfigResources)}${(remoteConfigResources?.teamProfile || '').replace(':teamId', teamId).replace(':orgId', orgId ?? '')}${$3d96dc0719b6030c$var$toStrParams(params)}`;
}
function $3d96dc0719b6030c$export$8b8a898467a65284(remoteConfigResources, teamId, ref, src) {
    const params = {
        ref: ref,
        src: src
    };
    return `${$3d96dc0719b6030c$export$575daf737e125483(remoteConfigResources)}${(remoteConfigResources?.teamProfile || '').replace(':teamId', teamId)}${$3d96dc0719b6030c$var$toStrParams(params)}`;
}
function $3d96dc0719b6030c$export$41ba1f3da3359c4(url = '') {
    if (url[url.length - 1] === '/') return url.slice(0, -1);
    return url;
}

});

parcelRegister("1XkTN", function(module, exports) {

$parcel$export(module.exports, "TeamState", () => $2e4d2173f996bc4f$export$c5c56131401e0716);
$parcel$export(module.exports, "TeamMembershipSettings", () => $2e4d2173f996bc4f$export$93b1c6cf9d16dce6);
$parcel$export(module.exports, "TeamDiscoverability", () => $2e4d2173f996bc4f$export$c698762b98da6685);
$parcel$export(module.exports, "TeamRestriction", () => $2e4d2173f996bc4f$export$e94592bde85a4d74);
$parcel$export(module.exports, "TeamPermission", () => $2e4d2173f996bc4f$export$4db108522156032a);
// raw data is returned from Legion API
var $2e4d2173f996bc4f$export$c5c56131401e0716 = /*#__PURE__*/ function(TeamState) {
    TeamState["ACTIVE"] = "ACTIVE";
    TeamState["DISBANDED"] = "DISBANDED";
    TeamState["PURGED"] = "PURGED";
    return TeamState;
}({});
var $2e4d2173f996bc4f$export$93b1c6cf9d16dce6 = /*#__PURE__*/ function(TeamMembershipSettings) {
    TeamMembershipSettings["OPEN"] = "OPEN";
    TeamMembershipSettings["INVITE_ONLY"] = "MEMBER_INVITE";
    TeamMembershipSettings["EXTERNAL"] = "EXTERNAL";
    return TeamMembershipSettings;
}({});
var $2e4d2173f996bc4f$export$c698762b98da6685 = /*#__PURE__*/ function(TeamDiscoverability) {
    TeamDiscoverability["DISCOVERABLE"] = "DISCOVERABLE";
    return TeamDiscoverability;
}({});
var $2e4d2173f996bc4f$export$e94592bde85a4d74 = /*#__PURE__*/ function(TeamRestriction) {
    TeamRestriction["ORG_MEMBERS"] = "ORG_MEMBERS";
    TeamRestriction["NO_RESTRICTION"] = "NO_RESTRICTION";
    return TeamRestriction;
}({});
var $2e4d2173f996bc4f$export$4db108522156032a = /*#__PURE__*/ function(TeamPermission) {
    TeamPermission["FULL_WRITE"] = "FULL_WRITE";
    TeamPermission["FULL_READ"] = "FULL_READ";
    TeamPermission["NONE"] = "NONE";
    return TeamPermission;
}({});

});

parcelRegister("v6X2P", function(module, exports) {

$parcel$export(module.exports, "ErrorWithContext", () => $f420277b82de59c9$export$6e749dfbce027249);
class $f420277b82de59c9$export$6e749dfbce027249 extends Error {
    constructor(message, context){
        super(message);
        this.context = context;
    }
}

});


parcelRegister("eS2nd", function(module, exports) {

$parcel$export(module.exports, "trimTeamAriInObject", () => $d1bcb2947e62ab7a$export$c75c12ecb0b3724e);
$parcel$export(module.exports, "transformTeams", () => $d1bcb2947e62ab7a$export$fd398a52d6f57b46);
function $d1bcb2947e62ab7a$export$c75c12ecb0b3724e(team) {
    if (!team) return team;
    return {
        ...team,
        id: team.id.replace('ari:cloud:teams::team/', '').replace('ari:cloud:identity::team/', '')
    };
}
const $d1bcb2947e62ab7a$export$fd398a52d6f57b46 = (data)=>{
    if (!data || !data.entities) return [];
    return data.entities.map($d1bcb2947e62ab7a$export$c75c12ecb0b3724e);
};

});



parcelRegister("dS8wI", function(module, exports) {

$parcel$export(module.exports, "VOID_FUNC", () => $83eda9ae9b3c8996$export$7e6ba5d480e9bd2f);
const $83eda9ae9b3c8996$export$53bb833296af4a30 = 5;
const $83eda9ae9b3c8996$export$88d6945644578407 = 3;
const $83eda9ae9b3c8996$export$7e6ba5d480e9bd2f = ()=>undefined;

});

parcelRegister("gFH8O", function(module, exports) {

$parcel$export(module.exports, "startMeasure", () => $b257cb8dc2555f00$export$b62aa2130c86b59b);
$parcel$export(module.exports, "stopMeasure", () => $b257cb8dc2555f00$export$37c25be427bec097);
$parcel$export(module.exports, "clearMeasure", () => $b257cb8dc2555f00$export$6f766653554dac02);
const $b257cb8dc2555f00$var$isPerformanceAPIAvailable = ()=>{
    return typeof window !== 'undefined' && 'performance' in window && [
        'measure',
        'clearMeasures',
        'clearMarks',
        'getEntriesByName',
        'getEntriesByType'
    ].every((api)=>!!performance[api]);
};
const $b257cb8dc2555f00$var$hasPerformanceAPIAvailable = $b257cb8dc2555f00$var$isPerformanceAPIAvailable();
const $b257cb8dc2555f00$var$measureMap = new Map();
function $b257cb8dc2555f00$export$b62aa2130c86b59b(measureName) {
    if (!$b257cb8dc2555f00$var$hasPerformanceAPIAvailable) return;
    performance.mark(`${measureName}::start`);
    $b257cb8dc2555f00$var$measureMap.set(measureName, performance.now());
}
function $b257cb8dc2555f00$export$37c25be427bec097(measureName, onMeasureComplete) {
    if (!$b257cb8dc2555f00$var$hasPerformanceAPIAvailable) return;
    // `startMeasure` is not called with `measureName` before.
    if (!$b257cb8dc2555f00$var$measureMap.get(measureName)) return;
    performance.mark(`${measureName}::end`);
    const start = onMeasureComplete ? $b257cb8dc2555f00$var$measureMap.get(measureName) : undefined;
    try {
        performance.measure(measureName, `${measureName}::start`, `${measureName}::end`);
    } catch (error) {} finally{
        if (onMeasureComplete) {
            const entry = performance.getEntriesByName(measureName).pop();
            if (entry) onMeasureComplete(entry.duration, entry.startTime);
            else if (start) onMeasureComplete(performance.now() - start, start);
        }
        $b257cb8dc2555f00$export$6f766653554dac02(measureName);
    }
}
function $b257cb8dc2555f00$export$6f766653554dac02(measureName) {
    if (!$b257cb8dc2555f00$var$hasPerformanceAPIAvailable) return;
    $b257cb8dc2555f00$var$measureMap.delete(measureName);
    performance.clearMarks(`${measureName}::start`);
    performance.clearMarks(`${measureName}::end`);
    performance.clearMeasures(measureName);
}

});

parcelRegister("9iwCj", function(module, exports) {

$parcel$export(module.exports, "triggerAnalyticsForClickCreateNewTeam", () => $36e53a66a40086f1$export$c22050996e7c2c8a);
$parcel$export(module.exports, "triggerAnalyticsForMenuLink", () => $36e53a66a40086f1$export$e2de484c93cb7dd8);
$parcel$export(module.exports, "triggerAnalyticsForClickViewDirectory", () => $36e53a66a40086f1$export$e3be20a27c367b1d);
$parcel$export(module.exports, "triggerAnalyticsForClickInvitePeople", () => $36e53a66a40086f1$export$bb6086ba6d61c34e);
$parcel$export(module.exports, "triggerAnalyticsForClickOnPeople", () => $36e53a66a40086f1$export$8c5588f22f5cd9d8);
$parcel$export(module.exports, "triggerAnalyticsForClickOnTeam", () => $36e53a66a40086f1$export$580e4977bd9f636d);
$parcel$export(module.exports, "triggerAnalyticsForViewedPeopleMenu", () => $36e53a66a40086f1$export$b7b4061d9dd52eb9);
$parcel$export(module.exports, "triggerAnalyticsForRenderedInvitePeople", () => $36e53a66a40086f1$export$3e9b11df8135b7cb);
$parcel$export(module.exports, "triggerAnalyticsForPreFetchData", () => $36e53a66a40086f1$export$750c07c02477d2f7);
$parcel$export(module.exports, "triggerAnalyticsForLoadingIndicator", () => $36e53a66a40086f1$export$d88a623841ba7b50);
$parcel$export(module.exports, "triggerAnalyticsForFetchingData", () => $36e53a66a40086f1$export$bda81aea2199d550);
$parcel$export(module.exports, "triggerAnalyticsForHoverAndClick", () => $36e53a66a40086f1$export$f2cf5fec906275c6);
$parcel$export(module.exports, "triggerAnalyticsForViewedFullUsersAndTeams", () => $36e53a66a40086f1$export$589011fd49e3f6d6);
$parcel$export(module.exports, "triggerAnalyticsForNoBrowsePeoplePermission", () => $36e53a66a40086f1$export$1eb2f70fed6b75f7);
$parcel$export(module.exports, "AnalyticsActionSubject", () => (parcelRequire("7kP9q")).AnalyticsActionSubject);
$parcel$export(module.exports, "AnalyticsAction", () => (parcelRequire("7kP9q")).AnalyticsAction);

var $3mE7N = parcelRequire("3mE7N");

var $7kP9q = parcelRequire("7kP9q");

var $6uNb2 = parcelRequire("6uNb2");
const $36e53a66a40086f1$export$c22050996e7c2c8a = (createAnalyticsEvent)=>{
    (0, $3mE7N.fireUIEvent)(createAnalyticsEvent, {
        actionSubject: (0, $7kP9q.AnalyticsActionSubject).CREATE_NEW_TEAM_LINK,
        action: (0, $7kP9q.AnalyticsAction).CLICKED
    });
};
const $36e53a66a40086f1$export$e2de484c93cb7dd8 = (additionalLinkId, action, createAnalyticsEvent, attributes)=>{
    (0, $3mE7N.fireUIEvent)(createAnalyticsEvent, {
        actionSubject: (0, $7kP9q.AnalyticsActionSubject).VIEW_PEOPLE_ADDITIONAL_LINK,
        actionSubjectId: additionalLinkId,
        action: action,
        attributes: {
            integration: 'peopleMenu',
            ...attributes
        }
    });
};
const $36e53a66a40086f1$export$e3be20a27c367b1d = (createAnalyticsEvent, isLeftClick = false)=>{
    (0, $3mE7N.fireUIEvent)(createAnalyticsEvent, {
        actionSubject: (0, $7kP9q.AnalyticsActionSubject).VIEW_PEOPLE_DIRECTORY_LINK,
        action: (0, $7kP9q.AnalyticsAction).CLICKED,
        attributes: {
            isLeftClick: isLeftClick
        }
    });
};
const $36e53a66a40086f1$export$bb6086ba6d61c34e = (createAnalyticsEvent, attributes)=>{
    (0, $3mE7N.fireUIEvent)(createAnalyticsEvent, {
        actionSubject: (0, $7kP9q.AnalyticsActionSubject).NAVIGATION_MENU_ITEM,
        actionSubjectId: 'addPeopleNavigationMenuItem',
        action: (0, $7kP9q.AnalyticsAction).CLICKED,
        attributes: {
            integration: 'peopleMenu',
            ...attributes
        }
    });
};
const $36e53a66a40086f1$export$8c5588f22f5cd9d8 = (createAnalyticsEvent, isLeftClick = false)=>{
    (0, $3mE7N.fireUIEvent)(createAnalyticsEvent, {
        actionSubject: (0, $7kP9q.AnalyticsActionSubject).PEOPLE_MENU_LINK,
        action: (0, $7kP9q.AnalyticsAction).CLICKED,
        attributes: {
            isLeftClick: isLeftClick
        }
    });
};
const $36e53a66a40086f1$export$580e4977bd9f636d = (createAnalyticsEvent, isLeftClick = false)=>{
    (0, $3mE7N.fireUIEvent)(createAnalyticsEvent, {
        actionSubject: (0, $7kP9q.AnalyticsActionSubject).TEAM_MENU_LINK,
        action: (0, $7kP9q.AnalyticsAction).CLICKED,
        attributes: {
            isLeftClick: isLeftClick
        }
    });
};
const $36e53a66a40086f1$export$b7b4061d9dd52eb9 = (createAnalyticsEvent, isCacheEmpty = false)=>{
    (0, $3mE7N.fireScreenEvent)(createAnalyticsEvent, {
        name: 'peopleMenu',
        attributes: {
            isCacheEmpty: isCacheEmpty
        }
    });
};
const $36e53a66a40086f1$export$3e9b11df8135b7cb = (createAnalyticsEvent)=>{
    (0, $3mE7N.fireUIEvent)(createAnalyticsEvent, {
        actionSubject: 'addPeopleNavigationItem',
        action: (0, $7kP9q.AnalyticsAction).RENDERED
    });
};
const $36e53a66a40086f1$export$750c07c02477d2f7 = (createAnalyticsEvent)=>{
    (0, $3mE7N.fireTrackEvent)(createAnalyticsEvent, {
        actionSubject: (0, $7kP9q.AnalyticsActionSubject).PRE_FETCH_DATA,
        action: (0, $7kP9q.AnalyticsAction).TRIGGERED
    });
};
const $36e53a66a40086f1$export$d88a623841ba7b50 = (createAnalyticsEvent, duration = 0, startTime = 0)=>{
    (0, $3mE7N.fireUIEvent)(createAnalyticsEvent, {
        actionSubject: (0, $7kP9q.AnalyticsActionSubject).PEOPLE_MENU,
        actionSubjectId: 'loadingIndicator',
        action: (0, $7kP9q.AnalyticsAction).VIEWED,
        attributes: {
            duration: duration,
            startTime: startTime
        }
    });
};
const $36e53a66a40086f1$export$bda81aea2199d550 = (createAnalyticsEvent, duration = 0, startTime = 0)=>{
    (0, $3mE7N.fireTrackEvent)(createAnalyticsEvent, {
        actionSubject: (0, $7kP9q.AnalyticsActionSubject).FETCHING_USERS_TEAMS_DATA,
        action: (0, $7kP9q.AnalyticsAction).MEASURED,
        attributes: {
            duration: duration,
            startTime: startTime
        }
    });
};
const $36e53a66a40086f1$export$f2cf5fec906275c6 = (createAnalyticsEvent, duration = 0, startTime = 0)=>{
    (0, $3mE7N.fireTrackEvent)(createAnalyticsEvent, {
        actionSubject: (0, $7kP9q.AnalyticsActionSubject).HOVER_AND_CLICK_PEOPLE_BUTTON,
        action: (0, $7kP9q.AnalyticsAction).MEASURED,
        attributes: {
            duration: duration,
            startTime: startTime
        }
    });
};
const $36e53a66a40086f1$export$589011fd49e3f6d6 = (createAnalyticsEvent, usersCount = 0, teamsCount = 0, duration = 0, startTime = 0)=>{
    (0, $3mE7N.fireTrackEvent)(createAnalyticsEvent, {
        actionSubject: (0, $7kP9q.AnalyticsActionSubject).PEOPLE_MENU,
        action: (0, $7kP9q.AnalyticsAction).SUCCEEDED,
        attributes: {
            usersCount: usersCount,
            teamsCount: teamsCount,
            duration: duration,
            startTime: startTime
        }
    });
};
const $36e53a66a40086f1$export$1eb2f70fed6b75f7 = (createAnalyticsEvent)=>{
    (0, $3mE7N.fireUIEvent)(createAnalyticsEvent, {
        actionSubject: (0, $7kP9q.AnalyticsActionSubject).PEOPLE_MENU,
        action: (0, $7kP9q.AnalyticsAction).VIEWED,
        actionSubjectId: 'noBrowsePermission'
    });
};

});
parcelRegister("6uNb2", function(module, exports) {

$parcel$export(module.exports, "triggerAnalyticsForLoadedPeople", () => $9ae06323a5a66ecb$export$62ecc9342d32a444);
$parcel$export(module.exports, "triggerAnalyticsForLoadedTeam", () => $9ae06323a5a66ecb$export$e648838c8bbef986);

var $3mE7N = parcelRequire("3mE7N");
parcelRequire("9iwCj");
var $7kP9q = parcelRequire("7kP9q");
const $9ae06323a5a66ecb$export$62ecc9342d32a444 = (action, createAnalyticsEvent, status, error)=>{
    (0, $3mE7N.fireOperationalEvent)(createAnalyticsEvent, {
        actionSubject: (0, $7kP9q.AnalyticsActionSubject).PEOPLE_MENU_LINK,
        action: action === 'succeeded' ? (0, $7kP9q.AnalyticsAction).SUCCEEDED : (0, $7kP9q.AnalyticsAction).FAILED,
        attributes: {
            status: status,
            error: error?.message || JSON.stringify(error)
        }
    });
};
const $9ae06323a5a66ecb$export$e648838c8bbef986 = (action, createAnalyticsEvent, status, error)=>{
    (0, $3mE7N.fireOperationalEvent)(createAnalyticsEvent, {
        actionSubject: (0, $7kP9q.AnalyticsActionSubject).TEAM_MENU_LINK,
        action: action === 'succeeded' ? (0, $7kP9q.AnalyticsAction).SUCCEEDED : (0, $7kP9q.AnalyticsAction).FAILED,
        attributes: {
            status: status,
            error: error?.message || JSON.stringify(error)
        }
    });
};

});


parcelRegister("jHmRo", function(module, exports) {

$parcel$export(module.exports, "MenuContent", () => $f5293b335fdac1fe$export$479f0f2f71193efe);
$parcel$export(module.exports, "MenuContentFallback", () => $f5293b335fdac1fe$export$48b47052ec2aea7f);

var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");
parcelRequire("kc9vJ");
var $8DfXF = parcelRequire("8DfXF");

var $eZUJu = parcelRequire("eZUJu");

var $hEofo = parcelRequire("hEofo");

var $5iwOw = parcelRequire("5iwOw");

var $ihfgn = parcelRequire("ihfgn");

var $5IiJH = parcelRequire("5IiJH");

const $f5293b335fdac1fe$export$479f0f2f71193efe = (0, $8DfXF.lazyForPaint)(()=>// eslint-disable-next-line import/dynamic-import-chunkname
    (parcelRequire("1x4s1")));
const $f5293b335fdac1fe$export$b0396be60c0e9152 = 480;
const $f5293b335fdac1fe$export$3f133812f81dfa49 = 320;
const $f5293b335fdac1fe$export$94aaf6acd960c412 = 'calc(100vh - 79px)';
function $f5293b335fdac1fe$export$48b47052ec2aea7f() {
    const { cloudId: cloudId, tenantUrl: tenantUrl, userId: userId, product: product, testId: testId, orgId: orgId } = (0, $5uXOq.useContext)((0, $hEofo.PeopleMenuContext));
    // kick off some requests sooner
    (0, $5iwOw.default)(cloudId, userId, product, tenantUrl, undefined, orgId);
    return /*#__PURE__*/ (0, $2OMIu.jsxs)((0, $eZUJu.default), {
        testId: `${testId}-group-loading`,
        maxWidth: $f5293b335fdac1fe$export$b0396be60c0e9152,
        maxHeight: $f5293b335fdac1fe$export$94aaf6acd960c412,
        minWidth: $f5293b335fdac1fe$export$3f133812f81dfa49,
        children: [
            /*#__PURE__*/ (0, $2OMIu.jsx)((0, $ihfgn.MenuGroupPeople), {
                isLoading: true
            }),
            /*#__PURE__*/ (0, $2OMIu.jsx)((0, $5IiJH.MenuGroupTeams), {
                isLoading: true
            })
        ]
    });
}

});
parcelRegister("kc9vJ", function(module, exports) {

$parcel$export(module.exports, "lazyForPaint", () => (parcelRequire("8DfXF")).lazyForPaint);
$parcel$export(module.exports, "lazyAfterPaint", () => (parcelRequire("8DfXF")).lazyAfterPaint);
$parcel$export(module.exports, "lazy", () => (parcelRequire("8DfXF")).lazy);
$parcel$export(module.exports, "LazySuspense", () => (parcelRequire("ihijj")).LazySuspense);
$parcel$export(module.exports, "useLazyPhase", () => (parcelRequire("7j6wR")).useLazyPhase);
parcelRequire("9tT5O");
var $0431B = parcelRequire("0431B");

var $bh45B = parcelRequire("bh45B");

var $8DfXF = parcelRequire("8DfXF");
parcelRequire("3iU61");
var $8gCAq = parcelRequire("8gCAq");
var $hxt6y = parcelRequire("hxt6y");
parcelRequire("41yqT");
var $ihijj = parcelRequire("ihijj");
parcelRequire("1Cn7k");
var $7j6wR = parcelRequire("7j6wR");

var $lUR7e = parcelRequire("lUR7e");

});
parcelRegister("9tT5O", function(module, exports) {

$parcel$export(module.exports, "getConfig", () => $6e718ebf0a3d5ffc$export$44487a86467333c3);
$parcel$export(module.exports, "setConfig", () => $6e718ebf0a3d5ffc$export$940a7873bb071df8);
$parcel$export(module.exports, "MODE", () => (parcelRequire("0431B")).MODE);

var $0431B = parcelRequire("0431B");
const $6e718ebf0a3d5ffc$var$DEFAULT_CROSS_ORIGIN = undefined;
const $6e718ebf0a3d5ffc$var$DEFAULT_MANIFEST = {
    publicPath: '/',
    assets: {}
};
const $6e718ebf0a3d5ffc$var$DEFAULT_MODE = (0, $0431B.MODE).HYDRATE;
const $6e718ebf0a3d5ffc$var$DEFAULT_RETRY = 2;
const $6e718ebf0a3d5ffc$var$config = {
    crossOrigin: $6e718ebf0a3d5ffc$var$DEFAULT_CROSS_ORIGIN,
    manifest: $6e718ebf0a3d5ffc$var$DEFAULT_MANIFEST,
    mode: $6e718ebf0a3d5ffc$var$DEFAULT_MODE,
    retry: $6e718ebf0a3d5ffc$var$DEFAULT_RETRY
};
const $6e718ebf0a3d5ffc$export$44487a86467333c3 = ()=>$6e718ebf0a3d5ffc$var$config;
const $6e718ebf0a3d5ffc$export$940a7873bb071df8 = (nextConfig)=>{
    var _nextConfig$crossOrig, _nextConfig$manifest, _nextConfig$mode, _nextConfig$retry;
    $6e718ebf0a3d5ffc$var$config.crossOrigin = (_nextConfig$crossOrig = nextConfig.crossOrigin) != null ? _nextConfig$crossOrig : $6e718ebf0a3d5ffc$var$DEFAULT_CROSS_ORIGIN;
    $6e718ebf0a3d5ffc$var$config.manifest = (_nextConfig$manifest = nextConfig.manifest) != null ? _nextConfig$manifest : $6e718ebf0a3d5ffc$var$DEFAULT_MANIFEST;
    $6e718ebf0a3d5ffc$var$config.mode = (_nextConfig$mode = nextConfig.mode) != null ? _nextConfig$mode : $6e718ebf0a3d5ffc$var$DEFAULT_MODE;
    $6e718ebf0a3d5ffc$var$config.retry = (_nextConfig$retry = nextConfig.retry) != null ? _nextConfig$retry : $6e718ebf0a3d5ffc$var$DEFAULT_RETRY;
};

});
parcelRegister("0431B", function(module, exports) {

$parcel$export(module.exports, "MODE", () => $00c2b881b8fbcee5$export$e48589d9e4824227);
const $00c2b881b8fbcee5$export$e48589d9e4824227 = {
    RENDER: 'RENDER',
    HYDRATE: 'HYDRATE'
};

});


parcelRegister("bh45B", function(module, exports) {

var $PZ2tE = parcelRequire("PZ2tE");

var $9tT5O = parcelRequire("9tT5O");
parcelRequire("1Cn7k");
var $7BvXL = parcelRequire("7BvXL");
var $7j6wR = parcelRequire("7j6wR");

var $fEDkH = parcelRequire("fEDkH");
const $83547451e376d6d0$export$33c5f161e1d4706 = {
    init: (config)=>{
        (0, $9tT5O.setConfig)(config);
        (0, $7BvXL.LISTENERS).length = 0;
        (0, $7j6wR.setCurrent)(0);
        if (!(0, $fEDkH.isNodeEnvironment)()) (0, $PZ2tE.collect)();
    }
};

});
parcelRegister("PZ2tE", function(module, exports) {

$parcel$export(module.exports, "collect", () => $09c41c99821e965e$export$bb44f104e3c54dae);

var $9tT5O = parcelRequire("9tT5O");
var $0431B = parcelRequire("0431B");

var $gRvGe = parcelRequire("gRvGe");

var $cIwb8 = parcelRequire("cIwb8");

var $916oJ = parcelRequire("916oJ");
const $09c41c99821e965e$export$bb44f104e3c54dae = ()=>{
    const markers = document.querySelectorAll('input[data-lazy-begin]');
    const { mode: mode } = (0, $9tT5O.getConfig)();
    for(let i = 0, j = markers.length; i < j; i += 1){
        const el = markers[i];
        const { lazyBegin: lazyBegin } = el.dataset || {};
        const value = mode === (0, $0431B.MODE).RENDER ? (0, $cIwb8.cloneElements)(markers[i], lazyBegin) : (0, $916oJ.refElements)(markers[i], lazyBegin);
        if ((0, $gRvGe.COLLECTED).has(lazyBegin)) (0, $gRvGe.COLLECTED).get(lazyBegin).push(value);
        else (0, $gRvGe.COLLECTED).set(lazyBegin, [
            value
        ]);
    }
};

});
parcelRegister("gRvGe", function(module, exports) {

$parcel$export(module.exports, "PHASE", () => $c46a2b9a383e79ee$export$2cc7a2eaaea7809f);
$parcel$export(module.exports, "COLLECTED", () => $c46a2b9a383e79ee$export$4831ef3968ea94ef);
const $c46a2b9a383e79ee$export$2cc7a2eaaea7809f = {
    PAINT: 0,
    AFTER_PAINT: 1,
    LAZY: 2
};
const $c46a2b9a383e79ee$export$4831ef3968ea94ef = new Map();

});

parcelRegister("cIwb8", function(module, exports) {

$parcel$export(module.exports, "cloneElements", () => $94228e13ffd964de$export$c42217d53a7ebafb);
const $94228e13ffd964de$export$c42217d53a7ebafb = (fromEl, id)=>{
    const fragment = document.createElement('div');
    let el = fromEl;
    while(el = el.nextSibling){
        if (el.dataset && el.dataset.lazyEnd === id) break; // cloneNode is 50% faster than outerHTML/textContent
        fragment.appendChild(el.cloneNode(true));
    }
    return Array.from(fragment.childNodes);
};

});

parcelRegister("916oJ", function(module, exports) {

$parcel$export(module.exports, "refElements", () => $69092b84bd4d8839$export$c69443129766a7fc);
const $69092b84bd4d8839$export$c69443129766a7fc = (fromEl, id)=>{
    const result = [];
    let el = fromEl;
    while(el = el.nextSibling){
        if (el.dataset && el.dataset.lazyEnd === id) break;
        result.push(el);
    }
    return result;
};

});


parcelRegister("1Cn7k", function(module, exports) {

$parcel$export(module.exports, "LazyPhaseContext", () => (parcelRequire("7j6wR")).LazyPhaseContext);
$parcel$export(module.exports, "setCurrent", () => (parcelRequire("7j6wR")).setCurrent);
$parcel$export(module.exports, "useLazyPhase", () => (parcelRequire("7j6wR")).useLazyPhase);
$parcel$export(module.exports, "LISTENERS", () => (parcelRequire("7BvXL")).LISTENERS);

var $7j6wR = parcelRequire("7j6wR");

var $7BvXL = parcelRequire("7BvXL");

var $hLAzE = parcelRequire("hLAzE");

});
parcelRegister("7j6wR", function(module, exports) {

$parcel$export(module.exports, "setCurrent", () => $551f5f4ab1e13682$export$5f80f094fd31fffd);
$parcel$export(module.exports, "LazyPhaseContext", () => $551f5f4ab1e13682$export$5a25eca35e5debcb);
$parcel$export(module.exports, "useLazyPhase", () => $551f5f4ab1e13682$export$1dc361b277327f88);

var $5uXOq = parcelRequire("5uXOq");

var $gRvGe = parcelRequire("gRvGe");

var $7BvXL = parcelRequire("7BvXL");

var $hLAzE = parcelRequire("hLAzE");
let $551f5f4ab1e13682$var$CURRENT_PHASE = (0, $gRvGe.PHASE).PAINT;
const $551f5f4ab1e13682$export$5f80f094fd31fffd = (phase)=>{
    $551f5f4ab1e13682$var$CURRENT_PHASE = phase;
    (0, $7BvXL.LISTENERS).slice(0).forEach((listener)=>listener(phase));
};
const $551f5f4ab1e13682$export$5a25eca35e5debcb = /*#__PURE__*/ (0, $5uXOq.createContext)({
    subscribe: (0, $hLAzE.createSubscribe)((0, $7BvXL.LISTENERS)),
    currentValue: ()=>$551f5f4ab1e13682$var$CURRENT_PHASE,
    api: {
        startNextPhase: ()=>{
            $551f5f4ab1e13682$export$5f80f094fd31fffd((0, $gRvGe.PHASE).AFTER_PAINT);
        },
        resetPhase: ()=>$551f5f4ab1e13682$export$5f80f094fd31fffd((0, $gRvGe.PHASE).PAINT)
    }
});
const $551f5f4ab1e13682$export$1dc361b277327f88 = ()=>{
    const v = (0, $5uXOq.useContext)($551f5f4ab1e13682$export$5a25eca35e5debcb);
    return v.api;
};

});
parcelRegister("7BvXL", function(module, exports) {

$parcel$export(module.exports, "LISTENERS", () => $5894c846af183bf2$export$81b9c458a026d68f);
const $5894c846af183bf2$export$81b9c458a026d68f = [];

});

parcelRegister("hLAzE", function(module, exports) {

$parcel$export(module.exports, "createSubscribe", () => $cef3324da336be99$export$364097d812234b3f);
const $cef3324da336be99$export$364097d812234b3f = (listeners)=>(listener)=>{
        listeners.push(listener);
        return ()=>{
            const index = listeners.indexOf(listener);
            if (index !== -1) listeners.splice(index, 1);
        };
    };

});



parcelRegister("fEDkH", function(module, exports) {

$parcel$export(module.exports, "getExport", () => $b6591a2169faf79a$export$d4c07b1daf44a7f);
$parcel$export(module.exports, "displayNameFromId", () => $b6591a2169faf79a$export$4429f98ef60d2d87);
$parcel$export(module.exports, "isNodeEnvironment", () => $b6591a2169faf79a$export$283635c04a02cc36);
$parcel$export(module.exports, "attrToProp", () => $b6591a2169faf79a$export$62bf630d0de3d781);
$parcel$export(module.exports, "hash", () => (parcelRequire("i0Mqq")).default);

var $i0Mqq = parcelRequire("i0Mqq");
const $b6591a2169faf79a$export$d4c07b1daf44a7f = (m)=>'default' in m ? m.default : m;
const $b6591a2169faf79a$export$4429f98ef60d2d87 = (id)=>{
    const fName = id.split('/').slice(-3).join('/');
    return fName || 'Component';
};
const $b6591a2169faf79a$export$283635c04a02cc36 = ()=>{
    if (typeof window === 'undefined') return true;
    if (window.name === 'nodejs') return true;
    return false;
};
function $b6591a2169faf79a$export$62bf630d0de3d781(props, attr) {
    switch(attr.name){
        case 'style':
            break;
        case 'class':
            props.className = attr.value;
            break;
        case 'crossorigin':
            props.crossOrigin = attr.value;
            break;
        default:
            props[attr.name] = attr.value;
    }
    return props;
}

});
parcelRegister("i0Mqq", function(module, exports) {

$parcel$export(module.exports, "default", () => $d1cdca4fd0ee8fb9$export$2e2bcd8739ae039);
/* eslint-disable */ // murmurhash2 via https://github.com/garycourt/murmurhash-js/blob/master/murmurhash2_gc.js
function $d1cdca4fd0ee8fb9$export$2e2bcd8739ae039(str) {
    var l = str.length, h = l ^ l, i = 0, k;
    while(l >= 4){
        k = str.charCodeAt(i) & 0xff | (str.charCodeAt(++i) & 0xff) << 8 | (str.charCodeAt(++i) & 0xff) << 16 | (str.charCodeAt(++i) & 0xff) << 24;
        k = (k & 0xffff) * 0x5bd1e995 + (((k >>> 16) * 0x5bd1e995 & 0xffff) << 16);
        k ^= k >>> 24;
        k = (k & 0xffff) * 0x5bd1e995 + (((k >>> 16) * 0x5bd1e995 & 0xffff) << 16);
        h = (h & 0xffff) * 0x5bd1e995 + (((h >>> 16) * 0x5bd1e995 & 0xffff) << 16) ^ k;
        l -= 4;
        ++i;
    }
    switch(l){
        case 3:
            h ^= (str.charCodeAt(i + 2) & 0xff) << 16;
        case 2:
            h ^= (str.charCodeAt(i + 1) & 0xff) << 8;
        case 1:
            h ^= str.charCodeAt(i) & 0xff;
            h = (h & 0xffff) * 0x5bd1e995 + (((h >>> 16) * 0x5bd1e995 & 0xffff) << 16);
    }
    h ^= h >>> 13;
    h = (h & 0xffff) * 0x5bd1e995 + (((h >>> 16) * 0x5bd1e995 & 0xffff) << 16);
    h ^= h >>> 15;
    return (h >>> 0).toString(36);
}

});



parcelRegister("8DfXF", function(module, exports) {

$parcel$export(module.exports, "lazyForPaint", () => $648e58dc5a799d99$export$c952e5f94576010e);
$parcel$export(module.exports, "lazyAfterPaint", () => $648e58dc5a799d99$export$291dd592399bdafa);
$parcel$export(module.exports, "lazy", () => $648e58dc5a799d99$export$488013bae63b21da);

var $3aJOa = parcelRequire("3aJOa");

var $9tT5O = parcelRequire("9tT5O");

var $gRvGe = parcelRequire("gRvGe");

var $fEDkH = parcelRequire("fEDkH");
var $i0Mqq = parcelRequire("i0Mqq");

var $9Ww7D = parcelRequire("9Ww7D");

var $eqm16 = parcelRequire("eqm16");

var $3ro9P = parcelRequire("3ro9P");

var $5pJCH = parcelRequire("5pJCH");

var $2LsHW = parcelRequire("2LsHW");

var $gNYzn = parcelRequire("gNYzn");

var $gI8wo = parcelRequire("gI8wo");
function $648e58dc5a799d99$var$_extends() {
    $648e58dc5a799d99$var$_extends = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $648e58dc5a799d99$var$_extends.apply(this, arguments);
}
function $648e58dc5a799d99$var$lazyProxy(_loader, { defer: defer = (0, $gRvGe.PHASE).PAINT, moduleId: moduleId = '', ssr: ssr = true } = {}) {
    const isServer = (0, $fEDkH.isNodeEnvironment)();
    const dataLazyId = (0, $i0Mqq.default)(moduleId);
    const LazyInternal = isServer ? (0, $3ro9P.createComponentServer)({
        dataLazyId: dataLazyId,
        defer: defer,
        loader: _loader,
        moduleId: moduleId,
        ssr: ssr
    }) : (0, $eqm16.createComponentClient)({
        dataLazyId: dataLazyId,
        defer: defer,
        // We separate the preload from the retryable request, as we do not want the preload to contribute to retry
        // attempts, when the the loader fallback is used
        deferred: (0, $5pJCH.createDeferred)({
            loader: ()=>{
                const { retry: maxAttempts } = (0, $9tT5O.getConfig)();
                return (0, $gNYzn.retry)(_loader, {
                    delay: (0, $9Ww7D.RETRY_DELAY),
                    factor: (0, $9Ww7D.RETRY_FACTOR),
                    maxAttempts: maxAttempts
                });
            },
            preload: _loader
        }),
        moduleId: moduleId
    });
    LazyInternal.displayName = `Lazy(${(0, $fEDkH.displayNameFromId)(moduleId)})`;
    /**
   * Allows getting module chunks urls
   */ const getAssetUrls = ()=>{
        const { manifest: manifest } = (0, $9tT5O.getConfig)();
        return (0, $3aJOa.getAssetUrlsFromId)(manifest, moduleId);
    };
    /**
   * Allows imperatively preload/ prefetch the module chunk asset
   */ const preload = (priority)=>{
        const p = priority != null ? priority : defer === (0, $gRvGe.PHASE).PAINT ? (0, $9Ww7D.PRIORITY).HIGH : (0, $9Ww7D.PRIORITY).LOW;
        return (0, $2LsHW.preloadAsset)({
            loader: _loader,
            moduleId: moduleId,
            priority: p
        });
    };
    return Object.assign(LazyInternal, {
        getAssetUrls: getAssetUrls,
        preload: preload
    });
}
const $648e58dc5a799d99$export$93ca5d3f8675ae4c = {
    lazyForPaint: {
        ssr: true,
        defer: (0, $gRvGe.PHASE).PAINT
    },
    lazyAfterPaint: {
        ssr: true,
        defer: (0, $gRvGe.PHASE).AFTER_PAINT
    },
    lazy: {
        ssr: false,
        defer: (0, $gRvGe.PHASE).LAZY
    }
};
function $648e58dc5a799d99$export$c952e5f94576010e(loader, opts) {
    return $648e58dc5a799d99$var$lazyProxy(loader, $648e58dc5a799d99$var$_extends({}, $648e58dc5a799d99$export$93ca5d3f8675ae4c.lazyForPaint, opts || {}));
}
function $648e58dc5a799d99$export$291dd592399bdafa(loader, opts) {
    return $648e58dc5a799d99$var$lazyProxy(loader, $648e58dc5a799d99$var$_extends({}, $648e58dc5a799d99$export$93ca5d3f8675ae4c.lazyAfterPaint, opts || {}));
}
function $648e58dc5a799d99$export$488013bae63b21da(loader, opts) {
    return $648e58dc5a799d99$var$lazyProxy(loader, $648e58dc5a799d99$var$_extends({}, $648e58dc5a799d99$export$93ca5d3f8675ae4c.lazy, opts || {}));
}

});
parcelRegister("3aJOa", function(module, exports) {

$parcel$export(module.exports, "getAssetUrlsFromId", () => $24f5d6cbe7374307$export$303f43e55cf1ef2f);
const $24f5d6cbe7374307$export$303f43e55cf1ef2f = (manifest, id)=>{
    if (!manifest.assets || !manifest.assets[id]) return;
    return manifest.assets[id].map((asset)=>`${manifest.publicPath}${asset}`);
};

});

parcelRegister("9Ww7D", function(module, exports) {

$parcel$export(module.exports, "PRIORITY", () => $73d2729ff937408e$export$bb34f3538ba26c7e);
$parcel$export(module.exports, "RETRY_DELAY", () => $73d2729ff937408e$export$a339266ad71b2447);
$parcel$export(module.exports, "RETRY_FACTOR", () => $73d2729ff937408e$export$ba64c908e55507fe);
const $73d2729ff937408e$export$bb34f3538ba26c7e = {
    HIGH: 0,
    LOW: 2
};
const $73d2729ff937408e$export$a339266ad71b2447 = 300;
const $73d2729ff937408e$export$ba64c908e55507fe = 1;

});

parcelRegister("eqm16", function(module, exports) {

$parcel$export(module.exports, "createComponentClient", () => $a804927df56ebdb2$export$6898b5504b58699a);

var $5uXOq = parcelRequire("5uXOq");

var $9tT5O = parcelRequire("9tT5O");
var $0431B = parcelRequire("0431B");

var $gRvGe = parcelRequire("gRvGe");
parcelRequire("3iU61");
var $hxt6y = parcelRequire("hxt6y");
parcelRequire("1Cn7k");
var $7j6wR = parcelRequire("7j6wR");
parcelRequire("41yqT");
var $7t9v5 = parcelRequire("7t9v5");

var $gI8wo = parcelRequire("gI8wo");

var $b1mtW = parcelRequire("b1mtW");

var $2uJW6 = parcelRequire("2uJW6");

var $lUR7e = parcelRequire("lUR7e");

var $k8XtJ = parcelRequire("k8XtJ");
function $a804927df56ebdb2$export$6898b5504b58699a({ defer: defer, deferred: deferred, dataLazyId: dataLazyId, moduleId: moduleId }) {
    const ResolvedLazy = /*#__PURE__*/ (0, $5uXOq.lazy)(()=>deferred.promise);
    return (props)=>{
        // use a single piece of state to hold info about progress or eventually
        // throw an error. We do change it via direct mutation as re-renders
        // break Suspense in React 18, making it lose hydration state
        const [status, bubbleError] = (0, $5uXOq.useState)(()=>({
                noWait: undefined,
                phase: defer === (0, $gRvGe.PHASE).AFTER_PAINT ? false : true,
                preloaded: defer === (0, $gRvGe.PHASE).AFTER_PAINT ? false : true,
                started: false
            }));
        const profiler = (0, $5uXOq.useContext)((0, $lUR7e.ProfilerContext)).current;
        const load = ()=>{
            if (status.started || !status.phase || !status.noWait) return;
            status.started = true;
            let onResolve;
            if (profiler) {
                const eventInfo = {
                    identifier: moduleId
                };
                onResolve = ()=>{
                    profiler.onLoadComplete(eventInfo);
                };
                profiler.onLoadStart(eventInfo);
            }
            const result = deferred.start().catch((err)=>{
                // Throw the error within the component lifecycle
                // refer to https://github.com/facebook/react/issues/11409
                bubbleError(()=>{
                    throw (0, $gI8wo.createLoaderError)(err);
                });
            });
            if (onResolve) result.then(onResolve);
        }; // Subscribe to LazyWait context, triggering load when until is true
        (0, $k8XtJ.useSubscription)({
            context: (0, $hxt6y.WaitContext),
            load: load,
            onValue: (v)=>status.noWait = v === 1
        });
        if (defer === (0, $gRvGe.PHASE).AFTER_PAINT) // Subscribe to LazyPhase context, triggering load when own phase starts
        (0, $k8XtJ.useSubscription)({
            context: (0, $7j6wR.LazyPhaseContext),
            load: load,
            onValue: (v)=>status.phase = v >= defer
        });
        const { setFallback: setFallback } = (0, $5uXOq.useContext)((0, $7t9v5.LazySuspenseContext));
        (0, $5uXOq.useMemo)(()=>{
            // find SSR content (or fallbacks) wrapped in inputs based on lazyId
            const content = ((0, $gRvGe.COLLECTED).get(dataLazyId) || []).shift();
            if (!content) return; // override Suspense fallback with magic input wrappers
            const component = (0, $9tT5O.getConfig)().mode === (0, $0431B.MODE).RENDER ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $b1mtW.PlaceholderFallbackRender), {
                id: dataLazyId,
                content: content
            }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $2uJW6.PlaceholderFallbackHydrate), {
                id: dataLazyId,
                content: content
            });
            setFallback(component);
        }, [
            setFallback
        ]);
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(ResolvedLazy, props);
    };
}

});
parcelRegister("3iU61", function(module, exports) {

$parcel$export(module.exports, "WaitContext", () => (parcelRequire("hxt6y")).WaitContext);

var $hxt6y = parcelRequire("hxt6y");

var $8gCAq = parcelRequire("8gCAq");

});
parcelRegister("hxt6y", function(module, exports) {

$parcel$export(module.exports, "WaitContext", () => $cc4c1850a13fcdaa$export$9ba3fe09d15de47b);

var $5uXOq = parcelRequire("5uXOq");

var $3Sq3c = parcelRequire("3Sq3c");
const $cc4c1850a13fcdaa$export$9ba3fe09d15de47b = /*#__PURE__*/ (0, $5uXOq.createContext)({
    subscribe: ()=>(0, $3Sq3c.noopCleanup),
    currentValue: ()=>1
});

});
parcelRegister("3Sq3c", function(module, exports) {

$parcel$export(module.exports, "noopCleanup", () => $2d2a9f5ddab5681f$export$276c7dbda7675aec);
const $2d2a9f5ddab5681f$export$276c7dbda7675aec = ()=>{};

});


parcelRegister("8gCAq", function(module, exports) {

var $5uXOq = parcelRequire("5uXOq");

var $hxt6y = parcelRequire("hxt6y");
const $604dbfd3e71469c9$export$7bf6cf03fd32cddb = ({ until: until, children: children })=>{
    const closestWait = (0, $5uXOq.useContext)((0, $hxt6y.WaitContext));
    const value = (0, $5uXOq.useRef)(until && closestWait.currentValue() ? 1 : 0);
    const subscribers = (0, $5uXOq.useRef)(new Set());
    const api = (0, $5uXOq.useRef)({
        subscribe: (subscriber)=>{
            subscribers.current.add(subscriber);
            return ()=>{
                subscribers.current.delete(subscriber);
            };
        },
        currentValue: ()=>value.current
    });
    (0, $5uXOq.useEffect)(()=>{
        // Notify subscribers when until prop or closest until value changes
        const notify = ()=>{
            value.current = closestWait.currentValue() && until ? 1 : 0;
            subscribers.current.forEach((subscriber)=>subscriber());
        };
        notify();
        return closestWait.subscribe(notify);
    }, [
        closestWait,
        until
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $hxt6y.WaitContext).Provider, {
        value: api.current
    }, children);
};

});


parcelRegister("41yqT", function(module, exports) {

$parcel$export(module.exports, "LazySuspense", () => (parcelRequire("ihijj")).LazySuspense);
$parcel$export(module.exports, "LazySuspenseContext", () => (parcelRequire("7t9v5")).LazySuspenseContext);

var $ihijj = parcelRequire("ihijj");

var $7t9v5 = parcelRequire("7t9v5");

});
parcelRegister("ihijj", function(module, exports) {

$parcel$export(module.exports, "LazySuspense", () => $d4e8049b2be3a01c$export$256c542058532d6f);

var $5uXOq = parcelRequire("5uXOq");

var $fEDkH = parcelRequire("fEDkH");

var $7t9v5 = parcelRequire("7t9v5");
class $d4e8049b2be3a01c$export$256c542058532d6f extends (0, $5uXOq.Component) {
    constructor(props){
        super(props);
        this.state = {
            // Used on server to render fallback down the tree
            fallback: this.props.fallback,
            // Used on client to replace fallback with magic input
            setFallback: (fallback)=>{
                if (this.hydrationFallback === fallback) return;
                this.hydrationFallback = fallback; // Schedule an update so we force switch from the sibling tree
                // back to the suspense boundary
                if (this.mounted) this.forceUpdate();
            },
            name: this.props.name
        };
        this.hydrationFallback = null;
        this.mounted = false;
        this.DynamicFallback = ({ children: children, outsideSuspense: outsideSuspense })=>{
            // eslint-disable-next-line react-hooks/rules-of-hooks
            (0, $5uXOq.useLayoutEffect)(()=>{
                return ()=>{
                    // the effect cleanup is called by the Suspense boundary itself
                    // when both Lazy AND the eventual promises thrown are done
                    // so Suspense will re-render with actual content and we remove
                    // the hydration fallback at the same time
                    if (!outsideSuspense) this.state.setFallback(null);
                };
            }, [
                outsideSuspense
            ]);
            return outsideSuspense ? children(this.hydrationFallback ? this.hydrationFallback : null) : children(this.hydrationFallback ? null : this.props.fallback);
        };
        this.DynamicFallback.displayName = 'DynamicFallback';
    }
    componentDidMount() {
        this.mounted = true;
    }
    renderFallback(outsideSuspense) {
        const { DynamicFallback: DynamicFallback } = this; // Use render prop component to allow switch to hydration fallback
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(DynamicFallback, {
            outsideSuspense: outsideSuspense
        }, (fallback)=>fallback);
    }
    renderServer() {
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7t9v5.LazySuspenseContext).Provider, {
            value: this.state
        }, this.props.children);
    }
    renderClient() {
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7t9v5.LazySuspenseContext).Provider, {
            value: this.state
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5uXOq.Suspense), {
            fallback: this.renderFallback(false)
        }, this.props.children), (!this.mounted || this.hydrationFallback) && this.renderFallback(true));
    }
    render() {
        return (0, $fEDkH.isNodeEnvironment)() ? this.renderServer() : this.renderClient();
    }
}

});
parcelRegister("7t9v5", function(module, exports) {

$parcel$export(module.exports, "LazySuspenseContext", () => $57029c6f61e78061$export$c33990e84065970c);

var $5uXOq = parcelRequire("5uXOq");
const $57029c6f61e78061$export$c33990e84065970c = /*#__PURE__*/ (0, $5uXOq.createContext)({
    fallback: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5uXOq.Fragment), null),
    setFallback: ()=>{
        console.warn('Missing <LooselySuspense /> boundary');
    }
});

});



parcelRegister("gI8wo", function(module, exports) {

$parcel$export(module.exports, "createLoaderError", () => $c2a75d9d2b1d4ac6$export$c73a6a6f0bf7d425);
const $c2a75d9d2b1d4ac6$export$6aa69c1258005366 = Symbol.for('react-loosely-lazy/loader-error');
const $c2a75d9d2b1d4ac6$export$c73a6a6f0bf7d425 = (error)=>{
    if (typeof error === 'object') return Object.assign(error, {
        [$c2a75d9d2b1d4ac6$export$6aa69c1258005366]: true
    });
    return error;
};
const $c2a75d9d2b1d4ac6$export$16a03aca4a3508b4 = (error)=>Object.getOwnPropertySymbols(error).includes($c2a75d9d2b1d4ac6$export$6aa69c1258005366);

});

parcelRegister("b1mtW", function(module, exports) {

$parcel$export(module.exports, "PlaceholderFallbackRender", () => $80613a2b6be8c4b1$export$d55db778a3e1446b);

var $5uXOq = parcelRequire("5uXOq");

var $lUR7e = parcelRequire("lUR7e");
parcelRequire("3iU61");
var $hxt6y = parcelRequire("hxt6y");
parcelRequire("41yqT");
var $7t9v5 = parcelRequire("7t9v5");
function $80613a2b6be8c4b1$var$isLinkPrefetch(el) {
    return el.tagName === 'LINK' && el.rel === 'prefetch';
}
const $80613a2b6be8c4b1$var$usePlaceholderRender = (resolveId, content)=>{
    const hydrationRef = (0, $5uXOq.useRef)(null);
    const { current: ssrDomNodes } = (0, $5uXOq.useRef)(content || []);
    const profilerContext = (0, $5uXOq.useContext)((0, $lUR7e.ProfilerContext)).current;
    const waitContext = (0, $5uXOq.useContext)((0, $hxt6y.WaitContext));
    const suspenseContext = (0, $5uXOq.useContext)((0, $7t9v5.LazySuspenseContext));
    (0, $5uXOq.useLayoutEffect)(()=>{
        const element = hydrationRef.current;
        const { parentNode: parentNode } = element || {};
        profilerContext === null || profilerContext.placeholderFallBackMounted(resolveId, suspenseContext.name, !waitContext.currentValue());
        if (parentNode && !parentNode.contains(ssrDomNodes[0])) ssrDomNodes.reverse().forEach((node)=>{
            // this fixes an issue with Chrome that re-triggers and cancels prefetch
            // when node is appended again, making network panel quite noisy
            if ($80613a2b6be8c4b1$var$isLinkPrefetch(node)) node.rel = '';
            parentNode.insertBefore(node, element.nextSibling);
        });
        return ()=>{
            profilerContext === null || profilerContext.placeholderFallBackUnmounted(resolveId, suspenseContext.name, !waitContext.currentValue());
            ssrDomNodes.forEach((node)=>{
                var _node$parentNode;
                return (_node$parentNode = node.parentNode) == null ? void 0 : _node$parentNode.removeChild(node);
            });
        }; // [hydrationRef.current, ssrDomNodes] are expected to be stable
    // with the second one never changing by design and the first one changing after first render
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    return hydrationRef;
};
const $80613a2b6be8c4b1$export$d55db778a3e1446b = ({ id: id, content: content })=>{
    const placeholderRef = $80613a2b6be8c4b1$var$usePlaceholderRender(id, content);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("input", {
        type: "hidden",
        "data-lazy-begin": id,
        ref: placeholderRef
    });
};

});
parcelRegister("lUR7e", function(module, exports) {

$parcel$export(module.exports, "GlobalReactLooselyLazyProfiler", () => $ff4807977d1ff541$export$e2d53c0cbedd2710);
$parcel$export(module.exports, "ProfilerContext", () => $ff4807977d1ff541$export$8146ab57a3f7a7cb);

var $5uXOq = parcelRequire("5uXOq");
const $ff4807977d1ff541$export$e2d53c0cbedd2710 = {
    current: null
};
const $ff4807977d1ff541$export$8146ab57a3f7a7cb = /*#__PURE__*/ (0, $5uXOq.createContext)($ff4807977d1ff541$export$e2d53c0cbedd2710);

});


parcelRegister("2uJW6", function(module, exports) {

$parcel$export(module.exports, "PlaceholderFallbackHydrate", () => $1d1204150993c3dd$export$ca5b8fbc835d95e4);

var $5uXOq = parcelRequire("5uXOq");

var $fEDkH = parcelRequire("fEDkH");
function $1d1204150993c3dd$var$_extends() {
    $1d1204150993c3dd$var$_extends = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $1d1204150993c3dd$var$_extends.apply(this, arguments);
}
const $1d1204150993c3dd$export$ca5b8fbc835d95e4 = ({ id: id, content: content })=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("input", {
        type: "hidden",
        "data-lazy-begin": id
    }), content.map((el, i)=>{
        const { tagName: tagName = '', childNodes: childNodes = [], attributes: attributes = [] } = el;
        const props = Array.from(attributes).reduce((0, $fEDkH.attrToProp), {
            key: String(i)
        }); // text node
        if (!tagName) return /*#__PURE__*/ (0, $5uXOq.createElement)((0, $5uXOq.Fragment), props, el.textContent); // childless tag
        if (!childNodes.length) return /*#__PURE__*/ (0, $5uXOq.createElement)(tagName.toLowerCase(), props); // tag with content
        return /*#__PURE__*/ (0, $5uXOq.createElement)(tagName.toLowerCase(), $1d1204150993c3dd$var$_extends({}, props, {
            dangerouslySetInnerHTML: {
                __html: ''
            },
            suppressHydrationWarning: true
        }));
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("input", {
        type: "hidden",
        "data-lazy-end": id
    }));
};

});

parcelRegister("k8XtJ", function(module, exports) {

$parcel$export(module.exports, "useSubscription", () => $eaa2b1340dc6db34$export$368b4214baeb914c);

var $5uXOq = parcelRequire("5uXOq");
function $eaa2b1340dc6db34$export$368b4214baeb914c({ context: context, load: load, onValue: onValue }) {
    const { subscribe: subscribe, currentValue: currentValue } = (0, $5uXOq.useContext)(context);
    (0, $5uXOq.useMemo)(()=>{
        let unsubscribe = null;
        const check = ()=>{
            const done = onValue(currentValue());
            if (done) load();
            if (done && unsubscribe) unsubscribe();
            return done;
        };
        unsubscribe = !check() ? subscribe(check) : null; // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
}

});


parcelRegister("3ro9P", function(module, exports) {

$parcel$export(module.exports, "createComponentServer", () => $2816a1dec93a8449$export$eb2e4b04351cdd9e);

var $3aJOa = parcelRequire("3aJOa");

var $5uXOq = parcelRequire("5uXOq");

var $9tT5O = parcelRequire("9tT5O");

var $gRvGe = parcelRequire("gRvGe");
parcelRequire("41yqT");
var $7t9v5 = parcelRequire("7t9v5");

var $fEDkH = parcelRequire("fEDkH");

var $gI8wo = parcelRequire("gI8wo");
function $2816a1dec93a8449$var$load(moduleId, loader) {
    try {
        return (0, $fEDkH.getExport)(loader());
    } catch (err) {
        throw (0, $gI8wo.createLoaderError)(err);
    }
}
function $2816a1dec93a8449$export$eb2e4b04351cdd9e({ dataLazyId: dataLazyId, defer: defer, loader: loader, moduleId: moduleId, ssr: ssr }) {
    return (props)=>{
        var _getAssetUrlsFromId;
        const Resolved = ssr ? $2816a1dec93a8449$var$load(moduleId, loader) : null;
        const { fallback: fallback } = (0, $5uXOq.useContext)((0, $7t9v5.LazySuspenseContext));
        const { crossOrigin: crossOrigin, manifest: manifest } = (0, $9tT5O.getConfig)();
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("input", {
            type: "hidden",
            "data-lazy-begin": dataLazyId
        }), defer !== (0, $gRvGe.PHASE).LAZY && ((_getAssetUrlsFromId = (0, $3aJOa.getAssetUrlsFromId)(manifest, moduleId)) == null ? void 0 : _getAssetUrlsFromId.map((url)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("link", {
                key: url,
                rel: defer === (0, $gRvGe.PHASE).PAINT ? 'preload' : 'prefetch',
                href: url,
                crossOrigin: crossOrigin,
                as: "script"
            }))), Resolved ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(Resolved, props) : fallback, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("input", {
            type: "hidden",
            "data-lazy-end": dataLazyId
        }));
    };
}

});

parcelRegister("5pJCH", function(module, exports) {

$parcel$export(module.exports, "createDeferred", () => $3f12ad617063b5b1$export$e673efccd97e4223);
const $3f12ad617063b5b1$export$e673efccd97e4223 = ({ loader: loader, preload: preload })=>{
    let resolve;
    const deferred = {
        promise: new Promise((res)=>{
            resolve = (m)=>{
                let withDefault;
                deferred.result = m;
                if (!m.default) withDefault = {
                    default: m
                };
                res(withDefault ? withDefault : m);
            };
        }),
        result: undefined,
        preload: function(_preload) {
            function preload() {
                return _preload.apply(this, arguments);
            }
            preload.toString = function() {
                return _preload.toString();
            };
            return preload;
        }(()=>{
            if (deferred.result) return;
            preload().then((m)=>{
                deferred.result = m;
            }).catch(()=>{});
        }),
        start: ()=>{
            if (deferred.result) {
                resolve(deferred.result);
                return Promise.resolve();
            } // Make a new loader request when none have started or resolved yet
            return loader().then(resolve);
        }
    };
    return deferred;
};

});

parcelRegister("2LsHW", function(module, exports) {

$parcel$export(module.exports, "preloadAsset", () => $20363d4ed5cd2af1$export$25bad4aa00c45355);

var $3aJOa = parcelRequire("3aJOa");

var $3Sq3c = parcelRequire("3Sq3c");

var $9tT5O = parcelRequire("9tT5O");

var $fEDkH = parcelRequire("fEDkH");

var $9Ww7D = parcelRequire("9Ww7D");

var $6MxP6 = parcelRequire("6MxP6");

var $lUR7e = parcelRequire("lUR7e");
function $20363d4ed5cd2af1$export$3af04dbcb01bad4d({ moduleId: moduleId, rel: rel }) {
    const { manifest: manifest } = (0, $9tT5O.getConfig)();
    const assets = (0, $3aJOa.getAssetUrlsFromId)(manifest, moduleId);
    if (!assets) throw new Error('Unsupported preload strategy');
    const cleanupLinkTags = assets.map((url)=>(0, $6MxP6.insertLinkTag)(url, rel));
    return ()=>{
        for (const cleanupLinkTag of cleanupLinkTags)cleanupLinkTag();
    };
}
const $20363d4ed5cd2af1$var$fakePromise = {
    then: ()=>$20363d4ed5cd2af1$var$fakePromise,
    catch: ()=>$20363d4ed5cd2af1$var$fakePromise,
    finally: ()=>$20363d4ed5cd2af1$var$fakePromise
};
function $20363d4ed5cd2af1$export$1046fd6a49d5e7a({ loader: loader, rel: rel }) {
    if (typeof __webpack_require__ === 'undefined' || typeof __webpack_get_script_filename__ === 'undefined') throw new Error('Unsupported preload strategy'); // Replace requireEnsure to create link tags instead of scripts
    const requireEnsure = __webpack_require__.e;
    const cleanupLinkTags = [];
    __webpack_require__.e = function requirePreload(chunkId) {
        const href = __webpack_get_script_filename__(chunkId);
        cleanupLinkTags.push((0, $6MxP6.insertLinkTag)(href, rel));
        return $20363d4ed5cd2af1$var$fakePromise;
    };
    try {
        loader();
    } catch (err) {} // Restore real webpack require ensure
    __webpack_require__.e = requireEnsure;
    return ()=>{
        for (const cleanupLinkTag of cleanupLinkTags)cleanupLinkTag();
    };
}
function $20363d4ed5cd2af1$export$eb05139fa4dcf992({ loader: loader }) {
    loader();
    return 0, $3Sq3c.noopCleanup;
}
function $20363d4ed5cd2af1$export$25bad4aa00c45355({ loader: loader, moduleId: moduleId, priority: priority }) {
    var _GlobalReactLooselyLa;
    if ((0, $fEDkH.isNodeEnvironment)()) return 0, $3Sq3c.noopCleanup;
    (_GlobalReactLooselyLa = (0, $lUR7e.GlobalReactLooselyLazyProfiler).current) == null || _GlobalReactLooselyLa.onPreload(moduleId, priority);
    const rel = priority === (0, $9Ww7D.PRIORITY).HIGH ? 'preload' : 'prefetch';
    const preloadStrategies = [
        $20363d4ed5cd2af1$export$3af04dbcb01bad4d,
        $20363d4ed5cd2af1$export$1046fd6a49d5e7a,
        $20363d4ed5cd2af1$export$eb05139fa4dcf992
    ];
    for (const strategy of preloadStrategies)try {
        return strategy({
            loader: loader,
            moduleId: moduleId,
            rel: rel
        });
    } catch (_) {}
    return 0, $3Sq3c.noopCleanup;
}

});
parcelRegister("6MxP6", function(module, exports) {

$parcel$export(module.exports, "insertLinkTag", () => $4f01765b3d259822$export$6610512821c8a4ce);

var $lUR7e = parcelRequire("lUR7e");

var $3Sq3c = parcelRequire("3Sq3c");

var $9tT5O = parcelRequire("9tT5O");
function $4f01765b3d259822$export$6610512821c8a4ce(href, rel) {
    var _document$head;
    // Skip if already preloaded, prefetched, or loaded
    if (document.querySelector(`link[href="${href}"]`) || document.querySelector(`script[src="${href}"]`)) return 0, $3Sq3c.noopCleanup;
    const { crossOrigin: crossOrigin } = (0, $9tT5O.getConfig)();
    const link = document.createElement('link');
    link.rel = rel;
    link.as = 'script';
    if (crossOrigin) link.crossOrigin = crossOrigin;
    link.href = href;
    const profiler = (0, $lUR7e.GlobalReactLooselyLazyProfiler).current;
    let removableListener = null;
    if (profiler) {
        const eventInfo = {
            identifier: href
        };
        const listener = ()=>{
            link.removeEventListener('onload', listener);
            removableListener = null;
            profiler.onLoadComplete(eventInfo);
        };
        link.addEventListener('onload', listener);
        removableListener = listener;
        profiler.onLoadStart(eventInfo);
    }
    (_document$head = document.head) == null || _document$head.appendChild(link);
    return ()=>{
        // Remove the link if it is still in the document head
        if (link.parentNode === document.head) {
            var _document$head2;
            (_document$head2 = document.head) == null || _document$head2.removeChild(link);
        }
        if (removableListener) link.removeEventListener('onload', removableListener);
    };
}

});


parcelRegister("gNYzn", function(module, exports) {

$parcel$export(module.exports, "retry", () => $032842ea9e8e4a24$export$9369b12211e1fce4);
const $032842ea9e8e4a24$var$calculateDelay = (context, policy)=>{
    const { attempt: attempt } = context;
    const { delay: delay, factor: factor } = policy;
    const retryAttempt = attempt - 1; // Do not use a delay on the first retry, or when the configured delay is 0
    if (retryAttempt === 1 || delay === 0) return 0;
     // Linear factor, like: https://github.com/Polly-Contrib/Polly.Contrib.WaitAndRetry#wait-and-retry-with-linear-back-off
    const add = factor * delay;
    return delay + add * (retryAttempt - 2);
};
const $032842ea9e8e4a24$var$sleep = (delay)=>new Promise((resolve)=>setTimeout(resolve, delay));
const $032842ea9e8e4a24$var$getPolicy = (configuration)=>{
    var _configuration$delay, _configuration$factor, _configuration$maxAtt;
    return {
        delay: Math.max(0, (_configuration$delay = configuration.delay) != null ? _configuration$delay : 0),
        factor: Math.max(0, (_configuration$factor = configuration.factor) != null ? _configuration$factor : 0),
        maxAttempts: Math.max(0, (_configuration$maxAtt = configuration.maxAttempts) != null ? _configuration$maxAtt : 0)
    };
};
function $032842ea9e8e4a24$export$9369b12211e1fce4(retryable, policyConfiguration = {}) {
    const policy = $032842ea9e8e4a24$var$getPolicy(policyConfiguration);
    const { maxAttempts: maxAttempts } = policy;
    const context = {
        attempt: 1,
        attemptsRemaining: maxAttempts
    };
    const onError = async (err)=>{
        if (context.attemptsRemaining === 0) throw err;
        context.attempt += 1;
        context.attemptsRemaining -= 1;
        const delay = $032842ea9e8e4a24$var$calculateDelay(context, policy);
        if (delay) await $032842ea9e8e4a24$var$sleep(delay);
        return retryable().catch(onError);
    };
    return retryable().catch(onError);
}

});



parcelRegister("ihfgn", function(module, exports) {

$parcel$export(module.exports, "MenuGroupPeople", () => $96009d3d2861caf5$export$c521b8e86241ef89);

var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $koVbs = parcelRequire("koVbs");

var $cb25w = parcelRequire("cb25w");

var $3Z96c = parcelRequire("3Z96c");

var $fWjEu = parcelRequire("fWjEu");

var $3ys0B = parcelRequire("3ys0B");

var $hEofo = parcelRequire("hEofo");

var $dS8wI = parcelRequire("dS8wI");

var $c5ORg = parcelRequire("c5ORg");
parcelRequire("9iwCj");
var $7kP9q = parcelRequire("7kP9q");
var $9iwCj = parcelRequire("9iwCj");

var $ckanx = parcelRequire("ckanx");

var $cf0l8 = parcelRequire("cf0l8");

var $c2P5e = parcelRequire("c2P5e");
const $96009d3d2861caf5$export$2e63129145f0c868 = (props)=>{
    const intl = (0, $koVbs.default)();
    const { users: users = [], createAnalyticsEvent: createAnalyticsEvent, isLoading: isLoading, remoteConfig: remoteConfig } = props;
    const { testId: testId, product: product, onClickedItem: onClickedItem = (0, $dS8wI.VOID_FUNC), pushRoute: pushRoute = (0, $dS8wI.VOID_FUNC), togglePeopleMenu: togglePeopleMenu = (0, $dS8wI.VOID_FUNC) } = (0, $5uXOq.useContext)((0, $hEofo.PeopleMenuContext));
    const handleClickOnPeople = (0, $5uXOq.useCallback)((id)=>(event)=>{
            const isLeftClick = !(0, $c5ORg.isModifiedEvent)(event);
            (0, $9iwCj.triggerAnalyticsForClickOnPeople)(createAnalyticsEvent, isLeftClick);
            onClickedItem(id, 'people', event);
            if (isLeftClick) {
                const peopleProfilePage = (0, $3ys0B.getPeopleProfilePage)(remoteConfig.resources, id, product, (0, $7kP9q.AnalyticsActionSubject).PEOPLE_MENU);
                pushRoute(peopleProfilePage);
                event.preventDefault();
            }
            togglePeopleMenu(false);
        }, [
        createAnalyticsEvent,
        onClickedItem,
        product,
        pushRoute,
        remoteConfig.resources,
        togglePeopleMenu
    ]);
    if (!remoteConfig.sections.collaborators.enabled) return null;
    return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $cf0l8.MenuGroupSection), {
        title: remoteConfig.sections.collaborators.label ?? intl.formatMessage((0, $ckanx.messages).yourCollab),
        testId: `${testId}-people-section`,
        isLoading: isLoading,
        isEmpty: users.length === 0,
        sectionType: 'user',
        maxItems: remoteConfig.sections.collaborators.maxItems,
        children: users.slice(0, remoteConfig.sections.collaborators.maxItems).map((user)=>/*#__PURE__*/ (0, $2OMIu.jsx)((0, $3Z96c.default), {
                iconBefore: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $c2P5e.ImgIcon), {
                    src: user.avatarUrl,
                    alt: ""
                }),
                testId: `${testId}-people-item`,
                href: (0, $3ys0B.getPeopleProfilePage)(remoteConfig.resources, user.id, product, (0, $7kP9q.AnalyticsActionSubject).PEOPLE_MENU),
                onClick: handleClickOnPeople(user.id),
                children: user.fullName
            }, user.id))
    });
};
const $96009d3d2861caf5$export$c521b8e86241ef89 = (0, $cb25w.default)()((0, $fWjEu.withMandatoryPeopleMenuConfiguration)($96009d3d2861caf5$export$2e63129145f0c868));

});
parcelRegister("fWjEu", function(module, exports) {

$parcel$export(module.exports, "usePeopleAndTeamsPeopleMenuConfiguration", () => $8887fdd411539e99$export$c616dd7f2557d148);
$parcel$export(module.exports, "withMandatoryPeopleMenuConfiguration", () => $8887fdd411539e99$export$aecb6ab9d1724228);

var $0Wtmq = parcelRequire("0Wtmq");
var $lQhhz = parcelRequire("lQhhz");
const $8887fdd411539e99$var$KEY = 'people-menu';
const $8887fdd411539e99$export$c616dd7f2557d148 = ()=>{
    const configuration = (0, $0Wtmq.usePeopleAndTeamsConfigurationContext)();
    return configuration[$8887fdd411539e99$var$KEY];
};
const $8887fdd411539e99$export$aecb6ab9d1724228 = (WrappedComponent)=>(0, $lQhhz.withMandatoryPeopleAndTeamsConfiguration)(WrappedComponent, $8887fdd411539e99$var$KEY);

});
parcelRegister("lQhhz", function(module, exports) {

$parcel$export(module.exports, "withMandatoryPeopleAndTeamsConfiguration", () => $d501cd0f5e905518$export$aead0eac38c797a5);

var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $0Wtmq = parcelRequire("0Wtmq");
function $d501cd0f5e905518$var$isMandatoryPeopleAndTeamsConfiguration(context) {
    return Boolean(context);
}
const $d501cd0f5e905518$export$aead0eac38c797a5 = (WrappedComponent, key)=>(props)=>{
        const remoteConfig = (0, $0Wtmq.usePeopleAndTeamsConfigurationContext)();
        if (!remoteConfig) return null;
        const keyedConfig = remoteConfig[key];
        if (!$d501cd0f5e905518$var$isMandatoryPeopleAndTeamsConfiguration(keyedConfig)) return null;
        return /*#__PURE__*/ (0, $2OMIu.jsx)(WrappedComponent, {
            remoteConfig: keyedConfig,
            ...props
        });
    };

});


parcelRegister("c5ORg", function(module, exports) {

$parcel$export(module.exports, "isModifiedEvent", () => $5872d4f5b124a4bb$export$642c6f14f6d4bbd5);
const $5872d4f5b124a4bb$export$642c6f14f6d4bbd5 = (event)=>!!(event.metaKey || event.altKey || event.ctrlKey || event.shiftKey);

});

parcelRegister("ckanx", function(module, exports) {

$parcel$export(module.exports, "messages", () => $dce0e5ac2ce66eb1$export$defe85febe8b728c);

var $7VHMR = parcelRequire("7VHMR");
const $dce0e5ac2ce66eb1$var$PREFIX = 'ptc.pm';
const $dce0e5ac2ce66eb1$export$defe85febe8b728c = (0, $7VHMR.defineMessages)({
    yourCollab: {
        id: `${$dce0e5ac2ce66eb1$var$PREFIX}.collaborators.title`,
        defaultMessage: 'Your Collaborators',
        description: 'A title of Your-Collaborators section in People Menu dropdown'
    },
    yourTeams: {
        id: `${$dce0e5ac2ce66eb1$var$PREFIX}.your-teams.title`,
        defaultMessage: 'Your Teams',
        description: 'A title of a Your-Teams section in People Menu dropdown'
    },
    viewYourProfile: {
        id: `${$dce0e5ac2ce66eb1$var$PREFIX}.view-your-profile`,
        defaultMessage: 'View your profile',
        description: 'A link in People Menu. Clicking on it will navigate the user to their personal profile'
    },
    errorHeading: {
        id: `${$dce0e5ac2ce66eb1$var$PREFIX}.error-heading`,
        defaultMessage: "Something\u2019s gone wrong",
        description: 'Heading of the error screen which is shown when an unknown error happens in the People Menu. Usually due to failed network requests.'
    },
    errorText: {
        id: `${$dce0e5ac2ce66eb1$var$PREFIX}.error-text`,
        defaultMessage: "We keep track of these errors, but feel free to contact us if refreshing doesn\u2019t fix things",
        description: 'Text that is displayed when an unknown error happens in the People Menu.'
    },
    errorImageAltText: {
        id: `${$dce0e5ac2ce66eb1$var$PREFIX}.error-image-alt-text`,
        defaultMessage: 'A broken robot and a number of people busy fixing it.',
        description: 'Text displayed as alt text when an error occurs in the People Menu'
    },
    people: {
        id: `${$dce0e5ac2ce66eb1$var$PREFIX}.people`,
        defaultMessage: 'People',
        description: 'A default title of primary People menu'
    },
    teams: {
        id: `${$dce0e5ac2ce66eb1$var$PREFIX}.teams`,
        defaultMessage: 'Teams',
        description: 'A new default title of primary People menu'
    },
    numMembers: {
        id: `${$dce0e5ac2ce66eb1$var$PREFIX}.num-members`,
        defaultMessage: `{memberCount, plural,
    one {# member}
    other {# members}
}`,
        description: 'Subtext of the number of members belonging to a team'
    }
});

});

parcelRegister("cf0l8", function(module, exports) {

$parcel$export(module.exports, "MenuGroupSection", () => $69942e80fb1d50dd$export$33b4adfb29dd0d95);

var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $9UCCQ = parcelRequire("9UCCQ");
var $eaGfl = parcelRequire("eaGfl");

var $hEofo = parcelRequire("hEofo");

var $9hDzh = parcelRequire("9hDzh");
const $69942e80fb1d50dd$export$33b4adfb29dd0d95 = ({ title: title, isEmpty: isEmpty, isLoading: isLoading, children: children, testId: testId, maxItems: maxItems, sectionType: sectionType })=>{
    const { isSectionList: isSectionList = false } = (0, $5uXOq.useContext)((0, $hEofo.PeopleMenuContext));
    if (!isLoading && isEmpty) return null;
    return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $9UCCQ.default), {
        // title is undefined if we are loading as we show the heading skeleton below
        title: isLoading ? undefined : title,
        testId: testId,
        isList: isSectionList,
        children: isLoading ? /*#__PURE__*/ (0, $2OMIu.jsxs)((0, $2OMIu.Fragment), {
            children: [
                /*#__PURE__*/ (0, $2OMIu.jsx)((0, $eaGfl.default), {
                    testId: `${sectionType}-skeleton-heading`
                }),
                Array(maxItems).fill(undefined).map((_, index)=>/*#__PURE__*/ (0, $2OMIu.jsx)((0, $9hDzh.default), {}, `${sectionType}-${index}`))
            ]
        }) : children
    });
};

});
parcelRegister("9hDzh", function(module, exports) {

$parcel$export(module.exports, "default", () => $7c4742eecef207b9$export$2e2bcd8739ae039);
/* LoadingSkeletonItem.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $iwwXK = parcelRequire("iwwXK");
const $7c4742eecef207b9$var$styles = {
    skeletonItem: "_mf8oze3t _7x0autpp _1xp3zwfg _da2vzwfg"
};
function $7c4742eecef207b9$export$2e2bcd8739ae039() {
    return /*#__PURE__*/ (0, $2OMIu.jsx)("div", {
        className: (0, $bwpsq.default)([
            $7c4742eecef207b9$var$styles.skeletonItem
        ]),
        children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $iwwXK.default), {
            hasAvatar: true,
            testId: "people-menu-skeleton-item"
        })
    });
}

});


parcelRegister("c2P5e", function(module, exports) {

$parcel$export(module.exports, "MAX_POPUP_WIDTH", () => $13590cfc2fac79d5$export$b0396be60c0e9152);
$parcel$export(module.exports, "MIN_POPUP_WIDTH", () => $13590cfc2fac79d5$export$3f133812f81dfa49);
$parcel$export(module.exports, "MAX_POPUP_HEIGHT", () => $13590cfc2fac79d5$export$94aaf6acd960c412);
$parcel$export(module.exports, "ImgIcon", () => $13590cfc2fac79d5$export$804b6389edcac2c2);
$parcel$export(module.exports, "Buggy", () => $13590cfc2fac79d5$export$6b52db8960fbef38);
$parcel$export(module.exports, "fireRenderPeopleNavMenuFail", () => $13590cfc2fac79d5$export$5884f4bd467a603a);

var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $VSDnB = parcelRequire("VSDnB");

var $fwSAz = parcelRequire("fwSAz");

var $v6X2P = parcelRequire("v6X2P");

var $6IwYZ = parcelRequire("6IwYZ");
const $13590cfc2fac79d5$export$91a15f1424900d33 = 32;
const $13590cfc2fac79d5$export$b0396be60c0e9152 = 480;
const $13590cfc2fac79d5$export$3f133812f81dfa49 = 320;
const $13590cfc2fac79d5$export$94aaf6acd960c412 = 'calc(100vh - 79px)';
function $13590cfc2fac79d5$export$804b6389edcac2c2({ src: src, alt: alt }) {
    if ((0, $VSDnB.fg)('enable-team-avatar-switch')) return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $fwSAz.default), {
        size: "medium",
        src: src
    });
    return /*#__PURE__*/ (0, $2OMIu.jsx)("img", {
        src: src || '',
        alt: alt,
        height: $13590cfc2fac79d5$export$91a15f1424900d33,
        width: $13590cfc2fac79d5$export$91a15f1424900d33,
        style: {
            borderRadius: $13590cfc2fac79d5$export$91a15f1424900d33 / 2
        }
    });
}
function $13590cfc2fac79d5$export$6b52db8960fbef38() {
    (0, $5uXOq.useEffect)(()=>{
        throw new Error('Something wrong inside People menu.');
    });
    return null;
}
const $13590cfc2fac79d5$export$5884f4bd467a603a = (error)=>{
    (0, $6IwYZ.renderPeopleNavMenuExp).failure({
        metadata: {
            ...error && 'status' in error ? {
                status: error.status
            } : {},
            ...error instanceof (0, $v6X2P.ErrorWithContext) ? {
                context: error.context
            } : {},
            error: error?.message
        }
    });
};

});
parcelRegister("fwSAz", function(module, exports) {

$parcel$export(module.exports, "default", () => $6cdf5ede1a400c9d$export$2e2bcd8739ae039);

var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $ujWmd = parcelRequire("ujWmd");


var $2w1D3 = parcelRequire("2w1D3");

var $ggnNZ = parcelRequire("ggnNZ");
const $6cdf5ede1a400c9d$export$ebe0b8fe8b6acbfd = `var(--ds-icon-inverse, ${(0, $829f609a65d26a98$export$29a4f05edc054374)})`;
const $6cdf5ede1a400c9d$export$72502e51aebdd94e = `var(--ds-icon-subtle, ${(0, $829f609a65d26a98$export$7c87d337fb91a97d)})`;
function $6cdf5ede1a400c9d$export$2e2bcd8739ae039({ testId: testId, src: src, size: size = 'medium', ...props }) {
    return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $ujWmd.default), {
        appearance: (0, $ggnNZ.isSquareIcon)(src) ? 'square' : 'circle',
        ...props,
        size: size,
        src: src,
        testId: `${testId}-team-avatar`,
        children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $2w1D3.TeamAvatarImage), {
            src: src,
            size: size,
            testId: testId
        })
    });
}

});
parcelRegister("2w1D3", function(module, exports) {

$parcel$export(module.exports, "TeamAvatarImage", () => $7d2527153712d181$export$ac3673635a5387be);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $5uXOq = parcelRequire("5uXOq");

var $f8Sb3 = parcelRequire("f8Sb3");

var $vIiRg = parcelRequire("vIiRg");
var $cEPfF = parcelRequire("cEPfF");

var $fptva = parcelRequire("fptva");

var $h8cgU = parcelRequire("h8cgU");

var $VSDnB = parcelRequire("VSDnB");


var $4jyNe = parcelRequire("4jyNe");

var $3WiFt = parcelRequire("3WiFt");
function $7d2527153712d181$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $7d2527153712d181$var$ICON_BACKGROUND = `var(--ds-icon-inverse, ${(0, $829f609a65d26a98$export$29a4f05edc054374)})`;
const $7d2527153712d181$var$ICON_COLOR = `var(--ds-icon-subtle, ${(0, $829f609a65d26a98$export$7c87d337fb91a97d)})`;
// used in a size calculation so can't be a token. Without this the avatar looks very squished
const $7d2527153712d181$var$ICON_PADDING = 4;
const $7d2527153712d181$var$avatarDefaultIconStyles = /*#__PURE__*/ (0, $f8Sb3.css)({
    display: 'flex',
    backgroundColor: $7d2527153712d181$var$ICON_COLOR,
    borderRadius: '50%',
    width: '100%',
    height: '100%',
    justifyContent: 'center',
    alignItems: 'center'
});
const $7d2527153712d181$var$SIZES = {
    xsmall: 16,
    small: 24,
    medium: 32,
    large: 40,
    xlarge: 96,
    xxlarge: 128
};
const $7d2527153712d181$var$nestedAvatarStyles = Object.entries((0, $vIiRg.AVATAR_SIZES)).reduce((styles, [key, size])=>{
    return {
        ...styles,
        [key]: /*#__PURE__*/ (0, $f8Sb3.css)({
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
            width: `${size}px`,
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
            height: `${size}px`,
            // eslint-disable-next-line @atlaskit/design-system/no-nested-styles, @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
            '& svg': {
                // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
                width: `${size - $7d2527153712d181$var$ICON_PADDING}px`,
                // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
                height: `${size - $7d2527153712d181$var$ICON_PADDING}px`
            }
        })
    };
}, {});
const $7d2527153712d181$var$avatarImageStyles = {
    name: "n68006",
    styles: "display:flex;flex:1 1 100%;width:100%;height:100%"
};
const $7d2527153712d181$export$9cfabd93718c0a2e = ({ alt: alt = '', src: src, size: size, testId: testId })=>{
    const [hasImageErrored, setHasImageErrored] = (0, $5uXOq.useState)(false);
    // If src changes, reset state
    (0, $5uXOq.useEffect)(()=>{
        setHasImageErrored(false);
    }, [
        src
    ]);
    if (!src || hasImageErrored) {
        if ((0, $VSDnB.fg)('enable-team-avatar-switch')) return /*#__PURE__*/ (0, $f8Sb3.jsx)((0, $4jyNe.FallbackAvatar), {
            "aria-label": alt,
            width: $7d2527153712d181$var$SIZES[size],
            height: $7d2527153712d181$var$SIZES[size],
            "data-testid": testId
        });
        return /*#__PURE__*/ (0, $f8Sb3.jsx)("span", {
            css: [
                $7d2527153712d181$var$avatarDefaultIconStyles,
                $7d2527153712d181$var$nestedAvatarStyles[size]
            ]
        }, /*#__PURE__*/ (0, $f8Sb3.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($fptva))), {
            label: alt,
            color: $7d2527153712d181$var$ICON_BACKGROUND,
            LEGACY_secondaryColor: $7d2527153712d181$var$ICON_COLOR,
            testId: testId && `${testId}--team`,
            spacing: "spacious",
            LEGACY_fallbackIcon: (0, (/*@__PURE__*/$parcel$interopDefault($h8cgU)))
        }));
    }
    return /*#__PURE__*/ (0, $f8Sb3.jsx)((0, $cEPfF.AvatarContent), null, /*#__PURE__*/ (0, $f8Sb3.jsx)("img", {
        src: src,
        alt: alt,
        "data-testid": testId && `${testId}--image`,
        css: $7d2527153712d181$var$avatarImageStyles,
        onError: ()=>setHasImageErrored(true)
    }));
};
const $7d2527153712d181$export$ac3673635a5387be = (props)=>{
    if ((0, $VSDnB.fg)('team-avatar-radii')) return /*#__PURE__*/ (0, $f8Sb3.jsx)((0, $3WiFt.TeamAvatarImage), props);
    return /*#__PURE__*/ (0, $f8Sb3.jsx)($7d2527153712d181$export$9cfabd93718c0a2e, props);
};

});
parcelRegister("vIiRg", function(module, exports) {

$parcel$export(module.exports, "AVATAR_SIZES", () => $32eb610dda6e4a8d$export$9a270941bcff7e77);
$parcel$export(module.exports, "AVATAR_RADIUS", () => $32eb610dda6e4a8d$export$e6da6efe4d1a5c9b);
$parcel$export(module.exports, "BORDER_WIDTH", () => $32eb610dda6e4a8d$export$e2bd4c1faded7921);
// eslint-disable-next-line @atlaskit/design-system/no-deprecated-imports

var $k5uoT = parcelRequire("k5uoT");
const $32eb610dda6e4a8d$export$9a270941bcff7e77 = {
    xsmall: (0, $k5uoT.gridSize)() * 2,
    small: (0, $k5uoT.gridSize)() * 3,
    medium: (0, $k5uoT.gridSize)() * 4,
    large: (0, $k5uoT.gridSize)() * 5,
    xlarge: (0, $k5uoT.gridSize)() * 12,
    xxlarge: (0, $k5uoT.gridSize)() * 16
};
const $32eb610dda6e4a8d$export$e6da6efe4d1a5c9b = {
    xsmall: 2,
    small: 2,
    medium: 3,
    large: 3,
    xlarge: 6,
    xxlarge: 12
};
const $32eb610dda6e4a8d$export$e2bd4c1faded7921 = 2;
const $32eb610dda6e4a8d$export$89a980dfdf90df51 = 0.9;
const $32eb610dda6e4a8d$export$3c061e31594ebabe = '--avatar-background-color';
const $32eb610dda6e4a8d$export$fdc820179f1f9be4 = {
    small: 12,
    medium: 14,
    large: 15,
    xlarge: 18
};
const $32eb610dda6e4a8d$export$382610e783aa2ae8 = {
    small: 0,
    medium: 0,
    large: 1,
    xlarge: 7
};

});

parcelRegister("h8cgU", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $c78cb3eb85357720$var$_react = $c78cb3eb85357720$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $c7fbr = parcelRequire("c7fbr");

var $c78cb3eb85357720$var$_peopleGroup = $c78cb3eb85357720$var$_interopRequireDefault((parcelRequire("fptva")));
function $c78cb3eb85357720$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $c78cb3eb85357720$var$PeopleIcon = (props)=>/*#__PURE__*/ $c78cb3eb85357720$var$_react.default.createElement($c7fbr.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><g fill="currentcolor" fill-rule="evenodd"><circle cx="16" cy="9" r="3"/><circle cx="8" cy="6" r="3"/><path d="M11 15c0-1.105.887-2 2-2h6c1.105 0 2 .885 2 2v3.73c0 3.027-10 3.027-10 0z"/><path d="M13 12a1.997 1.997 0 0 0-2-2H5c-1.113 0-2 .897-2 2.003v3.826c0 1.921 4.054 2.518 7 1.984v-2.807A3 3 0 0 1 12.997 12z"/></g></svg>`
    }, props, {
        newIcon: $c78cb3eb85357720$var$_peopleGroup.default
    }));
$c78cb3eb85357720$var$PeopleIcon.displayName = 'PeopleIcon';
var $c78cb3eb85357720$var$_default = module.exports.default = $c78cb3eb85357720$var$PeopleIcon;

});

parcelRegister("4jyNe", function(module, exports) {

$parcel$export(module.exports, "FallbackAvatar", () => $c800ab58c4d12cbb$export$eb63dcc490f6bbcd);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $MHKc7 = parcelRequire("MHKc7");
const $c800ab58c4d12cbb$var$styles = {
    wrapper: "_1e0c1txw _19pkv77o _2hwxv77o _otyrv77o _18u0v77o"
};
function $c800ab58c4d12cbb$export$eb63dcc490f6bbcd(props) {
    return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $MHKc7.default), {
        xcss: $c800ab58c4d12cbb$var$styles.wrapper,
        children: /*#__PURE__*/ (0, $2OMIu.jsxs)("svg", {
            width: "32",
            height: "32",
            viewBox: "0 0 32 32",
            fill: "none",
            xmlns: "http://www.w3.org/2000/svg",
            ...props,
            children: [
                /*#__PURE__*/ (0, $2OMIu.jsxs)("g", {
                    clipPath: "url(#clip0_2032_552)",
                    children: [
                        /*#__PURE__*/ (0, $2OMIu.jsx)("rect", {
                            width: "32",
                            height: "32",
                            rx: "4",
                            fill: "#DCDFE4"
                        }),
                        /*#__PURE__*/ (0, $2OMIu.jsx)("path", {
                            fillRule: "evenodd",
                            clipRule: "evenodd",
                            d: "M10.6666 12.6666C11.7712 12.6666 12.6666 11.7712 12.6666 10.6666C12.6666 9.56206 11.7712 8.66663 10.6666 8.66663C9.56202 8.66663 8.66658 9.56206 8.66658 10.6666C8.66658 11.7712 9.56202 12.6666 10.6666 12.6666ZM10.6666 14.6666C12.8757 14.6666 14.6666 12.8758 14.6666 10.6666C14.6666 8.45749 12.8757 6.66663 10.6666 6.66663C8.45745 6.66663 6.66658 8.45749 6.66658 10.6666C6.66658 12.8758 8.45745 14.6666 10.6666 14.6666Z",
                            fill: "#44546F"
                        }),
                        /*#__PURE__*/ (0, $2OMIu.jsx)("path", {
                            fillRule: "evenodd",
                            clipRule: "evenodd",
                            d: "M21.3333 12.6666C22.4378 12.6666 23.3333 11.7712 23.3333 10.6666C23.3333 9.56206 22.4378 8.66663 21.3333 8.66663C20.2287 8.66663 19.3333 9.56206 19.3333 10.6666C19.3333 11.7712 20.2287 12.6666 21.3333 12.6666ZM21.3333 14.6666C23.5424 14.6666 25.3333 12.8758 25.3333 10.6666C25.3333 8.45749 23.5424 6.66663 21.3333 6.66663C19.1241 6.66663 17.3333 8.45749 17.3333 10.6666C17.3333 12.8758 19.1241 14.6666 21.3333 14.6666Z",
                            fill: "#44546F"
                        }),
                        /*#__PURE__*/ (0, $2OMIu.jsx)("path", {
                            d: "M21.6666 16C24.4273 16.0004 26.6666 18.2385 26.6666 21V22.6666C26.6666 24.1394 25.4727 25.3333 23.9999 25.3333H20.135C18.0324 25.3333 16.1545 24.018 15.436 22.042L14.6843 19.9747C14.2531 18.7892 13.1264 18 11.8649 18H10.3333C8.6764 18 7.33325 19.3431 7.33325 21V22.6666C7.33325 23.0348 7.63173 23.3333 7.99992 23.3333H13.3333V25.3333H7.99992C6.52716 25.3333 5.33325 24.1394 5.33325 22.6666V21C5.33325 18.2385 7.57183 16 10.3333 16H11.8649C13.9674 16 15.8453 17.3153 16.5638 19.2913L17.3156 21.3585C17.7467 22.5441 18.8734 23.3333 20.135 23.3333H23.9999C24.3681 23.3333 24.6666 23.0348 24.6666 22.6666V21C24.6666 19.3437 23.3233 18.0004 21.6666 18H20.135V16H21.6666Z",
                            fill: "#44546F"
                        }),
                        /*#__PURE__*/ (0, $2OMIu.jsx)("path", {
                            d: "M20.135 16C19.5972 16 18.7183 16.1407 18.0518 16.4564L18.908 18.2639C19.064 18.19 19.288 18.1205 19.537 18.0703C19.785 18.0203 20.0045 18 20.135 18V16Z",
                            fill: "#44546F"
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $2OMIu.jsx)("defs", {
                    children: /*#__PURE__*/ (0, $2OMIu.jsx)("clipPath", {
                        id: "clip0_2032_552",
                        children: /*#__PURE__*/ (0, $2OMIu.jsx)("rect", {
                            width: "32",
                            height: "32",
                            rx: "4",
                            fill: "white"
                        })
                    })
                })
            ]
        })
    });
}

});

parcelRegister("3WiFt", function(module, exports) {

$parcel$export(module.exports, "TeamAvatarImage", () => $ed1385df3f8966b5$export$ac3673635a5387be);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $a9yTd = parcelRequire("a9yTd");
const $ed1385df3f8966b5$var$boxShadowCssVar = '--avatar-box-shadow';
const $ed1385df3f8966b5$var$bgColorCssVar = '--avatar-bg-color';
/**
 * We need to maintan the container styles manually until Avatar provides the correct border radius.
 * After that we can return to wrapping in <AvatarContent> rather than span
 */ const $ed1385df3f8966b5$var$containerStyles = {
    root: "_19itglyw _12ji1r31 _1qu2glyw _12y31o36 _1reo15vq _18m915vq _v564ieh6 _1e0c1txw _kqswpfqs _4cvr1fhb _1bah1h6o _2lx21bp4 _80om1kw7 _6rthv77o _1pfhv77o _12l2v77o _ahbqv77o _85i5ze3t _1q51ze3t _y4tize3t _bozgze3t _t9ec1aqe _9v7aze3t _qc5o1p41 _z0ai1osq _18postnw _1hfk18uv _aetrf705 _1peqidpf _11fnglyw",
    circle: "_2rko1q5u _14mj1q5u",
    positionRelative: "_kqswh2mm",
    disabled: "_80om13gf _1hfkvuon _1peqs237"
};
const $ed1385df3f8966b5$var$unboundStyles = {
    root: "_vchh18uv _bfhkcxp3 _16qs1nhn",
    interactive: "_80omtlke _4tpuw83z _ez1ykb7n _gcm11et6 _eeh8kb7n _jlxit94y"
};
const $ed1385df3f8966b5$var$avatarImageStyles = {
    image: "_16jlkb7n _1o9zkb7n _i0dl1osq _1e0c1txw _1bsb1osq _4t3i1osq"
};
const $ed1385df3f8966b5$var$SIZES = {
    xsmall: 16,
    small: 24,
    medium: 32,
    large: 40,
    xlarge: 96,
    xxlarge: 128
};
const $ed1385df3f8966b5$var$borderRadiusMap = {
    xsmall: "_2rko1y44",
    small: "_2rkoi2wt",
    medium: "_2rkoftgi",
    large: "_2rko19bv",
    xlarge: "_2rko1tcg",
    xxlarge: "_2rkozwfg"
};
const $ed1385df3f8966b5$var$widthHeightMap = {
    xsmall: "_1bsb7vkz _4t3i7vkz",
    small: "_1bsb1tcg _4t3i1tcg",
    medium: "_1bsbzwfg _4t3izwfg",
    large: "_1bsb1ylp _4t3i1ylp",
    xlarge: "_1bsb16xz _4t3i16xz",
    xxlarge: "_1bsb1qr7 _4t3i1qr7"
};
const $ed1385df3f8966b5$export$ac3673635a5387be = ({ alt: alt = '', src: src, size: size, testId: testId })=>{
    const [hasImageErrored, setHasImageErrored] = (0, $5uXOq.useState)(false);
    // If src changes, reset state
    (0, $5uXOq.useEffect)(()=>{
        setHasImageErrored(false);
    }, [
        src
    ]);
    if (!src || hasImageErrored) return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $a9yTd.FallbackAvatar), {
        "aria-label": alt,
        width: $ed1385df3f8966b5$var$SIZES[size],
        height: $ed1385df3f8966b5$var$SIZES[size],
        "data-testid": testId
    });
    return /*#__PURE__*/ (0, $2OMIu.jsx)("span", {
        "data-testid": testId,
        "aria-label": alt,
        className: (0, $bwpsq.default)([
            $ed1385df3f8966b5$var$unboundStyles.root,
            $ed1385df3f8966b5$var$containerStyles.root,
            $ed1385df3f8966b5$var$borderRadiusMap[size],
            $ed1385df3f8966b5$var$widthHeightMap[size]
        ]),
        children: /*#__PURE__*/ (0, $2OMIu.jsx)("img", {
            src: src,
            alt: alt,
            "data-testId": testId && `${testId}--image`,
            onError: ()=>setHasImageErrored(true),
            className: (0, $bwpsq.default)([
                $ed1385df3f8966b5$var$avatarImageStyles.image
            ])
        })
    });
};

});
parcelRegister("a9yTd", function(module, exports) {

$parcel$export(module.exports, "FallbackAvatar", () => $dc76f912cc56de65$export$eb63dcc490f6bbcd);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $MHKc7 = parcelRequire("MHKc7");
const $dc76f912cc56de65$var$styles = {
    wrapper: "_1e0c1txw _19pkv77o _2hwxv77o _otyrv77o _18u0v77o"
};
function $dc76f912cc56de65$export$eb63dcc490f6bbcd(props) {
    return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $MHKc7.default), {
        xcss: $dc76f912cc56de65$var$styles.wrapper,
        children: /*#__PURE__*/ (0, $2OMIu.jsxs)("svg", {
            width: "32",
            height: "32",
            viewBox: "0 0 32 32",
            fill: "none",
            xmlns: "http://www.w3.org/2000/svg",
            ...props,
            children: [
                /*#__PURE__*/ (0, $2OMIu.jsxs)("g", {
                    clipPath: "url(#clip0_2032_552)",
                    children: [
                        /*#__PURE__*/ (0, $2OMIu.jsx)("rect", {
                            width: "32",
                            height: "32",
                            rx: "4",
                            fill: "#DCDFE4"
                        }),
                        /*#__PURE__*/ (0, $2OMIu.jsx)("path", {
                            fillRule: "evenodd",
                            clipRule: "evenodd",
                            d: "M10.6666 12.6666C11.7712 12.6666 12.6666 11.7712 12.6666 10.6666C12.6666 9.56206 11.7712 8.66663 10.6666 8.66663C9.56202 8.66663 8.66658 9.56206 8.66658 10.6666C8.66658 11.7712 9.56202 12.6666 10.6666 12.6666ZM10.6666 14.6666C12.8757 14.6666 14.6666 12.8758 14.6666 10.6666C14.6666 8.45749 12.8757 6.66663 10.6666 6.66663C8.45745 6.66663 6.66658 8.45749 6.66658 10.6666C6.66658 12.8758 8.45745 14.6666 10.6666 14.6666Z",
                            fill: "#44546F"
                        }),
                        /*#__PURE__*/ (0, $2OMIu.jsx)("path", {
                            fillRule: "evenodd",
                            clipRule: "evenodd",
                            d: "M21.3333 12.6666C22.4378 12.6666 23.3333 11.7712 23.3333 10.6666C23.3333 9.56206 22.4378 8.66663 21.3333 8.66663C20.2287 8.66663 19.3333 9.56206 19.3333 10.6666C19.3333 11.7712 20.2287 12.6666 21.3333 12.6666ZM21.3333 14.6666C23.5424 14.6666 25.3333 12.8758 25.3333 10.6666C25.3333 8.45749 23.5424 6.66663 21.3333 6.66663C19.1241 6.66663 17.3333 8.45749 17.3333 10.6666C17.3333 12.8758 19.1241 14.6666 21.3333 14.6666Z",
                            fill: "#44546F"
                        }),
                        /*#__PURE__*/ (0, $2OMIu.jsx)("path", {
                            d: "M21.6666 16C24.4273 16.0004 26.6666 18.2385 26.6666 21V22.6666C26.6666 24.1394 25.4727 25.3333 23.9999 25.3333H20.135C18.0324 25.3333 16.1545 24.018 15.436 22.042L14.6843 19.9747C14.2531 18.7892 13.1264 18 11.8649 18H10.3333C8.6764 18 7.33325 19.3431 7.33325 21V22.6666C7.33325 23.0348 7.63173 23.3333 7.99992 23.3333H13.3333V25.3333H7.99992C6.52716 25.3333 5.33325 24.1394 5.33325 22.6666V21C5.33325 18.2385 7.57183 16 10.3333 16H11.8649C13.9674 16 15.8453 17.3153 16.5638 19.2913L17.3156 21.3585C17.7467 22.5441 18.8734 23.3333 20.135 23.3333H23.9999C24.3681 23.3333 24.6666 23.0348 24.6666 22.6666V21C24.6666 19.3437 23.3233 18.0004 21.6666 18H20.135V16H21.6666Z",
                            fill: "#44546F"
                        }),
                        /*#__PURE__*/ (0, $2OMIu.jsx)("path", {
                            d: "M20.135 16C19.5972 16 18.7183 16.1407 18.0518 16.4564L18.908 18.2639C19.064 18.19 19.288 18.1205 19.537 18.0703C19.785 18.0203 20.0045 18 20.135 18V16Z",
                            fill: "#44546F"
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $2OMIu.jsx)("defs", {
                    children: /*#__PURE__*/ (0, $2OMIu.jsx)("clipPath", {
                        id: "clip0_2032_552",
                        children: /*#__PURE__*/ (0, $2OMIu.jsx)("rect", {
                            width: "32",
                            height: "32",
                            rx: "4",
                            fill: "white"
                        })
                    })
                })
            ]
        })
    });
}

});



parcelRegister("ggnNZ", function(module, exports) {

$parcel$export(module.exports, "isSquareIcon", () => $cf7e4fad001aa258$export$d5a05ffb65695bc0);

var $VSDnB = parcelRequire("VSDnB");
function $cf7e4fad001aa258$export$d5a05ffb65695bc0(src) {
    if (!src) return false;
    try {
        const url = new URL(src);
        const host = url.host;
        const path = url.pathname;
        if ((host.startsWith('ptc-directory-sited-static') || host.startsWith('teams-directory-frontend')) && path.includes('teams/avatars/v4') && (0, $VSDnB.fg)('enable-team-avatar-switch')) return true;
    } catch  {
    // The src wasn't a URL, so it's obviously not the refreshed avatar.
    }
    return false;
}

});


parcelRegister("6IwYZ", function(module, exports) {

$parcel$export(module.exports, "renderPeopleNavMenuExp", () => $0c056f8279034760$export$a0db9187c809008d);

var $atdLB = parcelRequire("atdLB");
var $duUGa = parcelRequire("duUGa");

var $bSD7G = parcelRequire("bSD7G");
class $0c056f8279034760$var$UFOExperienceWithPackageContext extends (0, $duUGa.UFOExperience) {
    async success() {
        return super.success({
            metadata: {
                ...(0, $bSD7G.packageContext)
            }
        });
    }
    async failure(config) {
        return super.failure({
            force: config?.force,
            metadata: {
                ...config?.metadata ?? {},
                ...(0, $bSD7G.packageContext)
            }
        });
    }
    async abort() {
        return super.abort({
            metadata: {
                ...(0, $bSD7G.packageContext)
            }
        });
    }
}
const $0c056f8279034760$export$a0db9187c809008d = new $0c056f8279034760$var$UFOExperienceWithPackageContext('render-people-nav-menu', {
    type: (0, $atdLB.ExperienceTypes).Experience,
    performanceType: (0, $atdLB.ExperiencePerformanceTypes).InlineResult,
    platform: {
        component: 'people'
    }
});

});
parcelRegister("bSD7G", function(module, exports) {

$parcel$export(module.exports, "packageContext", () => $7c6b76e7041bc9a3$export$beac86d91b8e8b21);
const $7c6b76e7041bc9a3$export$beac86d91b8e8b21 = {
    packageName: "platform-pkg",
    packageVersion: "0.0.0-use.local"
};

});




parcelRegister("5IiJH", function(module, exports) {

$parcel$export(module.exports, "MenuGroupTeams", () => $bb1377fb4ffc4d3f$export$c3915c5ac3f99d49);

var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $koVbs = parcelRequire("koVbs");

var $cb25w = parcelRequire("cb25w");

var $3Z96c = parcelRequire("3Z96c");

var $fWjEu = parcelRequire("fWjEu");

var $3ys0B = parcelRequire("3ys0B");

var $hEofo = parcelRequire("hEofo");

var $dS8wI = parcelRequire("dS8wI");

var $c5ORg = parcelRequire("c5ORg");
parcelRequire("9iwCj");
var $7kP9q = parcelRequire("7kP9q");
var $9iwCj = parcelRequire("9iwCj");

var $ckanx = parcelRequire("ckanx");

var $cf0l8 = parcelRequire("cf0l8");

var $c2P5e = parcelRequire("c2P5e");
const $bb1377fb4ffc4d3f$export$86c994b04df922e = (props)=>{
    const intl = (0, $koVbs.default)();
    const { orgId: orgId } = (0, $hEofo.usePeopleMenuContext)();
    const { teams: teams = [], createAnalyticsEvent: createAnalyticsEvent, isLoading: isLoading, remoteConfig: remoteConfig } = props;
    const { testId: testId, product: product, onClickedItem: onClickedItem = (0, $dS8wI.VOID_FUNC), pushRoute: pushRoute = (0, $dS8wI.VOID_FUNC), togglePeopleMenu: togglePeopleMenu = (0, $dS8wI.VOID_FUNC) } = (0, $5uXOq.useContext)((0, $hEofo.PeopleMenuContext));
    const handleClickOnTeam = (0, $5uXOq.useCallback)((id)=>(event)=>{
            const isLeftClick = !(0, $c5ORg.isModifiedEvent)(event);
            (0, $9iwCj.triggerAnalyticsForClickOnTeam)(createAnalyticsEvent, isLeftClick);
            onClickedItem(id, 'team', event);
            if (isLeftClick) {
                const teamUrl = (0, $3ys0B.getTeamProfilePageLinkWithOrgId)({
                    remoteConfigResources: remoteConfig.resources,
                    teamId: id,
                    orgId: orgId,
                    ref: product,
                    src: (0, $7kP9q.AnalyticsActionSubject).PEOPLE_MENU
                });
                pushRoute(teamUrl);
                event.preventDefault();
            }
            togglePeopleMenu(false);
        }, [
        createAnalyticsEvent,
        onClickedItem,
        orgId,
        product,
        pushRoute,
        remoteConfig.resources,
        togglePeopleMenu
    ]);
    if (!remoteConfig.sections.teams.enabled) return null;
    return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $cf0l8.MenuGroupSection), {
        title: remoteConfig.sections.teams.label ?? intl.formatMessage((0, $ckanx.messages).yourTeams),
        testId: `${testId}-teams-section`,
        isLoading: isLoading,
        isEmpty: teams.length === 0,
        sectionType: 'team',
        maxItems: remoteConfig.sections.teams.maxItems,
        children: teams.slice(0, remoteConfig.sections.teams.maxItems).map((team)=>/*#__PURE__*/ (0, $2OMIu.jsx)((0, $3Z96c.default), {
                href: (0, $3ys0B.getTeamProfilePageLinkWithOrgId)({
                    remoteConfigResources: remoteConfig.resources,
                    teamId: team.id,
                    orgId: orgId
                }),
                onClick: handleClickOnTeam(team.id),
                iconBefore: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $c2P5e.ImgIcon), {
                    src: team.smallAvatarImageUrl || team.smallHeaderImageUrl,
                    alt: team.displayName
                }),
                description: intl.formatMessage((0, $ckanx.messages).numMembers, {
                    memberCount: team.memberCount ?? 1
                }),
                testId: `${testId}-team-item`,
                children: team.displayName
            }, team.id))
    });
};
const $bb1377fb4ffc4d3f$export$c3915c5ac3f99d49 = (0, $cb25w.default)()((0, $fWjEu.withMandatoryPeopleMenuConfiguration)($bb1377fb4ffc4d3f$export$86c994b04df922e));

});

parcelRegister("1x4s1", function(module, exports) {

let $11dc535c455f011b$var$load = (parcelRequire("28QjX"))(4);
module.exports = $11dc535c455f011b$var$load("93JHA").then(()=>parcelRequire('gRkfD'));

});


parcelRegister("7U5E9", function(module, exports) {

$parcel$export(module.exports, "PeopleMenuContentInternal", () => $912805c3f7a736e5$export$78306a734b6419e6);

var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");
parcelRequire("kc9vJ");
var $ihijj = parcelRequire("ihijj");

var $hEofo = parcelRequire("hEofo");

var $nRreb = parcelRequire("nRreb");

var $dS8wI = parcelRequire("dS8wI");

var $jHmRo = parcelRequire("jHmRo");

var $4144s = parcelRequire("4144s");
const $912805c3f7a736e5$var$stopPropagation = (e)=>e.stopPropagation();
const $912805c3f7a736e5$export$78306a734b6419e6 = /*#__PURE__*/ (0, $5uXOq.memo)(()=>{
    const { isBrowseUsersEnabled: isBrowseUsersEnabled } = (0, $5uXOq.useContext)((0, $hEofo.PeopleMenuContext));
    const { loading: isLoadingPermission, hasPermission: hasPermission } = (0, $nRreb.default)(isBrowseUsersEnabled);
    return(// eslint-disable-next-line jsx-a11y/click-events-have-key-events, jsx-a11y/no-static-element-interactions, @atlassian/a11y/interactive-element-not-keyboard-focusable
    /*#__PURE__*/ (0, $2OMIu.jsx)("span", {
        onClick: $912805c3f7a736e5$var$stopPropagation,
        children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $ihijj.LazySuspense), {
            fallback: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $jHmRo.MenuContentFallback), {}),
            children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $jHmRo.MenuContent), {
                isLoadingPermission: isLoadingPermission,
                hasPermission: hasPermission
            })
        })
    }));
});
const $912805c3f7a736e5$var$PeopleMenuContent = (props)=>{
    return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $4144s.default), {
        isOpen: true,
        onOpen: (0, $dS8wI.VOID_FUNC),
        onClose: (0, $dS8wI.VOID_FUNC),
        ...props,
        children: /*#__PURE__*/ (0, $2OMIu.jsx)($912805c3f7a736e5$export$78306a734b6419e6, {})
    });
};
var $912805c3f7a736e5$export$2e2bcd8739ae039 = $912805c3f7a736e5$var$PeopleMenuContent;

});
parcelRegister("nRreb", function(module, exports) {

$parcel$export(module.exports, "default", () => $fbf7656828aeee5c$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");
function $fbf7656828aeee5c$export$2e2bcd8739ae039(permissionPromise) {
    const noQuery = !permissionPromise;
    const [hasPermission, setPermission] = (0, $5uXOq.useState)(noQuery);
    const [loading, setLoading] = (0, $5uXOq.useState)(!noQuery);
    (0, $5uXOq.useEffect)(()=>{
        if (permissionPromise) permissionPromise().then((permissionResult)=>{
            setPermission(permissionResult);
            setLoading(false);
        }).catch(()=>{
            setPermission(false);
            setLoading(false);
        });
    }, [
        permissionPromise,
        setLoading,
        setPermission
    ]);
    return {
        loading: loading,
        hasPermission: hasPermission
    };
}

});

parcelRegister("4144s", function(module, exports) {

$parcel$export(module.exports, "default", () => $c08e04c739d3d984$export$2e2bcd8739ae039);

var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $daJ0i = parcelRequire("daJ0i");

var $cISRa = parcelRequire("cISRa");

var $3ys0B = parcelRequire("3ys0B");

var $hEofo = parcelRequire("hEofo");

var $bSD7G = parcelRequire("bSD7G");

var $7kP9q = parcelRequire("7kP9q");

var $2eTLr = parcelRequire("2eTLr");
const $c08e04c739d3d984$var$defaultProps = {
    onClickedMenuLink: ()=>Promise.reject('No handler defined. Using default props value.'),
    testId: 'menu',
    isSSR: false
};
/**
 * There are some essential higher components wrapping an actual PeopleMenu component:
 * - PeopleMenuContext: is used to avoid passing common props like cloudId
 * - IntlProvider: to make i18n working
 * - AnalyticsContext: is used to avoid passing many props for triggering analytics events
 * - ErrorBoundary: to capture any errors inside actual PeopleMenu component
 */ const $c08e04c739d3d984$var$PeopleMenuProviders = (props)=>{
    const { children: children, product: product, subProduct: subProduct, cloudId: cloudId, orgId: orgId, userId: userId, isBrowseUsersEnabled: isBrowseUsersEnabled, testId: testId, tenantUrl: tenantUrl, onClickedItem: onClickedItem, onClickedMenuLink: onClickedMenuLink, invitePeopleHandlers: invitePeopleHandlers, onOpen: onOpen, onClose: onClose, pushRoute: pushRoute, _hasError: _hasError, addFlag: addFlag, isOpen: isOpen, isSSR: isSSR, teamCreateDialogProps: teamCreateDialogProps, shouldRenderToParent: shouldRenderToParent, isSectionList: isSectionList } = {
        ...$c08e04c739d3d984$var$defaultProps,
        ...props
    };
    const analyticsContextData = {
        product: product,
        source: (0, $7kP9q.AnalyticsSource).PEOPLE_MENU,
        componentName: (0, $7kP9q.AnalyticsSource).PEOPLE_MENU,
        ...(0, $bSD7G.packageContext)
    };
    const commonPropsInContext = {
        cloudId: cloudId,
        orgId: orgId,
        product: product,
        subProduct: subProduct,
        userId: userId,
        isBrowseUsersEnabled: isBrowseUsersEnabled,
        isSSR: isSSR,
        testId: testId,
        tenantUrl: (0, $3ys0B.trimLastForwardSlash)(tenantUrl),
        onClickedItem: onClickedItem,
        onClickedMenuLink: onClickedMenuLink,
        invitePeopleHandlers: invitePeopleHandlers,
        onOpen: onOpen,
        onClose: onClose,
        pushRoute: pushRoute,
        _hasError: _hasError,
        addFlag: addFlag,
        isPeopleMenuOpen: false,
        isOpen: isOpen,
        teamCreateDialogProps: teamCreateDialogProps,
        shouldRenderToParent: shouldRenderToParent,
        isSectionList: isSectionList
    };
    return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $hEofo.PeopleMenuContextProvider), {
        ...commonPropsInContext,
        children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $cISRa.LazyIntlProvider), {
            fetchLanguageFile: (0, $2eTLr.fetchLanguageFile),
            children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $daJ0i.default), {
                data: analyticsContextData,
                children: children
            })
        })
    });
};
var $c08e04c739d3d984$export$2e2bcd8739ae039 = $c08e04c739d3d984$var$PeopleMenuProviders;

});
parcelRegister("cISRa", function(module, exports) {

$parcel$export(module.exports, "LazyIntlProvider", () => $765cbbd932b03192$export$b4f1ecc6daf5eb10);

var $5uXOq = parcelRequire("5uXOq");

var $i5FdW = parcelRequire("i5FdW");
var $koVbs = parcelRequire("koVbs");
const $765cbbd932b03192$export$94d2d72df36bbb16 = [
    'cs-CZ',
    'da-DK',
    'de-DE',
    'es-ES',
    'et-EE',
    'fi-FI',
    'fr-FR',
    'hu-HU',
    'is-IS',
    'it-IT',
    'ja-JP',
    'ko-KR',
    'nb-NB',
    'nl-NL',
    'pl-PL',
    'pt-BR',
    'pt-PT',
    'ro-RO',
    'ru-RU',
    'sk-SK',
    'sv-SE',
    'tr-TR',
    'th-TH',
    'uk-UK',
    'vi-VI',
    'zh-TW',
    'zh-HK',
    'zh-ZH',
    'zh-CN'
];
const $765cbbd932b03192$export$4d25b49b6dc1b540 = (locale)=>{
    const match = /([a-z]*)[_-]?([A-Z]*)/i.exec(locale);
    if (!match) throw Error('Unable to get language and country from invalid Locale');
    const [, language, country] = match;
    return {
        language: language.toLowerCase(),
        // when country code is missed, let it empty and we will use language/locale to find language file
        country: country ? country.toUpperCase() : ''
    };
};
function $765cbbd932b03192$export$5ac26fa9b941854e(locale, fetchLanguageFile) {
    const [messages, setMessages] = (0, $5uXOq.useState)({});
    const [isLoading, setIsLoading] = (0, $5uXOq.useState)(false);
    (0, $5uXOq.useEffect)(()=>{
        async function startToFetchMessagesByLocale() {
            const { language: language, country: country } = $765cbbd932b03192$export$4d25b49b6dc1b540(locale);
            // don't load English messages
            if (language === 'en') return;
            try {
                setIsLoading(true);
                const finalLocale = country ? `${language}-${country}` : language;
                const module = await fetchLanguageFile(finalLocale);
                const newMessages = module.default || module;
                setMessages(newMessages);
            } catch (e) {
            // fail to download message and do nothing because UI will use default language (English) to render
            } finally{
                setIsLoading(false);
            }
        }
        startToFetchMessagesByLocale();
    }, [
        locale,
        fetchLanguageFile
    ]);
    return {
        messages: messages,
        isLoading: isLoading
    };
}
const $765cbbd932b03192$export$b4f1ecc6daf5eb10 = (props)=>{
    const { children: children, fetchLanguageFile: fetchLanguageFile, ...rest } = props;
    const { locale: locale, messages: allMessages = {} } = (0, $koVbs.default)();
    const { messages: messages } = $765cbbd932b03192$export$5ac26fa9b941854e(locale, fetchLanguageFile);
    // Product might have already provided messages.
    // In the server-side environment, useFetchMessagesByLocale is noop we are relying on product to provide messages.
    for(const key in messages)if (!allMessages[key]) allMessages[key] = messages[key];
    return /*#__PURE__*/ (0, $5uXOq.createElement)((0, $i5FdW.default), {
        ...rest,
        messages: allMessages,
        key: locale,
        locale: locale,
        defaultLocale: "en-US"
    }, children);
};

});

parcelRegister("2eTLr", function(module, exports) {

$parcel$export(module.exports, "fetchLanguageFile", () => $97c2677f18f80a57$export$c08b58fa4727b0d2);

var $dX8RA = parcelRequire("dX8RA");
function $97c2677f18f80a57$export$c08b58fa4727b0d2(locale) {
    switch(locale){
        case 'cs-CZ':
        case 'cs':
            return $dX8RA.cs();
        case 'da-DK':
        case 'da':
            return $dX8RA.da();
        case 'de-DE':
        case 'de':
            return $dX8RA.de();
        case 'en-GB':
            return $dX8RA.engb();
        case 'en-US':
        case 'en':
            return $dX8RA.en();
        case 'en-ZZ':
            return $dX8RA.enzz();
        case 'es-ES':
        case 'es':
            return $dX8RA.es();
        case 'et-EE':
        case 'et':
            return $dX8RA.et();
        case 'fi-FI':
        case 'fi':
            return $dX8RA.fi();
        case 'fr-FR':
        case 'fr':
            return $dX8RA.fr();
        case 'hu-HU':
        case 'hu':
            return $dX8RA.hu();
        case 'is-IS':
        case 'is':
            return $dX8RA.is();
        case 'it-IT':
        case 'it':
            return $dX8RA.it();
        case 'ja-JP':
        case 'ja':
            return $dX8RA.ja();
        case 'ko-KR':
        case 'ko':
            return $dX8RA.ko();
        case 'nb-NB':
        case 'nb':
            return $dX8RA.nb();
        case 'nl-NL':
        case 'nl':
            return $dX8RA.nl();
        case 'pl-PL':
        case 'pl':
            return $dX8RA.pl();
        case 'pt-PT':
        case 'pt_PT':
        case 'pt':
            return $dX8RA.pt();
        case 'pt-BR':
        case 'pt_BR':
            return $dX8RA.ptbr();
        case 'ro-RO':
        case 'ro':
            return $dX8RA.ro();
        case 'ru-RU':
        case 'ru':
            return $dX8RA.ru();
        case 'sk-SK':
        case 'sk':
            return $dX8RA.sk();
        case 'sv-SE':
        case 'sv':
            return $dX8RA.sv();
        case 'tr-TR':
        case 'tr':
            return $dX8RA.tr();
        case 'th-TH':
        case 'th':
            return $dX8RA.th();
        case 'uk-UK':
        case 'uk':
            return $dX8RA.uk();
        case 'vi-VI':
        case 'vi':
            return $dX8RA.vi();
        case 'zh-TW':
        case 'zh-HK':
            return $dX8RA.zhtw();
        case 'zh-ZH':
        case 'zh-CN':
        case 'zh':
            return $dX8RA.zh();
    }
    return $dX8RA.fallback();
}

});
parcelRegister("dX8RA", function(module, exports) {

$parcel$export(module.exports, "fallback", () => $2bfa8f80c65d815a$export$bcd1dd1f397bba12);
$parcel$export(module.exports, "cs", () => $2bfa8f80c65d815a$export$bde1ed0f60b38f2f);
$parcel$export(module.exports, "da", () => $2bfa8f80c65d815a$export$8c8450b83b664ba4);
$parcel$export(module.exports, "de", () => $2bfa8f80c65d815a$export$2fa162a495d26869);
$parcel$export(module.exports, "en", () => $2bfa8f80c65d815a$export$84584c2a98eb6753);
$parcel$export(module.exports, "engb", () => $2bfa8f80c65d815a$export$141cd05f569bae45);
$parcel$export(module.exports, "enzz", () => $2bfa8f80c65d815a$export$a3f288d6c3177b8a);
$parcel$export(module.exports, "es", () => $2bfa8f80c65d815a$export$ca5e4045a55e76d2);
$parcel$export(module.exports, "et", () => $2bfa8f80c65d815a$export$457177dcde8472be);
$parcel$export(module.exports, "fi", () => $2bfa8f80c65d815a$export$ed5179c818622fb);
$parcel$export(module.exports, "fr", () => $2bfa8f80c65d815a$export$acb2a88f7d552ebf);
$parcel$export(module.exports, "hu", () => $2bfa8f80c65d815a$export$9901d21957972d53);
$parcel$export(module.exports, "is", () => $2bfa8f80c65d815a$export$226b3eccf92c9ed9);
$parcel$export(module.exports, "it", () => $2bfa8f80c65d815a$export$3486a10f30cf1ee4);
$parcel$export(module.exports, "ja", () => $2bfa8f80c65d815a$export$8c6f505e9474ce90);
$parcel$export(module.exports, "ko", () => $2bfa8f80c65d815a$export$798cf677954c9533);
$parcel$export(module.exports, "nb", () => $2bfa8f80c65d815a$export$38ef0e3f791a121e);
$parcel$export(module.exports, "nl", () => $2bfa8f80c65d815a$export$9c64ee4d84d79ce1);
$parcel$export(module.exports, "pl", () => $2bfa8f80c65d815a$export$6ea5311eda92944f);
$parcel$export(module.exports, "pt", () => $2bfa8f80c65d815a$export$84175d5f1cb4e39d);
$parcel$export(module.exports, "ptbr", () => $2bfa8f80c65d815a$export$82924b14976e7373);
$parcel$export(module.exports, "ro", () => $2bfa8f80c65d815a$export$ea30ec7f37fb148d);
$parcel$export(module.exports, "ru", () => $2bfa8f80c65d815a$export$cf48009033a0126b);
$parcel$export(module.exports, "sk", () => $2bfa8f80c65d815a$export$d608fa5b5bfd2021);
$parcel$export(module.exports, "sv", () => $2bfa8f80c65d815a$export$65540e5f7f6e7dce);
$parcel$export(module.exports, "tr", () => $2bfa8f80c65d815a$export$72451b88a72ad9c2);
$parcel$export(module.exports, "th", () => $2bfa8f80c65d815a$export$d657bc098992a431);
$parcel$export(module.exports, "uk", () => $2bfa8f80c65d815a$export$312745a8a3013c00);
$parcel$export(module.exports, "vi", () => $2bfa8f80c65d815a$export$e3786bf10a8abdf2);
$parcel$export(module.exports, "zh", () => $2bfa8f80c65d815a$export$b65a7f08f2280505);
$parcel$export(module.exports, "zhtw", () => $2bfa8f80c65d815a$export$41779e6acd26e15f);
/* istanbul ignore file */ const $2bfa8f80c65d815a$export$bcd1dd1f397bba12 = ()=>Promise.resolve({
        default: {}
    });

const $2bfa8f80c65d815a$export$bde1ed0f60b38f2f = ()=>(parcelRequire("1pN5l"));

const $2bfa8f80c65d815a$export$8c8450b83b664ba4 = ()=>(parcelRequire("1Hhcx"));

const $2bfa8f80c65d815a$export$2fa162a495d26869 = ()=>(parcelRequire("aJArm"));

const $2bfa8f80c65d815a$export$84584c2a98eb6753 = ()=>(parcelRequire("5zlkE"));

const $2bfa8f80c65d815a$export$141cd05f569bae45 = ()=>(parcelRequire("k0K3o"));

const $2bfa8f80c65d815a$export$a3f288d6c3177b8a = ()=>(parcelRequire("cn8Hy"));

const $2bfa8f80c65d815a$export$ca5e4045a55e76d2 = ()=>(parcelRequire("bZV9z"));

const $2bfa8f80c65d815a$export$457177dcde8472be = ()=>(parcelRequire("973X5"));

const $2bfa8f80c65d815a$export$ed5179c818622fb = ()=>(parcelRequire("lDqwo"));

const $2bfa8f80c65d815a$export$acb2a88f7d552ebf = ()=>(parcelRequire("91PBO"));

const $2bfa8f80c65d815a$export$9901d21957972d53 = ()=>(parcelRequire("5aNrK"));

const $2bfa8f80c65d815a$export$226b3eccf92c9ed9 = ()=>(parcelRequire("efsbl"));

const $2bfa8f80c65d815a$export$3486a10f30cf1ee4 = ()=>(parcelRequire("e9OPu"));

const $2bfa8f80c65d815a$export$8c6f505e9474ce90 = ()=>(parcelRequire("d5cLH"));

const $2bfa8f80c65d815a$export$798cf677954c9533 = ()=>(parcelRequire("9aaTw"));

const $2bfa8f80c65d815a$export$38ef0e3f791a121e = ()=>(parcelRequire("1gMCW"));

const $2bfa8f80c65d815a$export$9c64ee4d84d79ce1 = ()=>(parcelRequire("3X78k"));

const $2bfa8f80c65d815a$export$6ea5311eda92944f = ()=>(parcelRequire("lvGag"));

const $2bfa8f80c65d815a$export$84175d5f1cb4e39d = ()=>(parcelRequire("9HZGf"));

const $2bfa8f80c65d815a$export$82924b14976e7373 = ()=>(parcelRequire("io1jH"));

const $2bfa8f80c65d815a$export$ea30ec7f37fb148d = ()=>(parcelRequire("27SkM"));

const $2bfa8f80c65d815a$export$cf48009033a0126b = ()=>(parcelRequire("32C38"));

const $2bfa8f80c65d815a$export$d608fa5b5bfd2021 = ()=>(parcelRequire("4fcA2"));

const $2bfa8f80c65d815a$export$65540e5f7f6e7dce = ()=>(parcelRequire("kr8oc"));

const $2bfa8f80c65d815a$export$72451b88a72ad9c2 = ()=>(parcelRequire("cu66e"));

const $2bfa8f80c65d815a$export$d657bc098992a431 = ()=>(parcelRequire("anfPE"));

const $2bfa8f80c65d815a$export$312745a8a3013c00 = ()=>(parcelRequire("9X1Qp"));

const $2bfa8f80c65d815a$export$e3786bf10a8abdf2 = ()=>(parcelRequire("guhN0"));

const $2bfa8f80c65d815a$export$b65a7f08f2280505 = ()=>(parcelRequire("3V1E5"));

const $2bfa8f80c65d815a$export$41779e6acd26e15f = ()=>(parcelRequire("kR1Xs"));

});
parcelRegister("1pN5l", function(module, exports) {

let $107e33848c314706$var$load = (parcelRequire("28QjX"))(4);
module.exports = $107e33848c314706$var$load("bzPrt").then(()=>parcelRequire('fExJZ'));

});

parcelRegister("1Hhcx", function(module, exports) {

let $13c726634256996c$var$load = (parcelRequire("28QjX"))(4);
module.exports = $13c726634256996c$var$load("cAcaY").then(()=>parcelRequire('h49zj'));

});

parcelRegister("aJArm", function(module, exports) {

let $7d0a5fa356a4eb8a$var$load = (parcelRequire("28QjX"))(4);
module.exports = $7d0a5fa356a4eb8a$var$load("kpct2").then(()=>parcelRequire('ksdj2'));

});

parcelRegister("5zlkE", function(module, exports) {

let $40e0c4ba9a57d63a$var$load = (parcelRequire("28QjX"))(4);
module.exports = $40e0c4ba9a57d63a$var$load("bKLJ9").then(()=>parcelRequire('9S4eI'));

});

parcelRegister("k0K3o", function(module, exports) {

let $e917880e5ea9008f$var$load = (parcelRequire("28QjX"))(4);
module.exports = $e917880e5ea9008f$var$load("kNq8n").then(()=>parcelRequire('jR0Em'));

});

parcelRegister("cn8Hy", function(module, exports) {

let $901e61f9bff73dd8$var$load = (parcelRequire("28QjX"))(4);
module.exports = $901e61f9bff73dd8$var$load("h6lR9").then(()=>parcelRequire('cpC58'));

});

parcelRegister("bZV9z", function(module, exports) {

let $8bc1b9ab9a87b1a0$var$load = (parcelRequire("28QjX"))(4);
module.exports = $8bc1b9ab9a87b1a0$var$load("cMAwR").then(()=>parcelRequire('hXLvF'));

});

parcelRegister("973X5", function(module, exports) {

let $6a27d54f40b6a83b$var$load = (parcelRequire("28QjX"))(4);
module.exports = $6a27d54f40b6a83b$var$load("kafKa").then(()=>parcelRequire('3jxEi'));

});

parcelRegister("lDqwo", function(module, exports) {

let $fc01d0186ff47c8d$var$load = (parcelRequire("28QjX"))(4);
module.exports = $fc01d0186ff47c8d$var$load("j3PEW").then(()=>parcelRequire('bem9x'));

});

parcelRegister("91PBO", function(module, exports) {

let $692c3d7bb91972ab$var$load = (parcelRequire("28QjX"))(4);
module.exports = $692c3d7bb91972ab$var$load("dJhw2").then(()=>parcelRequire('1Z04w'));

});

parcelRegister("5aNrK", function(module, exports) {

let $3c443df9a636d69c$var$load = (parcelRequire("28QjX"))(4);
module.exports = $3c443df9a636d69c$var$load("9KyV4").then(()=>parcelRequire('ddvLU'));

});

parcelRegister("efsbl", function(module, exports) {

let $a5f853c5820ffce0$var$load = (parcelRequire("28QjX"))(4);
module.exports = $a5f853c5820ffce0$var$load("e0KhN").then(()=>parcelRequire('iuYhr'));

});

parcelRegister("e9OPu", function(module, exports) {

let $a4e9559ac1b6dee4$var$load = (parcelRequire("28QjX"))(4);
module.exports = $a4e9559ac1b6dee4$var$load("3ORi1").then(()=>parcelRequire('kjLAT'));

});

parcelRegister("d5cLH", function(module, exports) {

let $9865a5857c342072$var$load = (parcelRequire("28QjX"))(4);
module.exports = $9865a5857c342072$var$load("03LHp").then(()=>parcelRequire('j9DVR'));

});

parcelRegister("9aaTw", function(module, exports) {

let $6abd7fad78ae7584$var$load = (parcelRequire("28QjX"))(4);
module.exports = $6abd7fad78ae7584$var$load("9202h").then(()=>parcelRequire('7zgXj'));

});

parcelRegister("1gMCW", function(module, exports) {

let $0ecd0167c5662a20$var$load = (parcelRequire("28QjX"))(4);
module.exports = $0ecd0167c5662a20$var$load("clYHT").then(()=>parcelRequire('aXlfw'));

});

parcelRegister("3X78k", function(module, exports) {

let $2e0c6a511151b327$var$load = (parcelRequire("28QjX"))(4);
module.exports = $2e0c6a511151b327$var$load("6aSvJ").then(()=>parcelRequire('71H9N'));

});

parcelRegister("lvGag", function(module, exports) {

let $fa8d3335ba7aceb0$var$load = (parcelRequire("28QjX"))(4);
module.exports = $fa8d3335ba7aceb0$var$load("aC90a").then(()=>parcelRequire('ljJMk'));

});

parcelRegister("9HZGf", function(module, exports) {

let $7117f9a25f4bc383$var$load = (parcelRequire("28QjX"))(4);
module.exports = $7117f9a25f4bc383$var$load("2OZrA").then(()=>parcelRequire('9c3LE'));

});

parcelRegister("io1jH", function(module, exports) {

let $d62b7d577736e3f4$var$load = (parcelRequire("28QjX"))(4);
module.exports = $d62b7d577736e3f4$var$load("fGIvQ").then(()=>parcelRequire('h7Z1H'));

});

parcelRegister("27SkM", function(module, exports) {

let $18c661dbeb9b2ea1$var$load = (parcelRequire("28QjX"))(4);
module.exports = $18c661dbeb9b2ea1$var$load("ixZBE").then(()=>parcelRequire('llnnW'));

});

parcelRegister("32C38", function(module, exports) {

let $236f12d62644aed1$var$load = (parcelRequire("28QjX"))(4);
module.exports = $236f12d62644aed1$var$load("8Eo9v").then(()=>parcelRequire('jsirv'));

});

parcelRegister("4fcA2", function(module, exports) {

let $3172525666aad141$var$load = (parcelRequire("28QjX"))(4);
module.exports = $3172525666aad141$var$load("4TfrF").then(()=>parcelRequire('7s028'));

});

parcelRegister("kr8oc", function(module, exports) {

let $ee0cd634477b402e$var$load = (parcelRequire("28QjX"))(4);
module.exports = $ee0cd634477b402e$var$load("9elLh").then(()=>parcelRequire('8Tuck'));

});

parcelRegister("cu66e", function(module, exports) {

let $916d049c44492d4b$var$load = (parcelRequire("28QjX"))(4);
module.exports = $916d049c44492d4b$var$load("hhiQq").then(()=>parcelRequire('1czcz'));

});

parcelRegister("anfPE", function(module, exports) {

let $78d85543d00f8d49$var$load = (parcelRequire("28QjX"))(4);
module.exports = $78d85543d00f8d49$var$load("fLvHn").then(()=>parcelRequire('ciBsY'));

});

parcelRegister("9X1Qp", function(module, exports) {

let $73eb0df726f1e6a0$var$load = (parcelRequire("28QjX"))(4);
module.exports = $73eb0df726f1e6a0$var$load("3PkAh").then(()=>parcelRequire('9Ej9o'));

});

parcelRegister("guhN0", function(module, exports) {

let $c00d3f4efc04bfc6$var$load = (parcelRequire("28QjX"))(4);
module.exports = $c00d3f4efc04bfc6$var$load("6TcvA").then(()=>parcelRequire('3IrzE'));

});

parcelRegister("3V1E5", function(module, exports) {

let $2da7f8bf33ea9888$var$load = (parcelRequire("28QjX"))(4);
module.exports = $2da7f8bf33ea9888$var$load("8lxaY").then(()=>parcelRequire('eveoR'));

});

parcelRegister("kR1Xs", function(module, exports) {

let $f2ea46b5ebf354d0$var$load = (parcelRequire("28QjX"))(4);
module.exports = $f2ea46b5ebf354d0$var$load("geQMt").then(()=>parcelRequire('k9Nyn'));

});





parcelRegister("4AXtg", function(module, exports) {

$parcel$export(module.exports, "PeopleMenuTriggerSSR", () => $176dc84aa3d064ce$export$7e1e2ab520ce5d59);
$parcel$export(module.exports, "default", () => $176dc84aa3d064ce$export$2e2bcd8739ae039);
// eslint-disable @atlaskit/design-system/no-legacy-icons

var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $ousew = parcelRequire("ousew");

var $7ownK = parcelRequire("7ownK");

var $ebd3R = parcelRequire("ebd3R");

var $3dGN0 = parcelRequire("3dGN0");

var $kJpBP = parcelRequire("kJpBP");

var $fWjEu = parcelRequire("fWjEu");

var $ckanx = parcelRequire("ckanx");
function $176dc84aa3d064ce$export$7e1e2ab520ce5d59({ testId: testId, peopleText: peopleText }) {
    const remoteConfig = (0, $fWjEu.usePeopleAndTeamsPeopleMenuConfiguration)();
    const navLabel = remoteConfig?.navLabel || peopleText;
    return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $7ownK.PrimaryDropdownButton), {
        testId: `${testId}-people-primary-button-ssr`,
        children: navLabel ? navLabel : /*#__PURE__*/ (0, $2OMIu.jsx)((0, $ousew.default), {
            ...(0, $ckanx.messages).teams
        })
    });
}
function $176dc84aa3d064ce$var$PeopleMenuTrigger(props) {
    const { isVisible: isVisible, isHighlighted: isHighlighted, customChevronIcon: customChevronIcon, triggerProps: triggerProps, onClick: onClick, onMouseEnter: onMouseEnter, testId: testId, isSelected: isSelected, peopleText: peopleText } = props;
    const buttonProps = (0, $5uXOq.useMemo)(()=>({
            isSelected: isSelected,
            onClick: onClick,
            onMouseEnter: onMouseEnter,
            testId: testId
        }), [
        isSelected,
        onClick,
        onMouseEnter,
        testId
    ]);
    const remoteConfig = (0, $fWjEu.usePeopleAndTeamsPeopleMenuConfiguration)();
    const navLabel = remoteConfig?.navLabel || peopleText;
    const chevron = customChevronIcon || /*#__PURE__*/ (0, $2OMIu.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($3dGN0))), {
        label: "dropdown-chevron",
        spacing: "spacious",
        LEGACY_fallbackIcon: (0, (/*@__PURE__*/$parcel$interopDefault($ebd3R)))
    });
    const renderPrimaryDropDownButton = (0, $5uXOq.useCallback)(()=>{
        return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $7ownK.PrimaryDropdownButton), {
            isHighlighted: isHighlighted,
            ...buttonProps,
            ...triggerProps,
            children: navLabel || /*#__PURE__*/ (0, $2OMIu.jsx)((0, $ousew.default), {
                ...(0, $ckanx.messages).teams
            })
        });
    }, [
        buttonProps,
        isHighlighted,
        navLabel,
        triggerProps
    ]);
    if (isVisible) return renderPrimaryDropDownButton();
    return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $kJpBP.default), {
        iconAfter: chevron,
        ...triggerProps,
        ...buttonProps,
        children: navLabel || /*#__PURE__*/ (0, $2OMIu.jsx)((0, $ousew.default), {
            ...(0, $ckanx.messages).teams
        })
    });
}
var $176dc84aa3d064ce$export$2e2bcd8739ae039 = $176dc84aa3d064ce$var$PeopleMenuTrigger;

});

parcelRegister("14DM3", function(module, exports) {

$parcel$export(module.exports, "UsersTeamsPreFetch", () => $018d7b56116a683b$export$ffb64487c0de3976);

var $5uXOq = parcelRequire("5uXOq");

var $cb25w = parcelRequire("cb25w");

var $5iwOw = parcelRequire("5iwOw");

var $gFH8O = parcelRequire("gFH8O");

var $9iwCj = parcelRequire("9iwCj");
function $018d7b56116a683b$export$50ca75733630fce1({ cloudId: cloudId, orgId: orgId, userId: userId, product: product, tenantUrl: tenantUrl, createAnalyticsEvent: createAnalyticsEvent }) {
    (0, $5uXOq.useEffect)(()=>{
        (0, $9iwCj.triggerAnalyticsForPreFetchData)(createAnalyticsEvent);
        // measure duration time of fetching users and teams data
        (0, $gFH8O.startMeasure)('fetchingData');
    }, [
        createAnalyticsEvent
    ]);
    const { isLoading: isLoading } = (0, $5iwOw.default)(cloudId, userId, product, tenantUrl, undefined, orgId);
    // stop to measure fetching data time when isLoading is finished.
    (0, $5uXOq.useEffect)(()=>{
        if (!isLoading) (0, $gFH8O.stopMeasure)('fetchingData', (duration, startTime)=>{
            (0, $9iwCj.triggerAnalyticsForFetchingData)(createAnalyticsEvent, duration, startTime);
        });
    }, [
        createAnalyticsEvent,
        isLoading
    ]);
    return null;
}
const $018d7b56116a683b$export$ffb64487c0de3976 = (0, $cb25w.default)()($018d7b56116a683b$export$50ca75733630fce1);

});



parcelRegister("annPD", function(module, exports) {

$parcel$export(module.exports, "useBrowseUsersGroupsPermissionsNext", () => $72cc6e3d980d69b6$export$f16858a6f1359756);
$parcel$export(module.exports, "useBrowseUsersGroupsPermissions", () => $72cc6e3d980d69b6$export$c12f7f185a3a245f);

var $5uXOq = parcelRequire("5uXOq");

var $4R6GH = parcelRequire("4R6GH");

var $eusud = parcelRequire("eusud");

var $6yXtV = parcelRequire("6yXtV");
const $72cc6e3d980d69b6$var$deferredPromise = ()=>{
    const deferred = {
        resolve: undefined,
        reject: undefined
    };
    const promise = new Promise(// eslint-disable-next-line @typescript-eslint/no-explicit-any
    (resolve, reject)=>{
        // @ts-expect-error - TS2322 - Type '(result: boolean) => void' is not assignable to type 'undefined'.
        deferred.resolve = (result)=>{
            resolve(result);
        };
        // @ts-expect-error - TS2322 - Type '(error?: any) => void' is not assignable to type 'undefined'.
        deferred.reject = reject;
    });
    return {
        promise: promise,
        ...deferred
    };
};
class $72cc6e3d980d69b6$var$BrowseUsersGroupsCacheClient {
    fetch() {
        const requestUrl = '/rest/internal/latest/userPermission/browseUsersGroups';
        if (this.promise !== null) return this.promise;
        this.promise = (0, $eusud.performGetRequest)(requestUrl);
        return this.promise;
    }
    constructor(){
        this.promise = null;
    }
}
const $72cc6e3d980d69b6$var$client = new $72cc6e3d980d69b6$var$BrowseUsersGroupsCacheClient();
const $72cc6e3d980d69b6$export$f16858a6f1359756 = (force)=>{
    const [{ isReady: isReady }] = (0, $6yXtV.useSpaStatePageReady)();
    const [{ promise: promise, resolve: resolve, reject: reject }] = (0, $5uXOq.useState)($72cc6e3d980d69b6$var$deferredPromise());
    (0, $5uXOq.useEffect)(()=>{
        if ((isReady || force) && (0, $4R6GH.fg)('dont-auto-close-people-menu')) $72cc6e3d980d69b6$var$client.fetch().then(resolve).catch(reject);
    }, [
        isReady,
        reject,
        resolve,
        force
    ]);
    return (0, $5uXOq.useCallback)(()=>promise, [
        promise
    ]);
};
const $72cc6e3d980d69b6$export$c12f7f185a3a245f = ()=>{
    const [{ isReady: isReady }] = (0, $6yXtV.useSpaStatePageReady)();
    const [{ promise: promise, resolve: resolve, reject: reject }] = (0, $5uXOq.useState)($72cc6e3d980d69b6$var$deferredPromise());
    (0, $5uXOq.useEffect)(()=>{
        if (isReady && !(0, $4R6GH.fg)('dont-auto-close-people-menu')) {
            const requestUrl = '/rest/internal/latest/userPermission/browseUsersGroups';
            (0, $eusud.performGetRequest)(requestUrl).then(resolve).catch(reject);
        }
    }, [
        isReady,
        reject,
        resolve
    ]);
    return (0, $5uXOq.useCallback)(()=>promise, [
        promise
    ]);
};

});

parcelRegister("ikNzk", function(module, exports) {

$parcel$export(module.exports, "useInvitePeopleModal", () => $d166ed08e92451be$export$b9ec44715ae5ad99);
$parcel$export(module.exports, "InvitePeopleModalContextProvider", () => $d166ed08e92451be$export$496e4f58036bb94d);

var $5uXOq = parcelRequire("5uXOq");

var $fElvF = parcelRequire("fElvF");
var $2JsdQ = parcelRequire("2JsdQ");

var $6s1PB = parcelRequire("6s1PB");

var $dNEo8 = parcelRequire("dNEo8");

var $e5wyW = parcelRequire("e5wyW");
/*
 * When we cleaning up experiment 'jira-invite-people-to-project-modal', this file should be removed.
 * Depending on the success / failure of the expirement we can replace the import of the modal context and hook
 * with the one from the invite-people package or keep using the one from jira-invite-people-modal-context.
 */ const $d166ed08e92451be$var$isJiraInvitePeopleModalEnabled = ()=>{
    const [config] = (0, $6s1PB.UNSAFE_noExposureExp)('jira-invite-people-to-project-modal');
    return config.get('isEnabled', false);
};
const $d166ed08e92451be$export$c9ab9acc5993c948 = (0, $e5wyW.functionWithCondition)(()=>$d166ed08e92451be$var$isJiraInvitePeopleModalEnabled(), ({ resourceAri: resourceAri, onSubmit: onSubmit, ...props })=>(0, $dNEo8.useJiraInvitePeopleModalBound)(props), (0, $2JsdQ.useInvitePeopleModal));
const $d166ed08e92451be$export$b9ec44715ae5ad99 = (props)=>{
    const [, fireExposure] = (0, $6s1PB.UNSAFE_noExposureExp)('jira-invite-people-to-project-modal');
    const { openModal: openModal } = $d166ed08e92451be$export$c9ab9acc5993c948(props);
    const openModalWithExposure = (0, $5uXOq.useCallback)(()=>{
        fireExposure();
        openModal();
    }, [
        openModal,
        fireExposure
    ]);
    return {
        openModal: openModalWithExposure
    };
};
const $d166ed08e92451be$export$496e4f58036bb94d = ({ children: children })=>{
    if ($d166ed08e92451be$var$isJiraInvitePeopleModalEnabled()) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dNEo8.JiraInvitePeopleModalContextProvider), {
        renderedInProjectContext: false,
        shouldDisplaySuccessModal: false
    }, children);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $fElvF.InvitePeopleModalContextProvider), null, children);
};

});
parcelRegister("fElvF", function(module, exports) {

$parcel$export(module.exports, "InvitePeopleModalContext", () => $075d48b841fc8ac5$export$be58429061ae5194);
$parcel$export(module.exports, "InvitePeopleModalContextProvider", () => $075d48b841fc8ac5$export$496e4f58036bb94d);

var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

const $075d48b841fc8ac5$var$AKInvitePeopleModal = /*#__PURE__*/ (0, $5uXOq.lazy)(()=>(parcelRequire("ecXMV")));

const $075d48b841fc8ac5$var$AKModalTransition = /*#__PURE__*/ (0, $5uXOq.lazy)(()=>(parcelRequire("5LSAq")).then((module)=>({
            default: module.ModalTransition
        })));
const $075d48b841fc8ac5$export$be58429061ae5194 = /*#__PURE__*/ (0, $5uXOq.createContext)({
    isOpen: false,
    openModal: ()=>undefined,
    closeModal: ()=>undefined
});
const $075d48b841fc8ac5$export$496e4f58036bb94d = (invitePeopleModalContextProviderProps)=>{
    const { children: children } = invitePeopleModalContextProviderProps;
    const [invitePeopleState, setInvitePeopleState] = (0, $5uXOq.useState)({
        isOpen: false
    });
    const openModal = (invitePeopleProps, onClose)=>{
        setInvitePeopleState({
            isOpen: true,
            props: invitePeopleProps,
            onClose: onClose
        });
    };
    const closeModal = (0, $5uXOq.useCallback)((trigger)=>{
        if (!invitePeopleState.isOpen) return;
        invitePeopleState.onClose?.(trigger);
        setInvitePeopleState({
            previousProps: invitePeopleState.props,
            isOpen: false
        });
    }, [
        invitePeopleState
    ]);
    const reopenModal = (0, $5uXOq.useCallback)(()=>{
        // Reopen function can only reopen invite people if openModal has been called once with props
        setInvitePeopleState((prevState)=>!prevState.isOpen && prevState.previousProps ? {
                props: prevState.previousProps,
                isOpen: true
            } : prevState);
    }, []);
    const context = (0, $5uXOq.useMemo)(()=>({
            openModal: openModal,
            closeModal: closeModal,
            isOpen: invitePeopleState.isOpen
        }), [
        closeModal,
        invitePeopleState.isOpen
    ]);
    return /*#__PURE__*/ (0, $2OMIu.jsxs)($075d48b841fc8ac5$export$be58429061ae5194.Provider, {
        value: context,
        children: [
            children,
            invitePeopleState.isOpen && /*#__PURE__*/ (0, $2OMIu.jsx)((0, $5uXOq.Suspense), {
                fallback: null,
                children: /*#__PURE__*/ (0, $2OMIu.jsx)($075d48b841fc8ac5$var$AKModalTransition, {
                    children: /*#__PURE__*/ (0, $2OMIu.jsx)($075d48b841fc8ac5$var$AKInvitePeopleModal, {
                        onCloseHandler: closeModal,
                        experimental_onReopenHandler: reopenModal,
                        ...invitePeopleState.props
                    })
                })
            })
        ]
    });
};

});
parcelRegister("ecXMV", function(module, exports) {

let $a580905fed4cc067$var$load = (parcelRequire("28QjX"))(4);
module.exports = Promise.all([
    $a580905fed4cc067$var$load("76n7a"),
    $a580905fed4cc067$var$load("l253H"),
    $a580905fed4cc067$var$load("kNFvF"),
    $a580905fed4cc067$var$load("3GGfo")
]).then(()=>parcelRequire('h8XS8'));

});


parcelRegister("2JsdQ", function(module, exports) {

$parcel$export(module.exports, "useInvitePeopleModal", () => $e68e6d998c14d38d$export$b9ec44715ae5ad99);

var $5uXOq = parcelRequire("5uXOq");

var $fElvF = parcelRequire("fElvF");
const $e68e6d998c14d38d$export$b9ec44715ae5ad99 = (useInvitePeopleModalProps)=>{
    const { onClose: onClose, ...invitePeopleProps } = useInvitePeopleModalProps;
    const { openModal: openModal, closeModal: closeModal, isOpen: isOpen } = (0, $5uXOq.useContext)((0, $fElvF.InvitePeopleModalContext));
    return {
        // this is experimental only and should not be used without consulting !core-invtes in #groot-techops
        experimental_openModal: (propsOverride)=>openModal({
                ...invitePeopleProps,
                ...propsOverride
            }, onClose),
        openModal: ()=>openModal(invitePeopleProps, onClose),
        closeModal: closeModal,
        isOpen: isOpen
    };
};

});

parcelRegister("dNEo8", function(module, exports) {

$parcel$export(module.exports, "JiraInvitePeopleModalContextProvider", () => $dc5bcdd71ba92e9c$export$cdc03757c913ed0);
$parcel$export(module.exports, "useJiraInvitePeopleModalBound", () => $dc5bcdd71ba92e9c$export$569fef33efef0114);

var $5uXOq = parcelRequire("5uXOq");

var $gxYlr = parcelRequire("gxYlr");

var $k9JTq = parcelRequire("k9JTq");

var $cNd4s = parcelRequire("cNd4s");

var $koeKL = parcelRequire("koeKL");
const $dc5bcdd71ba92e9c$var$noop = ()=>null;
const $dc5bcdd71ba92e9c$var$JiraInvitePeopleModalContext = /*#__PURE__*/ (0, $5uXOq.createContext)({
    isOpen: false,
    onOpen: $dc5bcdd71ba92e9c$var$noop,
    onClose: $dc5bcdd71ba92e9c$var$noop
});
const $dc5bcdd71ba92e9c$export$cdc03757c913ed0 = ({ children: children, ...props })=>{
    // new invite people modal requirements
    const cloudId = (0, $koeKL.useCloudId)();
    const appEditions = (0, $k9JTq.useAppEditions)();
    const isSiteAdmin = (0, $cNd4s.useIsSiteAdmin)();
    const [providerState, setProviderState] = (0, $5uXOq.useState)({
        props: {},
        isOpen: false
    });
    const onClose = (0, $5uXOq.useCallback)(()=>{
        setProviderState({
            props: {},
            isOpen: false
        });
    }, []);
    const onOpen = (0, $5uXOq.useCallback)((state)=>{
        setProviderState({
            props: state ?? {},
            isOpen: true
        });
    }, []);
    const value = (0, $5uXOq.useMemo)(()=>({
            isOpen: providerState.isOpen,
            onOpen: onOpen,
            onClose: onClose
        }), [
        providerState.isOpen,
        onOpen,
        onClose
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($dc5bcdd71ba92e9c$var$JiraInvitePeopleModalContext.Provider, {
        value: value
    }, providerState.isOpen ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $gxYlr.default), {
        appEdition: appEditions.software,
        cloudId: cloudId,
        isOpen: providerState.isOpen,
        onClose: onClose,
        isSiteAdmin: isSiteAdmin,
        ...props,
        ...providerState.props
    }) : null, children);
};
const $dc5bcdd71ba92e9c$export$39f09976987c1e17 = ()=>(0, $5uXOq.useContext)($dc5bcdd71ba92e9c$var$JiraInvitePeopleModalContext);
const $dc5bcdd71ba92e9c$export$569fef33efef0114 = (props)=>{
    const { isOpen: isOpen, onOpen: onOpen, onClose: onClose } = (0, $5uXOq.useContext)($dc5bcdd71ba92e9c$var$JiraInvitePeopleModalContext);
    const openModal = (0, $5uXOq.useCallback)(()=>onOpen(props), [
        onOpen,
        props
    ]);
    return {
        isOpen: isOpen,
        openModal: openModal,
        closeModal: onClose
    };
};

});
parcelRegister("gxYlr", function(module, exports) {

$parcel$export(module.exports, "default", () => $0c808453409ea513$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $7CMCs = parcelRequire("7CMCs");

var $lfTZh = parcelRequire("lfTZh");

var $kxZPA = parcelRequire("kxZPA");

// eslint-disable-next-line jira/deprecations/no-rll-client-async-experiences
const $0c808453409ea513$var$LazyComponent = (0, $kxZPA.lazyForPaint)(()=>(parcelRequire("bcZC9")), {
    ssr: false,
    moduleId: "./src/packages/project-settings/jira-invite-people-modal/src/ui/index.tsx"
});
const $0c808453409ea513$export$65d7b8c193fa4f41 = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7CMCs.JSErrorBoundary), {
        id: "async-invite-people-modal",
        packageName: "jira-invite-people-modal",
        teamName: "groot-growth"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $lfTZh.default), {
        name: "jira-invite-people-modal",
        fallback: null
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($0c808453409ea513$var$LazyComponent, props)));
var $0c808453409ea513$export$2e2bcd8739ae039 = $0c808453409ea513$export$65d7b8c193fa4f41;

});
parcelRegister("bcZC9", function(module, exports) {

let $82909c07f8da78c1$var$load = (parcelRequire("28QjX"))(4);
module.exports = Promise.all([
    $82909c07f8da78c1$var$load("ffQaD"),
    $82909c07f8da78c1$var$load("kvRbA"),
    $82909c07f8da78c1$var$load("76n7a"),
    $82909c07f8da78c1$var$load("l253H"),
    $82909c07f8da78c1$var$load("kNFvF"),
    $82909c07f8da78c1$var$load("e0u5J")
]).then(()=>parcelRequire('xET05'));

});






parcelRegister("9i62K", function(module, exports) {

$parcel$export(module.exports, "useShowAssets", () => $ecfb0cbe48af33be$export$6d1797fe1bb33b7a);
$parcel$export(module.exports, "Insight", () => $ecfb0cbe48af33be$export$f9e7e087e1968b4a);

var $5uXOq = parcelRequire("5uXOq");

var $bliJ7 = parcelRequire("bliJ7");

var $7CMCs = parcelRequire("7CMCs");

var $lmyls = parcelRequire("lmyls");

var $8zOmE = parcelRequire("8zOmE");
var $2NMNM = parcelRequire("2NMNM");

var $ktP1V = parcelRequire("ktP1V");

var $ahEft = parcelRequire("ahEft");

var $90yGq = parcelRequire("90yGq");

var $9OXo1 = parcelRequire("9OXo1");

var $4uXxK = parcelRequire("4uXxK");

var $4XiFK = parcelRequire("4XiFK");

var $hFLLE = parcelRequire("hFLLE");
const $ecfb0cbe48af33be$export$6d1797fe1bb33b7a = ()=>{
    const tenantContext = (0, $9OXo1.useTenantContext)();
    const { appPermissions: appPermissions } = tenantContext;
    const isJSMUser = appPermissions.hasServiceDeskAccess;
    if ((0, $ktP1V.isCMDBEnabledInEnvironment)(tenantContext.cmdbDisabledInFedRAMP)) {
        if (isJSMUser) return true;
    }
    return false;
};
const $ecfb0cbe48af33be$var$Insight = ()=>{
    const tenantContext = (0, $9OXo1.useTenantContext)();
    const { appPermissions: appPermissions } = tenantContext;
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $2NMNM.useAnalyticsEvents)();
    const isPremiumUser = (0, $ahEft.isLicensedPremiumUser)(tenantContext);
    const isJSMUser = appPermissions.hasServiceDeskAccess;
    const [hasDismissed] = (0, $bliJ7.useUserHasDismissed)();
    const showUpsell = hasDismissed === false && isJSMUser;
    (0, $5uXOq.useEffect)(()=>{
        if (!isPremiumUser && showUpsell) // fire analytics event only for non-premium users that haven't dimissed the Assets upsell page button.
        (0, $8zOmE.fireTrackAnalytics)(createAnalyticsEvent({}), 'cmdbUpsellPageButton viewed', {
            serviceDeskEdition: tenantContext.appEditions?.serviceDesk,
            isSiteAdmin: tenantContext.isSiteAdmin
        });
    }, [
        createAnalyticsEvent,
        isPremiumUser,
        showUpsell,
        tenantContext.appEditions?.serviceDesk,
        tenantContext.isSiteAdmin
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7CMCs.JSErrorBoundary), {
        id: "InsightNavMenu",
        packageName: "jiraAtlassianNavigation",
        fallback: "unmount"
    }, !isPremiumUser && showUpsell || isPremiumUser ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $hFLLE.InsightMenuItem), null) : null);
};
const $ecfb0cbe48af33be$export$f9e7e087e1968b4a = ()=>{
    const atlassianAccountId = (0, $90yGq.useAccountId)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $4uXxK.TopLevelErrorBoundary), {
        id: (0, $lmyls.MENU_ID).INSIGHT
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $bliJ7.CmdbUpsellPageContainer), {
        isGlobal: true,
        atlassianAccountId: atlassianAccountId
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $4XiFK.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($ecfb0cbe48af33be$var$Insight, null))));
};

});
parcelRegister("bliJ7", function(module, exports) {

$parcel$export(module.exports, "CmdbUpsellPageContainer", () => $215e0f2cc3aecb56$export$185a1503ee62245e);
$parcel$export(module.exports, "useUserHasDismissed", () => $215e0f2cc3aecb56$export$168f6ca47f2dd0d7);
$parcel$export(module.exports, "useCmdbUpsellPageStoreActions", () => $215e0f2cc3aecb56$export$7bdf1f3cf5d7163b);
// eslint-disable-next-line jira/restricted/@atlassian/react-sweet-state

var $3sQ5x = parcelRequire("3sQ5x");
var $gg7kZ = parcelRequire("gg7kZ");
var $iXqE5 = parcelRequire("iXqE5");
var $51nlc = parcelRequire("51nlc");

var $8aeF9 = parcelRequire("8aeF9");
var $9jmKp = parcelRequire("9jmKp");
const $215e0f2cc3aecb56$export$185a1503ee62245e = (0, $gg7kZ.createContainer)();
const $215e0f2cc3aecb56$var$initialState = {
    userHasDismissed: undefined
};
const $215e0f2cc3aecb56$var$store = (0, $iXqE5.createStore)({
    initialState: $215e0f2cc3aecb56$var$initialState,
    actions: $8aeF9,
    containedBy: $215e0f2cc3aecb56$export$185a1503ee62245e,
    handlers: {
        onInit: $9jmKp.fetchInitialState
    }
});
const $215e0f2cc3aecb56$export$168f6ca47f2dd0d7 = (0, $3sQ5x.createHook)($215e0f2cc3aecb56$var$store, {
    selector: (state)=>state.userHasDismissed
});
const $215e0f2cc3aecb56$export$81f35d374558f538 = (0, $3sQ5x.createHook)($215e0f2cc3aecb56$var$store);
const $215e0f2cc3aecb56$export$7bdf1f3cf5d7163b = (0, $3sQ5x.createActionsHook)($215e0f2cc3aecb56$var$store);
const $215e0f2cc3aecb56$export$d766ac3cb3a067c0 = (0, $51nlc.createSubscriber)($215e0f2cc3aecb56$var$store);

});
parcelRegister("8aeF9", function(module, exports) {

$parcel$export(module.exports, "fetchInitialState", () => (parcelRequire("9jmKp")).fetchInitialState);
$parcel$export(module.exports, "toggleShowPage", () => (parcelRequire("hVpHy")).toggleShowPage);
// eslint-disable-next-line @atlassian/eng-health/no-barrel-files/disallow-reexports

var $9jmKp = parcelRequire("9jmKp");

var $hVpHy = parcelRequire("hVpHy");

});
parcelRegister("9jmKp", function(module, exports) {

$parcel$export(module.exports, "fetchInitialState", () => $bf172d9d821cf507$export$84ded0ac7058ab7a);

var $eeyUP = parcelRequire("eeyUP");
const $bf172d9d821cf507$export$84ded0ac7058ab7a = ()=>async ({ setState: setState, getState: getState }, { atlassianAccountId: atlassianAccountId })=>{
        if (getState().userHasDismissed === undefined) {
            const userHasDismissed = await (0, $eeyUP.fetchHasDismissedProperty)(atlassianAccountId);
            setState({
                userHasDismissed: userHasDismissed
            });
        }
    };

});
parcelRegister("eeyUP", function(module, exports) {

$parcel$export(module.exports, "fetchHasDismissedProperty", () => $2f0ac8757ae7c53f$export$872c472220985d8b);

var $89SaW = parcelRequire("89SaW");

var $jcw0u = parcelRequire("jcw0u");

const $2f0ac8757ae7c53f$export$872c472220985d8b = async (atlassianAccountId)=>{
    const meta = {
        id: 'fetchUpsellDismissedProperty',
        packageName: 'jiraCmdbUpsellPage'
    };
    if (atlassianAccountId === null) {
        const error = new Error('atlassianAccountId is null');
        (0, $jcw0u.default)({
            error: error,
            meta: meta
        });
        return false;
    }
    try {
        await (0, $89SaW.getUserProperty)(atlassianAccountId, (0, $8f514cf95b75cc66$export$38c3dc12cf3da533));
        return true;
    } catch (error) {
        if (error instanceof Error && (0, $jcw0u.isNetworkError)(error)) // don't capture analytics for this error as this is expected when a user has dimissed
        return false;
        (0, $jcw0u.default)({
            error: error instanceof Error ? error : undefined,
            meta: meta
        });
        return false;
    }
};

});
const $8f514cf95b75cc66$export$38c3dc12cf3da533 = 'jsm-cmdb-upsell-page-dismissed';



parcelRegister("hVpHy", function(module, exports) {

$parcel$export(module.exports, "toggleShowPage", () => $983267917c332983$export$76132886e83e1a9a);

var $b7zXG = parcelRequire("b7zXG");

var $eWMDa = parcelRequire("eWMDa");
const $983267917c332983$export$76132886e83e1a9a = ()=>async ({ getState: getState, dispatch: dispatch })=>{
        const { userHasDismissed: userHasDismissed } = getState();
        if (userHasDismissed) dispatch((0, $eWMDa.enablePage)());
        else if (userHasDismissed === false) dispatch((0, $b7zXG.dismissPage)());
    };

});
parcelRegister("b7zXG", function(module, exports) {

$parcel$export(module.exports, "dismissPage", () => $54ab437faf58b2ea$export$b6e8cf6e649eeb96);

var $89SaW = parcelRequire("89SaW");

var $jcw0u = parcelRequire("jcw0u");

const $54ab437faf58b2ea$export$b6e8cf6e649eeb96 = ()=>async ({ setState: setState }, { atlassianAccountId: atlassianAccountId })=>{
        // Optimistically hide Assets from the navigation bar immediately
        setState({
            userHasDismissed: true
        });
        try {
            // The specific value being set doesn't matter as long as the property *has* been set
            atlassianAccountId && await (0, $89SaW.setUserProperties)(atlassianAccountId, (0, $8f514cf95b75cc66$export$38c3dc12cf3da533), '1');
        } catch (error) {
            // When setting the user property fails, we still want to hide Assets from the navigation bar
            (0, $jcw0u.default)({
                error: error instanceof Error ? error : undefined,
                meta: {
                    id: 'fetchUpsellDismissedProperty',
                    packageName: 'jiraCmdbUpsellPage'
                }
            });
        }
    };

});

parcelRegister("eWMDa", function(module, exports) {

$parcel$export(module.exports, "enablePage", () => $72e0594a39999a08$export$d904731aa3799771);

var $jcw0u = parcelRequire("jcw0u");


var $5aUqV = parcelRequire("5aUqV");
const $72e0594a39999a08$export$d904731aa3799771 = ()=>async ({ setState: setState }, { atlassianAccountId: atlassianAccountId })=>{
        // Optimistically show Assets in the navigation bar immediately
        setState({
            userHasDismissed: false
        });
        try {
            atlassianAccountId && await (0, $5aUqV.deleteUserProperties)('', atlassianAccountId, (0, $8f514cf95b75cc66$export$38c3dc12cf3da533));
        } catch (error) {
            (0, $jcw0u.default)({
                error: error instanceof Error ? error : undefined,
                meta: {
                    id: 'fetchUpsellEnabledProperty',
                    packageName: 'jiraCmdbUpsellPage'
                }
            });
        }
    };

});
parcelRegister("5aUqV", function(module, exports) {

$parcel$export(module.exports, "deleteUserProperties", () => $9af5c0a0f8e96e9b$export$3de6197fc2f24c03);

var $89SaW = parcelRequire("89SaW");

var $6no39 = parcelRequire("6no39");
const $9af5c0a0f8e96e9b$export$3de6197fc2f24c03 = async (baseUrl, accountId, propertyKey)=>{
    const url = (0, $89SaW.getUserPropertiesUrl)(accountId, propertyKey);
    return fetch(url, {
        ...(0, $6no39.getDefaultOptions)(url),
        method: 'DELETE'
    });
};

});





parcelRegister("hFLLE", function(module, exports) {

$parcel$export(module.exports, "InsightMenuItem", () => $944d4f2112c8b786$export$eb258e2cec2937f9);

var $5uXOq = parcelRequire("5uXOq");

var $koVbs = parcelRequire("koVbs");

var $lmyls = parcelRequire("lmyls");

var $blEB6 = parcelRequire("blEB6");

var $9OXo1 = parcelRequire("9OXo1");

var $4R6GH = parcelRequire("4R6GH");

var $Mp6qH = parcelRequire("Mp6qH");

var $fVbkk = parcelRequire("fVbkk");

var $7rU7r = parcelRequire("7rU7r");
const $944d4f2112c8b786$export$eb258e2cec2937f9 = ()=>{
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const { isSiteAdmin: isSiteAdmin, appEditions: appEditions } = (0, $9OXo1.useTenantContext)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $fVbkk.MenuTrigger), {
        href: (0, $blEB6.getLandingPageUrl)(),
        target: (0, $4R6GH.fg)('assets_as_an_app_v2') ? '_blank' : undefined,
        menuId: (0, $lmyls.MENU_ID).INSIGHT,
        navigationItemId: (0, $Mp6qH.NAVIGATION_ITEM_ID).INSIGHT,
        analyticsAttributes: {
            isSiteAdmin: isSiteAdmin,
            serviceDeskEdition: appEditions?.serviceDesk
        }
    }, formatMessage((0, $7rU7r.default).titleCmdbAssets));
};

});
parcelRegister("blEB6", function(module, exports) {

$parcel$export(module.exports, "ASSETS_APP_ROUTE_PREFIX", () => $587a2dd53fdae2e8$export$42e57fb76a904fc3);
$parcel$export(module.exports, "isInsightRoute", () => $587a2dd53fdae2e8$export$296d80f3ce129968);
$parcel$export(module.exports, "getCreateServiceUrl", () => $587a2dd53fdae2e8$export$1f9b8b558a361aaf);
$parcel$export(module.exports, "getRootPath", () => $587a2dd53fdae2e8$export$5413f45d031c7806);
$parcel$export(module.exports, "getLandingPageUrl", () => $587a2dd53fdae2e8$export$9366da5a373815e5);
$parcel$export(module.exports, "getGlobalConfigUrl", () => $587a2dd53fdae2e8$export$20fd4a0aec335970);
$parcel$export(module.exports, "getDataManagerUrl", () => $587a2dd53fdae2e8$export$c9b27b0d2e19d52f);
$parcel$export(module.exports, "getDataManagerGettingStartedUrl", () => $587a2dd53fdae2e8$export$3d0380185f73b3d);
$parcel$export(module.exports, "getDataManagerObjectClassesUrl", () => $587a2dd53fdae2e8$export$4c9768bc51c7a1a);
$parcel$export(module.exports, "getDataManagerVisualizationUrl", () => $587a2dd53fdae2e8$export$6c3cb6f103b2324);
$parcel$export(module.exports, "getDataManagerAdaptersUrl", () => $587a2dd53fdae2e8$export$cd6b35373ba077a);
$parcel$export(module.exports, "getAssetsReportsUrl", () => $587a2dd53fdae2e8$export$c1909404b7ea317f);
$parcel$export(module.exports, "getAssetsReportUrl", () => $587a2dd53fdae2e8$export$272d35cbff1c220e);
$parcel$export(module.exports, "getAssetsSearchResultsUrl", () => $587a2dd53fdae2e8$export$97bfda8f5f38a121);
$parcel$export(module.exports, "createObjectSchemasUrl", () => $587a2dd53fdae2e8$export$c48ea1282c74411e);
$parcel$export(module.exports, "createObjectSchemaUrl", () => $587a2dd53fdae2e8$export$3a0332e980fe56cf);
$parcel$export(module.exports, "createObjectTypeUrl", () => $587a2dd53fdae2e8$export$cfefb90cfb86b528);
$parcel$export(module.exports, "createObjectSchemaConfigUrl", () => $587a2dd53fdae2e8$export$f02479149ce3cac7);
$parcel$export(module.exports, "createObjectDetailUrl", () => $587a2dd53fdae2e8$export$51e4229f2c7d3866);
$parcel$export(module.exports, "createObjectTypeSettingsUrl", () => $587a2dd53fdae2e8$export$4b4b7d2c3df4fa58);
$parcel$export(module.exports, "createObjectTypeListWithObjectSelectedUrl", () => $587a2dd53fdae2e8$export$c1790fa8f0d8e89a);
$parcel$export(module.exports, "getFeatureUsagePageUrl", () => $587a2dd53fdae2e8$export$5ba89eed0cf60033);
$parcel$export(module.exports, "getFeatureUsageVirtualAgentPageUrl", () => $587a2dd53fdae2e8$export$415502b49e27270d);

var $ebyGx = parcelRequire("ebyGx");

var $4R6GH = parcelRequire("4R6GH");

var $9PhlU = parcelRequire("9PhlU");
const $587a2dd53fdae2e8$export$ee637ecb2dfa4f6a = '/jira/servicedesk/service-modal';
const $587a2dd53fdae2e8$export$42e57fb76a904fc3 = '/jira/assets';
const $587a2dd53fdae2e8$export$80e512187a5e0d10 = '/jira/servicedesk/assets';
const $587a2dd53fdae2e8$export$6d7574dbda22cf7 = '/jira/servicedesk/insight';
const $587a2dd53fdae2e8$export$296d80f3ce129968 = (pathname)=>pathname.includes($587a2dd53fdae2e8$export$6d7574dbda22cf7);
const $587a2dd53fdae2e8$export$1f9b8b558a361aaf = ()=>$587a2dd53fdae2e8$export$ee637ecb2dfa4f6a;
const $587a2dd53fdae2e8$export$5413f45d031c7806 = ()=>(0, $4R6GH.fg)('assets_as_an_app_v2') ? $587a2dd53fdae2e8$export$42e57fb76a904fc3 : $587a2dd53fdae2e8$export$80e512187a5e0d10;
const $587a2dd53fdae2e8$export$9366da5a373815e5 = ()=>$587a2dd53fdae2e8$export$5413f45d031c7806();
const $587a2dd53fdae2e8$export$20fd4a0aec335970 = ()=>`${$587a2dd53fdae2e8$export$5413f45d031c7806()}/configure/global`;
const $587a2dd53fdae2e8$export$c9b27b0d2e19d52f = ()=>`${$587a2dd53fdae2e8$export$5413f45d031c7806()}/data-manager/`;
const $587a2dd53fdae2e8$export$3d0380185f73b3d = ()=>`${$587a2dd53fdae2e8$export$42e57fb76a904fc3}/data-manager/getting-started`;
const $587a2dd53fdae2e8$export$4c9768bc51c7a1a = ()=>`${$587a2dd53fdae2e8$export$42e57fb76a904fc3}/data-manager/object-classes`;
const $587a2dd53fdae2e8$export$6c3cb6f103b2324 = ()=>`${$587a2dd53fdae2e8$export$42e57fb76a904fc3}/data-manager/#/dashboards`;
const $587a2dd53fdae2e8$export$cd6b35373ba077a = ()=>`${$587a2dd53fdae2e8$export$5413f45d031c7806()}/data-manager/adapters/`;
const $587a2dd53fdae2e8$export$c1909404b7ea317f = ()=>`${$587a2dd53fdae2e8$export$5413f45d031c7806()}/reports`;
const $587a2dd53fdae2e8$export$272d35cbff1c220e = (reportId)=>`${$587a2dd53fdae2e8$export$c1909404b7ea317f()}/${reportId}`;
const $587a2dd53fdae2e8$export$97bfda8f5f38a121 = (query)=>`${$587a2dd53fdae2e8$export$5413f45d031c7806()}/search${query ? `?${query}` : ''}`;
const $587a2dd53fdae2e8$export$c48ea1282c74411e = ()=>`${$587a2dd53fdae2e8$export$5413f45d031c7806()}/object-schemas`;
const $587a2dd53fdae2e8$export$3a0332e980fe56cf = (objectSchemaId)=>`${$587a2dd53fdae2e8$export$5413f45d031c7806()}/object-schema/${objectSchemaId}`;
const $587a2dd53fdae2e8$export$cfefb90cfb86b528 = (objectSchemaId, objectTypeId)=>`${$587a2dd53fdae2e8$export$3a0332e980fe56cf(objectSchemaId)}?${(0, $9PhlU.SCHEMA_PAGE_QUERY_PARAMS).objectTypeId}=${objectTypeId}`;
const $587a2dd53fdae2e8$export$f02479149ce3cac7 = (objectSchemaId)=>`${$587a2dd53fdae2e8$export$5413f45d031c7806()}/configure/object-schema/${objectSchemaId}`;
const $587a2dd53fdae2e8$export$51e4229f2c7d3866 = (objectId)=>`${$587a2dd53fdae2e8$export$5413f45d031c7806()}/object/${objectId}`;
const $587a2dd53fdae2e8$export$4b4b7d2c3df4fa58 = (objectTypeId)=>`${$587a2dd53fdae2e8$export$5413f45d031c7806()}/configure/object-type/${objectTypeId}`;
const $587a2dd53fdae2e8$export$c1790fa8f0d8e89a = (objectSchemaId, objectTypeId, objectId)=>`${$587a2dd53fdae2e8$export$cfefb90cfb86b528(objectSchemaId, objectTypeId)}&view=list&objectId=${objectId}`;
const $587a2dd53fdae2e8$export$6e21e6efe57484c5 = (queryParams = {})=>{
    const base = `${$587a2dd53fdae2e8$export$42e57fb76a904fc3}/search`;
    if (Object.keys(queryParams).length > 0) {
        const encodedParams = (0, (/*@__PURE__*/$parcel$interopDefault($ebyGx))).stringify(queryParams);
        return `${base}?${encodedParams}`;
    }
    return base;
};
const $587a2dd53fdae2e8$export$5ba89eed0cf60033 = ({ showChangeLimitModal: showChangeLimitModal } = {})=>`/jira/settings/products/servicedesk/feature-usage?feature=assets${showChangeLimitModal ? '&changeLimit=true' : ''}`;
const $587a2dd53fdae2e8$export$415502b49e27270d = ({ showChangeLimitModal: showChangeLimitModal } = {})=>`/jira/settings/products/servicedesk/feature-usage?feature=virtual-agent${showChangeLimitModal ? '&changeLimit=true' : ''}`;

});
parcelRegister("9PhlU", function(module, exports) {

$parcel$export(module.exports, "SCHEMA_PAGE_QUERY_PARAMS", () => $dee65df3d835c7b2$export$a73deb42718b5c4);
$parcel$export(module.exports, "TAB_QUERY_PARAM_REFERENCE_TYPES", () => $dee65df3d835c7b2$export$f7855185bab37329);
$parcel$export(module.exports, "TAB_QUERY_PARAM_STATUSES", () => $dee65df3d835c7b2$export$3739ebbc7c6e87e8);
$parcel$export(module.exports, "TAB_QUERY_PARAM_ICONS", () => $dee65df3d835c7b2$export$2c22dc6c729ae0bd);
$parcel$export(module.exports, "TAB_QUERY_PARAM_DATA_MANAGER", () => $dee65df3d835c7b2$export$f37b3a97acf56eaf);
$parcel$export(module.exports, "TAB_QUERY_PARAM_GENERAL", () => $dee65df3d835c7b2$export$12ebb1d5017e1d6d);
$parcel$export(module.exports, "TAB_QUERY_PARAM_ROLES", () => $dee65df3d835c7b2$export$a77734d9ea30fe44);
$parcel$export(module.exports, "TAB_QUERY_PARAM_IMPORT", () => $dee65df3d835c7b2$export$be37b820df30c947);
$parcel$export(module.exports, "TAB_QUERY_PARAM_INHERITANCE", () => $dee65df3d835c7b2$export$670faa8ae93e0903);
$parcel$export(module.exports, "useUpdateQueryParams", () => $dee65df3d835c7b2$export$e66acc5f4583ce1c);
$parcel$export(module.exports, "useObjectTypeIdQueryParam", () => $dee65df3d835c7b2$export$f5a33d51dd6de08);
$parcel$export(module.exports, "useObjectIdQueryParam", () => $dee65df3d835c7b2$export$a6e3187c87554a1e);
$parcel$export(module.exports, "useSchemaViewModeQueryParam", () => $dee65df3d835c7b2$export$6abda0ad26022eff);
$parcel$export(module.exports, "useObjectViewModeQueryParam", () => $dee65df3d835c7b2$export$1927b50f7d074492);

var $5uXOq = parcelRequire("5uXOq");

var $ebyGx = parcelRequire("ebyGx");

var $5Ny9E = parcelRequire("5Ny9E");

var $ieDtd = parcelRequire("ieDtd");
var $doZTA = parcelRequire("doZTA");
var $lVJAU = parcelRequire("lVJAU");
const $dee65df3d835c7b2$export$a73deb42718b5c4 = {
    // Values are 'object' or 'attribute'
    schemaMode: 'mode',
    // Values are 'list' or undefined
    objectViewMode: 'view',
    // Both of these params are supported to set the object type ID. 'typeId' is preferred and is the one that is updated.
    // 'objecttypeid' is only used on initial load to support customers who have bookmarked this URL.
    objectTypeId: 'typeId',
    fallbackObjectTypeId: 'objecttypeid',
    objectId: 'objectId'
};
const $dee65df3d835c7b2$export$f7855185bab37329 = 'reference-types';
const $dee65df3d835c7b2$export$3739ebbc7c6e87e8 = 'statuses';
const $dee65df3d835c7b2$export$2c22dc6c729ae0bd = 'icons';
const $dee65df3d835c7b2$export$f37b3a97acf56eaf = 'data-manager';
const $dee65df3d835c7b2$export$12ebb1d5017e1d6d = 'general';
const $dee65df3d835c7b2$export$a77734d9ea30fe44 = 'roles';
const $dee65df3d835c7b2$export$be37b820df30c947 = 'import';
const $dee65df3d835c7b2$export$670faa8ae93e0903 = 'inheritance';
const $dee65df3d835c7b2$export$e66acc5f4583ce1c = ()=>{
    const { push: push } = (0, $lVJAU.useRouterActions)();
    const [{ location: location }] = (0, $doZTA.useRouter)();
    const updateQueryParams = (0, $5uXOq.useCallback)((queryParams = {})=>{
        const { pathname: pathname, search: search } = location;
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        const updatedQueryParams = {};
        Object.keys(queryParams).forEach((key)=>{
            updatedQueryParams[key] = queryParams[key] ?? undefined;
        });
        return `${pathname}?${(0, (/*@__PURE__*/$parcel$interopDefault($ebyGx))).stringify({
            ...(0, (/*@__PURE__*/$parcel$interopDefault($ebyGx))).parse(search),
            ...updatedQueryParams
        })}`;
    }, [
        location
    ]);
    const pushRouterAction = (0, $5uXOq.useCallback)((path)=>{
        push(path);
    }, [
        push
    ]);
    return [
        {
            updateQueryParams: updateQueryParams,
            pushRouterAction: pushRouterAction
        }
    ];
};
const $dee65df3d835c7b2$export$f5a33d51dd6de08 = ()=>{
    const [objectTypeId, setObjectTypeId] = (0, $ieDtd.useQueryParam)($dee65df3d835c7b2$export$a73deb42718b5c4.objectTypeId);
    const [fallbackObjectTypeId, setFallbackObjectTypeId] = (0, $ieDtd.useQueryParam)($dee65df3d835c7b2$export$a73deb42718b5c4.fallbackObjectTypeId);
    (0, $5uXOq.useEffect)(()=>{
        if (fallbackObjectTypeId !== undefined) {
            setObjectTypeId((0, $5Ny9E.toCmdbObjectTypeId)(fallbackObjectTypeId), 'replace');
            setFallbackObjectTypeId(undefined, 'replace');
        }
    }, [
        fallbackObjectTypeId,
        setObjectTypeId,
        setFallbackObjectTypeId
    ]);
    const nullableMain = objectTypeId !== undefined ? (0, $5Ny9E.toCmdbObjectTypeId)(objectTypeId) : null;
    const nullableFallback = fallbackObjectTypeId !== undefined ? (0, $5Ny9E.toCmdbObjectTypeId)(fallbackObjectTypeId) : null;
    const setter = (newObjectTypeId, updateType)=>{
        setObjectTypeId(newObjectTypeId !== null ? newObjectTypeId : undefined, updateType);
    };
    return [
        nullableMain !== null ? nullableMain : nullableFallback,
        setter
    ];
};
const $dee65df3d835c7b2$export$a6e3187c87554a1e = ()=>{
    const [objectId, setObjectId] = (0, $ieDtd.useQueryParam)($dee65df3d835c7b2$export$a73deb42718b5c4.objectId);
    const nullableObjectId = objectId !== undefined ? (0, $5Ny9E.toCmdbObjectId)(objectId) : null;
    const setter = (newObjectId, updateType)=>{
        setObjectId(newObjectId !== null ? newObjectId : undefined, updateType);
    };
    return [
        nullableObjectId,
        setter
    ];
};
const $dee65df3d835c7b2$export$6abda0ad26022eff = ()=>{
    const [rawParamValue, setSchemaMode] = (0, $ieDtd.useQueryParam)($dee65df3d835c7b2$export$a73deb42718b5c4.schemaMode);
    const schemaMode = rawParamValue === 'attribute' ? 'attribute' : 'object';
    return [
        schemaMode,
        setSchemaMode
    ];
};
const $dee65df3d835c7b2$export$1927b50f7d074492 = ()=>{
    const [rawParamValue, setObjectViewMode] = (0, $ieDtd.useQueryParam)($dee65df3d835c7b2$export$a73deb42718b5c4.objectViewMode);
    const objectViewMode = rawParamValue === 'list' ? 'list' : 'details';
    const setter = (newValue, updateMode)=>{
        setObjectViewMode(newValue === 'list' ? 'list' : undefined, updateMode);
    };
    return [
        objectViewMode,
        setter
    ];
};

});


parcelRegister("7rU7r", function(module, exports) {

$parcel$export(module.exports, "default", () => $421905193c27f8ab$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $421905193c27f8ab$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    titleCmdbAssets: {
        "id": "atlassian-navigation.insight.title-cmdb-assets",
        "defaultMessage": "Assets"
    }
});

});



parcelRegister("el0Fl", function(module, exports) {

$parcel$export(module.exports, "Roadmaps", () => $767dc22cd21e9a9b$export$a68bc1ba98e0d580);

var $5uXOq = parcelRequire("5uXOq");

var $5Fk4Z = parcelRequire("5Fk4Z");

var $koVbs = parcelRequire("koVbs");

var $lmyls = parcelRequire("lmyls");

var $aOD49 = parcelRequire("aOD49");

var $dWQF5 = parcelRequire("dWQF5");

var $9OXo1 = parcelRequire("9OXo1");

var $d9ulS = parcelRequire("d9ulS");

var $fClqt = parcelRequire("fClqt");

var $4R6GH = parcelRequire("4R6GH");

var $90yGq = parcelRequire("90yGq");

var $cAcWf = parcelRequire("cAcWf");

var $Mp6qH = parcelRequire("Mp6qH");

var $4uXxK = parcelRequire("4uXxK");

var $fVbkk = parcelRequire("fVbkk");

var $6yVM4 = parcelRequire("6yVM4");
const $767dc22cd21e9a9b$export$9564042b1b0a7d8f = ()=>{
    const { appPermissions: appPermissions } = (0, $9OXo1.useTenantContext)();
    const isRoadmapsEnabled = (0, $dWQF5.useIsCrossProjectViewsEnabled)();
    return appPermissions.hasProductDiscoveryAccess && isRoadmapsEnabled;
};
const $767dc22cd21e9a9b$export$90296ede40c0af4a = ()=>{
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const { isSiteAdmin: isSiteAdmin } = (0, $9OXo1.useTenantContext)();
    const accountId = (0, $90yGq.useAccountId)();
    // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
    const isJpdProjectView = window?.location.pathname.includes('/jira/polaris/projects');
    const menuTrigger = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $fVbkk.MenuTrigger), {
        href: (0, $aOD49.getCollectionsPageUrl)(),
        menuId: (0, $lmyls.MENU_ID).ROADMAPS,
        navigationItemId: (0, $Mp6qH.NAVIGATION_ITEM_ID).ROADMAPS,
        analyticsAttributes: {
            isSiteAdmin: isSiteAdmin
        }
    }, formatMessage((0, $6yVM4.default).titleJpdRoadmaps));
    if (!isJpdProjectView || !(0, $4R6GH.fg)('polaris_roadmaps_introduction_spotlight')) return menuTrigger;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $cAcWf.OnboardingFlowsContainer), {
        accountId: accountId
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5Fk4Z.default), {
        name: (0, $d9ulS.ROADMAP_INTRODUCTION_SPOTLIGHT)
    }, menuTrigger, isJpdProjectView && (0, $4R6GH.fg)('polaris_roadmaps_introduction_spotlight') && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $fClqt.RoadmapIntroductionSpotlight), {
        collectionsUrl: (0, $aOD49.getCollectionsPageUrl)(),
        placement: "bottom center"
    })));
};
const $767dc22cd21e9a9b$export$a68bc1ba98e0d580 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $4uXxK.TopLevelErrorBoundary), {
        id: (0, $lmyls.MENU_ID).ROADMAPS
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($767dc22cd21e9a9b$export$90296ede40c0af4a, null));

});
parcelRegister("aOD49", function(module, exports) {

$parcel$export(module.exports, "getCollectionDetailsPageUrl", () => $a92ae6c7b428c3ad$export$6d4e7a90e74e9b12);
$parcel$export(module.exports, "getCollectionViewPageUrl", () => $a92ae6c7b428c3ad$export$32ac8841347e1f79);
$parcel$export(module.exports, "getCollectionsPageUrl", () => $a92ae6c7b428c3ad$export$d15219b9c6a3e2f7);
const $a92ae6c7b428c3ad$var$withQueryParams = (path, queryParams)=>{
    if (queryParams) {
        const searchParams = new URLSearchParams();
        Object.keys(queryParams).forEach((key)=>{
            if (queryParams[key]) searchParams.set(key, queryParams[key]);
        });
        if (searchParams.size > 0) return `${path}?${searchParams.toString()}`;
    }
    return path;
};
const $a92ae6c7b428c3ad$export$6d4e7a90e74e9b12 = (collectionUUID)=>`/jira/polaris/roadmaps/${collectionUUID}/view`;
const $a92ae6c7b428c3ad$export$32ac8841347e1f79 = (collectionUUID, viewUUID, queryParams)=>$a92ae6c7b428c3ad$var$withQueryParams(`/jira/polaris/roadmaps/${collectionUUID}/view/${viewUUID}`, queryParams);
const $a92ae6c7b428c3ad$export$d15219b9c6a3e2f7 = (queryParams)=>$a92ae6c7b428c3ad$var$withQueryParams('/jira/polaris/roadmaps', queryParams);

});

parcelRegister("d9ulS", function(module, exports) {

$parcel$export(module.exports, "GO_TO_PROJECT_SPOTLIGHT_DISMISSED", () => $033135e4463a547c$export$d4b65c1c7753dab5);
$parcel$export(module.exports, "GLOBAL_FIELDS_TOUR_DISMISSED", () => $033135e4463a547c$export$5ca3ca33630ba93c);
$parcel$export(module.exports, "EXPLORE_SECTION_MESSAGE_DISMISSED", () => $033135e4463a547c$export$a81698c00c65eb4a);
$parcel$export(module.exports, "SEEN_PULSATING_FIELDS_BUTTON", () => $033135e4463a547c$export$3085446206860099);
$parcel$export(module.exports, "PROJECT_FIELDS_TOUR_DISMISSED", () => $033135e4463a547c$export$d32c1bbde6ae670d);
$parcel$export(module.exports, "PROJECT_FIELDS_PAGE_VIEWED", () => $033135e4463a547c$export$ca2e8a74c8b43637);
$parcel$export(module.exports, "TIMELINE_DATES_CONFIG_SECTION_MESSAGE_DISMISSED", () => $033135e4463a547c$export$c6877be73b5f3d5a);
$parcel$export(module.exports, "COLLECTIONS_TOUR_DISMISSED", () => $033135e4463a547c$export$9a1ee3e31621d60);
$parcel$export(module.exports, "PREMIUM_MODAL_DISMISSED", () => $033135e4463a547c$export$522f4dc72dc494f2);
$parcel$export(module.exports, "PREMIUM_LAST_VISIT", () => $033135e4463a547c$export$34f7000ddecc0e7f);
$parcel$export(module.exports, "CROSS_PROJECT_VIEW_TOUR_DISMISSED", () => $033135e4463a547c$export$1be797d9a57b42ac);
$parcel$export(module.exports, "VIEW_PERMISSIONS_LOCK_SPOTLIGHT_DISMISSED", () => $033135e4463a547c$export$94164335b70940ae);
$parcel$export(module.exports, "CROSS_PROJECT_LIST_VIEW_FIELDS_DISMISSED_KEY", () => $033135e4463a547c$export$c176277d0ae24685);
$parcel$export(module.exports, "CROSS_PROJECT_TIMELINE_VIEW_FIELDS_DISMISSED_KEY", () => $033135e4463a547c$export$dc14a417cdf40a4e);
$parcel$export(module.exports, "CROSS_PROJECT_BOARD_VIEW_FIELDS_DISMISSED_KEY", () => $033135e4463a547c$export$76d94539e8fefb4a);
$parcel$export(module.exports, "CROSS_PROJECT_MATRIX_VIEW_FIELDS_DISMISSED_KEY", () => $033135e4463a547c$export$c98b8b1065f15440);
$parcel$export(module.exports, "INVITE_FROM_SHARE_DIALOG_SPOTLIGHT_DISMISSED", () => $033135e4463a547c$export$a7071dd1945a163a);
$parcel$export(module.exports, "USER_PROPERTY_BY_STATE_KEY", () => $033135e4463a547c$export$61a0683bfb4060d7);
$parcel$export(module.exports, "GLOBAL_FIELDS_TOUR_SPOTLIGHTS_STEP_1", () => $033135e4463a547c$export$34cb8e95f71c5026);
$parcel$export(module.exports, "GLOBAL_FIELDS_TOUR_SPOTLIGHTS_STEP_2", () => $033135e4463a547c$export$7f842ac8d21dd77c);
$parcel$export(module.exports, "GLOBAL_FIELDS_TOUR_SPOTLIGHTS_STEP_3", () => $033135e4463a547c$export$bd207a2522aeeba4);
$parcel$export(module.exports, "GLOBAL_FIELDS_TOUR_SPOTLIGHTS_STEP_4", () => $033135e4463a547c$export$204b6702ab1fae0e);
$parcel$export(module.exports, "GLOBAL_FIELDS_TOUR_SPOTLIGHTS_STEP_LAST", () => $033135e4463a547c$export$14b1ce7029803351);
$parcel$export(module.exports, "GLOBAL_FIELDS_GO_TO_PROJECT_SPOTLIGHT", () => $033135e4463a547c$export$4aa3d2e1dc759f3c);
$parcel$export(module.exports, "PROJECT_FIELDS_TOUR_SPOTLIGHTS_STEP_1", () => $033135e4463a547c$export$c1ff7f4df78bdbc4);
$parcel$export(module.exports, "PROJECT_FIELDS_TOUR_SPOTLIGHTS_STEP_2", () => $033135e4463a547c$export$465e1e9058d0a33e);
$parcel$export(module.exports, "PROJECT_FIELDS_TOUR_SPOTLIGHTS_STEP_3", () => $033135e4463a547c$export$22cb3b19b9a67a4);
$parcel$export(module.exports, "PROJECT_FIELDS_TOUR_SPOTLIGHTS_STEP_4", () => $033135e4463a547c$export$639255389f81ee25);
$parcel$export(module.exports, "PROJECT_FIELDS_TOUR_SPOTLIGHTS_STEP_5", () => $033135e4463a547c$export$5420b6f468b681cb);
$parcel$export(module.exports, "PROJECT_FIELDS_TOUR_SPOTLIGHTS_STEP_LAST", () => $033135e4463a547c$export$b51c0dd69192efcd);
$parcel$export(module.exports, "COLLECTIONS_CREATE_ROADMAP_SPOTLIGHT", () => $033135e4463a547c$export$1e3c409324b9e1c8);
$parcel$export(module.exports, "COLLECTIONS_CREATE_ROADMAP_SPOTLIGHT_DISMISSED", () => $033135e4463a547c$export$960902aa280e7c02);
$parcel$export(module.exports, "CROSS_PROJECT_VIEW_TOUR_SPOTLIGHTS_STEP_1", () => $033135e4463a547c$export$a2cbd84444b19ad9);
$parcel$export(module.exports, "CROSS_PROJECT_VIEW_TOUR_SPOTLIGHTS_STEP_LAST", () => $033135e4463a547c$export$1ecd157040cc790b);
$parcel$export(module.exports, "JPD_NAV_VIEWS_SPOTLIGHT", () => $033135e4463a547c$export$f0a483c398048551);
$parcel$export(module.exports, "NAV_JPD_VIEWS_SPOTLIGHT_DISMISSED", () => $033135e4463a547c$export$6e3db205cdfcc126);
$parcel$export(module.exports, "PRIORITIZATION_VIEW_TOUR_SPOTLIGHTS_STEP_1", () => $033135e4463a547c$export$6231ca46e95bc736);
$parcel$export(module.exports, "PRIORITIZATION_VIEW_TOUR_SPOTLIGHTS_STEP_LAST", () => $033135e4463a547c$export$cd247efd7ec3525c);
$parcel$export(module.exports, "PRIORITIZATION_VIEW_TOUR_DISMISSED", () => $033135e4463a547c$export$2c379250399a65);
$parcel$export(module.exports, "ROADMAP_VIEW_SPOTLIGHT", () => $033135e4463a547c$export$3134ae340fb4ae39);
$parcel$export(module.exports, "ROADMAP_VIEW_SPOTLIGHT_DISMISSED", () => $033135e4463a547c$export$6ec637a8d4b52e12);
$parcel$export(module.exports, "ROADMAP_COLUMN_CONFIG_SPOTLIGHT", () => $033135e4463a547c$export$10bda8c91e48ff2c);
$parcel$export(module.exports, "ROADMAP_COLUMN_CONFIG_SPOTLIGHT_DISMISSED", () => $033135e4463a547c$export$4c25160b46095f67);
$parcel$export(module.exports, "ROADMAP_INTRODUCTION_SPOTLIGHT", () => $033135e4463a547c$export$ec0f5ceae1abcc93);
$parcel$export(module.exports, "ROADMAP_INTRODUCTION_SPOTLIGHT_DISMISSED", () => $033135e4463a547c$export$4aa206dd068119fd);
$parcel$export(module.exports, "ROADMAP_INTRODUCTION_SPOTLIGHT_PREREQUISITE_DISMISSALS", () => $033135e4463a547c$export$84d5c6b713e2a436);
$parcel$export(module.exports, "PRODUCT_START_TIMESTAMP", () => $033135e4463a547c$export$810ba1749ac4ea65);
$parcel$export(module.exports, "VIEW_CREATOR_TOUR_SPOTLIGHTS", () => $033135e4463a547c$export$bc58a8e989fbe3bc);
$parcel$export(module.exports, "VIEW_CREATOR_TOUR_SPOTLIGHTS_STEP_1", () => $033135e4463a547c$export$414ec9dafc5e9628);
$parcel$export(module.exports, "VIEW_CREATOR_TOUR_SPOTLIGHTS_STEP_2", () => $033135e4463a547c$export$a546fb30dcbeb6b5);
$parcel$export(module.exports, "VIEW_CREATOR_TOUR_SPOTLIGHTS_STEP_3", () => $033135e4463a547c$export$dc3c81a11cac598);
$parcel$export(module.exports, "VIEW_CREATOR_TOUR_SPOTLIGHTS_STEP_4", () => $033135e4463a547c$export$620c0e8c369ed103);
// User property names
const $033135e4463a547c$export$d4b65c1c7753dab5 = 'polaris.global-fields.go-to-project-spotlight-dismissed';
const $033135e4463a547c$export$5ca3ca33630ba93c = 'polaris.global-fields.tour-dismissed';
const $033135e4463a547c$export$a81698c00c65eb4a = 'polaris.project-fields.explore-section-message-dismissed';
const $033135e4463a547c$export$3085446206860099 = 'polaris.project-fields.seen-pulsating-fields-button';
const $033135e4463a547c$export$d32c1bbde6ae670d = 'polaris.project-fields.tour-dismissed';
const $033135e4463a547c$export$ca2e8a74c8b43637 = 'polaris.project-fields.page-viewed';
const $033135e4463a547c$export$c6877be73b5f3d5a = 'polaris.timeline.dates-config-section-message-dismissed';
const $033135e4463a547c$export$9a1ee3e31621d60 = 'polaris.collections.tour-dismissed';
const $033135e4463a547c$export$522f4dc72dc494f2 = 'polaris.premium.modal-dismissed';
const $033135e4463a547c$export$34f7000ddecc0e7f = 'polaris.premium.last-visit';
const $033135e4463a547c$export$1be797d9a57b42ac = 'polaris.cross-project-view.tour-dismissed';
const $033135e4463a547c$export$94164335b70940ae = 'polaris.view-permissions-lock.spotlight-dismissed';
const $033135e4463a547c$var$CROSS_PROJECT_VIEW_LIST_FIELDS_DISMISSED = 'polaris.cross-project-view.list-fields-dismissed';
const $033135e4463a547c$var$CROSS_PROJECT_VIEW_TIMELINE_FIELDS_DISMISSED = 'polaris.cross-project-view.timeline-fields-dismissed';
const $033135e4463a547c$var$CROSS_PROJECT_VIEW_BOARD_FIELDS_DISMISSED = 'polaris.cross-project-view.board-fields-dismissed';
const $033135e4463a547c$var$CROSS_PROJECT_VIEW_MATRIX_FIELDS_DISMISSED = 'polaris.cross-project-view.matrix-fields-dismissed';
const $033135e4463a547c$export$c176277d0ae24685 = 'listViewfieldsDismissed';
const $033135e4463a547c$export$dc14a417cdf40a4e = 'timelineViewfieldsDismissed';
const $033135e4463a547c$export$76d94539e8fefb4a = 'boardViewfieldsDismissed';
const $033135e4463a547c$export$c98b8b1065f15440 = 'matrixViewfieldsDismissed';
const $033135e4463a547c$export$a7071dd1945a163a = 'polaris.share-dialog.invite.spotlight-dismissed';
const $033135e4463a547c$export$61a0683bfb4060d7 = {
    [$033135e4463a547c$export$c176277d0ae24685]: $033135e4463a547c$var$CROSS_PROJECT_VIEW_LIST_FIELDS_DISMISSED,
    [$033135e4463a547c$export$dc14a417cdf40a4e]: $033135e4463a547c$var$CROSS_PROJECT_VIEW_TIMELINE_FIELDS_DISMISSED,
    [$033135e4463a547c$export$76d94539e8fefb4a]: $033135e4463a547c$var$CROSS_PROJECT_VIEW_BOARD_FIELDS_DISMISSED,
    [$033135e4463a547c$export$c98b8b1065f15440]: $033135e4463a547c$var$CROSS_PROJECT_VIEW_MATRIX_FIELDS_DISMISSED
};
const $033135e4463a547c$export$34cb8e95f71c5026 = 'global-fields.tour.spotlights.step-1';
const $033135e4463a547c$export$7f842ac8d21dd77c = 'global-fields.tour.spotlights.step-2';
const $033135e4463a547c$export$bd207a2522aeeba4 = 'global-fields.tour.spotlights.step-3';
const $033135e4463a547c$export$204b6702ab1fae0e = 'global-fields.tour.spotlights.step-4';
const $033135e4463a547c$export$14b1ce7029803351 = 'global-fields.tour.spotlights.step-last';
const $033135e4463a547c$export$4aa3d2e1dc759f3c = 'global-fields.go-to-project.spotlight';
const $033135e4463a547c$export$c1ff7f4df78bdbc4 = 'project-fields.tour.spotlights.step-1';
const $033135e4463a547c$export$465e1e9058d0a33e = 'project-fields.tour.spotlights.step-2';
const $033135e4463a547c$export$22cb3b19b9a67a4 = 'project-fields.tour.spotlights.step-3';
const $033135e4463a547c$export$639255389f81ee25 = 'project-fields.tour.spotlights.step-4';
const $033135e4463a547c$export$5420b6f468b681cb = 'project-fields.tour.spotlights.step-5';
const $033135e4463a547c$export$b51c0dd69192efcd = 'project-fields.tour.spotlights.step-last';
const $033135e4463a547c$export$1e3c409324b9e1c8 = 'collections.create-roadmap.spotlight';
const $033135e4463a547c$export$960902aa280e7c02 = 'collections.create-roadmap.spotlight-dismissed';
const $033135e4463a547c$export$a2cbd84444b19ad9 = 'cross-project-view.tour.spotlights.step-1';
const $033135e4463a547c$export$1ecd157040cc790b = 'cross-project-view.tour.spotlights.step-last';
const $033135e4463a547c$export$f0a483c398048551 = 'jpd-nav-views.spotlight';
const $033135e4463a547c$export$6e3db205cdfcc126 = 'polaris.nav-jpd-views.spotlight-dismissed';
const $033135e4463a547c$export$6231ca46e95bc736 = 'prioritization-view.tour.spotlights.step-1';
const $033135e4463a547c$export$cd247efd7ec3525c = 'prioritization-view.tour.spotlights.step-last';
const $033135e4463a547c$export$2c379250399a65 = 'polaris.prioritization-view.tour-dismissed';
const $033135e4463a547c$export$3134ae340fb4ae39 = 'roadmap-view.spotlight';
const $033135e4463a547c$export$6ec637a8d4b52e12 = 'polaris.roadmap-view.spotlight-dismissed';
const $033135e4463a547c$export$10bda8c91e48ff2c = 'roadmap-view.column-config.spotlight';
const $033135e4463a547c$export$4c25160b46095f67 = 'polaris.roadmap-view.column-config-spotlight-dismissed';
const $033135e4463a547c$export$ec0f5ceae1abcc93 = 'roadmap.introduction.spotlight';
const $033135e4463a547c$export$4aa206dd068119fd = 'roadmap.introduction.spotlight.dismissed';
const $033135e4463a547c$export$ef2e4b0f650c3249 = 'roadmap-view.initial-prompt.spotlight';
const $033135e4463a547c$export$84d5c6b713e2a436 = [
    $033135e4463a547c$export$522f4dc72dc494f2,
    $033135e4463a547c$export$6e3db205cdfcc126
];
const $033135e4463a547c$export$810ba1749ac4ea65 = 'polaris.product-start-timestamp';
const $033135e4463a547c$export$bc58a8e989fbe3bc = 'polaris.view-creator.spotlight';
const $033135e4463a547c$export$414ec9dafc5e9628 = 'view-creator.tour.spotlights.step-1';
const $033135e4463a547c$export$a546fb30dcbeb6b5 = 'view-creator.tour.spotlights.step-2';
const $033135e4463a547c$export$dc3c81a11cac598 = 'view-creator.tour.spotlights.step-3';
const $033135e4463a547c$export$620c0e8c369ed103 = 'view-creator.tour.spotlights.step-4';

});

parcelRegister("fClqt", function(module, exports) {

$parcel$export(module.exports, "RoadmapIntroductionSpotlight", () => $4083f42e34bf2006$export$71e9b7b9d410b300);

var $5uXOq = parcelRequire("5uXOq");

var $1QiBP = parcelRequire("1QiBP");

var $koVbs = parcelRequire("koVbs");

var $8zOmE = parcelRequire("8zOmE");
var $2NMNM = parcelRequire("2NMNM");

var $ehdJY = parcelRequire("ehdJY");

var $daoB1 = parcelRequire("daoB1");

var $lVJAU = parcelRequire("lVJAU");

var $fD6iO = parcelRequire("fD6iO");

var $4R6GH = parcelRequire("4R6GH");

var $d9ulS = parcelRequire("d9ulS");

var $cAcWf = parcelRequire("cAcWf");

var $7qsHB = parcelRequire("7qsHB");

var $jhE94 = parcelRequire("jhE94");

var $9V003 = parcelRequire("9V003");

var $3aLoA = parcelRequire("3aLoA");
const $4083f42e34bf2006$export$8130629f6db139c2 = ()=>{
    const { hasProductDiscoveryAccess: hasProductDiscoveryAccess } = (0, $daoB1.useApplicationPermissions)() ?? {};
    return Boolean(hasProductDiscoveryAccess);
};
const $4083f42e34bf2006$export$71e9b7b9d410b300 = ({ collectionsUrl: collectionsUrl, placement: placement })=>{
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const isLicensedUser = $4083f42e34bf2006$export$8130629f6db139c2();
    const { push: push } = (0, $lVJAU.useRouterActions)();
    const expandSideNav = (0, $fD6iO.useExpandSideNav)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $2NMNM.useAnalyticsEvents)();
    // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
    const isAlreadyInRoadmaps = window?.location.href.includes('roadmap');
    const { loadRoadmapIntroductionDismissed: loadRoadmapIntroductionDismissed, loadRoadmapIntroductionPrerequisiteDismissalsMet: loadRoadmapIntroductionPrerequisiteDismissalsMet, loadProductUsageStartTimestamp: loadProductUsageStartTimestamp, setRoadmapIntroductionDismissed: setRoadmapIntroductionDismissed } = (0, $cAcWf.useOnboardingFlowsActions)();
    (0, $5uXOq.useEffect)(()=>{
        // we can prevent unnecessary calls in these cases
        if (isAlreadyInRoadmaps || !isLicensedUser) return;
        loadRoadmapIntroductionDismissed();
        loadRoadmapIntroductionPrerequisiteDismissalsMet();
        loadProductUsageStartTimestamp();
    }, [
        isAlreadyInRoadmaps,
        isLicensedUser,
        loadProductUsageStartTimestamp,
        loadRoadmapIntroductionDismissed,
        loadRoadmapIntroductionPrerequisiteDismissalsMet
    ]);
    const isIntroductionDismissed = (0, $7qsHB.useCollectionsIntroductionDismissed)();
    const arePrerequisiteDismissalsMet = (0, $7qsHB.useCollectionsIntroductionPrerequisiteDismissalsMet)();
    const productUsageStartTimestamp = (0, $jhE94.useProductUsageStartTimestamp)();
    if (isAlreadyInRoadmaps || !isLicensedUser || isIntroductionDismissed === undefined || isIntroductionDismissed || !arePrerequisiteDismissalsMet || !(0, $3aLoA.checkIfOlderThanNDays)(productUsageStartTimestamp)) return null;
    const dismiss = (analyticsEvent)=>{
        (0, $8zOmE.fireUIAnalytics)(analyticsEvent, 'dismiss');
        setRoadmapIntroductionDismissed();
    };
    const openRoadmaps = (analyticsEvent)=>{
        if (analyticsEvent) (0, $8zOmE.fireUIAnalytics)(analyticsEvent, 'openRoadmaps');
        else (0, $8zOmE.fireUIAnalytics)(createAnalyticsEvent({
            action: 'clicked',
            actionSubject: 'button'
        }), 'openRoadmaps');
        setRoadmapIntroductionDismissed();
        push(collectionsUrl);
    };
    if ((0, $4R6GH.fg)('polaris_expand_sidenav_for_roadmaps_spotlight')) expandSideNav();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $1QiBP.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $ehdJY.JiraSpotlight), {
        actions: [
            {
                onClick: (_, analyticsEvent)=>dismiss(analyticsEvent),
                text: formatMessage((0, $9V003.messages).dismiss),
                testId: 'roadmap-introduction-spotlight-dismiss-button'
            },
            {
                onClick: (_, analyticsEvent)=>openRoadmaps(analyticsEvent),
                text: formatMessage((0, $9V003.messages).giveItATry)
            }
        ],
        dialogPlacement: placement,
        dialogWidth: 275,
        target: (0, $d9ulS.ROADMAP_INTRODUCTION_SPOTLIGHT),
        key: (0, $d9ulS.ROADMAP_INTRODUCTION_SPOTLIGHT),
        targetRadius: 3,
        targetBgColor: "var(--ds-surface, #FFFFFF)",
        targetOnClick: (_event)=>openRoadmaps(),
        messageId: "polaris-lib-onboarding-flows.ui.collections.tour.roadmap-introduction-spotlight.jira-spotlight",
        messageType: "engagement"
    }, formatMessage((0, $9V003.messages).message)));
};

});
parcelRegister("cAcWf", function(module, exports) {

$parcel$export(module.exports, "useOnboardingFlowsActions", () => $7dbb55da8793fd57$export$e3d86ac85365138c);
$parcel$export(module.exports, "createHook", () => $7dbb55da8793fd57$export$e7f733c8fc2b8a24);
$parcel$export(module.exports, "OnboardingFlowsContainer", () => $7dbb55da8793fd57$export$214c4fcbf19b9a1d);

var $5uXOq = parcelRequire("5uXOq");

var $imZsD = parcelRequire("imZsD");

var $6ToME = parcelRequire("6ToME");

var $iXqE5 = parcelRequire("iXqE5");

var $flDq6 = parcelRequire("flDq6");

var $7D44j = parcelRequire("7D44j");
const $7dbb55da8793fd57$export$46c52354b8798e89 = (0, $iXqE5.createStore)({
    name: 'PolarisLibOnboardingFlowsStore',
    initialState: {
        containerProps: {
            accountId: undefined
        },
        productUsageStartTimestamp: undefined,
        globalFields: {
            goToProjectSpotlightDismissed: undefined,
            tourDismissed: undefined,
            tourSpotlightStep: null
        },
        projectFields: {
            exploreSectionMessageDismissed: undefined,
            seenPulsatingFieldsButton: undefined,
            tourDismissed: undefined,
            tourSpotlightStep: null,
            pageViewed: undefined
        },
        collections: {
            tourDismissed: undefined,
            tourSpotlightStep: null,
            introductionDismissed: undefined,
            introductionPrerequisiteDismissalsMet: undefined
        },
        crossProjectView: {
            tourDismissed: undefined,
            tourSpotlightStep: null
        },
        timeline: {
            sectionMessageDismissed: undefined
        },
        viewPermissions: {
            spotlightDismissed: undefined
        },
        shareDialog: {
            inviteSpotlightDismissed: undefined
        },
        allViews: {
            spotlightDismissed: undefined
        },
        prioritizationView: {
            tourDismissed: undefined,
            tourSpotlightStep: null
        },
        roadmapView: {
            spotlightDismissed: undefined,
            columnConfigSpotlightDismissed: undefined
        },
        viewCreator: {
            tourDismissed: undefined,
            tourSpotlightStep: null
        },
        premium: {
            modalDismissed: undefined,
            lastVisit: {
                isPremium: undefined,
                updated: undefined
            },
            promise: (0, $flDq6.createDeferredPromise)()
        }
    },
    actions: $7D44j.default
});
const { Container: $7dbb55da8793fd57$export$2e28a971a45925e3, useActions: $7dbb55da8793fd57$export$e3d86ac85365138c, createHook: $7dbb55da8793fd57$export$e7f733c8fc2b8a24, createHigherLevelHook: $7dbb55da8793fd57$export$757252247e722815 } = (0, $6ToME.createJpdContainer)($7dbb55da8793fd57$export$46c52354b8798e89);
const $7dbb55da8793fd57$export$214c4fcbf19b9a1d = ({ accountId: accountId, children: children })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $imZsD.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($7dbb55da8793fd57$export$2e28a971a45925e3, {
        isGlobal: true,
        accountId: accountId
    }, children));

});
parcelRegister("6ToME", function(module, exports) {

$parcel$export(module.exports, "createJpdContainer", () => $23346b108d18c150$export$7ed5db99dcc39128);

var $gJBT6 = parcelRequire("gJBT6");

var $jYn8S = parcelRequire("jYn8S");

var $3sQ5x = parcelRequire("3sQ5x");

var $5vOOL = parcelRequire("5vOOL");
const $23346b108d18c150$var$createSelectorHook = (store, selector)=>{
    const innerHook = (0, $3sQ5x.createHook)(store, {
        selector: (state)=>selector(state, state.containerProps)
    });
    return ()=>{
        const [val] = innerHook();
        return val;
    };
};
const $23346b108d18c150$export$757252247e722815 = (store, selectorCreator)=>{
    // TODO POL-2195 memoize one is not suitable for this task, as it will only memoize the last invocation. while this
    //               improves subsequent calls with the same argument set, it does not improve calls with different args
    //               this case should be solved with a generic memoization lib, e.g. reselect (4.1+) or moize
    //               discussion: https://hello.atlassian.net/wiki/spaces/TGR/pages/1416371989/Dependency+review+moize
    const memoizedSelectorCreator = (0, $jYn8S.cacheSelectorCreator)(selectorCreator);
    // TODO POL-2195 in the meantime, we can use lodash/memoize to at least solve the 1-ary case,
    //               which should be 99% of our selector creators anyway
    const monadicSelectorCreatorMemoized = (0, (/*@__PURE__*/$parcel$interopDefault($gJBT6)))(selectorCreator);
    const rssHook = (0, $3sQ5x.createHook)(store, {
        selector: (state, args)=>{
            if (args.length <= 1) return monadicSelectorCreatorMemoized(...args)(state, state.containerProps);
            return memoizedSelectorCreator(...args)(state, state.containerProps);
        }
    });
    return (...args)=>{
        // @ts-expect-error - TS2345 - Argument of type 'SelectorCreatorArgs' is not assignable to parameter
        const [val] = rssHook(args);
        return val;
    };
};
const $23346b108d18c150$export$7ed5db99dcc39128 = (store, options)=>{
    const Container = (0, $5vOOL.createContainerWithContext)(store, options);
    const useEmptyState = (0, $3sQ5x.createHook)(store, {
        selector: null
    });
    const useActions = ()=>{
        const [, actions] = useEmptyState();
        return actions;
    };
    return {
        createHook: (selector)=>$23346b108d18c150$var$createSelectorHook(store, selector),
        createHigherLevelHook: (selectorCreator)=>$23346b108d18c150$export$757252247e722815(store, selectorCreator),
        useActions: useActions,
        Container: Container
    };
};

});
parcelRegister("jYn8S", function(module, exports) {

$parcel$export(module.exports, "cacheSelectorCreator", () => $904e561f620684de$export$413433974f0869c3);
$parcel$export(module.exports, "getCacheValue", () => $904e561f620684de$export$e15acfbd8ab989dd);
let $904e561f620684de$var$cache = new WeakMap();
let $904e561f620684de$var$jsonEqualityMap = new WeakMap();
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const $904e561f620684de$var$getValueFromJsonEqualityCache = (f, value, options)=>{
    if (options?.useJsonEquality !== true) return value;
    if (!$904e561f620684de$var$jsonEqualityMap.has(f)) $904e561f620684de$var$jsonEqualityMap.set(f, new Map());
    const storage = $904e561f620684de$var$jsonEqualityMap.get(f);
    try {
        const key = JSON.stringify(value);
        if (storage.has(key)) return storage.get(key);
        storage.set(key, value);
    } catch  {
    // do nothing
    }
    return value;
};
function $904e561f620684de$export$413433974f0869c3(f, options) {
    if (f.__isCachedSelectorCreator === true) return f;
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const cacheFunction = (...args)=>{
        if ($904e561f620684de$var$cache.has(f)) {
            let lastNode = $904e561f620684de$var$cache.get(f);
            for(let i = 0; i < args.length; i += 1){
                const value = $904e561f620684de$var$getValueFromJsonEqualityCache(f, args[i], options);
                if (!lastNode.args.has(value)) {
                    lastNode = null;
                    break;
                }
                lastNode = lastNode.args.get(value);
            }
            if (lastNode?.selector) return lastNode.selector;
        }
        const maybeSelector = f(...args);
        if (typeof maybeSelector?.resultFunc === 'function' || typeof maybeSelector === 'function') {
            if (!$904e561f620684de$var$cache.has(f)) $904e561f620684de$var$cache.set(f, {
                args: new Map(),
                selector: null
            });
            let lastNode = $904e561f620684de$var$cache.get(f);
            for(let i = 0; i < args.length; i += 1){
                const value = $904e561f620684de$var$getValueFromJsonEqualityCache(f, args[i], options);
                if (!lastNode.args.has(value)) lastNode.args.set(value, {
                    args: new Map(),
                    selector: null
                });
                lastNode = lastNode.args.get(value);
            }
            lastNode.selector = maybeSelector;
        }
        return maybeSelector;
    };
    cacheFunction.__isCachedSelectorCreator = true;
    cacheFunction.__origin = f;
    cacheFunction.displayName = f.name || f.displayName;
    return cacheFunction;
}
const $904e561f620684de$export$e2575ed62a2f107b = ()=>$904e561f620684de$var$cache;
const $904e561f620684de$export$e15acfbd8ab989dd = (key)=>$904e561f620684de$var$cache.get(key);
const $904e561f620684de$export$6e5dca841bdf93e3 = ()=>{
    $904e561f620684de$var$cache = new WeakMap();
    $904e561f620684de$var$jsonEqualityMap = new WeakMap();
};

});

parcelRegister("5vOOL", function(module, exports) {

$parcel$export(module.exports, "createContainerWithContext", () => $3e805df79a9b7626$export$ce6d80db779db7dc);
// eslint-disable-next-line jira/restricted/@atlassian/react-sweet-state

var $gg7kZ = parcelRequire("gg7kZ");

var $battw = parcelRequire("battw");
const $3e805df79a9b7626$export$ce6d80db779db7dc = (store, options)=>(0, $gg7kZ.createContainer)(store, {
        ...options,
        onInit: ()=>(api, containerProps)=>{
                (0, $battw.batchStateUpdates)(({ dispatch: dispatch, setState: setState }, props)=>{
                    // @ts-expect-error - TS2345 - Argument of type '{ containerProps: TContainerProps; }' is not assignable to parameter of type 'Partial<TState>'.
                    setState({
                        containerProps: props
                    });
                    options?.onInit && dispatch(options.onInit());
                })(api, containerProps);
            },
        onUpdate: ()=>(api, containerProps)=>{
                (0, $battw.batchStateUpdates)(({ dispatch: dispatch, setState: setState, getState: getState }, props)=>{
                    const prevContainerProps = getState().containerProps;
                    // @ts-expect-error - TS2345 - Argument of type '{ containerProps: TContainerProps; }' is not assignable to parameter of type 'Partial<TState>'.
                    setState({
                        containerProps: props,
                        prevContainerProps: prevContainerProps
                    });
                    options?.onUpdate && dispatch(options.onUpdate());
                })(api, containerProps);
            }
    });

});
parcelRegister("battw", function(module, exports) {

$parcel$export(module.exports, "batchStateUpdates", () => $cbff8929059d4af1$export$4f8b20404a906ca3);
// eslint-disable-next-line jira/restricted/@atlassian/react-sweet-state
const $cbff8929059d4af1$export$4f8b20404a906ca3 = (cb)=>(api, containerProps)=>{
        let finalized = false;
        let localState = api.getState();
        const setState = (newState)=>{
            if (finalized) {
                api.setState(newState);
                return;
            }
            localState = {
                ...localState,
                ...newState
            };
        };
        const getState = ()=>finalized ? api.getState() : localState;
        const dispatch = (action)=>finalized ? action(api, containerProps) : action({
                dispatch: dispatch,
                setState: setState,
                getState: getState
            }, containerProps);
        const patchedApi = {
            setState: setState,
            getState: getState,
            dispatch: dispatch
        };
        cb(patchedApi, containerProps);
        finalized = true;
        api.setState({
            ...localState
        });
        // eslint-disable-next-line @typescript-eslint/consistent-type-assertions, @typescript-eslint/no-explicit-any
        localState = null;
    };

});



parcelRegister("flDq6", function(module, exports) {

$parcel$export(module.exports, "checkIfActivatedMoreThanFourDays", () => $4c6cd1f60d2b26de$export$562701f849a0aba7);
$parcel$export(module.exports, "normalizeError", () => $4c6cd1f60d2b26de$export$e7bd538fb0c5db1a);
$parcel$export(module.exports, "createDeferredPromise", () => $4c6cd1f60d2b26de$export$87a845ded7190bfc);
$parcel$export(module.exports, "checkPrerequisiteDismissals", () => $4c6cd1f60d2b26de$export$b20d00c7cb810f65);

var $5egm2 = parcelRequire("5egm2");

var $89SaW = parcelRequire("89SaW");
const $4c6cd1f60d2b26de$export$562701f849a0aba7 = (productUsageStartTimestamp)=>{
    const diffInDays = (0, $5egm2.default)(new Date(), new Date(productUsageStartTimestamp));
    return diffInDays >= 4;
};
const $4c6cd1f60d2b26de$export$e7bd538fb0c5db1a = (error)=>{
    if (error instanceof Error) return error;
    return new Error('Unknown error');
};
function $4c6cd1f60d2b26de$export$87a845ded7190bfc() {
    // These will be properly initialized in the Promise constructor
    let resolve;
    let reject;
    const promise = new Promise((res, rej)=>{
        resolve = res;
        reject = rej;
    });
    return {
        promise: promise,
        resolve: resolve,
        reject: reject
    };
}
const $4c6cd1f60d2b26de$export$b20d00c7cb810f65 = async (prerequisiteDismissals, accountId)=>{
    if (!accountId) return;
    const prerequisiteDismissalsPromises = prerequisiteDismissals.map((prerequisite)=>{
        return (0, $89SaW.getUserProperty)(accountId, prerequisite);
    });
    return Promise.all(prerequisiteDismissalsPromises);
};

});

parcelRegister("7D44j", function(module, exports) {

$parcel$export(module.exports, "default", () => $73ced0fde2678944$export$2e2bcd8739ae039);

var $hTGLO = parcelRequire("hTGLO");

var $3nX69 = parcelRequire("3nX69");

var $j7wFs = parcelRequire("j7wFs");

var $fw4kd = parcelRequire("fw4kd");

var $aLCt5 = parcelRequire("aLCt5");

var $ekdyp = parcelRequire("ekdyp");

var $9SWPx = parcelRequire("9SWPx");

var $7lHeU = parcelRequire("7lHeU");

var $7kErt = parcelRequire("7kErt");

var $8DEAI = parcelRequire("8DEAI");

var $jJ3r3 = parcelRequire("jJ3r3");

var $43cMo = parcelRequire("43cMo");

var $ehOuS = parcelRequire("ehOuS");

var $1bQtC = parcelRequire("1bQtC");

var $5lIPS = parcelRequire("5lIPS");

var $1iEjh = parcelRequire("1iEjh");

var $gSOEi = parcelRequire("gSOEi");

var $irhvp = parcelRequire("irhvp");

var $i1anS = parcelRequire("i1anS");

var $cXfUC = parcelRequire("cXfUC");

var $9nrm9 = parcelRequire("9nrm9");

var $a6Bob = parcelRequire("a6Bob");

var $dke7D = parcelRequire("dke7D");
const $73ced0fde2678944$var$actions = {
    loadProductUsageStartTimestamp: $dke7D.loadProductUsageStartTimestamp,
    loadGoToProjectSpotlightDismissed: $9SWPx.loadGoToProjectSpotlightDismissed,
    setGoToProjectSpotlightDismissed: $9SWPx.setGoToProjectSpotlightDismissed,
    setGlobalFieldsTourSpotlightStep: $7lHeU.setGlobalFieldsTourSpotlightStep,
    loadGlobalFieldsTourDismissed: $7kErt.loadGlobalFieldsTourDismissed,
    setGlobalFieldsTourDismissed: $7kErt.setGlobalFieldsTourDismissed,
    loadExploreSectionMessageDismissed: $8DEAI.loadExploreSectionMessageDismissed,
    setExploreSectionMessageDismissed: $8DEAI.setExploreSectionMessageDismissed,
    loadProjectFieldsPageViewed: $jJ3r3.loadProjectFieldsPageViewed,
    setProjectFieldsPageViewed: $jJ3r3.setProjectFieldsPageViewed,
    loadSeenPulsatingFieldsButton: $43cMo.loadSeenPulsatingFieldsButton,
    setSeenPulsatingFieldsButton: $43cMo.setSeenPulsatingFieldsButton,
    loadProjectFieldsTourDismissed: $1bQtC.loadProjectFieldsTourDismissed,
    setProjectFieldsTourDismissed: $1bQtC.setProjectFieldsTourDismissed,
    setProjectFieldsTourSpotlightStep: $ehOuS.setProjectFieldsTourSpotlightStep,
    loadCollectionsTourDismissed: $3nX69.loadCollectionsTourDismissed,
    loadRoadmapIntroductionPrerequisiteDismissalsMet: $ekdyp.loadRoadmapIntroductionPrerequisiteDismissalsMet,
    setCollectionsTourDismissed: $3nX69.setCollectionsTourDismissed,
    setCollectionsTourSpotlightStep: $hTGLO.setCollectionsTourSpotlightStep,
    loadRoadmapIntroductionDismissed: $ekdyp.loadRoadmapIntroductionDismissed,
    setRoadmapIntroductionDismissed: $ekdyp.setRoadmapIntroductionDismissed,
    loadCrossProjectViewTourDismissed: $aLCt5.loadCrossProjectViewTourDismissed,
    setCrossProjectViewTourDismissed: $aLCt5.setCrossProjectViewTourDismissed,
    setCrossProjectViewTourSpotlightStep: $fw4kd.setCrossProjectViewTourSpotlightStep,
    loadTimelineSectionMessageDismissed: $5lIPS.loadTimelineSectionMessageDismissed,
    setTimelineSectionMessageDismissed: $5lIPS.setTimelineSectionMessageDismissed,
    loadViewPermissionsSpotlightDismissed: $1iEjh.loadViewPermissionsSpotlightDismissed,
    setViewPermissionsSpotlightDismissed: $1iEjh.setViewPermissionsSpotlightDismissed,
    loadCrossProjectViewFieldsDismissed: $j7wFs.loadCrossProjectViewFieldsDismissed,
    setCrossProjectViewFieldsDismissed: $j7wFs.setCrossProjectViewFieldsDismissed,
    loadInviteFromShareDialogSpotlightDismissed: $gSOEi.loadInviteFromShareDialogSpotlightDismissed,
    setInviteFromShareDialogSpotlightDismissed: $gSOEi.setInviteFromShareDialogSpotlightDismissed,
    loadAllViewsSpotlightDismissed: $irhvp.loadAllViewsSpotlightDismissed,
    setAllViewsSpotlightDismissed: $irhvp.setAllViewsSpotlightDismissed,
    loadRoadmapViewSpotlightDismissed: $cXfUC.loadRoadmapViewSpotlightDismissed,
    setRoadmapViewSpotlightDismissed: $cXfUC.setRoadmapViewSpotlightDismissed,
    loadRoadmapColumnConfigSpotlightDismissed: $cXfUC.loadRoadmapColumnConfigSpotlightDismissed,
    setRoadmapColumnConfigSpotlightDismissed: $cXfUC.setRoadmapColumnConfigSpotlightDismissed,
    loadPrioritizationViewTourDismissed: $i1anS.loadPrioritizationViewTourDismissed,
    setPrioritizationViewTourDismissed: $i1anS.setPrioritizationViewTourDismissed,
    setPrioritizationViewTourSpotlightStep: $i1anS.setPrioritizationViewTourSpotlightStep,
    setViewCreatorSpotlightDismissed: $9nrm9.setViewCreatorSpotlightDismissed,
    setViewCreatorSpotlightTourStep: $9nrm9.setViewCreatorSpotlightTourStep,
    loadViewCreatorSpotlightState: $9nrm9.loadViewCreatorSpotlightState,
    loadPremiumLastVisit: $a6Bob.loadPremiumLastVisit,
    loadPremiumModalDismissed: $a6Bob.loadPremiumModalDismissed,
    setPremiumLastVisit: $a6Bob.setPremiumLastVisit,
    setPremiumModalDismissed: $a6Bob.setPremiumModalDismissed,
    unlockOnboardingFlow: $a6Bob.unlockOnboardingFlow
};
var $73ced0fde2678944$export$2e2bcd8739ae039 = $73ced0fde2678944$var$actions;

});
parcelRegister("hTGLO", function(module, exports) {

$parcel$export(module.exports, "setCollectionsTourSpotlightStep", () => $6d68522005faa178$export$501a98d23141dc4d);
// eslint-disable-next-line jira/restricted/@atlassian/react-sweet-state
const $6d68522005faa178$export$501a98d23141dc4d = (step)=>({ getState: getState, setState: setState })=>{
        const state = getState();
        setState({
            ...state,
            collections: {
                ...state.collections,
                tourSpotlightStep: step
            }
        });
    };

});

parcelRegister("3nX69", function(module, exports) {

$parcel$export(module.exports, "loadCollectionsTourDismissed", () => $f4b58b9aa01e4518$export$c7e2395278267e1d);
$parcel$export(module.exports, "setCollectionsTourDismissed", () => $f4b58b9aa01e4518$export$2a7240b702e8d617);

var $89SaW = parcelRequire("89SaW");

var $jJZqs = parcelRequire("jJZqs");

var $8U9Op = parcelRequire("8U9Op");

var $4R6GH = parcelRequire("4R6GH");

var $d9ulS = parcelRequire("d9ulS");

var $6FNg9 = parcelRequire("6FNg9");
const $f4b58b9aa01e4518$export$c7e2395278267e1d = ()=>async ({ getState: getState, setState: setState }, { accountId: accountId })=>{
        if (!accountId) return;
        if ((0, $4R6GH.fg)('polaris_premium_modal_ga')) await (0, $6FNg9.maybeWaitForPremiumModal)(getState);
        // User property is already loaded
        if (typeof getState().collections.tourDismissed === 'boolean') return;
        try {
            const tourDismissed = await (0, $89SaW.getUserProperty)(accountId, (0, $d9ulS.COLLECTIONS_TOUR_DISMISSED));
            const state = getState();
            setState({
                ...state,
                collections: {
                    ...state.collections,
                    tourDismissed: tourDismissed
                }
            });
        } catch (error) {
            // Expected error, the property is not set yet
            if (error instanceof (0, $jJZqs.default) && error.statusCode === 404) {
                const state = getState();
                setState({
                    ...state,
                    collections: {
                        ...state.collections,
                        tourDismissed: false
                    }
                });
                return;
            }
            (0, $8U9Op.logSafeErrorWithoutCustomerDataWrapper)('polaris.onboarding.project-fields.tour', `Failed to get user property with key: ${(0, $d9ulS.COLLECTIONS_TOUR_DISMISSED)}`, error instanceof Error ? error : undefined);
        }
        return getState().collections.tourDismissed;
    };
const $f4b58b9aa01e4518$export$2a7240b702e8d617 = ()=>async ({ getState: getState, setState: setState }, { accountId: accountId })=>{
        if (!accountId) return;
        const state = getState();
        setState({
            ...state,
            collections: {
                ...state.collections,
                tourDismissed: true
            }
        });
        try {
            await (0, $89SaW.setUserProperties)(accountId, (0, $d9ulS.COLLECTIONS_TOUR_DISMISSED), 'true');
        } catch (error) {
            (0, $8U9Op.logSafeErrorWithoutCustomerDataWrapper)('polaris.onboarding.project-fields.tour', `Failed to set user property with key: ${(0, $d9ulS.COLLECTIONS_TOUR_DISMISSED)}`, error instanceof Error ? error : undefined);
        }
    };

});
parcelRegister("8U9Op", function(module, exports) {

$parcel$export(module.exports, "logSafeErrorWithoutCustomerDataWrapper", () => $5cb445ae48fef3c4$export$ebd6466ba18b2f3a);

var $2YZCu = parcelRequire("2YZCu");

var $jJZqs = parcelRequire("jJZqs");




const $5cb445ae48fef3c4$export$ebd6466ba18b2f3a = async (location, message, event)=>{
    const modifiedEvent = event;
    if (modifiedEvent instanceof (0, $jJZqs.default) && modifiedEvent.originalResponse) {
        const originalResponseText = await modifiedEvent.originalResponse.text();
        modifiedEvent.message = `${modifiedEvent.message} - ${originalResponseText}`;
        delete modifiedEvent.originalResponse;
    }
    (0, $2YZCu.default).safeErrorWithoutCustomerData(location, message, modifiedEvent);
};

});

parcelRegister("6FNg9", function(module, exports) {

$parcel$export(module.exports, "maybeWaitForPremiumModal", () => $a42f0641756b90a5$export$b797d1ff3b371e8a);
// eslint-disable-next-line jira/restricted/@atlassian/react-sweet-state
const $a42f0641756b90a5$export$b797d1ff3b371e8a = async (getState)=>{
    // Await the resolution of the deferred promise associated with the premium modal.
    // This ensures that the premium modal has either never been displayed or has already been closed.
    // This mechanism allows for seamless orchestration of all spotlights within a single package,
    // ensuring they are postponed until the premium modal can be displayed and is dismissed.
    // Treat this similar to the `!accountId`, as every loading action
    // in the `onboarding-flow` package should incorporate this check.
    await getState().premium.promise.promise;
};

});


parcelRegister("j7wFs", function(module, exports) {

$parcel$export(module.exports, "loadCrossProjectViewFieldsDismissed", () => $bf11a724423fc392$export$e6e8b16aaeac983b);
$parcel$export(module.exports, "setCrossProjectViewFieldsDismissed", () => $bf11a724423fc392$export$2468c71857d0e133);

var $89SaW = parcelRequire("89SaW");

var $jJZqs = parcelRequire("jJZqs");

var $8U9Op = parcelRequire("8U9Op");

var $4R6GH = parcelRequire("4R6GH");

var $d9ulS = parcelRequire("d9ulS");

var $6FNg9 = parcelRequire("6FNg9");
const $bf11a724423fc392$export$e6e8b16aaeac983b = (viewKindStateKey)=>async ({ getState: getState, setState: setState }, { accountId: accountId })=>{
        if (!accountId) return;
        if ((0, $4R6GH.fg)('polaris_premium_modal_ga')) await (0, $6FNg9.maybeWaitForPremiumModal)(getState);
        // User property is already loaded
        if (typeof getState().crossProjectView[viewKindStateKey] === 'boolean') return;
        const userProperty = (0, $d9ulS.USER_PROPERTY_BY_STATE_KEY)[viewKindStateKey];
        try {
            const viewfieldsDismissed = await (0, $89SaW.getUserProperty)(accountId, userProperty);
            const state = getState();
            setState({
                ...state,
                crossProjectView: {
                    ...state.crossProjectView,
                    [viewKindStateKey]: viewfieldsDismissed
                }
            });
        } catch (error) {
            // Expected error, the property is not set yet
            if (error instanceof (0, $jJZqs.default) && error.statusCode === 404) {
                const state = getState();
                setState({
                    ...state,
                    crossProjectView: {
                        ...state.crossProjectView,
                        [viewKindStateKey]: false
                    }
                });
                return;
            }
            (0, $8U9Op.logSafeErrorWithoutCustomerDataWrapper)(userProperty, `Failed to get user property with key: ${userProperty}`, error instanceof Error ? error : undefined);
        }
        return getState().crossProjectView[viewKindStateKey];
    };
const $bf11a724423fc392$export$2468c71857d0e133 = (viewKindStateKey)=>async ({ getState: getState, setState: setState }, { accountId: accountId })=>{
        if (!accountId) return;
        const state = getState();
        setState({
            ...state,
            crossProjectView: {
                ...state.crossProjectView,
                [viewKindStateKey]: true
            }
        });
        const userProperty = (0, $d9ulS.USER_PROPERTY_BY_STATE_KEY)[viewKindStateKey];
        try {
            await (0, $89SaW.setUserProperties)(accountId, userProperty, 'true');
        } catch (error) {
            (0, $8U9Op.logSafeErrorWithoutCustomerDataWrapper)(userProperty, `Failed to set user property with key: ${userProperty}`, error instanceof Error ? error : undefined);
        }
    };

});

parcelRegister("fw4kd", function(module, exports) {

$parcel$export(module.exports, "setCrossProjectViewTourSpotlightStep", () => $85bd86cefde8c272$export$7e29b1ed314f9b12);
// eslint-disable-next-line jira/restricted/@atlassian/react-sweet-state
const $85bd86cefde8c272$export$7e29b1ed314f9b12 = (step)=>({ getState: getState, setState: setState })=>{
        const state = getState();
        setState({
            ...state,
            crossProjectView: {
                ...state.crossProjectView,
                tourSpotlightStep: step
            }
        });
    };

});

parcelRegister("aLCt5", function(module, exports) {

$parcel$export(module.exports, "loadCrossProjectViewTourDismissed", () => $27e7ac097dc825d8$export$24c1a2fce44090f2);
$parcel$export(module.exports, "setCrossProjectViewTourDismissed", () => $27e7ac097dc825d8$export$d25b2932701a97e6);

var $89SaW = parcelRequire("89SaW");

var $jJZqs = parcelRequire("jJZqs");

var $8U9Op = parcelRequire("8U9Op");

var $4R6GH = parcelRequire("4R6GH");

var $d9ulS = parcelRequire("d9ulS");

var $6FNg9 = parcelRequire("6FNg9");
const $27e7ac097dc825d8$export$24c1a2fce44090f2 = ()=>async ({ getState: getState, setState: setState }, { accountId: accountId })=>{
        if (!accountId) return;
        if ((0, $4R6GH.fg)('polaris_premium_modal_ga')) await (0, $6FNg9.maybeWaitForPremiumModal)(getState);
        // User property is already loaded
        if (typeof getState().crossProjectView.tourDismissed === 'boolean') return;
        try {
            const tourDismissed = await (0, $89SaW.getUserProperty)(accountId, (0, $d9ulS.CROSS_PROJECT_VIEW_TOUR_DISMISSED));
            const state = getState();
            setState({
                ...state,
                crossProjectView: {
                    ...state.crossProjectView,
                    tourDismissed: tourDismissed
                }
            });
        } catch (error) {
            // Expected error, the property is not set yet
            if (error instanceof (0, $jJZqs.default) && error.statusCode === 404) {
                const state = getState();
                setState({
                    ...state,
                    crossProjectView: {
                        ...state.crossProjectView,
                        tourDismissed: false
                    }
                });
                return;
            }
            (0, $8U9Op.logSafeErrorWithoutCustomerDataWrapper)('polaris.onboarding.project-fields.tour', `Failed to get user property with key: ${(0, $d9ulS.CROSS_PROJECT_VIEW_TOUR_DISMISSED)}`, error instanceof Error ? error : undefined);
        }
        return getState().crossProjectView.tourDismissed;
    };
const $27e7ac097dc825d8$export$d25b2932701a97e6 = ()=>async ({ getState: getState, setState: setState }, { accountId: accountId })=>{
        if (!accountId) return;
        const state = getState();
        setState({
            ...state,
            crossProjectView: {
                ...state.crossProjectView,
                tourDismissed: true
            }
        });
        try {
            await (0, $89SaW.setUserProperties)(accountId, (0, $d9ulS.CROSS_PROJECT_VIEW_TOUR_DISMISSED), 'true');
        } catch (error) {
            (0, $8U9Op.logSafeErrorWithoutCustomerDataWrapper)('polaris.onboarding.project-fields.tour', `Failed to set user property with key: ${(0, $d9ulS.CROSS_PROJECT_VIEW_TOUR_DISMISSED)}`, error instanceof Error ? error : undefined);
        }
    };

});

parcelRegister("ekdyp", function(module, exports) {

$parcel$export(module.exports, "loadRoadmapIntroductionDismissed", () => $bb8292cba90e90b4$export$1a7b263d41622a5b);
$parcel$export(module.exports, "loadRoadmapIntroductionPrerequisiteDismissalsMet", () => $bb8292cba90e90b4$export$de983a99630cdc7d);
$parcel$export(module.exports, "setRoadmapIntroductionDismissed", () => $bb8292cba90e90b4$export$19c464c17f9739ab);

var $89SaW = parcelRequire("89SaW");

var $jJZqs = parcelRequire("jJZqs");

var $8U9Op = parcelRequire("8U9Op");

var $4R6GH = parcelRequire("4R6GH");

var $d9ulS = parcelRequire("d9ulS");

var $6FNg9 = parcelRequire("6FNg9");

var $flDq6 = parcelRequire("flDq6");
const $bb8292cba90e90b4$export$1a7b263d41622a5b = ()=>async ({ getState: getState, setState: setState }, { accountId: accountId })=>{
        if (!accountId) return;
        if ((0, $4R6GH.fg)('polaris_premium_modal_ga')) await (0, $6FNg9.maybeWaitForPremiumModal)(getState);
        // User property is already loaded
        if (typeof getState().collections.introductionDismissed === 'boolean') return;
        try {
            const introductionDismissed = await (0, $89SaW.getUserProperty)(accountId, (0, $d9ulS.ROADMAP_INTRODUCTION_SPOTLIGHT_DISMISSED));
            const state = getState();
            setState({
                ...state,
                collections: {
                    ...state.collections,
                    introductionDismissed: introductionDismissed
                }
            });
        } catch (error) {
            // Expected error, the property is not set yet
            if (error instanceof (0, $jJZqs.default) && error.statusCode === 404) {
                const state = getState();
                setState({
                    ...state,
                    collections: {
                        ...state.collections,
                        introductionDismissed: false
                    }
                });
                return;
            }
            (0, $8U9Op.logSafeErrorWithoutCustomerDataWrapper)('polaris.onboarding.roadmaps.introduction.spotlight.dismissed', `Failed to get user property with key: ${(0, $d9ulS.ROADMAP_INTRODUCTION_SPOTLIGHT_DISMISSED)}`, error instanceof Error ? error : undefined);
        }
        return getState().collections.introductionDismissed;
    };
const $bb8292cba90e90b4$export$de983a99630cdc7d = ()=>async ({ getState: getState, setState: setState }, { accountId: accountId })=>{
        if (!accountId) return;
        let dismissals = [];
        try {
            dismissals = await (0, $flDq6.checkPrerequisiteDismissals)((0, $d9ulS.ROADMAP_INTRODUCTION_SPOTLIGHT_PREREQUISITE_DISMISSALS), accountId);
        } catch (error) {
            (0, $8U9Op.logSafeErrorWithoutCustomerDataWrapper)('polaris.onboarding.roadmaps.introduction.spotlight.prerequisites', 'Failed to get user properties for roadmap introduction spotlight prerequisites', error instanceof Error ? error : undefined);
        }
        const state = getState();
        setState({
            ...state,
            collections: {
                ...state.collections,
                introductionPrerequisiteDismissalsMet: dismissals?.every((dismissal)=>dismissal) ?? false
            }
        });
        return getState().collections.introductionPrerequisiteDismissalsMet;
    };
const $bb8292cba90e90b4$export$19c464c17f9739ab = ()=>async ({ getState: getState, setState: setState }, { accountId: accountId })=>{
        if (!accountId) return;
        const state = getState();
        setState({
            ...state,
            collections: {
                ...state.collections,
                introductionDismissed: true
            }
        });
        try {
            await (0, $89SaW.setUserProperties)(accountId, (0, $d9ulS.ROADMAP_INTRODUCTION_SPOTLIGHT_DISMISSED), 'true');
        } catch (error) {
            (0, $8U9Op.logSafeErrorWithoutCustomerDataWrapper)('polaris.onboarding.roadmaps.introduction.spotlight.dismissed', `Failed to set user property with key: ${(0, $d9ulS.ROADMAP_INTRODUCTION_SPOTLIGHT_DISMISSED)}`, error instanceof Error ? error : undefined);
        }
    };

});

parcelRegister("9SWPx", function(module, exports) {

$parcel$export(module.exports, "loadGoToProjectSpotlightDismissed", () => $068bea930b483a71$export$4c8d16771ecf8930);
$parcel$export(module.exports, "setGoToProjectSpotlightDismissed", () => $068bea930b483a71$export$3ea7a545c4faccd4);

var $89SaW = parcelRequire("89SaW");

var $jJZqs = parcelRequire("jJZqs");

var $8U9Op = parcelRequire("8U9Op");

var $4R6GH = parcelRequire("4R6GH");

var $d9ulS = parcelRequire("d9ulS");

var $6FNg9 = parcelRequire("6FNg9");
const $068bea930b483a71$export$4c8d16771ecf8930 = ()=>async ({ getState: getState, setState: setState }, { accountId: accountId })=>{
        if (!accountId) return;
        if ((0, $4R6GH.fg)('polaris_premium_modal_ga')) await (0, $6FNg9.maybeWaitForPremiumModal)(getState);
        // User property is already loaded
        if (typeof getState().globalFields.goToProjectSpotlightDismissed === 'boolean') return;
        try {
            const goToProjectSpotlightDismissed = await (0, $89SaW.getUserProperty)(accountId, (0, $d9ulS.GO_TO_PROJECT_SPOTLIGHT_DISMISSED));
            const state = getState();
            setState({
                ...state,
                globalFields: {
                    ...state.globalFields,
                    goToProjectSpotlightDismissed: goToProjectSpotlightDismissed
                }
            });
        } catch (error) {
            // Expected error, the property is not set yet
            if (error instanceof (0, $jJZqs.default) && error.statusCode === 404) {
                const state = getState();
                setState({
                    ...state,
                    globalFields: {
                        ...state.globalFields,
                        goToProjectSpotlightDismissed: false
                    }
                });
                return;
            }
            (0, $8U9Op.logSafeErrorWithoutCustomerDataWrapper)('polaris.onboarding.global-fields.go-to-project-spotlight', `Failed to get user property with key: ${(0, $d9ulS.GO_TO_PROJECT_SPOTLIGHT_DISMISSED)}`, error instanceof Error ? error : undefined);
        }
    };
const $068bea930b483a71$export$3ea7a545c4faccd4 = ()=>async ({ getState: getState, setState: setState }, { accountId: accountId })=>{
        if (!accountId) return;
        const state = getState();
        setState({
            ...state,
            globalFields: {
                ...state.globalFields,
                goToProjectSpotlightDismissed: true
            }
        });
        try {
            await (0, $89SaW.setUserProperties)(accountId, (0, $d9ulS.GO_TO_PROJECT_SPOTLIGHT_DISMISSED), 'true');
        } catch (error) {
            (0, $8U9Op.logSafeErrorWithoutCustomerDataWrapper)('polaris.onboarding.global-fields.go-to-project-spotlight', `Failed to set user property with key: ${(0, $d9ulS.GO_TO_PROJECT_SPOTLIGHT_DISMISSED)}`, error instanceof Error ? error : undefined);
        }
    };

});

parcelRegister("7lHeU", function(module, exports) {

$parcel$export(module.exports, "setGlobalFieldsTourSpotlightStep", () => $1b436c0378152500$export$71a13f0fff467880);
// eslint-disable-next-line jira/restricted/@atlassian/react-sweet-state
const $1b436c0378152500$export$71a13f0fff467880 = (step)=>({ getState: getState, setState: setState })=>{
        const state = getState();
        setState({
            ...state,
            globalFields: {
                ...state.globalFields,
                tourSpotlightStep: step
            }
        });
    };

});

parcelRegister("7kErt", function(module, exports) {

$parcel$export(module.exports, "loadGlobalFieldsTourDismissed", () => $1bb555275befe735$export$6dbef36cf5394497);
$parcel$export(module.exports, "setGlobalFieldsTourDismissed", () => $1bb555275befe735$export$7ddbf8611b7a51e2);

var $89SaW = parcelRequire("89SaW");

var $jJZqs = parcelRequire("jJZqs");

var $8U9Op = parcelRequire("8U9Op");

var $4R6GH = parcelRequire("4R6GH");

var $d9ulS = parcelRequire("d9ulS");

var $6FNg9 = parcelRequire("6FNg9");
const $1bb555275befe735$export$6dbef36cf5394497 = ()=>async ({ getState: getState, setState: setState }, { accountId: accountId })=>{
        if (!accountId) return;
        if ((0, $4R6GH.fg)('polaris_premium_modal_ga')) await (0, $6FNg9.maybeWaitForPremiumModal)(getState);
        // User property is already loaded
        if (typeof getState().globalFields.tourDismissed === 'boolean') return;
        try {
            const tourDismissed = await (0, $89SaW.getUserProperty)(accountId, (0, $d9ulS.GLOBAL_FIELDS_TOUR_DISMISSED));
            const state = getState();
            setState({
                ...state,
                globalFields: {
                    ...state.globalFields,
                    tourDismissed: tourDismissed
                }
            });
        } catch (error) {
            // Expected error, the property is not set yet
            if (error instanceof (0, $jJZqs.default) && error.statusCode === 404) {
                const state = getState();
                setState({
                    ...state,
                    globalFields: {
                        ...state.globalFields,
                        tourDismissed: false
                    }
                });
                return;
            }
            (0, $8U9Op.logSafeErrorWithoutCustomerDataWrapper)('polaris.onboarding.global-fields.tour', `Failed to get user property with key: ${(0, $d9ulS.GLOBAL_FIELDS_TOUR_DISMISSED)}`, error instanceof Error ? error : undefined);
        }
    };
const $1bb555275befe735$export$7ddbf8611b7a51e2 = ()=>async ({ getState: getState, setState: setState }, { accountId: accountId })=>{
        if (!accountId) return;
        const state = getState();
        setState({
            ...state,
            globalFields: {
                ...state.globalFields,
                tourDismissed: true
            }
        });
        try {
            await (0, $89SaW.setUserProperties)(accountId, (0, $d9ulS.GLOBAL_FIELDS_TOUR_DISMISSED), 'true');
        } catch (error) {
            (0, $8U9Op.logSafeErrorWithoutCustomerDataWrapper)('polaris.onboarding.global-fields.tour', `Failed to set user property with key: ${(0, $d9ulS.GLOBAL_FIELDS_TOUR_DISMISSED)}`, error instanceof Error ? error : undefined);
        }
    };

});

parcelRegister("8DEAI", function(module, exports) {

$parcel$export(module.exports, "loadExploreSectionMessageDismissed", () => $c1db7be05492658f$export$178c75cc028231a2);
$parcel$export(module.exports, "setExploreSectionMessageDismissed", () => $c1db7be05492658f$export$994e754bbe4537c1);

var $89SaW = parcelRequire("89SaW");

var $jJZqs = parcelRequire("jJZqs");

var $8U9Op = parcelRequire("8U9Op");

var $4R6GH = parcelRequire("4R6GH");

var $d9ulS = parcelRequire("d9ulS");

var $6FNg9 = parcelRequire("6FNg9");
const $c1db7be05492658f$export$178c75cc028231a2 = ()=>async ({ getState: getState, setState: setState }, { accountId: accountId })=>{
        if (!accountId) return;
        if ((0, $4R6GH.fg)('polaris_premium_modal_ga')) await (0, $6FNg9.maybeWaitForPremiumModal)(getState);
        // User property is already loaded
        if (typeof getState().projectFields.exploreSectionMessageDismissed === 'boolean') return;
        try {
            const exploreSectionMessageDismissed = await (0, $89SaW.getUserProperty)(accountId, (0, $d9ulS.EXPLORE_SECTION_MESSAGE_DISMISSED));
            const state = getState();
            setState({
                ...state,
                projectFields: {
                    ...state.projectFields,
                    exploreSectionMessageDismissed: exploreSectionMessageDismissed
                }
            });
        } catch (error) {
            // Expected error, the property is not set yet
            if (error instanceof (0, $jJZqs.default) && error.statusCode === 404) {
                const state = getState();
                setState({
                    ...state,
                    projectFields: {
                        ...state.projectFields,
                        exploreSectionMessageDismissed: false
                    }
                });
                return;
            }
            (0, $8U9Op.logSafeErrorWithoutCustomerDataWrapper)('polaris.onboarding.project-fields.explore-section-message', `Failed to get user property with key: ${(0, $d9ulS.EXPLORE_SECTION_MESSAGE_DISMISSED)}`, error instanceof Error ? error : undefined);
        }
    };
const $c1db7be05492658f$export$994e754bbe4537c1 = ()=>async ({ getState: getState, setState: setState }, { accountId: accountId })=>{
        if (!accountId) return;
        const state = getState();
        setState({
            ...state,
            projectFields: {
                ...state.projectFields,
                exploreSectionMessageDismissed: true
            }
        });
        try {
            await (0, $89SaW.setUserProperties)(accountId, (0, $d9ulS.EXPLORE_SECTION_MESSAGE_DISMISSED), 'true');
        } catch (error) {
            (0, $8U9Op.logSafeErrorWithoutCustomerDataWrapper)('polaris.onboarding.project-fields.explore-section-message', `Failed to set user property with key: ${(0, $d9ulS.EXPLORE_SECTION_MESSAGE_DISMISSED)}`, error instanceof Error ? error : undefined);
        }
    };

});

parcelRegister("jJ3r3", function(module, exports) {

$parcel$export(module.exports, "loadProjectFieldsPageViewed", () => $15b014e1ee504e23$export$2932bbb803f6ab52);
$parcel$export(module.exports, "setProjectFieldsPageViewed", () => $15b014e1ee504e23$export$5425efd17972eca4);

var $89SaW = parcelRequire("89SaW");

var $jJZqs = parcelRequire("jJZqs");

var $8U9Op = parcelRequire("8U9Op");

var $4R6GH = parcelRequire("4R6GH");

var $d9ulS = parcelRequire("d9ulS");

var $6FNg9 = parcelRequire("6FNg9");
const $15b014e1ee504e23$export$2932bbb803f6ab52 = ()=>async ({ getState: getState, setState: setState }, { accountId: accountId })=>{
        if (!accountId) return;
        if ((0, $4R6GH.fg)('polaris_premium_modal_ga')) await (0, $6FNg9.maybeWaitForPremiumModal)(getState);
        // User property is already loaded
        if (typeof getState().projectFields.pageViewed === 'boolean') return;
        try {
            const pageViewed = await (0, $89SaW.getUserProperty)(accountId, (0, $d9ulS.PROJECT_FIELDS_PAGE_VIEWED));
            const state = getState();
            setState({
                ...state,
                projectFields: {
                    ...state.projectFields,
                    pageViewed: pageViewed
                }
            });
        } catch (error) {
            // Expected error, the property is not set yet
            if (error instanceof (0, $jJZqs.default) && error.statusCode === 404) {
                const state = getState();
                setState({
                    ...state,
                    projectFields: {
                        ...state.projectFields,
                        pageViewed: false
                    }
                });
                return;
            }
            (0, $8U9Op.logSafeErrorWithoutCustomerDataWrapper)('polaris.onboarding.project-fields.page-viewed', `Failed to get user property with key: ${(0, $d9ulS.PROJECT_FIELDS_PAGE_VIEWED)}`, error instanceof Error ? error : undefined);
        }
    };
const $15b014e1ee504e23$export$5425efd17972eca4 = ()=>async ({ getState: getState, setState: setState }, { accountId: accountId })=>{
        if (!accountId) return;
        const state = getState();
        setState({
            ...state,
            projectFields: {
                ...state.projectFields,
                pageViewed: true
            }
        });
        try {
            await (0, $89SaW.setUserProperties)(accountId, (0, $d9ulS.PROJECT_FIELDS_PAGE_VIEWED), 'true');
        } catch (error) {
            (0, $8U9Op.logSafeErrorWithoutCustomerDataWrapper)('polaris.onboarding.project-fields.page-viewed', `Failed to set user property with key: ${(0, $d9ulS.PROJECT_FIELDS_PAGE_VIEWED)}`, error instanceof Error ? error : undefined);
        }
    };

});

parcelRegister("43cMo", function(module, exports) {

$parcel$export(module.exports, "loadSeenPulsatingFieldsButton", () => $be3d4f9e88ab6d4d$export$4248149cb54f9a58);
$parcel$export(module.exports, "setSeenPulsatingFieldsButton", () => $be3d4f9e88ab6d4d$export$ef1450ffea0c5a63);

var $89SaW = parcelRequire("89SaW");

var $jJZqs = parcelRequire("jJZqs");

var $8U9Op = parcelRequire("8U9Op");

var $4R6GH = parcelRequire("4R6GH");

var $d9ulS = parcelRequire("d9ulS");

var $6FNg9 = parcelRequire("6FNg9");
const $be3d4f9e88ab6d4d$export$4248149cb54f9a58 = ()=>async ({ getState: getState, setState: setState }, { accountId: accountId })=>{
        if (!accountId) return;
        if ((0, $4R6GH.fg)('polaris_premium_modal_ga')) await (0, $6FNg9.maybeWaitForPremiumModal)(getState);
        // User property is already loaded
        if (typeof getState().projectFields.seenPulsatingFieldsButton === 'boolean') return;
        try {
            const seenPulsatingFieldsButton = await (0, $89SaW.getUserProperty)(accountId, (0, $d9ulS.SEEN_PULSATING_FIELDS_BUTTON));
            const state = getState();
            setState({
                ...state,
                projectFields: {
                    ...state.projectFields,
                    seenPulsatingFieldsButton: seenPulsatingFieldsButton
                }
            });
        } catch (error) {
            // Expected error, the property is not set yet
            if (error instanceof (0, $jJZqs.default) && error.statusCode === 404) {
                const state = getState();
                setState({
                    ...state,
                    projectFields: {
                        ...state.projectFields,
                        seenPulsatingFieldsButton: false
                    }
                });
                return;
            }
            (0, $8U9Op.logSafeErrorWithoutCustomerDataWrapper)('polaris.onboarding.project-fields.pulsating-fields-button', `Failed to get user property with key: ${(0, $d9ulS.SEEN_PULSATING_FIELDS_BUTTON)}`, error instanceof Error ? error : undefined);
        }
    };
const $be3d4f9e88ab6d4d$export$ef1450ffea0c5a63 = ()=>async ({ getState: getState, setState: setState }, { accountId: accountId })=>{
        if (!accountId) return;
        const state = getState();
        setState({
            ...state,
            projectFields: {
                ...state.projectFields,
                seenPulsatingFieldsButton: true
            }
        });
        try {
            await (0, $89SaW.setUserProperties)(accountId, (0, $d9ulS.SEEN_PULSATING_FIELDS_BUTTON), 'true');
        } catch (error) {
            (0, $8U9Op.logSafeErrorWithoutCustomerDataWrapper)('polaris.onboarding.project-fields.pulsating-fields-button', `Failed to set user property with key: ${(0, $d9ulS.SEEN_PULSATING_FIELDS_BUTTON)}`, error instanceof Error ? error : undefined);
        }
    };

});

parcelRegister("ehOuS", function(module, exports) {

$parcel$export(module.exports, "setProjectFieldsTourSpotlightStep", () => $69d9a94b5f8df0a0$export$a6b8eee670a4eb2f);
// eslint-disable-next-line jira/restricted/@atlassian/react-sweet-state
const $69d9a94b5f8df0a0$export$a6b8eee670a4eb2f = (step)=>({ getState: getState, setState: setState })=>{
        const state = getState();
        setState({
            ...state,
            projectFields: {
                ...state.projectFields,
                tourSpotlightStep: step
            }
        });
    };

});

parcelRegister("1bQtC", function(module, exports) {

$parcel$export(module.exports, "loadProjectFieldsTourDismissed", () => $5e852a2e701cb81c$export$9be5e6fba10e92ef);
$parcel$export(module.exports, "setProjectFieldsTourDismissed", () => $5e852a2e701cb81c$export$2ad2aec3cf81b681);

var $89SaW = parcelRequire("89SaW");

var $jJZqs = parcelRequire("jJZqs");

var $8U9Op = parcelRequire("8U9Op");

var $4R6GH = parcelRequire("4R6GH");

var $d9ulS = parcelRequire("d9ulS");

var $6FNg9 = parcelRequire("6FNg9");
const $5e852a2e701cb81c$export$9be5e6fba10e92ef = ()=>async ({ getState: getState, setState: setState }, { accountId: accountId })=>{
        if (!accountId) return;
        if ((0, $4R6GH.fg)('polaris_premium_modal_ga')) await (0, $6FNg9.maybeWaitForPremiumModal)(getState);
        // User property is already loaded
        if (typeof getState().projectFields.tourDismissed === 'boolean') return;
        try {
            const tourDismissed = await (0, $89SaW.getUserProperty)(accountId, (0, $d9ulS.PROJECT_FIELDS_TOUR_DISMISSED));
            const state = getState();
            setState({
                ...state,
                projectFields: {
                    ...state.projectFields,
                    tourDismissed: tourDismissed
                }
            });
        } catch (error) {
            // Expected error, the property is not set yet
            if (error instanceof (0, $jJZqs.default) && error.statusCode === 404) {
                const state = getState();
                setState({
                    ...state,
                    projectFields: {
                        ...state.projectFields,
                        tourDismissed: false
                    }
                });
                return;
            }
            (0, $8U9Op.logSafeErrorWithoutCustomerDataWrapper)('polaris.onboarding.project-fields.tour', `Failed to get user property with key: ${(0, $d9ulS.PROJECT_FIELDS_TOUR_DISMISSED)}`, error instanceof Error ? error : undefined);
        }
    };
const $5e852a2e701cb81c$export$2ad2aec3cf81b681 = ()=>async ({ getState: getState, setState: setState }, { accountId: accountId })=>{
        if (!accountId) return;
        const state = getState();
        setState({
            ...state,
            projectFields: {
                ...state.projectFields,
                tourDismissed: true
            }
        });
        try {
            await (0, $89SaW.setUserProperties)(accountId, (0, $d9ulS.PROJECT_FIELDS_TOUR_DISMISSED), 'true');
        } catch (error) {
            (0, $8U9Op.logSafeErrorWithoutCustomerDataWrapper)('polaris.onboarding.project-fields.tour', `Failed to set user property with key: ${(0, $d9ulS.PROJECT_FIELDS_TOUR_DISMISSED)}`, error instanceof Error ? error : undefined);
        }
    };

});

parcelRegister("5lIPS", function(module, exports) {

$parcel$export(module.exports, "loadTimelineSectionMessageDismissed", () => $4c4013cb55e34c16$export$85213c72021b1243);
$parcel$export(module.exports, "setTimelineSectionMessageDismissed", () => $4c4013cb55e34c16$export$f5452ae8fa9e3836);

var $89SaW = parcelRequire("89SaW");

var $jJZqs = parcelRequire("jJZqs");

var $8U9Op = parcelRequire("8U9Op");

var $4R6GH = parcelRequire("4R6GH");

var $d9ulS = parcelRequire("d9ulS");

var $6FNg9 = parcelRequire("6FNg9");
const $4c4013cb55e34c16$export$85213c72021b1243 = ()=>async ({ getState: getState, setState: setState }, { accountId: accountId })=>{
        if (!accountId) return;
        if ((0, $4R6GH.fg)('polaris_premium_modal_ga')) await (0, $6FNg9.maybeWaitForPremiumModal)(getState);
        // User property is already loaded
        if (typeof getState().timeline.sectionMessageDismissed === 'boolean') return;
        try {
            const timelineSectionMessageDismissed = await (0, $89SaW.getUserProperty)(accountId, (0, $d9ulS.TIMELINE_DATES_CONFIG_SECTION_MESSAGE_DISMISSED));
            const state = getState();
            setState({
                ...state,
                timeline: {
                    sectionMessageDismissed: timelineSectionMessageDismissed
                }
            });
        } catch (error) {
            // Expected error, the property is not set yet
            if (error instanceof (0, $jJZqs.default) && error.statusCode === 404) {
                const state = getState();
                setState({
                    ...state,
                    timeline: {
                        sectionMessageDismissed: false
                    }
                });
                return;
            }
            (0, $8U9Op.logSafeErrorWithoutCustomerDataWrapper)('polaris.onboarding.timeline.spotlight', `Failed to get user property with key: ${(0, $d9ulS.TIMELINE_DATES_CONFIG_SECTION_MESSAGE_DISMISSED)}`, error instanceof Error ? error : undefined);
        }
    };
const $4c4013cb55e34c16$export$f5452ae8fa9e3836 = ()=>async ({ getState: getState, setState: setState }, { accountId: accountId })=>{
        if (!accountId) return;
        const state = getState();
        setState({
            ...state,
            timeline: {
                sectionMessageDismissed: true
            }
        });
        try {
            await (0, $89SaW.setUserProperties)(accountId, (0, $d9ulS.TIMELINE_DATES_CONFIG_SECTION_MESSAGE_DISMISSED), 'true');
        } catch (error) {
            (0, $8U9Op.logSafeErrorWithoutCustomerDataWrapper)('polaris.onboarding.timeline.spotlight', `Failed to set user property with key: ${(0, $d9ulS.TIMELINE_DATES_CONFIG_SECTION_MESSAGE_DISMISSED)}`, error instanceof Error ? error : undefined);
        }
    };

});

parcelRegister("1iEjh", function(module, exports) {

$parcel$export(module.exports, "loadViewPermissionsSpotlightDismissed", () => $7a608510c9ee8b06$export$54cafbe0d6b064a7);
$parcel$export(module.exports, "setViewPermissionsSpotlightDismissed", () => $7a608510c9ee8b06$export$1f66e0ea425845f8);

var $89SaW = parcelRequire("89SaW");

var $jcw0u = parcelRequire("jcw0u");

var $jJZqs = parcelRequire("jJZqs");

var $1As78 = parcelRequire("1As78");

var $aiePb = parcelRequire("aiePb");

var $4R6GH = parcelRequire("4R6GH");

var $d9ulS = parcelRequire("d9ulS");

var $flDq6 = parcelRequire("flDq6");

var $6FNg9 = parcelRequire("6FNg9");
const $7a608510c9ee8b06$export$54cafbe0d6b064a7 = ()=>async ({ getState: getState, setState: setState }, { accountId: accountId })=>{
        if (!accountId) return;
        if ((0, $4R6GH.fg)('polaris_premium_modal_ga')) await (0, $6FNg9.maybeWaitForPremiumModal)(getState);
        // User property is already loaded
        if (typeof getState().viewPermissions.spotlightDismissed === 'boolean') return;
        try {
            const viewPermissionsSpotlightDismissed = await (0, $89SaW.getUserProperty)(accountId, (0, $d9ulS.VIEW_PERMISSIONS_LOCK_SPOTLIGHT_DISMISSED));
            const state = getState();
            setState({
                ...state,
                viewPermissions: {
                    spotlightDismissed: viewPermissionsSpotlightDismissed
                }
            });
        } catch (error) {
            // Expected error, the property is not set yet
            if (error instanceof (0, $jJZqs.default) && (0, $aiePb.isNotFoundError)(error)) {
                const state = getState();
                setState({
                    ...state,
                    viewPermissions: {
                        spotlightDismissed: false
                    }
                });
                return;
            }
            (0, $jcw0u.default)((0, $1As78.createErrorAnalytics)('polaris.view-permissions-lock.spotlight-dismissed', (0, $flDq6.normalizeError)(error)));
        }
    };
const $7a608510c9ee8b06$export$1f66e0ea425845f8 = ()=>async ({ getState: getState, setState: setState }, { accountId: accountId })=>{
        if (!accountId) return;
        const state = getState();
        setState({
            ...state,
            viewPermissions: {
                spotlightDismissed: true
            }
        });
        try {
            await (0, $89SaW.setUserProperties)(accountId, (0, $d9ulS.VIEW_PERMISSIONS_LOCK_SPOTLIGHT_DISMISSED), 'true');
        } catch (error) {
            (0, $jcw0u.default)((0, $1As78.createErrorAnalytics)('polaris.view-permissions-lock.spotlight-dismissed', (0, $flDq6.normalizeError)(error)));
        }
    };

});
parcelRegister("1As78", function(module, exports) {

$parcel$export(module.exports, "createErrorAnalytics", () => $7cf658edd2cdbf14$export$9841879b4fea885b);
$parcel$export(module.exports, "useErrorHandlers", () => $7cf658edd2cdbf14$export$e0b4869c7401cacb);
$parcel$export(module.exports, "useOnCyclicFormulaFieldError", () => $7cf658edd2cdbf14$export$4e01d30cacaf82b8);

var $5uXOq = parcelRequire("5uXOq");

var $dD7Zc = parcelRequire("dD7Zc");

var $aYAc3 = parcelRequire("aYAc3");

var $jcw0u = parcelRequire("jcw0u");

var $koVbs = parcelRequire("koVbs");

var $eW55R = parcelRequire("eW55R");

var $lH8Ty = parcelRequire("lH8Ty");

var $l6caf = parcelRequire("l6caf");

var $aiePb = parcelRequire("aiePb");
const $7cf658edd2cdbf14$export$9841879b4fea885b = (id, error, options)=>({
        meta: {
            id: id
        },
        error: error,
        sendToPrivacyUnsafeSplunk: options?.sendToPrivacyUnsafeSplunk ?? true,
        skipSentry: options?.skipSentry ?? false
    });
const $7cf658edd2cdbf14$var$handleCallback = (errorObject, callback)=>{
    callback && callback((0, $aiePb.getMetadata)(errorObject));
};
const $7cf658edd2cdbf14$var$useGeneralDataLoadingFailedHandling = ()=>{
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const { errorWithRefresh: errorWithRefresh } = (0, $eW55R.useNotifications)();
    return (0, $5uXOq.useCallback)((errorObject, callback)=>{
        $7cf658edd2cdbf14$var$handleCallback(errorObject, callback);
        errorWithRefresh({
            title: formatMessage((0, $l6caf.default).errorTitle),
            description: formatMessage((0, $l6caf.default).serverLoadFailedDescription)
        });
        (0, $jcw0u.default)($7cf658edd2cdbf14$export$9841879b4fea885b('polaris.error.generalDataLoadingFailed', errorObject));
    }, [
        errorWithRefresh,
        formatMessage
    ]);
};
const $7cf658edd2cdbf14$var$useGeneralDataUpdateFailedHandling = ()=>{
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const { error: error, errorWithRefresh: errorWithRefresh, customFlag: customFlag } = (0, $eW55R.useNotifications)();
    return (0, $5uXOq.useCallback)((errorObject, callback)=>{
        $7cf658edd2cdbf14$var$handleCallback(errorObject, callback);
        (0, $jcw0u.default)($7cf658edd2cdbf14$export$9841879b4fea885b('polaris.error.generalDataUpdateFailed', errorObject));
        const entityLimitError = (0, $lH8Ty.getEntityLimitError)(errorObject);
        if (entityLimitError) {
            const errorMessage = (0, $lH8Ty.getErrorMessageDescriptor)(entityLimitError);
            return errorMessage ? customFlag({
                title: formatMessage((0, $l6caf.default).entityLimitErrorTitle),
                description: formatMessage(errorMessage, {
                    item: (chunks)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $aYAc3.default), null, chunks)
                }),
                icon: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($dD7Zc))), {
                    spacing: "spacious",
                    label: "Error",
                    color: "var(--ds-icon-danger, #C9372C)"
                })
            }) : null;
        }
        if ((0, $aiePb.isPermissionError)(errorObject)) return error({
            title: formatMessage((0, $l6caf.default).errorTitle),
            description: formatMessage((0, $l6caf.default).permissionErrorDescription)
        });
        if ((0, $aiePb.isConfigError)(errorObject)) return error({
            title: formatMessage((0, $l6caf.default).configErrorTitle),
            description: formatMessage((0, $l6caf.default).configErrorDescription)
        });
        errorWithRefresh({
            title: formatMessage((0, $l6caf.default).errorTitle),
            description: formatMessage((0, $l6caf.default).serverUpdateFailedDescription)
        });
    }, [
        customFlag,
        error,
        errorWithRefresh,
        formatMessage
    ]);
};
const $7cf658edd2cdbf14$var$useGeneralActionFailedHandling = ()=>{
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const { errorWithRefresh: errorWithRefresh } = (0, $eW55R.useNotifications)();
    return (0, $5uXOq.useCallback)((errorObject, callback)=>{
        $7cf658edd2cdbf14$var$handleCallback(errorObject, callback);
        errorWithRefresh({
            title: formatMessage((0, $l6caf.default).errorTitle),
            description: formatMessage((0, $l6caf.default).errorDescription)
        });
        (0, $jcw0u.default)($7cf658edd2cdbf14$export$9841879b4fea885b('polaris.error.generalActionFailed', errorObject));
    }, [
        errorWithRefresh,
        formatMessage
    ]);
};
const $7cf658edd2cdbf14$var$usePossibleAccessLossError = ()=>{
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const { errorWithRefresh: errorWithRefresh } = (0, $eW55R.useNotifications)();
    return (0, $5uXOq.useCallback)((errorObject, callback)=>{
        $7cf658edd2cdbf14$var$handleCallback(errorObject, callback);
        errorWithRefresh({
            title: formatMessage((0, $l6caf.default).errorTitle),
            description: formatMessage((0, $l6caf.default).errorPossibleAccessLoss)
        });
        (0, $jcw0u.default)($7cf658edd2cdbf14$export$9841879b4fea885b('polaris.error.generalActionFailed', errorObject));
    }, [
        errorWithRefresh,
        formatMessage
    ]);
};
const $7cf658edd2cdbf14$export$e0b4869c7401cacb = ()=>{
    const possibleAccessLossError = $7cf658edd2cdbf14$var$usePossibleAccessLossError();
    const generalActionFailedError = $7cf658edd2cdbf14$var$useGeneralActionFailedHandling();
    const generalDataUpdateFailedError = $7cf658edd2cdbf14$var$useGeneralDataUpdateFailedHandling();
    const generalDataLoadingFailedError = $7cf658edd2cdbf14$var$useGeneralDataLoadingFailedHandling();
    return (0, $5uXOq.useMemo)(()=>({
            possibleAccessLossError: possibleAccessLossError,
            generalActionFailedError: generalActionFailedError,
            generalDataUpdateFailedError: generalDataUpdateFailedError,
            generalDataLoadingFailedError: generalDataLoadingFailedError
        }), [
        possibleAccessLossError,
        generalActionFailedError,
        generalDataUpdateFailedError,
        generalDataLoadingFailedError
    ]);
};
const $7cf658edd2cdbf14$export$4e01d30cacaf82b8 = ()=>{
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const { error: error } = (0, $eW55R.useNotifications)();
    return (0, $5uXOq.useCallback)((fieldLabels)=>{
        error({
            title: formatMessage((0, $l6caf.default).errorTitle),
            description: formatMessage((0, $l6caf.default).cyclicFormulaFieldDescription, {
                fieldLabels: fieldLabels.join(', ')
            })
        });
        (0, $jcw0u.default)($7cf658edd2cdbf14$export$9841879b4fea885b('polaris.error.cyclicFormula', new Error('Cyclic formula field')));
    }, [
        error,
        formatMessage
    ]);
};

});
parcelRegister("eW55R", function(module, exports) {

$parcel$export(module.exports, "useNotifications", () => $3e7591c0992d0e62$export$53d5ca6c3f53e109);

var $5uXOq = parcelRequire("5uXOq");

var $7Jxgt = parcelRequire("7Jxgt");

var $c2i4s = parcelRequire("c2i4s");

var $dD7Zc = parcelRequire("dD7Zc");

var $7R4eB = parcelRequire("7R4eB");
var $d4xRU = parcelRequire("d4xRU");
var $7HGHK = parcelRequire("7HGHK");
var $pa9q9 = parcelRequire("pa9q9");
const $3e7591c0992d0e62$var$customFlagCommon = (notification, onDismiss, AkFlagComponent)=>{
    const id = (0, $7Jxgt.v4)();
    return {
        id: id,
        render: (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(AkFlagComponent, {
                id: id,
                ...notification,
                // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
                onDismissed: (flagId)=>onDismiss(flagId),
                ...props,
                messageId: notification.messageId ?? `polaris-lib-notifications.controllers.ak-flag-component.${id}`,
                messageType: notification.messageType ?? 'transactional'
            })
    };
};
const $3e7591c0992d0e62$var$customFlag = (notification, onDismiss)=>$3e7591c0992d0e62$var$customFlagCommon(notification, onDismiss, (0, $d4xRU.default));
const $3e7591c0992d0e62$var$customAutoDismissFlag = (notification, onDismiss)=>$3e7591c0992d0e62$var$customFlagCommon(notification, onDismiss, (0, $7R4eB.default));
const $3e7591c0992d0e62$var$success = (notification, onDismiss)=>$3e7591c0992d0e62$var$customAutoDismissFlag({
        title: notification.title,
        description: notification.description,
        actions: notification.actions?.map((action, index)=>({
                ...action,
                testId: `polaris.nofitication.success.action.${action.testId !== undefined ? action.testId : `action-${index + 1}`}`
            })),
        icon: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($c2i4s))), {
            spacing: "spacious",
            label: "Success icon",
            color: "var(--ds-icon-success, #22A06B)"
        }),
        appearance: 'normal',
        testId: 'polaris-lib-notifications.controllers.notification.success',
        messageId: notification.messageId ?? 'polaris-lib-notifications.controllers.customAutoDismissFlag.success',
        messageType: notification.messageType ?? 'transactional'
    }, onDismiss);
const $3e7591c0992d0e62$var$errorWithRefresh = (notification, onDismiss)=>$3e7591c0992d0e62$var$customAutoDismissFlag({
        title: notification.title,
        description: notification.description,
        actions: [
            ...notification.actions || [],
            {
                content: 'Refresh',
                testId: 'refresh',
                // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
                onClick: ()=>window.location.reload()
            }
        ].map((action, index)=>({
                ...action,
                testId: `polaris.nofitication.error-refresh.action.${action.testId !== undefined ? action.testId : `action-${index + 1}`}`
            })),
        icon: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($dD7Zc))), {
            spacing: "spacious",
            label: "Error",
            color: "var(--ds-icon-danger, #C9372C)"
        }),
        appearance: 'normal',
        testId: 'polaris-lib-notifications.controllers.notification.error-refresh',
        messageId: notification.messageId ?? 'polaris-lib-notifications.controllers.customAutoDismissFlag.errorWithRefresh',
        messageType: notification.messageType ?? 'transactional'
    }, onDismiss);
const $3e7591c0992d0e62$var$error = (notification, onDismiss)=>$3e7591c0992d0e62$var$customAutoDismissFlag({
        title: notification.title,
        description: notification.description,
        actions: notification.actions?.map((action, index)=>({
                ...action,
                testId: `polaris.nofitication.error.action.${action.testId !== undefined ? action.testId : `action-${index + 1}`}`
            })),
        icon: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($dD7Zc))), {
            spacing: "spacious",
            label: "Error",
            color: "var(--ds-icon-danger, #C9372C)"
        }),
        appearance: 'normal',
        testId: 'polaris-lib-notifications.controllers.notification.error',
        messageId: notification.messageId ?? 'polaris-lib-notifications.controllers.customAutoDismissFlag.error',
        messageType: notification.messageType ?? 'transactional'
    }, onDismiss);
const $3e7591c0992d0e62$export$53d5ca6c3f53e109 = ()=>{
    const { showFlag: showFlag, dismissFlag: dismissFlag } = (0, $pa9q9.useFlagsService)();
    return (0, $5uXOq.useMemo)(()=>({
            customFlag: (notification)=>{
                const flagId = showFlag($3e7591c0992d0e62$var$customFlag(notification, dismissFlag));
                // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
                return ()=>dismissFlag(flagId);
            },
            success: (notification)=>{
                const flagId = showFlag($3e7591c0992d0e62$var$success(notification, dismissFlag));
                // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
                return ()=>dismissFlag(flagId);
            },
            errorWithRefresh: (notification)=>{
                const flagId = showFlag($3e7591c0992d0e62$var$errorWithRefresh(notification, dismissFlag));
                // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
                return ()=>dismissFlag(flagId);
            },
            error: (notification)=>{
                const flagId = showFlag($3e7591c0992d0e62$var$error(notification, dismissFlag));
                // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
                return ()=>dismissFlag(flagId);
            },
            showFlag: (flag)=>{
                const id = flag.id !== undefined ? flag.id : (0, $7HGHK.toFlagId)((0, $7Jxgt.v4)());
                const flagId = showFlag({
                    ...flag,
                    id: id,
                    key: id,
                    messageId: flag.messageId ?? `polaris-lib-notifications.controllers.showFlag.${id}`,
                    messageType: flag.messageType ?? 'transactional'
                });
                // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
                return ()=>dismissFlag(flagId);
            },
            showCustomFlag: (flag)=>{
                const id = flag.id !== undefined ? flag.id : (0, $7HGHK.toFlagId)((0, $7Jxgt.v4)());
                const flagId = showFlag({
                    messageId: `polaris-lib-notifications.controllers.showCustomFlag.${id}`,
                    messageType: 'transactional',
                    ...flag,
                    id: id
                });
                // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
                return ()=>dismissFlag(flagId);
            },
            dismissFlag: dismissFlag
        }), [
        showFlag,
        dismissFlag
    ]);
};

});
parcelRegister("7R4eB", function(module, exports) {

$parcel$export(module.exports, "default", () => $435170f9f2349b2e$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $iNWLk = parcelRequire("iNWLk");

var $3KRpp = parcelRequire("3KRpp");
const $435170f9f2349b2e$var$AkAutoDismissFlag = ({ packageName: packageName = 'flags', ...props })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $iNWLk.FlagsBoundary), {
        packageName: packageName
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $3KRpp.CommonFlag), {
        isAutoDismiss: true,
        ...props,
        flagType: "info"
    }));
var $435170f9f2349b2e$export$2e2bcd8739ae039 = $435170f9f2349b2e$var$AkAutoDismissFlag;

});

parcelRegister("d4xRU", function(module, exports) {

$parcel$export(module.exports, "default", () => $61381db0e069bc03$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $iNWLk = parcelRequire("iNWLk");

var $3KRpp = parcelRequire("3KRpp");
const $61381db0e069bc03$var$AkFlag = ({ packageName: packageName = 'flags', ...props })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $iNWLk.FlagsBoundary), {
        packageName: packageName
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $3KRpp.CommonFlag), {
        flagType: "info",
        ...props
    }));
var $61381db0e069bc03$export$2e2bcd8739ae039 = $61381db0e069bc03$var$AkFlag;

});


parcelRegister("lH8Ty", function(module, exports) {

$parcel$export(module.exports, "EntityLimitError", () => $bbaa521f44d79b10$export$c4e01b2c2ba95919);
$parcel$export(module.exports, "getEntityLimitError", () => $bbaa521f44d79b10$export$13f6f9a6b905ebbd);
$parcel$export(module.exports, "getErrorMessageDescriptor", () => $bbaa521f44d79b10$export$cf58cbb2768ea4f);

var $e3a3O = parcelRequire("e3a3O");

var $ht021 = parcelRequire("ht021");

var $j7a90 = parcelRequire("j7a90");

var $lTDxG = parcelRequire("lTDxG");
class $bbaa521f44d79b10$export$c4e01b2c2ba95919 extends (0, $ht021.default) {
    constructor(message, errors = [], statusCode = null, type){
        super(message, {
            cause: errors[0]
        }), this.name = 'EntityLimitError';
        this.errors = errors;
        this.statusCode = statusCode;
        this.type = type;
    }
}
const $bbaa521f44d79b10$export$13f6f9a6b905ebbd = (error)=>{
    // If already an EntityLimitError, return it
    if (error instanceof $bbaa521f44d79b10$export$c4e01b2c2ba95919) return error;
    // If not an ApolloError, return null as we can't handle it
    if (!(error instanceof (0, $e3a3O.ApolloError))) return null;
    // Get first entity limit error
    const entityLimitError = error.graphQLErrors?.filter((err)=>err.extensions?.limitType)[0];
    // If no entity limit error or no extensions, return null
    if (!entityLimitError?.extensions) return null;
    const { statusCode: statusCode, limitType: limitType } = entityLimitError.extensions;
    // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    const entityLimitErrorType = (0, $lTDxG.ENTITY_LIMIT_ERROR_TYPE)[limitType];
    return new $bbaa521f44d79b10$export$c4e01b2c2ba95919(entityLimitError.message, [
        {
            error: entityLimitError.message
        }
    ], statusCode, entityLimitErrorType);
};
const $bbaa521f44d79b10$export$cf58cbb2768ea4f = (error)=>(0, $j7a90.default)[error.type] || null;

});
parcelRegister("e3a3O", function(module, exports) {

$parcel$export(module.exports, "NetworkStatus", () => $02a3c2aebc919401$export$bd096ddbd246c79c);
$parcel$export(module.exports, "isApolloError", () => $02a3c2aebc919401$export$17f5e6bd290bb15d);
$parcel$export(module.exports, "ApolloError", () => $02a3c2aebc919401$export$26a337512320b8c6);
$parcel$export(module.exports, "ApolloClient", () => $02a3c2aebc919401$export$13f5a5f0f1dbab88);

var $3VFsf = parcelRequire("3VFsf");

var $jojW6 = parcelRequire("jojW6");
var $bqMzA = parcelRequire("bqMzA");

var $clSzL = parcelRequire("clSzL");
var $aS6b9 = parcelRequire("aS6b9");

var $ebaCz = parcelRequire("ebaCz");

var $1DiV8 = parcelRequire("1DiV8");

var $12QNw = parcelRequire("12QNw");
var $02a3c2aebc919401$export$bd096ddbd246c79c;
(function(NetworkStatus) {
    NetworkStatus[NetworkStatus["loading"] = 1] = "loading";
    NetworkStatus[NetworkStatus["setVariables"] = 2] = "setVariables";
    NetworkStatus[NetworkStatus["fetchMore"] = 3] = "fetchMore";
    NetworkStatus[NetworkStatus["refetch"] = 4] = "refetch";
    NetworkStatus[NetworkStatus["poll"] = 6] = "poll";
    NetworkStatus[NetworkStatus["ready"] = 7] = "ready";
    NetworkStatus[NetworkStatus["error"] = 8] = "error";
})($02a3c2aebc919401$export$bd096ddbd246c79c || ($02a3c2aebc919401$export$bd096ddbd246c79c = {}));
function $02a3c2aebc919401$var$isNetworkRequestInFlight(networkStatus) {
    return networkStatus < 7;
}
var $02a3c2aebc919401$var$Observable = function(_super) {
    (0, $3VFsf.__extends)(Observable, _super);
    function Observable() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    Observable.prototype[0, $ebaCz.default] = function() {
        return this;
    };
    Observable.prototype['@@observable'] = function() {
        return this;
    };
    return Observable;
}((0, $aS6b9.default));
function $02a3c2aebc919401$var$isNonEmptyArray(value) {
    return Array.isArray(value) && value.length > 0;
}
function $02a3c2aebc919401$export$17f5e6bd290bb15d(err) {
    return err.hasOwnProperty('graphQLErrors');
}
var $02a3c2aebc919401$var$generateErrorMessage = function(err) {
    var message = '';
    if ($02a3c2aebc919401$var$isNonEmptyArray(err.graphQLErrors)) err.graphQLErrors.forEach(function(graphQLError) {
        var errorMessage = graphQLError ? graphQLError.message : 'Error message not found.';
        message += "GraphQL error: " + errorMessage + "\n";
    });
    if (err.networkError) message += 'Network error: ' + err.networkError.message + '\n';
    message = message.replace(/\n$/, '');
    return message;
};
var $02a3c2aebc919401$export$26a337512320b8c6 = function(_super) {
    (0, $3VFsf.__extends)(ApolloError, _super);
    function ApolloError(_a) {
        var graphQLErrors = _a.graphQLErrors, networkError = _a.networkError, errorMessage = _a.errorMessage, extraInfo = _a.extraInfo;
        var _this = _super.call(this, errorMessage) || this;
        _this.graphQLErrors = graphQLErrors || [];
        _this.networkError = networkError || null;
        if (!errorMessage) _this.message = $02a3c2aebc919401$var$generateErrorMessage(_this);
        else _this.message = errorMessage;
        _this.extraInfo = extraInfo;
        _this.__proto__ = ApolloError.prototype;
        return _this;
    }
    return ApolloError;
}(Error);
var $02a3c2aebc919401$export$160bafb6ac1e0641;
(function(FetchType) {
    FetchType[FetchType["normal"] = 1] = "normal";
    FetchType[FetchType["refetch"] = 2] = "refetch";
    FetchType[FetchType["poll"] = 3] = "poll";
})($02a3c2aebc919401$export$160bafb6ac1e0641 || ($02a3c2aebc919401$export$160bafb6ac1e0641 = {}));
var $02a3c2aebc919401$var$hasError = function(storeValue, policy) {
    if (policy === void 0) policy = 'none';
    return storeValue && (storeValue.networkError || policy === 'none' && $02a3c2aebc919401$var$isNonEmptyArray(storeValue.graphQLErrors));
};
var $02a3c2aebc919401$export$6c1b56eac59c9584 = function(_super) {
    (0, $3VFsf.__extends)(ObservableQuery, _super);
    function ObservableQuery(_a) {
        var queryManager = _a.queryManager, options = _a.options, _b = _a.shouldSubscribe, shouldSubscribe = _b === void 0 ? true : _b;
        var _this = _super.call(this, function(observer) {
            return _this.onSubscribe(observer);
        }) || this;
        _this.observers = new Set();
        _this.subscriptions = new Set();
        _this.isTornDown = false;
        _this.options = options;
        _this.variables = options.variables || {};
        _this.queryId = queryManager.generateQueryId();
        _this.shouldSubscribe = shouldSubscribe;
        var opDef = (0, $jojW6.getOperationDefinition)(options.query);
        _this.queryName = opDef && opDef.name && opDef.name.value;
        _this.queryManager = queryManager;
        return _this;
    }
    ObservableQuery.prototype.result = function() {
        var _this = this;
        return new Promise(function(resolve, reject) {
            var observer = {
                next: function(result) {
                    resolve(result);
                    _this.observers.delete(observer);
                    if (!_this.observers.size) _this.queryManager.removeQuery(_this.queryId);
                    setTimeout(function() {
                        subscription.unsubscribe();
                    }, 0);
                },
                error: reject
            };
            var subscription = _this.subscribe(observer);
        });
    };
    ObservableQuery.prototype.currentResult = function() {
        var result = this.getCurrentResult();
        if (result.data === undefined) result.data = {};
        return result;
    };
    ObservableQuery.prototype.getCurrentResult = function() {
        if (this.isTornDown) {
            var lastResult = this.lastResult;
            return {
                data: !this.lastError && lastResult && lastResult.data || void 0,
                error: this.lastError,
                loading: false,
                networkStatus: $02a3c2aebc919401$export$bd096ddbd246c79c.error
            };
        }
        var _a = this.queryManager.getCurrentQueryResult(this), data = _a.data, partial = _a.partial;
        var queryStoreValue = this.queryManager.queryStore.get(this.queryId);
        var result;
        var fetchPolicy = this.options.fetchPolicy;
        var isNetworkFetchPolicy = fetchPolicy === 'network-only' || fetchPolicy === 'no-cache';
        if (queryStoreValue) {
            var networkStatus = queryStoreValue.networkStatus;
            if ($02a3c2aebc919401$var$hasError(queryStoreValue, this.options.errorPolicy)) return {
                data: void 0,
                loading: false,
                networkStatus: networkStatus,
                error: new $02a3c2aebc919401$export$26a337512320b8c6({
                    graphQLErrors: queryStoreValue.graphQLErrors,
                    networkError: queryStoreValue.networkError
                })
            };
            if (queryStoreValue.variables) {
                this.options.variables = (0, $3VFsf.__assign)((0, $3VFsf.__assign)({}, this.options.variables), queryStoreValue.variables);
                this.variables = this.options.variables;
            }
            result = {
                data: data,
                loading: $02a3c2aebc919401$var$isNetworkRequestInFlight(networkStatus),
                networkStatus: networkStatus
            };
            if (queryStoreValue.graphQLErrors && this.options.errorPolicy === 'all') result.errors = queryStoreValue.graphQLErrors;
        } else {
            var loading = isNetworkFetchPolicy || partial && fetchPolicy !== 'cache-only';
            result = {
                data: data,
                loading: loading,
                networkStatus: loading ? $02a3c2aebc919401$export$bd096ddbd246c79c.loading : $02a3c2aebc919401$export$bd096ddbd246c79c.ready
            };
        }
        if (!partial) this.updateLastResult((0, $3VFsf.__assign)((0, $3VFsf.__assign)({}, result), {
            stale: false
        }));
        return (0, $3VFsf.__assign)((0, $3VFsf.__assign)({}, result), {
            partial: partial
        });
    };
    ObservableQuery.prototype.isDifferentFromLastResult = function(newResult) {
        var snapshot = this.lastResultSnapshot;
        return !(snapshot && newResult && snapshot.networkStatus === newResult.networkStatus && snapshot.stale === newResult.stale && (0, $bqMzA.equal)(snapshot.data, newResult.data));
    };
    ObservableQuery.prototype.getLastResult = function() {
        return this.lastResult;
    };
    ObservableQuery.prototype.getLastError = function() {
        return this.lastError;
    };
    ObservableQuery.prototype.resetLastResults = function() {
        delete this.lastResult;
        delete this.lastResultSnapshot;
        delete this.lastError;
        this.isTornDown = false;
    };
    ObservableQuery.prototype.resetQueryStoreErrors = function() {
        var queryStore = this.queryManager.queryStore.get(this.queryId);
        if (queryStore) {
            queryStore.networkError = null;
            queryStore.graphQLErrors = [];
        }
    };
    ObservableQuery.prototype.refetch = function(variables) {
        var fetchPolicy = this.options.fetchPolicy;
        if (fetchPolicy === 'cache-only') return Promise.reject(new (0, $1DiV8.InvariantError)(1));
        if (fetchPolicy !== 'no-cache' && fetchPolicy !== 'cache-and-network') fetchPolicy = 'network-only';
        if (!(0, $bqMzA.equal)(this.variables, variables)) this.variables = (0, $3VFsf.__assign)((0, $3VFsf.__assign)({}, this.variables), variables);
        if (!(0, $bqMzA.equal)(this.options.variables, this.variables)) this.options.variables = (0, $3VFsf.__assign)((0, $3VFsf.__assign)({}, this.options.variables), this.variables);
        return this.queryManager.fetchQuery(this.queryId, (0, $3VFsf.__assign)((0, $3VFsf.__assign)({}, this.options), {
            fetchPolicy: fetchPolicy
        }), $02a3c2aebc919401$export$160bafb6ac1e0641.refetch);
    };
    ObservableQuery.prototype.fetchMore = function(fetchMoreOptions) {
        var _this = this;
        (0, $1DiV8.invariant)(fetchMoreOptions.updateQuery, 2);
        var combinedOptions = (0, $3VFsf.__assign)((0, $3VFsf.__assign)({}, fetchMoreOptions.query ? fetchMoreOptions : (0, $3VFsf.__assign)((0, $3VFsf.__assign)((0, $3VFsf.__assign)({}, this.options), fetchMoreOptions), {
            variables: (0, $3VFsf.__assign)((0, $3VFsf.__assign)({}, this.variables), fetchMoreOptions.variables)
        })), {
            fetchPolicy: 'network-only'
        });
        var qid = this.queryManager.generateQueryId();
        return this.queryManager.fetchQuery(qid, combinedOptions, $02a3c2aebc919401$export$160bafb6ac1e0641.normal, this.queryId).then(function(fetchMoreResult) {
            _this.updateQuery(function(previousResult) {
                return fetchMoreOptions.updateQuery(previousResult, {
                    fetchMoreResult: fetchMoreResult.data,
                    variables: combinedOptions.variables
                });
            });
            _this.queryManager.stopQuery(qid);
            return fetchMoreResult;
        }, function(error) {
            _this.queryManager.stopQuery(qid);
            throw error;
        });
    };
    ObservableQuery.prototype.subscribeToMore = function(options) {
        var _this = this;
        var subscription = this.queryManager.startGraphQLSubscription({
            query: options.document,
            variables: options.variables
        }).subscribe({
            next: function(subscriptionData) {
                var updateQuery = options.updateQuery;
                if (updateQuery) _this.updateQuery(function(previous, _a) {
                    var variables = _a.variables;
                    return updateQuery(previous, {
                        subscriptionData: subscriptionData,
                        variables: variables
                    });
                });
            },
            error: function(err) {
                if (options.onError) {
                    options.onError(err);
                    return;
                }
            }
        });
        this.subscriptions.add(subscription);
        return function() {
            if (_this.subscriptions.delete(subscription)) subscription.unsubscribe();
        };
    };
    ObservableQuery.prototype.setOptions = function(opts) {
        var oldFetchPolicy = this.options.fetchPolicy;
        this.options = (0, $3VFsf.__assign)((0, $3VFsf.__assign)({}, this.options), opts);
        if (opts.pollInterval) this.startPolling(opts.pollInterval);
        else if (opts.pollInterval === 0) this.stopPolling();
        var fetchPolicy = opts.fetchPolicy;
        return this.setVariables(this.options.variables, oldFetchPolicy !== fetchPolicy && (oldFetchPolicy === 'cache-only' || oldFetchPolicy === 'standby' || fetchPolicy === 'network-only'), opts.fetchResults);
    };
    ObservableQuery.prototype.setVariables = function(variables, tryFetch, fetchResults) {
        if (tryFetch === void 0) tryFetch = false;
        if (fetchResults === void 0) fetchResults = true;
        this.isTornDown = false;
        variables = variables || this.variables;
        if (!tryFetch && (0, $bqMzA.equal)(variables, this.variables)) return this.observers.size && fetchResults ? this.result() : Promise.resolve();
        this.variables = this.options.variables = variables;
        if (!this.observers.size) return Promise.resolve();
        return this.queryManager.fetchQuery(this.queryId, this.options);
    };
    ObservableQuery.prototype.updateQuery = function(mapFn) {
        var queryManager = this.queryManager;
        var _a = queryManager.getQueryWithPreviousResult(this.queryId), previousResult = _a.previousResult, variables = _a.variables, document = _a.document;
        var newResult = (0, $jojW6.tryFunctionOrLogError)(function() {
            return mapFn(previousResult, {
                variables: variables
            });
        });
        if (newResult) {
            queryManager.dataStore.markUpdateQueryResult(document, variables, newResult);
            queryManager.broadcastQueries();
        }
    };
    ObservableQuery.prototype.stopPolling = function() {
        this.queryManager.stopPollingQuery(this.queryId);
        this.options.pollInterval = undefined;
    };
    ObservableQuery.prototype.startPolling = function(pollInterval) {
        $02a3c2aebc919401$var$assertNotCacheFirstOrOnly(this);
        this.options.pollInterval = pollInterval;
        this.queryManager.startPollingQuery(this.options, this.queryId);
    };
    ObservableQuery.prototype.updateLastResult = function(newResult) {
        var previousResult = this.lastResult;
        this.lastResult = newResult;
        this.lastResultSnapshot = this.queryManager.assumeImmutableResults ? newResult : (0, $jojW6.cloneDeep)(newResult);
        return previousResult;
    };
    ObservableQuery.prototype.onSubscribe = function(observer) {
        var _this = this;
        try {
            var subObserver = observer._subscription._observer;
            if (subObserver && !subObserver.error) subObserver.error = $02a3c2aebc919401$var$defaultSubscriptionObserverErrorCallback;
        } catch (_a) {}
        var first = !this.observers.size;
        this.observers.add(observer);
        if (observer.next && this.lastResult) observer.next(this.lastResult);
        if (observer.error && this.lastError) observer.error(this.lastError);
        if (first) this.setUpQuery();
        return function() {
            if (_this.observers.delete(observer) && !_this.observers.size) _this.tearDownQuery();
        };
    };
    ObservableQuery.prototype.setUpQuery = function() {
        var _this = this;
        var _a = this, queryManager = _a.queryManager, queryId = _a.queryId;
        if (this.shouldSubscribe) queryManager.addObservableQuery(queryId, this);
        if (this.options.pollInterval) {
            $02a3c2aebc919401$var$assertNotCacheFirstOrOnly(this);
            queryManager.startPollingQuery(this.options, queryId);
        }
        var onError = function(error) {
            _this.updateLastResult((0, $3VFsf.__assign)((0, $3VFsf.__assign)({}, _this.lastResult), {
                errors: error.graphQLErrors,
                networkStatus: $02a3c2aebc919401$export$bd096ddbd246c79c.error,
                loading: false
            }));
            $02a3c2aebc919401$var$iterateObserversSafely(_this.observers, 'error', _this.lastError = error);
        };
        queryManager.observeQuery(queryId, this.options, {
            next: function(result) {
                if (_this.lastError || _this.isDifferentFromLastResult(result)) {
                    var previousResult_1 = _this.updateLastResult(result);
                    var _a = _this.options, query_1 = _a.query, variables = _a.variables, fetchPolicy_1 = _a.fetchPolicy;
                    if (queryManager.transform(query_1).hasClientExports) queryManager.getLocalState().addExportedVariables(query_1, variables).then(function(variables) {
                        var previousVariables = _this.variables;
                        _this.variables = _this.options.variables = variables;
                        if (!result.loading && previousResult_1 && fetchPolicy_1 !== 'cache-only' && queryManager.transform(query_1).serverQuery && !(0, $bqMzA.equal)(previousVariables, variables)) _this.refetch();
                        else $02a3c2aebc919401$var$iterateObserversSafely(_this.observers, 'next', result);
                    });
                    else $02a3c2aebc919401$var$iterateObserversSafely(_this.observers, 'next', result);
                }
            },
            error: onError
        }).catch(onError);
    };
    ObservableQuery.prototype.tearDownQuery = function() {
        var queryManager = this.queryManager;
        this.isTornDown = true;
        queryManager.stopPollingQuery(this.queryId);
        this.subscriptions.forEach(function(sub) {
            return sub.unsubscribe();
        });
        this.subscriptions.clear();
        queryManager.removeObservableQuery(this.queryId);
        queryManager.stopQuery(this.queryId);
        this.observers.clear();
    };
    return ObservableQuery;
}($02a3c2aebc919401$var$Observable);
function $02a3c2aebc919401$var$defaultSubscriptionObserverErrorCallback(error) {}
function $02a3c2aebc919401$var$iterateObserversSafely(observers, method, argument) {
    var observersWithMethod = [];
    observers.forEach(function(obs) {
        return obs[method] && observersWithMethod.push(obs);
    });
    observersWithMethod.forEach(function(obs) {
        return obs[method](argument);
    });
}
function $02a3c2aebc919401$var$assertNotCacheFirstOrOnly(obsQuery) {
    var fetchPolicy = obsQuery.options.fetchPolicy;
    (0, $1DiV8.invariant)(fetchPolicy !== 'cache-first' && fetchPolicy !== 'cache-only', 3);
}
var $02a3c2aebc919401$var$MutationStore = function() {
    function MutationStore() {
        this.store = {};
    }
    MutationStore.prototype.getStore = function() {
        return this.store;
    };
    MutationStore.prototype.get = function(mutationId) {
        return this.store[mutationId];
    };
    MutationStore.prototype.initMutation = function(mutationId, mutation, variables) {
        this.store[mutationId] = {
            mutation: mutation,
            variables: variables || {},
            loading: true,
            error: null
        };
    };
    MutationStore.prototype.markMutationError = function(mutationId, error) {
        var mutation = this.store[mutationId];
        if (mutation) {
            mutation.loading = false;
            mutation.error = error;
        }
    };
    MutationStore.prototype.markMutationResult = function(mutationId) {
        var mutation = this.store[mutationId];
        if (mutation) {
            mutation.loading = false;
            mutation.error = null;
        }
    };
    MutationStore.prototype.reset = function() {
        this.store = {};
    };
    return MutationStore;
}();
var $02a3c2aebc919401$var$QueryStore = function() {
    function QueryStore() {
        this.store = {};
    }
    QueryStore.prototype.getStore = function() {
        return this.store;
    };
    QueryStore.prototype.get = function(queryId) {
        return this.store[queryId];
    };
    QueryStore.prototype.initQuery = function(query) {
        var previousQuery = this.store[query.queryId];
        (0, $1DiV8.invariant)(!previousQuery || previousQuery.document === query.document || (0, $bqMzA.equal)(previousQuery.document, query.document), 19);
        var isSetVariables = false;
        var previousVariables = null;
        if (query.storePreviousVariables && previousQuery && previousQuery.networkStatus !== $02a3c2aebc919401$export$bd096ddbd246c79c.loading) {
            if (!(0, $bqMzA.equal)(previousQuery.variables, query.variables)) {
                isSetVariables = true;
                previousVariables = previousQuery.variables;
            }
        }
        var networkStatus;
        if (isSetVariables) networkStatus = $02a3c2aebc919401$export$bd096ddbd246c79c.setVariables;
        else if (query.isPoll) networkStatus = $02a3c2aebc919401$export$bd096ddbd246c79c.poll;
        else if (query.isRefetch) networkStatus = $02a3c2aebc919401$export$bd096ddbd246c79c.refetch;
        else networkStatus = $02a3c2aebc919401$export$bd096ddbd246c79c.loading;
        var graphQLErrors = [];
        if (previousQuery && previousQuery.graphQLErrors) graphQLErrors = previousQuery.graphQLErrors;
        this.store[query.queryId] = {
            document: query.document,
            variables: query.variables,
            previousVariables: previousVariables,
            networkError: null,
            graphQLErrors: graphQLErrors,
            networkStatus: networkStatus,
            metadata: query.metadata
        };
        if (typeof query.fetchMoreForQueryId === 'string' && this.store[query.fetchMoreForQueryId]) this.store[query.fetchMoreForQueryId].networkStatus = $02a3c2aebc919401$export$bd096ddbd246c79c.fetchMore;
    };
    QueryStore.prototype.markQueryResult = function(queryId, result, fetchMoreForQueryId) {
        if (!this.store || !this.store[queryId]) return;
        this.store[queryId].networkError = null;
        this.store[queryId].graphQLErrors = $02a3c2aebc919401$var$isNonEmptyArray(result.errors) ? result.errors : [];
        this.store[queryId].previousVariables = null;
        this.store[queryId].networkStatus = $02a3c2aebc919401$export$bd096ddbd246c79c.ready;
        if (typeof fetchMoreForQueryId === 'string' && this.store[fetchMoreForQueryId]) this.store[fetchMoreForQueryId].networkStatus = $02a3c2aebc919401$export$bd096ddbd246c79c.ready;
    };
    QueryStore.prototype.markQueryError = function(queryId, error, fetchMoreForQueryId) {
        if (!this.store || !this.store[queryId]) return;
        this.store[queryId].networkError = error;
        this.store[queryId].networkStatus = $02a3c2aebc919401$export$bd096ddbd246c79c.error;
        if (typeof fetchMoreForQueryId === 'string') this.markQueryResultClient(fetchMoreForQueryId, true);
    };
    QueryStore.prototype.markQueryResultClient = function(queryId, complete) {
        var storeValue = this.store && this.store[queryId];
        if (storeValue) {
            storeValue.networkError = null;
            storeValue.previousVariables = null;
            if (complete) storeValue.networkStatus = $02a3c2aebc919401$export$bd096ddbd246c79c.ready;
        }
    };
    QueryStore.prototype.stopQuery = function(queryId) {
        delete this.store[queryId];
    };
    QueryStore.prototype.reset = function(observableQueryIds) {
        var _this = this;
        Object.keys(this.store).forEach(function(queryId) {
            if (observableQueryIds.indexOf(queryId) < 0) _this.stopQuery(queryId);
            else _this.store[queryId].networkStatus = $02a3c2aebc919401$export$bd096ddbd246c79c.loading;
        });
    };
    return QueryStore;
}();
function $02a3c2aebc919401$var$capitalizeFirstLetter(str) {
    return str.charAt(0).toUpperCase() + str.slice(1);
}
var $02a3c2aebc919401$var$LocalState = function() {
    function LocalState(_a) {
        var cache = _a.cache, client = _a.client, resolvers = _a.resolvers, fragmentMatcher = _a.fragmentMatcher;
        this.cache = cache;
        if (client) this.client = client;
        if (resolvers) this.addResolvers(resolvers);
        if (fragmentMatcher) this.setFragmentMatcher(fragmentMatcher);
    }
    LocalState.prototype.addResolvers = function(resolvers) {
        var _this = this;
        this.resolvers = this.resolvers || {};
        if (Array.isArray(resolvers)) resolvers.forEach(function(resolverGroup) {
            _this.resolvers = (0, $jojW6.mergeDeep)(_this.resolvers, resolverGroup);
        });
        else this.resolvers = (0, $jojW6.mergeDeep)(this.resolvers, resolvers);
    };
    LocalState.prototype.setResolvers = function(resolvers) {
        this.resolvers = {};
        this.addResolvers(resolvers);
    };
    LocalState.prototype.getResolvers = function() {
        return this.resolvers || {};
    };
    LocalState.prototype.runResolvers = function(_a) {
        var document = _a.document, remoteResult = _a.remoteResult, context = _a.context, variables = _a.variables, _b = _a.onlyRunForcedResolvers, onlyRunForcedResolvers = _b === void 0 ? false : _b;
        return (0, $3VFsf.__awaiter)(this, void 0, void 0, function() {
            return (0, $3VFsf.__generator)(this, function(_c) {
                if (document) return [
                    2,
                    this.resolveDocument(document, remoteResult.data, context, variables, this.fragmentMatcher, onlyRunForcedResolvers).then(function(localResult) {
                        return (0, $3VFsf.__assign)((0, $3VFsf.__assign)({}, remoteResult), {
                            data: localResult.result
                        });
                    })
                ];
                return [
                    2,
                    remoteResult
                ];
            });
        });
    };
    LocalState.prototype.setFragmentMatcher = function(fragmentMatcher) {
        this.fragmentMatcher = fragmentMatcher;
    };
    LocalState.prototype.getFragmentMatcher = function() {
        return this.fragmentMatcher;
    };
    LocalState.prototype.clientQuery = function(document) {
        if ((0, $jojW6.hasDirectives)([
            'client'
        ], document)) {
            if (this.resolvers) return document;
        }
        return null;
    };
    LocalState.prototype.serverQuery = function(document) {
        return this.resolvers ? (0, $jojW6.removeClientSetsFromDocument)(document) : document;
    };
    LocalState.prototype.prepareContext = function(context) {
        if (context === void 0) context = {};
        var cache = this.cache;
        var newContext = (0, $3VFsf.__assign)((0, $3VFsf.__assign)({}, context), {
            cache: cache,
            getCacheKey: function(obj) {
                if (cache.config) return cache.config.dataIdFromObject(obj);
                else (0, $1DiV8.invariant)(false, 6);
            }
        });
        return newContext;
    };
    LocalState.prototype.addExportedVariables = function(document, variables, context) {
        if (variables === void 0) variables = {};
        if (context === void 0) context = {};
        return (0, $3VFsf.__awaiter)(this, void 0, void 0, function() {
            return (0, $3VFsf.__generator)(this, function(_a) {
                if (document) return [
                    2,
                    this.resolveDocument(document, this.buildRootValueFromCache(document, variables) || {}, this.prepareContext(context), variables).then(function(data) {
                        return (0, $3VFsf.__assign)((0, $3VFsf.__assign)({}, variables), data.exportedVariables);
                    })
                ];
                return [
                    2,
                    (0, $3VFsf.__assign)({}, variables)
                ];
            });
        });
    };
    LocalState.prototype.shouldForceResolvers = function(document) {
        var forceResolvers = false;
        (0, $12QNw.visit)(document, {
            Directive: {
                enter: function(node) {
                    if (node.name.value === 'client' && node.arguments) {
                        forceResolvers = node.arguments.some(function(arg) {
                            return arg.name.value === 'always' && arg.value.kind === 'BooleanValue' && arg.value.value === true;
                        });
                        if (forceResolvers) return 0, $12QNw.BREAK;
                    }
                }
            }
        });
        return forceResolvers;
    };
    LocalState.prototype.buildRootValueFromCache = function(document, variables) {
        return this.cache.diff({
            query: (0, $jojW6.buildQueryFromSelectionSet)(document),
            variables: variables,
            returnPartialData: true,
            optimistic: false
        }).result;
    };
    LocalState.prototype.resolveDocument = function(document, rootValue, context, variables, fragmentMatcher, onlyRunForcedResolvers) {
        if (context === void 0) context = {};
        if (variables === void 0) variables = {};
        if (fragmentMatcher === void 0) fragmentMatcher = function() {
            return true;
        };
        if (onlyRunForcedResolvers === void 0) onlyRunForcedResolvers = false;
        return (0, $3VFsf.__awaiter)(this, void 0, void 0, function() {
            var mainDefinition, fragments, fragmentMap, definitionOperation, defaultOperationType, _a, cache, client, execContext;
            return (0, $3VFsf.__generator)(this, function(_b) {
                mainDefinition = (0, $jojW6.getMainDefinition)(document);
                fragments = (0, $jojW6.getFragmentDefinitions)(document);
                fragmentMap = (0, $jojW6.createFragmentMap)(fragments);
                definitionOperation = mainDefinition.operation;
                defaultOperationType = definitionOperation ? $02a3c2aebc919401$var$capitalizeFirstLetter(definitionOperation) : 'Query';
                _a = this, cache = _a.cache, client = _a.client;
                execContext = {
                    fragmentMap: fragmentMap,
                    context: (0, $3VFsf.__assign)((0, $3VFsf.__assign)({}, context), {
                        cache: cache,
                        client: client
                    }),
                    variables: variables,
                    fragmentMatcher: fragmentMatcher,
                    defaultOperationType: defaultOperationType,
                    exportedVariables: {},
                    onlyRunForcedResolvers: onlyRunForcedResolvers
                };
                return [
                    2,
                    this.resolveSelectionSet(mainDefinition.selectionSet, rootValue, execContext).then(function(result) {
                        return {
                            result: result,
                            exportedVariables: execContext.exportedVariables
                        };
                    })
                ];
            });
        });
    };
    LocalState.prototype.resolveSelectionSet = function(selectionSet, rootValue, execContext) {
        return (0, $3VFsf.__awaiter)(this, void 0, void 0, function() {
            var fragmentMap, context, variables, resultsToMerge, execute;
            var _this = this;
            return (0, $3VFsf.__generator)(this, function(_a) {
                fragmentMap = execContext.fragmentMap, context = execContext.context, variables = execContext.variables;
                resultsToMerge = [
                    rootValue
                ];
                execute = function(selection) {
                    return (0, $3VFsf.__awaiter)(_this, void 0, void 0, function() {
                        var fragment, typeCondition;
                        return (0, $3VFsf.__generator)(this, function(_a) {
                            if (!(0, $jojW6.shouldInclude)(selection, variables)) return [
                                2
                            ];
                            if ((0, $jojW6.isField)(selection)) return [
                                2,
                                this.resolveField(selection, rootValue, execContext).then(function(fieldResult) {
                                    var _a;
                                    if (typeof fieldResult !== 'undefined') resultsToMerge.push((_a = {}, _a[(0, $jojW6.resultKeyNameFromField)(selection)] = fieldResult, _a));
                                })
                            ];
                            if ((0, $jojW6.isInlineFragment)(selection)) fragment = selection;
                            else {
                                fragment = fragmentMap[selection.name.value];
                                (0, $1DiV8.invariant)(fragment, 7);
                            }
                            if (fragment && fragment.typeCondition) {
                                typeCondition = fragment.typeCondition.name.value;
                                if (execContext.fragmentMatcher(rootValue, typeCondition, context)) return [
                                    2,
                                    this.resolveSelectionSet(fragment.selectionSet, rootValue, execContext).then(function(fragmentResult) {
                                        resultsToMerge.push(fragmentResult);
                                    })
                                ];
                            }
                            return [
                                2
                            ];
                        });
                    });
                };
                return [
                    2,
                    Promise.all(selectionSet.selections.map(execute)).then(function() {
                        return (0, $jojW6.mergeDeepArray)(resultsToMerge);
                    })
                ];
            });
        });
    };
    LocalState.prototype.resolveField = function(field, rootValue, execContext) {
        return (0, $3VFsf.__awaiter)(this, void 0, void 0, function() {
            var variables, fieldName, aliasedFieldName, aliasUsed, defaultResult, resultPromise, resolverType, resolverMap, resolve;
            var _this = this;
            return (0, $3VFsf.__generator)(this, function(_a) {
                variables = execContext.variables;
                fieldName = field.name.value;
                aliasedFieldName = (0, $jojW6.resultKeyNameFromField)(field);
                aliasUsed = fieldName !== aliasedFieldName;
                defaultResult = rootValue[aliasedFieldName] || rootValue[fieldName];
                resultPromise = Promise.resolve(defaultResult);
                if (!execContext.onlyRunForcedResolvers || this.shouldForceResolvers(field)) {
                    resolverType = rootValue.__typename || execContext.defaultOperationType;
                    resolverMap = this.resolvers && this.resolvers[resolverType];
                    if (resolverMap) {
                        resolve = resolverMap[aliasUsed ? fieldName : aliasedFieldName];
                        if (resolve) resultPromise = Promise.resolve(resolve(rootValue, (0, $jojW6.argumentsObjectFromField)(field, variables), execContext.context, {
                            field: field,
                            fragmentMap: execContext.fragmentMap
                        }));
                    }
                }
                return [
                    2,
                    resultPromise.then(function(result) {
                        if (result === void 0) result = defaultResult;
                        if (field.directives) field.directives.forEach(function(directive) {
                            if (directive.name.value === 'export' && directive.arguments) directive.arguments.forEach(function(arg) {
                                if (arg.name.value === 'as' && arg.value.kind === 'StringValue') execContext.exportedVariables[arg.value.value] = result;
                            });
                        });
                        if (!field.selectionSet) return result;
                        if (result == null) return result;
                        if (Array.isArray(result)) return _this.resolveSubSelectedArray(field, result, execContext);
                        if (field.selectionSet) return _this.resolveSelectionSet(field.selectionSet, result, execContext);
                    })
                ];
            });
        });
    };
    LocalState.prototype.resolveSubSelectedArray = function(field, result, execContext) {
        var _this = this;
        return Promise.all(result.map(function(item) {
            if (item === null) return null;
            if (Array.isArray(item)) return _this.resolveSubSelectedArray(field, item, execContext);
            if (field.selectionSet) return _this.resolveSelectionSet(field.selectionSet, item, execContext);
        }));
    };
    return LocalState;
}();
function $02a3c2aebc919401$var$multiplex(inner) {
    var observers = new Set();
    var sub = null;
    return new $02a3c2aebc919401$var$Observable(function(observer) {
        observers.add(observer);
        sub = sub || inner.subscribe({
            next: function(value) {
                observers.forEach(function(obs) {
                    return obs.next && obs.next(value);
                });
            },
            error: function(error) {
                observers.forEach(function(obs) {
                    return obs.error && obs.error(error);
                });
            },
            complete: function() {
                observers.forEach(function(obs) {
                    return obs.complete && obs.complete();
                });
            }
        });
        return function() {
            if (observers.delete(observer) && !observers.size && sub) {
                sub.unsubscribe();
                sub = null;
            }
        };
    });
}
function $02a3c2aebc919401$var$asyncMap(observable, mapFn) {
    return new $02a3c2aebc919401$var$Observable(function(observer) {
        var next = observer.next, error = observer.error, complete = observer.complete;
        var activeNextCount = 0;
        var completed = false;
        var handler = {
            next: function(value) {
                ++activeNextCount;
                new Promise(function(resolve) {
                    resolve(mapFn(value));
                }).then(function(result) {
                    --activeNextCount;
                    next && next.call(observer, result);
                    completed && handler.complete();
                }, function(e) {
                    --activeNextCount;
                    error && error.call(observer, e);
                });
            },
            error: function(e) {
                error && error.call(observer, e);
            },
            complete: function() {
                completed = true;
                if (!activeNextCount) complete && complete.call(observer);
            }
        };
        var sub = observable.subscribe(handler);
        return function() {
            return sub.unsubscribe();
        };
    });
}
var $02a3c2aebc919401$var$hasOwnProperty = Object.prototype.hasOwnProperty;
var $02a3c2aebc919401$var$QueryManager = function() {
    function QueryManager(_a) {
        var link = _a.link, _b = _a.queryDeduplication, queryDeduplication = _b === void 0 ? false : _b, store = _a.store, _c = _a.onBroadcast, onBroadcast = _c === void 0 ? function() {
            return undefined;
        } : _c, _d = _a.ssrMode, ssrMode = _d === void 0 ? false : _d, _e = _a.clientAwareness, clientAwareness = _e === void 0 ? {} : _e, localState = _a.localState, assumeImmutableResults = _a.assumeImmutableResults;
        this.mutationStore = new $02a3c2aebc919401$var$MutationStore();
        this.queryStore = new $02a3c2aebc919401$var$QueryStore();
        this.clientAwareness = {};
        this.idCounter = 1;
        this.queries = new Map();
        this.fetchQueryRejectFns = new Map();
        this.transformCache = new ((0, $jojW6.canUseWeakMap) ? WeakMap : Map)();
        this.inFlightLinkObservables = new Map();
        this.pollingInfoByQueryId = new Map();
        this.link = link;
        this.queryDeduplication = queryDeduplication;
        this.dataStore = store;
        this.onBroadcast = onBroadcast;
        this.clientAwareness = clientAwareness;
        this.localState = localState || new $02a3c2aebc919401$var$LocalState({
            cache: store.getCache()
        });
        this.ssrMode = ssrMode;
        this.assumeImmutableResults = !!assumeImmutableResults;
    }
    QueryManager.prototype.stop = function() {
        var _this = this;
        this.queries.forEach(function(_info, queryId) {
            _this.stopQueryNoBroadcast(queryId);
        });
        this.fetchQueryRejectFns.forEach(function(reject) {
            reject(new (0, $1DiV8.InvariantError)(8));
        });
    };
    QueryManager.prototype.mutate = function(_a) {
        var mutation = _a.mutation, variables = _a.variables, optimisticResponse = _a.optimisticResponse, updateQueriesByName = _a.updateQueries, _b = _a.refetchQueries, refetchQueries = _b === void 0 ? [] : _b, _c = _a.awaitRefetchQueries, awaitRefetchQueries = _c === void 0 ? false : _c, updateWithProxyFn = _a.update, _d = _a.errorPolicy, errorPolicy = _d === void 0 ? 'none' : _d, fetchPolicy = _a.fetchPolicy, _e = _a.context, context = _e === void 0 ? {} : _e;
        return (0, $3VFsf.__awaiter)(this, void 0, void 0, function() {
            var mutationId, generateUpdateQueriesInfo, self;
            var _this = this;
            return (0, $3VFsf.__generator)(this, function(_f) {
                switch(_f.label){
                    case 0:
                        (0, $1DiV8.invariant)(mutation, 9);
                        (0, $1DiV8.invariant)(!fetchPolicy || fetchPolicy === 'no-cache', 10);
                        mutationId = this.generateQueryId();
                        mutation = this.transform(mutation).document;
                        this.setQuery(mutationId, function() {
                            return {
                                document: mutation
                            };
                        });
                        variables = this.getVariables(mutation, variables);
                        if (!this.transform(mutation).hasClientExports) return [
                            3,
                            2
                        ];
                        return [
                            4,
                            this.localState.addExportedVariables(mutation, variables, context)
                        ];
                    case 1:
                        variables = _f.sent();
                        _f.label = 2;
                    case 2:
                        generateUpdateQueriesInfo = function() {
                            var ret = {};
                            if (updateQueriesByName) _this.queries.forEach(function(_a, queryId) {
                                var observableQuery = _a.observableQuery;
                                if (observableQuery) {
                                    var queryName = observableQuery.queryName;
                                    if (queryName && $02a3c2aebc919401$var$hasOwnProperty.call(updateQueriesByName, queryName)) ret[queryId] = {
                                        updater: updateQueriesByName[queryName],
                                        query: _this.queryStore.get(queryId)
                                    };
                                }
                            });
                            return ret;
                        };
                        this.mutationStore.initMutation(mutationId, mutation, variables);
                        this.dataStore.markMutationInit({
                            mutationId: mutationId,
                            document: mutation,
                            variables: variables,
                            updateQueries: generateUpdateQueriesInfo(),
                            update: updateWithProxyFn,
                            optimisticResponse: optimisticResponse
                        });
                        this.broadcastQueries();
                        self = this;
                        return [
                            2,
                            new Promise(function(resolve, reject) {
                                var storeResult;
                                var error;
                                self.getObservableFromLink(mutation, (0, $3VFsf.__assign)((0, $3VFsf.__assign)({}, context), {
                                    optimisticResponse: optimisticResponse
                                }), variables, false).subscribe({
                                    next: function(result) {
                                        if ((0, $jojW6.graphQLResultHasError)(result) && errorPolicy === 'none') {
                                            error = new $02a3c2aebc919401$export$26a337512320b8c6({
                                                graphQLErrors: result.errors
                                            });
                                            return;
                                        }
                                        self.mutationStore.markMutationResult(mutationId);
                                        if (fetchPolicy !== 'no-cache') self.dataStore.markMutationResult({
                                            mutationId: mutationId,
                                            result: result,
                                            document: mutation,
                                            variables: variables,
                                            updateQueries: generateUpdateQueriesInfo(),
                                            update: updateWithProxyFn
                                        });
                                        storeResult = result;
                                    },
                                    error: function(err) {
                                        self.mutationStore.markMutationError(mutationId, err);
                                        self.dataStore.markMutationComplete({
                                            mutationId: mutationId,
                                            optimisticResponse: optimisticResponse
                                        });
                                        self.broadcastQueries();
                                        self.setQuery(mutationId, function() {
                                            return {
                                                document: null
                                            };
                                        });
                                        reject(new $02a3c2aebc919401$export$26a337512320b8c6({
                                            networkError: err
                                        }));
                                    },
                                    complete: function() {
                                        if (error) self.mutationStore.markMutationError(mutationId, error);
                                        self.dataStore.markMutationComplete({
                                            mutationId: mutationId,
                                            optimisticResponse: optimisticResponse
                                        });
                                        self.broadcastQueries();
                                        if (error) {
                                            reject(error);
                                            return;
                                        }
                                        if (typeof refetchQueries === 'function') refetchQueries = refetchQueries(storeResult);
                                        var refetchQueryPromises = [];
                                        if ($02a3c2aebc919401$var$isNonEmptyArray(refetchQueries)) refetchQueries.forEach(function(refetchQuery) {
                                            if (typeof refetchQuery === 'string') self.queries.forEach(function(_a) {
                                                var observableQuery = _a.observableQuery;
                                                if (observableQuery && observableQuery.queryName === refetchQuery) refetchQueryPromises.push(observableQuery.refetch());
                                            });
                                            else {
                                                var queryOptions = {
                                                    query: refetchQuery.query,
                                                    variables: refetchQuery.variables,
                                                    fetchPolicy: 'network-only'
                                                };
                                                if (refetchQuery.context) queryOptions.context = refetchQuery.context;
                                                refetchQueryPromises.push(self.query(queryOptions));
                                            }
                                        });
                                        Promise.all(awaitRefetchQueries ? refetchQueryPromises : []).then(function() {
                                            self.setQuery(mutationId, function() {
                                                return {
                                                    document: null
                                                };
                                            });
                                            if (errorPolicy === 'ignore' && storeResult && (0, $jojW6.graphQLResultHasError)(storeResult)) delete storeResult.errors;
                                            resolve(storeResult);
                                        });
                                    }
                                });
                            })
                        ];
                }
            });
        });
    };
    QueryManager.prototype.fetchQuery = function(queryId, options, fetchType, fetchMoreForQueryId) {
        return (0, $3VFsf.__awaiter)(this, void 0, void 0, function() {
            var _a, metadata, _b, fetchPolicy, _c, context, query, variables, storeResult, isNetworkOnly, needToFetch, _d, complete, result, shouldFetch, requestId, cancel, networkResult;
            var _this = this;
            return (0, $3VFsf.__generator)(this, function(_e) {
                switch(_e.label){
                    case 0:
                        _a = options.metadata, metadata = _a === void 0 ? null : _a, _b = options.fetchPolicy, fetchPolicy = _b === void 0 ? 'cache-first' : _b, _c = options.context, context = _c === void 0 ? {} : _c;
                        query = this.transform(options.query).document;
                        variables = this.getVariables(query, options.variables);
                        if (!this.transform(query).hasClientExports) return [
                            3,
                            2
                        ];
                        return [
                            4,
                            this.localState.addExportedVariables(query, variables, context)
                        ];
                    case 1:
                        variables = _e.sent();
                        _e.label = 2;
                    case 2:
                        options = (0, $3VFsf.__assign)((0, $3VFsf.__assign)({}, options), {
                            variables: variables
                        });
                        isNetworkOnly = fetchPolicy === 'network-only' || fetchPolicy === 'no-cache';
                        needToFetch = isNetworkOnly;
                        if (!isNetworkOnly) {
                            _d = this.dataStore.getCache().diff({
                                query: query,
                                variables: variables,
                                returnPartialData: true,
                                optimistic: false
                            }), complete = _d.complete, result = _d.result;
                            needToFetch = !complete || fetchPolicy === 'cache-and-network';
                            storeResult = result;
                        }
                        shouldFetch = needToFetch && fetchPolicy !== 'cache-only' && fetchPolicy !== 'standby';
                        if ((0, $jojW6.hasDirectives)([
                            'live'
                        ], query)) shouldFetch = true;
                        requestId = this.idCounter++;
                        cancel = fetchPolicy !== 'no-cache' ? this.updateQueryWatch(queryId, query, options) : undefined;
                        this.setQuery(queryId, function() {
                            return {
                                document: query,
                                lastRequestId: requestId,
                                invalidated: true,
                                cancel: cancel
                            };
                        });
                        this.invalidate(fetchMoreForQueryId);
                        this.queryStore.initQuery({
                            queryId: queryId,
                            document: query,
                            storePreviousVariables: shouldFetch,
                            variables: variables,
                            isPoll: fetchType === $02a3c2aebc919401$export$160bafb6ac1e0641.poll,
                            isRefetch: fetchType === $02a3c2aebc919401$export$160bafb6ac1e0641.refetch,
                            metadata: metadata,
                            fetchMoreForQueryId: fetchMoreForQueryId
                        });
                        this.broadcastQueries();
                        if (shouldFetch) {
                            networkResult = this.fetchRequest({
                                requestId: requestId,
                                queryId: queryId,
                                document: query,
                                options: options,
                                fetchMoreForQueryId: fetchMoreForQueryId
                            }).catch(function(error) {
                                if ($02a3c2aebc919401$export$17f5e6bd290bb15d(error)) throw error;
                                else {
                                    if (requestId >= _this.getQuery(queryId).lastRequestId) {
                                        _this.queryStore.markQueryError(queryId, error, fetchMoreForQueryId);
                                        _this.invalidate(queryId);
                                        _this.invalidate(fetchMoreForQueryId);
                                        _this.broadcastQueries();
                                    }
                                    throw new $02a3c2aebc919401$export$26a337512320b8c6({
                                        networkError: error
                                    });
                                }
                            });
                            if (fetchPolicy !== 'cache-and-network') return [
                                2,
                                networkResult
                            ];
                            networkResult.catch(function() {});
                        }
                        this.queryStore.markQueryResultClient(queryId, !shouldFetch);
                        this.invalidate(queryId);
                        this.invalidate(fetchMoreForQueryId);
                        if (this.transform(query).hasForcedResolvers) return [
                            2,
                            this.localState.runResolvers({
                                document: query,
                                remoteResult: {
                                    data: storeResult
                                },
                                context: context,
                                variables: variables,
                                onlyRunForcedResolvers: true
                            }).then(function(result) {
                                _this.markQueryResult(queryId, result, options, fetchMoreForQueryId);
                                _this.broadcastQueries();
                                return result;
                            })
                        ];
                        this.broadcastQueries();
                        return [
                            2,
                            {
                                data: storeResult
                            }
                        ];
                }
            });
        });
    };
    QueryManager.prototype.markQueryResult = function(queryId, result, _a, fetchMoreForQueryId) {
        var fetchPolicy = _a.fetchPolicy, variables = _a.variables, errorPolicy = _a.errorPolicy;
        if (fetchPolicy === 'no-cache') this.setQuery(queryId, function() {
            return {
                newData: {
                    result: result.data,
                    complete: true
                }
            };
        });
        else this.dataStore.markQueryResult(result, this.getQuery(queryId).document, variables, fetchMoreForQueryId, errorPolicy === 'ignore' || errorPolicy === 'all');
    };
    QueryManager.prototype.queryListenerForObserver = function(queryId, options, observer) {
        var _this = this;
        function invoke(method, argument) {
            if (observer[method]) try {
                observer[method](argument);
            } catch (e) {}
            else method;
        }
        return function(queryStoreValue, newData) {
            _this.invalidate(queryId, false);
            if (!queryStoreValue) return;
            var _a = _this.getQuery(queryId), observableQuery = _a.observableQuery, document = _a.document;
            var fetchPolicy = observableQuery ? observableQuery.options.fetchPolicy : options.fetchPolicy;
            if (fetchPolicy === 'standby') return;
            var loading = $02a3c2aebc919401$var$isNetworkRequestInFlight(queryStoreValue.networkStatus);
            var lastResult = observableQuery && observableQuery.getLastResult();
            var networkStatusChanged = !!(lastResult && lastResult.networkStatus !== queryStoreValue.networkStatus);
            var shouldNotifyIfLoading = options.returnPartialData || !newData && queryStoreValue.previousVariables || networkStatusChanged && options.notifyOnNetworkStatusChange || fetchPolicy === 'cache-only' || fetchPolicy === 'cache-and-network';
            if (loading && !shouldNotifyIfLoading) return;
            var hasGraphQLErrors = $02a3c2aebc919401$var$isNonEmptyArray(queryStoreValue.graphQLErrors);
            var errorPolicy = observableQuery && observableQuery.options.errorPolicy || options.errorPolicy || 'none';
            if (errorPolicy === 'none' && hasGraphQLErrors || queryStoreValue.networkError) return invoke('error', new $02a3c2aebc919401$export$26a337512320b8c6({
                graphQLErrors: queryStoreValue.graphQLErrors,
                networkError: queryStoreValue.networkError
            }));
            try {
                var data = void 0;
                var isMissing = void 0;
                if (newData) {
                    if (fetchPolicy !== 'no-cache' && fetchPolicy !== 'network-only') _this.setQuery(queryId, function() {
                        return {
                            newData: null
                        };
                    });
                    data = newData.result;
                    isMissing = !newData.complete;
                } else {
                    var lastError = observableQuery && observableQuery.getLastError();
                    var errorStatusChanged = errorPolicy !== 'none' && (lastError && lastError.graphQLErrors) !== queryStoreValue.graphQLErrors;
                    if (lastResult && lastResult.data && !errorStatusChanged) {
                        data = lastResult.data;
                        isMissing = false;
                    } else {
                        var diffResult = _this.dataStore.getCache().diff({
                            query: document,
                            variables: queryStoreValue.previousVariables || queryStoreValue.variables,
                            returnPartialData: true,
                            optimistic: true
                        });
                        data = diffResult.result;
                        isMissing = !diffResult.complete;
                    }
                }
                var stale = isMissing && !(options.returnPartialData || fetchPolicy === 'cache-only');
                var resultFromStore = {
                    data: stale ? lastResult && lastResult.data : data,
                    loading: loading,
                    networkStatus: queryStoreValue.networkStatus,
                    stale: stale
                };
                if (errorPolicy === 'all' && hasGraphQLErrors) resultFromStore.errors = queryStoreValue.graphQLErrors;
                invoke('next', resultFromStore);
            } catch (networkError) {
                invoke('error', new $02a3c2aebc919401$export$26a337512320b8c6({
                    networkError: networkError
                }));
            }
        };
    };
    QueryManager.prototype.transform = function(document) {
        var transformCache = this.transformCache;
        if (!transformCache.has(document)) {
            var cache = this.dataStore.getCache();
            var transformed = cache.transformDocument(document);
            var forLink = (0, $jojW6.removeConnectionDirectiveFromDocument)(cache.transformForLink(transformed));
            var clientQuery = this.localState.clientQuery(transformed);
            var serverQuery = this.localState.serverQuery(forLink);
            var cacheEntry_1 = {
                document: transformed,
                hasClientExports: (0, $jojW6.hasClientExports)(transformed),
                hasForcedResolvers: this.localState.shouldForceResolvers(transformed),
                clientQuery: clientQuery,
                serverQuery: serverQuery,
                defaultVars: (0, $jojW6.getDefaultValues)((0, $jojW6.getOperationDefinition)(transformed))
            };
            var add = function(doc) {
                if (doc && !transformCache.has(doc)) transformCache.set(doc, cacheEntry_1);
            };
            add(document);
            add(transformed);
            add(clientQuery);
            add(serverQuery);
        }
        return transformCache.get(document);
    };
    QueryManager.prototype.getVariables = function(document, variables) {
        return (0, $3VFsf.__assign)((0, $3VFsf.__assign)({}, this.transform(document).defaultVars), variables);
    };
    QueryManager.prototype.watchQuery = function(options, shouldSubscribe) {
        if (shouldSubscribe === void 0) shouldSubscribe = true;
        (0, $1DiV8.invariant)(options.fetchPolicy !== 'standby', 11);
        options.variables = this.getVariables(options.query, options.variables);
        if (typeof options.notifyOnNetworkStatusChange === 'undefined') options.notifyOnNetworkStatusChange = false;
        var transformedOptions = (0, $3VFsf.__assign)({}, options);
        return new $02a3c2aebc919401$export$6c1b56eac59c9584({
            queryManager: this,
            options: transformedOptions,
            shouldSubscribe: shouldSubscribe
        });
    };
    QueryManager.prototype.query = function(options) {
        var _this = this;
        (0, $1DiV8.invariant)(options.query, 12);
        (0, $1DiV8.invariant)(options.query.kind === 'Document', 13);
        (0, $1DiV8.invariant)(!options.returnPartialData, 14);
        (0, $1DiV8.invariant)(!options.pollInterval, 15);
        return new Promise(function(resolve, reject) {
            var watchedQuery = _this.watchQuery(options, false);
            _this.fetchQueryRejectFns.set("query:" + watchedQuery.queryId, reject);
            watchedQuery.result().then(resolve, reject).then(function() {
                return _this.fetchQueryRejectFns.delete("query:" + watchedQuery.queryId);
            });
        });
    };
    QueryManager.prototype.generateQueryId = function() {
        return String(this.idCounter++);
    };
    QueryManager.prototype.stopQueryInStore = function(queryId) {
        this.stopQueryInStoreNoBroadcast(queryId);
        this.broadcastQueries();
    };
    QueryManager.prototype.stopQueryInStoreNoBroadcast = function(queryId) {
        this.stopPollingQuery(queryId);
        this.queryStore.stopQuery(queryId);
        this.invalidate(queryId);
    };
    QueryManager.prototype.addQueryListener = function(queryId, listener) {
        this.setQuery(queryId, function(_a) {
            var listeners = _a.listeners;
            listeners.add(listener);
            return {
                invalidated: false
            };
        });
    };
    QueryManager.prototype.updateQueryWatch = function(queryId, document, options) {
        var _this = this;
        var cancel = this.getQuery(queryId).cancel;
        if (cancel) cancel();
        var previousResult = function() {
            var previousResult = null;
            var observableQuery = _this.getQuery(queryId).observableQuery;
            if (observableQuery) {
                var lastResult = observableQuery.getLastResult();
                if (lastResult) previousResult = lastResult.data;
            }
            return previousResult;
        };
        return this.dataStore.getCache().watch({
            query: document,
            variables: options.variables,
            optimistic: true,
            previousResult: previousResult,
            callback: function(newData) {
                _this.setQuery(queryId, function() {
                    return {
                        invalidated: true,
                        newData: newData
                    };
                });
            }
        });
    };
    QueryManager.prototype.addObservableQuery = function(queryId, observableQuery) {
        this.setQuery(queryId, function() {
            return {
                observableQuery: observableQuery
            };
        });
    };
    QueryManager.prototype.removeObservableQuery = function(queryId) {
        var cancel = this.getQuery(queryId).cancel;
        this.setQuery(queryId, function() {
            return {
                observableQuery: null
            };
        });
        if (cancel) cancel();
    };
    QueryManager.prototype.clearStore = function() {
        this.fetchQueryRejectFns.forEach(function(reject) {
            reject(new (0, $1DiV8.InvariantError)(16));
        });
        var resetIds = [];
        this.queries.forEach(function(_a, queryId) {
            var observableQuery = _a.observableQuery;
            if (observableQuery) resetIds.push(queryId);
        });
        this.queryStore.reset(resetIds);
        this.mutationStore.reset();
        return this.dataStore.reset();
    };
    QueryManager.prototype.resetStore = function() {
        var _this = this;
        return this.clearStore().then(function() {
            return _this.reFetchObservableQueries();
        });
    };
    QueryManager.prototype.reFetchObservableQueries = function(includeStandby) {
        var _this = this;
        if (includeStandby === void 0) includeStandby = false;
        var observableQueryPromises = [];
        this.queries.forEach(function(_a, queryId) {
            var observableQuery = _a.observableQuery;
            if (observableQuery) {
                var fetchPolicy = observableQuery.options.fetchPolicy;
                observableQuery.resetLastResults();
                if (fetchPolicy !== 'cache-only' && (includeStandby || fetchPolicy !== 'standby')) observableQueryPromises.push(observableQuery.refetch());
                _this.setQuery(queryId, function() {
                    return {
                        newData: null
                    };
                });
                _this.invalidate(queryId);
            }
        });
        this.broadcastQueries();
        return Promise.all(observableQueryPromises);
    };
    QueryManager.prototype.observeQuery = function(queryId, options, observer) {
        this.addQueryListener(queryId, this.queryListenerForObserver(queryId, options, observer));
        return this.fetchQuery(queryId, options);
    };
    QueryManager.prototype.startQuery = function(queryId, options, listener) {
        this.addQueryListener(queryId, listener);
        this.fetchQuery(queryId, options).catch(function() {
            return undefined;
        });
        return queryId;
    };
    QueryManager.prototype.startGraphQLSubscription = function(_a) {
        var _this = this;
        var query = _a.query, fetchPolicy = _a.fetchPolicy, variables = _a.variables;
        query = this.transform(query).document;
        variables = this.getVariables(query, variables);
        var makeObservable = function(variables) {
            return _this.getObservableFromLink(query, {}, variables, false).map(function(result) {
                if (!fetchPolicy || fetchPolicy !== 'no-cache') {
                    _this.dataStore.markSubscriptionResult(result, query, variables);
                    _this.broadcastQueries();
                }
                if ((0, $jojW6.graphQLResultHasError)(result)) throw new $02a3c2aebc919401$export$26a337512320b8c6({
                    graphQLErrors: result.errors
                });
                return result;
            });
        };
        if (this.transform(query).hasClientExports) {
            var observablePromise_1 = this.localState.addExportedVariables(query, variables).then(makeObservable);
            return new $02a3c2aebc919401$var$Observable(function(observer) {
                var sub = null;
                observablePromise_1.then(function(observable) {
                    return sub = observable.subscribe(observer);
                }, observer.error);
                return function() {
                    return sub && sub.unsubscribe();
                };
            });
        }
        return makeObservable(variables);
    };
    QueryManager.prototype.stopQuery = function(queryId) {
        this.stopQueryNoBroadcast(queryId);
        this.broadcastQueries();
    };
    QueryManager.prototype.stopQueryNoBroadcast = function(queryId) {
        this.stopQueryInStoreNoBroadcast(queryId);
        this.removeQuery(queryId);
    };
    QueryManager.prototype.removeQuery = function(queryId) {
        this.fetchQueryRejectFns.delete("query:" + queryId);
        this.fetchQueryRejectFns.delete("fetchRequest:" + queryId);
        this.getQuery(queryId).subscriptions.forEach(function(x) {
            return x.unsubscribe();
        });
        this.queries.delete(queryId);
    };
    QueryManager.prototype.getCurrentQueryResult = function(observableQuery, optimistic) {
        if (optimistic === void 0) optimistic = true;
        var _a = observableQuery.options, variables = _a.variables, query = _a.query, fetchPolicy = _a.fetchPolicy, returnPartialData = _a.returnPartialData;
        var lastResult = observableQuery.getLastResult();
        var newData = this.getQuery(observableQuery.queryId).newData;
        if (newData && newData.complete) return {
            data: newData.result,
            partial: false
        };
        if (fetchPolicy === 'no-cache' || fetchPolicy === 'network-only') return {
            data: undefined,
            partial: false
        };
        var _b = this.dataStore.getCache().diff({
            query: query,
            variables: variables,
            previousResult: lastResult ? lastResult.data : undefined,
            returnPartialData: true,
            optimistic: optimistic
        }), result = _b.result, complete = _b.complete;
        return {
            data: complete || returnPartialData ? result : void 0,
            partial: !complete
        };
    };
    QueryManager.prototype.getQueryWithPreviousResult = function(queryIdOrObservable) {
        var observableQuery;
        if (typeof queryIdOrObservable === 'string') {
            var foundObserveableQuery = this.getQuery(queryIdOrObservable).observableQuery;
            (0, $1DiV8.invariant)(foundObserveableQuery, 17);
            observableQuery = foundObserveableQuery;
        } else observableQuery = queryIdOrObservable;
        var _a = observableQuery.options, variables = _a.variables, query = _a.query;
        return {
            previousResult: this.getCurrentQueryResult(observableQuery, false).data,
            variables: variables,
            document: query
        };
    };
    QueryManager.prototype.broadcastQueries = function() {
        var _this = this;
        this.onBroadcast();
        this.queries.forEach(function(info, id) {
            if (info.invalidated) info.listeners.forEach(function(listener) {
                if (listener) listener(_this.queryStore.get(id), info.newData);
            });
        });
    };
    QueryManager.prototype.getLocalState = function() {
        return this.localState;
    };
    QueryManager.prototype.getObservableFromLink = function(query, context, variables, deduplication) {
        var _this = this;
        if (deduplication === void 0) deduplication = this.queryDeduplication;
        var observable;
        var serverQuery = this.transform(query).serverQuery;
        if (serverQuery) {
            var _a = this, inFlightLinkObservables_1 = _a.inFlightLinkObservables, link = _a.link;
            var operation = {
                query: serverQuery,
                variables: variables,
                operationName: (0, $jojW6.getOperationName)(serverQuery) || void 0,
                context: this.prepareContext((0, $3VFsf.__assign)((0, $3VFsf.__assign)({}, context), {
                    forceFetch: !deduplication
                }))
            };
            context = operation.context;
            if (deduplication) {
                var byVariables_1 = inFlightLinkObservables_1.get(serverQuery) || new Map();
                inFlightLinkObservables_1.set(serverQuery, byVariables_1);
                var varJson_1 = JSON.stringify(variables);
                observable = byVariables_1.get(varJson_1);
                if (!observable) {
                    byVariables_1.set(varJson_1, observable = $02a3c2aebc919401$var$multiplex((0, $clSzL.execute)(link, operation)));
                    var cleanup = function() {
                        byVariables_1.delete(varJson_1);
                        if (!byVariables_1.size) inFlightLinkObservables_1.delete(serverQuery);
                        cleanupSub_1.unsubscribe();
                    };
                    var cleanupSub_1 = observable.subscribe({
                        next: cleanup,
                        error: cleanup,
                        complete: cleanup
                    });
                }
            } else observable = $02a3c2aebc919401$var$multiplex((0, $clSzL.execute)(link, operation));
        } else {
            observable = $02a3c2aebc919401$var$Observable.of({
                data: {}
            });
            context = this.prepareContext(context);
        }
        var clientQuery = this.transform(query).clientQuery;
        if (clientQuery) observable = $02a3c2aebc919401$var$asyncMap(observable, function(result) {
            return _this.localState.runResolvers({
                document: clientQuery,
                remoteResult: result,
                context: context,
                variables: variables
            });
        });
        return observable;
    };
    QueryManager.prototype.fetchRequest = function(_a) {
        var _this = this;
        var requestId = _a.requestId, queryId = _a.queryId, document = _a.document, options = _a.options, fetchMoreForQueryId = _a.fetchMoreForQueryId;
        var variables = options.variables, _b = options.errorPolicy, errorPolicy = _b === void 0 ? 'none' : _b, fetchPolicy = options.fetchPolicy;
        var resultFromStore;
        var errorsFromStore;
        return new Promise(function(resolve, reject) {
            var observable = _this.getObservableFromLink(document, options.context, variables);
            var fqrfId = "fetchRequest:" + queryId;
            _this.fetchQueryRejectFns.set(fqrfId, reject);
            var cleanup = function() {
                _this.fetchQueryRejectFns.delete(fqrfId);
                _this.setQuery(queryId, function(_a) {
                    var subscriptions = _a.subscriptions;
                    subscriptions.delete(subscription);
                });
            };
            var subscription = observable.map(function(result) {
                if (requestId >= _this.getQuery(queryId).lastRequestId) {
                    _this.markQueryResult(queryId, result, options, fetchMoreForQueryId);
                    _this.queryStore.markQueryResult(queryId, result, fetchMoreForQueryId);
                    _this.invalidate(queryId);
                    _this.invalidate(fetchMoreForQueryId);
                    _this.broadcastQueries();
                }
                if (errorPolicy === 'none' && $02a3c2aebc919401$var$isNonEmptyArray(result.errors)) return reject(new $02a3c2aebc919401$export$26a337512320b8c6({
                    graphQLErrors: result.errors
                }));
                if (errorPolicy === 'all') errorsFromStore = result.errors;
                if (fetchMoreForQueryId || fetchPolicy === 'no-cache') resultFromStore = result.data;
                else {
                    var _a = _this.dataStore.getCache().diff({
                        variables: variables,
                        query: document,
                        optimistic: false,
                        returnPartialData: true
                    }), result_1 = _a.result, complete = _a.complete;
                    if (complete || options.returnPartialData) resultFromStore = result_1;
                }
            }).subscribe({
                error: function(error) {
                    cleanup();
                    reject(error);
                },
                complete: function() {
                    cleanup();
                    resolve({
                        data: resultFromStore,
                        errors: errorsFromStore,
                        loading: false,
                        networkStatus: $02a3c2aebc919401$export$bd096ddbd246c79c.ready,
                        stale: false
                    });
                }
            });
            _this.setQuery(queryId, function(_a) {
                var subscriptions = _a.subscriptions;
                subscriptions.add(subscription);
            });
        });
    };
    QueryManager.prototype.getQuery = function(queryId) {
        return this.queries.get(queryId) || {
            listeners: new Set(),
            invalidated: false,
            document: null,
            newData: null,
            lastRequestId: 1,
            observableQuery: null,
            subscriptions: new Set()
        };
    };
    QueryManager.prototype.setQuery = function(queryId, updater) {
        var prev = this.getQuery(queryId);
        var newInfo = (0, $3VFsf.__assign)((0, $3VFsf.__assign)({}, prev), updater(prev));
        this.queries.set(queryId, newInfo);
    };
    QueryManager.prototype.invalidate = function(queryId, invalidated) {
        if (invalidated === void 0) invalidated = true;
        if (queryId) this.setQuery(queryId, function() {
            return {
                invalidated: invalidated
            };
        });
    };
    QueryManager.prototype.prepareContext = function(context) {
        if (context === void 0) context = {};
        var newContext = this.localState.prepareContext(context);
        return (0, $3VFsf.__assign)((0, $3VFsf.__assign)({}, newContext), {
            clientAwareness: this.clientAwareness
        });
    };
    QueryManager.prototype.checkInFlight = function(queryId) {
        var query = this.queryStore.get(queryId);
        return query && query.networkStatus !== $02a3c2aebc919401$export$bd096ddbd246c79c.ready && query.networkStatus !== $02a3c2aebc919401$export$bd096ddbd246c79c.error;
    };
    QueryManager.prototype.startPollingQuery = function(options, queryId, listener) {
        var _this = this;
        var pollInterval = options.pollInterval;
        (0, $1DiV8.invariant)(pollInterval, 18);
        if (!this.ssrMode) {
            var info = this.pollingInfoByQueryId.get(queryId);
            if (!info) this.pollingInfoByQueryId.set(queryId, info = {});
            info.interval = pollInterval;
            info.options = (0, $3VFsf.__assign)((0, $3VFsf.__assign)({}, options), {
                fetchPolicy: 'network-only'
            });
            var maybeFetch_1 = function() {
                var info = _this.pollingInfoByQueryId.get(queryId);
                if (info) {
                    if (_this.checkInFlight(queryId)) poll_1();
                    else _this.fetchQuery(queryId, info.options, $02a3c2aebc919401$export$160bafb6ac1e0641.poll).then(poll_1, poll_1);
                }
            };
            var poll_1 = function() {
                var info = _this.pollingInfoByQueryId.get(queryId);
                if (info) {
                    clearTimeout(info.timeout);
                    info.timeout = setTimeout(maybeFetch_1, info.interval);
                }
            };
            if (listener) this.addQueryListener(queryId, listener);
            poll_1();
        }
        return queryId;
    };
    QueryManager.prototype.stopPollingQuery = function(queryId) {
        this.pollingInfoByQueryId.delete(queryId);
    };
    return QueryManager;
}();
var $02a3c2aebc919401$var$DataStore = function() {
    function DataStore(initialCache) {
        this.cache = initialCache;
    }
    DataStore.prototype.getCache = function() {
        return this.cache;
    };
    DataStore.prototype.markQueryResult = function(result, document, variables, fetchMoreForQueryId, ignoreErrors) {
        if (ignoreErrors === void 0) ignoreErrors = false;
        var writeWithErrors = !(0, $jojW6.graphQLResultHasError)(result);
        if (ignoreErrors && (0, $jojW6.graphQLResultHasError)(result) && result.data) writeWithErrors = true;
        if (!fetchMoreForQueryId && writeWithErrors) this.cache.write({
            result: result.data,
            dataId: 'ROOT_QUERY',
            query: document,
            variables: variables
        });
    };
    DataStore.prototype.markSubscriptionResult = function(result, document, variables) {
        if (!(0, $jojW6.graphQLResultHasError)(result)) this.cache.write({
            result: result.data,
            dataId: 'ROOT_SUBSCRIPTION',
            query: document,
            variables: variables
        });
    };
    DataStore.prototype.markMutationInit = function(mutation) {
        var _this = this;
        if (mutation.optimisticResponse) {
            var optimistic_1;
            if (typeof mutation.optimisticResponse === 'function') optimistic_1 = mutation.optimisticResponse(mutation.variables);
            else optimistic_1 = mutation.optimisticResponse;
            this.cache.recordOptimisticTransaction(function(c) {
                var orig = _this.cache;
                _this.cache = c;
                try {
                    _this.markMutationResult({
                        mutationId: mutation.mutationId,
                        result: {
                            data: optimistic_1
                        },
                        document: mutation.document,
                        variables: mutation.variables,
                        updateQueries: mutation.updateQueries,
                        update: mutation.update
                    });
                } finally{
                    _this.cache = orig;
                }
            }, mutation.mutationId);
        }
    };
    DataStore.prototype.markMutationResult = function(mutation) {
        var _this = this;
        if (!(0, $jojW6.graphQLResultHasError)(mutation.result)) {
            var cacheWrites_1 = [
                {
                    result: mutation.result.data,
                    dataId: 'ROOT_MUTATION',
                    query: mutation.document,
                    variables: mutation.variables
                }
            ];
            var updateQueries_1 = mutation.updateQueries;
            if (updateQueries_1) Object.keys(updateQueries_1).forEach(function(id) {
                var _a = updateQueries_1[id], query = _a.query, updater = _a.updater;
                var _b = _this.cache.diff({
                    query: query.document,
                    variables: query.variables,
                    returnPartialData: true,
                    optimistic: false
                }), currentQueryResult = _b.result, complete = _b.complete;
                if (complete) {
                    var nextQueryResult = (0, $jojW6.tryFunctionOrLogError)(function() {
                        return updater(currentQueryResult, {
                            mutationResult: mutation.result,
                            queryName: (0, $jojW6.getOperationName)(query.document) || undefined,
                            queryVariables: query.variables
                        });
                    });
                    if (nextQueryResult) cacheWrites_1.push({
                        result: nextQueryResult,
                        dataId: 'ROOT_QUERY',
                        query: query.document,
                        variables: query.variables
                    });
                }
            });
            this.cache.performTransaction(function(c) {
                cacheWrites_1.forEach(function(write) {
                    return c.write(write);
                });
                var update = mutation.update;
                if (update) (0, $jojW6.tryFunctionOrLogError)(function() {
                    return update(c, mutation.result);
                });
            });
        }
    };
    DataStore.prototype.markMutationComplete = function(_a) {
        var mutationId = _a.mutationId, optimisticResponse = _a.optimisticResponse;
        if (optimisticResponse) this.cache.removeOptimistic(mutationId);
    };
    DataStore.prototype.markUpdateQueryResult = function(document, variables, newResult) {
        this.cache.write({
            result: newResult,
            dataId: 'ROOT_QUERY',
            variables: variables,
            query: document
        });
    };
    DataStore.prototype.reset = function() {
        return this.cache.reset();
    };
    return DataStore;
}();
var $02a3c2aebc919401$var$version = "2.6.10";
var $02a3c2aebc919401$var$hasSuggestedDevtools = false;
var $02a3c2aebc919401$export$13f5a5f0f1dbab88 = function() {
    function ApolloClient(options) {
        var _this = this;
        this.defaultOptions = {};
        this.resetStoreCallbacks = [];
        this.clearStoreCallbacks = [];
        var cache = options.cache, _a = options.ssrMode, ssrMode = _a === void 0 ? false : _a, _b = options.ssrForceFetchDelay, ssrForceFetchDelay = _b === void 0 ? 0 : _b, connectToDevTools = options.connectToDevTools, _c = options.queryDeduplication, queryDeduplication = _c === void 0 ? true : _c, defaultOptions = options.defaultOptions, _d = options.assumeImmutableResults, assumeImmutableResults = _d === void 0 ? false : _d, resolvers = options.resolvers, typeDefs = options.typeDefs, fragmentMatcher = options.fragmentMatcher, clientAwarenessName = options.name, clientAwarenessVersion = options.version;
        var link = options.link;
        if (!link && resolvers) link = (0, $clSzL.ApolloLink).empty();
        if (!link || !cache) throw new (0, $1DiV8.InvariantError)(4);
        this.link = link;
        this.cache = cache;
        this.store = new $02a3c2aebc919401$var$DataStore(cache);
        this.disableNetworkFetches = ssrMode || ssrForceFetchDelay > 0;
        this.queryDeduplication = queryDeduplication;
        this.defaultOptions = defaultOptions || {};
        this.typeDefs = typeDefs;
        if (ssrForceFetchDelay) setTimeout(function() {
            return _this.disableNetworkFetches = false;
        }, ssrForceFetchDelay);
        this.watchQuery = this.watchQuery.bind(this);
        this.query = this.query.bind(this);
        this.mutate = this.mutate.bind(this);
        this.resetStore = this.resetStore.bind(this);
        this.reFetchObservableQueries = this.reFetchObservableQueries.bind(this);
        var defaultConnectToDevTools = false;
        if (typeof connectToDevTools === 'undefined' ? defaultConnectToDevTools : connectToDevTools && typeof window !== 'undefined') window.__APOLLO_CLIENT__ = this;
        this.version = $02a3c2aebc919401$var$version;
        this.localState = new $02a3c2aebc919401$var$LocalState({
            cache: cache,
            client: this,
            resolvers: resolvers,
            fragmentMatcher: fragmentMatcher
        });
        this.queryManager = new $02a3c2aebc919401$var$QueryManager({
            link: this.link,
            store: this.store,
            queryDeduplication: queryDeduplication,
            ssrMode: ssrMode,
            clientAwareness: {
                name: clientAwarenessName,
                version: clientAwarenessVersion
            },
            localState: this.localState,
            assumeImmutableResults: assumeImmutableResults,
            onBroadcast: function() {
                if (_this.devToolsHookCb) _this.devToolsHookCb({
                    action: {},
                    state: {
                        queries: _this.queryManager.queryStore.getStore(),
                        mutations: _this.queryManager.mutationStore.getStore()
                    },
                    dataWithOptimisticResults: _this.cache.extract(true)
                });
            }
        });
    }
    ApolloClient.prototype.stop = function() {
        this.queryManager.stop();
    };
    ApolloClient.prototype.watchQuery = function(options) {
        if (this.defaultOptions.watchQuery) options = (0, $3VFsf.__assign)((0, $3VFsf.__assign)({}, this.defaultOptions.watchQuery), options);
        if (this.disableNetworkFetches && (options.fetchPolicy === 'network-only' || options.fetchPolicy === 'cache-and-network')) options = (0, $3VFsf.__assign)((0, $3VFsf.__assign)({}, options), {
            fetchPolicy: 'cache-first'
        });
        return this.queryManager.watchQuery(options);
    };
    ApolloClient.prototype.query = function(options) {
        if (this.defaultOptions.query) options = (0, $3VFsf.__assign)((0, $3VFsf.__assign)({}, this.defaultOptions.query), options);
        (0, $1DiV8.invariant)(options.fetchPolicy !== 'cache-and-network', 5);
        if (this.disableNetworkFetches && options.fetchPolicy === 'network-only') options = (0, $3VFsf.__assign)((0, $3VFsf.__assign)({}, options), {
            fetchPolicy: 'cache-first'
        });
        return this.queryManager.query(options);
    };
    ApolloClient.prototype.mutate = function(options) {
        if (this.defaultOptions.mutate) options = (0, $3VFsf.__assign)((0, $3VFsf.__assign)({}, this.defaultOptions.mutate), options);
        return this.queryManager.mutate(options);
    };
    ApolloClient.prototype.subscribe = function(options) {
        return this.queryManager.startGraphQLSubscription(options);
    };
    ApolloClient.prototype.readQuery = function(options, optimistic) {
        if (optimistic === void 0) optimistic = false;
        return this.cache.readQuery(options, optimistic);
    };
    ApolloClient.prototype.readFragment = function(options, optimistic) {
        if (optimistic === void 0) optimistic = false;
        return this.cache.readFragment(options, optimistic);
    };
    ApolloClient.prototype.writeQuery = function(options) {
        var result = this.cache.writeQuery(options);
        this.queryManager.broadcastQueries();
        return result;
    };
    ApolloClient.prototype.writeFragment = function(options) {
        var result = this.cache.writeFragment(options);
        this.queryManager.broadcastQueries();
        return result;
    };
    ApolloClient.prototype.writeData = function(options) {
        var result = this.cache.writeData(options);
        this.queryManager.broadcastQueries();
        return result;
    };
    ApolloClient.prototype.__actionHookForDevTools = function(cb) {
        this.devToolsHookCb = cb;
    };
    ApolloClient.prototype.__requestRaw = function(payload) {
        return (0, $clSzL.execute)(this.link, payload);
    };
    ApolloClient.prototype.initQueryManager = function() {
        return this.queryManager;
    };
    ApolloClient.prototype.resetStore = function() {
        var _this = this;
        return Promise.resolve().then(function() {
            return _this.queryManager.clearStore();
        }).then(function() {
            return Promise.all(_this.resetStoreCallbacks.map(function(fn) {
                return fn();
            }));
        }).then(function() {
            return _this.reFetchObservableQueries();
        });
    };
    ApolloClient.prototype.clearStore = function() {
        var _this = this;
        return Promise.resolve().then(function() {
            return _this.queryManager.clearStore();
        }).then(function() {
            return Promise.all(_this.clearStoreCallbacks.map(function(fn) {
                return fn();
            }));
        });
    };
    ApolloClient.prototype.onResetStore = function(cb) {
        var _this = this;
        this.resetStoreCallbacks.push(cb);
        return function() {
            _this.resetStoreCallbacks = _this.resetStoreCallbacks.filter(function(c) {
                return c !== cb;
            });
        };
    };
    ApolloClient.prototype.onClearStore = function(cb) {
        var _this = this;
        this.clearStoreCallbacks.push(cb);
        return function() {
            _this.clearStoreCallbacks = _this.clearStoreCallbacks.filter(function(c) {
                return c !== cb;
            });
        };
    };
    ApolloClient.prototype.reFetchObservableQueries = function(includeStandby) {
        return this.queryManager.reFetchObservableQueries(includeStandby);
    };
    ApolloClient.prototype.extract = function(optimistic) {
        return this.cache.extract(optimistic);
    };
    ApolloClient.prototype.restore = function(serializedState) {
        return this.cache.restore(serializedState);
    };
    ApolloClient.prototype.addResolvers = function(resolvers) {
        this.localState.addResolvers(resolvers);
    };
    ApolloClient.prototype.setResolvers = function(resolvers) {
        this.localState.setResolvers(resolvers);
    };
    ApolloClient.prototype.getResolvers = function() {
        return this.localState.getResolvers();
    };
    ApolloClient.prototype.setLocalStateFragmentMatcher = function(fragmentMatcher) {
        this.localState.setFragmentMatcher(fragmentMatcher);
    };
    return ApolloClient;
}();
var $02a3c2aebc919401$export$2e2bcd8739ae039 = $02a3c2aebc919401$export$13f5a5f0f1dbab88;

});
parcelRegister("jojW6", function(module, exports) {

$parcel$export(module.exports, "storeKeyNameFromField", () => $e1dfb923a27ca793$export$54be8689c65f3b56);
$parcel$export(module.exports, "getStoreKeyName", () => $e1dfb923a27ca793$export$3cdb6c178b88cabe);
$parcel$export(module.exports, "argumentsObjectFromField", () => $e1dfb923a27ca793$export$3f5a60fb6a781b4f);
$parcel$export(module.exports, "resultKeyNameFromField", () => $e1dfb923a27ca793$export$7d1ad22471852218);
$parcel$export(module.exports, "isField", () => $e1dfb923a27ca793$export$fb56ad75dd311c12);
$parcel$export(module.exports, "isInlineFragment", () => $e1dfb923a27ca793$export$22a1cdafaf27bcff);
$parcel$export(module.exports, "isIdValue", () => $e1dfb923a27ca793$export$e33b89a9aa87695);
$parcel$export(module.exports, "toIdValue", () => $e1dfb923a27ca793$export$b124f125e34d720a);
$parcel$export(module.exports, "isJsonValue", () => $e1dfb923a27ca793$export$226c1c6d1a5b660a);
$parcel$export(module.exports, "getDirectiveInfoFromField", () => $e1dfb923a27ca793$export$2a7f471142984a91);
$parcel$export(module.exports, "shouldInclude", () => $e1dfb923a27ca793$export$3dc388a5f013b4a5);
$parcel$export(module.exports, "hasDirectives", () => $e1dfb923a27ca793$export$2dafb573e282fe8d);
$parcel$export(module.exports, "hasClientExports", () => $e1dfb923a27ca793$export$8d1e9e5bbfa5d09a);
$parcel$export(module.exports, "getFragmentQueryDocument", () => $e1dfb923a27ca793$export$abbf37c7cf644e41);
$parcel$export(module.exports, "assign", () => $e1dfb923a27ca793$export$e6e34fd1f2686227);
$parcel$export(module.exports, "checkDocument", () => $e1dfb923a27ca793$export$a7d0d8111d2386df);
$parcel$export(module.exports, "getOperationDefinition", () => $e1dfb923a27ca793$export$7a5b1fa979d2c158);
$parcel$export(module.exports, "getOperationName", () => $e1dfb923a27ca793$export$41bca9dc6871dd4e);
$parcel$export(module.exports, "getFragmentDefinitions", () => $e1dfb923a27ca793$export$5320a7ba9466a3df);
$parcel$export(module.exports, "getQueryDefinition", () => $e1dfb923a27ca793$export$d96b2213c1b9d3a9);
$parcel$export(module.exports, "getMainDefinition", () => $e1dfb923a27ca793$export$f431198736b7f96d);
$parcel$export(module.exports, "createFragmentMap", () => $e1dfb923a27ca793$export$193789b4c8246dd4);
$parcel$export(module.exports, "getDefaultValues", () => $e1dfb923a27ca793$export$84c19026e616569e);
$parcel$export(module.exports, "removeDirectivesFromDocument", () => $e1dfb923a27ca793$export$e5ae0530da5fe96c);
$parcel$export(module.exports, "addTypenameToDocument", () => $e1dfb923a27ca793$export$43b332f87950a467);
$parcel$export(module.exports, "removeConnectionDirectiveFromDocument", () => $e1dfb923a27ca793$export$74985f3324559867);
$parcel$export(module.exports, "buildQueryFromSelectionSet", () => $e1dfb923a27ca793$export$57c368c23873f32b);
$parcel$export(module.exports, "removeClientSetsFromDocument", () => $e1dfb923a27ca793$export$8eae69e876ee321e);
$parcel$export(module.exports, "canUseWeakMap", () => $e1dfb923a27ca793$export$772fbc04a0ad4ce9);
$parcel$export(module.exports, "cloneDeep", () => $e1dfb923a27ca793$export$629a2bd3f5a49ecc);
$parcel$export(module.exports, "isProduction", () => $e1dfb923a27ca793$export$f15d00aa73aafac4);
$parcel$export(module.exports, "isTest", () => $e1dfb923a27ca793$export$410cbc2864fa25b5);
$parcel$export(module.exports, "tryFunctionOrLogError", () => $e1dfb923a27ca793$export$50a91acae4904909);
$parcel$export(module.exports, "graphQLResultHasError", () => $e1dfb923a27ca793$export$b4df399e879e53ab);
$parcel$export(module.exports, "mergeDeep", () => $e1dfb923a27ca793$export$dd702b3c8240390c);
$parcel$export(module.exports, "mergeDeepArray", () => $e1dfb923a27ca793$export$160070228be94b08);

var $12QNw = parcelRequire("12QNw");

var $1DiV8 = parcelRequire("1DiV8");

var $3VFsf = parcelRequire("3VFsf");

var $fkrBp = parcelRequire("fkrBp");

var $bqMzA = parcelRequire("bqMzA");

var $6cAn5 = parcelRequire("6cAn5");
function $e1dfb923a27ca793$export$dc071f102752d0eb(value) {
    return [
        'StringValue',
        'BooleanValue',
        'EnumValue'
    ].indexOf(value.kind) > -1;
}
function $e1dfb923a27ca793$export$3ff5e9927c3257c6(value) {
    return [
        'IntValue',
        'FloatValue'
    ].indexOf(value.kind) > -1;
}
function $e1dfb923a27ca793$var$isStringValue(value) {
    return value.kind === 'StringValue';
}
function $e1dfb923a27ca793$var$isBooleanValue(value) {
    return value.kind === 'BooleanValue';
}
function $e1dfb923a27ca793$var$isIntValue(value) {
    return value.kind === 'IntValue';
}
function $e1dfb923a27ca793$var$isFloatValue(value) {
    return value.kind === 'FloatValue';
}
function $e1dfb923a27ca793$var$isVariable(value) {
    return value.kind === 'Variable';
}
function $e1dfb923a27ca793$var$isObjectValue(value) {
    return value.kind === 'ObjectValue';
}
function $e1dfb923a27ca793$var$isListValue(value) {
    return value.kind === 'ListValue';
}
function $e1dfb923a27ca793$var$isEnumValue(value) {
    return value.kind === 'EnumValue';
}
function $e1dfb923a27ca793$var$isNullValue(value) {
    return value.kind === 'NullValue';
}
function $e1dfb923a27ca793$export$a1dab82d368d6525(argObj, name, value, variables) {
    if ($e1dfb923a27ca793$var$isIntValue(value) || $e1dfb923a27ca793$var$isFloatValue(value)) argObj[name.value] = Number(value.value);
    else if ($e1dfb923a27ca793$var$isBooleanValue(value) || $e1dfb923a27ca793$var$isStringValue(value)) argObj[name.value] = value.value;
    else if ($e1dfb923a27ca793$var$isObjectValue(value)) {
        var nestedArgObj_1 = {};
        value.fields.map(function(obj) {
            return $e1dfb923a27ca793$export$a1dab82d368d6525(nestedArgObj_1, obj.name, obj.value, variables);
        });
        argObj[name.value] = nestedArgObj_1;
    } else if ($e1dfb923a27ca793$var$isVariable(value)) {
        var variableValue = (variables || {})[value.name.value];
        argObj[name.value] = variableValue;
    } else if ($e1dfb923a27ca793$var$isListValue(value)) argObj[name.value] = value.values.map(function(listValue) {
        var nestedArgArrayObj = {};
        $e1dfb923a27ca793$export$a1dab82d368d6525(nestedArgArrayObj, name, listValue, variables);
        return nestedArgArrayObj[name.value];
    });
    else if ($e1dfb923a27ca793$var$isEnumValue(value)) argObj[name.value] = value.value;
    else if ($e1dfb923a27ca793$var$isNullValue(value)) argObj[name.value] = null;
    else throw new (0, $1DiV8.InvariantError)(17);
}
function $e1dfb923a27ca793$export$54be8689c65f3b56(field, variables) {
    var directivesObj = null;
    if (field.directives) {
        directivesObj = {};
        field.directives.forEach(function(directive) {
            directivesObj[directive.name.value] = {};
            if (directive.arguments) directive.arguments.forEach(function(_a) {
                var name = _a.name, value = _a.value;
                return $e1dfb923a27ca793$export$a1dab82d368d6525(directivesObj[directive.name.value], name, value, variables);
            });
        });
    }
    var argObj = null;
    if (field.arguments && field.arguments.length) {
        argObj = {};
        field.arguments.forEach(function(_a) {
            var name = _a.name, value = _a.value;
            return $e1dfb923a27ca793$export$a1dab82d368d6525(argObj, name, value, variables);
        });
    }
    return $e1dfb923a27ca793$export$3cdb6c178b88cabe(field.name.value, argObj, directivesObj);
}
var $e1dfb923a27ca793$var$KNOWN_DIRECTIVES = [
    'connection',
    'include',
    'skip',
    'client',
    'rest',
    'export'
];
function $e1dfb923a27ca793$export$3cdb6c178b88cabe(fieldName, args, directives) {
    if (directives && directives['connection'] && directives['connection']['key']) {
        if (directives['connection']['filter'] && directives['connection']['filter'].length > 0) {
            var filterKeys = directives['connection']['filter'] ? directives['connection']['filter'] : [];
            filterKeys.sort();
            var queryArgs_1 = args;
            var filteredArgs_1 = {};
            filterKeys.forEach(function(key) {
                filteredArgs_1[key] = queryArgs_1[key];
            });
            return directives['connection']['key'] + "(" + JSON.stringify(filteredArgs_1) + ")";
        } else return directives['connection']['key'];
    }
    var completeFieldName = fieldName;
    if (args) {
        var stringifiedArgs = (0, (/*@__PURE__*/$parcel$interopDefault($fkrBp)))(args);
        completeFieldName += "(" + stringifiedArgs + ")";
    }
    if (directives) Object.keys(directives).forEach(function(key) {
        if ($e1dfb923a27ca793$var$KNOWN_DIRECTIVES.indexOf(key) !== -1) return;
        if (directives[key] && Object.keys(directives[key]).length) completeFieldName += "@" + key + "(" + JSON.stringify(directives[key]) + ")";
        else completeFieldName += "@" + key;
    });
    return completeFieldName;
}
function $e1dfb923a27ca793$export$3f5a60fb6a781b4f(field, variables) {
    if (field.arguments && field.arguments.length) {
        var argObj_1 = {};
        field.arguments.forEach(function(_a) {
            var name = _a.name, value = _a.value;
            return $e1dfb923a27ca793$export$a1dab82d368d6525(argObj_1, name, value, variables);
        });
        return argObj_1;
    }
    return null;
}
function $e1dfb923a27ca793$export$7d1ad22471852218(field) {
    return field.alias ? field.alias.value : field.name.value;
}
function $e1dfb923a27ca793$export$fb56ad75dd311c12(selection) {
    return selection.kind === 'Field';
}
function $e1dfb923a27ca793$export$22a1cdafaf27bcff(selection) {
    return selection.kind === 'InlineFragment';
}
function $e1dfb923a27ca793$export$e33b89a9aa87695(idObject) {
    return idObject && idObject.type === 'id' && typeof idObject.generated === 'boolean';
}
function $e1dfb923a27ca793$export$b124f125e34d720a(idConfig, generated) {
    if (generated === void 0) generated = false;
    return (0, $3VFsf.__assign)({
        type: 'id',
        generated: generated
    }, typeof idConfig === 'string' ? {
        id: idConfig,
        typename: undefined
    } : idConfig);
}
function $e1dfb923a27ca793$export$226c1c6d1a5b660a(jsonObject) {
    return jsonObject != null && typeof jsonObject === 'object' && jsonObject.type === 'json';
}
function $e1dfb923a27ca793$var$defaultValueFromVariable(node) {
    throw new (0, $1DiV8.InvariantError)(18);
}
function $e1dfb923a27ca793$export$b3db129ed867b445(node, onVariable) {
    if (onVariable === void 0) onVariable = $e1dfb923a27ca793$var$defaultValueFromVariable;
    switch(node.kind){
        case 'Variable':
            return onVariable(node);
        case 'NullValue':
            return null;
        case 'IntValue':
            return parseInt(node.value, 10);
        case 'FloatValue':
            return parseFloat(node.value);
        case 'ListValue':
            return node.values.map(function(v) {
                return $e1dfb923a27ca793$export$b3db129ed867b445(v, onVariable);
            });
        case 'ObjectValue':
            var value = {};
            for(var _i = 0, _a = node.fields; _i < _a.length; _i++){
                var field = _a[_i];
                value[field.name.value] = $e1dfb923a27ca793$export$b3db129ed867b445(field.value, onVariable);
            }
            return value;
        default:
            return node.value;
    }
}
function $e1dfb923a27ca793$export$2a7f471142984a91(field, variables) {
    if (field.directives && field.directives.length) {
        var directiveObj_1 = {};
        field.directives.forEach(function(directive) {
            directiveObj_1[directive.name.value] = $e1dfb923a27ca793$export$3f5a60fb6a781b4f(directive, variables);
        });
        return directiveObj_1;
    }
    return null;
}
function $e1dfb923a27ca793$export$3dc388a5f013b4a5(selection, variables) {
    if (variables === void 0) variables = {};
    return $e1dfb923a27ca793$export$b7bdffb7e6f1ef53(selection.directives).every(function(_a) {
        var directive = _a.directive, ifArgument = _a.ifArgument;
        var evaledValue = false;
        if (ifArgument.value.kind === 'Variable') {
            evaledValue = variables[ifArgument.value.name.value];
            (0, $1DiV8.invariant)(evaledValue !== void 0, 13);
        } else evaledValue = ifArgument.value.value;
        return directive.name.value === 'skip' ? !evaledValue : evaledValue;
    });
}
function $e1dfb923a27ca793$export$1b217de6ce18b9a(doc) {
    var names = [];
    (0, $12QNw.visit)(doc, {
        Directive: function(node) {
            names.push(node.name.value);
        }
    });
    return names;
}
function $e1dfb923a27ca793$export$2dafb573e282fe8d(names, doc) {
    return $e1dfb923a27ca793$export$1b217de6ce18b9a(doc).some(function(name) {
        return names.indexOf(name) > -1;
    });
}
function $e1dfb923a27ca793$export$8d1e9e5bbfa5d09a(document) {
    return document && $e1dfb923a27ca793$export$2dafb573e282fe8d([
        'client'
    ], document) && $e1dfb923a27ca793$export$2dafb573e282fe8d([
        'export'
    ], document);
}
function $e1dfb923a27ca793$var$isInclusionDirective(_a) {
    var value = _a.name.value;
    return value === 'skip' || value === 'include';
}
function $e1dfb923a27ca793$export$b7bdffb7e6f1ef53(directives) {
    return directives ? directives.filter($e1dfb923a27ca793$var$isInclusionDirective).map(function(directive) {
        var directiveArguments = directive.arguments;
        var directiveName = directive.name.value;
        (0, $1DiV8.invariant)(directiveArguments && directiveArguments.length === 1, 14);
        var ifArgument = directiveArguments[0];
        (0, $1DiV8.invariant)(ifArgument.name && ifArgument.name.value === 'if', 15);
        var ifValue = ifArgument.value;
        (0, $1DiV8.invariant)(ifValue && (ifValue.kind === 'Variable' || ifValue.kind === 'BooleanValue'), 16);
        return {
            directive: directive,
            ifArgument: ifArgument
        };
    }) : [];
}
function $e1dfb923a27ca793$export$abbf37c7cf644e41(document, fragmentName) {
    var actualFragmentName = fragmentName;
    var fragments = [];
    document.definitions.forEach(function(definition) {
        if (definition.kind === 'OperationDefinition') throw new (0, $1DiV8.InvariantError)(11);
        if (definition.kind === 'FragmentDefinition') fragments.push(definition);
    });
    if (typeof actualFragmentName === 'undefined') {
        (0, $1DiV8.invariant)(fragments.length === 1, 12);
        actualFragmentName = fragments[0].name.value;
    }
    var query = (0, $3VFsf.__assign)((0, $3VFsf.__assign)({}, document), {
        definitions: (0, $3VFsf.__spreadArrays)([
            {
                kind: 'OperationDefinition',
                operation: 'query',
                selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                        {
                            kind: 'FragmentSpread',
                            name: {
                                kind: 'Name',
                                value: actualFragmentName
                            }
                        }
                    ]
                }
            }
        ], document.definitions)
    });
    return query;
}
function $e1dfb923a27ca793$export$e6e34fd1f2686227(target) {
    var sources = [];
    for(var _i = 1; _i < arguments.length; _i++)sources[_i - 1] = arguments[_i];
    sources.forEach(function(source) {
        if (typeof source === 'undefined' || source === null) return;
        Object.keys(source).forEach(function(key) {
            target[key] = source[key];
        });
    });
    return target;
}
function $e1dfb923a27ca793$export$a92e7a440b22bdf0(doc) {
    $e1dfb923a27ca793$export$a7d0d8111d2386df(doc);
    var mutationDef = doc.definitions.filter(function(definition) {
        return definition.kind === 'OperationDefinition' && definition.operation === 'mutation';
    })[0];
    (0, $1DiV8.invariant)(mutationDef, 1);
    return mutationDef;
}
function $e1dfb923a27ca793$export$a7d0d8111d2386df(doc) {
    (0, $1DiV8.invariant)(doc && doc.kind === 'Document', 2);
    var operations = doc.definitions.filter(function(d) {
        return d.kind !== 'FragmentDefinition';
    }).map(function(definition) {
        if (definition.kind !== 'OperationDefinition') throw new (0, $1DiV8.InvariantError)(3);
        return definition;
    });
    (0, $1DiV8.invariant)(operations.length <= 1, 4);
    return doc;
}
function $e1dfb923a27ca793$export$7a5b1fa979d2c158(doc) {
    $e1dfb923a27ca793$export$a7d0d8111d2386df(doc);
    return doc.definitions.filter(function(definition) {
        return definition.kind === 'OperationDefinition';
    })[0];
}
function $e1dfb923a27ca793$export$78a8e95d8d43ad7f(document) {
    var def = $e1dfb923a27ca793$export$7a5b1fa979d2c158(document);
    (0, $1DiV8.invariant)(def, 5);
    return def;
}
function $e1dfb923a27ca793$export$41bca9dc6871dd4e(doc) {
    return doc.definitions.filter(function(definition) {
        return definition.kind === 'OperationDefinition' && definition.name;
    }).map(function(x) {
        return x.name.value;
    })[0] || null;
}
function $e1dfb923a27ca793$export$5320a7ba9466a3df(doc) {
    return doc.definitions.filter(function(definition) {
        return definition.kind === 'FragmentDefinition';
    });
}
function $e1dfb923a27ca793$export$d96b2213c1b9d3a9(doc) {
    var queryDef = $e1dfb923a27ca793$export$7a5b1fa979d2c158(doc);
    (0, $1DiV8.invariant)(queryDef && queryDef.operation === 'query', 6);
    return queryDef;
}
function $e1dfb923a27ca793$export$772111caef41b3f5(doc) {
    (0, $1DiV8.invariant)(doc.kind === 'Document', 7);
    (0, $1DiV8.invariant)(doc.definitions.length <= 1, 8);
    var fragmentDef = doc.definitions[0];
    (0, $1DiV8.invariant)(fragmentDef.kind === 'FragmentDefinition', 9);
    return fragmentDef;
}
function $e1dfb923a27ca793$export$f431198736b7f96d(queryDoc) {
    $e1dfb923a27ca793$export$a7d0d8111d2386df(queryDoc);
    var fragmentDefinition;
    for(var _i = 0, _a = queryDoc.definitions; _i < _a.length; _i++){
        var definition = _a[_i];
        if (definition.kind === 'OperationDefinition') {
            var operation = definition.operation;
            if (operation === 'query' || operation === 'mutation' || operation === 'subscription') return definition;
        }
        if (definition.kind === 'FragmentDefinition' && !fragmentDefinition) fragmentDefinition = definition;
    }
    if (fragmentDefinition) return fragmentDefinition;
    throw new (0, $1DiV8.InvariantError)(10);
}
function $e1dfb923a27ca793$export$193789b4c8246dd4(fragments) {
    if (fragments === void 0) fragments = [];
    var symTable = {};
    fragments.forEach(function(fragment) {
        symTable[fragment.name.value] = fragment;
    });
    return symTable;
}
function $e1dfb923a27ca793$export$84c19026e616569e(definition) {
    if (definition && definition.variableDefinitions && definition.variableDefinitions.length) {
        var defaultValues = definition.variableDefinitions.filter(function(_a) {
            var defaultValue = _a.defaultValue;
            return defaultValue;
        }).map(function(_a) {
            var variable = _a.variable, defaultValue = _a.defaultValue;
            var defaultValueObj = {};
            $e1dfb923a27ca793$export$a1dab82d368d6525(defaultValueObj, variable.name, defaultValue);
            return defaultValueObj;
        });
        return $e1dfb923a27ca793$export$e6e34fd1f2686227.apply(void 0, (0, $3VFsf.__spreadArrays)([
            {}
        ], defaultValues));
    }
    return {};
}
function $e1dfb923a27ca793$export$55ead6c9e4eac970(operation) {
    var names = new Set();
    if (operation.variableDefinitions) for(var _i = 0, _a = operation.variableDefinitions; _i < _a.length; _i++){
        var definition = _a[_i];
        names.add(definition.variable.name.value);
    }
    return names;
}
function $e1dfb923a27ca793$var$filterInPlace(array, test, context) {
    var target = 0;
    array.forEach(function(elem, i) {
        if (test.call(this, elem, i, array)) array[target++] = elem;
    }, context);
    array.length = target;
    return array;
}
var $e1dfb923a27ca793$var$TYPENAME_FIELD = {
    kind: 'Field',
    name: {
        kind: 'Name',
        value: '__typename'
    }
};
function $e1dfb923a27ca793$var$isEmpty(op, fragments) {
    return op.selectionSet.selections.every(function(selection) {
        return selection.kind === 'FragmentSpread' && $e1dfb923a27ca793$var$isEmpty(fragments[selection.name.value], fragments);
    });
}
function $e1dfb923a27ca793$var$nullIfDocIsEmpty(doc) {
    return $e1dfb923a27ca793$var$isEmpty($e1dfb923a27ca793$export$7a5b1fa979d2c158(doc) || $e1dfb923a27ca793$export$772111caef41b3f5(doc), $e1dfb923a27ca793$export$193789b4c8246dd4($e1dfb923a27ca793$export$5320a7ba9466a3df(doc))) ? null : doc;
}
function $e1dfb923a27ca793$var$getDirectiveMatcher(directives) {
    return function directiveMatcher(directive) {
        return directives.some(function(dir) {
            return dir.name && dir.name === directive.name.value || dir.test && dir.test(directive);
        });
    };
}
function $e1dfb923a27ca793$export$e5ae0530da5fe96c(directives, doc) {
    var variablesInUse = Object.create(null);
    var variablesToRemove = [];
    var fragmentSpreadsInUse = Object.create(null);
    var fragmentSpreadsToRemove = [];
    var modifiedDoc = $e1dfb923a27ca793$var$nullIfDocIsEmpty((0, $12QNw.visit)(doc, {
        Variable: {
            enter: function(node, _key, parent) {
                if (parent.kind !== 'VariableDefinition') variablesInUse[node.name.value] = true;
            }
        },
        Field: {
            enter: function(node) {
                if (directives && node.directives) {
                    var shouldRemoveField = directives.some(function(directive) {
                        return directive.remove;
                    });
                    if (shouldRemoveField && node.directives && node.directives.some($e1dfb923a27ca793$var$getDirectiveMatcher(directives))) {
                        if (node.arguments) node.arguments.forEach(function(arg) {
                            if (arg.value.kind === 'Variable') variablesToRemove.push({
                                name: arg.value.name.value
                            });
                        });
                        if (node.selectionSet) $e1dfb923a27ca793$var$getAllFragmentSpreadsFromSelectionSet(node.selectionSet).forEach(function(frag) {
                            fragmentSpreadsToRemove.push({
                                name: frag.name.value
                            });
                        });
                        return null;
                    }
                }
            }
        },
        FragmentSpread: {
            enter: function(node) {
                fragmentSpreadsInUse[node.name.value] = true;
            }
        },
        Directive: {
            enter: function(node) {
                if ($e1dfb923a27ca793$var$getDirectiveMatcher(directives)(node)) return null;
            }
        }
    }));
    if (modifiedDoc && $e1dfb923a27ca793$var$filterInPlace(variablesToRemove, function(v) {
        return !variablesInUse[v.name];
    }).length) modifiedDoc = $e1dfb923a27ca793$export$ecd5bb739c4a8b38(variablesToRemove, modifiedDoc);
    if (modifiedDoc && $e1dfb923a27ca793$var$filterInPlace(fragmentSpreadsToRemove, function(fs) {
        return !fragmentSpreadsInUse[fs.name];
    }).length) modifiedDoc = $e1dfb923a27ca793$export$7c9d17c333033c13(fragmentSpreadsToRemove, modifiedDoc);
    return modifiedDoc;
}
function $e1dfb923a27ca793$export$43b332f87950a467(doc) {
    return (0, $12QNw.visit)($e1dfb923a27ca793$export$a7d0d8111d2386df(doc), {
        SelectionSet: {
            enter: function(node, _key, parent) {
                if (parent && parent.kind === 'OperationDefinition') return;
                var selections = node.selections;
                if (!selections) return;
                var skip = selections.some(function(selection) {
                    return $e1dfb923a27ca793$export$fb56ad75dd311c12(selection) && (selection.name.value === '__typename' || selection.name.value.lastIndexOf('__', 0) === 0);
                });
                if (skip) return;
                var field = parent;
                if ($e1dfb923a27ca793$export$fb56ad75dd311c12(field) && field.directives && field.directives.some(function(d) {
                    return d.name.value === 'export';
                })) return;
                return (0, $3VFsf.__assign)((0, $3VFsf.__assign)({}, node), {
                    selections: (0, $3VFsf.__spreadArrays)(selections, [
                        $e1dfb923a27ca793$var$TYPENAME_FIELD
                    ])
                });
            }
        }
    });
}
var $e1dfb923a27ca793$var$connectionRemoveConfig = {
    test: function(directive) {
        var willRemove = directive.name.value === 'connection';
        if (willRemove) !directive.arguments || directive.arguments.some(function(arg) {
            return arg.name.value === 'key';
        });
        return willRemove;
    }
};
function $e1dfb923a27ca793$export$74985f3324559867(doc) {
    return $e1dfb923a27ca793$export$e5ae0530da5fe96c([
        $e1dfb923a27ca793$var$connectionRemoveConfig
    ], $e1dfb923a27ca793$export$a7d0d8111d2386df(doc));
}
function $e1dfb923a27ca793$var$hasDirectivesInSelectionSet(directives, selectionSet, nestedCheck) {
    if (nestedCheck === void 0) nestedCheck = true;
    return selectionSet && selectionSet.selections && selectionSet.selections.some(function(selection) {
        return $e1dfb923a27ca793$var$hasDirectivesInSelection(directives, selection, nestedCheck);
    });
}
function $e1dfb923a27ca793$var$hasDirectivesInSelection(directives, selection, nestedCheck) {
    if (nestedCheck === void 0) nestedCheck = true;
    if (!$e1dfb923a27ca793$export$fb56ad75dd311c12(selection)) return true;
    if (!selection.directives) return false;
    return selection.directives.some($e1dfb923a27ca793$var$getDirectiveMatcher(directives)) || nestedCheck && $e1dfb923a27ca793$var$hasDirectivesInSelectionSet(directives, selection.selectionSet, nestedCheck);
}
function $e1dfb923a27ca793$export$deed3420cb5d2e1d(directives, doc) {
    $e1dfb923a27ca793$export$a7d0d8111d2386df(doc);
    var parentPath;
    return $e1dfb923a27ca793$var$nullIfDocIsEmpty((0, $12QNw.visit)(doc, {
        SelectionSet: {
            enter: function(node, _key, _parent, path) {
                var currentPath = path.join('-');
                if (!parentPath || currentPath === parentPath || !currentPath.startsWith(parentPath)) {
                    if (node.selections) {
                        var selectionsWithDirectives = node.selections.filter(function(selection) {
                            return $e1dfb923a27ca793$var$hasDirectivesInSelection(directives, selection);
                        });
                        if ($e1dfb923a27ca793$var$hasDirectivesInSelectionSet(directives, node, false)) parentPath = currentPath;
                        return (0, $3VFsf.__assign)((0, $3VFsf.__assign)({}, node), {
                            selections: selectionsWithDirectives
                        });
                    } else return null;
                }
            }
        }
    }));
}
function $e1dfb923a27ca793$var$getArgumentMatcher(config) {
    return function argumentMatcher(argument) {
        return config.some(function(aConfig) {
            return argument.value && argument.value.kind === 'Variable' && argument.value.name && (aConfig.name === argument.value.name.value || aConfig.test && aConfig.test(argument));
        });
    };
}
function $e1dfb923a27ca793$export$ecd5bb739c4a8b38(config, doc) {
    var argMatcher = $e1dfb923a27ca793$var$getArgumentMatcher(config);
    return $e1dfb923a27ca793$var$nullIfDocIsEmpty((0, $12QNw.visit)(doc, {
        OperationDefinition: {
            enter: function(node) {
                return (0, $3VFsf.__assign)((0, $3VFsf.__assign)({}, node), {
                    variableDefinitions: node.variableDefinitions.filter(function(varDef) {
                        return !config.some(function(arg) {
                            return arg.name === varDef.variable.name.value;
                        });
                    })
                });
            }
        },
        Field: {
            enter: function(node) {
                var shouldRemoveField = config.some(function(argConfig) {
                    return argConfig.remove;
                });
                if (shouldRemoveField) {
                    var argMatchCount_1 = 0;
                    node.arguments.forEach(function(arg) {
                        if (argMatcher(arg)) argMatchCount_1 += 1;
                    });
                    if (argMatchCount_1 === 1) return null;
                }
            }
        },
        Argument: {
            enter: function(node) {
                if (argMatcher(node)) return null;
            }
        }
    }));
}
function $e1dfb923a27ca793$export$7c9d17c333033c13(config, doc) {
    function enter(node) {
        if (config.some(function(def) {
            return def.name === node.name.value;
        })) return null;
    }
    return $e1dfb923a27ca793$var$nullIfDocIsEmpty((0, $12QNw.visit)(doc, {
        FragmentSpread: {
            enter: enter
        },
        FragmentDefinition: {
            enter: enter
        }
    }));
}
function $e1dfb923a27ca793$var$getAllFragmentSpreadsFromSelectionSet(selectionSet) {
    var allFragments = [];
    selectionSet.selections.forEach(function(selection) {
        if (($e1dfb923a27ca793$export$fb56ad75dd311c12(selection) || $e1dfb923a27ca793$export$22a1cdafaf27bcff(selection)) && selection.selectionSet) $e1dfb923a27ca793$var$getAllFragmentSpreadsFromSelectionSet(selection.selectionSet).forEach(function(frag) {
            return allFragments.push(frag);
        });
        else if (selection.kind === 'FragmentSpread') allFragments.push(selection);
    });
    return allFragments;
}
function $e1dfb923a27ca793$export$57c368c23873f32b(document) {
    var definition = $e1dfb923a27ca793$export$f431198736b7f96d(document);
    var definitionOperation = definition.operation;
    if (definitionOperation === 'query') return document;
    var modifiedDoc = (0, $12QNw.visit)(document, {
        OperationDefinition: {
            enter: function(node) {
                return (0, $3VFsf.__assign)((0, $3VFsf.__assign)({}, node), {
                    operation: 'query'
                });
            }
        }
    });
    return modifiedDoc;
}
function $e1dfb923a27ca793$export$8eae69e876ee321e(document) {
    $e1dfb923a27ca793$export$a7d0d8111d2386df(document);
    var modifiedDoc = $e1dfb923a27ca793$export$e5ae0530da5fe96c([
        {
            test: function(directive) {
                return directive.name.value === 'client';
            },
            remove: true
        }
    ], document);
    if (modifiedDoc) modifiedDoc = (0, $12QNw.visit)(modifiedDoc, {
        FragmentDefinition: {
            enter: function(node) {
                if (node.selectionSet) {
                    var isTypenameOnly = node.selectionSet.selections.every(function(selection) {
                        return $e1dfb923a27ca793$export$fb56ad75dd311c12(selection) && selection.name.value === '__typename';
                    });
                    if (isTypenameOnly) return null;
                }
            }
        }
    });
    return modifiedDoc;
}
var $e1dfb923a27ca793$export$772fbc04a0ad4ce9 = typeof WeakMap === 'function' && !(typeof navigator === 'object' && navigator.product === 'ReactNative');
var $e1dfb923a27ca793$var$toString = Object.prototype.toString;
function $e1dfb923a27ca793$export$629a2bd3f5a49ecc(value) {
    return $e1dfb923a27ca793$var$cloneDeepHelper(value, new Map());
}
function $e1dfb923a27ca793$var$cloneDeepHelper(val, seen) {
    switch($e1dfb923a27ca793$var$toString.call(val)){
        case "[object Array]":
            if (seen.has(val)) return seen.get(val);
            var copy_1 = val.slice(0);
            seen.set(val, copy_1);
            copy_1.forEach(function(child, i) {
                copy_1[i] = $e1dfb923a27ca793$var$cloneDeepHelper(child, seen);
            });
            return copy_1;
        case "[object Object]":
            if (seen.has(val)) return seen.get(val);
            var copy_2 = Object.create(Object.getPrototypeOf(val));
            seen.set(val, copy_2);
            Object.keys(val).forEach(function(key) {
                copy_2[key] = $e1dfb923a27ca793$var$cloneDeepHelper(val[key], seen);
            });
            return copy_2;
        default:
            return val;
    }
}
function $e1dfb923a27ca793$export$4bd44a2aa29d3d6e() {
    if (typeof $6cAn5 !== 'undefined' && "production") return "production";
    return 'development';
}
function $e1dfb923a27ca793$export$f0cb0fda19c18b37(env) {
    return $e1dfb923a27ca793$export$4bd44a2aa29d3d6e() === env;
}
function $e1dfb923a27ca793$export$f15d00aa73aafac4() {
    return $e1dfb923a27ca793$export$f0cb0fda19c18b37('production') === true;
}
function $e1dfb923a27ca793$export$df77466336fe5355() {
    return $e1dfb923a27ca793$export$f0cb0fda19c18b37('development') === true;
}
function $e1dfb923a27ca793$export$410cbc2864fa25b5() {
    return $e1dfb923a27ca793$export$f0cb0fda19c18b37('test') === true;
}
function $e1dfb923a27ca793$export$50a91acae4904909(f) {
    try {
        return f();
    } catch (e) {
        if (console.error) console.error(e);
    }
}
function $e1dfb923a27ca793$export$b4df399e879e53ab(result) {
    return result.errors && result.errors.length;
}
function $e1dfb923a27ca793$var$deepFreeze(o) {
    Object.freeze(o);
    Object.getOwnPropertyNames(o).forEach(function(prop) {
        if (o[prop] !== null && (typeof o[prop] === 'object' || typeof o[prop] === 'function') && !Object.isFrozen(o[prop])) $e1dfb923a27ca793$var$deepFreeze(o[prop]);
    });
    return o;
}
function $e1dfb923a27ca793$export$7f9c177735b71f18(obj) {
    if ($e1dfb923a27ca793$export$df77466336fe5355() || $e1dfb923a27ca793$export$410cbc2864fa25b5()) {
        var symbolIsPolyfilled = typeof Symbol === 'function' && typeof Symbol('') === 'string';
        if (!symbolIsPolyfilled) return $e1dfb923a27ca793$var$deepFreeze(obj);
    }
    return obj;
}
var $e1dfb923a27ca793$var$hasOwnProperty = Object.prototype.hasOwnProperty;
function $e1dfb923a27ca793$export$dd702b3c8240390c() {
    var sources = [];
    for(var _i = 0; _i < arguments.length; _i++)sources[_i] = arguments[_i];
    return $e1dfb923a27ca793$export$160070228be94b08(sources);
}
function $e1dfb923a27ca793$export$160070228be94b08(sources) {
    var target = sources[0] || {};
    var count = sources.length;
    if (count > 1) {
        var pastCopies = [];
        target = $e1dfb923a27ca793$var$shallowCopyForMerge(target, pastCopies);
        for(var i = 1; i < count; ++i)target = $e1dfb923a27ca793$var$mergeHelper(target, sources[i], pastCopies);
    }
    return target;
}
function $e1dfb923a27ca793$var$isObject(obj) {
    return obj !== null && typeof obj === 'object';
}
function $e1dfb923a27ca793$var$mergeHelper(target, source, pastCopies) {
    if ($e1dfb923a27ca793$var$isObject(source) && $e1dfb923a27ca793$var$isObject(target)) {
        if (Object.isExtensible && !Object.isExtensible(target)) target = $e1dfb923a27ca793$var$shallowCopyForMerge(target, pastCopies);
        Object.keys(source).forEach(function(sourceKey) {
            var sourceValue = source[sourceKey];
            if ($e1dfb923a27ca793$var$hasOwnProperty.call(target, sourceKey)) {
                var targetValue = target[sourceKey];
                if (sourceValue !== targetValue) target[sourceKey] = $e1dfb923a27ca793$var$mergeHelper($e1dfb923a27ca793$var$shallowCopyForMerge(targetValue, pastCopies), sourceValue, pastCopies);
            } else target[sourceKey] = sourceValue;
        });
        return target;
    }
    return source;
}
function $e1dfb923a27ca793$var$shallowCopyForMerge(value, pastCopies) {
    if (value !== null && typeof value === 'object' && pastCopies.indexOf(value) < 0) {
        if (Array.isArray(value)) value = value.slice(0);
        else value = (0, $3VFsf.__assign)({
            __proto__: Object.getPrototypeOf(value)
        }, value);
        pastCopies.push(value);
    }
    return value;
}
var $e1dfb923a27ca793$var$haveWarned = Object.create({});
function $e1dfb923a27ca793$export$49d47c8e549bfaf9(msg, type) {
    if (type === void 0) type = 'warn';
    if (!$e1dfb923a27ca793$export$f15d00aa73aafac4() && !$e1dfb923a27ca793$var$haveWarned[msg]) {
        if (!$e1dfb923a27ca793$export$410cbc2864fa25b5()) $e1dfb923a27ca793$var$haveWarned[msg] = true;
        if (type === 'error') console.error(msg);
        else console.warn(msg);
    }
}
function $e1dfb923a27ca793$export$c54efeba029d4fe8(data) {
    return JSON.parse(JSON.stringify(data));
}

});
parcelRegister("1DiV8", function(module, exports) {

$parcel$export(module.exports, "InvariantError", () => $13081c324be1f9ab$export$cea12affaee22fe8);
$parcel$export(module.exports, "invariant", () => $13081c324be1f9ab$export$f5708dca728d7177);

var $3VFsf = parcelRequire("3VFsf");

var $6cAn5 = parcelRequire("6cAn5");
var $13081c324be1f9ab$var$genericMessage = "Invariant Violation";
var $13081c324be1f9ab$var$_a = Object.setPrototypeOf, $13081c324be1f9ab$var$setPrototypeOf = $13081c324be1f9ab$var$_a === void 0 ? function(obj, proto) {
    obj.__proto__ = proto;
    return obj;
} : $13081c324be1f9ab$var$_a;
var $13081c324be1f9ab$export$cea12affaee22fe8 = /** @class */ function(_super) {
    (0, $3VFsf.__extends)(InvariantError, _super);
    function InvariantError(message) {
        if (message === void 0) message = $13081c324be1f9ab$var$genericMessage;
        var _this = _super.call(this, typeof message === "number" ? $13081c324be1f9ab$var$genericMessage + ": " + message + " (see https://github.com/apollographql/invariant-packages)" : message) || this;
        _this.framesToPop = 1;
        _this.name = $13081c324be1f9ab$var$genericMessage;
        $13081c324be1f9ab$var$setPrototypeOf(_this, InvariantError.prototype);
        return _this;
    }
    return InvariantError;
}(Error);
function $13081c324be1f9ab$export$f5708dca728d7177(condition, message) {
    if (!condition) throw new $13081c324be1f9ab$export$cea12affaee22fe8(message);
}
function $13081c324be1f9ab$var$wrapConsoleMethod(method) {
    return function() {
        return console[method].apply(console, arguments);
    };
}
(function(invariant) {
    invariant.warn = $13081c324be1f9ab$var$wrapConsoleMethod("warn");
    invariant.error = $13081c324be1f9ab$var$wrapConsoleMethod("error");
})($13081c324be1f9ab$export$f5708dca728d7177 || ($13081c324be1f9ab$export$f5708dca728d7177 = {}));
// Code that uses ts-invariant with rollup-plugin-invariant may want to
// import this process stub to avoid errors evaluating process.env.NODE_ENV.
// However, because most ESM-to-CJS compilers will rewrite the process import
// as tsInvariant.process, which prevents proper replacement by minifiers, we
// also attempt to define the stub globally when it is not already defined.
var $13081c324be1f9ab$export$e54fe5b0f43758f7 = {
    env: {}
};
if (typeof $6cAn5 === "object") $13081c324be1f9ab$export$e54fe5b0f43758f7 = $6cAn5;
else try {
    // Using Function to evaluate this assignment in global scope also escapes
    // the strict mode of the current module, thereby allowing the assignment.
    // Inspired by https://github.com/facebook/regenerator/pull/369.
    Function("stub", "process = stub")($13081c324be1f9ab$export$e54fe5b0f43758f7);
} catch (atLeastWeTried) {
// The assignment can fail if a Content Security Policy heavy-handedly
// forbids Function usage. In those environments, developers should take
// extra care to replace process.env.NODE_ENV in their production builds,
// or define an appropriate global.process polyfill.
}
var $13081c324be1f9ab$var$invariant$1 = $13081c324be1f9ab$export$f5708dca728d7177;
var $13081c324be1f9ab$export$2e2bcd8739ae039 = $13081c324be1f9ab$var$invariant$1;

});

parcelRegister("fkrBp", function(module, exports) {
'use strict';
module.exports = function(data, opts) {
    if (!opts) opts = {};
    if (typeof opts === 'function') opts = {
        cmp: opts
    };
    var cycles = typeof opts.cycles === 'boolean' ? opts.cycles : false;
    var cmp = opts.cmp && function(f) {
        return function(node) {
            return function(a, b) {
                var aobj = {
                    key: a,
                    value: node[a]
                };
                var bobj = {
                    key: b,
                    value: node[b]
                };
                return f(aobj, bobj);
            };
        };
    }(opts.cmp);
    var seen = [];
    return function stringify(node) {
        if (node && node.toJSON && typeof node.toJSON === 'function') node = node.toJSON();
        if (node === undefined) return;
        if (typeof node == 'number') return isFinite(node) ? '' + node : 'null';
        if (typeof node !== 'object') return JSON.stringify(node);
        var i, out;
        if (Array.isArray(node)) {
            out = '[';
            for(i = 0; i < node.length; i++){
                if (i) out += ',';
                out += stringify(node[i]) || 'null';
            }
            return out + ']';
        }
        if (node === null) return 'null';
        if (seen.indexOf(node) !== -1) {
            if (cycles) return JSON.stringify('__cycle__');
            throw new TypeError('Converting circular structure to JSON');
        }
        var seenIndex = seen.push(node) - 1;
        var keys = Object.keys(node).sort(cmp && cmp(node));
        out = '';
        for(i = 0; i < keys.length; i++){
            var key = keys[i];
            var value = stringify(node[key]);
            if (!value) continue;
            if (out) out += ',';
            out += JSON.stringify(key) + ':' + value;
        }
        seen.splice(seenIndex, 1);
        return '{' + out + '}';
    }(data);
};

});

parcelRegister("bqMzA", function(module, exports) {

$parcel$export(module.exports, "equal", () => $8527cd05038b1b96$export$411ce8e5a71e3069);
var $8527cd05038b1b96$var$_a = Object.prototype, $8527cd05038b1b96$var$toString = $8527cd05038b1b96$var$_a.toString, $8527cd05038b1b96$var$hasOwnProperty = $8527cd05038b1b96$var$_a.hasOwnProperty;
var $8527cd05038b1b96$var$previousComparisons = new Map();
/**
 * Performs a deep equality check on two JavaScript values, tolerating cycles.
 */ function $8527cd05038b1b96$export$411ce8e5a71e3069(a, b) {
    try {
        return $8527cd05038b1b96$var$check(a, b);
    } finally{
        $8527cd05038b1b96$var$previousComparisons.clear();
    }
}
function $8527cd05038b1b96$var$check(a, b) {
    // If the two values are strictly equal, our job is easy.
    if (a === b) return true;
    // Object.prototype.toString returns a representation of the runtime type of
    // the given value that is considerably more precise than typeof.
    var aTag = $8527cd05038b1b96$var$toString.call(a);
    var bTag = $8527cd05038b1b96$var$toString.call(b);
    // If the runtime types of a and b are different, they could maybe be equal
    // under some interpretation of equality, but for simplicity and performance
    // we just return false instead.
    if (aTag !== bTag) return false;
    switch(aTag){
        case '[object Array]':
            // Arrays are a lot like other objects, but we can cheaply compare their
            // lengths as a short-cut before comparing their elements.
            if (a.length !== b.length) return false;
        // Fall through to object case...
        case '[object Object]':
            if ($8527cd05038b1b96$var$previouslyCompared(a, b)) return true;
            var aKeys = Object.keys(a);
            var bKeys = Object.keys(b);
            // If `a` and `b` have a different number of enumerable keys, they
            // must be different.
            var keyCount = aKeys.length;
            if (keyCount !== bKeys.length) return false;
            // Now make sure they have the same keys.
            for(var k = 0; k < keyCount; ++k){
                if (!$8527cd05038b1b96$var$hasOwnProperty.call(b, aKeys[k])) return false;
            }
            // Finally, check deep equality of all child properties.
            for(var k = 0; k < keyCount; ++k){
                var key = aKeys[k];
                if (!$8527cd05038b1b96$var$check(a[key], b[key])) return false;
            }
            return true;
        case '[object Error]':
            return a.name === b.name && a.message === b.message;
        case '[object Number]':
            // Handle NaN, which is !== itself.
            if (a !== a) return b !== b;
        // Fall through to shared +a === +b case...
        case '[object Boolean]':
        case '[object Date]':
            return +a === +b;
        case '[object RegExp]':
        case '[object String]':
            return a == "" + b;
        case '[object Map]':
        case '[object Set]':
            if (a.size !== b.size) return false;
            if ($8527cd05038b1b96$var$previouslyCompared(a, b)) return true;
            var aIterator = a.entries();
            var isMap = aTag === '[object Map]';
            while(true){
                var info = aIterator.next();
                if (info.done) break;
                // If a instanceof Set, aValue === aKey.
                var _a = info.value, aKey = _a[0], aValue = _a[1];
                // So this works the same way for both Set and Map.
                if (!b.has(aKey)) return false;
                // However, we care about deep equality of values only when dealing
                // with Map structures.
                if (isMap && !$8527cd05038b1b96$var$check(aValue, b.get(aKey))) return false;
            }
            return true;
    }
    // Otherwise the values are not equal.
    return false;
}
function $8527cd05038b1b96$var$previouslyCompared(a, b) {
    // Though cyclic references can make an object graph appear infinite from the
    // perspective of a depth-first traversal, the graph still contains a finite
    // number of distinct object references. We use the previousComparisons cache
    // to avoid comparing the same pair of object references more than once, which
    // guarantees termination (even if we end up comparing every object in one
    // graph to every object in the other graph, which is extremely unlikely),
    // while still allowing weird isomorphic structures (like rings with different
    // lengths) a chance to pass the equality test.
    var bSet = $8527cd05038b1b96$var$previousComparisons.get(a);
    if (bSet) {
        // Return true here because we can be sure false will be returned somewhere
        // else if the objects are not equivalent.
        if (bSet.has(b)) return true;
    } else $8527cd05038b1b96$var$previousComparisons.set(a, bSet = new Set);
    bSet.add(b);
    return false;
}
var $8527cd05038b1b96$export$2e2bcd8739ae039 = $8527cd05038b1b96$export$411ce8e5a71e3069;

});


parcelRegister("clSzL", function(module, exports) {

$parcel$export(module.exports, "fromError", () => fromError);
$parcel$export(module.exports, "ApolloLink", () => ApolloLink);
$parcel$export(module.exports, "from", () => from);
$parcel$export(module.exports, "execute", () => execute);
$parcel$export(module.exports, "Observable", () => (parcelRequire("aS6b9")).default);

var $aS6b9 = parcelRequire("aS6b9");

var $1DiV8 = parcelRequire("1DiV8");

var $3VFsf = parcelRequire("3VFsf");

var $jojW6 = parcelRequire("jojW6");
function validateOperation(operation) {
    var OPERATION_FIELDS = [
        'query',
        'operationName',
        'variables',
        'extensions',
        'context'
    ];
    for(var _i = 0, _a = Object.keys(operation); _i < _a.length; _i++){
        var key = _a[_i];
        if (OPERATION_FIELDS.indexOf(key) < 0) throw new (0, $1DiV8.InvariantError)(2);
    }
    return operation;
}
var LinkError = function(_super) {
    (0, $3VFsf.__extends)(LinkError, _super);
    function LinkError(message, link) {
        var _this = _super.call(this, message) || this;
        _this.link = link;
        return _this;
    }
    return LinkError;
}(Error);
function isTerminating(link) {
    return link.request.length <= 1;
}
function toPromise(observable) {
    var completed = false;
    return new Promise(function(resolve, reject) {
        observable.subscribe({
            next: function(data) {
                if (completed) ;
                else {
                    completed = true;
                    resolve(data);
                }
            },
            error: reject
        });
    });
}
var makePromise = toPromise;
function fromPromise(promise) {
    return new (0, $aS6b9.default)(function(observer) {
        promise.then(function(value) {
            observer.next(value);
            observer.complete();
        }).catch(observer.error.bind(observer));
    });
}
function fromError(errorValue) {
    return new (0, $aS6b9.default)(function(observer) {
        observer.error(errorValue);
    });
}
function transformOperation(operation) {
    var transformedOperation = {
        variables: operation.variables || {},
        extensions: operation.extensions || {},
        operationName: operation.operationName,
        query: operation.query
    };
    if (!transformedOperation.operationName) transformedOperation.operationName = typeof transformedOperation.query !== 'string' ? (0, $jojW6.getOperationName)(transformedOperation.query) : '';
    return transformedOperation;
}
function createOperation(starting, operation) {
    var context = (0, $3VFsf.__assign)({}, starting);
    var setContext = function(next) {
        if (typeof next === 'function') context = (0, $3VFsf.__assign)({}, context, next(context));
        else context = (0, $3VFsf.__assign)({}, context, next);
    };
    var getContext = function() {
        return (0, $3VFsf.__assign)({}, context);
    };
    Object.defineProperty(operation, 'setContext', {
        enumerable: false,
        value: setContext
    });
    Object.defineProperty(operation, 'getContext', {
        enumerable: false,
        value: getContext
    });
    Object.defineProperty(operation, 'toKey', {
        enumerable: false,
        value: function() {
            return getKey(operation);
        }
    });
    return operation;
}
function getKey(operation) {
    var query = operation.query, variables = operation.variables, operationName = operation.operationName;
    return JSON.stringify([
        operationName,
        query,
        variables
    ]);
}
function passthrough(op, forward) {
    return forward ? forward(op) : (0, $aS6b9.default).of();
}
function toLink(handler) {
    return typeof handler === 'function' ? new ApolloLink(handler) : handler;
}
function empty() {
    return new ApolloLink(function() {
        return (0, $aS6b9.default).of();
    });
}
function from(links) {
    if (links.length === 0) return empty();
    return links.map(toLink).reduce(function(x, y) {
        return x.concat(y);
    });
}
function split(test, left, right) {
    var leftLink = toLink(left);
    var rightLink = toLink(right || new ApolloLink(passthrough));
    if (isTerminating(leftLink) && isTerminating(rightLink)) return new ApolloLink(function(operation) {
        return test(operation) ? leftLink.request(operation) || (0, $aS6b9.default).of() : rightLink.request(operation) || (0, $aS6b9.default).of();
    });
    else return new ApolloLink(function(operation, forward) {
        return test(operation) ? leftLink.request(operation, forward) || (0, $aS6b9.default).of() : rightLink.request(operation, forward) || (0, $aS6b9.default).of();
    });
}
var concat = function(first, second) {
    var firstLink = toLink(first);
    if (isTerminating(firstLink)) return firstLink;
    var nextLink = toLink(second);
    if (isTerminating(nextLink)) return new ApolloLink(function(operation) {
        return firstLink.request(operation, function(op) {
            return nextLink.request(op) || (0, $aS6b9.default).of();
        }) || (0, $aS6b9.default).of();
    });
    else return new ApolloLink(function(operation, forward) {
        return firstLink.request(operation, function(op) {
            return nextLink.request(op, forward) || (0, $aS6b9.default).of();
        }) || (0, $aS6b9.default).of();
    });
};
var ApolloLink = function() {
    function ApolloLink(request) {
        if (request) this.request = request;
    }
    ApolloLink.prototype.split = function(test, left, right) {
        return this.concat(split(test, left, right || new ApolloLink(passthrough)));
    };
    ApolloLink.prototype.concat = function(next) {
        return concat(this, next);
    };
    ApolloLink.prototype.request = function(operation, forward) {
        throw new (0, $1DiV8.InvariantError)(1);
    };
    ApolloLink.empty = empty;
    ApolloLink.from = from;
    ApolloLink.split = split;
    ApolloLink.execute = execute;
    return ApolloLink;
}();
function execute(link, operation) {
    return link.request(createOperation(operation.context, transformOperation(validateOperation(operation)))) || (0, $aS6b9.default).of();
}

});
parcelRegister("aS6b9", function(module, exports) {

$parcel$export(module.exports, "default", () => $7ea3bd7f736c1eb4$export$2e2bcd8739ae039);

var $4osjv = parcelRequire("4osjv");
var $7ea3bd7f736c1eb4$export$77cea355fa80b5f4 = (0, (/*@__PURE__*/$parcel$interopDefault($4osjv)));
var $7ea3bd7f736c1eb4$export$2e2bcd8739ae039 = $7ea3bd7f736c1eb4$export$77cea355fa80b5f4;

});
parcelRegister("4osjv", function(module, exports) {

module.exports = (parcelRequire("k0hXK")).Observable;

});
parcelRegister("k0hXK", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.Observable = void 0;
function $e901bdc1c9a5edd7$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function $e901bdc1c9a5edd7$var$_defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function $e901bdc1c9a5edd7$var$_createClass(Constructor, protoProps, staticProps) {
    if (protoProps) $e901bdc1c9a5edd7$var$_defineProperties(Constructor.prototype, protoProps);
    if (staticProps) $e901bdc1c9a5edd7$var$_defineProperties(Constructor, staticProps);
    return Constructor;
}
// === Symbol Support ===
var $e901bdc1c9a5edd7$var$hasSymbols = function() {
    return typeof Symbol === 'function';
};
var $e901bdc1c9a5edd7$var$hasSymbol = function(name) {
    return $e901bdc1c9a5edd7$var$hasSymbols() && Boolean(Symbol[name]);
};
var $e901bdc1c9a5edd7$var$getSymbol = function(name) {
    return $e901bdc1c9a5edd7$var$hasSymbol(name) ? Symbol[name] : '@@' + name;
};
if ($e901bdc1c9a5edd7$var$hasSymbols() && !$e901bdc1c9a5edd7$var$hasSymbol('observable')) Symbol.observable = Symbol('observable');
var $e901bdc1c9a5edd7$var$SymbolIterator = $e901bdc1c9a5edd7$var$getSymbol('iterator');
var $e901bdc1c9a5edd7$var$SymbolObservable = $e901bdc1c9a5edd7$var$getSymbol('observable');
var $e901bdc1c9a5edd7$var$SymbolSpecies = $e901bdc1c9a5edd7$var$getSymbol('species'); // === Abstract Operations ===
function $e901bdc1c9a5edd7$var$getMethod(obj, key) {
    var value = obj[key];
    if (value == null) return undefined;
    if (typeof value !== 'function') throw new TypeError(value + ' is not a function');
    return value;
}
function $e901bdc1c9a5edd7$var$getSpecies(obj) {
    var ctor = obj.constructor;
    if (ctor !== undefined) {
        ctor = ctor[$e901bdc1c9a5edd7$var$SymbolSpecies];
        if (ctor === null) ctor = undefined;
    }
    return ctor !== undefined ? ctor : $e901bdc1c9a5edd7$var$Observable;
}
function $e901bdc1c9a5edd7$var$isObservable(x) {
    return x instanceof $e901bdc1c9a5edd7$var$Observable; // SPEC: Brand check
}
function $e901bdc1c9a5edd7$var$hostReportError(e) {
    if ($e901bdc1c9a5edd7$var$hostReportError.log) $e901bdc1c9a5edd7$var$hostReportError.log(e);
    else setTimeout(function() {
        throw e;
    });
}
function $e901bdc1c9a5edd7$var$enqueue(fn) {
    Promise.resolve().then(function() {
        try {
            fn();
        } catch (e) {
            $e901bdc1c9a5edd7$var$hostReportError(e);
        }
    });
}
function $e901bdc1c9a5edd7$var$cleanupSubscription(subscription) {
    var cleanup = subscription._cleanup;
    if (cleanup === undefined) return;
    subscription._cleanup = undefined;
    if (!cleanup) return;
    try {
        if (typeof cleanup === 'function') cleanup();
        else {
            var unsubscribe = $e901bdc1c9a5edd7$var$getMethod(cleanup, 'unsubscribe');
            if (unsubscribe) unsubscribe.call(cleanup);
        }
    } catch (e) {
        $e901bdc1c9a5edd7$var$hostReportError(e);
    }
}
function $e901bdc1c9a5edd7$var$closeSubscription(subscription) {
    subscription._observer = undefined;
    subscription._queue = undefined;
    subscription._state = 'closed';
}
function $e901bdc1c9a5edd7$var$flushSubscription(subscription) {
    var queue = subscription._queue;
    if (!queue) return;
    subscription._queue = undefined;
    subscription._state = 'ready';
    for(var i = 0; i < queue.length; ++i){
        $e901bdc1c9a5edd7$var$notifySubscription(subscription, queue[i].type, queue[i].value);
        if (subscription._state === 'closed') break;
    }
}
function $e901bdc1c9a5edd7$var$notifySubscription(subscription, type, value) {
    subscription._state = 'running';
    var observer = subscription._observer;
    try {
        var m = $e901bdc1c9a5edd7$var$getMethod(observer, type);
        switch(type){
            case 'next':
                if (m) m.call(observer, value);
                break;
            case 'error':
                $e901bdc1c9a5edd7$var$closeSubscription(subscription);
                if (m) m.call(observer, value);
                else throw value;
                break;
            case 'complete':
                $e901bdc1c9a5edd7$var$closeSubscription(subscription);
                if (m) m.call(observer);
                break;
        }
    } catch (e) {
        $e901bdc1c9a5edd7$var$hostReportError(e);
    }
    if (subscription._state === 'closed') $e901bdc1c9a5edd7$var$cleanupSubscription(subscription);
    else if (subscription._state === 'running') subscription._state = 'ready';
}
function $e901bdc1c9a5edd7$var$onNotify(subscription, type, value) {
    if (subscription._state === 'closed') return;
    if (subscription._state === 'buffering') {
        subscription._queue.push({
            type: type,
            value: value
        });
        return;
    }
    if (subscription._state !== 'ready') {
        subscription._state = 'buffering';
        subscription._queue = [
            {
                type: type,
                value: value
            }
        ];
        $e901bdc1c9a5edd7$var$enqueue(function() {
            return $e901bdc1c9a5edd7$var$flushSubscription(subscription);
        });
        return;
    }
    $e901bdc1c9a5edd7$var$notifySubscription(subscription, type, value);
}
var $e901bdc1c9a5edd7$var$Subscription = /*#__PURE__*/ function() {
    function Subscription(observer, subscriber) {
        $e901bdc1c9a5edd7$var$_classCallCheck(this, Subscription);
        // ASSERT: observer is an object
        // ASSERT: subscriber is callable
        this._cleanup = undefined;
        this._observer = observer;
        this._queue = undefined;
        this._state = 'initializing';
        var subscriptionObserver = new $e901bdc1c9a5edd7$var$SubscriptionObserver(this);
        try {
            this._cleanup = subscriber.call(undefined, subscriptionObserver);
        } catch (e) {
            subscriptionObserver.error(e);
        }
        if (this._state === 'initializing') this._state = 'ready';
    }
    $e901bdc1c9a5edd7$var$_createClass(Subscription, [
        {
            key: "unsubscribe",
            value: function unsubscribe() {
                if (this._state !== 'closed') {
                    $e901bdc1c9a5edd7$var$closeSubscription(this);
                    $e901bdc1c9a5edd7$var$cleanupSubscription(this);
                }
            }
        },
        {
            key: "closed",
            get: function() {
                return this._state === 'closed';
            }
        }
    ]);
    return Subscription;
}();
var $e901bdc1c9a5edd7$var$SubscriptionObserver = /*#__PURE__*/ function() {
    function SubscriptionObserver(subscription) {
        $e901bdc1c9a5edd7$var$_classCallCheck(this, SubscriptionObserver);
        this._subscription = subscription;
    }
    $e901bdc1c9a5edd7$var$_createClass(SubscriptionObserver, [
        {
            key: "next",
            value: function next(value) {
                $e901bdc1c9a5edd7$var$onNotify(this._subscription, 'next', value);
            }
        },
        {
            key: "error",
            value: function error(value) {
                $e901bdc1c9a5edd7$var$onNotify(this._subscription, 'error', value);
            }
        },
        {
            key: "complete",
            value: function complete() {
                $e901bdc1c9a5edd7$var$onNotify(this._subscription, 'complete');
            }
        },
        {
            key: "closed",
            get: function() {
                return this._subscription._state === 'closed';
            }
        }
    ]);
    return SubscriptionObserver;
}();
var $e901bdc1c9a5edd7$var$Observable = /*#__PURE__*/ function() {
    function Observable(subscriber) {
        $e901bdc1c9a5edd7$var$_classCallCheck(this, Observable);
        if (!(this instanceof Observable)) throw new TypeError('Observable cannot be called as a function');
        if (typeof subscriber !== 'function') throw new TypeError('Observable initializer must be a function');
        this._subscriber = subscriber;
    }
    $e901bdc1c9a5edd7$var$_createClass(Observable, [
        {
            key: "subscribe",
            value: function subscribe(observer) {
                if (typeof observer !== 'object' || observer === null) observer = {
                    next: observer,
                    error: arguments[1],
                    complete: arguments[2]
                };
                return new $e901bdc1c9a5edd7$var$Subscription(observer, this._subscriber);
            }
        },
        {
            key: "forEach",
            value: function forEach(fn) {
                var _this = this;
                return new Promise(function(resolve, reject) {
                    if (typeof fn !== 'function') {
                        reject(new TypeError(fn + ' is not a function'));
                        return;
                    }
                    function done() {
                        subscription.unsubscribe();
                        resolve();
                    }
                    var subscription = _this.subscribe({
                        next: function(value) {
                            try {
                                fn(value, done);
                            } catch (e) {
                                reject(e);
                                subscription.unsubscribe();
                            }
                        },
                        error: reject,
                        complete: resolve
                    });
                });
            }
        },
        {
            key: "map",
            value: function map(fn) {
                var _this2 = this;
                if (typeof fn !== 'function') throw new TypeError(fn + ' is not a function');
                var C = $e901bdc1c9a5edd7$var$getSpecies(this);
                return new C(function(observer) {
                    return _this2.subscribe({
                        next: function(value) {
                            try {
                                value = fn(value);
                            } catch (e) {
                                return observer.error(e);
                            }
                            observer.next(value);
                        },
                        error: function(e) {
                            observer.error(e);
                        },
                        complete: function() {
                            observer.complete();
                        }
                    });
                });
            }
        },
        {
            key: "filter",
            value: function filter(fn) {
                var _this3 = this;
                if (typeof fn !== 'function') throw new TypeError(fn + ' is not a function');
                var C = $e901bdc1c9a5edd7$var$getSpecies(this);
                return new C(function(observer) {
                    return _this3.subscribe({
                        next: function(value) {
                            try {
                                if (!fn(value)) return;
                            } catch (e) {
                                return observer.error(e);
                            }
                            observer.next(value);
                        },
                        error: function(e) {
                            observer.error(e);
                        },
                        complete: function() {
                            observer.complete();
                        }
                    });
                });
            }
        },
        {
            key: "reduce",
            value: function reduce(fn) {
                var _this4 = this;
                if (typeof fn !== 'function') throw new TypeError(fn + ' is not a function');
                var C = $e901bdc1c9a5edd7$var$getSpecies(this);
                var hasSeed = arguments.length > 1;
                var hasValue = false;
                var seed = arguments[1];
                var acc = seed;
                return new C(function(observer) {
                    return _this4.subscribe({
                        next: function(value) {
                            var first = !hasValue;
                            hasValue = true;
                            if (!first || hasSeed) try {
                                acc = fn(acc, value);
                            } catch (e) {
                                return observer.error(e);
                            }
                            else acc = value;
                        },
                        error: function(e) {
                            observer.error(e);
                        },
                        complete: function() {
                            if (!hasValue && !hasSeed) return observer.error(new TypeError('Cannot reduce an empty sequence'));
                            observer.next(acc);
                            observer.complete();
                        }
                    });
                });
            }
        },
        {
            key: "concat",
            value: function concat() {
                var _this5 = this;
                for(var _len = arguments.length, sources = new Array(_len), _key = 0; _key < _len; _key++)sources[_key] = arguments[_key];
                var C = $e901bdc1c9a5edd7$var$getSpecies(this);
                return new C(function(observer) {
                    var subscription;
                    var index = 0;
                    function startNext(next) {
                        subscription = next.subscribe({
                            next: function(v) {
                                observer.next(v);
                            },
                            error: function(e) {
                                observer.error(e);
                            },
                            complete: function() {
                                if (index === sources.length) {
                                    subscription = undefined;
                                    observer.complete();
                                } else startNext(C.from(sources[index++]));
                            }
                        });
                    }
                    startNext(_this5);
                    return function() {
                        if (subscription) {
                            subscription.unsubscribe();
                            subscription = undefined;
                        }
                    };
                });
            }
        },
        {
            key: "flatMap",
            value: function flatMap(fn) {
                var _this6 = this;
                if (typeof fn !== 'function') throw new TypeError(fn + ' is not a function');
                var C = $e901bdc1c9a5edd7$var$getSpecies(this);
                return new C(function(observer) {
                    var subscriptions = [];
                    var outer = _this6.subscribe({
                        next: function(value) {
                            if (fn) try {
                                value = fn(value);
                            } catch (e) {
                                return observer.error(e);
                            }
                            var inner = C.from(value).subscribe({
                                next: function(value) {
                                    observer.next(value);
                                },
                                error: function(e) {
                                    observer.error(e);
                                },
                                complete: function() {
                                    var i = subscriptions.indexOf(inner);
                                    if (i >= 0) subscriptions.splice(i, 1);
                                    completeIfDone();
                                }
                            });
                            subscriptions.push(inner);
                        },
                        error: function(e) {
                            observer.error(e);
                        },
                        complete: function() {
                            completeIfDone();
                        }
                    });
                    function completeIfDone() {
                        if (outer.closed && subscriptions.length === 0) observer.complete();
                    }
                    return function() {
                        subscriptions.forEach(function(s) {
                            return s.unsubscribe();
                        });
                        outer.unsubscribe();
                    };
                });
            }
        },
        {
            key: $e901bdc1c9a5edd7$var$SymbolObservable,
            value: function() {
                return this;
            }
        }
    ], [
        {
            key: "from",
            value: function from(x) {
                var C = typeof this === 'function' ? this : Observable;
                if (x == null) throw new TypeError(x + ' is not an object');
                var method = $e901bdc1c9a5edd7$var$getMethod(x, $e901bdc1c9a5edd7$var$SymbolObservable);
                if (method) {
                    var observable = method.call(x);
                    if (Object(observable) !== observable) throw new TypeError(observable + ' is not an object');
                    if ($e901bdc1c9a5edd7$var$isObservable(observable) && observable.constructor === C) return observable;
                    return new C(function(observer) {
                        return observable.subscribe(observer);
                    });
                }
                if ($e901bdc1c9a5edd7$var$hasSymbol('iterator')) {
                    method = $e901bdc1c9a5edd7$var$getMethod(x, $e901bdc1c9a5edd7$var$SymbolIterator);
                    if (method) return new C(function(observer) {
                        $e901bdc1c9a5edd7$var$enqueue(function() {
                            if (observer.closed) return;
                            var _iteratorNormalCompletion = true;
                            var _didIteratorError = false;
                            var _iteratorError = undefined;
                            try {
                                for(var _iterator = method.call(x)[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                                    var _item = _step.value;
                                    observer.next(_item);
                                    if (observer.closed) return;
                                }
                            } catch (err) {
                                _didIteratorError = true;
                                _iteratorError = err;
                            } finally{
                                try {
                                    if (!_iteratorNormalCompletion && _iterator.return != null) _iterator.return();
                                } finally{
                                    if (_didIteratorError) throw _iteratorError;
                                }
                            }
                            observer.complete();
                        });
                    });
                }
                if (Array.isArray(x)) return new C(function(observer) {
                    $e901bdc1c9a5edd7$var$enqueue(function() {
                        if (observer.closed) return;
                        for(var i = 0; i < x.length; ++i){
                            observer.next(x[i]);
                            if (observer.closed) return;
                        }
                        observer.complete();
                    });
                });
                throw new TypeError(x + ' is not observable');
            }
        },
        {
            key: "of",
            value: function of() {
                for(var _len2 = arguments.length, items = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++)items[_key2] = arguments[_key2];
                var C = typeof this === 'function' ? this : Observable;
                return new C(function(observer) {
                    $e901bdc1c9a5edd7$var$enqueue(function() {
                        if (observer.closed) return;
                        for(var i = 0; i < items.length; ++i){
                            observer.next(items[i]);
                            if (observer.closed) return;
                        }
                        observer.complete();
                    });
                });
            }
        },
        {
            key: $e901bdc1c9a5edd7$var$SymbolSpecies,
            get: function() {
                return this;
            }
        }
    ]);
    return Observable;
}();
module.exports.Observable = $e901bdc1c9a5edd7$var$Observable;
if ($e901bdc1c9a5edd7$var$hasSymbols()) Object.defineProperty($e901bdc1c9a5edd7$var$Observable, Symbol('extensions'), {
    value: {
        symbol: $e901bdc1c9a5edd7$var$SymbolObservable,
        hostReportError: $e901bdc1c9a5edd7$var$hostReportError
    },
    configurable: true
});

});





parcelRegister("j7a90", function(module, exports) {

$parcel$export(module.exports, "default", () => $6233b95581c40425$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");

var $lTDxG = parcelRequire("lTDxG");
var $6233b95581c40425$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    /* eslint-disable jira/i18n/id-named-by-package */ [(0, $lTDxG.ENTITY_LIMIT_ERROR_TYPE).COMMENTS_PER_VIEW]: {
        "id": "polaris-lib-errors.controllers.entity-limit-error.comments-per-view",
        "defaultMessage": "We couldn\u2019t create a new <item>comment</item> because this <item>view</item> has reached its limit for <item>comments</item>. Remove <item>comment</item> to create a new <item>comment</item>"
    },
    [(0, $lTDxG.ENTITY_LIMIT_ERROR_TYPE).FIELDS_PER_VIEW]: {
        "id": "polaris-lib-errors.controllers.entity-limit-error.fields-per-view",
        "defaultMessage": "We couldn\u2019t create a new <item>field</item> because this <item>view</item> has reached its limit for <item>fields</item>. Remove <item>field</item> to create a new <item>field</item>"
    },
    [(0, $lTDxG.ENTITY_LIMIT_ERROR_TYPE).FIELDS_PER_PROJECT]: {
        "id": "polaris-lib-errors.controllers.entity-limit-error.fields-per-project",
        "defaultMessage": "We couldn\u2019t create a new <item>field</item> because this <item>project</item> has reached its limit for <item>fields</item>. Remove <item>field</item> to create a new <item>field</item>"
    },
    [(0, $lTDxG.ENTITY_LIMIT_ERROR_TYPE).INSIGHTS_PER_IDEA]: {
        "id": "polaris-lib-errors.controllers.entity-limit-error.insights-per-idea",
        "defaultMessage": "We couldn\u2019t create a new <item>insight</item> because this <item>idea</item> has reached its limit for <item>insights</item>. Remove <item>insight</item> to create a new <item>insight</item>"
    },
    [(0, $lTDxG.ENTITY_LIMIT_ERROR_TYPE).INSIGHTS_PER_PROJECT]: {
        "id": "polaris-lib-errors.controllers.entity-limit-error.insights-per-project",
        "defaultMessage": "We couldn\u2019t create a new <item>insight</item> because this <item>project</item> has reached its limit for <item>insights</item>. Remove <item>insight</item> to create a new <item>insight</item>"
    },
    [(0, $lTDxG.ENTITY_LIMIT_ERROR_TYPE).LABELS_PER_SNIPPET]: {
        "id": "polaris-lib-errors.controllers.entity-limit-error.labels-per-snippet",
        "defaultMessage": "We couldn\u2019t create a new <item>label</item> because this <item>snippet</item> has reached its limit for <item>labels</item>. Remove <item>label</item> to create a new <item>label</item>"
    },
    [(0, $lTDxG.ENTITY_LIMIT_ERROR_TYPE).OPTIONS_PER_FIELD]: {
        "id": "polaris-lib-errors.controllers.entity-limit-error.options-per-field",
        "defaultMessage": "We couldn\u2019t create a new <item>option</item> because this <item>field</item> has reached its limit for <item>options</item>. Remove <item>option</item> to create a new <item>option</item>"
    },
    [(0, $lTDxG.ENTITY_LIMIT_ERROR_TYPE).PLAY_CONTRIBUTIONS_PER_PLAY]: {
        "id": "polaris-lib-errors.controllers.entity-limit-error.play-contributions-per-play",
        "defaultMessage": "We couldn\u2019t create a new <item>vote contribution</item> because this <item>vote</item> has reached its limit for <item>vote contributions</item>. Remove <item>vote contribution</item> to create a new <item>vote contribution</item>"
    },
    [(0, $lTDxG.ENTITY_LIMIT_ERROR_TYPE).PLAY_CONTRIBUTIONS_PER_PROJECT]: {
        "id": "polaris-lib-errors.controllers.entity-limit-error.play-contributions-per-project",
        "defaultMessage": "We couldn\u2019t create a new <item>vote contribution</item> because this <item>project</item> has reached its limit for <item>vote contributions</item>. Remove <item>vote contribution</item> to create a new <item>vote contribution</item>"
    },
    [(0, $lTDxG.ENTITY_LIMIT_ERROR_TYPE).PLAYS_PER_PROJECT]: {
        "id": "polaris-lib-errors.controllers.entity-limit-error.plays-per-project",
        "defaultMessage": "We couldn\u2019t create a new <item>vote</item> because this <item>project</item> has reached its limit for <item>votes</item>. Remove <item>vote</item> to create a new <item>vote</item>"
    },
    [(0, $lTDxG.ENTITY_LIMIT_ERROR_TYPE).SNIPPETS_PER_INSIGHT]: {
        "id": "polaris-lib-errors.controllers.entity-limit-error.snippets-per-insight",
        "defaultMessage": "We couldn\u2019t create a new <item>snippet</item> because this <item>insight</item> has reached its limit for <item>snippets</item>. Remove <item>snippet</item> to create a new <item>snippet</item>"
    },
    [(0, $lTDxG.ENTITY_LIMIT_ERROR_TYPE).VIEWS_PER_PROJECT]: {
        "id": "polaris-lib-errors.controllers.entity-limit-error.views-per-project",
        "defaultMessage": "We couldn\u2019t create a new <item>view</item> because this <item>project</item> has reached its limit for <item>views</item>. Remove <item>view</item> to create a new <item>view</item>"
    },
    [(0, $lTDxG.ENTITY_LIMIT_ERROR_TYPE).VIEWSETS_PER_PROJECT]: {
        "id": "polaris-lib-errors.controllers.entity-limit-error.viewsets-per-project",
        "defaultMessage": "We couldn\u2019t create a new <item>section</item> because this <item>project</item> has reached its limit for <item>sections</item>. Remove <item>section</item> to create a new <item>section</item>"
    }
});

});
parcelRegister("lTDxG", function(module, exports) {

$parcel$export(module.exports, "ENTITY_LIMIT_ERROR_TYPE", () => $557259e823a7e117$export$a197d88688faa32c);
const $557259e823a7e117$export$a197d88688faa32c = {
    COMMENTS_PER_VIEW: 'commentsPerView',
    FIELDS_PER_VIEW: 'fieldsPerView',
    FIELDS_PER_PROJECT: 'fieldsPerProject',
    INSIGHTS_PER_IDEA: 'insightsPerIdea',
    INSIGHTS_PER_PROJECT: 'insightsPerProject',
    LABELS_PER_SNIPPET: 'labelsPerSnippet',
    OPTIONS_PER_FIELD: 'optionsPerField',
    PLAY_CONTRIBUTIONS_PER_PLAY: 'playContributionsPerPlay',
    PLAY_CONTRIBUTIONS_PER_PROJECT: 'playContributionsPerProject',
    PLAYS_PER_PROJECT: 'playsPerProject',
    SNIPPETS_PER_INSIGHT: 'snippetsPerInsight',
    VIEWS_PER_PROJECT: 'viewsPerProject',
    VIEWSETS_PER_PROJECT: 'viewsetsPerProject'
};

});



parcelRegister("l6caf", function(module, exports) {

$parcel$export(module.exports, "default", () => $891c8f37fb7de7f7$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $891c8f37fb7de7f7$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    errorTitle: {
        "id": "polaris-lib-errors.controllers.error-title",
        "defaultMessage": "Something went wrong."
    },
    permissionErrorDescription: {
        "id": "polaris-lib-errors.controllers.permission-error-description",
        "defaultMessage": "You may not have the permissions required to perform this operation."
    },
    configErrorTitle: {
        "id": "polaris-lib-errors.controllers.config-error-title",
        "defaultMessage": "We couldn't save that."
    },
    configErrorDescription: {
        "id": "polaris-lib-errors.controllers.config-error-description",
        "defaultMessage": "This usually happens because the configuration data on this field is too big. Contact support for more details"
    },
    serverLoadFailedDescription: {
        "id": "polaris-lib-errors.controllers.server-load-failed-description",
        "defaultMessage": "We had difficulties to fetch some data from the server. Please refresh the page."
    },
    serverUpdateFailedDescription: {
        "id": "polaris-lib-errors.controllers.server-update-failed-description",
        "defaultMessage": "We had some difficulties to save some data to the server. Please try again or refresh the page."
    },
    errorDescription: {
        "id": "polaris-lib-errors.controllers.error-description",
        "defaultMessage": "We failed to execute your last operation. Our team has been notified. Please refresh the page to try again."
    },
    workflowLoadingFailedDescription: {
        "id": "polaris-lib-errors.controllers.workflow-loading-failed-description",
        "defaultMessage": "We had some difficulties to load some workflow data from the server. Please refresh the page."
    },
    errorPossibleAccessLoss: {
        "id": "polaris-lib-errors.controllers.error-possible-access-loss",
        "defaultMessage": "You may have lost access to the project or site. Please refresh the page."
    },
    cyclicFormulaFieldDescription: {
        "id": "polaris-lib-errors.controllers.cyclic-formula-field-description",
        "defaultMessage": "We cannot calculate the value of some fields because they contain a cyclic formula. Please edit the field configurations and refresh: {fieldLabels}"
    },
    entityLimitErrorTitle: {
        "id": "polaris-lib-errors.controllers.entity-limit-error-title",
        "defaultMessage": "You\u2019ve hit a limit"
    }
});

});

parcelRegister("aiePb", function(module, exports) {

$parcel$export(module.exports, "isPermissionError", () => $b7e19fcceac7c31b$export$e11674744930cd15);
$parcel$export(module.exports, "isRateLimitError", () => $b7e19fcceac7c31b$export$a8908c3867f6f20b);
$parcel$export(module.exports, "isAccessForbiddenError", () => $b7e19fcceac7c31b$export$443ae86cf12ba84);
$parcel$export(module.exports, "isNotFoundError", () => $b7e19fcceac7c31b$export$6ccdb59d3479f4f1);
$parcel$export(module.exports, "isClientClosedError", () => $b7e19fcceac7c31b$export$ce14333297f1d017);
$parcel$export(module.exports, "isBadRequest", () => $b7e19fcceac7c31b$export$9ec5d1f0bf2939c);
$parcel$export(module.exports, "isConflictError", () => $b7e19fcceac7c31b$export$b43c7b888ac6458);
$parcel$export(module.exports, "isConfigError", () => $b7e19fcceac7c31b$export$5e48c9e1c3c8f299);
$parcel$export(module.exports, "getMetadata", () => $b7e19fcceac7c31b$export$8548546c0aa631e6);

var $561FV = parcelRequire("561FV");

var $8LQ84 = parcelRequire("8LQ84");

var $icGZu = parcelRequire("icGZu");
const $b7e19fcceac7c31b$export$e11674744930cd15 = (errorObject)=>{
    if ((0, (/*@__PURE__*/$parcel$interopDefault($561FV)))(errorObject, 'statusCode')) // http response error, check status code
    return errorObject.statusCode === 401 || errorObject.statusCode === 403;
    if ((0, (/*@__PURE__*/$parcel$interopDefault($561FV)))(errorObject, 'graphQLErrors') && (0, (/*@__PURE__*/$parcel$interopDefault($8LQ84)))(errorObject.graphQLErrors)) // graphql response error, check polaris-specific payload
    return (0, (/*@__PURE__*/$parcel$interopDefault($icGZu)))(errorObject.graphQLErrors, (error)=>{
        const safeMessage = error.message || '';
        return error.extensions?.statusCode === 403 || error.extensions?.statusCode === 401 || safeMessage.includes('JIRA_ACCESS_NOT_PERMITTED') || safeMessage.includes('RequestStatus: 401') || safeMessage.includes('RequestStatus: 403') || safeMessage.includes('status code 401') || // that's probably obsolete
        safeMessage.includes('status code 403') // that's probably obsolete
        ;
    });
    return false;
};
const $b7e19fcceac7c31b$var$checkRateLimitErrorMatch = (error)=>{
    const safeMessage = error?.message || '';
    return error && 'statusCode' in error && error?.statusCode === 429 || error && 'extensions' in error && error.extensions?.statusCode === 429 || safeMessage.includes('RequestStatus: 429') || safeMessage.includes('status code 429');
};
const $b7e19fcceac7c31b$export$a8908c3867f6f20b = (errorObject)=>{
    return $b7e19fcceac7c31b$var$checkRateLimitErrorMatch(errorObject) || errorObject.networkError && $b7e19fcceac7c31b$var$checkRateLimitErrorMatch(errorObject.networkError) || errorObject?.graphQLErrors?.some((error)=>$b7e19fcceac7c31b$var$checkRateLimitErrorMatch(error)) || false;
};
const $b7e19fcceac7c31b$export$443ae86cf12ba84 = (errorObject)=>{
    if ((0, (/*@__PURE__*/$parcel$interopDefault($561FV)))(errorObject, 'statusCode')) // http response error, check status code
    return errorObject.statusCode === 403;
    return false;
};
const $b7e19fcceac7c31b$export$6ccdb59d3479f4f1 = (errorObject)=>{
    if ((0, (/*@__PURE__*/$parcel$interopDefault($561FV)))(errorObject, 'statusCode')) // http response error, check status code
    return errorObject.statusCode === 404;
    return false;
};
const $b7e19fcceac7c31b$export$ce14333297f1d017 = (errorObject)=>{
    if ((0, (/*@__PURE__*/$parcel$interopDefault($561FV)))(errorObject, 'statusCode')) // http response error, check status code
    return errorObject.statusCode === 499;
    return false;
};
const $b7e19fcceac7c31b$export$9ec5d1f0bf2939c = (errorObject)=>{
    if (errorObject?.statusCode) // http response error, check status code
    return errorObject?.statusCode >= 400 && errorObject?.statusCode < 500;
    return false;
};
const $b7e19fcceac7c31b$export$b43c7b888ac6458 = (errorObject)=>errorObject.statusCode === 409;
const $b7e19fcceac7c31b$export$5e48c9e1c3c8f299 = (errorObject)=>{
    if ((0, (/*@__PURE__*/$parcel$interopDefault($561FV)))(errorObject, 'statusCode') && (0, (/*@__PURE__*/$parcel$interopDefault($561FV)))(errorObject, 'message')) return errorObject.statusCode === 500 && errorObject.message === 'Property is too long';
    return false;
};
const $b7e19fcceac7c31b$export$8548546c0aa631e6 = (errorObject)=>({
        metadata: {
            error: errorObject.message
        }
    });

});
parcelRegister("icGZu", function(module, exports) {

var $2k3l6 = parcelRequire("2k3l6");

var $bxDef = parcelRequire("bxDef");

var $6kYP8 = parcelRequire("6kYP8");

var $8LQ84 = parcelRequire("8LQ84");

var $4rDUz = parcelRequire("4rDUz");
/**
 * Checks if `predicate` returns truthy for **any** element of `collection`.
 * Iteration is stopped once `predicate` returns truthy. The predicate is
 * invoked with three arguments: (value, index|key, collection).
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Collection
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Function} [predicate=_.identity] The function invoked per iteration.
 * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
 * @returns {boolean} Returns `true` if any element passes the predicate check,
 *  else `false`.
 * @example
 *
 * _.some([null, 0, 'yes', false], Boolean);
 * // => true
 *
 * var users = [
 *   { 'user': 'barney', 'active': true },
 *   { 'user': 'fred',   'active': false }
 * ];
 *
 * // The `_.matches` iteratee shorthand.
 * _.some(users, { 'user': 'barney', 'active': false });
 * // => false
 *
 * // The `_.matchesProperty` iteratee shorthand.
 * _.some(users, ['active', false]);
 * // => true
 *
 * // The `_.property` iteratee shorthand.
 * _.some(users, 'active');
 * // => true
 */ function $d40ab2104a331ebd$var$some(collection, predicate, guard) {
    var func = $8LQ84(collection) ? $2k3l6 : $6kYP8;
    if (guard && $4rDUz(collection, predicate, guard)) predicate = undefined;
    return func(collection, $bxDef(predicate, 3));
}
module.exports = $d40ab2104a331ebd$var$some;

});
parcelRegister("6kYP8", function(module, exports) {

var $e7pfQ = parcelRequire("e7pfQ");
/**
 * The base implementation of `_.some` without support for iteratee shorthands.
 *
 * @private
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Function} predicate The function invoked per iteration.
 * @returns {boolean} Returns `true` if any element passes the predicate check,
 *  else `false`.
 */ function $49d3cab0435826ab$var$baseSome(collection, predicate) {
    var result;
    $e7pfQ(collection, function(value, index, collection) {
        result = predicate(value, index, collection);
        return !result;
    });
    return !!result;
}
module.exports = $49d3cab0435826ab$var$baseSome;

});





parcelRegister("gSOEi", function(module, exports) {

$parcel$export(module.exports, "loadInviteFromShareDialogSpotlightDismissed", () => $13bae66d7887fecd$export$8303e588f14a5f5);
$parcel$export(module.exports, "setInviteFromShareDialogSpotlightDismissed", () => $13bae66d7887fecd$export$57382f7f22e8cda0);

var $89SaW = parcelRequire("89SaW");

var $jcw0u = parcelRequire("jcw0u");

var $jJZqs = parcelRequire("jJZqs");

var $1As78 = parcelRequire("1As78");

var $aiePb = parcelRequire("aiePb");

var $4R6GH = parcelRequire("4R6GH");

var $d9ulS = parcelRequire("d9ulS");

var $flDq6 = parcelRequire("flDq6");

var $6FNg9 = parcelRequire("6FNg9");
const $13bae66d7887fecd$export$8303e588f14a5f5 = ()=>async ({ getState: getState, setState: setState }, { accountId: accountId })=>{
        if (!accountId) return;
        if ((0, $4R6GH.fg)('polaris_premium_modal_ga')) await (0, $6FNg9.maybeWaitForPremiumModal)(getState);
        // User property is already loaded
        if (typeof getState().shareDialog.inviteSpotlightDismissed === 'boolean') return;
        try {
            const inviteFromShareDialogSpotlightDismissed = await (0, $89SaW.getUserProperty)(accountId, (0, $d9ulS.INVITE_FROM_SHARE_DIALOG_SPOTLIGHT_DISMISSED));
            const state = getState();
            setState({
                ...state,
                shareDialog: {
                    ...state.shareDialog,
                    inviteSpotlightDismissed: inviteFromShareDialogSpotlightDismissed
                }
            });
        } catch (error) {
            // Expected error, the property is not set yet
            if (error instanceof (0, $jJZqs.default) && (0, $aiePb.isNotFoundError)(error)) {
                const state = getState();
                setState({
                    ...state,
                    shareDialog: {
                        ...state.shareDialog,
                        inviteSpotlightDismissed: false
                    }
                });
                return;
            }
            (0, $jcw0u.default)((0, $1As78.createErrorAnalytics)((0, $d9ulS.INVITE_FROM_SHARE_DIALOG_SPOTLIGHT_DISMISSED), (0, $flDq6.normalizeError)(error)));
        }
    };
const $13bae66d7887fecd$export$57382f7f22e8cda0 = ()=>async ({ getState: getState, setState: setState }, { accountId: accountId })=>{
        if (!accountId) return;
        const state = getState();
        setState({
            ...state,
            shareDialog: {
                ...state.shareDialog,
                inviteSpotlightDismissed: true
            }
        });
        try {
            await (0, $89SaW.setUserProperties)(accountId, (0, $d9ulS.INVITE_FROM_SHARE_DIALOG_SPOTLIGHT_DISMISSED), 'true');
        } catch (error) {
            (0, $jcw0u.default)((0, $1As78.createErrorAnalytics)((0, $d9ulS.INVITE_FROM_SHARE_DIALOG_SPOTLIGHT_DISMISSED), (0, $flDq6.normalizeError)(error)));
        }
    };

});

parcelRegister("irhvp", function(module, exports) {

$parcel$export(module.exports, "loadAllViewsSpotlightDismissed", () => $386a76adebfd5ad6$export$73f482a9822cc952);
$parcel$export(module.exports, "setAllViewsSpotlightDismissed", () => $386a76adebfd5ad6$export$84df3d965709961e);

var $89SaW = parcelRequire("89SaW");

var $jJZqs = parcelRequire("jJZqs");

var $8U9Op = parcelRequire("8U9Op");

var $4R6GH = parcelRequire("4R6GH");

var $d9ulS = parcelRequire("d9ulS");

var $6FNg9 = parcelRequire("6FNg9");
const $386a76adebfd5ad6$export$73f482a9822cc952 = ()=>async ({ getState: getState, setState: setState }, { accountId: accountId })=>{
        if (!accountId) return;
        if ((0, $4R6GH.fg)('polaris_premium_modal_ga')) await (0, $6FNg9.maybeWaitForPremiumModal)(getState);
        // User property is already loaded
        if (typeof getState().allViews.spotlightDismissed === 'boolean') return;
        try {
            const spotlightDismissed = await (0, $89SaW.getUserProperty)(accountId, (0, $d9ulS.NAV_JPD_VIEWS_SPOTLIGHT_DISMISSED));
            const state = getState();
            setState({
                ...state,
                allViews: {
                    ...state.allViews,
                    spotlightDismissed: spotlightDismissed
                }
            });
        } catch (error) {
            // Expected error, the property is not set yet
            if (error instanceof (0, $jJZqs.default) && error.statusCode === 404) {
                const state = getState();
                setState({
                    ...state,
                    allViews: {
                        ...state.allViews,
                        spotlightDismissed: false
                    }
                });
                return;
            }
            (0, $8U9Op.logSafeErrorWithoutCustomerDataWrapper)('polaris.onboarding.all-views-spotlight', `Failed to get user property with key: ${(0, $d9ulS.NAV_JPD_VIEWS_SPOTLIGHT_DISMISSED)}`, error instanceof Error ? error : new Error(String(error)));
        }
    };
const $386a76adebfd5ad6$export$84df3d965709961e = ()=>async ({ getState: getState, setState: setState }, { accountId: accountId })=>{
        if (!accountId) return;
        const state = getState();
        setState({
            ...state,
            allViews: {
                ...state.allViews,
                spotlightDismissed: true
            }
        });
        try {
            await (0, $89SaW.setUserProperties)(accountId, (0, $d9ulS.NAV_JPD_VIEWS_SPOTLIGHT_DISMISSED), 'true');
        } catch (error) {
            (0, $8U9Op.logSafeErrorWithoutCustomerDataWrapper)('polaris.onboarding.all-views-spotlight', `Failed to set user property with key: ${(0, $d9ulS.NAV_JPD_VIEWS_SPOTLIGHT_DISMISSED)}`, error instanceof Error ? error : new Error(String(error)));
        }
    };

});

parcelRegister("i1anS", function(module, exports) {

$parcel$export(module.exports, "loadPrioritizationViewTourDismissed", () => $21cf3ff4ec7ad773$export$f610fdf8823d3e34);
$parcel$export(module.exports, "setPrioritizationViewTourDismissed", () => $21cf3ff4ec7ad773$export$a72bdc987d4b2c7d);
$parcel$export(module.exports, "setPrioritizationViewTourSpotlightStep", () => $21cf3ff4ec7ad773$export$a76ccd1e602a886c);

var $89SaW = parcelRequire("89SaW");

var $jJZqs = parcelRequire("jJZqs");

var $8U9Op = parcelRequire("8U9Op");

var $4R6GH = parcelRequire("4R6GH");

var $d9ulS = parcelRequire("d9ulS");

var $6FNg9 = parcelRequire("6FNg9");
const $21cf3ff4ec7ad773$export$f610fdf8823d3e34 = ()=>async ({ getState: getState, setState: setState }, { accountId: accountId })=>{
        if (!accountId) return;
        if ((0, $4R6GH.fg)('polaris_premium_modal_ga')) await (0, $6FNg9.maybeWaitForPremiumModal)(getState);
        // User property is already loaded
        if (typeof getState().prioritizationView.tourDismissed === 'boolean') return;
        try {
            const tourDismissed = await (0, $89SaW.getUserProperty)(accountId, (0, $d9ulS.PRIORITIZATION_VIEW_TOUR_DISMISSED));
            const state = getState();
            setState({
                ...state,
                prioritizationView: {
                    ...state.prioritizationView,
                    tourDismissed: tourDismissed
                }
            });
        } catch (error) {
            // Expected error, the property is not set yet
            if (error instanceof (0, $jJZqs.default) && error.statusCode === 404) {
                const state = getState();
                setState({
                    ...state,
                    prioritizationView: {
                        ...state.prioritizationView,
                        tourDismissed: false
                    }
                });
                return;
            }
            (0, $8U9Op.logSafeErrorWithoutCustomerDataWrapper)('polaris.onboarding.prioritization-view.tour', `Failed to get user property with key: ${(0, $d9ulS.PRIORITIZATION_VIEW_TOUR_DISMISSED)}`, error instanceof Error ? error : undefined);
        }
    };
const $21cf3ff4ec7ad773$export$a72bdc987d4b2c7d = ()=>async ({ getState: getState, setState: setState }, { accountId: accountId })=>{
        if (!accountId) return;
        const state = getState();
        setState({
            ...state,
            prioritizationView: {
                ...state.prioritizationView,
                tourDismissed: true
            }
        });
        try {
            await (0, $89SaW.setUserProperties)(accountId, (0, $d9ulS.PRIORITIZATION_VIEW_TOUR_DISMISSED), 'true');
        } catch (error) {
            (0, $8U9Op.logSafeErrorWithoutCustomerDataWrapper)('polaris.onboarding.prioritization-view.tour', `Failed to set user property with key: ${(0, $d9ulS.PRIORITIZATION_VIEW_TOUR_DISMISSED)}`, error instanceof Error ? error : undefined);
        }
    };
const $21cf3ff4ec7ad773$export$a76ccd1e602a886c = (step)=>({ getState: getState, setState: setState })=>{
        const state = getState();
        setState({
            ...state,
            prioritizationView: {
                ...state.prioritizationView,
                tourSpotlightStep: step
            }
        });
    };

});

parcelRegister("cXfUC", function(module, exports) {

$parcel$export(module.exports, "loadRoadmapViewSpotlightDismissed", () => $2206505688e5db6e$export$7efa8325e0de15f);
$parcel$export(module.exports, "setRoadmapViewSpotlightDismissed", () => $2206505688e5db6e$export$b55083c189662aa5);
$parcel$export(module.exports, "loadRoadmapColumnConfigSpotlightDismissed", () => $2206505688e5db6e$export$9e6f136ba325b100);
$parcel$export(module.exports, "setRoadmapColumnConfigSpotlightDismissed", () => $2206505688e5db6e$export$866ee7083694a75f);

var $89SaW = parcelRequire("89SaW");

var $jJZqs = parcelRequire("jJZqs");

var $8U9Op = parcelRequire("8U9Op");

var $4R6GH = parcelRequire("4R6GH");

var $d9ulS = parcelRequire("d9ulS");

var $6FNg9 = parcelRequire("6FNg9");
const $2206505688e5db6e$export$7efa8325e0de15f = ()=>async ({ getState: getState, setState: setState }, { accountId: accountId })=>{
        if (!accountId) return;
        if ((0, $4R6GH.fg)('polaris_premium_modal_ga')) await (0, $6FNg9.maybeWaitForPremiumModal)(getState);
        // User property is already loaded
        if (typeof getState().roadmapView.spotlightDismissed === 'boolean') return;
        try {
            const spotlightDismissed = await (0, $89SaW.getUserProperty)(accountId, (0, $d9ulS.ROADMAP_VIEW_SPOTLIGHT_DISMISSED));
            const state = getState();
            setState({
                ...state,
                roadmapView: {
                    ...state.roadmapView,
                    spotlightDismissed: spotlightDismissed
                }
            });
        } catch (error) {
            // Expected error, the property is not set yet
            if (error instanceof (0, $jJZqs.default) && error.statusCode === 404) {
                const state = getState();
                setState({
                    ...state,
                    roadmapView: {
                        ...state.roadmapView,
                        spotlightDismissed: false
                    }
                });
                return;
            }
            (0, $8U9Op.logSafeErrorWithoutCustomerDataWrapper)('polaris.onboarding.roadmap-view-spotlight', `Failed to get user property with key: ${(0, $d9ulS.ROADMAP_VIEW_SPOTLIGHT_DISMISSED)}`, error instanceof Error ? error : undefined);
        }
    };
const $2206505688e5db6e$export$b55083c189662aa5 = ()=>async ({ getState: getState, setState: setState }, { accountId: accountId })=>{
        if (!accountId) return;
        const state = getState();
        setState({
            ...state,
            roadmapView: {
                ...state.roadmapView,
                spotlightDismissed: true
            }
        });
        try {
            await (0, $89SaW.setUserProperties)(accountId, (0, $d9ulS.ROADMAP_VIEW_SPOTLIGHT_DISMISSED), 'true');
        } catch (error) {
            (0, $8U9Op.logSafeErrorWithoutCustomerDataWrapper)('polaris.onboarding.roadmap-view-spotlight', `Failed to set user property with key: ${(0, $d9ulS.ROADMAP_VIEW_SPOTLIGHT_DISMISSED)}`, error instanceof Error ? error : undefined);
        }
    };
const $2206505688e5db6e$export$9e6f136ba325b100 = ()=>async ({ getState: getState, setState: setState }, { accountId: accountId })=>{
        if (!accountId) return;
        // User property is already loaded
        if (typeof getState().roadmapView.columnConfigSpotlightDismissed === 'boolean') return;
        try {
            const columnConfigSpotlightDismissed = await (0, $89SaW.getUserProperty)(accountId, (0, $d9ulS.ROADMAP_COLUMN_CONFIG_SPOTLIGHT_DISMISSED));
            const state = getState();
            setState({
                ...state,
                roadmapView: {
                    ...state.roadmapView,
                    columnConfigSpotlightDismissed: columnConfigSpotlightDismissed
                }
            });
        } catch (error) {
            // Expected error, the property is not set yet
            if (error instanceof (0, $jJZqs.default) && error.statusCode === 404) {
                const state = getState();
                setState({
                    ...state,
                    roadmapView: {
                        ...state.roadmapView,
                        columnConfigSpotlightDismissed: false
                    }
                });
                return;
            }
            (0, $8U9Op.logSafeErrorWithoutCustomerDataWrapper)('polaris.onboarding.all-views-spotlight', `Failed to get user property with key: ${(0, $d9ulS.ROADMAP_COLUMN_CONFIG_SPOTLIGHT_DISMISSED)}`, error instanceof Error ? error : undefined);
        }
    };
const $2206505688e5db6e$export$866ee7083694a75f = ()=>async ({ getState: getState, setState: setState }, { accountId: accountId })=>{
        if (!accountId) return;
        const state = getState();
        setState({
            ...state,
            roadmapView: {
                ...state.roadmapView,
                columnConfigSpotlightDismissed: true
            }
        });
        try {
            await (0, $89SaW.setUserProperties)(accountId, (0, $d9ulS.ROADMAP_COLUMN_CONFIG_SPOTLIGHT_DISMISSED), 'true');
        } catch (error) {
            (0, $8U9Op.logSafeErrorWithoutCustomerDataWrapper)('polaris.onboarding.roadmap-view-column-config-spotlight', `Failed to set user property with key: ${(0, $d9ulS.ROADMAP_COLUMN_CONFIG_SPOTLIGHT_DISMISSED)}`, error instanceof Error ? error : undefined);
        }
    };

});

parcelRegister("9nrm9", function(module, exports) {

$parcel$export(module.exports, "loadViewCreatorSpotlightState", () => $99d368e0edf5cbc9$export$9a1628c8a6cce5a8);
$parcel$export(module.exports, "setViewCreatorSpotlightTourStep", () => $99d368e0edf5cbc9$export$55b6ef0c08b2c8bc);
$parcel$export(module.exports, "setViewCreatorSpotlightDismissed", () => $99d368e0edf5cbc9$export$b883437f952d9bab);

var $hJCUd = parcelRequire("hJCUd");

var $4R6GH = parcelRequire("4R6GH");

var $89SaW = parcelRequire("89SaW");

var $jJZqs = parcelRequire("jJZqs");

var $8U9Op = parcelRequire("8U9Op");

var $jcw0u = parcelRequire("jcw0u");

var $1As78 = parcelRequire("1As78");

var $6FNg9 = parcelRequire("6FNg9");

var $d9ulS = parcelRequire("d9ulS");

var $flDq6 = parcelRequire("flDq6");
const $99d368e0edf5cbc9$export$9a1628c8a6cce5a8 = ()=>async ({ getState: getState, setState: setState }, { accountId: accountId })=>{
        if (!accountId) return;
        if ((0, $4R6GH.fg)('polaris_premium_modal_ga')) await (0, $6FNg9.maybeWaitForPremiumModal)(getState);
        // User property is already loaded
        if (typeof getState().viewCreator.tourDismissed === 'boolean') return;
        try {
            const remoteState = await (0, $89SaW.getUserProperty)(accountId, (0, $d9ulS.VIEW_CREATOR_TOUR_SPOTLIGHTS));
            const state = getState();
            setState({
                ...state,
                viewCreator: {
                    ...state.viewCreator,
                    ...(0, (/*@__PURE__*/$parcel$interopDefault($hJCUd)))(remoteState, {
                        tourSpotlightStep: null,
                        tourDismissed: false
                    })
                }
            });
        } catch (error) {
            // Expected error, the property is not set yet
            if (error instanceof (0, $jJZqs.default) && error.statusCode === 404) {
                const state = getState();
                setState({
                    ...state,
                    viewCreator: {
                        ...state.viewCreator,
                        tourDismissed: false
                    }
                });
                return;
            }
            (0, $8U9Op.logSafeErrorWithoutCustomerDataWrapper)('polaris.onboarding.view-creator-spotlight', `Failed to get user property with key: ${(0, $d9ulS.VIEW_CREATOR_TOUR_SPOTLIGHTS)}`, error instanceof Error ? error : new Error(String(error)));
        }
    };
const $99d368e0edf5cbc9$export$55b6ef0c08b2c8bc = (step)=>async ({ getState: getState, setState: setState }, { accountId: accountId })=>{
        if (!accountId) return;
        const state = getState();
        const newViewCreatorState = {
            ...state.viewCreator,
            tourSpotlightStep: step
        };
        setState({
            ...state,
            viewCreator: newViewCreatorState
        });
        try {
            await (0, $89SaW.setUserProperties)(accountId, (0, $d9ulS.VIEW_CREATOR_TOUR_SPOTLIGHTS), JSON.stringify(newViewCreatorState));
        } catch (error) {
            (0, $jcw0u.default)((0, $1As78.createErrorAnalytics)('polaris.onboarding.view-creator-spotlight', (0, $flDq6.normalizeError)(error)));
        }
    };
const $99d368e0edf5cbc9$export$b883437f952d9bab = (tourDismissed = true)=>async ({ getState: getState, setState: setState }, { accountId: accountId })=>{
        if (!accountId) return;
        const state = getState();
        const newViewCreatorState = {
            ...state.viewCreator,
            tourDismissed: tourDismissed
        };
        setState({
            ...state,
            viewCreator: newViewCreatorState
        });
        try {
            await (0, $89SaW.setUserProperties)(accountId, (0, $d9ulS.VIEW_CREATOR_TOUR_SPOTLIGHTS), JSON.stringify(newViewCreatorState));
        } catch (error) {
            (0, $jcw0u.default)((0, $1As78.createErrorAnalytics)('polaris.onboarding.view-creator-spotlight', (0, $flDq6.normalizeError)(error)));
        }
    };

});
parcelRegister("hJCUd", function(module, exports) {

var $hlchF = parcelRequire("hlchF");

var $g7i7g = parcelRequire("g7i7g");

var $3KORh = parcelRequire("3KORh");

var $3dHKF = parcelRequire("3dHKF");
/**
 * This method is like `_.defaults` except that it recursively assigns
 * default properties.
 *
 * **Note:** This method mutates `object`.
 *
 * @static
 * @memberOf _
 * @since 3.10.0
 * @category Object
 * @param {Object} object The destination object.
 * @param {...Object} [sources] The source objects.
 * @returns {Object} Returns `object`.
 * @see _.defaults
 * @example
 *
 * _.defaultsDeep({ 'a': { 'b': 2 } }, { 'a': { 'b': 1, 'c': 3 } });
 * // => { 'a': { 'b': 2, 'c': 3 } }
 */ var $ce94d17a4ae582d5$var$defaultsDeep = $g7i7g(function(args) {
    args.push(undefined, $3KORh);
    return $hlchF($3dHKF, undefined, args);
});
module.exports = $ce94d17a4ae582d5$var$defaultsDeep;

});
parcelRegister("3KORh", function(module, exports) {

var $1m1GH = parcelRequire("1m1GH");

var $k0qYG = parcelRequire("k0qYG");
/**
 * Used by `_.defaultsDeep` to customize its `_.merge` use to merge source
 * objects into destination objects that are passed thru.
 *
 * @private
 * @param {*} objValue The destination value.
 * @param {*} srcValue The source value.
 * @param {string} key The key of the property to merge.
 * @param {Object} object The parent object of `objValue`.
 * @param {Object} source The parent object of `srcValue`.
 * @param {Object} [stack] Tracks traversed source values and their merged
 *  counterparts.
 * @returns {*} Returns the value to assign.
 */ function $2bbd1e633373e9a1$var$customDefaultsMerge(objValue, srcValue, key, object, source, stack) {
    if ($k0qYG(objValue) && $k0qYG(srcValue)) {
        // Recursively merge objects and arrays (susceptible to call stack limits).
        stack.set(srcValue, objValue);
        $1m1GH(objValue, srcValue, undefined, $2bbd1e633373e9a1$var$customDefaultsMerge, stack);
        stack['delete'](srcValue);
    }
    return objValue;
}
module.exports = $2bbd1e633373e9a1$var$customDefaultsMerge;

});

parcelRegister("3dHKF", function(module, exports) {

var $1m1GH = parcelRequire("1m1GH");

var $9MM2g = parcelRequire("9MM2g");
/**
 * This method is like `_.merge` except that it accepts `customizer` which
 * is invoked to produce the merged values of the destination and source
 * properties. If `customizer` returns `undefined`, merging is handled by the
 * method instead. The `customizer` is invoked with six arguments:
 * (objValue, srcValue, key, object, source, stack).
 *
 * **Note:** This method mutates `object`.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Object
 * @param {Object} object The destination object.
 * @param {...Object} sources The source objects.
 * @param {Function} customizer The function to customize assigned values.
 * @returns {Object} Returns `object`.
 * @example
 *
 * function customizer(objValue, srcValue) {
 *   if (_.isArray(objValue)) {
 *     return objValue.concat(srcValue);
 *   }
 * }
 *
 * var object = { 'a': [1], 'b': [2] };
 * var other = { 'a': [3], 'b': [4] };
 *
 * _.mergeWith(object, other, customizer);
 * // => { 'a': [1, 3], 'b': [2, 4] }
 */ var $2584862af7fb4983$var$mergeWith = $9MM2g(function(object, source, srcIndex, customizer) {
    $1m1GH(object, source, srcIndex, customizer);
});
module.exports = $2584862af7fb4983$var$mergeWith;

});



parcelRegister("a6Bob", function(module, exports) {

$parcel$export(module.exports, "loadPremiumModalDismissed", () => $f7233d1c4eea5348$export$f4ca311cb4b4350f);
$parcel$export(module.exports, "setPremiumModalDismissed", () => $f7233d1c4eea5348$export$99d8813bb6724f28);
$parcel$export(module.exports, "loadPremiumLastVisit", () => $f7233d1c4eea5348$export$6825e78fd5bc05f5);
$parcel$export(module.exports, "setPremiumLastVisit", () => $f7233d1c4eea5348$export$c2d4fef533f3196c);
$parcel$export(module.exports, "unlockOnboardingFlow", () => $f7233d1c4eea5348$export$f92cc7ff16154919);

var $89SaW = parcelRequire("89SaW");

var $jJZqs = parcelRequire("jJZqs");

var $8U9Op = parcelRequire("8U9Op");

var $d9ulS = parcelRequire("d9ulS");
const $f7233d1c4eea5348$export$f4ca311cb4b4350f = ()=>async ({ getState: getState, setState: setState }, { accountId: accountId })=>{
        if (!accountId) return;
        // User property is already loaded
        if (typeof getState().premium.modalDismissed === 'boolean') return;
        try {
            const modalDismissed = await (0, $89SaW.getUserProperty)(accountId, (0, $d9ulS.PREMIUM_MODAL_DISMISSED));
            const state = getState();
            setState({
                premium: {
                    ...state.premium,
                    modalDismissed: modalDismissed
                }
            });
        } catch (error) {
            // Expected error, the property is not set yet
            if (error instanceof (0, $jJZqs.default) && error.statusCode === 404) {
                const state = getState();
                setState({
                    premium: {
                        ...state.premium,
                        modalDismissed: false
                    }
                });
                return;
            }
            (0, $8U9Op.logSafeErrorWithoutCustomerDataWrapper)('polaris.onboarding.premium.modal-dismissed', `Failed to get user property with key: ${(0, $d9ulS.PREMIUM_MODAL_DISMISSED)}`, error instanceof Error ? error : undefined);
        }
        return getState().premium.modalDismissed;
    };
const $f7233d1c4eea5348$export$99d8813bb6724f28 = ()=>async ({ getState: getState, setState: setState }, { accountId: accountId })=>{
        if (!accountId) return;
        const state = getState();
        // we need to pass isPremium to the lastVisit object to ensure that the modal is dismissed
        // when the user is on the premium edition and the last visit was on the free edition
        setState({
            premium: {
                ...state.premium,
                modalDismissed: true,
                lastVisit: {
                    ...state.premium.lastVisit,
                    isPremium: true
                }
            }
        });
        try {
            await (0, $89SaW.setUserProperties)(accountId, (0, $d9ulS.PREMIUM_MODAL_DISMISSED), 'true');
        } catch (error) {
            (0, $8U9Op.logSafeErrorWithoutCustomerDataWrapper)('polaris.onboarding.premium.modal-dismissed', `Failed to set user property with key: ${(0, $d9ulS.PREMIUM_MODAL_DISMISSED)}`, error instanceof Error ? error : undefined);
        }
    };
const $f7233d1c4eea5348$export$6825e78fd5bc05f5 = (isPremiumEdition)=>async ({ getState: getState, setState: setState }, { accountId: accountId })=>{
        if (!accountId) return;
        // User property is already loaded
        if (typeof getState().premium.lastVisit.isPremium === 'boolean') return;
        try {
            const lastVisitOnPremium = await (0, $89SaW.getUserProperty)(accountId, (0, $d9ulS.PREMIUM_LAST_VISIT));
            const state = getState();
            setState({
                premium: {
                    ...state.premium,
                    lastVisit: {
                        ...state.premium.lastVisit,
                        isPremium: lastVisitOnPremium
                    }
                }
            });
        } catch (error) {
            // Expected error, the property is not set yet
            if (error instanceof (0, $jJZqs.default) && error.statusCode === 404) {
                const state = getState();
                setState({
                    premium: {
                        ...state.premium,
                        lastVisit: {
                            ...state.premium.lastVisit,
                            isPremium: isPremiumEdition
                        }
                    }
                });
                return;
            }
            (0, $8U9Op.logSafeErrorWithoutCustomerDataWrapper)('polaris.onboarding.premium.last-visit', `Failed to get user property with key: ${(0, $d9ulS.PREMIUM_LAST_VISIT)}`, error instanceof Error ? error : undefined);
        }
        return getState().premium.modalDismissed;
    };
const $f7233d1c4eea5348$export$c2d4fef533f3196c = (isPremium)=>async ({ getState: getState, setState: setState }, { accountId: accountId })=>{
        if (!accountId) return;
        if (getState().premium.lastVisit.updated) // If lastVisit has been updated already
        // then don't do it again
        return;
        try {
            await (0, $89SaW.setUserProperties)(accountId, (0, $d9ulS.PREMIUM_LAST_VISIT), String(isPremium));
            const state = getState();
            setState({
                premium: {
                    ...state.premium,
                    lastVisit: {
                        ...state.premium.lastVisit,
                        updated: true
                    }
                }
            });
        } catch (error) {
            (0, $8U9Op.logSafeErrorWithoutCustomerDataWrapper)('polaris.onboarding.premium.last-visit', `Failed to set user property with key: ${(0, $d9ulS.PREMIUM_LAST_VISIT)}`, error instanceof Error ? error : undefined);
        }
    };
const $f7233d1c4eea5348$export$f92cc7ff16154919 = ()=>async ({ getState: getState })=>{
        getState().premium.promise.resolve();
    };

});

parcelRegister("dke7D", function(module, exports) {

$parcel$export(module.exports, "loadProductUsageStartTimestamp", () => $f2bc503204fd19f2$export$7cb2c6cd0d7c32c0);

var $89SaW = parcelRequire("89SaW");

var $8U9Op = parcelRequire("8U9Op");

var $fZneA = parcelRequire("fZneA");

var $jJZqs = parcelRequire("jJZqs");

var $d9ulS = parcelRequire("d9ulS");
const $f2bc503204fd19f2$export$7cb2c6cd0d7c32c0 = ()=>async ({ getState: getState, setState: setState }, { accountId: accountId })=>{
        if (!accountId) return;
        // usage timestamp already loaded
        if (getState().productUsageStartTimestamp) return;
        try {
            const { isoDateString: productUsageStartTimestamp } = await (0, $89SaW.getUserProperty)(accountId, (0, $d9ulS.PRODUCT_START_TIMESTAMP));
            const state = getState();
            setState({
                ...state,
                productUsageStartTimestamp: productUsageStartTimestamp
            });
        } catch (error) {
            if (error instanceof (0, $jJZqs.default) && error.statusCode === 404 || (0, $fZneA.isClientFetchError)(error)) return;
            (0, $8U9Op.logSafeErrorWithoutCustomerDataWrapper)('polaris.onboarding.roadmaps.introduction.spotlight.dismissed', `Failed to get user property with key: ${(0, $d9ulS.PRODUCT_START_TIMESTAMP)}`, error instanceof Error ? error : undefined);
        }
        return getState().productUsageStartTimestamp;
    };

});



parcelRegister("7qsHB", function(module, exports) {

$parcel$export(module.exports, "useCollectionsTourDismissed", () => $de678aee09ba157d$export$17de768881ff6446);
$parcel$export(module.exports, "useTourSpotlightStep", () => $de678aee09ba157d$export$152b14ddbe17966d);
$parcel$export(module.exports, "useCollectionsIntroductionDismissed", () => $de678aee09ba157d$export$2c88e8fbdc79e33c);
$parcel$export(module.exports, "useCollectionsIntroductionPrerequisiteDismissalsMet", () => $de678aee09ba157d$export$45df47b92137b673);

var $cAcWf = parcelRequire("cAcWf");

var $3u3TI = parcelRequire("3u3TI");
const $de678aee09ba157d$export$17de768881ff6446 = (0, $cAcWf.createHook)((0, $3u3TI.getCollectionsTourDismissed));
const $de678aee09ba157d$export$152b14ddbe17966d = (0, $cAcWf.createHook)((0, $3u3TI.getTourSpotlightStep));
const $de678aee09ba157d$export$2c88e8fbdc79e33c = (0, $cAcWf.createHook)((0, $3u3TI.getCollectionsIntroductionDismissed));
const $de678aee09ba157d$export$45df47b92137b673 = (0, $cAcWf.createHook)((0, $3u3TI.getCollectionsIntroductionPrerequisiteDismissalsMet));

});
parcelRegister("3u3TI", function(module, exports) {

$parcel$export(module.exports, "getCollectionsTourDismissed", () => $dd2f618ed5b718df$export$2f4e8052c0c8cc36);
$parcel$export(module.exports, "getTourSpotlightStep", () => $dd2f618ed5b718df$export$c0777ba57d86bcd1);
$parcel$export(module.exports, "getCollectionsIntroductionDismissed", () => $dd2f618ed5b718df$export$df23a375f28a4c0f);
$parcel$export(module.exports, "getCollectionsIntroductionPrerequisiteDismissalsMet", () => $dd2f618ed5b718df$export$e6b937f1096fabf9);

var $dGvGJ = parcelRequire("dGvGJ");
const $dd2f618ed5b718df$export$9bc19dcd1978ec48 = (state)=>state.collections;
const $dd2f618ed5b718df$export$2f4e8052c0c8cc36 = (0, $dGvGJ.createSelector)($dd2f618ed5b718df$export$9bc19dcd1978ec48, (collections)=>collections.tourDismissed);
const $dd2f618ed5b718df$export$c0777ba57d86bcd1 = (0, $dGvGJ.createSelector)($dd2f618ed5b718df$export$9bc19dcd1978ec48, (collections)=>collections.tourSpotlightStep);
const $dd2f618ed5b718df$export$df23a375f28a4c0f = (0, $dGvGJ.createSelector)($dd2f618ed5b718df$export$9bc19dcd1978ec48, (collections)=>collections.introductionDismissed);
const $dd2f618ed5b718df$export$e6b937f1096fabf9 = (0, $dGvGJ.createSelector)($dd2f618ed5b718df$export$9bc19dcd1978ec48, (collections)=>collections.introductionPrerequisiteDismissalsMet);

});


parcelRegister("jhE94", function(module, exports) {

$parcel$export(module.exports, "useProductUsageStartTimestamp", () => $2346875d10b87fd5$export$935abb673611c138);

var $cAcWf = parcelRequire("cAcWf");

var $eyW9h = parcelRequire("eyW9h");
const $2346875d10b87fd5$export$935abb673611c138 = (0, $cAcWf.createHook)((0, $eyW9h.getProductUsageStartTimestamp));

});
parcelRegister("eyW9h", function(module, exports) {

$parcel$export(module.exports, "getProductUsageStartTimestamp", () => $4d3ab3242e339cb7$export$e96fba6f475323c2);
const $4d3ab3242e339cb7$export$e96fba6f475323c2 = (state)=>state.productUsageStartTimestamp;

});


parcelRegister("9V003", function(module, exports) {

$parcel$export(module.exports, "messages", () => $896b0ce39c051edc$export$defe85febe8b728c);

var $7VHMR = parcelRequire("7VHMR");
const $896b0ce39c051edc$export$defe85febe8b728c = (0, $7VHMR.defineMessages)({
    dismiss: {
        "id": "polaris-lib-onboarding-flows.collections.tour.introduction.dismiss",
        "defaultMessage": "Dismiss"
    },
    giveItATry: {
        "id": "polaris-lib-onboarding-flows.collections.tour.introduction.give-it-a-try",
        "defaultMessage": "Give it a try!"
    },
    message: {
        "id": "polaris-lib-onboarding-flows.collections.tour.introduction.message",
        "defaultMessage": "Create a roadmap tailored to the information your stakeholders care about the most by selecting which projects and ideas to include."
    }
});

});

parcelRegister("3aLoA", function(module, exports) {

$parcel$export(module.exports, "checkIfOlderThanNDays", () => $769a162525414dfb$export$cbcf9869d63af9cf);
const $769a162525414dfb$export$cbcf9869d63af9cf = (productStartTimestamp, days = 7)=>{
    if (!productStartTimestamp) return false;
    const daysInMs = days * 86400000;
    const currentDate = new Date();
    const productAge = currentDate.getTime() - new Date(productStartTimestamp).getTime();
    return productAge > daysInMs;
};

});


parcelRegister("6yVM4", function(module, exports) {

$parcel$export(module.exports, "default", () => $2fe7682072c5451b$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $2fe7682072c5451b$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    titleJpdRoadmaps: {
        "id": "atlassian-navigation.roadmaps.title-jpd-roadmaps",
        "defaultMessage": "Roadmaps"
    }
});

});


parcelRegister("6U0zt", function(module, exports) {

$parcel$export(module.exports, "Addons", () => $10f4e1510a5de408$export$a97e6a0578b4c83);

var $5uXOq = parcelRequire("5uXOq");

var $2bzBV = parcelRequire("2bzBV");

var $kJH82 = parcelRequire("kJH82");

var $azzrO = parcelRequire("azzrO");

var $kaHBi = parcelRequire("kaHBi");

var $6s1PB = parcelRequire("6s1PB");

var $eKYL7 = parcelRequire("eKYL7");

var $koVbs = parcelRequire("koVbs");

var $lmyls = parcelRequire("lmyls");

var $iXVV6 = parcelRequire("iXVV6");

var $dAfqg = parcelRequire("dAfqg");

var $a4k7n = parcelRequire("a4k7n");

var $heI7y = parcelRequire("heI7y");

var $9OXo1 = parcelRequire("9OXo1");

var $Mp6qH = parcelRequire("Mp6qH");

var $4uXxK = parcelRequire("4uXxK");

var $j94qH = parcelRequire("j94qH");

var $ebYJ0 = parcelRequire("ebYJ0");

var $h5OKf = parcelRequire("h5OKf");

var $1bhgl = parcelRequire("1bhgl");

var $dEiSH = parcelRequire("dEiSH");
const $10f4e1510a5de408$var$AddonsView = ()=>{
    const { key: projectIdOrKey } = (0, $dAfqg.useProjectContext)();
    const [, { load: loadItem, setContext: setContext }] = (0, $kJH82.useAddon)();
    const [, { load: loadForgeItem }] = (0, $eKYL7.useForgeGlobalItems)();
    (0, $5uXOq.useEffect)(()=>{
        setContext({
            projectIdOrKey: projectIdOrKey
        });
    }, [
        projectIdOrKey,
        setContext
    ]);
    const [{ hasSuccessOnce: hasSuccessOnceUserSegmentation }, { loadPersonalisedAppsUserSegmentation: loadPersonalisedAppsUserSegmentation }] = (0, $h5OKf.usePersonalisedAppsTeamType)();
    const { cloudId: cloudId, isAnonymous: isAnonymous } = (0, $9OXo1.useTenantContext)();
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const onStart = (0, $kaHBi.useExperienceStart)({
        experience: (0, $Mp6qH.EXPERIENCE_NAVIGATION_TOP_MENU),
        experienceId: (0, $Mp6qH.NAVIGATION_ITEM_ID).ADDONS,
        analyticsSource: 'atlassian-navigation'
    });
    const onBeforeMenuOpen = (0, $5uXOq.useCallback)(()=>{
        onStart();
        loadItem();
        loadForgeItem({
            cloudId: cloudId,
            isAnonymous: isAnonymous
        });
        !hasSuccessOnceUserSegmentation && loadPersonalisedAppsUserSegmentation();
        (0, $azzrO.NAVIGATION_TOP_DROPDOWN_MARKS).ADDONS.start();
    }, [
        onStart,
        loadItem,
        hasSuccessOnceUserSegmentation,
        loadPersonalisedAppsUserSegmentation,
        loadForgeItem,
        cloudId,
        isAnonymous
    ]);
    const attributes = (0, $5uXOq.useMemo)(()=>({
            isEmbeddedMarketplaceEnabledForEndUsers: (0, $6s1PB.expVal)('enduser-emcee-discover', 'value', true),
            isEmbeddedMarketplaceSpaEnabled: true
        }), []);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $iXVV6.ContextualAnalyticsData), {
        attributes: attributes
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $ebYJ0.Popup), {
        menuId: (0, $lmyls.MENU_ID).ADDONS,
        navigationItemId: (0, $Mp6qH.NAVIGATION_ITEM_ID).ADDONS,
        Menu: (0, $1bhgl.AsyncMenu),
        onBeforeMenuOpen: onBeforeMenuOpen,
        label: formatMessage((0, $dEiSH.default).apps)
    }, formatMessage((0, $dEiSH.default).apps)));
};
const $10f4e1510a5de408$export$a97e6a0578b4c83 = ()=>{
    const { isVisible: isVisible } = (0, $2bzBV.useOverflowStatus)();
    const [{ hasOpened: shouldShowNudge }] = (0, $heI7y.useHasOpened)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $4uXxK.TopLevelErrorBoundary), {
        id: (0, $lmyls.MENU_ID).ADDONS
    }, !false && shouldShowNudge ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $a4k7n.NavigationAppsNavItemWrapperNudgeAsync), {
        isInsideMenu: !isVisible
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $j94qH.FullHeightTextColorWrapper), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($10f4e1510a5de408$var$AddonsView, null))) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($10f4e1510a5de408$var$AddonsView, null));
};

});
parcelRegister("a4k7n", function(module, exports) {

$parcel$export(module.exports, "NavigationAppsNavItemWrapperNudgeAsync", () => $86c9ba44b2aedf6e$export$c143067f544307f);

var $5uXOq = parcelRequire("5uXOq");


var $bBbEG = parcelRequire("bBbEG");

var $lfTZh = parcelRequire("lfTZh");

var $kxZPA = parcelRequire("kxZPA");

// eslint-disable-next-line jira/deprecations/no-rll-client-async-experiences
const $86c9ba44b2aedf6e$var$NavigationAppsNavItemLazy = (0, $kxZPA.lazyAfterPaint)(()=>(parcelRequire("6rsRb")).then((exportedModule)=>exportedModule.NavigationAppsNavItemWrapperNudge), {
    ssr: false,
    moduleId: "./src/packages/software/onboarding-nudges/src/ui/navigation-apps/index.tsx"
});
const $86c9ba44b2aedf6e$export$c143067f544307f = ({ children: children, isInsideMenu: isInsideMenu })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $bBbEG.OnboardingNudgeErrorBoundary), {
        id: (0, $6784cbc7d62e5d7c$export$dd63d0099d95ba4f),
        fallback: children,
        attributes: {
            nudgeId: (0, $6784cbc7d62e5d7c$export$dd63d0099d95ba4f)
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $lfTZh.default), {
        name: "navigation-apps-nav-item-lazy",
        fallback: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, children)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($86c9ba44b2aedf6e$var$NavigationAppsNavItemLazy, {
        nudgeId: (0, $6784cbc7d62e5d7c$export$dd63d0099d95ba4f),
        isInsideMenu: isInsideMenu
    }, children)));

});
parcelRegister("6rsRb", function(module, exports) {

let $4b0ba60e07f8a2c3$var$load = (parcelRequire("28QjX"))(4);
module.exports = $4b0ba60e07f8a2c3$var$load("ffRiQ").then(()=>parcelRequire('3Hy6N'));

});


parcelRegister("h5OKf", function(module, exports) {

$parcel$export(module.exports, "usePersonalisedAppsTeamType", () => $1c093da579689f30$export$952bf3a355bf4d23);
// eslint-disable-next-line jira/restricted/@atlassian/react-sweet-state

var $3sQ5x = parcelRequire("3sQ5x");
var $iXqE5 = parcelRequire("iXqE5");

var $cE27s = parcelRequire("cE27s");
const $1c093da579689f30$var$initialState = {
    isLoading: false,
    isSuccess: false,
    error: null,
    promise: null,
    teamType: undefined,
    hasSuccessOnce: false
};
const $1c093da579689f30$var$store = (0, $iXqE5.createStore)({
    actions: $cE27s.actions,
    initialState: $1c093da579689f30$var$initialState,
    name: 'atlassian-navigation-addons-personalised-apps-team-type'
});
const $1c093da579689f30$export$952bf3a355bf4d23 = (0, $3sQ5x.createHook)($1c093da579689f30$var$store);
const $1c093da579689f30$export$202fd798d158e553 = (0, $3sQ5x.createHook)($1c093da579689f30$var$store, {
    selector: null
});

});
parcelRegister("cE27s", function(module, exports) {

$parcel$export(module.exports, "actions", () => $cbb59c8ecf2badc7$export$e324594224ef24da);
// eslint-disable-next-line jira/restricted/@atlassian/react-sweet-state

var $i5yN4 = parcelRequire("i5yN4");

var $26xre = parcelRequire("26xre");
const $cbb59c8ecf2badc7$var$loadPersonalisedAppsUserSegmentation = ()=>async ({ setState: setState })=>{
        const promise = (0, $i5yN4.getUserSegmentationData)();
        setState({
            error: null,
            isLoading: true,
            isSuccess: false,
            promise: promise
        });
        try {
            const { team: team } = await promise;
            const teamType = (0, $26xre.mapUserTeamTypeToTeamType)(team);
            setState({
                teamType: teamType,
                isSuccess: true,
                hasSuccessOnce: true
            });
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        } catch (error) {
            setState({
                error: error
            });
        } finally{
            setState({
                isLoading: false
            });
        }
    };
const $cbb59c8ecf2badc7$export$e324594224ef24da = {
    loadPersonalisedAppsUserSegmentation: $cbb59c8ecf2badc7$var$loadPersonalisedAppsUserSegmentation
};

});
parcelRegister("i5yN4", function(module, exports) {

$parcel$export(module.exports, "getUserSegmentationData", () => $d567b9983c1fa90f$export$f0a14a7cbbb7397e);

var $jcw0u = parcelRequire("jcw0u");

var $eusud = parcelRequire("eusud");
const $d567b9983c1fa90f$var$GET_ME_URL = '/gateway/api/me';
const $d567b9983c1fa90f$export$318c25600a19e2ee = ()=>(0, $eusud.performGetRequest)($d567b9983c1fa90f$var$GET_ME_URL);
const $d567b9983c1fa90f$export$f0a14a7cbbb7397e = async ()=>{
    let response = {
        jobTitle: undefined,
        team: undefined
    };
    try {
        const { extended_profile: extendedProfile } = await $d567b9983c1fa90f$export$318c25600a19e2ee();
        const { job_title: jobTitle, team_type: team } = extendedProfile;
        response = {
            jobTitle: // @ts-expect-error - TS2322 - Type 'string | undefined' is not assignable to type 'undefined'.
            jobTitle,
            team: // @ts-expect-error - TS2322 - Type 'string | undefined' is not assignable to type 'undefined'.
            team
        };
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    } catch (error) {
        // failed to fetch user segmentation data, analytics will be added later
        (0, $jcw0u.default)({
            meta: {
                id: 'getUserSegmentationData',
                packageName: 'jiraAtlassianNavigation',
                teamName: 'navigation'
            },
            error: error
        });
    }
    return response;
};

});

parcelRegister("26xre", function(module, exports) {

$parcel$export(module.exports, "mapUserTeamTypeToTeamType", () => $3464a59742bad1ac$export$38b9d6b529723f8c);

var $2nA8w = parcelRequire("2nA8w");
const $3464a59742bad1ac$export$38b9d6b529723f8c = (team)=>{
    switch(team){
        case (0, $2nA8w.PERSONALISED_APPS_TEAM_TYPES).softwareDevelopment:
            return (0, $2nA8w.PERSONALISED_APPS_TEAM_TYPES).softwareDevelopment;
        case (0, $2nA8w.PERSONALISED_APPS_TEAM_TYPES).itSupport:
            return (0, $2nA8w.PERSONALISED_APPS_TEAM_TYPES).itSupport;
        default:
            return (0, $2nA8w.PERSONALISED_APPS_TEAM_TYPES).marketing;
    }
};

});
parcelRegister("2nA8w", function(module, exports) {

$parcel$export(module.exports, "PERSONALISED_APPS_TEAM_TYPES", () => $e0c89db7eea0cd0a$export$2bdcfab7823ff30);
const $e0c89db7eea0cd0a$export$2bdcfab7823ff30 = {
    marketing: 'Business Management and Operations',
    itSupport: 'IT Support',
    softwareDevelopment: 'Software Development'
};

});




parcelRegister("1bhgl", function(module, exports) {

$parcel$export(module.exports, "AsyncMenu", () => $ed4263c510e6df56$export$81adf29ff528dc9c);
/* async.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $9UCCQ = parcelRequire("9UCCQ");

var $lfTZh = parcelRequire("lfTZh");

var $kxZPA = parcelRequire("kxZPA");
var $6Lg6A = parcelRequire("6Lg6A");

var $ag3sS = parcelRequire("ag3sS");

var $9TMfX = parcelRequire("9TMfX");
const $ed4263c510e6df56$var$Skeleton = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $ag3sS.MenuLayout), {
        isWide: true
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($ed4263c510e6df56$var$AppsSectionWrapper, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $9TMfX.MenuSkeletonContent), null)));

const $ed4263c510e6df56$export$c49a6d699b74b197 = (0, $kxZPA.lazy)(()=>(parcelRequire("4fVXN")).then((module)=>module.Menu), {
    ssr: false,
    moduleId: "./src/packages/navigation-apps/atlassian-navigation/src/ui/addons/menu/index.tsx"
});
const $ed4263c510e6df56$export$81adf29ff528dc9c = ({ shouldLoad: shouldLoad = true })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $6Lg6A.LazyWait), {
        until: shouldLoad
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $lfTZh.default), {
        fallback: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($ed4263c510e6df56$var$Skeleton, null),
        name: "lazy-menu"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($ed4263c510e6df56$export$c49a6d699b74b197, null)));
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled
const $ed4263c510e6df56$var$AppsSectionWrapper = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = (0, $9UCCQ.default), style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_1tke12am",
            __cmplp.className
        ])
    });
});

});
parcelRegister("4fVXN", function(module, exports) {

let $319586761420c0e7$var$load = (parcelRequire("28QjX"))(4);
module.exports = $319586761420c0e7$var$load("6m5cK").then(()=>parcelRequire('4opAu'));

});


parcelRegister("dEiSH", function(module, exports) {

$parcel$export(module.exports, "default", () => $f4ce60ec2367163b$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $f4ce60ec2367163b$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    apps: {
        "id": "atlassian-navigation.addons.apps",
        "defaultMessage": "Apps"
    }
});

});




//# sourceMappingURL=async-jira-atlassian-top-nav-nav3.67d5758c.js.map
